webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(333);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(334);
	
	__webpack_require__(343);
	
	__webpack_require__(345);
	
	var _bootstrapLoader = __webpack_require__(347);
	
	var _bootstrapLoader2 = _interopRequireDefault(_bootstrapLoader);
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(447);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(679);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(1883);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(1888);
	
	var _angucompleteAlt = __webpack_require__(1890);
	
	var _angucompleteAlt2 = _interopRequireDefault(_angucompleteAlt);
	
	var _angularBlockUi = __webpack_require__(1891);
	
	var _angularBlockUi2 = _interopRequireDefault(_angularBlockUi);
	
	__webpack_require__(1892);
	
	__webpack_require__(1894);
	
	__webpack_require__(1896);
	
	__webpack_require__(1903);
	
	__webpack_require__(1905);
	
	var _angularUiNotification = __webpack_require__(1906);
	
	var _angularUiNotification2 = _interopRequireDefault(_angularUiNotification);
	
	__webpack_require__(1908);
	
	var _angularUiSwitch = __webpack_require__(1910);
	
	var _angularUiSwitch2 = _interopRequireDefault(_angularUiSwitch);
	
	__webpack_require__(1911);
	
	var _appMisc = __webpack_require__(956);
	
	var _angularGrowlV = __webpack_require__(1913);
	
	var _angularGrowlV2 = _interopRequireDefault(_angularGrowlV);
	
	__webpack_require__(1914);
	
	var _angularConfirm = __webpack_require__(1916);
	
	var _angularConfirm2 = _interopRequireDefault(_angularConfirm);
	
	__webpack_require__(1917);
	
	var _angularjsSlider = __webpack_require__(1919);
	
	var _angularjsSlider2 = _interopRequireDefault(_angularjsSlider);
	
	__webpack_require__(1920);
	
	var _angularAuth = __webpack_require__(1922);
	
	var _angularAuth2 = _interopRequireDefault(_angularAuth);
	
	var _angularLegacySortablejsMaintained = __webpack_require__(1928);
	
	var _angularLegacySortablejsMaintained2 = _interopRequireDefault(_angularLegacySortablejsMaintained);
	
	var _angularjsDropdownMultiselect = __webpack_require__(1930);
	
	var _angularjsDropdownMultiselect2 = _interopRequireDefault(_angularjsDropdownMultiselect);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _app3 = __webpack_require__(659);
	
	var _angularMarked = __webpack_require__(1931);
	
	var _angularMarked2 = _interopRequireDefault(_angularMarked);
	
	var _enquiryNotificationTemplate = __webpack_require__(1934);
	
	var _enquiryNotificationTemplate2 = _interopRequireDefault(_enquiryNotificationTemplate);
	
	var _existingEnquiryTemplate = __webpack_require__(1935);
	
	var _existingEnquiryTemplate2 = _interopRequireDefault(_existingEnquiryTemplate);
	
	var _sendMessageTemplate = __webpack_require__(1936);
	
	var _sendMessageTemplate2 = _interopRequireDefault(_sendMessageTemplate);
	
	var _webEnquiriesCreatedTemplate = __webpack_require__(1937);
	
	var _webEnquiriesCreatedTemplate2 = _interopRequireDefault(_webEnquiriesCreatedTemplate);
	
	var _enquiryFromWebEnquiryTemplate = __webpack_require__(1938);
	
	var _enquiryFromWebEnquiryTemplate2 = _interopRequireDefault(_enquiryFromWebEnquiryTemplate);
	
	var _assignWebEnquiry = __webpack_require__(1939);
	
	var _assignWebEnquiry2 = _interopRequireDefault(_assignWebEnquiry);
	
	var _codeweaversDataTemplate = __webpack_require__(1940);
	
	var _codeweaversDataTemplate2 = _interopRequireDefault(_codeweaversDataTemplate);
	
	var _autoPromiseTemplate = __webpack_require__(1941);
	
	var _autoPromiseTemplate2 = _interopRequireDefault(_autoPromiseTemplate);
	
	var _nukeContactConfirmTemplate = __webpack_require__(1942);
	
	var _nukeContactConfirmTemplate2 = _interopRequireDefault(_nukeContactConfirmTemplate);
	
	var _enquiryQuoteViewedTemplate = __webpack_require__(1943);
	
	var _enquiryQuoteViewedTemplate2 = _interopRequireDefault(_enquiryQuoteViewedTemplate);
	
	var _editMonthlyDistributionTemplate = __webpack_require__(1944);
	
	var _editMonthlyDistributionTemplate2 = _interopRequireDefault(_editMonthlyDistributionTemplate);
	
	var _editUserTargetsTemplate = __webpack_require__(1945);
	
	var _editUserTargetsTemplate2 = _interopRequireDefault(_editUserTargetsTemplate);
	
	var _marketingConsentExportTemplate = __webpack_require__(1946);
	
	var _marketingConsentExportTemplate2 = _interopRequireDefault(_marketingConsentExportTemplate);
	
	var _vehicleBrandingTemplate = __webpack_require__(1947);
	
	var _vehicleBrandingTemplate2 = _interopRequireDefault(_vehicleBrandingTemplate);
	
	var _editEnquirySourceTemplate = __webpack_require__(1948);
	
	var _editEnquirySourceTemplate2 = _interopRequireDefault(_editEnquirySourceTemplate);
	
	var _financeCreatedTemplate = __webpack_require__(1949);
	
	var _financeCreatedTemplate2 = _interopRequireDefault(_financeCreatedTemplate);
	
	var _docuSignAuthConsentTemplate = __webpack_require__(1950);
	
	var _docuSignAuthConsentTemplate2 = _interopRequireDefault(_docuSignAuthConsentTemplate);
	
	var _signatureEventTemplate = __webpack_require__(1951);
	
	var _signatureEventTemplate2 = _interopRequireDefault(_signatureEventTemplate);
	
	var _mazdaAuthConsentTemplate = __webpack_require__(1952);
	
	var _mazdaAuthConsentTemplate2 = _interopRequireDefault(_mazdaAuthConsentTemplate);
	
	var _addCustomFormTemplate = __webpack_require__(1953);
	
	var _addCustomFormTemplate2 = _interopRequireDefault(_addCustomFormTemplate);
	
	var _mercUsedWarranty = __webpack_require__(1954);
	
	var _mercUsedWarranty2 = _interopRequireDefault(_mercUsedWarranty);
	
	var _stockProviderTemplate = __webpack_require__(1955);
	
	var _stockProviderTemplate2 = _interopRequireDefault(_stockProviderTemplate);
	
	var _webLeadFollowUpEmailTemplate = __webpack_require__(1956);
	
	var _webLeadFollowUpEmailTemplate2 = _interopRequireDefault(_webLeadFollowUpEmailTemplate);
	
	var _scheduledReportEditTemplate = __webpack_require__(1957);
	
	var _scheduledReportEditTemplate2 = _interopRequireDefault(_scheduledReportEditTemplate);
	
	var _contactViewEnquiryRegs = __webpack_require__(1958);
	
	var _contactViewEnquiryRegs2 = _interopRequireDefault(_contactViewEnquiryRegs);
	
	var _telecomProviderTemplate = __webpack_require__(1959);
	
	var _telecomProviderTemplate2 = _interopRequireDefault(_telecomProviderTemplate);
	
	var _exportContactsTemplate = __webpack_require__(1960);
	
	var _exportContactsTemplate2 = _interopRequireDefault(_exportContactsTemplate);
	
	var _callLogViewTemplate = __webpack_require__(1961);
	
	var _callLogViewTemplate2 = _interopRequireDefault(_callLogViewTemplate);
	
	var _editProduct = __webpack_require__(1962);
	
	var _editProduct2 = _interopRequireDefault(_editProduct);
	
	var _editContactTemplate = __webpack_require__(1963);
	
	var _editContactTemplate2 = _interopRequireDefault(_editContactTemplate);
	
	var _editInvoicePaymentTemplate = __webpack_require__(1964);
	
	var _editInvoicePaymentTemplate2 = _interopRequireDefault(_editInvoicePaymentTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appModule = _angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _components2.default, 'angucomplete-alt', 'blockUI', 'ui-notification', 'uiSwitch', 'angular-growl', 'cp.ngConfirm', 'rzModule', 'auth0.auth0', 'ng-sortable', 'angularjs-dropdown-multiselect', 'hc.marked']).config(["$locationProvider", function ($locationProvider) {
	    "ngInject";
	    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	    // #how-to-configure-your-server-to-work-with-html5mode
	
	    $locationProvider.html5Mode(true).hashPrefix('!');
	
	    //Global Settings
	    String.prototype.toCamelCase = function () {
	        return this.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
	            if (p2) return p2.toUpperCase();
	            return p1.toLowerCase();
	        });
	    };
	
	    String.prototype.replaceAll = function (search, replacement) {
	        var target = this;
	        return target.replace(new RegExp(search, 'g'), replacement);
	    };
	
	    Date.prototype.withoutTime = function () {
	        var d = new Date(this);
	        d.setHours(0, 0, 0, 0);
	        return d;
	    };
	
	    Date.prototype.getUTCTime = function () {
	        return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds()).getTime();
	    };
	
	    Date.prototype.toUniversalFormat = function () {
	        return this.getFullYear() + '-' + (this.getMonth() + 1) + '-' + this.getDate();
	    };
	
	    // Radialize the colors
	    _highcharts2.default.setOptions({
	        colors: _highcharts2.default.map(_highcharts2.default.getOptions().colors, function (color) {
	            return {
	                radialGradient: {
	                    cx: 0.5,
	                    cy: 0.3,
	                    r: 0.7
	                },
	                stops: [[0, color], [1, _highcharts2.default.color(color).brighten(-0.3).get('rgb')] // darken
	                ]
	            };
	        })
	    });
	}]).config(["angularAuth0Provider", "appConfig", function (angularAuth0Provider, appConfig) {
	    "ngInject";
	
	    angularAuth0Provider.init({
	        clientID: appConfig.auth0.clientId,
	        domain: appConfig.auth0.domain,
	        responseType: 'token id_token',
	        scope: 'openid email profile'
	    });
	}]).config(["blockUIConfig", function (blockUIConfig) {
	    "ngInject";
	
	    blockUIConfig.autoBlock = false;
	    blockUIConfig.delay = 10;
	}]).run(["$templateCache", function ($templateCache) {
	    "ngInject";
	
	    $templateCache.put('templates/notification/enquiryNotificationTemplate', _enquiryNotificationTemplate2.default);
	    $templateCache.put('templates/notification/existingEnquiryTemplate', _existingEnquiryTemplate2.default);
	    $templateCache.put('templates/notification/sendMessageTemplate', _sendMessageTemplate2.default);
	    $templateCache.put('templates/notification/enquiryFromWebEnquiryTemplate', _enquiryFromWebEnquiryTemplate2.default);
	    $templateCache.put('templates/notification/webEnquiriesCreatedTemplate', _webEnquiriesCreatedTemplate2.default);
	    $templateCache.put('templates/webEnquiry/assignWebEnquiry', _assignWebEnquiry2.default);
	    $templateCache.put('templates/webEnquiry/codeweaversDataTemplate', _codeweaversDataTemplate2.default);
	    $templateCache.put('templates/promise/autoPromiseTemplate', _autoPromiseTemplate2.default);
	    $templateCache.put('templates/dashboard/nukeContactConfirmTemplate', _nukeContactConfirmTemplate2.default);
	    $templateCache.put('templates/notification/enquiryQuoteViewedTemplate', _enquiryQuoteViewedTemplate2.default);
	    $templateCache.put('templates/performance/editMonthlyDistributionTemplate', _editMonthlyDistributionTemplate2.default);
	    $templateCache.put('templates/performance/editUserTargetsTemplate', _editUserTargetsTemplate2.default);
	    $templateCache.put('templates/reports/marketingConsentExportTemplate', _marketingConsentExportTemplate2.default);
	    $templateCache.put('templates/vehicle/vehicleBrandingTemplate', _vehicleBrandingTemplate2.default);
	    $templateCache.put('templates/admin/editEnquirySourceTemplate', _editEnquirySourceTemplate2.default);
	    $templateCache.put('templates/notification/financeCreatedTemplate', _financeCreatedTemplate2.default);
	    $templateCache.put('templates/enquiry/docuSignAuthConsentTemplate', _docuSignAuthConsentTemplate2.default);
	    $templateCache.put('templates/notification/signatureEventTemplate', _signatureEventTemplate2.default);
	    $templateCache.put('templates/vehicle/mazdaAuthConsentTemplate', _mazdaAuthConsentTemplate2.default);
	    $templateCache.put('templates/customForms/addCustomFormTemplate', _addCustomFormTemplate2.default);
	    $templateCache.put('templates/customForms/mercUsedWarranty', _mercUsedWarranty2.default);
	    $templateCache.put('templates/admin/stockProviderTemplate', _stockProviderTemplate2.default);
	    $templateCache.put('templates/enquiry/webLeadFollowUpEmailTemplate', _webLeadFollowUpEmailTemplate2.default);
	    $templateCache.put('templates/reports/scheduledReportEditTemplate', _scheduledReportEditTemplate2.default);
	    $templateCache.put('templates/contact/contactViewEnquiryRegs', _contactViewEnquiryRegs2.default);
	    $templateCache.put('templates/admin/telecomProviderTemplate', _telecomProviderTemplate2.default);
	    $templateCache.put('templates/contact/exportContactsTemplate', _exportContactsTemplate2.default);
	    $templateCache.put('templates/contact/callLogViewTemplate', _callLogViewTemplate2.default);
	    $templateCache.put('templates/product/editProductTemplate', _editProduct2.default);
	    $templateCache.put('templates/contact/editContactTemplate', _editContactTemplate2.default);
	    $templateCache.put('templates/accounting/editInvoicePaymentTemplate', _editInvoicePaymentTemplate2.default);
	}]).run(["appConfig", "$location", function (appConfig, $location) {
	    "ngInject";
	
	    //Determine the URL being used (localhost / carsnowdev / leadmanager / carsnow-prod)
	
	    appConfig.oauthCallbackUrl = $location.protocol() + '://' + $location.host() + ($location.port() === 80 || $location.port() === 443 ? '' : ':' + $location.port()) + '/login';
	
	    //Set the baseApiUrl 
	    appConfig.apiServiceBaseUri = $location.protocol() + '://' + $location.host() + ($location.port() === 80 || $location.port() === 443 ? '' : ':30641/') + ($location.port() === 80 || $location.port() === 443 ? '/api/' : '');
	
	    if (appConfig.oauthCallbackUrl.search('localhost') !== -1) {
	        appConfig.appTitle = "Cars Now Localhost";
	    } else if (appConfig.oauthCallbackUrl.search('carsnowdev.com') !== -1) {
	        appConfig.appTitle = "Cars Now Dev";
	    } else if (appConfig.oauthCallbackUrl.search('carsnow.ie') !== -1) {
	        appConfig.appTitle = "Cars Now";
	    } else if (appConfig.oauthCallbackUrl.search('leadmanagerdev.com') !== -1) {
	        appConfig.appTitle = "Lead Manager Dev";
	    } else if (appConfig.oauthCallbackUrl.search('leadmanager.ie') !== -1) {
	        appConfig.appTitle = "Lead Manager";
	    }
	
	    appConfig.isLeadManager = appConfig.appTitle.toLowerCase().search('lead manager') !== -1;
	    //appConfig.isLeadManager = true;
	    //Theme Configurator
	    appConfig.switchTheme = function () {
	        //Set Base Image Path
	        if (!appConfig.isLeadManager) {
	            appConfig.imagePath = "images";
	            appConfig.supportEmail = "support@carsnow.ie";
	        } else {
	            appConfig.imagePath = "images/leadmanager";
	            appConfig.supportEmail = "support@leadmanager.ie";
	        }
	
	        //Update favicon
	        document.getElementById("favicon").setAttribute("href", appConfig.imagePath + '/menu-btn.png');
	
	        //Apply Theme Color
	        (0, _app3.applyTheme)(appConfig.isLeadManager);
	    };
	    appConfig.switchTheme();
	
	    console.log('oauthCallbackUrl', appConfig.oauthCallbackUrl);
	    console.log('apiServiceBaseUri', appConfig.apiServiceBaseUri);
	}]).run(["$transitions", "pushService", "appConfig", function ($transitions, pushService, appConfig) {
	    "ngInject";
	
	    $transitions.onSuccess({}, function (transition) {
	        var isMobileDevice = window.navigator.userAgent.toLowerCase().includes("mobi");
	        document.body.style.position = '';
	
	        if (isMobileDevice && (transition.to().name === 'simpleDpa' || transition.to().name === 'allDpa')) {
	            document.body.style.position = 'fixed';
	        }
	
	        document.title = appConfig.appTitle;
	        (0, _appMisc.initJqElems)();
	        pushService.init();
	    });
	}]).constant('enums', {
	    PERMISSION_TYPE: {
	        View: 1,
	        Add: 2,
	        Edit: 4,
	        Delete: 8
	    },
	
	    ENTITY_TYPE: {
	        Company: 1,
	        Dealer: 2,
	        Location: 3
	    },
	
	    OBJECT_ROW_STATE: {
	        Active: 1,
	        Inactive: 2,
	        Deleted: 3
	    },
	
	    MEDIA_TYPE: {
	        Image: 1,
	        Video: 2,
	        ExternalImage: 3,
	        Youtube: 4
	    },
	
	    VEHICLE_STATUS: {
	        DueIn: 1,
	        InStock: 2,
	        Sold: 3,
	        Delivered: 4,
	        Discontinued: 5,
	        Pending: 6
	    },
	
	    VEHICLE_CONDITION: {
	        New: 1,
	        Used: 2
	    },
	
	    AUTO_SOLD: {
	        Retail: 1,
	        Trade: 2
	    },
	
	    VEHICLE_CONDITION_SEARCH: {
	        All: 0,
	        New: 1,
	        UsedRetail: 2,
	        UsedTrade: 3
	    },
	
	    COMPANY_TYPE: {
	        Limited: 1,
	        Partnership: 2,
	        SoleTrader: 3
	    },
	
	    CONTACT_TYPE: {
	        Customer: 1,
	        Supplier: 2,
	        Trader: 3,
	        RetailFleet: 4,
	        Other: 5
	    },
	
	    PERSON_TITLE: {
	        Dr: 1,
	        Mr: 2,
	        Miss: 3,
	        Ms: 7,
	        Mrs: 4,
	        Rev: 5,
	        Other: 6,
	        Sr: 8
	    },
	
	    CONTACT_METHOD: {
	        Phone: 1,
	        Email: 2,
	        Post: 3
	    },
	
	    ENQUIRY_PRICE_TYPE: {
	        Cost: 1,
	        Discount: 2
	    },
	
	    ENQUIRY_PAYMENT_MODE: {
	        Cash: 1,
	        EFT: 3,
	        Cheque: 5,
	        Finance: 6
	    },
	
	    ENQUIRY_ORIGINATION: {
	        WalkIn: 1,
	        Phone: 2,
	        Email: 3,
	        Web: 4,
	        CarsNowApp: 11,
	        InboundCall: 12,
	        OutboundCall: 13
	    },
	
	    ENQUIRY_CONTACT: {
	        Trade: 1,
	        Retail: 2
	    },
	
	    ENQUIRY_STATE: {
	        Open: 1,
	        Lost: 2,
	        Confirmed: 3,
	        Closed: 4
	    },
	
	    ENQUIRY_LOST_REASON: {
	        Price: 1,
	        Availability: 2,
	        Recommendation: 3,
	        "Quality Of Service": 4,
	        "Finance Rates": 5,
	        "Opened In Error": 6,
	        "Finance Declined": 7,
	        "Bought Non Franchise": 8,
	        "Bought From Competitor": 9,
	        "Not Changing Until": 10,
	        "Bought From Different Enquiry": 11,
	        "No Further Contact Possible": 12,
	        "Closed by Admin": 13
	    },
	
	    FUEL_TYPE: {
	        Petrol: 1,
	        Diesel: 2,
	        Hybrid: 3,
	        BiFuel: 4,
	        Electric: 5,
	        LPG: 6,
	        BioGas: 7,
	        Other: 8,
	        BioFuel: 9,
	        DieselHybrid: 10,
	        DieselPlugInHybrid: 11,
	        DualFuel: 12,
	        PetrolEthanol: 13,
	        PetrolHybrid: 14,
	        PetrolPlugInHybrid: 15,
	        UnspecifiedHybrid: 16
	    },
	
	    VEHICLE_BODY_TYPE: {
	        Cabriolet: 1,
	        Coupe: 2,
	        Estate: 3,
	        Hatchback: 4,
	        MPV: 5,
	        Saloon: 6,
	        SUV: 7,
	        LCV: 8,
	        "4x4": 9,
	        "Mini MPV": 10,
	        Van: 11,
	        Bus: 12,
	        "Panel Van": 13,
	        PickUp: 14,
	        Commercial: 15,
	        "Mini Bus": 16,
	        "Chassis Cab": 17,
	        "Crew Cab Pickup": 18,
	        "Sport Mini": 19,
	        "Lift Back": 20,
	        "Car Derived Van": 21,
	        Roadster: 22,
	        "Station Wagon": 23,
	        Hatch: 24,
	        Quadcycle: 25
	    },
	
	    ENQUIRY_PRICE_GROUP_TYPE: {
	        VehiclePricing: 1,
	        Extras: 2,
	        FinancialProducts: 3,
	        Misc: 4
	    },
	
	    TRANSMISSION_TYPE: {
	        Manual: 1,
	        Automatic: 2
	    },
	
	    VEHICLE_TYPE: {
	        Car: 1,
	        Commercial: 2
	    },
	
	    ENQUIRY_TYPE: {
	        Sales: 1,
	        Aftersales: 2
	    },
	
	    ENQUIRY_SUBTYPE: {
	        New: 1,
	        Used: 2,
	        BuyIn: 3,
	        FinanceQuote: 4,
	        Unsure: 5,
	        ServiceBooking: 6,
	        RepairsRequired: 7,
	        Parts: 8,
	        TechQuery: 9
	    },
	
	    PROMISE_CATEGORY: {
	        Customer: 1,
	        Business: 2,
	        Personal: 3
	    },
	
	    MILEAGE_TYPE: {
	        Km: 1,
	        Mi: 2
	    },
	
	    COLOR: {
	        Beige: 1,
	        Black: 2,
	        Blue: 3,
	        Bronze: 4,
	        Brown: 5,
	        Gold: 6,
	        Green: 7,
	        Grey: 8,
	        Maroon: 9,
	        Navy: 10,
	        Orange: 11,
	        Pink: 12,
	        Purple: 13,
	        Red: 14,
	        Silver: 15,
	        Various: 16,
	        White: 17,
	        Wine: 18,
	        Yellow: 19
	    },
	
	    DATE_RANGE_TYPE: {
	        Today: 1,
	        Yesterday: 2,
	        'This Week': 3,
	        'This Month to date': 4,
	        'This Month': 5,
	        'This Quarter': 6,
	        'This Year': 7,
	        'This Year to date': 8,
	        'Last Week': 9,
	        'Last Month': 10,
	        'Last Quarter': 11,
	        'Next Week': 12,
	        'Next Month': 13,
	        'Next Quarter': 14,
	        Custom: 100
	    },
	
	    USER_WORK_TYPE: {
	        Sales: 1,
	        Aftersales: 2
	    },
	
	    RESIDENCE_TYPE: {
	        Owner: 1,
	        Tenant: 2,
	        LWP: 3
	    },
	
	    GENDER: {
	        Male: 1,
	        Female: 2
	    },
	
	    MARITAL_STATUS: {
	        Single: 1,
	        Married: 2,
	        'Civil Partner': 3,
	        Divorced: 4,
	        Widowed: 5
	    },
	
	    EMPLOYMENT_TYPE: {
	        FullTime: 1,
	        PartTime: 2,
	        SelfEmployed: 3
	    },
	
	    FINANCE_STATE: {
	        Awaiting_Approval: 1,
	        Finance_Accepted: 2,
	        Finance_Rejected: 3,
	        Customer_Accepted: 4,
	        Customer_Rejected: 5
	    },
	
	    FINANCE_TYPE: {
	        HP: 1,
	        PCP: 2
	    },
	
	    AUTO_PROMISE_TRIGGER: {
	        "New contact created": 1,
	        "Enquiry created on a new vehicle": 2,
	        "Enquiry confirmed on a new vehicle": 3,
	        "Enquiry closed on a new vehicle": 4,
	        "Finance created on a new vehicle": 5,
	        "Finance accepted by customer on a new vehicle": 6,
	        "Enquiry created on a used vehicle": 7,
	        "Enquiry confirmed on a used vehicle": 8,
	        "Enquiry closed on a used vehicle": 9,
	        "Finance created on a used vehicle": 10,
	        "Finance accepted by customer on a used vehicle": 11,
	        "New Web Enquiry Received": 12
	    },
	
	    TIMESPAN_TYPE: {
	        Day: 1,
	        Week: 2,
	        Month: 3,
	        Year: 4
	    },
	
	    APPRAISAL_QUALITY: {
	        Excellent: 1,
	        Good: 2,
	        Fair: 3,
	        Poor: 4
	    },
	
	    ENQUIRY_CONFIRMED_EMAIL_TYPE: {
	        Unknown: 0,
	        Retail: 1,
	        Trade: 2,
	        BuyIn: 4
	    },
	
	    REPORTABLE_ADDON_TYPE: {
	        All: 1,
	        Chargeable: 2,
	        Complimentary: 3
	    },
	
	    OMNISEARCH_OBJECT_TYPE: {
	        Enquiry: 1,
	        Contact: 2
	    },
	
	    COMPONENT_STATE: {
	        Uninitialized: 0,
	        Loading: 1,
	        Completed: 2
	    },
	
	    WEB_ENQUIRY_SOURCE: {
	        Email: 0,
	        Lucid: 1,
	        Api: 2
	    },
	
	    WEB_PUBLISHER_TYPE: {
	        EasierAd: 1,
	        StockLoader: 2
	    },
	
	    SIGNATURE_STATUS: {
	        Created: 1,
	        Voided: 2,
	        CustomerSigned: 3,
	        CustomerDeclined: 4,
	        Completed: 5,
	        DealerDeclined: 6
	    },
	
	    DEFAULT_LANDING_PAGE: {
	        WelcomeCentre: 0,
	        Dashboard: 1,
	        LeadMonitor_WebEnquiries_Today: 2,
	        LeadMonitor_WebEnquiries_ThisWeek: 3,
	        LeadMonitor_WebEnquiries_LastWeek: 4,
	        LeadMonitor_Enquiries_Today: 5,
	        LeadMonitor_Enquiries_ThisWeek: 6,
	        LeadMonitor_Enquiries_LastWeek: 7
	    },
	
	    ENTITY_META_TYPE: {
	        EnquiryManageGroupHash: 1,
	        EnquiryManageFranchiseHash: 2,
	        WebLeadFollowUpEmail: 3,
	        DisplayInDashboard: 4,
	        EnquiryManageLocationHash: 5,
	        MarketingSourceRequired: 6,
	        SalutationEnabled: 7,
	        TelecomProvider: 8,
	        MandatoryMakeModel: 9,
	        ConfirmedEnquiryComplianceTemplate: 10,
	        InvoiceDetails: 11
	    },
	
	    SCHEDULED_REPORT_FREQUENCY: {
	        Daily: 1,
	        Weekly: 2,
	        //BiWeekly: 3,
	        Monthly: 4,
	        Quarterly: 5
	    },
	
	    SCHEDULED_REPORT_OUTPUT_TYPE: {
	        Html: 1,
	        Pdf: 2,
	        Excel: 3
	    },
	
	    SCHEDULED_REPORT_OUTPUT_TYPE_TEMP: {
	        Html: 1,
	        Excel: 3
	    },
	
	    INVOICE_STATUS: {
	        Draft: 1,
	        Issued: 2,
	        Paid: 3,
	        Voided: 4,
	        Deleted: 5
	    }
	}).filter("trustUrl", ["$sce", function ($sce) {
	    "ngInject";
	
	    return function (recordingUrl) {
	        return $sce.trustAsResourceUrl(recordingUrl);
	    };
	}]).filter("time", function () {
	    "ngInject";
	
	    return function (sec) {
	        var sec_num = parseInt(sec, 10); // don't forget the second param
	        var hours = Math.floor(sec_num / 3600);
	        var minutes = Math.floor((sec_num - hours * 3600) / 60);
	        var seconds = sec_num - hours * 3600 - minutes * 60;
	
	        if (hours < 10) {
	            hours = "0" + hours;
	        }
	        if (minutes < 10) {
	            minutes = "0" + minutes;
	        }
	        if (seconds < 10) {
	            seconds = "0" + seconds;
	        }
	        return hours + ':' + minutes + ':' + seconds;
	    };
	}).directive('ngEnumFlag', function () {
	    return {
	        restrict: 'A',
	        scope: {
	            value: '=ngEnumFlag',
	            model: '=ngEnumModel'
	        },
	        link: function link(scope, element) {
	            var checkbox = element[0];
	            element.on('change', function () {
	                scope.$apply(function () {
	                    if (checkbox.checked) {
	                        scope.model += scope.value;
	                    } else {
	                        scope.model -= scope.value;
	                    }
	                });
	            });
	            scope.$watch('model', function () {
	                checkbox.checked = (scope.model & scope.value) == scope.value;
	            });
	        }
	    };
	}).directive('inputRestrictor', function () {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        scope: {
	            value: '=ngEnumFlag',
	            model: '=ngEnumModel'
	        },
	        link: function link(scope, element, attr, ngModelCtrl) {
	            var pattern = /[^a-z0-9]/gi;
	            function fromUser(text) {
	                if (!text) return text;
	
	                var transformedInput = text.replace(pattern, '');
	                if (transformedInput !== text) {
	                    ngModelCtrl.$setViewValue(transformedInput);
	                    ngModelCtrl.$render();
	                }
	                return transformedInput;
	            }
	            ngModelCtrl.$parsers.push(fromUser);
	        }
	    };
	}).component('app', _app2.default).name;
	
	//Import Tempaltes  
	exports.default = appModule;

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(346);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./site.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./site.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".angucomplete-dropdown{border:1px solid #ccc;border-radius:2px;width:250px;padding-top:20px;padding:6px;cursor:pointer;z-index:9999;position:absolute;margin-top:32px;background-color:#fff;overflow-y:auto;max-height:200px}.autocomplete-highlight{color:red}.user-image{height:128px!important;width:128px!important;cursor:pointer}.user-image-container .selected,.user-image-container img:hover{border:2px solid red}.iconBtn{font-size:14px!important}", ""]);
	
	// exports


/***/ }),
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authService = __webpack_require__(448);
	
	var _authService2 = _interopRequireDefault(_authService);
	
	var _navbar = __webpack_require__(501);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(510);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	var _CarsNowAppConfig = __webpack_require__(516);
	
	var _CarsNowAppConfig2 = _interopRequireDefault(_CarsNowAppConfig);
	
	var _authInterceptorService = __webpack_require__(517);
	
	var _authInterceptorService2 = _interopRequireDefault(_authInterceptorService);
	
	var _loadingService = __webpack_require__(518);
	
	var _loadingService2 = _interopRequireDefault(_loadingService);
	
	var _lookupService = __webpack_require__(500);
	
	var _lookupService2 = _interopRequireDefault(_lookupService);
	
	var _pushService = __webpack_require__(519);
	
	var _pushService2 = _interopRequireDefault(_pushService);
	
	var _notificationService = __webpack_require__(520);
	
	var _notificationService2 = _interopRequireDefault(_notificationService);
	
	var _addPromiseService = __webpack_require__(521);
	
	var _addPromiseService2 = _interopRequireDefault(_addPromiseService);
	
	var _addEditEnquiryExtraService = __webpack_require__(524);
	
	var _addEditEnquiryExtraService2 = _interopRequireDefault(_addEditEnquiryExtraService);
	
	var _addEditFinancialProductService = __webpack_require__(526);
	
	var _addEditFinancialProductService2 = _interopRequireDefault(_addEditFinancialProductService);
	
	var _utilsService = __webpack_require__(528);
	
	var _utilsService2 = _interopRequireDefault(_utilsService);
	
	var _print = __webpack_require__(658);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _export = __webpack_require__(660);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _mail = __webpack_require__(661);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _admin = __webpack_require__(662);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _file = __webpack_require__(663);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _branding = __webpack_require__(664);
	
	var _branding2 = _interopRequireDefault(_branding);
	
	var _performanceManagementService = __webpack_require__(665);
	
	var _performanceManagementService2 = _interopRequireDefault(_performanceManagementService);
	
	var _integration = __webpack_require__(666);
	
	var _integration2 = _interopRequireDefault(_integration);
	
	var _customForms = __webpack_require__(667);
	
	var _customForms2 = _interopRequireDefault(_customForms);
	
	var _barChart = __webpack_require__(668);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	var _dialogService = __webpack_require__(675);
	
	var _dialogService2 = _interopRequireDefault(_dialogService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _navbar4.default, _barChart2.default]).service('authService', _authService2.default).service('authInterceptorService', _authInterceptorService2.default).service('loadingService', _loadingService2.default).service('lookupService', _lookupService2.default).service('pushService', _pushService2.default).service('notificationService', _notificationService2.default).service('addPromiseService', _addPromiseService2.default).service('addEditEnquiryExtraService', _addEditEnquiryExtraService2.default).service('addEditFinancialProductService', _addEditFinancialProductService2.default).service('utilsService', _utilsService2.default).service('printService', _print2.default).service('exportService', _export2.default).service('mailService', _mail2.default).service('adminService', _admin2.default).service('fileService', _file2.default).service('brandingService', _branding2.default).service('performanceManagementService', _performanceManagementService2.default).service('integrationService', _integration2.default).service('customFormsService', _customForms2.default).service('dialogService', _dialogService2.default).config(["$httpProvider", function ($httpProvider) {
	  "ngInject";
	
	  $httpProvider.interceptors.push('authInterceptorService');
	}]).constant('appConfig', ({"msClientId":"88704920-3119-473b-b5f4-219639c48419","useAuth0":true,"auth0":{"clientId":"msaW3PakUso8HVmjBo-Om_NxzsHYT93U","domain":"carsnow.eu.auth0.com"},"docuSignClientId":"39754e4d-49d7-47b5-b3a8-a88e2be0d113","mazda":{"baseUrl":"https://mappsacc.mazdaeur.com","clientId":"0725AE0F-6D78-4D99-966C-F48725F0BE33"}})).name;
	
	exports.default = commonModule;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(449);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _lookupService = __webpack_require__(500);
	
	var _lookupService2 = _interopRequireDefault(_lookupService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function () {
	  AuthService.$inject = ["$http", "$q", "$state", "appConfig", "angularAuth0", "enums"];
	  function AuthService($http, $q, $state, appConfig, angularAuth0, enums) {
	    "ngInject";
	
	    var _this = this;
	
	    var storageProvider = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : window.sessionStorage;
	    (0, _classCallCheck3.default)(this, AuthService);
	    this.$http = $http;
	    this.$q = $q;
	    this.$state = $state;
	    this.appConfig = appConfig;
	    this.storageProvider = storageProvider;
	    this.lookupService = new _lookupService2.default($http, $q, appConfig);
	    this.angularAuth0 = angularAuth0;
	    this.enums = enums;
	    this.lookupService.lookupRoles().then(function (roles) {
	      _this.roles = roles;
	    });
	
	    this.loggingIn = false;
	
	    this.authData = {
	      siteMapCollection: []
	    };
	
	    this.retrieveLoggedInData();
	  }
	
	  (0, _createClass3.default)(AuthService, [{
	    key: 'retrieveLoggedInData',
	    value: function retrieveLoggedInData() {
	      this.authData = JSON.parse(this.storageProvider.getItem('authData')) || { siteMapCollection: [] };
	    }
	  }, {
	    key: 'authorize',
	    value: function authorize(authCodeOrEmail, isRenew) {
	      var _this2 = this;
	
	      var authService = this;
	
	      var deferred = this.$q.defer();
	
	      var url = '';
	
	      if (this.appConfig.useAuth0) {
	        url = this.appConfig.apiServiceBaseUri + ('api/auth/ExternalAuthByEmail' + (this.appConfig.isLeadManager ? '_LM' : ''));
	      } else {
	        url = this.appConfig.apiServiceBaseUri + 'api/auth/ExternalAuth';
	      }
	
	      this.loggingIn = true;
	
	      this.$http.post(url, authCodeOrEmail).success(function (response) {
	        var tempAuthData = response;
	
	        if (!isRenew) {
	          if (tempAuthData.userLocations && tempAuthData.userLocations.length) {
	            //Get Default Location if any
	            var defaultLocation = (0, _lodash.find)(tempAuthData.userLocations, function (o) {
	              return o.defaultLocation;
	            });
	
	            tempAuthData.currentLocation = defaultLocation || tempAuthData.userLocations[0];
	          }
	
	          tempAuthData.msgCount = tempAuthData.msgCount || 0;
	
	          _this2.storageProvider.setItem('authData', (0, _stringify2.default)(tempAuthData));
	          (0, _assign2.default)(_this2.authData, tempAuthData);
	
	          _this2.getLocationExtendedProperties('dashboardPreferences');
	        } else {
	          _this2.authData.authToken = response.authToken;
	          _this2.authData.expiry = response.expiry;
	          _this2.storageProvider.removeItem('authData');
	          _this2.storageProvider.setItem('authData', (0, _stringify2.default)(_this2.authData));
	        }
	
	        deferred.resolve();
	      }).error(function (err, status) {
	        _this2.logOut();
	        deferred.reject(err, status);
	      }).finally(function () {
	        _this2.loggingIn = false;
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'authorize_Auth0',
	    value: function authorize_Auth0(accessToken) {
	      var _this3 = this;
	
	      var authService = this;
	
	      var deferred = this.$q.defer();
	
	      var url = this.appConfig.apiServiceBaseUri + ('api/auth/ExternalAuth_Auth0' + (this.appConfig.isLeadManager ? '_LM' : ''));
	
	      this.loggingIn = true;
	
	      this.$http.post(url, accessToken).success(function (response) {
	        var tempAuthData = response;
	
	        if (tempAuthData.userLocations && tempAuthData.userLocations.length) {
	          //Get Default Location if any
	          var defaultLocation = (0, _lodash.find)(tempAuthData.userLocations, function (o) {
	            return o.defaultLocation;
	          });
	
	          tempAuthData.currentLocation = defaultLocation || tempAuthData.userLocations[0];
	        }
	
	        tempAuthData.msgCount = tempAuthData.msgCount || 0;
	
	        _this3.storageProvider.setItem('authData', (0, _stringify2.default)(tempAuthData));
	        (0, _assign2.default)(_this3.authData, tempAuthData);
	
	        deferred.resolve();
	      }).error(function (err, status) {
	        _this3.logOut();
	        deferred.reject(err, status);
	      }).finally(function () {
	        _this3.loggingIn = false;
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'login',
	    value: function login(loginData) {
	      var _this4 = this;
	
	      var authService = this;
	      var deferred = this.$q.defer();
	
	      this.$http.post(this.appConfig.apiServiceBaseUri + 'api/auth/login', loginData).then(function (response) {
	        authService.updateAuthAfterAuthentication(response.data);
	
	        deferred.resolve(response);
	      }).catch(function (err, status) {
	        _this4.logOut();
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'getSkupenetToken',
	    value: function getSkupenetToken(skupenetVehicle) {
	      var authService = this;
	
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/auth/skupenettoken/', skupenetVehicle);
	    }
	  }, {
	    key: 'getSkupenetTokenEdit',
	    value: function getSkupenetTokenEdit(skupenetId) {
	      var authService = this;
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/auth/skupenettoken/' + this.authData.currentLocation.webPublisherUsername + '/' + skupenetId));
	    }
	  }, {
	    key: 'logOut',
	    value: function logOut() {
	      if (this.loggingIn) {
	        return;
	      }
	      var authService = this;
	      var isAdmin = authService.authData.isAdmin;
	
	      this.storageProvider.removeItem('authData');
	
	      if (authService.authData.siteMapCollection) {
	        authService.authData.siteMapCollection.map(function (item) {
	          return authService.authData.siteMapCollection.pop(item);
	        });
	      }
	
	      authService.authData = {
	        siteMapCollection: []
	      };
	
	      if (authService.$state.current.name === 'adminLogin' || isAdmin) {
	        authService.$state.go('adminLogin');
	      } else {
	        if (this.appConfig.useAuth0) {
	          this.angularAuth0.logout({
	            returnTo: this.appConfig.oauthCallbackUrl
	          });
	        } else {
	          authService.$state.go('userLogin');
	        }
	      }
	    }
	  }, {
	    key: 'validateUser',
	    value: function validateUser(isAdmin, featureName, permissionToCheck, redirect) {
	      var authService = this;
	
	      if (authService.isLoggedIn()) {
	        if (authService.authData.isAdmin !== isAdmin) {
	          return false;
	        } else if (featureName && permissionToCheck) {
	          return authService.checkFeatureAccess(featureName, permissionToCheck, redirect);
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'updateAuthAfterAuthentication',
	    value: function updateAuthAfterAuthentication(authData) {
	      var authService = this;
	
	      authService.storageProvider.setItem('authData', (0, _stringify2.default)(authData));
	
	      authService.authData = (0, _assign2.default)(authService.authData, authData);
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      var authService = this;
	
	      if ((0, _keys2.default)(authService.authData).length === 1 && authService.authData.siteMapCollection) {
	        //User is not logged
	        authService.logOut();
	        return false;
	      } else if (new Date(authService.authData.expiry) < new Date()) {
	        //Token is expired
	        authService.logOut();
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'timeToLogout',
	    value: function timeToLogout() {
	      return new Date(this.authData.expiry) - new Date();
	    }
	  }, {
	    key: 'isLoggedIn_NoRedirect',
	    value: function isLoggedIn_NoRedirect() {
	      var authService = this;
	
	      if ((0, _keys2.default)(authService.authData).length === 1 && authService.authData.siteMapCollection) {
	        //User is not logged
	        return false;
	      } else if (new Date(authService.authData.expiry) < new Date()) {
	        //Token is expired
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'unauthorized',
	    value: function unauthorized(msg) {
	      var authService = this;
	
	      authService.$state.go('unauthorized', { msg: msg });
	    }
	  }, {
	    key: 'checkFeatureAccess',
	    value: function checkFeatureAccess(featureName, permissionToCheck, redirect, brandId) {
	      var _this5 = this;
	
	      if (this.authData.isAdmin) {
	        return true;
	      }
	
	      var hasAccess = false;
	
	      //Get the list of All roles vailable to this user in this location (on a brand)
	      var locationRoles = void 0;
	      if (!brandId) {
	        locationRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	          return o.entityId === _this5.authData.currentLocation.key;
	        });
	      } else {
	        locationRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	          return o.entityId === _this5.authData.currentLocation.key && (o.brandId === brandId || o.brandId === 1);
	        });
	      }
	
	      //Get a unique list of role Ids only
	      var uniqueRolesInLocation = (0, _lodash.uniqBy)(locationRoles, function (o) {
	        return o.roleId;
	      }).map(function (userRole) {
	        return userRole.roleId;
	      });
	
	      //Get permission set by the feature name
	      var featurePermissions = (0, _lodash.filter)(this.authData.permissionSet, function (o) {
	        return o.featureName === featureName;
	      });
	
	      //Get permissions specific to the unique roles
	      var rolePermissions = (0, _lodash.filter)(featurePermissions, function (o) {
	        return (0, _lodash.find)(uniqueRolesInLocation, function (roleId) {
	          return o.roleId === roleId;
	        }) !== undefined;
	      });
	
	      rolePermissions.map(function (perm) {
	        hasAccess = hasAccess || (perm.permissions & permissionToCheck) === permissionToCheck;
	      });
	
	      if (!hasAccess && redirect) {
	        this.unauthorized(this.getUnauthorizedMsg(featureName, permissionToCheck));
	      }
	
	      return hasAccess;
	    }
	  }, {
	    key: 'getUnauthorizedMsg',
	    value: function getUnauthorizedMsg(featureName, permissionToCheck) {
	      switch (permissionToCheck) {
	        case 1:
	          return 'You do not have permission to View ' + featureName + ' under ' + this.authData.currentLocation.value + ' location';
	        case 2:
	          return 'You do not have permission to Add a ' + featureName + ' under ' + this.authData.currentLocation.value + ' location';
	        case 4:
	          return 'You do not have permission to Edit a ' + featureName + ' under ' + this.authData.currentLocation.value + ' location';
	        case 8:
	          return 'You do not have permission to Delete a ' + featureName + ' under ' + this.authData.currentLocation.value + ' location';
	      }
	    }
	  }, {
	    key: 'getLocationBrands',
	    value: function getLocationBrands(permissionToCheck) {
	      var _this6 = this;
	
	      //Get the list of Vehicle Permission Set for this user against the permissionToCheck
	      var vehiclePermissions = (0, _lodash.filter)(this.authData.permissionSet, function (o) {
	        return o.featureName === 'Vehicle' && (o.permissions & permissionToCheck) == permissionToCheck;
	      });
	
	      //Get the List of User Roles against the currently selected location
	      var userEntityRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	        return o.entityId === _this6.authData.currentLocation.key;
	      });
	
	      //Filter user userEntityRoles and return only the ones that the user has vehiclePermissions on
	      var userRoles = (0, _lodash.filter)(userEntityRoles, function (o) {
	        return (0, _lodash.find)(vehiclePermissions, function (vehRole) {
	          return o.roleId === vehRole.roleId;
	        }) !== undefined;
	      });
	
	      //Return an array of brandIds from userRoles
	      return userRoles.map(function (userRole) {
	        return userRole.brandId;
	      });
	    }
	  }, {
	    key: 'getEntitiesForManagement',
	    value: function getEntitiesForManagement(entityType) {
	      var editEntityRoles = (0, _lodash.filter)(this.authData.permissionSet, function (o) {
	        var viewEditPerm = 5;
	        return o.featureName === 'Entity' && (o.permissions & viewEditPerm) === viewEditPerm;
	      });
	
	      var adminRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	        return (0, _lodash.find)(editEntityRoles, function (role) {
	          return role.roleId === o.roleId;
	        }) !== undefined;
	      });
	
	      if (entityType) {
	        adminRoles = (0, _lodash.filter)(adminRoles, function (role) {
	          return role.entityType === entityType;
	        });
	      }
	
	      return adminRoles.map(function (adminRole) {
	        return adminRole.entityId;
	      });
	    }
	  }, {
	    key: 'updateLocation',
	    value: function updateLocation() {
	      this.storageProvider.setItem('authData', (0, _stringify2.default)(this.authData));
	      this.$state.reload();
	    }
	  }, {
	    key: 'updateLocationLogin',
	    value: function updateLocationLogin(locationId) {
	      var location = (0, _lodash.find)(this.authData.userLocations, function (o) {
	        return o.key === parseInt(locationId);
	      });
	
	      if (location) {
	        this.authData.currentLocation = location;
	        this.storageProvider.setItem('authData', (0, _stringify2.default)(this.authData));
	      }
	    }
	  }, {
	    key: 'isReceptionist',
	    value: function isReceptionist(entityId) {
	      var hasOnlyReceptionistRole = false;
	      if (!this.authData.userId || this.authData.isAdmin) {
	        return hasOnlyReceptionistRole;
	      } else {
	        if (!entityId) {
	          entityId = this.authData.currentLocation.key;
	        }
	
	        var receptionistDbRoleId = (0, _lodash.find)(this.roles, function (o) {
	          return o.name.toLowerCase() === 'showroom host';
	        }).roleId;
	        var entityRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	          return o.entityId === entityId;
	        });
	
	        hasOnlyReceptionistRole = entityRoles.length === 1 && entityRoles[0].roleId === receptionistDbRoleId;
	
	        return hasOnlyReceptionistRole;
	      }
	    }
	  }, {
	    key: 'isManager',
	    value: function isManager(entityId) {
	      var hasOnlyManagerRole = false;
	      if (!this.authData.userId) {
	        return hasOnlyManagerRole;
	      } else {
	        if (this.authData.isAdmin) {
	          return true;
	        }
	
	        if (!entityId) {
	          entityId = this.authData.currentLocation.key;
	        }
	
	        if (!entityId) {
	          return false;
	        }
	
	        var crmAdminDbRoleId = (0, _lodash.find)(this.roles, function (o) {
	          return o.name.toLowerCase() === 'administrator';
	        }).roleId;
	        var salesManagerDbRoleId = (0, _lodash.find)(this.roles, function (o) {
	          return o.name.toLowerCase() === 'sales manager';
	        }).roleId;
	        var entityRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	          return o.entityId === entityId;
	        });
	
	        hasOnlyManagerRole = entityRoles[0].roleId === crmAdminDbRoleId || entityRoles[0].roleId === salesManagerDbRoleId;
	
	        return hasOnlyManagerRole;
	      }
	    }
	  }, {
	    key: 'isEntityOwner',
	    value: function isEntityOwner(entity) {
	      if (!this.authData.userId) {
	        return false;
	      } else {
	        return entity.ownerId === this.authData.userId;
	      }
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      if (!this.authData.userId) {
	        return null;
	      } else if (this.authData.isAdmin) {
	        return { roleId: null, name: 'CarsNow Admin' };
	      }
	
	      var entityId = this.authData.currentLocation.key;
	      var entityRoles = (0, _lodash.filter)(this.authData.userRoles, function (o) {
	        return o.entityId === entityId;
	      });
	      var role = (0, _lodash.find)(this.roles, function (o) {
	        return o.roleId === entityRoles[0].roleId;
	      });
	
	      return role;
	    }
	  }, {
	    key: 'loggedInUserName',
	    value: function loggedInUserName() {
	      return this.authData.firstName + ' ' + this.authData.lastName;
	    }
	  }, {
	    key: 'updateLocationById',
	    value: function updateLocationById(entityId) {
	      var locToUpdate = (0, _lodash.find)(this.authData.userLocations, function (o) {
	        return o.key === entityId;
	      });
	      this.authData.currentLocation = locToUpdate;
	    }
	  }, {
	    key: 'renewSession',
	    value: function renewSession() {
	      return this.authorize(this.authData.email, true);
	    }
	  }, {
	    key: 'getLocationExtendedProperties',
	    value: function getLocationExtendedProperties(key) {
	      var _this7 = this;
	
	      var deferred = this.$q.defer();
	      var location = this.authData.currentLocation;
	
	      if (location && !location[key]) {
	        this.$http.get(this.appConfig.apiServiceBaseUri + ('api/auth/getLocationExtendedProperties/' + location.key + '/' + key)).then(function (response) {
	          location[key] = response.data.data;
	
	          _this7.storageProvider.removeItem('authData');
	          _this7.storageProvider.setItem('authData', (0, _stringify2.default)(_this7.authData));
	          deferred.resolve();
	        });
	      }
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'hasEasierAd',
	    value: function hasEasierAd() {
	      return this.authData.currentLocation.webPublisherType === this.enums.WEB_PUBLISHER_TYPE.EasierAd;
	    }
	  }, {
	    key: 'hasStockLoader',
	    value: function hasStockLoader() {
	      return this.authData.currentLocation.webPublisherType === this.enums.WEB_PUBLISHER_TYPE.StockLoader;
	    }
	  }, {
	    key: 'isSimi',
	    value: function isSimi() {
	      return this.authData.currentLocation.isSimi;
	    }
	  }, {
	    key: 'docuSignLogin',
	    value: function docuSignLogin(enquiryId, action) {
	      var state = { enquiryId: enquiryId, action: action };
	
	      var url = 'https://account.docusign.com/oauth/auth?response_type=code&scope=signature%20impersonation&client_id=' + this.appConfig.docuSignClientId + '&state=' + (0, _stringify2.default)(state) + '&redirect_uri=' + this.appConfig.oauthCallbackUrl;
	
	      window.location.href = url;
	    }
	  }, {
	    key: 'mazdaLogin',
	    value: function mazdaLogin(stateName, stateParams) {
	      var provider = "mazda";
	      var state = { provider: provider, stateName: stateName, stateParams: stateParams };
	
	      var url = this.appConfig.mazda.baseUrl + '/oauth/authorize?client_id=' + this.appConfig.mazda.clientId + '&response_type=code&state=' + (0, _stringify2.default)(state) + '&redirect_uri=' + this.appConfig.oauthCallbackUrl;
	
	      window.location.href = url;
	    }
	  }, {
	    key: 'mazdaLoginBackend',
	    value: function mazdaLoginBackend(authCode, stateName, stateParams) {
	      var _this8 = this;
	
	      this.$http.get(this.appConfig.apiServiceBaseUri + ('api/auth/mazdalogin/' + authCode)).success(function (response) {
	        _this8.authData.mazdaToken = JSON.parse(response.data);
	        _this8.storageProvider.removeItem('authData');
	        _this8.storageProvider.setItem('authData', (0, _stringify2.default)(_this8.authData));
	
	        _this8.$state.go(stateName, stateParams);
	      });
	    }
	  }, {
	    key: 'hasActiveMazdaToken',
	    value: function hasActiveMazdaToken() {
	      if (!this.authData.mazdaToken) {
	        return false;
	      }
	
	      var issued = new Date(this.authData.mazdaToken.iat * 1000);
	      var expires = new Date(issued.getTime() + this.authData.mazdaToken.expires_in * 1000);
	
	      return expires > new Date();
	    }
	  }]);
	  return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LookupService = function () {
	  LookupService.$inject = ["$http", "$q", "appConfig"];
	  function LookupService($http, $q, appConfig) {
	    "ngInject";
	
	    var storageProvider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.sessionStorage;
	    (0, _classCallCheck3.default)(this, LookupService);
	    this.$http = $http;
	    this.$q = $q;
	    this.appConfig = appConfig;
	    this.storageProvider = storageProvider;
	  }
	
	  (0, _createClass3.default)(LookupService, [{
	    key: "lookup",
	    value: function lookup(lookupName, params) {
	      var _this = this;
	
	      var deferred = this.$q.defer();
	      var lookupData = JSON.parse(this.storageProvider.getItem("lookups." + lookupName));
	      var query = this.appConfig.apiServiceBaseUri + ("api/lookup/" + lookupName + "?");
	
	      if (!lookupData || !lookupData.length) {
	        if (params) {
	          (0, _lodash.map)(params, function (itemValue, itemName) {
	            query += itemName + "=" + itemValue + "&";
	          });
	        }
	
	        this.$http.get(query).then(function (response) {
	          if (!params) {
	            _this.storageProvider.setItem("lookups." + lookupName, (0, _stringify2.default)(response.data.items));
	          }
	
	          deferred.resolve(response.data.items || response.data);
	        }).catch(function (err) {
	          deferred.reject(err);
	        });
	      } else {
	        deferred.resolve(lookupData);
	      }
	      return deferred.promise;
	    }
	  }, {
	    key: "lookupEnums",
	    value: function lookupEnums(enumNames) {
	      var _this2 = this;
	
	      var deferred = this.$q.defer();
	      var enumsToLookupFromServer = [];
	      var enumLookupCollection = {};
	
	      enumNames.map(function (enumName) {
	        var lookupData = JSON.parse(_this2.storageProvider.getItem("lookups." + enumName.toCamelCase()));
	
	        if (!lookupData || !lookupData.length) {
	          enumsToLookupFromServer.push(enumName);
	        } else {
	          enumLookupCollection[enumName.toCamelCase()] = lookupData;
	        }
	      });
	
	      if (enumsToLookupFromServer.length) {
	        this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/enums?enumNames=" + enumsToLookupFromServer.toString())).then(function (response) {
	          response.data.map(function (enumLookup) {
	            enumLookupCollection[enumLookup.enumName.toCamelCase()] = enumLookup.values;
	            _this2.storageProvider.setItem("lookups." + enumLookup.enumName.toCamelCase(), (0, _stringify2.default)(enumLookup.values));
	          });
	          deferred.resolve(enumLookupCollection);
	        }).catch(function (err) {
	          deferred.reject(err);
	        });
	      } else {
	        deferred.resolve(enumLookupCollection);
	      }
	
	      return deferred.promise;
	    }
	  }, {
	    key: "lookupRoles",
	    value: function lookupRoles() {
	      var deferred = this.$q.defer();
	
	      var roles = [{ "roleId": 1, "name": "Administrator" }, { "roleId": 2, "name": "Sales Manager" }, { "roleId": 3, "name": "Sales Rep" }, { "roleId": 4, "name": "Showroom Host" }, { "roleId": 5, "name": "Accounts Admin" }];
	
	      deferred.resolve(roles);
	
	      return deferred.promise;
	    }
	  }, {
	    key: "lookupBrands",
	    value: function lookupBrands() {
	      return this.lookup('brands');
	    }
	  }, {
	    key: "lookupBrandModels",
	    value: function lookupBrandModels() {
	      return this.lookup('brandModels');
	    }
	  }, {
	    key: "lookupPriceLookups",
	    value: function lookupPriceLookups(entityId) {
	      return this.lookup('priceLookups', {
	        entityId: entityId
	      });
	    }
	  }, {
	    key: "lookupAccessoryLookups",
	    value: function lookupAccessoryLookups(entityId, locationOnly) {
	      return this.lookup('accessoryLookups', {
	        entityId: entityId,
	        locationOnly: locationOnly ? true : false
	      });
	    }
	  }, {
	    key: "lookupEnquiryPrices",
	    value: function lookupEnquiryPrices(entityId) {
	      return this.lookup('enquiryPrices', {
	        entityId: entityId
	      });
	    }
	  }, {
	    key: "lookupEntityNamesByIds",
	    value: function lookupEntityNamesByIds(entityIds) {
	      return this.lookup('entityNameLookup', {
	        entityIds: entityIds
	      });
	    }
	  }, {
	    key: "lookupVehicleByRegNo",
	    value: function lookupVehicleByRegNo(locationId, vehicleCondition, regNo, validate) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/vehicle/" + locationId + "/" + vehicleCondition + "/" + regNo + "/" + validate));
	    }
	  }, {
	    key: "lookupMyLocations",
	    value: function lookupMyLocations(locationId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/mylocations/" + locationId));
	    }
	  }]);
	  return LookupService;
	}();
	
	exports.default = LookupService;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(502);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	__webpack_require__(507);
	
	__webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(503);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(504);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"dashboard-sidenav\" ng-hide=\"!$ctrl.authService.authData.userId || $ctrl.authService.isReceptionist($ctrl.authService.currentLocation.key)\">\r\n  <ul>\r\n      <li ng-repeat=\"mainMenu in $ctrl.authService.authData.siteMapCollection\">\r\n        <a ui-sref=\"{{mainMenu.state}}\" ng-if=\"mainMenu.state\">\r\n            <img src=\"images/{{mainMenu.iconClass}}\" alt=\"{{mainMenu.name}}\">\r\n            <span>{{mainMenu.name}}</span>\r\n        </a>\r\n\r\n        <a href=\"javascript:void(0)\" ng-if=\"!mainMenu.state\">\r\n            <img src=\"images/{{mainMenu.iconClass}}\" alt=\"{{mainMenu.name}}\">\r\n            <span>{{mainMenu.name}}</span>\r\n        </a>\r\n\r\n        <ul>\r\n          <li ng-repeat=\"menuItem in mainMenu.children\" ng-if=\"$ctrl.checkCustomPermission(menuItem)\">\r\n            <a ui-sref=\"{{menuItem.state + '(' + menuItem.stateParams + ')'}}\">{{menuItem.name}}</a>\r\n          </li>\r\n        </ul>\r\n      </li>\r\n  </ul>\r\n\r\n  <ul ng-show=\"$ctrl.authService.authData.isAdmin\">\r\n    <li>\r\n      <a href=\"javascript:void(0)\">\r\n        <img src=\"images/administrator.png\" alt=\"Administrator Management\">\r\n        <span>Administrator Management</span>\r\n      </a>\r\n      <ul>\r\n        <li><a ui-sref=\"admin.listEntities\">Manage Entities</a></li>\r\n        <li><a ui-sref=\"retailPriceList\">Upload Retail Price List</a></li>\r\n        <li><a ui-sref=\"viewRetailPriceList\">View Retail Price List</a></li>\r\n        <li><a ui-sref=\"brandModelManagement\">Brand Models</a></li>        \r\n        <li><a ui-sref=\"failedWebEnquiries\">Web Enquiries Mailbox</a></li>        \r\n        <li><a ui-sref=\"migrationUtility\">Migration Utility</a></li>        \r\n        <li><a ui-sref=\"entityPreferences\">Location Preferences</a></li>        \r\n        <li><a ui-sref=\"reportsAccess\">Reports Access</a></li>        \r\n        <li><a ui-sref=\"dataUtility\">Data Utility</a></li>        \r\n      </ul>\r\n    </li>\r\n\r\n    <li>\r\n      <a href=\"javascript:void(0)\">\r\n        <img src=\"images/reports.png\" alt=\"Reports\">\r\n        <span>Reports</span>\r\n      </a>\r\n      <ul>\r\n        <li><a ui-sref=\"systemUsage\">System Usage</a></li>\r\n        <li><a ui-sref=\"digitalSignatures\">Digital Signatures</a></li>\r\n        <li><a ui-sref=\"lastLogin\">Last Login</a></li>\r\n        <li><a ui-sref=\"vehicleImports\">Vehicle Imports</a></li>\r\n        <li><a ui-sref=\"reportsUsage\">Reports Usage</a></li>\r\n      </ul>\r\n    </li>    \r\n  </ul>\r\n</nav>\r\n"

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["authService", "$state"];
	  function NavbarController(authService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    this.authService = authService;
	    this.$state = $state;
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: 'logOut',
	    value: function logOut() {
	      this.authService.logOut();
	    }
	  }, {
	    key: 'checkCustomPermission',
	    value: function checkCustomPermission(item) {
	      if (item.name === 'Add Vehicle (Skupenet)') {
	        return this.authService.hasEasierAd();
	      }
	
	      return true;
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(506);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(508);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./navbar.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./navbar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	$(function () {
	  "use strict";
	
	  $(document).on("click", ".sidebar a.toggleNavigation", toggleNavigation);
	  $(document).on("click", ".sidebar ul.childToggleNavigation", childToggleNavigation);
	
	  function toggleNavigation() {
	    var $this = $(this),
	        $sibling = $this.siblings("ul");
	
	    //mobile
	    if ($sibling.css("position") == "absolute") {
	      hideOthers();
	      $sibling.toggle();
	    } else {
	      $sibling.slideToggle();
	    }
	  }
	
	  function childToggleNavigation() {
	    var $this = $(this);
	    if ($this.css("position") == "absolute") {
	      $this.toggle();
	    }
	  }
	
	  function hideOthers() {
	    $('.sidebar a.toggleNavigation').each(function (i, v) {
	      var $this = $(this),
	          $sibling = $this.siblings("ul");
	
	      if ($sibling.css('display') == 'block') {
	        $sibling.toggle();
	      }
	    });
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(511);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbar2Module = _angular2.default.module('navbar2', [_angularUiRouter2.default]).component('navbar2', _navbar2.default).name;
	
	exports.default = navbar2Module;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(512);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(513);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbar2Component = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbar2Component;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = "<header class=\"dashboard-header clearfix\" ng-hide=\"!$ctrl.authService.authData.userId\">\r\n    <a ui-sref=\"welcomeCentre\" ng-attr-title=\"{{$ctrl.appConfig.appTitle}}\" ng-class=\"{'logo': !$ctrl.appConfig.isLeadManager, 'logo2': $ctrl.appConfig.isLeadManager}\">\r\n        <img ng-src=\"{{$ctrl.appConfig.imagePath}}/logo.png\">\r\n    </a>\r\n    <div class=\"dashboard-user\">\r\n        <small>Session Timer {{$ctrl.sessionTimer}}</small>\r\n        <strong>{{$ctrl.authService.authData.firstName + ' ' + $ctrl.authService.authData.lastName}} ({{$ctrl.authService.getRole().name}})</strong>\r\n        <div class=\"dealership\" ng-hide=\"$ctrl.authService.authData.isAdmin\">\r\n            <a href=\"javascript:void(0)\">\r\n                <img src=\"images/carot-right.png\" alt=\"Dealership\">\r\n                {{$ctrl.authService.authData.currentLocation.value}}\r\n            </a>\r\n            <ul class=\"dealership-menu\">\r\n                <li ng-repeat=\"loc in $ctrl.authService.authData.userLocations\">\r\n                  <a href=\"#\" ng-click=\"$ctrl.updateLocation(loc)\">\r\n                    {{loc.value}}\r\n                  </a>\r\n                </li>\r\n            </ul>            \r\n        </div>\r\n        <switch ng-model=\"$ctrl.appConfig.isLeadManager\" ng-change=\"$ctrl.appConfig.switchTheme()\" ng-show=\"$ctrl.appConfig.appTitle.toLowerCase().search('localhost') !== -1\"></switch>\r\n    </div>\r\n    <nav class=\"dashboard-nav\">\r\n        <ul>\r\n            <li ng-hide=\"$ctrl.authService.isReceptionist($ctrl.authService.currentLocation.key) || $ctrl.authService.authData.isAdmin\">\r\n                <a href=\"{{'mailto:' + $ctrl.appConfig.supportEmail}}\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}/support-icon.png\" alt=\"Support\">\r\n                    <span>Support</span>\r\n                </a>\r\n            </li>                        \r\n            <li ng-hide=\"$ctrl.authService.isReceptionist($ctrl.authService.currentLocation.key) || $ctrl.authService.authData.isAdmin\">\r\n                <a ui-sref=\"omniSearch\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}/search-btn.png\" alt=\"Search\">\r\n                    <span>Search</span>\r\n                </a>\r\n            </li>            \r\n            <li ng-hide=\"$ctrl.authService.isReceptionist($ctrl.authService.currentLocation.key) || $ctrl.authService.authData.isAdmin || true\">\r\n                <a ui-sref=\"kpiAnalytics\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}//kpi-btn.png\" alt=\"Dashboard\">\r\n                    <span>KPI Analytics</span>\r\n                </a>\r\n            </li>            \r\n            <li ng-hide=\"!$ctrl.authService.isManager() \r\n                    || $ctrl.authService.authData.isAdmin\r\n                    || !$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.leadMonitor\">\r\n                <a ui-sref=\"leadMonitor\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}//kpi-btn.png\" alt=\"Lead Monitor\">\r\n                    <span>Leads & Enquiries</span>\r\n                </a>\r\n            </li>                     \r\n            <li ng-hide=\"$ctrl.authService.isReceptionist($ctrl.authService.currentLocation.key) || $ctrl.authService.authData.isAdmin\">\r\n                <a ui-sref=\"dashboard\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}//dashboard-icon.png\" alt=\"Dashboard\">\r\n                    <span>Dashboard</span>\r\n                </a>\r\n            </li>\r\n            <li ng-hide=\"$ctrl.authService.authData.isAdmin\">\r\n                <a ui-sref=\"messaging\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}//message-icon.png\" alt=\"Message\">\r\n                    <span>\r\n                      Message\r\n                      <span class=\"badge\" ng-show=\"$ctrl.authService.authData.msgCount > 0\">{{$ctrl.authService.authData.msgCount}}</span>\r\n                    </span>\r\n                </a>\r\n            </li>\r\n            <li>\r\n                <a href=\"#\" ng-click=\"$ctrl.authService.logOut()\">\r\n                    <img ng-src=\"{{$ctrl.appConfig.imagePath}}//logout-icon.png\" alt=\"Log Out\">\r\n                    <span>Log Out</span>\r\n                </a>\r\n            </li>\r\n        </ul>\r\n    </nav>\r\n</header>\r\n\r\n<form method=\"post\" action=\"\" id=\"frmPrint\" target=\"_blank\">\r\n    <input type=\"hidden\" name=\"postdata\" id=\"postdata\" />      \r\n    <input type=\"hidden\" name=\"token\" id=\"token\" ng-value=\"$ctrl.authService.authData.authToken\" />      \r\n</form>"

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navbar2Controller = function () {
	  Navbar2Controller.$inject = ["authService", "$state", "$interval", "$ngConfirm", "growl", "appConfig"];
	  function Navbar2Controller(authService, $state, $interval, $ngConfirm, growl, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, Navbar2Controller);
	    this.authService = authService;
	    this.$state = $state;
	    this.$ngConfirm = $ngConfirm;
	    this.growl = growl;
	    this.appConfig = appConfig;
	
	    this.sessionTimer = "";
	
	    this.timerFn = $interval(this.updateSessionTimer.bind(this), 1000);
	
	    this.logoutWarningThreshold = 10;
	    this.warningDialog = null;
	    this.logoutDialog = null;
	  }
	
	  (0, _createClass3.default)(Navbar2Controller, [{
	    key: "updateLocation",
	    value: function updateLocation(loc) {
	      if (loc.key !== this.authService.authData.currentLocation.key) {
	        var sure = window.confirm('Are you sure you want to change your current location');
	
	        if (sure) {
	          this.authService.authData.currentLocation = loc;
	          this.authService.getLocationExtendedProperties('dashboardPreferences');
	          this.$state.transitionTo('welcomeCentre', null, {
	            reload: true, inherit: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "updateSessionTimer",
	    value: function updateSessionTimer() {
	      if (!this.authService.isLoggedIn_NoRedirect()) {
	        return;
	      }
	
	      var remainingMs = this.authService.timeToLogout();
	      var remainingPercent = Math.floor(remainingMs / this.authService.authData.expiryMs * 100);
	
	      //if logout warning threshold reached
	      if (remainingPercent <= this.logoutWarningThreshold) {
	        this.showWarningDialog();
	      }
	
	      if (remainingPercent <= 1) {
	        this.showLoggedOutDialog();
	      }
	
	      if (remainingMs && remainingMs > 0) {
	        this.sessionTimer = this.msToTime(remainingMs);
	      } else {
	        this.sessionTimer = null;
	      }
	    }
	  }, {
	    key: "msToTime",
	    value: function msToTime(s) {
	      // Pad to 2 or 3 digits, default is 2
	      var pad = function pad(n) {
	        var z = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	        return ('00' + n).slice(-z);
	      };
	      return pad(s / 3.6e6 | 0) + ':' + pad(s % 3.6e6 / 6e4 | 0) + ':' + pad(s % 6e4 / 1000 | 0);
	    }
	  }, {
	    key: "showWarningDialog",
	    value: function showWarningDialog() {
	      var _this = this;
	
	      if (this.warningDialog) {
	        return;
	      }
	
	      this.warningDialog = this.$ngConfirm({
	        title: "Warning",
	        content: "Your session will expire soon",
	        type: 'orange',
	        columnClass: 'l',
	        buttons: {
	          renew: {
	            text: 'Renew',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this.renew();
	            }
	          },
	          cancel: {
	            text: 'Leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: "showLoggedOutDialog",
	    value: function showLoggedOutDialog() {
	      var _this2 = this;
	
	      if (this.logoutDialog) {
	        return;
	      }
	
	      this.warningDialog.close();
	
	      this.logoutDialog = this.$ngConfirm({
	        title: "Error",
	        content: "Your session has expired",
	        type: 'red',
	        columnClass: 'l',
	        buttons: {
	          ok: {
	            text: 'Ok',
	            btnClass: 'btn-default',
	            action: function action() {
	              _this2.authService.logOut();
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: "renew",
	    value: function renew() {
	      var _this3 = this;
	
	      this.authService.renewSession().then(function () {
	        _this3.growl.success('Session renewed successfully', { ttl: 5000 });
	
	        _this3.warningDialog = null;
	        _this3.logoutDialog = null;
	      });
	    }
	  }]);
	  return Navbar2Controller;
	}();
	
	exports.default = Navbar2Controller;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(515);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar2.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar2.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".navbar2{color:red}", ""]);
	
	// exports


/***/ }),
/* 516 */,
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthInterceptorService = function () {
	  AuthInterceptorService.$inject = ["$q", "$injector"];
	  function AuthInterceptorService($q, $injector) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AuthInterceptorService);
	    this.$q = $q;
	    this.$injector = $injector;
	
	    return {
	      request: this.request.bind(this),
	      responseError: this.responseError.bind(this)
	    };
	  }
	
	  (0, _createClass3.default)(AuthInterceptorService, [{
	    key: 'request',
	    value: function request(config) {
	      config.headers = config.headers || {};
	
	      if (config.url.includes('http') && !config.url.includes('login')) {
	        var authService = this.$injector.get('authService');
	
	        if (authService.isLoggedIn()) {
	          var authData = JSON.parse(sessionStorage.getItem('authData'));
	          if (authData) {
	            config.headers.Authorization = 'Bearer ' + authData.authToken;
	          }
	        }
	      }
	
	      return config;
	    }
	  }, {
	    key: 'responseError',
	    value: function responseError(rejection) {
	      if (rejection.status === 401 || rejection.status === 404) {
	        var authService = this.$injector.get('authService');
	        authService.unauthorized();
	      }
	
	      if (rejection.status === 403) {
	        var _authService = this.$injector.get('authService');
	        _authService.unauthorized(rejection.data.message);
	      }
	
	      return this.$q.reject(rejection);
	    }
	  }]);
	  return AuthInterceptorService;
	}();
	
	exports.default = AuthInterceptorService;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingService = function () {
	  LoadingService.$inject = ["blockUI", "$timeout"];
	  function LoadingService(blockUI, $timeout) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LoadingService);
	    this.blockUI = blockUI;
	    this.$timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(LoadingService, [{
	    key: "showLoading",
	    value: function showLoading(instanceId, msg) {
	      var blockInstance = this.blockUI.instances.get(instanceId);
	
	      blockInstance.start(msg);
	    }
	  }, {
	    key: "hideLoading",
	    value: function hideLoading(instanceId) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
	
	      var blockInstance = this.blockUI.instances.get(instanceId);
	
	      if (delay === 0) {
	        blockInstance.stop();
	      } else {
	        this.$timeout(function () {
	          blockInstance.stop();
	        }, delay);
	      }
	    }
	  }]);
	  return LoadingService;
	}();
	
	exports.default = LoadingService;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PushService = function () {
	  PushService.$inject = ["authService", "appConfig", "notificationService", "$state", "$rootScope", "enquiryService", "enums", "$ngConfirm"];
	  function PushService(authService, appConfig, notificationService, $state, $rootScope, enquiryService, enums, $ngConfirm) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PushService);
	    this.authService = authService;
	    this.notificationService = notificationService;
	    this.connection = $.hubConnection(appConfig.apiServiceBaseUri);
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.enquiryService = enquiryService;
	    this.enums = enums;
	    this.$ngConfirm = $ngConfirm;
	
	    //Add Enquiry Notification Handlers in Root scope
	    this.$rootScope.enquiryAcceptedByUser = this.enquiryAcceptedByUser.bind(this);
	    this.$rootScope.enquiryRejectedByUser = this.enquiryRejectedByUser.bind(this);
	    this.$rootScope.enquiryHeldByUser = this.enquiryHeldByUser.bind(this);
	
	    this.messageHub = {
	      enquiryCreated: function enquiryCreated(enquiryId, receiverId, senderId) {
	        _this.messageHubProxy.invoke('enquiryCreated', enquiryId, receiverId, senderId);
	      },
	      existingEnquiry: function existingEnquiry(enquiryId, receiverId, senderId, contactName, contactMethod) {
	        _this.messageHubProxy.invoke('existingEnquiry', enquiryId, receiverId, senderId, contactName, contactMethod);
	      },
	      enquiryDeclined: function enquiryDeclined(enquiryId, userId) {
	        _this.messageHubProxy.invoke('enquiryDeclined', enquiryId, userId);
	      },
	      enquiryAccepted: function enquiryAccepted(enquiryId, userId) {
	        _this.messageHubProxy.invoke('enquiryAccepted', enquiryId, userId);
	      },
	      enquiryHeld: function enquiryHeld(enquiryId, userId) {
	        _this.messageHubProxy.invoke('enquiryHeld', enquiryId, userId);
	      },
	      sendMessage: function sendMessage(userIds, msg) {
	        _this.messageHubProxy.invoke('sendMessage', userIds, msg);
	      },
	      enquiryCreatedFromWebEnquiry: function enquiryCreatedFromWebEnquiry(userId, enquiryId, senderName) {
	        _this.messageHubProxy.invoke('enquiryCreatedFromWebEnquiry', userId, enquiryId, senderName);
	      },
	      signatureEvent: function signatureEvent(enquiryId, contactName, newStatus) {
	        _this.messageHubProxy.invoke('signatureEvent', enquiryId, contactName, newStatus);
	      }
	    };
	
	    this.hubProxy = this.connection.createHubProxy('messageHub');
	  }
	
	  (0, _createClass3.default)(PushService, [{
	    key: 'init',
	    value: function init() {
	      var svc = this;
	
	      if (svc.connection.state === 1 || svc.connection.state === 0 || !svc.authService.authData.userId) {
	        //Push Service is already connected, dont do anything
	        return;
	      }
	
	      svc.initMessageHub();
	
	      svc.connection.start({ jsonp: true }).done(function () {
	        svc.messageHubProxy.invoke('subscribe', svc.authService.authData.userId);
	        console.log('Now connected, connection ID=' + svc.connection.id);
	      }).fail(function (e) {
	        console.log('Could not connect', e);
	      });
	    }
	  }, {
	    key: 'initMessageHub',
	    value: function initMessageHub() {
	      this.messageHubProxy = this.connection.createHubProxy('messageHub');
	
	      this.messageHubProxy.on('notifyEnquiryCreated', this.notifyEnquiryCreatedHandler.bind(this));
	      this.messageHubProxy.on('notifyExistingEnquiryOpened', this.notifyExistingEnquiryOpened.bind(this));
	      this.messageHubProxy.on('notifySendMessage', this.notifySendMessage.bind(this));
	      this.messageHubProxy.on('notifyWebEnquiriesCreated', this.notifyWebEnquiriesCreatedHandler.bind(this));
	      this.messageHubProxy.on('notifyEnquiryCreatedFromWebEnquiry', this.notifyEnquiryCreatedFromWebEnquiryHandler.bind(this));
	      this.messageHubProxy.on('notifyEnquiryQuotationViewed', this.notifyEnquiryQuotationViewed.bind(this));
	      this.messageHubProxy.on('notifyFinanceCreated', this.notifyFinanceCreated.bind(this));
	      this.messageHubProxy.on('signatureEvent', this.signatureEvent.bind(this));
	    }
	  }, {
	    key: 'registerEnquiryDeclinedHandler',
	    value: function registerEnquiryDeclinedHandler(handler) {
	      this.messageHubProxy.on('notifyEnquiryDeclined', handler);
	    }
	  }, {
	    key: 'registerEnquiryAcceptedHandler',
	    value: function registerEnquiryAcceptedHandler(handler) {
	      this.messageHubProxy.on('notifyEnquiryAccepted', handler);
	    }
	  }, {
	    key: 'registerEnquiryHeldHandler',
	    value: function registerEnquiryHeldHandler(handler) {
	      this.messageHubProxy.on('notifyEnquiryHeld', handler);
	    }
	  }, {
	    key: 'registerEnquiryCreatedHandler',
	    value: function registerEnquiryCreatedHandler(handler) {
	      debugger;
	      this.messageHubProxy.on('notifyEnquiryCreated', handler);
	    }
	  }, {
	    key: 'registerExistingEnquiryOpenedHandler',
	    value: function registerExistingEnquiryOpenedHandler(handler) {
	      this.messageHubProxy.on('notifyExistingEnquiryOpened', handler);
	    }
	  }, {
	    key: 'notifyExistingEnquiryOpened',
	    value: function notifyExistingEnquiryOpened(enquiryId, senderId, contactName, contactMethod) {
	      this.authService.authData.msgCount++;
	      var scope = this.$rootScope.$new();
	      scope.enquiryId = enquiryId;
	      scope.senderId = senderId;
	
	      var header = 'Enquiry Alert';
	      var msgBody = '';
	
	      switch (contactMethod) {
	        case this.enums.ENQUIRY_ORIGINATION.WalkIn:
	          msgBody = contactName + ' requires your attention in the showroom';
	          break;
	
	        case this.enums.ENQUIRY_ORIGINATION.Phone:
	          msgBody = contactName + ' is on the phone looking to speak to you ';
	          break;
	
	        case this.enums.ENQUIRY_ORIGINATION.Email:
	          msgBody = contactName + ' has sent an e mail and is looking for you to contact them';
	          break;
	
	        case this.enums.ENQUIRY_ORIGINATION.Web:
	          msgBody = contactName + ' has sent a message through Web and is looking for you to contact them';
	          break;
	      }
	
	      scope.header = header;
	      scope.msgBody = msgBody;
	
	      this.notificationService.showEnquiryNotification(scope, 'existingEnquiryTemplate');
	    }
	  }, {
	    key: 'notifyEnquiryCreatedHandler',
	    value: function notifyEnquiryCreatedHandler(enquiryId, senderId) {
	      this.authService.authData.msgCount++;
	      var scope = this.$rootScope.$new();
	      scope.enquiryId = enquiryId;
	      scope.senderId = senderId;
	      this.notificationService.showEnquiryNotification(scope, 'enquiryNotificationTemplate');
	    }
	  }, {
	    key: 'notifyEnquiryCreatedFromWebEnquiryHandler',
	    value: function notifyEnquiryCreatedFromWebEnquiryHandler(enquiryId, sender) {
	      var scope = this.$rootScope.$new();
	      scope.enquiryId = enquiryId;
	      scope.sender = sender;
	      this.notificationService.showEnquiryNotification(scope, 'enquiryFromWebEnquiryTemplate');
	    }
	  }, {
	    key: 'viewMessage',
	    value: function viewMessage(messageId) {
	      this.authService.authData.msgCount--;
	      this.$state.go('messageView', { messageId: messageId });
	    }
	  }, {
	    key: 'enquiryAcceptedByUser',
	    value: function enquiryAcceptedByUser(enquiryId, senderId) {
	      var _this2 = this;
	
	      this.enquiryService.updateOwner(enquiryId, this.authService.authData.userId).then(function () {
	        _this2.messageHub.enquiryAccepted(enquiryId, senderId);
	        _this2.$state.go('enquiryEdit', { enquiryId: enquiryId });
	      });
	    }
	  }, {
	    key: 'enquiryHeldByUser',
	    value: function enquiryHeldByUser(enquiryId, senderId) {
	      this.messageHub.enquiryHeld(enquiryId, senderId);
	    }
	  }, {
	    key: 'enquiryRejectedByUser',
	    value: function enquiryRejectedByUser(enquiryId, senderId) {
	      this.messageHub.enquiryDeclined(enquiryId, senderId);
	    }
	  }, {
	    key: 'notifySendMessage',
	    value: function notifySendMessage(msg) {
	      this.authService.authData.msgCount++;
	      var scope = this.$rootScope.$new();
	      scope.header = 'New Message Received';
	      scope.msg = msg;
	      this.notificationService.showEnquiryNotification(scope, 'sendMessageTemplate');
	    }
	  }, {
	    key: 'notifyWebEnquiriesCreatedHandler',
	    value: function notifyWebEnquiriesCreatedHandler(entityId, count) {
	      var _this3 = this;
	
	      console.log('entityId', entityId);
	      var scope = this.$rootScope.$new();
	      scope.count = count;
	
	      scope.viewDashoard = function () {
	        if (_this3.authService.authData.currentLocation.key !== entityId) {
	          _this3.$ngConfirm({
	            title: "Warning",
	            content: 'The section you\'re trying to navigate is not in your currently selected location.<br><br>If you wish to proceed, your selected location will be updated',
	            type: 'orange',
	            columnClass: 'l',
	            buttons: {
	              ok: {
	                text: 'Proceed',
	                btnClass: 'btn-primary',
	                action: function action() {
	                  _this3.authService.updateLocationById(entityId);
	                  _this3.$state.go('dashboard', {}, { reload: true });
	                }
	              },
	              cancel: {
	                text: 'Not sure',
	                btnClass: 'btn-default',
	                action: function action() {}
	              }
	            }
	          });
	        } else {
	          _this3.$state.go('dashboard', {}, { reload: true });
	        }
	      };
	
	      this.notificationService.showEnquiryNotification(scope, 'webEnquiriesCreatedTemplate');
	    }
	  }, {
	    key: 'notifyEnquiryQuotationViewed',
	    value: function notifyEnquiryQuotationViewed(enquiryId) {
	      var scope = this.$rootScope.$new();
	      scope.enquiryId = enquiryId;
	      this.notificationService.showEnquiryNotification(scope, 'enquiryQuoteViewedTemplate');
	      this.authService.authData.msgCount += 1;
	    }
	  }, {
	    key: 'notifyFinanceCreated',
	    value: function notifyFinanceCreated(financeId) {
	      var scope = this.$rootScope.$new();
	      scope.financeId = financeId;
	      this.notificationService.showEnquiryNotification(scope, 'financeCreatedTemplate');
	      this.authService.authData.msgCount += 1;
	    }
	  }, {
	    key: 'signatureEvent',
	    value: function signatureEvent(enquiryId, contactName, newStatus) {
	      this.authService.authData.msgCount++;
	      var scope = this.$rootScope.$new();
	      scope.enquiryId = enquiryId;
	
	      switch (newStatus) {
	        case this.enums.SIGNATURE_STATUS.Voided:
	          scope.msg = 'The signature request has been voided by the Admin';
	          break;
	
	        case this.enums.SIGNATURE_STATUS.CustomerDeclined:
	          scope.msg = contactName + ' has declined to sign the Order Form';
	          break;
	
	        case this.enums.SIGNATURE_STATUS.CustomerSigned:
	          scope.msg = contactName + ' has signed the Order Form';
	          break;
	
	        case this.enums.SIGNATURE_STATUS.DealerDeclined:
	          scope.msg = 'You have declined to sign the Order Form';
	          break;
	
	        case this.enums.SIGNATURE_STATUS.Completed:
	          scope.msg = 'The order form signatures have been completed';
	          break;
	      }
	
	      this.notificationService.showEnquiryNotification(scope, 'signatureEventTemplate');
	    }
	  }]);
	  return PushService;
	}();
	
	exports.default = PushService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationService = function () {
	  NotificationService.$inject = ["Notification", "$http", "appConfig"];
	  function NotificationService(Notification, $http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NotificationService);
	    this.Notification = Notification;
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(NotificationService, [{
	    key: "showEnquiryNotification",
	    value: function showEnquiryNotification(scope, templateId) {
	      this.Notification.info({
	        positionY: 'bottom',
	        delay: 30 * 1000,
	        replaceMessage: false,
	        templateUrl: "templates/notification/" + templateId,
	        scope: scope
	      });
	    }
	  }, {
	    key: "sendFinanceCreatedNotification",
	    value: function sendFinanceCreatedNotification(financeId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/notification/notifyfinancecreated/" + financeId));
	    }
	  }]);
	  return NotificationService;
	}();
	
	exports.default = NotificationService;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _addPromiseTemplate = __webpack_require__(522);
	
	var _addPromiseTemplate2 = _interopRequireDefault(_addPromiseTemplate);
	
	var _updateOwnerTemplate = __webpack_require__(523);
	
	var _updateOwnerTemplate2 = _interopRequireDefault(_updateOwnerTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddPromise = function () {
	  AddPromise.$inject = ["$uibModal", "$rootScope", "enums", "appConfig", "authService", "promiseService"];
	  function AddPromise($uibModal, $rootScope, enums, appConfig, authService, promiseService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddPromise);
	    this.$scope = $rootScope.$new();
	    this.$uibModal = $uibModal;
	    this.authService = authService;
	    this.appConfig = appConfig;
	
	    this.$scope.promiseService = promiseService;
	    this.$scope.authService = authService;
	    this.$scope.enums = enums;
	    this.$scope.categories = this.convertEnumToKeyValueList(enums.PROMISE_CATEGORY, true);
	    this.$scope.addPromise = this.addPromise;
	    this.$scope.validateForm = this.validateForm;
	    this.$scope.checkCurrentTime = this.checkCurrentTime;
	    this.$scope.getFullDateTime = this.getFullDateTime;
	    this.$scope.contactSelected = this.contactSelected.bind(this.$scope);
	    this.$scope.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + authService.authData.currentLocation.key + '/';
	    this.$scope.getPromiseFromForm = this.getPromiseFromForm;
	    this.$scope.closeModal = this.closeModal;
	    this.$scope.addPromiseSuccess = this.addPromiseSuccess;
	    this.$scope.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';
	    this.$scope.initialOwnerName = authService.authData.firstName + ' ' + authService.authData.lastName;
	    this.$scope.ownerSelected = this.ownerSelected.bind(this.$scope);
	    this.$scope.updateOwner = this.updateOwner;
	  }
	
	  (0, _createClass3.default)(AddPromise, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'showAddPromise',
	    value: function showAddPromise(successHandler, noSave, noteText, contact, addPromiseConfirmation) {
	      this.$scope.searchContactUrl = this.appConfig.apiServiceBaseUri + 'api/contact/search/' + this.authService.authData.currentLocation.key + '/';
	      this.$scope.searchUsersUrl = this.appConfig.apiServiceBaseUri + 'api/user/search/' + this.authService.authData.currentLocation.key + '/';
	
	      this.$scope.errMsg = "";
	      this.$scope.tempPromise = {
	        category: this.$scope.categories[0]
	      };
	      this.$scope.addPromiseConfirmation = addPromiseConfirmation;
	
	      if (noteText) {
	        this.$scope.tempPromise.subject = noteText.substring(0, 200);
	      }
	
	      if (contact) {
	        this.$scope.tempPromise.category = this.$scope.categories[1];
	        this.$scope.tempPromise.contactId = contact.contactId;
	        this.$scope.tempPromise.contactName = contact.contactName;
	      }
	
	      this.$scope.successHandler = successHandler;
	      this.$scope.noSave = noSave;
	
	      this.$scope.datePickerOptions = {
	        minDate: new Date(),
	        showButtonBar: false
	      };
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _addPromiseTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var scope = this;
	
	      if (scope.modalInstance) {
	        scope.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'addPromise',
	    value: function addPromise() {
	      var scope = this;
	
	      if (!scope.validateForm()) {
	        return;
	      }
	
	      var promiseToAdd = scope.getPromiseFromForm();
	
	      if (scope.noSave) {
	        scope.addPromiseSuccess(promiseToAdd);
	      } else {
	        scope.promiseService.addPromise(promiseToAdd).then(function (response) {
	          scope.addPromiseSuccess(response.data);
	        });
	      }
	    }
	  }, {
	    key: 'addPromiseSuccess',
	    value: function addPromiseSuccess(promiseToAdd) {
	      var scope = this;
	
	      scope.closeModal();
	
	      if (scope.successHandler) {
	        scope.successHandler(promiseToAdd);
	      }
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var scope = this;
	
	      if (!scope.tempPromise.subject) {
	        scope.errMsg = 'Please enter some text for the subject';
	        return false;
	      }
	
	      if (!scope.tempPromise.category.id) {
	        scope.errMsg = 'Please select a category';
	        return false;
	      }
	
	      if (scope.tempPromise.category.id === scope.enums.PROMISE_CATEGORY.Customer && !scope.tempPromise.contactId) {
	        scope.errMsg = 'Please select a contact';
	        return false;
	      }
	
	      if (!scope.tempPromise.date) {
	        scope.errMsg = 'Please select a due date';
	        return false;
	      }
	
	      if (!scope.tempPromise.time) {
	        scope.errMsg = 'Please select a due time';
	        return false;
	      }
	
	      if (scope.checkCurrentTime()) {
	        scope.errMsg = 'Due Date cannot be in the past';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'getPromiseFromForm',
	    value: function getPromiseFromForm() {
	      var scope = this;
	
	      return {
	        ownerId: this.tempPromise.ownerId || scope.authService.authData.userId,
	        subject: scope.tempPromise.subject,
	        category: scope.tempPromise.category.id,
	        dueDate: scope.getFullDateTime(),
	        contactId: scope.tempPromise.contactId
	      };
	    }
	  }, {
	    key: 'getFullDateTime',
	    value: function getFullDateTime() {
	      var scope = this;
	
	      var dt = scope.tempPromise.date.getFullYear() + '-' + (scope.tempPromise.date.getMonth() + 1) + '-' + scope.tempPromise.date.getDate();
	      var time = scope.tempPromise.time.getHours() + ':' + scope.tempPromise.time.getMinutes();
	
	      return dt + ' ' + time;
	    }
	  }, {
	    key: 'checkCurrentTime',
	    value: function checkCurrentTime() {
	      return new Date(this.getFullDateTime()) < new Date();
	    }
	  }, {
	    key: 'contactSelected',
	    value: function contactSelected(item) {
	      if (item) {
	        this.tempPromise.contactId = item.originalObject.contactId;
	      }
	    }
	  }, {
	    key: 'ownerSelected',
	    value: function ownerSelected(item) {
	      if (item) {
	        this.tempPromise.ownerId = item.originalObject.userId;
	      }
	    }
	  }, {
	    key: 'showUpdateOwner',
	    value: function showUpdateOwner(promiseId, successHandler) {
	      this.$scope.tempPromise = {
	        ownerId: this.authService.authData.userId
	      };
	      this.$scope.initialOwnerName = this.authService.authData.firstName + ' ' + this.authService.authData.lastName;
	
	      this.$scope.errMsg = "";
	      this.$scope.promiseId = promiseId;
	      this.$scope.successHandler = successHandler;
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _updateOwnerTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'updateOwner',
	    value: function updateOwner() {
	      var scope = this;
	
	      scope.promiseService.updateOwner(scope.promiseId, this.tempPromise.ownerId).then(function (response) {
	        scope.addPromiseSuccess();
	      });
	    }
	  }]);
	  return AddPromise;
	}();
	
	exports.default = AddPromise;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Add Promise </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div ng-show=\"!addPromiseConfirmation\">\r\n    Do you want to add any Promise ?\r\n  </div>\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div ng-show=\"addPromiseConfirmation\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-3\">\r\n              <label>Subject *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <textarea class=\"form-control\" placeholder=\"Subject\" ng-model=\"tempPromise.subject\" maxlength=\"200\">\r\n              </textarea>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-3\">\r\n              <label>Category *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-options=\"item.name for item in categories track by item.id\"\r\n                ng-model=\"tempPromise.category\"\r\n                ng-disabled=\"tempPromise.contactName\">\r\n              </select>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-if=\"tempPromise.contactName\">\r\n            <div class=\"col-md-3\">\r\n              <label>Contact *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              {{tempPromise.contactName}}\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-show=\"tempPromise.category.id === enums.PROMISE_CATEGORY.Customer && !tempPromise.contactName\">\r\n            <div class=\"col-md-3\">\r\n              <label>Contact *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <div angucomplete-alt\r\n                placeholder=\"Search Contacts by Phone, Name, Email or Registration\"\r\n                id=\"searchContacts\"\r\n                selected-object=\"contactSelected\"\r\n                remote-url=\"{{searchContactUrl}}\"\r\n                title-field=\"name,phone,email,reg\"\r\n                minlength=\"2\"\r\n                input-class=\"form-control form-control-small\"\r\n                match-class=\"autocomplete-highlight\">\r\n              </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-3\">\r\n              <label>Due Date *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <p class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-click=\"showDueDatePopup = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"tempPromise.date\" is-open=\"showDueDatePopup\" readonly=\"readOnly\" datepicker-options=\"datePickerOptions\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"showDueDatePopup = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                </span>\r\n              </p>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-3\">\r\n              <label>Due Time *</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <div uib-timepicker ng-model=\"tempPromise.time\" minute-step=\"15\" show-meridian=\"false\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-show=\"authService.isManager()\">\r\n            <div class=\"col-md-3\">\r\n              <label>Owner</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <div angucomplete-alt\r\n                id=\"searchUsers\"\r\n                placeholder=\"Search Users by Email, First Name or Last Name\"\r\n                pause=\"400\"\r\n                selected-object=\"ownerSelected\"\r\n                remote-url=\"{{searchUsersUrl}}\"\r\n                title-field=\"firstName,lastName\"\r\n                minlength=\"2\"\r\n                input-class=\"form-control form-control-small\"\r\n                initial-value = \"initialOwnerName\"\r\n                match-class=\"autocomplete-highlight\">\r\n              </div>\r\n            </div>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"addPromise()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\" ng-show=\"addPromiseConfirmation\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Add Promise\r\n                    </button>\r\n\r\n                    <div ng-show=\"!addPromiseConfirmation\">\r\n                      <a ng-click=\"addPromiseConfirmation = true\" class=\"btn btn-primary\" style=\"width:20%\">Yes</a>\r\n                      <a ng-click=\"addPromiseSuccess()\" class=\"btn btn-warning\" style=\"width:20%\">No</a>\r\n                    </div>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Update Owner </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div>\r\n        <div class=\"row\" ng-show=\"authService.isManager()\">\r\n            <div class=\"col-md-3\">\r\n              <label>Owner</label>\r\n            </div>\r\n            <div class=\"col-md-9 ph10 mb5\">\r\n              <div angucomplete-alt\r\n                id=\"searchUsers\"\r\n                placeholder=\"Search Users by Email, First Name or Last Name\"\r\n                pause=\"400\"\r\n                selected-object=\"ownerSelected\"\r\n                remote-url=\"{{searchUsersUrl}}\"\r\n                title-field=\"firstName,lastName\"\r\n                minlength=\"2\"\r\n                input-class=\"form-control form-control-small\"\r\n                initial-value = \"initialOwnerName\"\r\n                match-class=\"autocomplete-highlight\">\r\n              </div>\r\n            </div>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"updateOwner()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Update Owner\r\n                    </button>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editEnquiryExtraTemplate = __webpack_require__(525);
	
	var _editEnquiryExtraTemplate2 = _interopRequireDefault(_editEnquiryExtraTemplate);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddEditEnquiryExtra = function () {
	  AddEditEnquiryExtra.$inject = ["$uibModal", "$rootScope", "authService", "enquiryExtraManagementService"];
	  function AddEditEnquiryExtra($uibModal, $rootScope, authService, enquiryExtraManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddEditEnquiryExtra);
	    this.$scope = $rootScope.$new();
	    this.$uibModal = $uibModal;
	    this.authService = authService;
	    this.enquiryExtraManagementService = enquiryExtraManagementService;
	
	    this.$scope.save = this.save;
	    this.$scope.add = this.add;
	    this.$scope.edit = this.edit;
	    this.$scope.closeModal = this.closeModal;
	    this.$scope.validateForm = this.validateForm;
	
	    this.$scope.authService = authService;
	    this.$scope.enquiryExtraManagementService = enquiryExtraManagementService;
	  }
	
	  (0, _createClass3.default)(AddEditEnquiryExtra, [{
	    key: 'showAdd',
	    value: function showAdd(enquiryExtraLookups, callback, fromEnquiry, complimentary) {
	      this.$scope.enquiryExtraLookups = enquiryExtraLookups;
	      this.$scope.callback = callback;
	      this.$scope.errMsg = "";
	
	      if (fromEnquiry) {
	        this.$scope.add = this.addEnquiryOnly;
	      } else {
	        this.$scope.add = this.add;
	      }
	
	      this.$scope.tempExtra = {
	        complimentary: complimentary,
	        reportable: false
	      };
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editEnquiryExtraTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(enquiryExtraLookups, extra, callback) {
	      this.$scope.enquiryExtraLookups = enquiryExtraLookups;
	      this.$scope.callback = callback;
	      this.$scope.errMsg = "";
	      this.$scope.tempExtra = extra;
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editEnquiryExtraTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var scope = this;
	
	      if (scope.modalInstance) {
	        scope.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var scope = this;
	
	      if (!scope.validateForm(scope.tempExtra.enquiryExtraId)) {
	        return;
	      }
	
	      if (!scope.tempExtra.enquiryExtraId) {
	        scope.add();
	      } else {
	        scope.edit();
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var scope = this;
	
	      scope.enquiryExtraManagementService.addEnquiryExtra(scope.authService.authData.currentLocation.key, scope.tempExtra).then(function (response) {
	        if (scope.callback) {
	          scope.callback({
	            enquiryExtraId: response.data,
	            name: scope.tempExtra.name,
	            defaultPrice: scope.tempExtra.defaultPrice,
	            reportable: scope.tempExtra.reportable
	          });
	        }
	      }).finally(function () {
	        scope.closeModal();
	      });
	    }
	  }, {
	    key: 'addEnquiryOnly',
	    value: function addEnquiryOnly() {
	      var scope = this;
	
	      if (scope.callback) {
	        scope.callback({
	          name: scope.tempExtra.name,
	          defaultPrice: scope.tempExtra.defaultPrice,
	          reportable: scope.tempExtra.reportable
	        });
	      }
	
	      scope.closeModal();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var scope = this;
	
	      scope.enquiryExtraManagementService.editEnquiryExtra(scope.authService.authData.currentLocation.key, scope.tempExtra.enquiryExtraId, scope.tempExtra).then(function (response) {
	        if (scope.callback) {
	          scope.callback({
	            id: response.data,
	            name: scope.tempExtra.name,
	            defaultPrice: scope.tempExtra.defaultPrice,
	            reportable: scope.tempExtra.reportable
	          });
	        }
	      }).finally(function () {
	        scope.closeModal();
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(enquiryExtraId) {
	      var scope = this;
	
	      if (!scope.tempExtra.name || scope.tempExtra.name < 3 || scope.tempExtra.name > 40) {
	        scope.errMsg = 'Name is required field and must be between 3 and 40 characters';
	        return false;
	      } else if ((0, _lodash.find)(scope.enquiryExtraLookups, function (e) {
	        var removeEdit = false;
	        if (enquiryExtraId) {
	          removeEdit = e.enquiryExtraId !== enquiryExtraId;
	        }
	
	        return e.name.toLowerCase() === scope.tempExtra.name.toLowerCase() && removeEdit;
	      })) {
	        scope.errMsg = scope.tempExtra.name + ' is already added to the list';
	        return;
	      }
	
	      return true;
	    }
	  }]);
	  return AddEditEnquiryExtra;
	}();
	
	exports.default = AddEditEnquiryExtra;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Enquiry Extra Item </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Name</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Subject\" ng-model=\"tempExtra.name\" maxlength=\"40\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\" ng-show=\"!tempExtra.complimentary\">\r\n          <div class=\"col-md-3\">\r\n            <label>Default Price</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" placeholder=\"Default Price\" ng-model=\"tempExtra.defaultPrice\" />\r\n          </div>\r\n      </div>\r\n      \r\n      <div class=\"row\" ng-show=\"!tempExtra.complimentary\">\r\n        <div class=\"col-md-3\">\r\n          <label>Reportable</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n            <switch ng-model=\"tempExtra.reportable\"></switch>\r\n        </div>\r\n    </div>      \r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"save()\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n                    </button>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editFinancialProductTemplate = __webpack_require__(527);
	
	var _editFinancialProductTemplate2 = _interopRequireDefault(_editFinancialProductTemplate);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddEditFinancialProduct = function () {
	  AddEditFinancialProduct.$inject = ["$uibModal", "$rootScope", "authService", "financialProductManagementService"];
	  function AddEditFinancialProduct($uibModal, $rootScope, authService, financialProductManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddEditFinancialProduct);
	    this.$scope = $rootScope.$new();
	    this.$uibModal = $uibModal;
	    this.authService = authService;
	    this.financialProductManagementService = financialProductManagementService;
	
	    this.$scope.save = this.save;
	    this.$scope.add = this.add;
	    this.$scope.edit = this.edit;
	    this.$scope.closeModal = this.closeModal;
	    this.$scope.validateForm = this.validateForm;
	
	    this.$scope.authService = authService;
	    this.$scope.financialProductManagementService = financialProductManagementService;
	  }
	
	  (0, _createClass3.default)(AddEditFinancialProduct, [{
	    key: 'showAdd',
	    value: function showAdd(financialProductLookups, callback, fromEnquiry) {
	      this.$scope.financialProductLookups = financialProductLookups;
	      this.$scope.callback = callback;
	      this.$scope.errMsg = "";
	      this.$scope.tempExtra = {};
	
	      if (fromEnquiry) {
	        this.$scope.add = this.addEnquiryOnly;
	      } else {
	        this.$scope.add = this.add;
	      }
	
	      this.$scope.tempExtra = {
	        reportable: false
	      };
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editFinancialProductTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(financialProductLookups, extra) {
	      this.$scope.financialProductLookups = financialProductLookups;
	      this.$scope.callback = null;
	      this.$scope.errMsg = "";
	      this.$scope.tempExtra = extra;
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editFinancialProductTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var scope = this;
	
	      if (scope.modalInstance) {
	        scope.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var scope = this;
	
	      if (!scope.validateForm(scope.tempExtra.financialProductId)) {
	        return;
	      }
	
	      if (!scope.tempExtra.financialProductId) {
	        scope.add();
	      } else {
	        scope.edit();
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var scope = this;
	
	      scope.financialProductManagementService.addFinancialProduct(scope.authService.authData.currentLocation.key, scope.tempExtra.name, scope.tempExtra.reportable, scope.tempExtra.defaultPrice).then(function (response) {
	        if (scope.callback) {
	          scope.callback({
	            financialProductId: response.data,
	            name: scope.tempExtra.name,
	            defaultPrice: scope.tempExtra.defaultPrice,
	            reportable: scope.tempExtra.reportable
	          });
	        }
	      }).finally(function () {
	        scope.closeModal();
	      });
	    }
	  }, {
	    key: 'addEnquiryOnly',
	    value: function addEnquiryOnly() {
	      var scope = this;
	
	      if (scope.callback) {
	        scope.callback({
	          name: scope.tempExtra.name,
	          defaultPrice: scope.tempExtra.defaultPrice,
	          reportable: scope.tempExtra.reportable
	        });
	      }
	
	      scope.closeModal();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var scope = this;
	
	      scope.financialProductManagementService.editFinancialProduct(scope.authService.authData.currentLocation.key, scope.tempExtra.financialProductId, scope.tempExtra.name, scope.tempExtra.reportable, scope.tempExtra.defaultPrice).then(function (response) {
	        if (scope.callback) {
	          scope.callback({
	            id: response.data,
	            name: scope.tempExtra.name,
	            defaultPrice: scope.tempExtra.defaultPrice,
	            reportable: scope.tempExtra.reportable
	          });
	        }
	      }).finally(function () {
	        scope.closeModal();
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(financialProductId) {
	      var scope = this;
	
	      if (!scope.tempExtra.name || scope.tempExtra.name < 3 || scope.tempExtra.name > 40) {
	        scope.errMsg = 'Name is required field and must be between 3 and 40 characters';
	        return false;
	      } else if ((0, _lodash.find)(scope.financialProductLookups, function (e) {
	        var removeEdit = false;
	        if (financialProductId) {
	          removeEdit = e.financialProductId !== financialProductId;
	        }
	
	        return e.name.toLowerCase() === scope.tempExtra.name.toLowerCase() && removeEdit;
	      })) {
	        scope.errMsg = scope.tempExtra.name + ' is already added to the list';
	        return;
	      }
	
	      return true;
	    }
	  }]);
	  return AddEditFinancialProduct;
	}();
	
	exports.default = AddEditFinancialProduct;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Financial Product Item </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Name</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Subject\" ng-model=\"tempExtra.name\" maxlength=\"40\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Default Price</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" placeholder=\"Default Price\" ng-model=\"tempExtra.defaultPrice\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Reportable</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n            <switch ng-model=\"tempExtra.reportable\"></switch>\r\n        </div>\r\n    </div>          \r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"save()\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n                    </button>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _moment = __webpack_require__(529);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UtilsService = function () {
	  UtilsService.$inject = ["$http", "$q", "appConfig", "enums"];
	  function UtilsService($http, $q, appConfig, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UtilsService);
	    this.$http = $http;
	    this.$q = $q;
	    this.appConfig = appConfig;
	    this.enums = enums;
	  }
	
	  (0, _createClass3.default)(UtilsService, [{
	    key: 'calculateAmount',
	    value: function calculateAmount(calc) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateAmount', calc);
	    }
	  }, {
	    key: 'calculateMonthly',
	    value: function calculateMonthly(calc) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateMonthly', calc);
	    }
	  }, {
	    key: 'calculateTerm',
	    value: function calculateTerm(calc) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateTerm', calc);
	    }
	  }, {
	    key: 'calculateRate',
	    value: function calculateRate(calc) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateRate', calc);
	    }
	  }, {
	    key: 'getDatePart',
	    value: function getDatePart(dateString) {
	      if (dateString) {
	        var timeIndex = dateString.search(/T/);
	
	        return new Date(dateString.substring(0, timeIndex));
	      } else {
	        return null;
	      }
	    }
	  }]);
	  return UtilsService;
	}();
	
	exports.default = UtilsService;

/***/ }),
/* 529 */,
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 531,
		"./af.js": 531,
		"./ar": 532,
		"./ar-dz": 533,
		"./ar-dz.js": 533,
		"./ar-kw": 534,
		"./ar-kw.js": 534,
		"./ar-ly": 535,
		"./ar-ly.js": 535,
		"./ar-ma": 536,
		"./ar-ma.js": 536,
		"./ar-sa": 537,
		"./ar-sa.js": 537,
		"./ar-tn": 538,
		"./ar-tn.js": 538,
		"./ar.js": 532,
		"./az": 539,
		"./az.js": 539,
		"./be": 540,
		"./be.js": 540,
		"./bg": 541,
		"./bg.js": 541,
		"./bm": 542,
		"./bm.js": 542,
		"./bn": 543,
		"./bn.js": 543,
		"./bo": 544,
		"./bo.js": 544,
		"./br": 545,
		"./br.js": 545,
		"./bs": 546,
		"./bs.js": 546,
		"./ca": 547,
		"./ca.js": 547,
		"./cs": 548,
		"./cs.js": 548,
		"./cv": 549,
		"./cv.js": 549,
		"./cy": 550,
		"./cy.js": 550,
		"./da": 551,
		"./da.js": 551,
		"./de": 552,
		"./de-at": 553,
		"./de-at.js": 553,
		"./de-ch": 554,
		"./de-ch.js": 554,
		"./de.js": 552,
		"./dv": 555,
		"./dv.js": 555,
		"./el": 556,
		"./el.js": 556,
		"./en-SG": 557,
		"./en-SG.js": 557,
		"./en-au": 558,
		"./en-au.js": 558,
		"./en-ca": 559,
		"./en-ca.js": 559,
		"./en-gb": 560,
		"./en-gb.js": 560,
		"./en-ie": 561,
		"./en-ie.js": 561,
		"./en-il": 562,
		"./en-il.js": 562,
		"./en-nz": 563,
		"./en-nz.js": 563,
		"./eo": 564,
		"./eo.js": 564,
		"./es": 565,
		"./es-do": 566,
		"./es-do.js": 566,
		"./es-us": 567,
		"./es-us.js": 567,
		"./es.js": 565,
		"./et": 568,
		"./et.js": 568,
		"./eu": 569,
		"./eu.js": 569,
		"./fa": 570,
		"./fa.js": 570,
		"./fi": 571,
		"./fi.js": 571,
		"./fo": 572,
		"./fo.js": 572,
		"./fr": 573,
		"./fr-ca": 574,
		"./fr-ca.js": 574,
		"./fr-ch": 575,
		"./fr-ch.js": 575,
		"./fr.js": 573,
		"./fy": 576,
		"./fy.js": 576,
		"./ga": 577,
		"./ga.js": 577,
		"./gd": 578,
		"./gd.js": 578,
		"./gl": 579,
		"./gl.js": 579,
		"./gom-latn": 580,
		"./gom-latn.js": 580,
		"./gu": 581,
		"./gu.js": 581,
		"./he": 582,
		"./he.js": 582,
		"./hi": 583,
		"./hi.js": 583,
		"./hr": 584,
		"./hr.js": 584,
		"./hu": 585,
		"./hu.js": 585,
		"./hy-am": 586,
		"./hy-am.js": 586,
		"./id": 587,
		"./id.js": 587,
		"./is": 588,
		"./is.js": 588,
		"./it": 589,
		"./it-ch": 590,
		"./it-ch.js": 590,
		"./it.js": 589,
		"./ja": 591,
		"./ja.js": 591,
		"./jv": 592,
		"./jv.js": 592,
		"./ka": 593,
		"./ka.js": 593,
		"./kk": 594,
		"./kk.js": 594,
		"./km": 595,
		"./km.js": 595,
		"./kn": 596,
		"./kn.js": 596,
		"./ko": 597,
		"./ko.js": 597,
		"./ku": 598,
		"./ku.js": 598,
		"./ky": 599,
		"./ky.js": 599,
		"./lb": 600,
		"./lb.js": 600,
		"./lo": 601,
		"./lo.js": 601,
		"./lt": 602,
		"./lt.js": 602,
		"./lv": 603,
		"./lv.js": 603,
		"./me": 604,
		"./me.js": 604,
		"./mi": 605,
		"./mi.js": 605,
		"./mk": 606,
		"./mk.js": 606,
		"./ml": 607,
		"./ml.js": 607,
		"./mn": 608,
		"./mn.js": 608,
		"./mr": 609,
		"./mr.js": 609,
		"./ms": 610,
		"./ms-my": 611,
		"./ms-my.js": 611,
		"./ms.js": 610,
		"./mt": 612,
		"./mt.js": 612,
		"./my": 613,
		"./my.js": 613,
		"./nb": 614,
		"./nb.js": 614,
		"./ne": 615,
		"./ne.js": 615,
		"./nl": 616,
		"./nl-be": 617,
		"./nl-be.js": 617,
		"./nl.js": 616,
		"./nn": 618,
		"./nn.js": 618,
		"./pa-in": 619,
		"./pa-in.js": 619,
		"./pl": 620,
		"./pl.js": 620,
		"./pt": 621,
		"./pt-br": 622,
		"./pt-br.js": 622,
		"./pt.js": 621,
		"./ro": 623,
		"./ro.js": 623,
		"./ru": 624,
		"./ru.js": 624,
		"./sd": 625,
		"./sd.js": 625,
		"./se": 626,
		"./se.js": 626,
		"./si": 627,
		"./si.js": 627,
		"./sk": 628,
		"./sk.js": 628,
		"./sl": 629,
		"./sl.js": 629,
		"./sq": 630,
		"./sq.js": 630,
		"./sr": 631,
		"./sr-cyrl": 632,
		"./sr-cyrl.js": 632,
		"./sr.js": 631,
		"./ss": 633,
		"./ss.js": 633,
		"./sv": 634,
		"./sv.js": 634,
		"./sw": 635,
		"./sw.js": 635,
		"./ta": 636,
		"./ta.js": 636,
		"./te": 637,
		"./te.js": 637,
		"./tet": 638,
		"./tet.js": 638,
		"./tg": 639,
		"./tg.js": 639,
		"./th": 640,
		"./th.js": 640,
		"./tl-ph": 641,
		"./tl-ph.js": 641,
		"./tlh": 642,
		"./tlh.js": 642,
		"./tr": 643,
		"./tr.js": 643,
		"./tzl": 644,
		"./tzl.js": 644,
		"./tzm": 645,
		"./tzm-latn": 646,
		"./tzm-latn.js": 646,
		"./tzm.js": 645,
		"./ug-cn": 647,
		"./ug-cn.js": 647,
		"./uk": 648,
		"./uk.js": 648,
		"./ur": 649,
		"./ur.js": 649,
		"./uz": 650,
		"./uz-latn": 651,
		"./uz-latn.js": 651,
		"./uz.js": 650,
		"./vi": 652,
		"./vi.js": 652,
		"./x-pseudo": 653,
		"./x-pseudo.js": 653,
		"./yo": 654,
		"./yo.js": 654,
		"./zh-cn": 655,
		"./zh-cn.js": 655,
		"./zh-hk": 656,
		"./zh-hk.js": 656,
		"./zh-tw": 657,
		"./zh-tw.js": 657
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 530;


/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _app = __webpack_require__(659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintService = function () {
	  PrintService.$inject = ["$http", "appConfig", "$window"];
	  function PrintService($http, appConfig, $window) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PrintService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	    this.$window = $window;
	  }
	
	  (0, _createClass3.default)(PrintService, [{
	    key: 'printReport',
	    value: function printReport(reportName, criteria) {
	      criteria.additionalParameter1 = (0, _app.getThemeColor)('--report-even-row');
	      criteria.additionalParameter2 = (0, _app.getThemeColor)('--report-even-hover');
	
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/report/' + reportName), (0, _stringify2.default)(criteria));
	    }
	  }, {
	    key: 'printVehicleList',
	    value: function printVehicleList(queryParams) {
	      this.$window.open(this.appConfig.apiServiceBaseUri + ('api/print/vehiclelist/' + queryParams));
	    }
	  }, {
	    key: 'printDpaHistory',
	    value: function printDpaHistory(contactId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/dpahistory/' + contactId));
	    }
	  }, {
	    key: 'printSimiOrderForm',
	    value: function printSimiOrderForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/simiorderform/' + enquiryId));
	    }
	  }, {
	    key: 'printSignedOrderForm',
	    value: function printSignedOrderForm(enquiryId, entityId, authCode) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/signedoderform/' + enquiryId), (0, _stringify2.default)({ entityId: entityId, authCode: authCode }));
	    }
	  }, {
	    key: 'printSimiTradeOrderForm',
	    value: function printSimiTradeOrderForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/simitradeorderform/' + enquiryId));
	    }
	  }, {
	    key: 'nonSimiOrderForm',
	    value: function nonSimiOrderForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/nonSimiOrder/' + enquiryId));
	    }
	  }, {
	    key: 'printQuotation',
	    value: function printQuotation(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/quotation/' + enquiryId));
	    }
	  }, {
	    key: 'saveQuotation',
	    value: function saveQuotation(enquiryId, userId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/print/form/savequotation/' + enquiryId + '/' + userId));
	    }
	  }, {
	    key: 'emailQuotation',
	    value: function emailQuotation(enquiryId, userId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/print/form/emailquotation/' + enquiryId + '/' + userId));
	    }
	  }, {
	    key: 'printTradeOrderForm',
	    value: function printTradeOrderForm(enquiryId, isSimi) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/tradeorderform/' + enquiryId + '/' + isSimi));
	    }
	  }, {
	    key: 'printFinanceQuotation',
	    value: function printFinanceQuotation(enquiryId, selectedOption) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/financequotation/' + enquiryId + '/' + selectedOption));
	    }
	  }, {
	    key: 'printVehicleAppraisal',
	    value: function printVehicleAppraisal(appraisalId, enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/appraisal/' + appraisalId + '/' + enquiryId));
	    }
	  }, {
	    key: 'printMSL_DNS_CustomForm',
	    value: function printMSL_DNS_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_msl_dns/' + enquiryId));
	    }
	  }, {
	    key: 'printMercUsedWarranty_CustomForm',
	    value: function printMercUsedWarranty_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mercusedwarranty/' + enquiryId));
	    }
	  }, {
	    key: 'printMercSPA_CustomForm',
	    value: function printMercSPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mercspa/' + enquiryId));
	    }
	  }, {
	    key: 'printMercUsedSPA_CustomForm',
	    value: function printMercUsedSPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mercusedspa/' + enquiryId));
	    }
	  }, {
	    key: 'printMercDPA_CustomForm',
	    value: function printMercDPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mercdpa/' + enquiryId));
	    }
	  }, {
	    key: 'printMslUsedDPA_CustomForm',
	    value: function printMslUsedDPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_msluseddpa/' + enquiryId));
	    }
	  }, {
	    key: 'printMazdaDPA_CustomForm',
	    value: function printMazdaDPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mazdadpa/' + enquiryId));
	    }
	  }, {
	    key: 'printSkodaDPA_CustomForm',
	    value: function printSkodaDPA_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_skodadpa/' + enquiryId));
	    }
	  }, {
	    key: 'printRf105Form_CustomForm',
	    value: function printRf105Form_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_rf105form/' + enquiryId));
	    }
	  }, {
	    key: 'printRf105TradeForm_CustomForm',
	    value: function printRf105TradeForm_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_rf105tradeform/' + enquiryId));
	    }
	  }, {
	    key: 'printMslBydDpa_CustomForm',
	    value: function printMslBydDpa_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mslbyddpa/' + enquiryId));
	    }
	  }, {
	    key: 'printOrderConfirmation_Customer',
	    value: function printOrderConfirmation_Customer(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_orderconfirmation/' + enquiryId));
	    }
	  }, {
	    key: 'printCunninghamOrderForm_CustomForm',
	    value: function printCunninghamOrderForm_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_cunninghamorderform/' + enquiryId));
	    }
	  }, {
	    key: 'printDistanceSellingAddendum_CustomForm',
	    value: function printDistanceSellingAddendum_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_distancesellingaddendum/' + enquiryId));
	    }
	  }, {
	    key: 'printOrderFormGuid_CustomForm',
	    value: function printOrderFormGuid_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_orderformguide/' + enquiryId));
	    }
	  }, {
	    key: 'printMSL_PCP_CustomForm',
	    value: function printMSL_PCP_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_msl_pcp/' + enquiryId));
	    }
	  }, {
	    key: 'printMslPreOwnedWarrantyAgreement',
	    value: function printMslPreOwnedWarrantyAgreement(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mslusedwarranty/' + enquiryId));
	    }
	  }, {
	    key: 'printMslXpengDpa_CustomForm',
	    value: function printMslXpengDpa_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_mslxpengdpa/' + enquiryId));
	    }
	  }, {
	    key: 'printSuzukiDataForm_CustomForm',
	    value: function printSuzukiDataForm_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_suzukidataform/' + enquiryId));
	    }
	  }, {
	    key: 'paymentReceipt',
	    value: function paymentReceipt(enquiryId, userId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/paymentreceipt/' + enquiryId + '/' + userId));
	    }
	  }, {
	    key: 'printLyonsPrepWorkForm_CustomForm',
	    value: function printLyonsPrepWorkForm_CustomForm(enquiryId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/cf_lyonsprepworkform/' + enquiryId));
	    }
	  }, {
	    key: 'printInvoice',
	    value: function printInvoice(invoiceId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/invoice/print/' + invoiceId));
	    }
	  }, {
	    key: 'printInvoicePaymentReceipt',
	    value: function printInvoicePaymentReceipt(invoiceId) {
	      this.formPrint(this.appConfig.apiServiceBaseUri + ('api/print/form/invoicepaymentreceipt/' + invoiceId));
	    }
	  }, {
	    key: 'emailInvoice',
	    value: function emailInvoice(entityId, invoiceId, cc) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/print/form/emailinvoice/' + entityId + '/' + invoiceId + '/' + cc));
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(obj) {
	      var str = [];
	      for (var p in obj) {
	        if (obj.hasOwnProperty(p)) {
	          if (Array.isArray(obj[p])) {
	            obj[p].map(function (item) {
	              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
	            });
	          } else {
	            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	          }
	        }
	      }return str.join("&");
	    }
	  }, {
	    key: 'formPrint',
	    value: function formPrint(url, postData) {
	      var frm = $('#frmPrint');
	      frm.attr('action', url);
	      $('#postdata').val(postData);
	      frm.submit();
	    }
	  }]);
	  return PrintService;
	}();
	
	exports.default = PrintService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getThemeColor = getThemeColor;
	exports.applyTheme = applyTheme;
	var styleVars = document.querySelector(':root');
	
	function getThemeColor(colorName) {
	    // Get the styles (properties and values) for the root
	    var style = getComputedStyle(styleVars);
	    return style.getPropertyValue(colorName);
	}
	
	// Create a function for setting a variable value
	
	function setThemeColor(colorName, colorHash) {
	    // Set the value of variable to another Value
	    styleVars.style.setProperty(colorName, colorHash);
	}
	
	var themeColors = [{ name: '--logo-path', carsNow: 'url(../../../images/logo.png)', leadManager: 'url(../../../images/leadmanager/logo.png)' }, { name: '--default-color', carsNow: '#4d585a', leadManager: '#233D4D' }, { name: '--default-color-hover', carsNow: '#596568', leadManager: '#596568' }, { name: '--primary-color', carsNow: '#ffd700', leadManager: '#56c4f0' }, { name: '--primary-color-hover', carsNow: '#ffdb1a', leadManager: '#6bc1e3' }, { name: '--success-color', carsNow: '#3d9648', leadManager: '#3d9648' }, { name: '--success-color-hover', carsNow: '#44a851', leadManager: '#44a851' }, { name: '--danger-color', carsNow: '#ed1c24', leadManager: '#ed1c24' }, { name: '--danger-color-hover', carsNow: '#ef343b', leadManager: '#ef343b' }, { name: '--topNav-user-text', carsNow: '#4e5757', leadManager: '#4e5757' }, { name: '--dashboard-odd-panel-mainColor', carsNow: '#ffe247', leadManager: '#61A5C2' }, { name: '--dashboard-odd-panel-gradColor', carsNow: '#ffe660', leadManager: '#A9D6E5' }, { name: '--dashboard-even-panel-mainColor', carsNow: '#cdccbc', leadManager: '#ADB5BD' }, { name: '--dashboard-even-panel-gradColor', carsNow: '#c2c2b4', leadManager: '#DEE2E6' }, { name: '--report-even-row', carsNow: '#FFF8D3', leadManager: '#bde0fe' }, { name: '--report-even-hover', carsNow: '#FFD700', leadManager: '#a2d2ff' }];
	
	function applyTheme(isLeadManager) {
	    themeColors.map(function (col) {
	        setThemeColor(col.name, isLeadManager ? col.leadManager : col.carsNow);
	    });
	}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExportService = function () {
	  ExportService.$inject = ["$http", "appConfig", "$window"];
	  function ExportService($http, appConfig, $window) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ExportService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	    this.$window = $window;
	  }
	
	  (0, _createClass3.default)(ExportService, [{
	    key: 'exportReport',
	    value: function exportReport(reportName, criteria) {
	      var frm = $('#frmPrint');
	      frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/export/report/' + reportName));
	      $('#postdata').val((0, _stringify2.default)(criteria));
	      frm.submit();
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(obj) {
	      var str = [];
	      for (var p in obj) {
	        if (obj.hasOwnProperty(p)) {
	          if (Array.isArray(obj[p])) {
	            obj[p].map(function (item) {
	              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
	            });
	          } else {
	            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	          }
	        }
	      }return str.join("&");
	    }
	  }]);
	  return ExportService;
	}();
	
	exports.default = ExportService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailService = function () {
	    MailService.$inject = ["$http", "appConfig", "$q"];
	    function MailService($http, appConfig, $q) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, MailService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	        this.$q = $q;
	    }
	
	    (0, _createClass3.default)(MailService, [{
	        key: 'mailDpaHistory',
	        value: function mailDpaHistory(contactId) {
	            var deferred = this.$q.defer();
	
	            var frm = $('#frmPrint');
	            frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/mail/dpahistory/' + contactId));
	            frm.attr('target', null);
	            frm.submit();
	            frm.attr('target', '_blank');
	            window.setTimeout(function () {
	                return deferred.resolve();
	            }, 100);
	
	            return deferred.promise;
	        }
	    }]);
	    return MailService;
	}();
	
	exports.default = MailService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminService = function () {
	  AdminService.$inject = ["$http", "appConfig", "$window"];
	  function AdminService($http, appConfig, $window) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AdminService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(AdminService, [{
	    key: "listDefaultTexts",
	    value: function listDefaultTexts(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/admin/defaulttexts/list/" + entityId + "/"));
	    }
	  }, {
	    key: "updateDefaultTexts",
	    value: function updateDefaultTexts(entityId, defaultTexts) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/admin/defaulttexts/update/" + entityId + "/"), defaultTexts);
	    }
	  }, {
	    key: "getWebEnquiryLocations",
	    value: function getWebEnquiryLocations() {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + "api/admin/webenquirylocations");
	    }
	  }, {
	    key: "listOpenEnquiries",
	    value: function listOpenEnquiries(reportCriteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/admin/listOpenEnquiries", reportCriteria);
	    }
	  }, {
	    key: "closeOpenEnquiries",
	    value: function closeOpenEnquiries(enquiryIds) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/admin/closeOpenEnquiries", enquiryIds);
	    }
	  }]);
	  return AdminService;
	}();
	
	exports.default = AdminService;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileService = function () {
	    FileService.$inject = ["$http", "appConfig"];
	    function FileService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, FileService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(FileService, [{
	        key: 'getQuotation',
	        value: function getQuotation(enquiryQuoteId) {
	            var frm = $('#frmPrint');
	            frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/file/getquote/' + enquiryQuoteId));
	            frm.submit();
	        }
	    }, {
	        key: 'exportVehicles',
	        value: function exportVehicles(entityId) {
	            var frm = $('#frmPrint');
	            frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/vehicle/publish/' + entityId));
	            frm.submit();
	        }
	    }, {
	        key: 'getWebLeadFollowUpEmailTemplate',
	        value: function getWebLeadFollowUpEmailTemplate(entityId, enquiryId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/file/getwebleadfollowupemailtemplate/' + entityId + '/' + enquiryId));
	        }
	    }, {
	        key: 'removeFollowUpImage',
	        value: function removeFollowUpImage(enquiryId, fileName) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/file/remove/followupimage/' + enquiryId + '?fullUrl=' + fileName));
	        }
	    }]);
	    return FileService;
	}();
	
	exports.default = FileService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandingService = function () {
	    BrandingService.$inject = ["$http", "appConfig"];
	    function BrandingService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, BrandingService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(BrandingService, [{
	        key: "list",
	        value: function list(entityId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/branding/list/" + entityId));
	        }
	    }, {
	        key: "applyBranding",
	        value: function applyBranding(entityId, templateId, images) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/branding/apply/" + entityId + "/" + templateId), images);
	        }
	    }]);
	    return BrandingService;
	}();
	
	exports.default = BrandingService;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PerformanceManagementService = function () {
	  PerformanceManagementService.$inject = ["$http", "appConfig"];
	  function PerformanceManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PerformanceManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(PerformanceManagementService, [{
	    key: "addMonthlyDistribution",
	    value: function addMonthlyDistribution(monthlyDistribution) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/addmonthlydistribution/", monthlyDistribution);
	    }
	  }, {
	    key: "listMonthlyDistribution",
	    value: function listMonthlyDistribution(entityId, year) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/listmonthlydistribution/" + entityId + "/" + year));
	    }
	  }, {
	    key: "editMonthlyDistribution",
	    value: function editMonthlyDistribution(monthlyDistribution) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/editmonthlydistribution/", monthlyDistribution);
	    }
	  }, {
	    key: "removeMonthlyDistribution",
	    value: function removeMonthlyDistribution(entityId, monthlyDistributionId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/removemonthlydistribution/" + entityId + "/" + monthlyDistributionId));
	    }
	  }, {
	    key: "addUserTarget",
	    value: function addUserTarget(userTarget) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/addusertarget/", userTarget);
	    }
	  }, {
	    key: "listUserTargets",
	    value: function listUserTargets(entityId, year) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/listusertargets/" + entityId + "/" + year));
	    }
	  }, {
	    key: "editUserTarget",
	    value: function editUserTarget(userTarget) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/editusertarget/", userTarget);
	    }
	  }, {
	    key: "removeUserTarget",
	    value: function removeUserTarget(entityId, userTargetId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/performancemanagement/removeusertarget/" + entityId + "/" + userTargetId));
	    }
	  }, {
	    key: "getTargetsOverview",
	    value: function getTargetsOverview(criteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/performancemanagement/getTargetsOverview", criteria);
	    }
	  }]);
	  return PerformanceManagementService;
	}();
	
	exports.default = PerformanceManagementService;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntegrationService = function () {
	    IntegrationService.$inject = ["$http", "appConfig"];
	    function IntegrationService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, IntegrationService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(IntegrationService, [{
	        key: "sendForSignature",
	        value: function sendForSignature(entityId, enquiryId, additionalRecipients, code, orderFormVersion) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/sendforsignature/", { entityId: entityId, enquiryId: enquiryId, additionalRecipients: additionalRecipients, code: code, orderFormVersion: orderFormVersion });
	        }
	    }, {
	        key: "sendTradeFormForSignature",
	        value: function sendTradeFormForSignature(entityId, enquiryId, additionalRecipients, code) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/sendtradeformforsignature/", { entityId: entityId, enquiryId: enquiryId, additionalRecipients: additionalRecipients, code: code });
	        }
	    }, {
	        key: "getMazdaServiceHistory",
	        value: function getMazdaServiceHistory(mazdaToken, orgName, chassisNo) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/GetMazdaServiceHistory/", { mazdaToken: mazdaToken, orgName: orgName, chassisNo: chassisNo });
	        }
	    }, {
	        key: "getMazdaRecallHistory",
	        value: function getMazdaRecallHistory(mazdaToken, orgName, chassisNo) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/GetMazdaRecallHistory/", { mazdaToken: mazdaToken, orgName: orgName, chassisNo: chassisNo });
	        }
	    }]);
	    return IntegrationService;
	}();
	
	exports.default = IntegrationService;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomFormsService = function () {
	    CustomFormsService.$inject = ["$http", "appConfig"];
	    function CustomFormsService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, CustomFormsService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(CustomFormsService, [{
	        key: "list",
	        value: function list(entityId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/customforms/list/" + entityId));
	        }
	    }, {
	        key: "add",
	        value: function add(customForm) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/customforms/add/", customForm);
	        }
	    }, {
	        key: "edit",
	        value: function edit(customForm) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/customforms/edit/", customForm);
	        }
	    }, {
	        key: "remove",
	        value: function remove(entityId, customFormId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/customforms/remove/" + entityId + "/" + customFormId));
	        }
	    }]);
	    return CustomFormsService;
	}();
	
	exports.default = CustomFormsService;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _barChart = __webpack_require__(669);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barChartModule = _angular2.default.module('barChart', [_angularUiRouter2.default]).component('barChart', _barChart2.default).name;
	
	exports.default = barChartModule;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _barChart = __webpack_require__(670);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	var _barChart3 = __webpack_require__(671);
	
	var _barChart4 = _interopRequireDefault(_barChart3);
	
	__webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barChartComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '<',
	    settings: '<',
	    data: '<'
	  },
	  template: _barChart2.default,
	  controller: _barChart4.default
	};
	
	exports.default = barChartComponent;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-hide=\"$ctrl.data.length\">No data to display</div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" ng-show=\"$ctrl.data.length\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarChartController = function () {
	    BarChartController.$inject = ["$scope"];
	    function BarChartController($scope) {
	        "ngInject";
	
	        //Begin Services
	
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, BarChartController);
	        this.$scope = $scope;
	        //End Services
	
	        //Begin Data
	        this.hasNoTarget = false;
	        this.chartContainerId = "chartContainer" + this.getGuid();
	        this.chart = null;
	        this.settings = this.settings || {};
	        //End Data
	
	        //Begin Initialize
	        this.$onChanges = function (changesObj) {
	            if (changesObj.data && changesObj.data.currentValue) {
	                _this.chart = _this.generateChart();
	            }
	        };
	        //End Initialize 
	    }
	
	    (0, _createClass3.default)(BarChartController, [{
	        key: "generateChart",
	        value: function generateChart() {
	            var _this2 = this;
	
	            //Chart Code Start    
	            var ctrl = this;
	
	            var labels = [];
	            var countSeries = [];
	
	            this.data.map(function (item) {
	                labels.push(_this2.settings.labelReader ? _this2.settings.labelReader(item) : item.name);
	                countSeries.push(_this2.settings.countReader ? _this2.settings.countReader(item) : item.count);
	            });
	
	            var chartOptions = {
	                chart: {
	                    type: 'column',
	                    height: '300'
	                },
	                title: {
	                    text: null
	                },
	                xAxis: {
	                    categories: labels,
	                    crosshair: true
	                },
	                yAxis: {
	                    min: 0,
	                    title: {
	                        text: null
	                    }
	                },
	                credits: {
	                    enabled: false
	                },
	                tooltip: {
	                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
	                    footerFormat: '</table>',
	                    shared: true,
	                    useHTML: true
	                },
	                plotOptions: {
	                    column: {
	                        pointPadding: 0.2,
	                        borderWidth: 0
	                    }
	                },
	                series: [{
	                    name: 'Count',
	                    data: countSeries
	                }]
	            };
	
	            return _highcharts2.default.chart(this.chartContainerId, chartOptions);
	
	            //Chart Code End
	        }
	    }, {
	        key: "getGuid",
	        value: function getGuid() {
	            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }]);
	    return BarChartController;
	}();
	
	exports.default = BarChartController;

/***/ }),
/* 672 */,
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(674);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./barChart.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./barChart.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".barChart{color:red}", ""]);
	
	// exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _dialogButton = __webpack_require__(676);
	
	var _dialogButton2 = _interopRequireDefault(_dialogButton);
	
	var _dialogConfig = __webpack_require__(678);
	
	var _dialogConfig2 = _interopRequireDefault(_dialogConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogService = function () {
	  DialogService.$inject = ["$ngConfirm"];
	  function DialogService($ngConfirm) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DialogService);
	    this.$ngConfirm = $ngConfirm;
	  }
	
	  (0, _createClass3.default)(DialogService, [{
	    key: 'single',
	    value: function single(dialogConfig, dialogButton) {
	      return this.$ngConfirm({
	        title: dialogConfig.title,
	        content: dialogConfig.content,
	        contentUrl: dialogConfig.contentUrl,
	        type: dialogConfig.type,
	        typeAnimated: true,
	        buttons: {
	          ok: {
	            text: dialogButton.text,
	            btnClass: dialogButton.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton.callback) {
	                return dialogButton.callback(scope, button);
	              }
	              return true;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'double',
	    value: function double(dialogConfig, dialogButton1, dialogButton2) {
	      return this.$ngConfirm({
	        title: dialogConfig.title,
	        content: dialogConfig.content,
	        contentUrl: dialogConfig.contentUrl,
	        type: dialogConfig.type,
	        typeAnimated: true,
	        buttons: {
	          button1: {
	            text: dialogButton1.text,
	            btnClass: dialogButton1.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton1.callback) {
	                return dialogButton1.callback(scope, button);
	              }
	              return true;
	            }
	          },
	          button2: {
	            text: dialogButton2.text,
	            btnClass: dialogButton2.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton2.callback) {
	                return dialogButton2.callback(scope, button);
	              }
	              return true;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'triple',
	    value: function triple(dialogConfig, dialogButton1, dialogButton2, dialogButton3) {
	      return this.$ngConfirm({
	        title: dialogConfig.title,
	        content: dialogConfig.content,
	        contentUrl: dialogConfig.contentUrl,
	        type: dialogConfig.type,
	        typeAnimated: true,
	        buttons: {
	          button1: {
	            text: dialogButton1.text,
	            btnClass: dialogButton1.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton1.callback) {
	                return dialogButton1.callback(scope, button);
	              }
	              return true;
	            }
	          },
	          button2: {
	            text: dialogButton2.text,
	            btnClass: dialogButton2.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton2.callback) {
	                return dialogButton2.callback(scope, button);
	              }
	              return true;
	            }
	          },
	          button3: {
	            text: dialogButton3.text,
	            btnClass: dialogButton3.btnClass,
	            action: function action(scope, button) {
	              if (dialogButton3.callback) {
	                return dialogButton3.callback(scope, button);
	              }
	              return true;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'error',
	    value: function error(message) {
	      return this.single(_dialogConfig2.default.red(message), _dialogButton2.default.ok());
	    }
	  }]);
	  return DialogService;
	}();
	
	exports.default = DialogService;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dialogColor = __webpack_require__(677);
	
	var _dialogColor2 = _interopRequireDefault(_dialogColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogButton = function () {
	    function DialogButton(text, btnClass, callback) {
	        (0, _classCallCheck3.default)(this, DialogButton);
	
	        this.text = text;
	        if (btnClass) {
	            this.btnClass = 'btn-' + btnClass;
	        }
	        this.callback = callback;
	    }
	
	    (0, _createClass3.default)(DialogButton, null, [{
	        key: 'new',
	        value: function _new(text, btnClass, callback) {
	            return new DialogButton(text, btnClass, callback);
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            return new DialogButton('OK', null, null);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            return new DialogButton('CANCEL', null, null);
	        }
	    }]);
	    return DialogButton;
	}();
	
	exports.default = DialogButton;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogColor = function DialogColor() {
	    (0, _classCallCheck3.default)(this, DialogColor);
	};
	
	DialogColor.GREEN = 'green';
	DialogColor.RED = 'red';
	DialogColor.ORANGE = 'orange';
	DialogColor.PURPLE = 'purple';
	DialogColor.DARK = 'dark';
	DialogColor.BLUE = 'blue';
	DialogColor.PRIMARY = 'primary';
	DialogColor.DEFAULT = 'default';
	exports.default = DialogColor;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dialogColor = __webpack_require__(677);
	
	var _dialogColor2 = _interopRequireDefault(_dialogColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogConfig = function () {
	  function DialogConfig(title, content, contentUrl, type) {
	    (0, _classCallCheck3.default)(this, DialogConfig);
	
	    this.title = title;
	    this.content = content;
	    this.contentUrl = contentUrl;
	    this.type = type;
	  }
	
	  (0, _createClass3.default)(DialogConfig, null, [{
	    key: "red",
	    value: function red(content, title) {
	      return new DialogConfig(title, content, null, _dialogColor2.default.RED);
	    }
	  }, {
	    key: "primary",
	    value: function primary(content, title) {
	      return new DialogConfig(title, content, null, _dialogColor2.default.ORANGE);
	    }
	  }, {
	    key: "success",
	    value: function success(content, title) {
	      return new DialogConfig(title, content, null, _dialogColor2.default.GREEN);
	    }
	  }]);
	  return DialogConfig;
	}();
	
	exports.default = DialogConfig;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(680);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _login = __webpack_require__(1015);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _user = __webpack_require__(1036);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _unauthorized = __webpack_require__(1043);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	var _vehicle = __webpack_require__(1049);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _notes = __webpack_require__(1186);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _entityManagement = __webpack_require__(1192);
	
	var _entityManagement2 = _interopRequireDefault(_entityManagement);
	
	var _accessoryManagement = __webpack_require__(1204);
	
	var _accessoryManagement2 = _interopRequireDefault(_accessoryManagement);
	
	var _priceManagement = __webpack_require__(1217);
	
	var _priceManagement2 = _interopRequireDefault(_priceManagement);
	
	var _company = __webpack_require__(1230);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _contact = __webpack_require__(1249);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _address = __webpack_require__(1299);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _contactPhones = __webpack_require__(1305);
	
	var _contactPhones2 = _interopRequireDefault(_contactPhones);
	
	var _contactEmails = __webpack_require__(1312);
	
	var _contactEmails2 = _interopRequireDefault(_contactEmails);
	
	var _gaugeChart = __webpack_require__(1319);
	
	var _gaugeChart2 = _interopRequireDefault(_gaugeChart);
	
	var _enquiry = __webpack_require__(1327);
	
	var _enquiry2 = _interopRequireDefault(_enquiry);
	
	var _welcomeCentre = __webpack_require__(1422);
	
	var _welcomeCentre2 = _interopRequireDefault(_welcomeCentre);
	
	var _messaging = __webpack_require__(1443);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	var _dashboard = __webpack_require__(1456);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _promise = __webpack_require__(1510);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _reports = __webpack_require__(1529);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _finance = __webpack_require__(1753);
	
	var _finance2 = _interopRequireDefault(_finance);
	
	var _omniSearch = __webpack_require__(1800);
	
	var _omniSearch2 = _interopRequireDefault(_omniSearch);
	
	var _webEnquiries = __webpack_require__(1819);
	
	var _webEnquiries2 = _interopRequireDefault(_webEnquiries);
	
	var _kpiAnalytics = __webpack_require__(1820);
	
	var _kpiAnalytics2 = _interopRequireDefault(_kpiAnalytics);
	
	var _leadMonitor = __webpack_require__(1832);
	
	var _leadMonitor2 = _interopRequireDefault(_leadMonitor);
	
	var _privacyPolicy = __webpack_require__(1852);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	var _accounting = __webpack_require__(1858);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_admin2.default, _login2.default, _user2.default, _unauthorized2.default, _vehicle2.default, _notes2.default, _entityManagement2.default, _accessoryManagement2.default, _priceManagement2.default, _company2.default, _address2.default, _contactPhones2.default, _contactEmails2.default, _contact2.default, _enquiry2.default, _welcomeCentre2.default, _messaging2.default, _dashboard2.default, _promise2.default, _reports2.default, _finance2.default, _omniSearch2.default, _gaugeChart2.default, _kpiAnalytics2.default, _leadMonitor2.default, _privacyPolicy2.default, _accounting2.default]).service('webEnquiriesService', _webEnquiries2.default).name;
	
	exports.default = componentModule;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _admin = __webpack_require__(681);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _entity = __webpack_require__(686);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _list = __webpack_require__(692);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _enquiryExtraManagement = __webpack_require__(762);
	
	var _enquiryExtraManagement2 = _interopRequireDefault(_enquiryExtraManagement);
	
	var _financialProductManagement = __webpack_require__(797);
	
	var _financialProductManagement2 = _interopRequireDefault(_financialProductManagement);
	
	var _enquirySourceManagement = __webpack_require__(810);
	
	var _enquirySourceManagement2 = _interopRequireDefault(_enquirySourceManagement);
	
	var _retailPriceList = __webpack_require__(823);
	
	var _retailPriceList2 = _interopRequireDefault(_retailPriceList);
	
	var _vehicleTradersManagement = __webpack_require__(842);
	
	var _vehicleTradersManagement2 = _interopRequireDefault(_vehicleTradersManagement);
	
	var _financeCompaniesManagement = __webpack_require__(856);
	
	var _financeCompaniesManagement2 = _interopRequireDefault(_financeCompaniesManagement);
	
	var _deliveryPriceManagement = __webpack_require__(870);
	
	var _deliveryPriceManagement2 = _interopRequireDefault(_deliveryPriceManagement);
	
	var _defaultTextManagement = __webpack_require__(887);
	
	var _defaultTextManagement2 = _interopRequireDefault(_defaultTextManagement);
	
	var _brandModelManagement = __webpack_require__(899);
	
	var _brandModelManagement2 = _interopRequireDefault(_brandModelManagement);
	
	var _failedWebEnquiries = __webpack_require__(906);
	
	var _failedWebEnquiries2 = _interopRequireDefault(_failedWebEnquiries);
	
	var _autoPromiseManagement = __webpack_require__(946);
	
	var _autoPromiseManagement2 = _interopRequireDefault(_autoPromiseManagement);
	
	var _monthlyDistributionManagement = __webpack_require__(960);
	
	var _monthlyDistributionManagement2 = _interopRequireDefault(_monthlyDistributionManagement);
	
	var _userTargetsManagement = __webpack_require__(972);
	
	var _userTargetsManagement2 = _interopRequireDefault(_userTargetsManagement);
	
	var _entityPreferences = __webpack_require__(984);
	
	var _entityPreferences2 = _interopRequireDefault(_entityPreferences);
	
	var _reportsAccess = __webpack_require__(990);
	
	var _reportsAccess2 = _interopRequireDefault(_reportsAccess);
	
	var _dataUtility = __webpack_require__(996);
	
	var _dataUtility2 = _interopRequireDefault(_dataUtility);
	
	var _scheduledReportsManagement = __webpack_require__(1002);
	
	var _scheduledReportsManagement2 = _interopRequireDefault(_scheduledReportsManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminModule = _angular2.default.module('admin', [_angularUiRouter2.default, _entity2.default, _enquiryExtraManagement2.default, _financialProductManagement2.default, _enquirySourceManagement2.default, _retailPriceList2.default, _vehicleTradersManagement2.default, _financeCompaniesManagement2.default, _deliveryPriceManagement2.default, _defaultTextManagement2.default, _brandModelManagement2.default, _failedWebEnquiries2.default, _autoPromiseManagement2.default, _monthlyDistributionManagement2.default, _userTargetsManagement2.default, _entityPreferences2.default, _reportsAccess2.default, _dataUtility2.default, _scheduledReportsManagement2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    component: 'admin'
	  });
	
	  $stateProvider.state('admin.listEntities', {
	    url: '/listEntities',
	    component: 'list'
	  });
	}]).component('admin', _admin2.default).name;
	
	exports.default = adminModule;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _admin = __webpack_require__(682);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(683);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	__webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _admin2.default,
	  controller: _admin4.default
	};
	
	exports.default = adminComponent;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div ui-view></div>\r\n</div>\r\n"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminController = function AdminController(authService, enums) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, AdminController);
	  this.authService = authService;
	  this.enums = enums;
	
	  if (!authService.validateUser(true)) {
	    return;
	  }
	};
	AdminController.$inject = ["authService", "enums"];
	
	exports.default = AdminController;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admin.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admin.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _entity = __webpack_require__(687);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _list = __webpack_require__(692);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _edit = __webpack_require__(732);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _entity3 = __webpack_require__(761);
	
	var _entity4 = _interopRequireDefault(_entity3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityModule = _angular2.default.module('entity', [_angularUiRouter2.default, _list2.default, _edit2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('admin.entity', {
	    url: '/entity',
	    component: 'entity'
	  });
	}]).service('entityService', _entity4.default).component('entity', _entity2.default).name;
	
	exports.default = entityModule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entity = __webpack_require__(688);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _entity3 = __webpack_require__(689);
	
	var _entity4 = _interopRequireDefault(_entity3);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _entity2.default,
	  controller: _entity4.default
	};
	
	exports.default = entityComponent;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>\r\n"

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityController = function EntityController() {
	  (0, _classCallCheck3.default)(this, EntityController);
	
	  this.name = 'entity';
	};
	
	exports.default = EntityController;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entity.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entity.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".entity{color:red}", ""]);
	
	// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _list = __webpack_require__(693);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _listCompany = __webpack_require__(698);
	
	var _listCompany2 = _interopRequireDefault(_listCompany);
	
	var _listDealers = __webpack_require__(704);
	
	var _listDealers2 = _interopRequireDefault(_listDealers);
	
	var _listLocations = __webpack_require__(710);
	
	var _listLocations2 = _interopRequireDefault(_listLocations);
	
	var _pagination = __webpack_require__(716);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _dropdown = __webpack_require__(723);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listModule = _angular2.default.module('list', [_angularUiRouter2.default, _listCompany2.default, _listDealers2.default, _listLocations2.default, _pagination2.default, _dropdown2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('admin.entity.listCompanies', {
	    url: '/:entityType/list',
	    component: 'list'
	  });
	
	  $stateProvider.state('admin.entity.listChildren', {
	    url: '/:entityType/:entityId/list',
	    component: 'list'
	  });
	}]).component('list', _list2.default).name;
	
	exports.default = listModule;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _list = __webpack_require__(694);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _list3 = __webpack_require__(695);
	
	var _list4 = _interopRequireDefault(_list3);
	
	__webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _list2.default,
	  controller: _list4.default
	};
	
	exports.default = listComponent;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"entityListing\">\r\n  <div class=\"panel\">\r\n\r\n      <header>\r\n          <h2>Entities List</h2>\r\n\r\n        <a class=\"btn btn-success\"\r\n          ui-sref=\"admin.entity.add({entityType: 1})\"\r\n          ng-show=\"$ctrl.authService.checkFeatureAccess('Entity', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New Company\r\n        </a>\r\n    </header>\r\n\r\n      <section class=\"search\">\r\n\r\n        <span class=\"col-md-2 nopadding\">\r\n          <input class=\"form-control col-md-2\" ng-model=\"$ctrl.filterParams.name\" placeholder=\"Filter By Entity Name\">\r\n        </span>\r\n\r\n        <span class=\"col-md-2 nopadding\">\r\n          <select class=\"form-control\" ng-model=\"$ctrl.filterParams.entityType\">\r\n            <option value=\"0\">-- Entity Type --</option>\r\n            <option value=\"1\">Company</option>\r\n            <option value=\"2\">Dealer</option>\r\n            <option value=\"3\">Location</option>\r\n          </select>\r\n        </span>\r\n\r\n        <span class=\"col-md-2 nopadding\">\r\n          <select class=\"form-control\" ng-model=\"$ctrl.filterParams.state\">\r\n            <option value=\"0\">-- State --</option>\r\n            <option value=\"1\">Active</option>\r\n            <option value=\"2\">Suspended</option>\r\n          </select>\r\n        </span>\r\n\r\n        <span class=\"col-md-2 nopadding\">\r\n          <select class=\"form-control\" ng-model=\"$ctrl.filterParams.brandType\">\r\n            <option value=\"0\">-- Brand Type --</option>\r\n            <option value=\"1\">Cars Now</option>\r\n            <option value=\"2\">Lead Manager</option>\r\n          </select>\r\n        </span>        \r\n\r\n        <span class=\"col-md-2 nopadding\">\r\n          <button ng-click=\"$ctrl.listEntities()\" class=\"btn btn-primary\">\r\n            <i class=\"glyphicon glyphicon-search\"></i>\r\n            Search\r\n          </button>\r\n        </span>\r\n\r\n        <span class=\"col-md-2 nopadding pull-right\">\r\n          <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n            <i class=\"fa fa-eraser\"></i>\r\n            Clear Filters\r\n          </button>\r\n        </span>\r\n\r\n      </section>\r\n\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                  <th class=\"col-md-2\" class=\"btn\"><a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('entityType')\">Entity Type <i class=\"fa fa-fw fa-sort\"></i></a></th>\r\n                  <th class=\"col-md-3\"><a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('name')\">Name <i class=\"fa fa-fw fa-sort\"></i></a></th>\r\n                  <th class=\"col-md-3\"><a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('parent')\">Parent <i class=\"fa fa-fw fa-sort\"></i></a></th>\r\n                  <th class=\"col-md-3\">Website</th>\r\n                  <th class=\"col-md-2\" class=\"btn\">State</th>\r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"e in $ctrl.entities\">\r\n                  <td class=\"col-md-2\">\r\n                      {{ e.entityTypeName }}\r\n                  </td>\r\n                  <td class=\"col-md-2\">\r\n                      {{ e.name }}\r\n                  </td>\r\n                  <td class=\"col-md-2\">\r\n                      {{ e.parentName }}\r\n                  </td>\r\n                  <td class=\"col-md-2\">\r\n                      <a href=\"{{ e.website }}\" target=\"_blank\">{{e.website}}</a>\r\n                  </td>\r\n                  <td class=\"col-md-1\">\r\n                      {{ e.state === 1 ? 'Active' : 'Suspended' }}\r\n                  </td>\r\n                  <td class=\"col-md-1\">\r\n                    <!-- Single button using append-to-body -->\r\n                    <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                      <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                        Actions <span class=\"caret\"></span>\r\n                      </button>\r\n                      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                        <li role=\"menuitem\" ng-repeat=\"action in e.actions\">\r\n                          <a ui-sref={{action.sref}}>{{action.text}}</a>\r\n                        </li>\r\n                        <li class=\"divider\" ng-if=\"$ctrl.authService.checkFeatureAccess('Entity', $ctrl.enums.PERMISSION_TYPE.Delete, false)\"></li>\r\n                        <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Entity', $ctrl.enums.PERMISSION_TYPE.Delete, false) && e.state === 1\">\r\n                          <a href=\"#\" ng-click=\"$ctrl.suspendEntity(e.entityId)\">Suspend</a>\r\n                        </li>\r\n                        <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Entity', $ctrl.enums.PERMISSION_TYPE.Delete, false) && e.state === 2\">\r\n                          <a href=\"#\" ng-click=\"$ctrl.resumeEntity(e.entityId)\">Resume</a>\r\n                        </li>\r\n                        <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Entity', $ctrl.enums.PERMISSION_TYPE.Delete, false)\">\r\n                          <a href=\"#\" ng-click=\"$ctrl.deleteEntity(e.entityId)\">Delete</a>\r\n                        </li>\r\n                      </ul>\r\n                    </div>\r\n                  </td>\r\n              </tr>\r\n          </tbody>\r\n      </table>\r\n\r\n      <footer>\r\n        <div class=\"row\" >\r\n          <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.entities.length\">\r\n            <ul uib-pagination\r\n              total-items=\"$ctrl.pagination.totalItems\"\r\n              items-per-page=\"$ctrl.pagination.pageSize\"\r\n              ng-model=\"$ctrl.pagination.currentPage\"\r\n              ng-change=\"$ctrl.listEntities()\"\r\n            ></ul>\r\n          </div>\r\n\r\n          <span class=\"col-md-4 pull-right\">\r\n            <span class=\"pull-right\">\r\n              {{$ctrl.notification.msg}}\r\n            </span>\r\n          </span>\r\n        </div>\r\n      </footer>\r\n\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListController = function () {
	  ListController.$inject = ["entityService", "$timeout", "loadingService", "$window", "authService", "enums"];
	  function ListController(entityService, $timeout, loadingService, $window, authService, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ListController);
	    this.entityService = entityService;
	    this.$timeout = $timeout;
	    this.loadingService = loadingService;
	    this.$window = $window;
	    this.authService = authService;
	    this.enums = enums;
	
	    this.reset();
	  }
	
	  (0, _createClass3.default)(ListController, [{
	    key: 'reset',
	    value: function reset() {
	      this.filterParams = {
	        entityType: '0',
	        state: '0',
	        brandType: '0',
	        sortExpression: 'entityType',
	        ascending: true
	      };
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listEntities();
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.sortExpression === fieldName) {
	        this.filterParams.ascending = !this.filterParams.ascending;
	      } else {
	        this.filterParams.sortExpression = fieldName;
	        this.filterParams.ascending = true;
	      }
	
	      this.listEntities();
	    }
	  }, {
	    key: 'listEntities',
	    value: function listEntities() {
	      var _this = this;
	
	      var listCtrl = this;
	      var pageIndex = this.getPageIndex();
	
	      this.loadingService.showLoading('entityListing', 'Loading Entities ...');
	
	      listCtrl.entityService.listEntities(listCtrl.filterParams, pageIndex, listCtrl.pagination.pageSize).then(function (response) {
	        response.data.items.map(function (entity) {
	          return listCtrl.getActionsDropdown(entity);
	        });
	        listCtrl.entities = response.data.items;
	        listCtrl.pagination.totalItems = response.data.totalRecords;
	
	        if (listCtrl.pagination.totalItems === 0) {
	          listCtrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = pageIndex + listCtrl.pagination.pageSize < response.data.totalRecords ? pageIndex + listCtrl.pagination.pageSize : response.data.totalRecords;
	
	          listCtrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (pageIndex + 1) + ' to ' + pageEnd + ' out of ' + listCtrl.pagination.totalItems + ' records'
	          };
	        }
	      }).catch(function (err) {
	        listCtrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching entities." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        _this.loadingService.hideLoading('entityListing');
	      });
	    }
	  }, {
	    key: 'getPageIndex',
	    value: function getPageIndex() {
	      if (this.pagination.currentPage === 1) {
	        return 0;
	      } else {
	        return (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'getActionsDropdown',
	    value: function getActionsDropdown(entity) {
	      var actions = [];
	      var entityType = entity.entityType,
	          entityId = entity.entityId,
	          name = entity.name,
	          state = entity.state;
	
	
	      switch (entityType) {
	        case 1:
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
	            actions.push({ text: 'Edit Company', sref: 'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})' });
	          }
	
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
	            actions.push({ text: 'Add Child Company', sref: 'admin.entity.add({entityType: 1 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})' });
	          }
	
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
	            actions.push({ text: 'Add Dealer', sref: 'admin.entity.add({entityType: 2 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})' });
	          }
	          break;
	
	        case 2:
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
	            actions.push({ text: 'Edit Dealer', sref: 'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})' });
	          }
	
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Add, false)) {
	            actions.push({ text: 'Add Location', sref: 'admin.entity.add({entityType: 3 , parent: {entityId: ' + entityId + ', entityName: "' + name + '"}})' });
	          }
	          break;
	
	        case 3:
	          if (this.authService.checkFeatureAccess('Entity', this.enums.PERMISSION_TYPE.Edit, false)) {
	            actions.push({ text: 'Edit Location', sref: 'admin.entity.edit({entityType: ' + entityType + ', entityId: ' + entityId + '})' });
	          }
	          break;
	      }
	
	      entity.actions = actions;
	    }
	  }, {
	    key: 'deleteEntity',
	    value: function deleteEntity(entityId) {
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Deleting an Entity will delete the Entity and all its child entities. Are you sure you want to delete this entity ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('entityListing', 'Removing Entity ...');
	
	      this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Deleted);
	    }
	  }, {
	    key: 'suspendEntity',
	    value: function suspendEntity(entityId) {
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Suspending an Entity will suspend this Entity and all its child entities. Are you sure you want to suspend this entity ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('entityListing', 'Suspending Entity ...');
	
	      this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Inactive);
	    }
	  }, {
	    key: 'resumeEntity',
	    value: function resumeEntity(entityId) {
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to resume this entity ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('entityListing', 'Resuming Entity ...');
	
	      this.updateEntityState(entityId, this.enums.OBJECT_ROW_STATE.Active);
	    }
	  }, {
	    key: 'updateEntityState',
	    value: function updateEntityState(entityId, state) {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      ctrl.entityService.updateEntityState(entityId, state).then(function (response) {
	        ctrl.listEntities();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this2.loadingService.hideLoading('entityListing');
	      });
	    }
	  }]);
	  return ListController;
	}();
	
	exports.default = ListController;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(697);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./list.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./list.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".list{color:red}", ""]);
	
	// exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _listCompany = __webpack_require__(699);
	
	var _listCompany2 = _interopRequireDefault(_listCompany);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listCompanyModule = _angular2.default.module('listCompany', [_angularUiRouter2.default]).component('listCompany', _listCompany2.default).name;
	
	exports.default = listCompanyModule;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listCompany = __webpack_require__(700);
	
	var _listCompany2 = _interopRequireDefault(_listCompany);
	
	var _listCompany3 = __webpack_require__(701);
	
	var _listCompany4 = _interopRequireDefault(_listCompany3);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listCompanyComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _listCompany2.default,
	  controller: _listCompany4.default
	};
	
	exports.default = listCompanyComponent;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<h3>List of all Companies</h3>\r\n<div block-ui=\"companyList\">\r\n  <table class=\"table table-striped table-bordered table-hover\">\r\n      <thead>\r\n          <tr>\r\n              <th>Name</th>\r\n              <th>Parent</th>\r\n              <th>Contact Person</th>\r\n              <th>Website</th>\r\n              <th>Dealers</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"c in $ctrl.companies\">\r\n              <td>\r\n                  <a ui-sref=\"admin.entity.edit({entityType: c.entityType, entityId: c.entityId})\">{{ c.name }}</a>\r\n              </td>\r\n              <td>\r\n                  {{ c.parentName }}\r\n              </td>\r\n              <td>\r\n                  {{ c.contactPersonName }}\r\n              </td>\r\n              <td>\r\n                  <a href=\"{{ c.website }}\">{{c.website}}</a>\r\n              </td>\r\n              <td>\r\n                  <a ui-sref=\"admin.entity.listChildren({entityType: 2, entityId: c.entityId})\">{{ c.dealers }}</a>\r\n              </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n</div>\r\n"

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListCompanyController = function () {
	  ListCompanyController.$inject = ["entityService", "loadingService"];
	  function ListCompanyController(entityService, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ListCompanyController);
	    this._entityService = entityService;
	    this.loadingService = loadingService;
	
	    this.companies = [];
	
	    this.listCompanies();
	  }
	
	  (0, _createClass3.default)(ListCompanyController, [{
	    key: 'listCompanies',
	    value: function listCompanies(entityType) {
	      var listCompanyCtrl = this;
	
	      listCompanyCtrl.loadingService.showLoading('companyList', 'Loading Entities ...');
	
	      this._entityService.listEntities(1).then(function (response) {
	        listCompanyCtrl.companies = response.data.data;
	      }).finally(function () {
	        listCompanyCtrl.loadingService.hideLoading('companyList');
	      });
	    }
	  }]);
	  return ListCompanyController;
	}();
	
	exports.default = ListCompanyController;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(703);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listCompany.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listCompany.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".listCompany{color:red}", ""]);
	
	// exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _listDealers = __webpack_require__(705);
	
	var _listDealers2 = _interopRequireDefault(_listDealers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listDealersModule = _angular2.default.module('listDealers', [_angularUiRouter2.default]).component('listDealers', _listDealers2.default).name;
	
	exports.default = listDealersModule;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listDealers = __webpack_require__(706);
	
	var _listDealers2 = _interopRequireDefault(_listDealers);
	
	var _listDealers3 = __webpack_require__(707);
	
	var _listDealers4 = _interopRequireDefault(_listDealers3);
	
	__webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listDealersComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _listDealers2.default,
	  controller: _listDealers4.default
	};
	
	exports.default = listDealersComponent;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<h3>List of all Dealers under <b>{{$ctrl.parent.name}}</b></h3>\r\n\r\n<div class=\"panel panel-default\">\r\n  <div class=\"panel-body\">\r\n    <a ui-sref=\"admin.entity.add({entityType: 2 , parent: {entityId: $ctrl.parent.id, entityName: $ctrl.parent.name}})\" class=\"btn btn-primary\">Add Dealer</a>\r\n  </div>\r\n</div>\r\n\r\n<div block-ui=\"dealerList\">\r\n  <table class=\"table table-striped table-bordered table-hover\">\r\n      <thead>\r\n          <tr>\r\n              <th>Name</th>\r\n              <th>Contact Person</th>\r\n              <th>Website</th>\r\n              <th>Max Locations</th>\r\n              <th>Max Users</th>\r\n              <th>Locations</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"d in $ctrl.dealers\">\r\n              <td>\r\n                  <a ui-sref=\"admin.entity.edit({entityType: d.entityType, entityId: d.entityId})\">{{ d.name }}</a>\r\n              </td>\r\n              <td>\r\n                  {{ d.contactPersonName }}\r\n              </td>\r\n              <td>\r\n                  <a href=\"{{ d.website }}\">{{d.website}}</a>\r\n              </td>\r\n              <td>\r\n                  {{ d.maxLocations }}\r\n              </td>\r\n              <td>\r\n                  {{ d.maxUsersPerLocation }}\r\n              </td>\r\n              <td>\r\n                  <a ui-sref=\"admin.entity.listChildren({entityType: 3, entityId: d.entityId})\">{{ d.locations }}</a>\r\n              </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n</div>\r\n"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDealersController = function () {
	  ListDealersController.$inject = ["$stateParams", "entityService", "loadingService"];
	  function ListDealersController($stateParams, entityService, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ListDealersController);
	    this._$stateParams = $stateParams;
	    this._entityService = entityService;
	    this.loadingService = loadingService;
	
	    this.parent = {};
	    this.dealers = [];
	
	    this.listDealers($stateParams.entityId);
	  }
	
	  (0, _createClass3.default)(ListDealersController, [{
	    key: 'listDealers',
	    value: function listDealers(companyId) {
	      var listDealersCtrl = this;
	
	      listDealersCtrl.loadingService.showLoading('dealerList', 'Loading Entities ...');
	
	      this._entityService.listEntities(2, companyId).then(function (response) {
	        listDealersCtrl.parent = {
	          id: response.data.parentId,
	          name: response.data.parentName
	        };
	
	        listDealersCtrl.dealers = response.data.data;
	      }).finally(function () {
	        listDealersCtrl.loadingService.hideLoading('dealerList');
	      });
	    }
	  }]);
	  return ListDealersController;
	}();
	
	exports.default = ListDealersController;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(709);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listDealers.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listDealers.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".listDealers{color:red}", ""]);
	
	// exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _listLocations = __webpack_require__(711);
	
	var _listLocations2 = _interopRequireDefault(_listLocations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listLocationsModule = _angular2.default.module('listLocations', [_angularUiRouter2.default]).component('listLocations', _listLocations2.default).name;
	
	exports.default = listLocationsModule;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _listLocations = __webpack_require__(712);
	
	var _listLocations2 = _interopRequireDefault(_listLocations);
	
	var _listLocations3 = __webpack_require__(713);
	
	var _listLocations4 = _interopRequireDefault(_listLocations3);
	
	__webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listLocationsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _listLocations2.default,
	  controller: _listLocations4.default
	};
	
	exports.default = listLocationsComponent;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<h3>List of all Locations under <b>{{$ctrl.parent.name}}</b></h3>\r\n\r\n<div class=\"panel panel-default\">\r\n  <div class=\"panel-body\">\r\n    <a ui-sref=\"admin.entity.add({entityType: 3 , parent: {entityId: $ctrl.parent.id, entityName: $ctrl.parent.name}})\" class=\"btn btn-primary\">Add Location</a>\r\n  </div>\r\n</div>\r\n\r\n<div block-ui=\"locationList\">\r\n  <table class=\"table table-striped table-bordered table-hover\">\r\n      <thead>\r\n          <tr>\r\n              <th>Name</th>\r\n              <th>Contact Person</th>\r\n              <th>Website</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"l in $ctrl.locations\">\r\n              <td>\r\n                  <a ui-sref=\"admin.entity.edit({entityType: l.entityType, entityId: l.entityId})\">{{ l.name }}</a>\r\n              </td>\r\n              <td>\r\n                  {{ l.contactPersonName }}\r\n              </td>\r\n              <td>\r\n                  <a href=\"{{ l.website }}\">{{l.website}}</a>\r\n              </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n</div>\r\n"

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListLocationsController = function () {
	  ListLocationsController.$inject = ["$stateParams", "entityService", "loadingService"];
	  function ListLocationsController($stateParams, entityService, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ListLocationsController);
	    this._$stateParams = $stateParams;
	    this._entityService = entityService;
	    this.loadingService = loadingService;
	
	    this.parent = {};
	    this.locations = [];
	
	    this.listLocations($stateParams.entityId);
	  }
	
	  (0, _createClass3.default)(ListLocationsController, [{
	    key: 'listLocations',
	    value: function listLocations(dealerId) {
	      var listLocationsCtrl = this;
	
	      listLocationsCtrl.loadingService.showLoading('locationList', 'Loading Entities ...');
	
	      this._entityService.listEntities(3, dealerId).then(function (response) {
	        listLocationsCtrl.parent = {
	          id: response.data.parentId,
	          name: response.data.parentName
	        };
	
	        listLocationsCtrl.locations = response.data.data;
	      }).finally(function () {
	        listLocationsCtrl.loadingService.hideLoading('locationList');
	      });
	    }
	  }]);
	  return ListLocationsController;
	}();
	
	exports.default = ListLocationsController;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(715);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listLocations.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./listLocations.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".listLocations{color:red}", ""]);
	
	// exports


/***/ }),
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _edit = __webpack_require__(733);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _entityUser = __webpack_require__(741);
	
	var _entityUser2 = _interopRequireDefault(_entityUser);
	
	var _accordion = __webpack_require__(749);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _modal = __webpack_require__(755);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editModule = _angular2.default.module('edit', [_angularUiRouter2.default, _entityUser2.default, _accordion2.default, _modal2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('admin.entity.add', {
	    url: '/:entityType/edit',
	    component: 'edit',
	    params: {
	      parent: {
	        entityId: 0,
	        entityName: ''
	      }
	    }
	  }).state('admin.entity.edit', {
	    url: '/:entityType/edit/:entityId',
	    component: 'edit',
	    params: {
	      parent: {
	        entityId: 0,
	        entityName: ''
	      }
	    }
	  });
	}]).component('edit', _edit2.default).name;
	
	exports.default = editModule;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _edit = __webpack_require__(734);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _edit3 = __webpack_require__(735);
	
	var _edit4 = _interopRequireDefault(_edit3);
	
	__webpack_require__(739);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editComponent = {
	  restrict: 'E',
	  bindings: {
	    entityManagement: '<'
	  },
	  template: _edit2.default,
	  controller: _edit4.default
	};
	
	exports.default = editComponent;

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"editEntity\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>{{$ctrl.pageTitle}}</h2>\r\n\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.addEntity()\">\r\n          <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n          <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i> {{ $ctrl.state !== 'Saving' ? 'Save Changes'\r\n          : 'Saving Changes ...' }}\r\n        </a>\r\n\r\n        <a class=\"btn btn-warning\" ng-hide=\"$ctrl.params.isEntityManagement\" ng-click=\"$ctrl.redirectToParent()\">\r\n          <span class=\"glyphicon glyphicon-remove\"></span> Cancel\r\n        </a>\r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n\r\n\r\n    <div class=\"alert alert-success\" ng-show=\"$ctrl.state === 'Saved'\">\r\n      Updated successfully\r\n    </div>\r\n    <!-- end alerts -->\r\n    <div class=\"col-md-6\">\r\n      <div class=\"panel\">\r\n\r\n        <header>\r\n\r\n          <h2>Entity Details</h2>\r\n\r\n\r\n        </header>\r\n\r\n        <div class=\"form-horizontal\">\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Parent</label>\r\n            <div class=\"col-sm-9\">\r\n              <div class=\"input-group\">\r\n                <div angucomplete-alt id=\"searchCompanies\" placeholder=\"Search Companies by name\" pause1=\"1000\" selected-object=\"$ctrl.entity.parent\"\r\n                  remote-url=\"{{$ctrl.searchEntityUrl}}\" title-field=\"entityName\" minlength=\"2\" match-class=\"autocomplete-highlight\"\r\n                  input-class=\"form-control form-control-small\" initial-value=\"$ctrl.entity.parent.name\" disable-input=\"$ctrl.searchParentDisabled\"\r\n                  match-class=\"highlight\">\r\n                </div>\r\n                <a class=\"input-group-addon btn btn-primary btn-small\" ng-click=\"$ctrl.clearParent()\" ng-class=\"{'disabled' : $ctrl.searchParentDisabled}\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.name }\">\r\n            <label class=\"control-label col-sm-3\">Trading Name *</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.name\" placeholder=\"Entere name here\" maxLength=50>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Legal Name</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.legalName\" placeholder=\"Enter legal name here\" maxLength=50>\r\n            </div>\r\n          </div>          \r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.website }\">\r\n            <label class=\"control-label col-sm-3\">Website</label>\r\n            <div class=\"col-sm-9\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.website\" placeholder=\"Enter the url\" maxLength=100>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Website Name</label>\r\n              <div class=\"col-sm-9\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.websiteName\" placeholder=\"Website Name\" maxLength=150>\r\n              </div>\r\n            </div>          \r\n\r\n          <!-- Dealer Specific Section -->\r\n          <div ng-show=\"$ctrl.entity.entityType.toString() === '2'\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Max Locations</label>\r\n              <div class=\"col-sm-9\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.maxLocations\" placeholder=\"Enter max locations for this dealer\">\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Max Users</label>\r\n              <div class=\"col-sm-9\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.maxUsers\" placeholder=\"Enter max allowed users under this dealer\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Location Specific Section -->\r\n          <div class=\"form-group\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n            <label class=\"control-label col-sm-3\">Is Lead Manager</label>\r\n            <div class=\"col-sm-9\">\r\n                <span class=\"checkbox no-margin\">\r\n                    <switch ng-model=\"$ctrl.entity.isLeadManager\"></switch>\r\n                </span>\r\n            </div>\r\n        </div> \r\n                  \r\n          <div ng-show=\"$ctrl.entity.entityType.toString() === '3'\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Auto Sold</label>\r\n              <div class=\"col-sm-9\">\r\n\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                      <input type=\"checkbox\" data-toggle=\"toggle\" ng-model=\"$ctrl.autoSold.retail\" ng-change=\"$ctrl.updateAutoSold(1, 'retail')\" /> Retail\r\n                  </label>\r\n                </div>\r\n                <div class=\"checkbox\">\r\n                  <label><input type=\"checkbox\" ng-model=\"$ctrl.autoSold.trade\" ng-change=\"$ctrl.updateAutoSold(2, 'trade')\">Trade</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Appraisal Expiry</label>\r\n              <div class=\"col-sm-9\">\r\n                <select class=\"form-control\" ng-model=\"$ctrl.entity.appraisalExpiry\" ng-options=\"selectedItem*1 as (selectedItem + ' Days') for selectedItem in [0,5,10,15,20,25,30,60,90]\"></select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Enquiry Hold Time</label>\r\n              <div class=\"col-sm-9\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.enquiryHoldTime\" placeholder=\"Enter the maximum amount of time(in minutes) an enquiry can be held, default is 5 minutes if left blank\">\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Logo</label>\r\n              <div class=\"col-sm-9\">\r\n                <div upload-button class=\"btn-upload\" url=\"{{$ctrl.uploadUrl}}\" on-success=\"$ctrl.onImageUploaded(response)\" multiple=\"false\">\r\n                  <img ng-src='{{$ctrl.entity.imageUrl}}' class=\"location-logo\" />\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Initials</label>\r\n              <div class=\"col-sm-9\">\r\n                <input class=\"form-control uppercase\" ng-model=\"$ctrl.entity.initials\" placeholder=\"Will appear in Order Forms and other places\" maxlength=\"3\">\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Simi Member</label>\r\n                <div class=\"col-sm-9\">\r\n                    <span class=\"checkbox no-margin\">\r\n                        <input type=\"checkbox\" ng-model=\"$ctrl.entity.isSimiMember\" />\r\n                    </span>\r\n                </div>\r\n            </div>            \r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Privacy Statement Link</label>\r\n              <div class=\"col-sm-9\">\r\n                  <span class=\"checkbox no-margin\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.privacyStatementUrl\" placeholder=\"Privacy Statement Link\">\r\n                  </span>\r\n              </div>\r\n            </div>                        \r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Privacy Statement Notes</label>\r\n              <div class=\"col-sm-9\">\r\n                  <span class=\"checkbox no-margin\">\r\n                    <textarea type=\"text\" rows=\"6\" class=\"form-control\" ng-model=\"$ctrl.entity.privacyNotes\" placeholder=\"Privacy Statement Notes\"></textarea>\r\n                  </span>\r\n              </div>\r\n            </div>  \r\n            \r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Quotation Validity</label>\r\n              <div class=\"col-sm-9\">\r\n                  <span class=\"checkbox no-margin\">\r\n                    <select class=\"form-control\" ng-model=\"$ctrl.entity.quotationValidity\" ng-options=\"selectedItem as selectedItem for selectedItem in [2, 5, 7, 14, 21, 28]\"></select>\r\n                  </span>\r\n              </div>\r\n            </div>    \r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Finance Quotation Validity</label>\r\n              <div class=\"col-sm-9\">\r\n                  <span class=\"checkbox no-margin\">\r\n                    <select class=\"form-control\" ng-model=\"$ctrl.entity.financeQuotationValidity\" ng-options=\"selectedItem as selectedItem for selectedItem in [7, 14, 21, 28]\"></select>\r\n                  </span>\r\n              </div>\r\n            </div>  \r\n\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Format Extras in Quotation</label>\r\n                <div class=\"col-sm-9\">\r\n                    <span class=\"checkbox no-margin\">\r\n                        <input type=\"checkbox\" ng-model=\"$ctrl.entity.formattedExtras\" />\r\n                    </span>\r\n                </div>\r\n            </div> \r\n            \r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Marketing DPA Optional</label>\r\n                <div class=\"col-sm-9\">\r\n                    <span class=\"checkbox no-margin\">\r\n                        <input type=\"checkbox\" ng-model=\"$ctrl.entity.basicDpaOptional\" />\r\n                    </span>\r\n                </div>\r\n            </div>             \r\n\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Full DPA Optional</label>\r\n                <div class=\"col-sm-9\">\r\n                    <span class=\"checkbox no-margin\">\r\n                        <input type=\"checkbox\" ng-model=\"$ctrl.entity.allDpaOptional\" />\r\n                    </span>\r\n                </div>\r\n            </div>     \r\n            \r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\">Marketing Source Required</label>\r\n              <div class=\"col-sm-9\">            \r\n                  <switch ng-model=\"$ctrl.entity.marketingSourceRequired\" ng-change=\"$ctrl.updateMeta($ctrl.enums.ENTITY_META_TYPE.MarketingSourceRequired, $ctrl.entity.marketingSourceRequired)\"></switch>\r\n              </div>\r\n            </div>              \r\n            \r\n            <div class=\"form-group\" ng-hide=\"true\">\r\n              <label class=\"control-label col-sm-3\">Disable Auto Notify Email Customer</label>\r\n              <div class=\"col-sm-9\">\r\n                  <span class=\"checkbox no-margin\">\r\n                      <input type=\"checkbox\" ng-model=\"$ctrl.entity.disableAutoEmailCustomer\" />\r\n                  </span>\r\n              </div>\r\n          </div> \r\n          \r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"panel\">\r\n        <header>\r\n          <h2>Social Links</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Facebook</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.facebookUrl\" placeholder=\"Facebook Link\" maxlength=\"250\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Twitter</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.twitterUrl\" placeholder=\"Twitter Link\" maxlength=\"250\">\r\n            </div>\r\n          </div>          \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Instagram</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.instaUrl\" placeholder=\"Instagram Link\" maxlength=\"250\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Youtube</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.youtubeUrl\" placeholder=\"Youtube Link\" maxlength=\"250\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">TikTok</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.tikTokUrl\" placeholder=\"TikTok Link\" maxlength=\"250\">\r\n            </div>\r\n          </div>          \r\n\r\n        </div>\r\n\r\n\r\n      <div class=\"panel\">\r\n        <header>\r\n          <h2>Contact Person</h2>\r\n        </header>\r\n\r\n        <div class=\"form-horizontal\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Salutation&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <select id=\"cpSalutation\" class=\"form-control\" ng-model=\"$ctrl.entity.contactPerson.title\">\r\n                  <option value=\"1\">Mr</option>\r\n                  <option value=\"2\">Ms</option>\r\n                  <option value=\"3\">Mrs</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.firstName }\">\r\n            <label class=\"control-label col-sm-3\">First Name *</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.contactPerson.firstName\" placeholder=\"First Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.lastName }\">\r\n            <label class=\"control-label col-sm-3\">First Name *</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.contactPerson.lastName\" placeholder=\"Last Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"col-md-6\">\r\n      <div class=\"panel\">\r\n        <header>\r\n\r\n          <h2>Address Details</h2>\r\n\r\n        </header>\r\n\r\n        <div class=\"form-horizontal\">\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.line1 }\">\r\n            <label class=\"control-label col-sm-3\">Line1 *</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.line1\" placeholder=\"Line 1\" maxLength=100>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Line2&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.line2\" placeholder=\"Line 2\" maxLength=100>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Line3&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.line3\" placeholder=\"Line 3\" maxLength=100>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">City&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.city\" placeholder=\"City\" maxLength=20>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Country&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.country\" placeholder=\"Country\" maxLength=10>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Zip&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.address.zip\" placeholder=\"Zip code\" maxLength=10>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-12\">\r\n      &nbsp;\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <div class=\"panel\">\r\n        <header>\r\n          <h2>Contact Phones</h2>\r\n          <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.addContactPhone()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Add Contact Phone\r\n          </a>\r\n        </header>\r\n\r\n        <table class=\"table table-hover\" ng-show=\"$ctrl.entity.contactPhones.length\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"col-md-3\">Phone Type</th>\r\n              <th class=\"col-md-8\">Phone No</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr data-ng-repeat=\"p in $ctrl.entity.contactPhones\">\r\n              <td class=\"col-md-3\">\r\n                {{ $ctrl.phoneTypeToString(p.phoneType) }}\r\n              </td>\r\n              <td class=\"col-md-8\">\r\n                {{ p.phone }}\r\n              </td>\r\n              <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removePhone(p)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n\r\n        <p ng-show=\"!$ctrl.entity.contactPhones.length\">\r\n          Contact Phones List is Empty\r\n        </p>\r\n\r\n      </div>\r\n\r\n      <entity-User entity-users=\"$ctrl.entity.entityUsers\" entity-id=\"$ctrl.entity.entityId\"></entity-User>\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <div class=\"panel\">\r\n        <header>\r\n          <h2>Contact Emails</h2>\r\n          <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.addContactEmail()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Add Contact Email\r\n          </a>\r\n        </header>\r\n\r\n        <table class=\"table table-hover\" ng-show=\"$ctrl.entity.contactEmails.length\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"col-md-5\">Contact Name</th>\r\n              <th class=\"col-md-6\">Email Addresses</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr data-ng-repeat=\"e in $ctrl.entity.contactEmails\">\r\n              <td class=\"col-md-5\">\r\n                {{ e.name }}\r\n              </td>\r\n\r\n              <td class=\"col-md-6\">\r\n                {{ e.email }}\r\n              </td>\r\n              <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEmail(e)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <p ng-show=\"!$ctrl.entity.contactEmails.length\">Contact Emails List is Empty</p>\r\n      </div>\r\n\r\n      <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n        <header>\r\n          <h2>Lookup Provider</h2>\r\n          <span class=\"checkbox no-margin\">\r\n            <input type=\"checkbox\" ng-model=\"$ctrl.entity.lookupProviderEnabled\" />\r\n          </span>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Provider&nbsp;&nbsp;</label>\r\n          <div class=\"col-sm-9\">\r\n            <select class=\"form-control\" ng-model=\"$ctrl.entity.lookupProviderType\" ng-disabled=\"!$ctrl.entity.lookupProviderEnabled\">\r\n              <option value=\"1\">SIMI</option>\r\n          </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.lookupProviderUsername }\">\r\n          <label class=\"control-label col-sm-3\">Api Key&nbsp;&nbsp;</label>\r\n          <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.lookupProviderUsername\" ng-disabled=\"!$ctrl.entity.lookupProviderEnabled\"\r\n              maxlength=\"200\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n          <header>\r\n            <h2>GDPR Maintenance</h2>\r\n            <span class=\"checkbox no-margin\">\r\n              <input type=\"checkbox\" ng-model=\"$ctrl.entity.gdprMaintenance\" />\r\n            </span>\r\n          </header>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Non-Customer Expiry (Days)</label>\r\n            <div class=\"col-sm-9\">\r\n                <span class=\"checkbox no-margin\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.contactExpiry\" placeholder=\"Days\" ng-disabled=\"!$ctrl.entity.gdprMaintenance\">\r\n                </span>\r\n            </div>\r\n          </div>            \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Customer Expiry (Days)</label>\r\n            <div class=\"col-sm-9\">\r\n                <span class=\"checkbox no-margin\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.customerExpiry\" placeholder=\"Days\" ng-disabled=\"!$ctrl.entity.gdprMaintenance\">\r\n                </span>\r\n            </div>\r\n          </div>                      \r\n\r\n          <div class=\"form-group\">            \r\n            <label class=\"control-label col-sm-3\">Expiry Notice (Days)</label>\r\n            <div class=\"col-sm-9\">\r\n                <span class=\"checkbox no-margin\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.entity.contactExpiryNotice\" placeholder=\"Days\" ng-disabled=\"!$ctrl.entity.gdprMaintenance\">\r\n                </span>\r\n            </div>\r\n          </div>   \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Automatic Anonymize</label>\r\n            <div class=\"col-sm-9\">\r\n                <switch ng-model=\"$ctrl.entity.automaticAnonymize\"></switch>\r\n            </div>\r\n          </div>             \r\n\r\n        </div>      \r\n\r\n      <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n        <header>\r\n          <h2>Web Publisher</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Provider&nbsp;&nbsp;</label>\r\n          <div class=\"col-sm-9\">\r\n            <select \r\n              ng-options=\"item.id as item.name for item in $ctrl.webPublisherList\"\r\n              class=\"form-control\" \r\n              ng-model=\"$ctrl.entity.webPublisherType\">\r\n            </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Username&nbsp;&nbsp;</label>\r\n          <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.webPublisherUsername\" maxlength=\"50\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Password&nbsp;&nbsp;</label>\r\n          <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.entity.webPublisherPassword\" maxlength=\"50\">\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n        <header>\r\n          <h2>Web Enquiries</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">WebEnquiry Manager Only View</label>\r\n          <div class=\"col-sm-9\">\r\n              <switch ng-model=\"$ctrl.entity.webEnquiryManagerOnly\"></switch>\r\n          </div>\r\n        </div>          \r\n        \r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Incoming Email</label>\r\n          <div class=\"col-sm-9\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.entity.webEnquiryEmail\" placeholder=\"Incoming Email to Monitor for automatically creating enquiries\" maxlength=\"100\">\r\n          </div>\r\n        </div>              \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Email Pwd</label>\r\n          <div class=\"col-sm-9\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.entity.webEnquiryPassword\" type=\"text\" placeholder=\"Password for Web Enquiry Email\" maxlength=\"30\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">POP3 Server</label>\r\n          <div class=\"col-sm-9\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.entity.webEnquiryServer\" placeholder=\"SMTP Server Address for Web Enquiry Email\" maxlength=\"100\">\r\n          </div>\r\n        </div>        \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Port</label>\r\n          <div class=\"col-sm-9\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.entity.webEnquiryPort\" type=\"number\" placeholder=\"SMTP Server Port for Web Enquiry Email\" maxlength=\"5\">\r\n          </div>\r\n        </div>        \r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Assign Enquiry</label>\r\n            <div class=\"col-sm-9\">\r\n                <label>\r\n                    <input type=\"radio\" ng-model=\"$ctrl.entity.webEnquiryManagerAssign\" ng-value=\"false\">\r\n                    Managers and Sales Reps can Accept\r\n                  </label><br/>\r\n                  <label>\r\n                    <input type=\"radio\" ng-model=\"$ctrl.entity.webEnquiryManagerAssign\" ng-value=\"true\">\r\n                    Only Managers can Asssign\r\n                  </label>\r\n            </div>\r\n        </div>    \r\n        \r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Anonymize Web Leads</label>\r\n          <div class=\"col-sm-9\">\r\n              <switch ng-model=\"$ctrl.entity.anonWebLeads\"></switch>\r\n          </div>\r\n        </div>          \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Follow Up Email</label>\r\n          <div class=\"col-sm-9\">            \r\n              <switch ng-model=\"$ctrl.entity.webLeadFollowUpEmail\" ng-change=\"$ctrl.updateMeta($ctrl.enums.ENTITY_META_TYPE.WebLeadFollowUpEmail, $ctrl.entity.webLeadFollowUpEmail)\"></switch>\r\n          </div>\r\n        </div>  \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Display in Dashboard</label>\r\n          <div class=\"col-sm-9\">\r\n            <select class=\"form-control\" \r\n              ng-model=\"$ctrl.entity.displayInDashboard\" \r\n              ng-options=\"selectedItem as (selectedItem + ' Weeks') for selectedItem in [3, 4, 5, 6]\"\r\n              ng-change=\"$ctrl.updateMeta($ctrl.enums.ENTITY_META_TYPE.DisplayInDashboard, $ctrl.entity.displayInDashboard)\">\r\n            </select>\r\n          </div>       \r\n        </div>          \r\n\r\n      </div>      \r\n\r\n      <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n        <header>\r\n          <h2>Misc</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Enable Lucid Integration</label>\r\n          <div class=\"col-sm-9\">\r\n              <switch ng-model=\"$ctrl.entity.enableLucidIntegration\"></switch>\r\n          </div>\r\n        </div>  \r\n        \r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Wip System Code</label>\r\n          <div class=\"col-sm-9\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.entity.wipSystemCode\" placeholder=\"WIP System Code\" maxlength=\"30\">\r\n          </div>\r\n        </div>          \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-3\">Enquiry Confirmation Complaince Email Template</label>\r\n          <div class=\"col-sm-9\">\r\n            <textarea class=\"form-control\" rows=\"6\" ng-model=\"$ctrl.entity.confirmedEnquiryComplianceTemplate\" ng-change=\"$ctrl.updateMeta($ctrl.enums.ENTITY_META_TYPE.ConfirmedEnquiryComplianceTemplate, $ctrl.entity.confirmedEnquiryComplianceTemplate)\" placeholder=\"Enquiry Confirmation Compliance Email Template\" maxlength=\"3000\"></textarea>            \r\n          </div>\r\n        </div> \r\n\r\n      </div> \r\n      \r\n      <div class=\"panel\">\r\n          <header>\r\n            <h2>Custom Enquiry Forms</h2>\r\n\r\n            <button class=\"btn btn-small btn-default\" ng-click=\"$ctrl.addCustomForm()\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">Add Form</button>\r\n          </header>\r\n  \r\n          <div class=\"form-group\" ng-hide=\"true\">\r\n            <label class=\"control-label col-sm-3\">Demands and Needs Statement</label>\r\n            <div class=\"col-sm-9\">\r\n                <switch ng-model=\"$ctrl.entity.dnsForm\"></switch>\r\n            </div>\r\n          </div>    \r\n          \r\n          <table class=\"table table-striped table-bordered table-hover\">\r\n            <tr>\r\n                <th class=\"col-md-10\">Form</th>\r\n                <th class=\"col-md-2\">Remove</th>\r\n            </tr>\r\n            <tbody>\r\n              <tr ng-repeat=\"cf in $ctrl.entity.customForms\">\r\n                  <td class=\"col-md-10\" ng-if=\"!cf.settingsJson\">{{cf.customFormName}}</td>\r\n                  <td class=\"col-md-10\" ng-if=\"cf.settingsJson\"><a href=\"#\" ng-click=\"$ctrl.showEditCustomForm(cf)\">{{cf.customFormName}}</a></td>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-danger btn-small\" ng-click=\"$ctrl.showRemoveCustomForm(cf)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n                  </th>\r\n              </tr>\r\n            </tbody>\r\n          </table>  \r\n        </div> \r\n        \r\n        <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n          <header>\r\n            <h2>Stock Provider</h2>\r\n          </header>\r\n  \r\n          <div class=\"form-group\">\r\n            <div class=\"col-sm-12\">\r\n              <a href=\"#\" class=\"link\" ng-click=\"$ctrl.showEditStockProvider()\">{{$ctrl.entity.stockProviderName}}</a>              \r\n            </div>\r\n          </div>  \r\n        </div>  \r\n        \r\n        <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n          <header>\r\n            <h2>Telecom Provider</h2>\r\n          </header>\r\n  \r\n          <div class=\"form-group\">\r\n            <div class=\"col-sm-12\">\r\n              <a href=\"#\" class=\"link\" ng-click=\"$ctrl.showEditTelecomProvider()\">{{$ctrl.entity.telecomProviderName}}</a>              \r\n            </div>\r\n          </div>  \r\n        </div>   \r\n        \r\n        <div class=\"panel\" ng-show=\"!$ctrl.entityManagement && $ctrl.entity.entityType.toString() === '3'\">\r\n          <header>\r\n            <h2>Invoice Details</h2>\r\n          </header>\r\n  \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Invoice Initials</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.initials\" placeholder=\"Invoice Initials\" maxlength=\"3\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'initials', $ctrl.entity.invoice.initials)\">                \r\n            </div>\r\n          </div> \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Email Server</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.emailServer\" placeholder=\"Email Server\" maxlength=\"20\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'emailServer', $ctrl.entity.invoice.emailServer)\">                \r\n            </div>\r\n          </div>         \r\n          \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Email Port</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.entity.invoice.emailPort\" placeholder=\"Email Port\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'emailPort', $ctrl.entity.invoice.emailPort)\">                \r\n            </div>\r\n          </div>                   \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Email Username</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.emailUsername\" placeholder=\"Email Username\" maxlength=\"50\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'emailUsername', $ctrl.entity.invoice.emailUsername)\">                \r\n            </div>\r\n          </div>                   \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Email Password</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" type=\"password\" ng-model=\"$ctrl.entity.invoice.emailPassword\" placeholder=\"Email Password\" maxlength=\"50\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'emailPassword', $ctrl.entity.invoice.emailPassword)\">                \r\n            </div>\r\n          </div>       \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Requires SSL</label>\r\n            <div class=\"col-sm-9\">\r\n              <switch ng-model=\"$ctrl.entity.invoice.emailSsl\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'emailSsl', $ctrl.entity.invoice.emailSsl)\"></switch>\r\n            </div>\r\n          </div>                 \r\n          \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Bank Name</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.bankName\" placeholder=\"Bank Name\" maxlength=\"20\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'bankName', $ctrl.entity.invoice.bankName)\">                \r\n            </div>\r\n          </div> \r\n          \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">IBAN</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.iban\" placeholder=\"IBAN\" maxlength=\"34\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'iban', $ctrl.entity.invoice.iban)\">                \r\n            </div>\r\n          </div>           \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">SWIFT</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.swift\" placeholder=\"SWIFT\" maxlength=\"11\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'swift', $ctrl.entity.invoice.swift)\">                \r\n            </div>\r\n          </div>           \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Sort Code</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.sortCode\" placeholder=\"Sort Code\" maxlength=\"6\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'sortCode', $ctrl.entity.invoice.sortCode)\">                \r\n            </div>\r\n          </div>                     \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-3\">Account Number</label>\r\n            <div class=\"col-sm-9\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.entity.invoice.accountNumber\" placeholder=\"Account Number\" maxlength=\"8\" ng-change=\"$ctrl.updateJsonMeta($ctrl.enums.ENTITY_META_TYPE.InvoiceDetails, $ctrl.entity.invoice, 'accountNumber', $ctrl.entity.invoice.accountNumber)\">\r\n            </div>\r\n          </div>                               \r\n  \r\n        </div>        \r\n\r\n    </div>\r\n\r\n  </form>\r\n</div>\r\n"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(449);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _editContactphoneModal = __webpack_require__(737);
	
	var _editContactphoneModal2 = _interopRequireDefault(_editContactphoneModal);
	
	var _editContactemailModal = __webpack_require__(738);
	
	var _editContactemailModal2 = _interopRequireDefault(_editContactemailModal);
	
	var _angularUiRouter = __webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditController = function () {
	  EditController.$inject = ["$scope", "$stateParams", "$state", "$timeout", "entityService", "appConfig", "loadingService", "$uibModal", "$ngConfirm", "customFormsService", "growl", "enums"];
	  function EditController($scope, $stateParams, $state, $timeout, entityService, appConfig, loadingService, $uibModal, $ngConfirm, customFormsService, growl, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EditController);
	
	    this.closeModal = function () {
	      this.$uibModalInstance.close();
	    };
	
	    this._$scope = $scope;
	    this._$state = $state;
	    this._$timeout = $timeout;
	    this._$uibModal = $uibModal;
	    this._entityService = entityService;
	    this._appConfig = appConfig;
	    this.formValidationService = new _FormValidationService2.default();
	    this.loadingService = loadingService;
	    this.$ngConfirm = $ngConfirm;
	    this.customFormsService = customFormsService;
	    this.growl = growl;
	    this.enums = enums;
	
	    this.searchEntityUrl = appConfig.apiServiceBaseUri + 'api/entity/search/';
	
	    this.params = {};
	    if (this.entityManagement && (0, _keys2.default)(this.entityManagement).length) {
	      (0, _assign2.default)(this.params, this.entityManagement);
	    } else {
	      (0, _assign2.default)(this.params, $stateParams);
	    }
	
	    this.entityType = this.params.entityType;
	    this.entityId = this.params.entityId;
	
	    this.initializeEntity();
	
	    this.tempPhone = {
	      phoneType: "1",
	      phone: ""
	    };
	    this.addPhoneError = '';
	
	    this.tempEmail = "";
	    this.addEmailError = '';
	
	    this.state = '';
	
	    this.panels = {
	      entityDetails: true,
	      addressDetails: true,
	      contactPerson: true
	    };
	
	    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
	    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';
	
	    this.getWebPublisherList();
	    this.getStockProviderList();
	  }
	
	  (0, _createClass3.default)(EditController, [{
	    key: 'initializeEntity',
	    value: function initializeEntity() {
	      var _this = this;
	
	      var editCtrl = this;
	
	      editCtrl.entity = {
	        parentId: editCtrl.params.parent.entityId > 0 ? editCtrl.params.parent.entityId : null,
	        parent: {
	          name: editCtrl.params.parent.entityId > 0 ? editCtrl.params.parent.entityName : null
	        },
	        address: {},
	        entityType: editCtrl.params.entityType,
	        contactPerson: {
	          title: "1"
	        },
	        contactPhones: [],
	        contactEmails: [],
	        entityUsers: [],
	        lookupProviderType: "1",
	        webPublisherType: "1",
	        imageUrl: '/images/location.png'
	      };
	
	      editCtrl.configureForm();
	
	      if (editCtrl.params.entityId) {
	        editCtrl.loadingService.showLoading('editEntity', 'Loading Entity ...');
	
	        editCtrl._entityService.getEntity(editCtrl.params.entityId).then(function (response) {
	          (0, _assign2.default)(editCtrl.entity, response.data);
	          editCtrl.entity.parent.name = response.data.parentName;
	          if (editCtrl.entity.contactPerson) {
	            editCtrl.entity.contactPerson.title = editCtrl.entity.contactPerson.title.toString();
	          } else {
	            editCtrl.entity.contactPerson = { title: "1" };
	          }
	          editCtrl.entity.lookupProviderType = editCtrl.entity.lookupProviderType.toString();
	
	          //Entity Metas
	          var webleadFollowUpEmail = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.WebLeadFollowUpEmail;
	          });
	          editCtrl.entity.webLeadFollowUpEmail = _this.strToBool(webleadFollowUpEmail != null ? webleadFollowUpEmail.value : null);
	
	          var displayInDashboard = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.DisplayInDashboard;
	          });
	          editCtrl.entity.displayInDashboard = displayInDashboard ? parseInt(displayInDashboard.value) : 3;
	
	          var marketingSourceRequired = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.MarketingSourceRequired;
	          });
	          editCtrl.entity.marketingSourceRequired = _this.strToBool(marketingSourceRequired != null ? marketingSourceRequired.value : null);
	
	          var telecomProviderMeta = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.TelecomProvider;
	          });
	          if (telecomProviderMeta != null) {
	            editCtrl.entity.telecomProviderName = JSON.parse(telecomProviderMeta.value).name;
	          } else {
	            editCtrl.entity.telecomProviderName = "None";
	          }
	
	          var confirmedEnquiryComplianceTemplate = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.ConfirmedEnquiryComplianceTemplate;
	          });
	          editCtrl.entity.confirmedEnquiryComplianceTemplate = confirmedEnquiryComplianceTemplate ? confirmedEnquiryComplianceTemplate.value : null;
	
	          var invoiceDetails = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
	            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.InvoiceDetails;
	          });
	          editCtrl.entity.invoice = invoiceDetails ? JSON.parse(invoiceDetails.value) : {};
	
	          editCtrl.configureForm();
	          editCtrl.setDefaults(editCtrl.entity.entityType);
	        }).catch(function (err) {}).finally(function () {
	          editCtrl.loadingService.hideLoading('editEntity');
	        });
	      } else {
	        editCtrl.setDefaults(editCtrl.entity.entityType);
	      }
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var editCtrl = this;
	
	      editCtrl.formValidationService.initialize(editCtrl.entity);
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'name',
	        displayName: 'Name',
	        required: true,
	        stringLength: {
	          min: 2,
	          max: 50
	        }
	      });
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'legalName',
	        displayName: 'Legal Name',
	        stringLength: {
	          min: 2,
	          max: 50
	        }
	      });
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'website',
	        displayName: 'Website',
	        type: 'url',
	        stringLength1: {
	          min: 10,
	          max: 100
	        }
	      });
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'line1',
	        displayName: 'Address Line 1',
	        model: editCtrl.entity.address,
	        required: true,
	        stringLength: {
	          min: 5,
	          max: 100
	        }
	      });
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'firstName',
	        displayName: 'First Name',
	        model: editCtrl.entity.contactPerson,
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      editCtrl.formValidationService.addField({
	        fieldName: 'lastName',
	        displayName: 'Last Name',
	        model: editCtrl.entity.contactPerson,
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      if (parseInt(editCtrl.params.entityType) === 3) {
	        editCtrl.formValidationService.addField({
	          fieldName: 'lookupProviderUsername',
	          displayName: 'Api Key',
	          condition: '{MODEL}.lookupProviderEnabled',
	          required: true
	        });
	      }
	    }
	  }, {
	    key: 'setDefaults',
	    value: function setDefaults(entityType) {
	      switch (entityType.toString()) {
	        case "1":
	          this.setDefaultsCompany();
	          break;
	
	        case "2":
	          this.setDefaultsDealer();
	          break;
	
	        case "3":
	          this.setDefaultsLocation();
	          break;
	      }
	    }
	  }, {
	    key: 'setDefaultsCompany',
	    value: function setDefaultsCompany() {
	      var prefix = this.params.entityId ? 'Edit' : 'Add';
	      this.pageTitle = prefix + ' Company';
	      this.searchParentDisabled = false;
	    }
	  }, {
	    key: 'setDefaultsDealer',
	    value: function setDefaultsDealer() {
	      var prefix = this.params.entityId ? 'Edit' : 'Add';
	      this.pageTitle = prefix + ' Dealer';
	      this.searchParentDisabled = true;
	    }
	  }, {
	    key: 'setDefaultsLocation',
	    value: function setDefaultsLocation() {
	      var prefix = this.params.entityId ? 'Edit' : 'Add';
	      this.pageTitle = prefix + ' Location';
	      this.searchParentDisabled = true;
	
	      this.entity.autoSold = this.entity.autoSold || 0;
	      this.entity.appraisalExpiry = this.entity.appraisalExpiry || 0;
	
	      this.autoSold = {
	        retail: (1 | this.entity.autoSold) === this.entity.autoSold,
	        trade: (2 | this.entity.autoSold) === this.entity.autoSold
	      };
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      var _this2 = this;
	
	      var phones = this.entity.contactPhones;
	
	      if (!this.tempPhone.phone || this.tempPhone.phone === '') {
	        this.addPhoneError = 'Please enter a phone number to add';
	        return;
	      }
	
	      var phone = (0, _lodash.find)(phones, function (p) {
	        return p.phone === _this2.tempPhone.phone;
	      });
	      if (phone) {
	        this.addPhoneError = 'This phone number has already been added';
	        return;
	      }
	
	      phones.push(this.tempPhone);
	
	      this.addPhoneError = '';
	      this.tempPhone = {
	        "phoneType": "1",
	        "phone": ""
	      };
	
	      this.closeModal();
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(contactPhone) {
	      this.entity.contactPhones = (0, _lodash.without)(this.entity.contactPhones, contactPhone);
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      var _this3 = this;
	
	      var emails = this.entity.contactEmails;
	
	      if (!this.tempEmail || this.tempEmail === '') {
	        this.addEmailError = 'Please enter a valid email address to add';
	        return;
	      }
	
	      var email = (0, _lodash.find)(emails, function (e) {
	        return e.email === _this3.tempEmail;
	      });
	      if (email) {
	        this.addEmailError = 'This email address has already been added';
	        return;
	      }
	
	      emails.push({ 'email': this.tempEmail, 'name': this.tempName });
	
	      this.addEmailError = '';
	      this.tempEmail = "";
	      this.tempName = "";
	
	      this.closeModal();
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(contactEmail) {
	      this.entity.contactEmails = (0, _lodash.without)(this.entity.contactEmails, contactEmail);
	    }
	  }, {
	    key: 'addEntity',
	    value: function addEntity() {
	      var _this4 = this;
	
	      var editCtrl = this;
	
	      if (!editCtrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      editCtrl.loadingService.showLoading('editEntity', 'Saving Changes ...');
	
	      //If Parent Selected
	      if (editCtrl.entity.parent) {
	        if (editCtrl.entity.parent.originalObject) {
	          editCtrl.entity.parentId = editCtrl.entity.parent.originalObject.entityId;
	        }
	
	        delete editCtrl.entity.parent;
	      }
	
	      this._entityService.addEntity(this.entity).then(function (response) {
	        _this4.state = 'Saved';
	        editCtrl.redirectToParent();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          editCtrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            editCtrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          editCtrl.state = 'SystemError';
	          editCtrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        editCtrl.loadingService.hideLoading('editEntity');
	      });
	    }
	  }, {
	    key: 'parentSelected',
	    value: function parentSelected(item) {
	      if (item) {
	        this.$parent.$ctrl.entity = item.originalObject.EntityId;
	      }
	    }
	  }, {
	    key: 'clearParent',
	    value: function clearParent() {
	      if (this.entity.parent) {
	        delete this.entity.parent;
	        this._$scope.$broadcast('angucomplete-alt:clearInput', 'searchCompanies');
	      }
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent() {
	      if (this.params.isEntityManagement) {
	        return;
	      }
	
	      switch (this.entityType) {
	        case "1":
	          this._$state.go('admin.entity.listCompanies', { entityType: this.entityType });
	          break;
	        case "2":
	        case "3":
	          this._$state.go('admin.entity.listChildren', { entityId: this.entity.parentId, entityType: this.entityType });
	          break;
	      }
	    }
	  }, {
	    key: 'updateAutoSold',
	    value: function updateAutoSold(autoSoldType, modelProp) {
	      if (this.autoSold[modelProp]) {
	        this.entity.autoSold |= autoSoldType;
	      } else {
	        this.entity.autoSold &= ~autoSoldType;
	      }
	    }
	  }, {
	    key: 'addContactPhone',
	    value: function addContactPhone() {
	      this.openModal(_editContactphoneModal2.default);
	    }
	  }, {
	    key: 'addContactEmail',
	    value: function addContactEmail() {
	      this.openModal(_editContactemailModal2.default);
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(template) {
	      this.$uibModalInstance = this._$uibModal.open({
	        template: template,
	        scope: this._$scope
	      });
	    }
	  }, {
	    key: 'onImageUploaded',
	    value: function onImageUploaded(response) {
	      this.entity.imageUrl = this.mediaUrl + '/' + response.data[0].value;
	    }
	  }, {
	    key: 'phoneTypeToString',
	    value: function phoneTypeToString(phoneType) {
	      switch (phoneType.toString()) {
	        case "1":
	          return "Work Phone";
	        case "2":
	          return "Home Phone";
	        case "3":
	          return "Work Mobile";
	        case "4":
	          return "Personal Mobile";
	        case "5":
	          return "Fax";
	        case "6":
	          return "Other";
	      }
	    }
	  }, {
	    key: 'getWebPublisherList',
	    value: function getWebPublisherList() {
	      this.webPublisherList = [];
	      this.webPublisherList.push({ id: null, name: 'None' });
	      this.webPublisherList.push({ id: 1, name: 'EasierAd' });
	      this.webPublisherList.push({ id: 2, name: 'Stock Loader' });
	    }
	  }, {
	    key: 'addCustomForm',
	    value: function addCustomForm() {
	      var _this5 = this;
	
	      this.customFormsService.list(this.entityId).then(function (response) {
	        _this5.showAddCustomForms(response.data);
	      });
	    }
	  }, {
	    key: 'showAddCustomForms',
	    value: function showAddCustomForms(availableForms) {
	      this._$scope.customForms = availableForms;
	      this._$scope.selectedForm = null;
	
	      this.addCustomFormDialog = this.$ngConfirm({
	        title: 'Add Custom Form',
	        contentUrl: 'templates/customForms/addCustomFormTemplate',
	        scope: this._$scope,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: this.customFormNextStep.bind(this)
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'customFormNextStep',
	    value: function customFormNextStep() {
	      var _this6 = this;
	
	      if (!this._$scope.selectedForm.settingsTemplate) {
	        var customForm = {
	          entityId: this.entityId,
	          customFormId: this._$scope.selectedForm.customFormId,
	          customFormName: this._$scope.selectedForm.name,
	          settingsJson: null
	        };
	        this.addNewCustomForm(customForm);
	        return;
	      }
	
	      this._$scope.errMsgs = null;
	      this._$scope.settings = {};
	
	      this.$ngConfirm({
	        title: 'Settings for ' + this._$scope.selectedForm.name + ' Form',
	        contentUrl: 'templates/customForms/' + this._$scope.selectedForm.settingsTemplate,
	        scope: this._$scope,
	        columnClass: 'm',
	        type: 'dark',
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var settings = _this6.parseCustomFormSettings(_this6._$scope.selectedForm.parser);
	              if (!settings) {
	                return false;
	              } else {
	                var _customForm = {
	                  entityId: _this6.entityId,
	                  customFormId: _this6._$scope.selectedForm.customFormId,
	                  customFormName: _this6._$scope.selectedForm.name,
	                  settingsJson: settings,
	                  settingsTemplate: _this6._$scope.selectedForm.settingsTemplate,
	                  parser: _this6._$scope.selectedForm.parser
	                };
	                _this6.addNewCustomForm(_customForm);
	              }
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'addNewCustomForm',
	    value: function addNewCustomForm(customForm) {
	      var _this7 = this;
	
	      this.customFormsService.add(customForm).then(function (response) {
	        _this7.entity.customForms.push(customForm);
	
	        _this7.growl.success(customForm.customFormName + ' added successfully', { ttl: 5000 });
	      }).catch(function (err) {
	        alert('Could not save custom form. Something went wrong.');
	      });
	    }
	  }, {
	    key: 'showRemoveCustomForm',
	    value: function showRemoveCustomForm(customForm) {
	      var _this8 = this;
	
	      this.$ngConfirm({
	        title: 'Remove Custom Form',
	        content: 'Are you sure want to remove this form ?',
	        columnClass: 'm',
	        type: 'red',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-danger',
	            action: function action() {
	              _this8.customFormsService.remove(_this8.entityId, customForm.customFormId).then(function (response) {
	                debugger;
	                //const formToRemove = find(this.entity.customForms, o => o.customFormId === customForm.customFormId);
	                (0, _lodash.remove)(_this8.entity.customForms, function (o) {
	                  return o.customFormId === customForm.customFormId;
	                });
	
	                _this8.growl.success(customForm.customFormName + ' removed successfully', { ttl: 5000 });
	              });
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'parseCustomFormSettings',
	    value: function parseCustomFormSettings(fn) {
	      if (fn === 'parseMercPerOwnedWarranty') {
	        return this.parseMercPerOwnedWarranty();
	      }
	    }
	  }, {
	    key: 'parseMercPerOwnedWarranty',
	    value: function parseMercPerOwnedWarranty() {
	      var errMsgs = [];
	
	      if (!this._$scope.settings.exchangePlan) {
	        errMsgs.push('Exchange Plan is a required field');
	      }
	
	      if (!this._$scope.settings.salesManager) {
	        errMsgs.push('Sales Manager is a required field');
	      }
	
	      if (!this._$scope.settings.serviceManager) {
	        errMsgs.push('Service Manager is a required field');
	      }
	
	      if (!this._$scope.settings.partsManager) {
	        errMsgs.push('Parts Manager is a required field');
	      }
	
	      if (!this._$scope.settings.warrantyPeriod) {
	        errMsgs.push('Warranty Period is a required field');
	      }
	
	      if (errMsgs.length > 0) {
	        this._$scope.errMsgs = errMsgs;
	        return null;
	      }
	
	      return (0, _stringify2.default)(this._$scope.settings);
	    }
	  }, {
	    key: 'showEditCustomForm',
	    value: function showEditCustomForm(customForm) {
	      var _this9 = this;
	
	      this._$scope.errMsgs = null;
	      this._$scope.settings = JSON.parse(customForm.settingsJson);
	
	      this.$ngConfirm({
	        title: 'Settings for ' + customForm.name + ' Form',
	        contentUrl: 'templates/customForms/' + customForm.settingsTemplate,
	        scope: this._$scope,
	        columnClass: 'm',
	        type: 'dark',
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var settings = _this9.parseCustomFormSettings(customForm.parser);
	              if (!settings) {
	                return false;
	              } else {
	                var updatedForm = {
	                  entityId: _this9.entityId,
	                  customFormId: customForm.customFormId,
	                  customFormName: customForm.customFormName,
	                  settingsJson: settings,
	                  settingsTemplate: customForm.settingsTemplate,
	                  parser: customForm.parser
	                };
	                _this9.editCustomForm(updatedForm);
	              }
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'editCustomForm',
	    value: function editCustomForm(customForm) {
	      var _this10 = this;
	
	      this.customFormsService.edit(customForm).then(function (response) {
	        var form = (0, _lodash.find)(_this10.entity.customForms, function (o) {
	          return o.customFormId === customForm.customFormId;
	        });
	        form.settingsJson = customForm.settingsJson;
	
	        _this10.growl.success(customForm.customFormName + ' updated successfully', { ttl: 5000 });
	      }).catch(function (err) {
	        alert('Could not save custom form. Something went wrong.');
	      });
	    }
	  }, {
	    key: 'getStockProviderList',
	    value: function getStockProviderList() {
	      var stockProviderList = [];
	      stockProviderList.push({ id: null, name: 'None', params: null });
	      stockProviderList.push({ id: 1, name: 'DoneDeal', params: [{ key: 'dealerId', label: 'Dealer Id', value: null }] });
	      stockProviderList.push({ id: 2, name: 'Cars Ireland', params: [{ key: 'dealerId', label: 'CarsIreland DealerId', value: null }] });
	      stockProviderList.push({ id: 3, name: 'SIMI Stock Loader', params: [{ key: 'dealerId', label: 'StockLoader DealerId', value: null }] });
	      stockProviderList.push({ id: 4, name: 'CarZone', params: [{ key: 'username', label: 'Username', value: null }, { key: 'password', label: 'Password', value: null }] });
	      stockProviderList.push({ id: 5, name: 'Happy Dealer', params: [{ key: 'feedId', label: 'Feed Id', value: null }] });
	
	      return stockProviderList;
	    }
	  }, {
	    key: 'showEditStockProvider',
	    value: function showEditStockProvider() {
	      var _this11 = this;
	
	      this._$scope.stockProviderList = this.getStockProviderList();
	      this._$scope.errMsgs = null;
	      this._$scope.changeProvider = function () {
	        var selectedProvider = (0, _lodash.find)(_this11._$scope.stockProviderList, function (p) {
	          return p.id === _this11._$scope.stockProviderViewModel.stockProvider;
	        });
	        _this11._$scope.stockProviderViewModel.params = selectedProvider.params;
	        _this11._$scope.stockProviderViewModel.name = selectedProvider.name;
	      };
	
	      this._$scope.stockProviderViewModel = {
	        entityId: this.entity.entityId,
	        stockProvider: this.entity.stockProvider,
	        params: JSON.parse(this.entity.stockProviderSettings),
	        name: this.entity.stockProviderName
	      };
	
	      this.$ngConfirm({
	        title: 'Stock Provider Settings',
	        contentUrl: 'templates/admin/stockProviderTemplate',
	        scope: this._$scope,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              return _this11.updateStockProvider();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateStockProvider',
	    value: function updateStockProvider() {
	      var _this12 = this;
	
	      if (this._$scope.stockProviderViewModel.params) {
	        var unfilled = (0, _lodash.filter)(this._$scope.stockProviderViewModel.params, function (s) {
	          return !s.value;
	        });
	
	        if (unfilled.length) {
	          this._$scope.errMsgs = unfilled.map(function (p) {
	            return 'Please provide a value for ' + p.label;
	          });
	          return false;
	        }
	      }
	
	      var stockProviderViewModel = {
	        entityId: this.entity.entityId,
	        stockProvider: null,
	        stockProviderSettings: null
	      };
	
	      this.loadingService.showLoading('editEntity', 'Updating Stock Provider ...');
	
	      if (this._$scope.stockProviderViewModel.stockProvider) {
	        stockProviderViewModel.stockProvider = this._$scope.stockProviderViewModel.stockProvider;
	        stockProviderViewModel.stockProviderSettings = (0, _stringify2.default)(this._$scope.stockProviderViewModel.params.map(function (p) {
	          return { key: p.key, label: p.label, value: p.value };
	        }));
	      }
	
	      this._entityService.updateStockProvider(stockProviderViewModel).then(function (response) {
	        _this12.entity.stockProvider = stockProviderViewModel.stockProvider;
	        _this12.entity.stockProviderName = _this12._$scope.stockProviderViewModel.name;
	        _this12.entity.stockProviderSettings = stockProviderViewModel.stockProviderSettings;
	
	        _this12.growl.success('Stock Provider updated successfully', { ttl: 5000 });
	      }).finally(function () {
	        editCtrl.loadingService.hideLoading('editEntity');
	      });
	    }
	  }, {
	    key: 'strToBool',
	    value: function strToBool(value) {
	      if (value === 'true') {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'updateMeta',
	    value: function updateMeta(entityMetaType, value) {
	      var meta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
	        return em.entityMetaType === entityMetaType;
	      });
	
	      if (meta) {
	        meta.value = value;
	      } else {
	        this.entity.entityMeta.push({ entityMetaType: entityMetaType, value: value });
	      }
	    }
	  }, {
	    key: 'updateJsonMeta',
	    value: function updateJsonMeta(entityMetaType, obj, fieldName, value) {
	      var meta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
	        return em.entityMetaType === entityMetaType;
	      });
	
	      if (meta) {
	        obj[fieldName] = value;
	        meta.value = (0, _angularUiRouter.toJson)(obj);
	      } else {
	        obj[fieldName] = value;
	        this.entity.entityMeta.push({ entityMetaType: entityMetaType, value: (0, _angularUiRouter.toJson)(obj) });
	      }
	    }
	  }, {
	    key: 'getTelecomProviderList',
	    value: function getTelecomProviderList() {
	      var telecomProviderList = [];
	      telecomProviderList.push({ id: null, name: 'None', params: null });
	      telecomProviderList.push({ id: 1, name: 'Nuacom', params: [{ key: 'apiKey', label: 'Api Key', value: null }] });
	      telecomProviderList.push({ id: 2, name: 'Call Metrics', params: [{ key: 'apiKey', label: 'Api Key', value: null }, { key: 'username', label: 'Username', value: null }, { key: 'password', label: 'Password', value: null }] });
	
	      return telecomProviderList;
	    }
	  }, {
	    key: 'showEditTelecomProvider',
	    value: function showEditTelecomProvider() {
	      var _this13 = this;
	
	      this._$scope.telecomProviderList = this.getTelecomProviderList();
	      this._$scope.errMsgs = null;
	      this._$scope.changeProvider = function () {
	        var selectedProvider = (0, _lodash.find)(_this13._$scope.telecomProviderList, function (p) {
	          return p.id === _this13._$scope.telecomProviderViewModel.id;
	        });
	        _this13._$scope.telecomProviderViewModel.params = selectedProvider.params;
	        _this13._$scope.telecomProviderViewModel.name = selectedProvider.name;
	      };
	
	      var telecomProviderMeta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
	        return em.entityMetaType === _this13.enums.ENTITY_META_TYPE.TelecomProvider;
	      });
	      if (telecomProviderMeta != null) {
	        var jsonValue = JSON.parse(telecomProviderMeta.value);
	
	        this._$scope.telecomProviderViewModel = {
	          id: jsonValue.id,
	          params: jsonValue.params,
	          name: jsonValue.name
	        };
	      } else {
	        this._$scope.telecomProviderViewModel = {
	          id: null,
	          params: null,
	          name: "None"
	        };
	      }
	
	      this.$ngConfirm({
	        title: 'Telecom Provider Settings',
	        contentUrl: 'templates/admin/telecomProviderTemplate',
	        scope: this._$scope,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              return _this13.updateTelecomProvider();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateTelecomProvider',
	    value: function updateTelecomProvider() {
	      var _this14 = this;
	
	      if (this._$scope.telecomProviderViewModel.params) {
	        var unfilled = (0, _lodash.filter)(this._$scope.telecomProviderViewModel.params, function (s) {
	          return !s.value;
	        });
	
	        if (unfilled.length) {
	          this._$scope.errMsgs = unfilled.map(function (p) {
	            return 'Please provide a value for ' + p.label;
	          });
	          return false;
	        }
	      }
	
	      var telecomProvider = (0, _lodash.find)(this.entity.entityMeta, function (em) {
	        return em.entityMetaType === _this14.enums.ENTITY_META_TYPE.TelecomProvider;
	      });
	
	      if (telecomProvider != null) {
	        telecomProvider.value = (0, _angularUiRouter.toJson)(this._$scope.telecomProviderViewModel);
	      } else {
	        telecomProvider = {
	          entityMetaType: this.enums.ENTITY_META_TYPE.TelecomProvider,
	          value: (0, _angularUiRouter.toJson)(this._$scope.telecomProviderViewModel)
	        };
	
	        this.entity.entityMeta.push(telecomProvider);
	      }
	
	      this.entity.telecomProviderName = this._$scope.telecomProviderViewModel.name;
	    }
	  }]);
	  return EditController;
	}();
	
	exports.default = EditController;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormValidationService = function () {
	  function FormValidationService() {
	    (0, _classCallCheck3.default)(this, FormValidationService);
	
	    this.configuration = [];
	
	    this.model = null;
	
	    this.validations = {
	      msgs: [],
	      errorType: ''
	    };
	
	    this.requiredFieldValidatorText = this.requiredFieldValidatorText.bind(this);
	    this.requiredFieldValidatorSelect = this.requiredFieldValidatorSelect.bind(this);
	    this.requiredFieldValidatorBoolean = this.requiredFieldValidatorBoolean.bind(this);
	    this.stringLengthValidator = this.stringLengthValidator.bind(this);
	    this.boundFieldValidator = this.boundFieldValidator.bind(this);
	    this.urlTypeValidator = this.urlTypeValidator.bind(this);
	    this.dateLessThanValidator = this.dateLessThanValidator.bind(this);
	    this.pastDateValidator = this.pastDateValidator.bind(this);
	    this.floatValidator = this.floatValidator.bind(this);
	    this.intValidator = this.intValidator.bind(this);
	    this.rangeValidator = this.rangeValidator.bind(this);
	  }
	
	  (0, _createClass3.default)(FormValidationService, [{
	    key: 'initialize',
	    value: function initialize(model) {
	      this.configuration = [];
	
	      this.model = model;
	
	      this.fieldCount = 0;
	    }
	  }, {
	    key: 'addField',
	    value: function addField(config) {
	      var formValidationService = this;
	      var fieldConfig = void 0;
	
	      //Check Required Properties
	      if (!config || !config.fieldName || !config.displayName) {
	        console.log('Invalid Config', config);
	        return;
	      }
	
	      if ((0, _lodash.find)(this.configuration, function (o) {
	        return o.fieldName === config.fieldName;
	      })) {
	        config.isDup = true;
	      }
	
	      fieldConfig = {
	        fieldName: config.fieldName,
	        displayName: config.displayName,
	        model: config.model,
	        type: config.type || 'text',
	        required: config.required || false,
	        stringLength: {
	          min: config.stringLength && config.stringLength.min ? config.stringLength.min : null,
	          max: config.stringLength && config.stringLength.max ? config.stringLength.max : null
	        },
	        bindTo: config.bindTo || null,
	        condition: config.condition || null,
	        dateLessThan: config.dateLessThan || null,
	        allowPastDate: config.allowPastDate !== undefined ? config.allowPastDate : null,
	        allowedDecimals: config.allowedDecimals || null,
	        range: {
	          min: config.range && config.range.min ? config.range.min : null,
	          max: config.range && config.range.max ? config.range.max : null
	        },
	        validators: [],
	        isDup: config.isDup || false
	      };
	
	      if (fieldConfig.required) {
	        if (fieldConfig.type === 'text') {
	          fieldConfig.validators.push(this.requiredFieldValidatorText);
	        } else if (fieldConfig.type === 'boolean') {
	          fieldConfig.validators.push(this.requiredFieldValidatorBoolean);
	        } else {
	          fieldConfig.validators.push(this.requiredFieldValidatorSelect);
	        }
	      }
	
	      if (fieldConfig.stringLength.min && fieldConfig.stringLength.max) {
	        fieldConfig.validators.push(this.stringLengthValidator);
	      }
	
	      if (fieldConfig.bindTo) {
	        fieldConfig.validators.push(this.boundFieldValidator);
	      }
	
	      if (fieldConfig.type === 'url') {
	        fieldConfig.validators.push(this.urlTypeValidator);
	      }
	
	      if (fieldConfig.dateLessThan) {
	        fieldConfig.validators.push(this.dateLessThanValidator);
	      }
	
	      if (fieldConfig.type === 'datetime' && fieldConfig.allowPastDate === false) {
	        fieldConfig.validators.push(this.pastDateValidator);
	      }
	
	      if (fieldConfig.type === 'float') {
	        fieldConfig.validators.push(this.floatValidator);
	      }
	
	      if (fieldConfig.type === 'int') {
	        fieldConfig.validators.push(this.intValidator);
	      }
	
	      if (fieldConfig.range.min && fieldConfig.range.max) {
	        fieldConfig.validators.push(this.rangeValidator);
	      }
	
	      formValidationService.configuration.push(fieldConfig);
	
	      if (fieldConfig.isDup) {
	        formValidationService.validations[fieldConfig.fieldName + '2'] = true;
	      } else {
	        formValidationService.validations[fieldConfig.fieldName] = true;
	      }
	
	      return fieldConfig;
	    }
	  }, {
	    key: 'resetValidations',
	    value: function resetValidations() {
	      var formValidationService = this;
	
	      formValidationService.validations = {
	        msgs: [],
	        errorType: ''
	      };
	
	      formValidationService.configuration.map(function (item) {
	        if (item.isDup) {
	          formValidationService.validations[item.fieldName + '2'] = true;
	        } else {
	          formValidationService.validations[item.fieldName] = true;
	        }
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var formValidationService = this;
	      var isValid = true;
	
	      formValidationService.resetValidations();
	
	      if (!formValidationService.configuration || !formValidationService.configuration.length) {
	        return isValid;
	      }
	
	      formValidationService.configuration.map(function (field) {
	        field.validators.map(function (validator) {
	          isValid = isValid & validator(field);
	        });
	      });
	
	      return formValidationService.validations.msgs.length === 0;
	    }
	  }, {
	    key: 'getFieldValue',
	    value: function getFieldValue(field) {
	      var model = field.model || this.model;
	
	      if (model) {
	        return model[field.fieldName];
	      }
	    }
	  }, {
	    key: 'requiredFieldValidatorText',
	    value: function requiredFieldValidatorText(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	
	      if (field.condition === null) {
	        if ((!value || value === '') && value !== false) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName, field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      } else {
	        if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (!value || value === '' || !value.length)) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName, field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'requiredFieldValidatorBoolean',
	    value: function requiredFieldValidatorBoolean(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	
	      if (field.condition === null) {
	        if (typeof value === 'undefined' || value === null) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName, field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      } else {
	        if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (typeof value === 'undefined' || value === null)) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName, field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'requiredFieldValidatorSelect',
	    value: function requiredFieldValidatorSelect(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	
	      if (field.condition === null) {
	        if (!value || value === 0) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName);
	          return false;
	        } else {
	          return true;
	        }
	      } else {
	        if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (!value || value === 0)) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a value for ' + field.displayName);
	          return false;
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'stringLengthValidator',
	    value: function stringLengthValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var stringLength = field.stringLength;
	
	      if (!value) {
	        return false;
	      }
	
	      if (field.condition === null) {
	        if (value && (value.length < stringLength.min || value.length > stringLength.max)) {
	          formValidationService.addModelError(field.fieldName, field.displayName + ' should be between ' + stringLength.min + ' and ' + stringLength.max + ' characters', field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      } else {
	        if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && value && (value.length < stringLength.min || value.length > stringLength.max)) {
	          formValidationService.addModelError(field.fieldName, field.displayName + ' should be between ' + stringLength.min + ' and ' + stringLength.max + ' characters', field.isDup);
	          return false;
	        } else {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'boundFieldValidator',
	    value: function boundFieldValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var boundValue = formValidationService.getFieldValue(field.bindTo);
	
	      if (value !== boundValue) {
	        formValidationService.addModelError([field.fieldName, field.bindTo.fieldName], field.displayName + ' and ' + field.bindTo.displayName + ' do not match');
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'urlTypeValidator',
	    value: function urlTypeValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var pattern = new RegExp(/[a-z0-9-\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?$/, 'i'); // fragment locator
	
	      if (value) {
	        if (!pattern.test(value)) {
	          formValidationService.addModelError(field.fieldName, 'Please provide a valid URL for the ' + field.displayName);
	        } else {
	          return true;
	        }
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'dateLessThanValidator',
	    value: function dateLessThanValidator(field) {
	      var formValidationService = this;
	      var dtStart = formValidationService.getFieldValue(field.dateLessThan);
	      var dtEnd = formValidationService.getFieldValue(field);
	
	      if (dtEnd <= dtStart) {
	        formValidationService.addModelError([field.fieldName, field.dateLessThan.fieldName], field.dateLessThan.displayName + ' cannot be greater than ' + field.displayName);
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'pastDateValidator',
	    value: function pastDateValidator(field) {
	      var formValidationService = this;
	      var dt = formValidationService.getFieldValue(field);
	
	      if (!dt) {
	        return false;
	      }
	
	      if (dt < new Date().withoutTime()) {
	        formValidationService.addModelError([field.fieldName], field.displayName + ' cannot be in the past');
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'floatValidator',
	    value: function floatValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var pattern = '';
	
	      if (field.allowedDecimals) {
	        pattern = new RegExp('^-?\\d*(\\.\\d{0,' + field.allowedDecimals + '})?$');
	      } else {
	        pattern = new RegExp(/^-?\d*(\.\d+)?$/);
	      }
	
	      if (!value) {
	        return true;
	      }
	
	      if (!pattern.exec(value)) {
	        if (field.allowedDecimals) {
	          formValidationService.addModelError([field.fieldName], field.displayName + ' must be a valid floating point number with a maximum of ' + field.allowedDecimals + ' decimals');
	        } else {
	          formValidationService.addModelError([field.fieldName], field.displayName + ' must be a valid floating point number');
	        }
	
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'intValidator',
	    value: function intValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var pattern = new RegExp(/^-?\d*?$/);
	
	      if (!value) {
	        return true;
	      }
	
	      if (!pattern.exec(value)) {
	        formValidationService.addModelError([field.fieldName], field.displayName + ' must be a valid number');
	
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'rangeValidator',
	    value: function rangeValidator(field) {
	      var formValidationService = this;
	      var value = formValidationService.getFieldValue(field);
	      var range = field.range;
	
	      if (!value) {
	        return true;
	      }
	
	      if (value && (value < range.min || value > range.max)) {
	        formValidationService.addModelError(field.fieldName, field.displayName + ' should be between ' + range.min + ' and ' + range.max);
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'addModelError',
	    value: function addModelError(fields, errorMsg, isDup) {
	      this.addError(fields, 'Model', errorMsg, isDup);
	    }
	  }, {
	    key: 'addSystemError',
	    value: function addSystemError(fields, errorMsg, isDup) {
	      this.addError(fields, 'System', errorMsg, isDup);
	    }
	  }, {
	    key: 'addError',
	    value: function addError(fields, errorType, errorMsg, isDup) {
	      var formValidationService = this;
	
	      formValidationService.validations.errorType = errorType;
	
	      if (Array.isArray(fields)) {
	        fields.map(function (field) {
	          if (isDup) {
	            //Dirty Hack
	            formValidationService.validations[field + '2'] = false;
	          } else {
	            formValidationService.validations[field] = false;
	          }
	        });
	      } else {
	        if (isDup) {
	          //Dirty Hack
	          formValidationService.validations[fields + '2'] = false;
	        } else {
	          formValidationService.validations[fields] = false;
	        }
	      }
	
	      formValidationService.validations.msgs.push(errorMsg);
	    }
	  }]);
	  return FormValidationService;
	}();
	
	exports.default = FormValidationService;

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Contact Phone </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.addPhoneError !== ''\">\r\n        {{$ctrl.addPhoneError}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Phone Number</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n\r\n            <input id=\"cphPhone\" name=\"cphPhone\" class=\"form-control\" placeholder=\"Phone number\" ng-model=\"$ctrl.tempPhone.phone\" required/>\r\n\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Phone Type</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n              <div class=\"section\">\r\n                  <select id=\"cphType\" name=\"cphType\" class=\"form-control\" ng-model=\"$ctrl.tempPhone.phoneType\" required>\r\n                      <option value=\"1\">Work Phone</option>\r\n                      <option value=\"2\">Home Phone</option>\r\n                      <option value=\"3\">Work Mobile</option>\r\n                      <option value=\"4\">Personal Mobile</option>\r\n                      <option value=\"5\">Fax</option>\r\n                      <option value=\"6\">Other</option>\r\n                  </select>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addPhone()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Add\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Contact Email </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.addEmailError !== ''\">\r\n        {{$ctrl.addEmailError}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Contact Email</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n\r\n            <input type=\"email\" id=\"ceEmail\" name=\"ceEmail\" class=\"form-control\" placeholder=\"Email address\" ng-model=\"$ctrl.tempEmail\" required/>\r\n\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Contact Name</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n              <input type=\"text\" id=\"ceName\" name=\"ceName\" class=\"form-control\" placeholder=\"Name\" ng-model=\"$ctrl.tempName\" required/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addEmail()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Add\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(740);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./edit.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./edit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".uppercase{text-transform:uppercase}.location-logo{width:200px;height:150px}", ""]);
	
	// exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _entityUser = __webpack_require__(742);
	
	var _entityUser2 = _interopRequireDefault(_entityUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityUserModule = _angular2.default.module('entityUser', [_angularUiRouter2.default]).component('entityUser', _entityUser2.default).name;
	
	exports.default = entityUserModule;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entityUser = __webpack_require__(743);
	
	var _entityUser2 = _interopRequireDefault(_entityUser);
	
	var _entityUser3 = __webpack_require__(744);
	
	var _entityUser4 = _interopRequireDefault(_entityUser3);
	
	__webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityUserComponent = {
	  restrict: 'E',
	  bindings: {
	    entityUsers: '=',
	    entityId: '<'
	  },
	  template: _entityUser2.default,
	  controller: _entityUser4.default
	};
	
	exports.default = entityUserComponent;

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel\">\r\n  <header>\r\n    <h2>Users</h2>\r\n    <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.addUserModal()\">\r\n        <span class=\"glyphicon glyphicon-plus\"></span>\r\n        Add New User\r\n    </a>\r\n  </header>\r\n\r\n  <div class=\"alert alert-danger\" ng-show=\"$ctrl.addUserError !== ''\">\r\n    {{$ctrl.addUserError}}\r\n  </div>\r\n\r\n\r\n  <div class=\"input-group\" ng-show=\"$ctrl.addNewUser === false\">\r\n    <div angucomplete-alt\r\n      disable-input=\"$ctrl.searchDisabled\"\r\n      id=\"searchUsers\"\r\n      placeholder=\"Search Users by Email, First Name or Last Name\"\r\n      pause=\"400\"\r\n      selected-object=\"$ctrl.selectedUser\"\r\n      remote-url=\"{{$ctrl.searchUsersUrl}}\"\r\n      title-field=\"firstName,lastName,email\"\r\n      minlength=\"2\"\r\n      input-class=\"form-control form-control-small\"\r\n      match-class=\"autocomplete-highlight\"\r\n      initial-value = \"$ctrl.newUserName\"\r\n      match-class=\"highlight\">\r\n    </div>\r\n    <select\r\n      class=\"form-control\"\r\n      ng-options=\"role.name for role in $ctrl.roles track by role.roleId\"\r\n      ng-model=\"$ctrl.tempRole\">\r\n    </select>\r\n    <select\r\n      class=\"form-control\"\r\n      ng-options=\"brand.name for brand in $ctrl.brands track by brand.brandId\"\r\n      ng-model=\"$ctrl.tempBrand\">\r\n    </select>\r\n    <a class=\"input-group-addon btn btn-primary btn-small\" ng-click=\"$ctrl.addEntityUser()\"><span class=\"glyphicon glyphicon-plus\"></span></a>\r\n  </div>\r\n\r\n  <br>\r\n  <table class=\"table table-hover\" ng-show=\"$ctrl.entityUsers.length\">\r\n      <thead>\r\n          <tr>\r\n              <th class=\"col-md-4\">User</th>\r\n              <th class=\"col-md-4\">Role</th>\r\n              <th class=\"col-md-3\">Brand</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"eu in $ctrl.entityUsers\">\r\n              <td class=\"col-md-4\">\r\n                  <a href=\"#\" ng-click=\"$ctrl.showUpdateUserPref(eu.userPreferences)\">\r\n                    {{ eu.userName }}\r\n                  </a>\r\n              </td>\r\n              <td class=\"col-md-4\">\r\n                  {{ eu.roleName }}\r\n              </td>\r\n              <td class=\"col-md-4\">\r\n                  {{ eu.brandName }}\r\n              </td>\r\n              <td class=\"col-md-1\">\r\n                  <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEntityUser(eu)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n  <p ng-show=\"!$ctrl.entityUsers.length\">\r\n    User List is Empty\r\n  </p>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _lodash = __webpack_require__(498);
	
	var _entityUserAddUserModal = __webpack_require__(745);
	
	var _entityUserAddUserModal2 = _interopRequireDefault(_entityUserAddUserModal);
	
	var _entityUserUserPreferencesModal = __webpack_require__(746);
	
	var _entityUserUserPreferencesModal2 = _interopRequireDefault(_entityUserUserPreferencesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityUserController = function () {
	  EntityUserController.$inject = ["entityService", "loadingService", "lookupService", "appConfig", "$scope", "$uibModal", "$timeout", "enums"];
	  function EntityUserController(entityService, loadingService, lookupService, appConfig, $scope, $uibModal, $timeout, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EntityUserController);
	
	    this.closeModal = function () {
	      this.$uibModalInstance.close();
	    };
	
	    this.entityService = entityService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.$scope = $scope;
	    this.formValidationService = new _FormValidationService2.default();
	    this.$uibModal = $uibModal;
	    this.appConfig = appConfig;
	    this.enums = enums;
	
	    $timeout(this.setSearchUrl.bind(this), 7000);
	
	    this.searchDisabled = true;
	    this.searchUsersUrl = '';
	
	    this.state = '';
	
	    this.addUserError = '';
	
	    this.user = {
	      email: '',
	      firstName: '',
	      lastName: '',
	      imageUrl: '',
	      workType: 1
	    };
	
	    this.newUserName = '';
	
	    this.addNewUser = false;
	
	    this.configureForm();
	    this.initializeLookups();
	
	    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
	    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';
	    this.profilePicBaseUrl = appConfig.apiServiceBaseUri + 'api/file/updateprfilepic';
	    this.profilePicUrl = '';
	  }
	
	  (0, _createClass3.default)(EntityUserController, [{
	    key: 'setSearchUrl',
	    value: function setSearchUrl() {
	      this.searchUsersUrl = this.appConfig.apiServiceBaseUri + ('api/user/searchcompanyuser/' + this.entityId + '/');
	      this.searchDisabled = false;
	    }
	  }, {
	    key: 'toggleAddNewUser',
	    value: function toggleAddNewUser() {
	      this.addNewUser = !this.addNewUser;
	    }
	  }, {
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this = this;
	
	      var entityUserCtrl = this;
	
	      entityUserCtrl.lookupService.lookupRoles().then(function (roles) {
	        entityUserCtrl.roles = roles;
	        _this.tempRole = roles[0];
	      });
	
	      entityUserCtrl.lookupService.lookupBrands().then(function (brands) {
	        entityUserCtrl.brands = brands;
	        _this.tempBrand = brands[0];
	      });
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var entityUserCtrl = this;
	
	      entityUserCtrl.formValidationService.initialize(entityUserCtrl.user);
	
	      entityUserCtrl.formValidationService.addField({
	        fieldName: 'email',
	        displayName: 'Email',
	        required: true,
	        stringLength: {
	          min: 5,
	          max: 50
	        }
	      });
	
	      entityUserCtrl.formValidationService.addField({
	        fieldName: 'firstName',
	        displayName: 'First Name',
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      entityUserCtrl.formValidationService.addField({
	        fieldName: 'lastName',
	        displayName: 'Last Name',
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	    }
	  }, {
	    key: 'addUser',
	    value: function addUser() {
	      var _this2 = this;
	
	      var entityUserCtrl = this;
	
	      if (!entityUserCtrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      entityUserCtrl.loadingService.showLoading('addUser', 'Saving Changes ...');
	
	      entityUserCtrl.entityService.addUser(entityUserCtrl.user).then(function (response) {
	        entityUserCtrl.state = 'Saved';
	
	        entityUserCtrl.newUserName = entityUserCtrl.user.firstName + ' ' + entityUserCtrl.user.lastName;
	        entityUserCtrl.selectedUser = {
	          originalObject: entityUserCtrl.user
	        };
	        entityUserCtrl.selectedUser.originalObject.userId = response.data;
	        _this2.closeModal();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          entityUserCtrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            entityUserCtrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          entityUserCtrl.state = 'SystemError';
	          entityUserCtrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        entityUserCtrl.loadingService.hideLoading('addUser');
	      });
	    }
	  }, {
	    key: 'addEntityUser',
	    value: function addEntityUser() {
	      var entityUserCtrl = this;
	      var entityUsers = this.entityUsers;
	
	      if (!entityUserCtrl.selectedUser || !entityUserCtrl.selectedUser.originalObject) {
	        entityUserCtrl.addUserError = 'Please select a User to add';
	        return;
	      }
	
	      var userAccess = (0, _lodash.filter)(entityUsers, function (eu) {
	        return eu.userId === entityUserCtrl.selectedUser.originalObject.userId;
	      });
	
	      if (userAccess.length) {
	        var roleId = userAccess[0].roleId;
	        var brandIds = userAccess.map(function (eu) {
	          return eu.brandId;
	        });
	
	        if (roleId !== entityUserCtrl.tempRole.roleId) {
	          this.addUserError = 'Adding multiple roles for a User is not possible';
	
	          return;
	        }
	
	        if ((0, _lodash.find)(brandIds, function (id) {
	          return id === entityUserCtrl.tempBrand.brandId;
	        })) {
	          this.addUserError = 'User ' + userAccess[0].userName + ' has been already been given access to ' + entityUserCtrl.tempBrand.name;
	
	          return;
	        }
	      }
	
	      entityUsers.push({
	        userId: entityUserCtrl.selectedUser.originalObject.userId,
	        userName: entityUserCtrl.selectedUser.originalObject.firstName + ' ' + entityUserCtrl.selectedUser.originalObject.lastName,
	        roleId: entityUserCtrl.tempRole.roleId,
	        roleName: entityUserCtrl.tempRole.name,
	        brandId: entityUserCtrl.tempBrand.brandId,
	        brandName: entityUserCtrl.tempBrand.name,
	        userPreferences: {
	          entityId: entityUserCtrl.entityId,
	          userId: entityUserCtrl.selectedUser.originalObject.userId
	        }
	      });
	
	      entityUserCtrl.addUserError = '';
	      entityUserCtrl.$scope.$broadcast('angucomplete-alt:clearInput', 'searchUsers');
	      entityUserCtrl.selectedUser = null;
	      entityUserCtrl.tempRole = entityUserCtrl.roles[0];
	      entityUserCtrl.tempBrand = entityUserCtrl.brands[0];
	    }
	  }, {
	    key: 'removeEntityUser',
	    value: function removeEntityUser(entityUser) {
	      this.entityUsers = (0, _lodash.without)(this.entityUsers, entityUser);
	    }
	  }, {
	    key: 'addUserModal',
	    value: function addUserModal() {
	      this.addUserError = '';
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _entityUserAddUserModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'onImageUploaded',
	    value: function onImageUploaded(response) {
	      this.user.imageUrl = response.data[0].value;
	    }
	  }, {
	    key: 'onImageUploadedPref',
	    value: function onImageUploadedPref(response) {
	      this.userPreferences.imageUrl = response.data;
	    }
	  }, {
	    key: 'showUpdateUserPref',
	    value: function showUpdateUserPref(userPreferences) {
	      this.landingPageOptions = [{ id: 0, name: 'Welcome Centre' }, { id: 1, name: 'Dashboard' }, { id: 2, name: 'Lead Monitor WebEnquiries Today' }, { id: 3, name: 'Lead Monitor WebEnquiries This Week' }, { id: 4, name: 'Lead Monitor WebEnquiries Last Week' }, { id: 5, name: 'Lead Monitor Enquiries Today' }, { id: 6, name: 'Lead Monitor Enquiries This Week' }, { id: 7, name: 'Lead Monitor Enquiries Last Week' }];
	
	      this.userPreferences = userPreferences;
	      this.userPreferences.userTitle = userPreferences.firstName + ' ' + userPreferences.lastName;
	      this.profilePicUrl = this.profilePicBaseUrl + '/' + userPreferences.userId;
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _entityUserUserPreferencesModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'updateUserPref',
	    value: function updateUserPref(userPreferences) {
	      var _this3 = this;
	
	      var listPref = (0, _lodash.find)(this.entityUsers, function (eu) {
	        return eu.userId === _this3.userPreferences.userId;
	      });
	      listPref.userName = this.userPreferences.firstName + ' ' + this.userPreferences.lastName;
	
	      this.entityService.updateUserPreferences(this.userPreferences);
	      this.closeModal();
	    }
	  }]);
	  return EntityUserController;
	}();
	
	exports.default = EntityUserController;

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2> Create User </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n    <div class=\"alert alert-danger\" ng-show=\"$ctrl.addUserError !== ''\">\r\n      {{$ctrl.addUserError}}\r\n    </div>\r\n\r\n    <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n      <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n        Please correct the follow errors before proceeding <br> <br>\r\n      </div>\r\n\r\n      <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n        &emsp; - {{msg}} <br>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.email }\">\r\n        <div class=\"col-md-3\">\r\n          <label class=\"control-label\">Email *</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <input type=\"email\" class=\"form-control\" ng-model=\"$ctrl.user.email\" placeholder=\"Enter username here\"  maxLength=50>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.firstName }\">\r\n        <div class=\"col-md-3\">\r\n          <label class=\"control-label\">First Name *</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <input class=\"form-control\" ng-model=\"$ctrl.user.firstName\" placeholder=\"Enter first name here\"  maxLength=50>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.lastName }\">\r\n        <div class=\"col-md-3\">\r\n            <label class=\"control-labe\">Last Name *</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <input class=\"form-control\" ng-model=\"$ctrl.user.lastName\" placeholder=\"Enter last name here\"  maxLength=50>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n          <label class=\"control-labe\">Work Type</label>\r\n      </div>\r\n      <div class=\"col-md-9\">\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"$ctrl.user.workType\" value=\"1\">\r\n          Sales\r\n        </label><br/>\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"$ctrl.user.workType\" value=\"2\">\r\n          Aftersales\r\n        </label><br/>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">&nbsp;</div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">&nbsp;</div>\r\n    </div>    \r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Image</label>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <div upload-button class=\"btn btn-upload btn-primary\" url=\"{{$ctrl.uploadUrl}}\" on-upload1=\"$ctrl.showUploading(response)\" on-error1=\"$ctrl.hideUploading(response)\"\r\n            on-success=\"$ctrl.onImageUploaded(response)\" multiple=\"false\">\r\n            Click here to upload an image\r\n          </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n            <label class=\"control-labe\">&nbsp;</label>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <img ng-src=\"{{$ctrl.mediaUrl}}/{{$ctrl.user.imageUrl}}\" ng-show=\"$ctrl.user.imageUrl\" class=\"user-image\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"modal-footer\">\r\n            <div class=\"col-md-12\">\r\n                <div class=\"form-group\">\r\n\r\n                  <button type=\"submit\" ng-click=\"$ctrl.addUser()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                      <span class=\"glyphicon glyphicon-plus\"></span> Add\r\n                  </button>\r\n\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n        <button type=\"button\"\r\n                class=\"close\"\r\n                data-dismiss=\"modal\"\r\n                aria-hidden=\"true\"\r\n                ng-click=\"$ctrl.closeModal()\">x</button>\r\n        <h2> {{$ctrl.userPreferences.userTitle}}`s Preferences </h2>\r\n    </div>\r\n    \r\n    <div class=\"modal-body\">   \r\n      <div class=\"form-horizontal\">    \r\n        <div class=\"row\">\r\n            <div class=\"col-md-3\">\r\n                <div upload-button class=\"btn-upload\" url=\"{{$ctrl.profilePicUrl}}\" on-success=\"$ctrl.onImageUploadedPref(response)\" multiple=\"false\">\r\n                    <img ng-src='{{$ctrl.userPreferences.imageUrl || \"/images/blankuser.jpg\"}}' class=\"user-image\" />\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-9\">\r\n                <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                        <label class=\"control-label col-sm-3\">Email</label>\r\n                        <label class=\"control-label col-sm-8\">{{$ctrl.userPreferences.email}}</label>\r\n                    </div>                     \r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                        <label class=\"control-label col-sm-3\">First Name</label>\r\n                        <div class=\"col-sm-8\">\r\n                            <input class=\"form-control\" ng-model=\"$ctrl.userPreferences.firstName\" placeholder=\"First Name\" maxlength=\"50\">                    \r\n                        </div>\r\n                    </div>                     \r\n                </div>                \r\n\r\n                <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                        <label class=\"control-label col-sm-3\">Last Name</label>\r\n                        <div class=\"col-sm-8\">\r\n                            <input class=\"form-control\" ng-model=\"$ctrl.userPreferences.lastName\" placeholder=\"Last Name\" maxlength=\"50\">                    \r\n                        </div>\r\n                    </div>                     \r\n                </div> \r\n\r\n                <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                        <label class=\"control-label col-sm-3\">Title</label>\r\n                        <div class=\"col-sm-8\">\r\n                            <input class=\"form-control\" ng-model=\"$ctrl.userPreferences.title\" placeholder=\"Title\" maxlength=\"100\">                    \r\n                        </div>\r\n                    </div>                     \r\n                </div>                 \r\n                \r\n                <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                        <label class=\"control-label col-sm-3\">Phone</label>\r\n                        <div class=\"col-sm-8\">\r\n                            <input class=\"form-control\" ng-model=\"$ctrl.userPreferences.phone\" placeholder=\"Phone\" maxlength=\"100\">                    \r\n                        </div>\r\n                    </div>                     \r\n                </div> \r\n\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\">\r\n                        <label class=\"control-labe\">Work Type</label>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <label>\r\n                        <input type=\"radio\" ng-model=\"$ctrl.userPreferences.userWorkType\" value=\"1\">\r\n                        Sales\r\n                        </label>&nbsp;&nbsp;&nbsp;\r\n                        <label>\r\n                        <input type=\"radio\" ng-model=\"$ctrl.userPreferences.userWorkType\" value=\"2\">\r\n                        Aftersales\r\n                        </label>\r\n                    </div>\r\n                </div>                \r\n            </div>\r\n        </div>\r\n\r\n        <hr class=\"boldHr\" />\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-8 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Default Landing Page\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n                <select class=\"form-control\" ng-options=\"opt.id as opt.name for opt in $ctrl.landingPageOptions\" ng-model=\"$ctrl.userPreferences.landingPage\"></select>\r\n            </div>            \r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when an Enquiry is Confirmed\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.enquiryConfirmed\"></switch>\r\n            </div>            \r\n        </div>\r\n\r\n        <div class=\"row\" ng-show=\"$ctrl.userPreferences.enquiryConfirmed\">\r\n            <div class=\"col-md-2\">\r\n                <label>\r\n                    Retail\r\n                    <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.Retail\" ng-enum-model=\"$ctrl.userPreferences.confirmedEmailType\" />\r\n                </label>\r\n            </div>              \r\n            <div class=\"col-md-2\">\r\n                <label>\r\n                    Trade\r\n                    <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.Trade\" ng-enum-model=\"$ctrl.userPreferences.confirmedEmailType\" />\r\n                </label>\r\n            </div>                           \r\n            <div class=\"col-md-2\">\r\n                <label>\r\n                    Buy In\r\n                    <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.BuyIn\" ng-enum-model=\"$ctrl.userPreferences.confirmedEmailType\" />\r\n                </label>\r\n            </div>                                           \r\n        </div>        \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Retail Enquiry Confirmed Email Format\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <label>\r\n                    <input type=\"radio\" ng-model=\"$ctrl.userPreferences.confirmedEmailFormat\" ng-value=\"false\">\r\n                    Basic\r\n                </label>\r\n                <label>\r\n                    <input type=\"radio\" ng-model=\"$ctrl.userPreferences.confirmedEmailFormat\" ng-value=\"true\">\r\n                    Full\r\n                </label>                \r\n            </div>            \r\n        </div>        \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when an Enquiry is Delivered\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.enquiryClosed\"></switch>\r\n            </div>            \r\n        </div>   \r\n\r\n        <div class=\"row\" ng-show=\"$ctrl.userPreferences.enquiryClosed\">\r\n                <div class=\"col-md-2\">\r\n                    <label>\r\n                        Retail\r\n                        <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.Retail\" ng-enum-model=\"$ctrl.userPreferences.closedEmailType\" />\r\n                    </label>\r\n                </div>              \r\n                <div class=\"col-md-2\">\r\n                    <label>\r\n                        Trade\r\n                        <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.Trade\" ng-enum-model=\"$ctrl.userPreferences.closedEmailType\" />\r\n                    </label>\r\n                </div>                           \r\n                <div class=\"col-md-2\">\r\n                    <label>\r\n                        Buy In\r\n                        <input type=\"checkbox\" ng-enum-flag=\"$ctrl.enums.ENQUIRY_CONFIRMED_EMAIL_TYPE.BuyIn\" ng-enum-model=\"$ctrl.userPreferences.closedEmailType\" />\r\n                    </label>\r\n                </div>                                           \r\n            </div>         \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when an Enquiry is Lost\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.enquiryLost\"></switch>\r\n            </div>            \r\n        </div>        \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when a Finance Deal is Created\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.financeCreated\"></switch>\r\n            </div>            \r\n        </div>               \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when a Finance Deal is Updated\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.financeUpdated\"></switch>\r\n            </div>            \r\n        </div>        \r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an email when a Finance Deal is Customer Accepted\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.financeAccepted\"></switch>\r\n            </div>            \r\n        </div>                \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Make this location Default Location for this User\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.defaultLocation\"></switch>\r\n            </div>            \r\n        </div>\r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Show Dashboard for this User by default\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.dashboardDefaultMyUser\"></switch>\r\n            </div>            \r\n        </div>        \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Hide this user from Welcome Centre / Dashboard\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.dashboardHidden\"></switch>\r\n            </div>            \r\n        </div>    \r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Show all users in Welcome Centre\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.receptionistWelcomeCentre\"></switch>\r\n            </div>            \r\n        </div>            \r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Hide from Reports\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.reportsHidden\"></switch>\r\n            </div>            \r\n        </div> \r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send an Email when a Web Enquiry is received\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.webEnquiryEmail\"></switch>\r\n            </div>            \r\n        </div>    \r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-md-10 ph10 mb5\">\r\n                <label class=\"control-label\">\r\n                    Send a copy of the Sales Quotation\r\n                </label>\r\n            </div>\r\n            <div class=\"col-md-2\">\r\n                <switch ng-model=\"$ctrl.userPreferences.salesQuoteBcc\"></switch>\r\n            </div>            \r\n        </div>            \r\n\r\n        <div class=\"row\">\r\n            <div class=\"modal-footer\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"form-group\">\r\n    \r\n                      <button type=\"submit\" ng-click=\"$ctrl.updateUserPref()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                          Save Changes\r\n                      </button>\r\n    \r\n    \r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    \r\n      </div>\r\n    </div>\r\n    "

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(748);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./entityUser.styl", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/stylus-loader/index.js!./entityUser.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".entityUser{color:red}.boldHr{border:2px solid #596568;margin:auto;margin-bottom:2%}", ""]);
	
	// exports


/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityService = function () {
	  EntityService.$inject = ["$http", "appConfig"];
	  function EntityService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EntityService);
	    this._$http = $http;
	    this._appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(EntityService, [{
	    key: 'listEntitiesOld',
	    value: function listEntitiesOld(entityType, entityId) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list/' + entityType + '/' + entityId);
	    }
	  }, {
	    key: 'addEntity',
	    value: function addEntity(entity) {
	      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/add', entity);
	    }
	  }, {
	    key: 'addUser',
	    value: function addUser(user) {
	      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/user/add', user);
	    }
	  }, {
	    key: 'getEntity',
	    value: function getEntity(entityId) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/get/' + entityId));
	    }
	  }, {
	    key: 'listEntities',
	    value: function listEntities(filterParams, pageStart, pageSize) {
	      var query = '?pageStart=' + pageStart + '&itemsToFetch=' + pageSize;
	
	      if (filterParams && filterParams.name) {
	        query += '&name=' + filterParams.name;
	      }
	
	      if (filterParams && filterParams.entityType) {
	        query += '&entityType=' + filterParams.entityType;
	      }
	
	      if (filterParams && filterParams.brandType) {
	        query += '&brandType=' + filterParams.brandType;
	      }
	
	      if (filterParams && filterParams.state) {
	        query += '&state=' + filterParams.state;
	      }
	
	      if (filterParams && filterParams.sortExpression) {
	        query += '&sortExpression=' + filterParams.sortExpression + '&ascending=' + filterParams.ascending;
	      }
	
	      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list' + query);
	    }
	  }, {
	    key: 'updateEntityState',
	    value: function updateEntityState(entityId, state) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/update/' + entityId + '/' + state));
	    }
	  }, {
	    key: 'updateUserPreferences',
	    value: function updateUserPreferences(userPreferences) {
	      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updateuserpref/', userPreferences);
	    }
	  }, {
	    key: 'listAllLocations',
	    value: function listAllLocations() {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/listalllocations');
	    }
	  }, {
	    key: 'listAllImportLocations',
	    value: function listAllImportLocations() {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/listallimportlocations');
	    }
	  }, {
	    key: 'getEntityPreferences',
	    value: function getEntityPreferences(entityId) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/getentitypreferences/' + entityId));
	    }
	  }, {
	    key: 'updateEntityPreferences',
	    value: function updateEntityPreferences(entityPrefs) {
	      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updateentitypreferences', entityPrefs);
	    }
	  }, {
	    key: 'getEntityReportsAccess',
	    value: function getEntityReportsAccess(entityId) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/getentityreportsaccess/' + entityId));
	    }
	  }, {
	    key: 'toggleEntityReportAccess',
	    value: function toggleEntityReportAccess(entityId, reportId) {
	      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/toggleentityreportaccess/' + entityId + '/' + reportId));
	    }
	  }, {
	    key: 'updateStockProvider',
	    value: function updateStockProvider(stockProviderViewModel) {
	      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updatestockprovider/', stockProviderViewModel);
	    }
	  }]);
	  return EntityService;
	}();
	
	exports.default = EntityService;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryExtraManagement = __webpack_require__(763);
	
	var _enquiryExtraManagement2 = _interopRequireDefault(_enquiryExtraManagement);
	
	var _enquiryExtraContainer = __webpack_require__(790);
	
	var _enquiryExtraContainer2 = _interopRequireDefault(_enquiryExtraContainer);
	
	var _enquiryExtraManagement3 = __webpack_require__(796);
	
	var _enquiryExtraManagement4 = _interopRequireDefault(_enquiryExtraManagement3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryExtraManagementModule = _angular2.default.module('enquiryExtraManagement', [_angularUiRouter2.default, _enquiryExtraContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquiryExtraManagement', {
	    url: '/enquiryExtraManagement',
	    component: 'enquiryExtraManagement'
	  });
	}]).component('enquiryExtraManagement', _enquiryExtraManagement2.default).service('enquiryExtraManagementService', _enquiryExtraManagement4.default).name;
	
	exports.default = enquiryExtraManagementModule;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryExtraManagement = __webpack_require__(764);
	
	var _enquiryExtraManagement2 = _interopRequireDefault(_enquiryExtraManagement);
	
	var _enquiryExtraManagement3 = __webpack_require__(765);
	
	var _enquiryExtraManagement4 = _interopRequireDefault(_enquiryExtraManagement3);
	
	__webpack_require__(788);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryExtraManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiryExtraManagement2.default,
	  controller: _enquiryExtraManagement4.default
	};
	
	exports.default = enquiryExtraManagementComponent;

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryExtraManagementController = function () {
	  EnquiryExtraManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function EnquiryExtraManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryExtraManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(EnquiryExtraManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('enquiryExtraManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return EnquiryExtraManagementController;
	}();
	
	exports.default = EnquiryExtraManagementController;

/***/ }),
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(789);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryExtraManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryExtraManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryExtraManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryExtraContainer = __webpack_require__(791);
	
	var _enquiryExtraContainer2 = _interopRequireDefault(_enquiryExtraContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryExtraContainerModule = _angular2.default.module('enquiryExtraContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquiryExtraManagement.container', {
	    url: '/:locationId',
	    component: 'enquiryExtraContainer'
	  });
	}]).component('enquiryExtraContainer', _enquiryExtraContainer2.default).name;
	
	exports.default = enquiryExtraContainerModule;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryExtraContainer = __webpack_require__(792);
	
	var _enquiryExtraContainer2 = _interopRequireDefault(_enquiryExtraContainer);
	
	var _enquiryExtraContainer3 = __webpack_require__(793);
	
	var _enquiryExtraContainer4 = _interopRequireDefault(_enquiryExtraContainer3);
	
	__webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryExtraContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiryExtraContainer2.default,
	  controller: _enquiryExtraContainer4.default
	};
	
	exports.default = enquiryExtraContainerComponent;

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"enquiryExtraList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Enquiry Extra Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-6\">Name</th>\r\n          <th class=\"col-md-2\">Default Price</th>\r\n          <th class=\"col-md-2\">Reportable</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"e in $ctrl.enquiryExtraLookups\">\r\n            <td class=\"col-md-6\">{{e.name}}</td>\r\n            <td class=\"col-md-2\">{{e.defaultPrice | currency:'&euro;':2}}</td>\r\n            <td class=\"col-md-2\">{{e.reportable ? 'Yes' : 'No'}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showEdit(e)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEnquiryExtra(e)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryExtraContainerController = function () {
	  EnquiryExtraContainerController.$inject = ["authService", "enums", "$stateParams", "lookupService", "loadingService", "enquiryExtraManagementService", "addEditEnquiryExtraService"];
	  function EnquiryExtraContainerController(authService, enums, $stateParams, lookupService, loadingService, enquiryExtraManagementService, addEditEnquiryExtraService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryExtraContainerController);
	    this.$stateParams = $stateParams;
	    this.lookupService = lookupService;
	    this.loadingService = loadingService;
	    this.enquiryExtraManagementService = enquiryExtraManagementService;
	    this.addEditEnquiryExtraService = addEditEnquiryExtraService;
	
	    this.enquiryExtraLookups = [];
	    this.initializeEnquiryExtras();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(EnquiryExtraContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializeEnquiryExtras',
	    value: function initializeEnquiryExtras() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquiryExtraList', 'Loading Extras ...');
	
	      ctrl.lookupService.lookupEnquiryPrices(ctrl.$stateParams.locationId).then(function (data) {
	        ctrl.enquiryExtraLookups = (0, _lodash.orderBy)(data.enquiryExtras, function (o) {
	          return o.name.toLowerCase();
	        });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiryExtraList');
	      });
	    }
	  }, {
	    key: 'removeEnquiryExtra',
	    value: function removeEnquiryExtra(enquiryExtra) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquiryExtraList', 'Removing Extra ...');
	
	      ctrl.enquiryExtraManagementService.removeEnquiryExtra(ctrl.$stateParams.locationId, enquiryExtra.enquiryExtraId).finally(function () {
	        ctrl.initializeEnquiryExtras();
	        ctrl.loadingService.hideLoading('enquiryExtraList');
	      });
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      this.addEditEnquiryExtraService.showAdd(this.enquiryExtraLookups, this.addEnquiryExtra.bind(this));
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(enquiryExtra) {
	      var _this = this;
	
	      this.addEditEnquiryExtraService.showEdit(this.enquiryExtraLookups, enquiryExtra, function () {
	        _this.enquiryExtraLookups = (0, _lodash.orderBy)(_this.enquiryExtraLookups, function (o) {
	          return o.name.toLowerCase();
	        });
	      });
	    }
	  }, {
	    key: 'addEnquiryExtra',
	    value: function addEnquiryExtra(newItem) {
	      this.enquiryExtraLookups.push(newItem);
	      this.enquiryExtraLookups = (0, _lodash.orderBy)(this.enquiryExtraLookups, function (o) {
	        return o.name.toLowerCase();
	      });
	    }
	  }]);
	  return EnquiryExtraContainerController;
	}();
	
	exports.default = EnquiryExtraContainerController;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(795);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryExtraContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryExtraContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryExtraContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryExtraManagementService = function () {
	  EnquiryExtraManagementService.$inject = ["$http", "appConfig"];
	  function EnquiryExtraManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryExtraManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(EnquiryExtraManagementService, [{
	    key: "addEnquiryExtra",
	    value: function addEnquiryExtra(entityId, extra) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/enquiryextra/add/" + entityId), extra);
	    }
	  }, {
	    key: "editEnquiryExtra",
	    value: function editEnquiryExtra(entityId, enquiryExtraId, extra) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/enquiryextra/edit/" + entityId + "/" + enquiryExtraId), extra);
	    }
	  }, {
	    key: "removeEnquiryExtra",
	    value: function removeEnquiryExtra(entityId, enquiryExtraId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/enquiryextra/remove/" + entityId + "/" + enquiryExtraId));
	    }
	  }]);
	  return EnquiryExtraManagementService;
	}();
	
	exports.default = EnquiryExtraManagementService;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financialProductManagement = __webpack_require__(798);
	
	var _financialProductManagement2 = _interopRequireDefault(_financialProductManagement);
	
	var _FinancialProductManagement = __webpack_require__(803);
	
	var _FinancialProductManagement2 = _interopRequireDefault(_FinancialProductManagement);
	
	var _financialProductContainer = __webpack_require__(804);
	
	var _financialProductContainer2 = _interopRequireDefault(_financialProductContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financialProductManagementModule = _angular2.default.module('financialProductManagement', [_angularUiRouter2.default, _financialProductContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('financialProductManagement', {
	    url: '/financialProductManagement',
	    component: 'financialProductManagement'
	  });
	}]).component('financialProductManagement', _financialProductManagement2.default).service('financialProductManagementService', _FinancialProductManagement2.default).name;
	
	exports.default = financialProductManagementModule;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financialProductManagement = __webpack_require__(799);
	
	var _financialProductManagement2 = _interopRequireDefault(_financialProductManagement);
	
	var _financialProductManagement3 = __webpack_require__(800);
	
	var _financialProductManagement4 = _interopRequireDefault(_financialProductManagement3);
	
	__webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financialProductManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financialProductManagement2.default,
	  controller: _financialProductManagement4.default
	};
	
	exports.default = financialProductManagementComponent;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancialProductManagementController = function () {
	  FinancialProductManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function FinancialProductManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinancialProductManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(FinancialProductManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('financialProductManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return FinancialProductManagementController;
	}();
	
	exports.default = FinancialProductManagementController;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(802);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financialProductManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financialProductManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financialProductManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancialProductManagementService = function () {
	  FinancialProductManagementService.$inject = ["$http", "appConfig"];
	  function FinancialProductManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinancialProductManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(FinancialProductManagementService, [{
	    key: "addFinancialProduct",
	    value: function addFinancialProduct(entityId, extraName, reportable, defaultPrice) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/financialproduct/add/" + entityId + "/" + extraName + "/" + reportable + "/" + defaultPrice));
	    }
	  }, {
	    key: "editFinancialProduct",
	    value: function editFinancialProduct(entityId, financialProductId, extraName, reportable, defaultPrice) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/financialproduct/edit/" + entityId + "/" + financialProductId + "/" + extraName + "/" + reportable + "/" + defaultPrice));
	    }
	  }, {
	    key: "removeFinancialProduct",
	    value: function removeFinancialProduct(entityId, financialProductId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/financialproduct/remove/" + entityId + "/" + financialProductId));
	    }
	  }]);
	  return FinancialProductManagementService;
	}();
	
	exports.default = FinancialProductManagementService;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financialProductContainer = __webpack_require__(805);
	
	var _financialProductContainer2 = _interopRequireDefault(_financialProductContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financialProductContainerModule = _angular2.default.module('financialProductContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('financialProductManagement.container', {
	    url: '/:locationId',
	    component: 'financialProductContainer'
	  });
	}]).component('financialProductContainer', _financialProductContainer2.default).name;
	
	exports.default = financialProductContainerModule;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financialProductContainer = __webpack_require__(806);
	
	var _financialProductContainer2 = _interopRequireDefault(_financialProductContainer);
	
	var _financialProductContainer3 = __webpack_require__(807);
	
	var _financialProductContainer4 = _interopRequireDefault(_financialProductContainer3);
	
	__webpack_require__(808);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financialProductContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financialProductContainer2.default,
	  controller: _financialProductContainer4.default
	};
	
	exports.default = financialProductContainerComponent;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"financialProductList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Financial Product Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-6\">Name</th>\r\n          <th class=\"col-md-2\">Default Price</th>\r\n          <th class=\"col-md-2\">Reportable</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"e in $ctrl.financialProductLookups\">\r\n            <td class=\"col-md-6\">{{e.name}}</td>\r\n            <td class=\"col-md-2\">{{e.defaultPrice | currency:'&euro;':2}}</td>\r\n            <td class=\"col-md-2\">{{e.reportable ? 'Yes' : 'No'}}</td>          \r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showEdit(e)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeFinancialProduct(e)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancialProductContainerController = function () {
	  FinancialProductContainerController.$inject = ["authService", "enums", "$stateParams", "lookupService", "loadingService", "financialProductManagementService", "addEditFinancialProductService"];
	  function FinancialProductContainerController(authService, enums, $stateParams, lookupService, loadingService, financialProductManagementService, addEditFinancialProductService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinancialProductContainerController);
	    this.$stateParams = $stateParams;
	    this.lookupService = lookupService;
	    this.loadingService = loadingService;
	    this.financialProductManagementService = financialProductManagementService;
	    this.addEditFinancialProductService = addEditFinancialProductService;
	
	    this.financialProductLookups = [];
	    this.initializeFinancialProducts();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(FinancialProductContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializeFinancialProducts',
	    value: function initializeFinancialProducts() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financialProductList', 'Loading Products ...');
	
	      ctrl.lookupService.lookupEnquiryPrices(ctrl.$stateParams.locationId).then(function (data) {
	        ctrl.financialProductLookups = data.financialProducts;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('financialProductList');
	      });
	    }
	  }, {
	    key: 'removeFinancialProduct',
	    value: function removeFinancialProduct(financialProduct) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financialProductList', 'Removing Product ...');
	
	      ctrl.financialProductManagementService.removeFinancialProduct(ctrl.$stateParams.locationId, financialProduct.financialProductId).finally(function () {
	        ctrl.initializeFinancialProducts();
	        ctrl.loadingService.hideLoading('financialProductList');
	      });
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      this.addEditFinancialProductService.showAdd(this.financialProductLookups, this.addFinancialProduct.bind(this));
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(financialProduct) {
	      this.addEditFinancialProductService.showEdit(this.financialProductLookups, financialProduct);
	    }
	  }, {
	    key: 'addFinancialProduct',
	    value: function addFinancialProduct(newItem) {
	      this.financialProductLookups.push(newItem);
	    }
	  }]);
	  return FinancialProductContainerController;
	}();
	
	exports.default = FinancialProductContainerController;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(809);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financialProductContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financialProductContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financialProductContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquirySourceManagement = __webpack_require__(811);
	
	var _enquirySourceManagement2 = _interopRequireDefault(_enquirySourceManagement);
	
	var _enquirySourceContainer = __webpack_require__(816);
	
	var _enquirySourceContainer2 = _interopRequireDefault(_enquirySourceContainer);
	
	var _EnquirySourcesManagement = __webpack_require__(822);
	
	var _EnquirySourcesManagement2 = _interopRequireDefault(_EnquirySourcesManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquirySourceManagementModule = _angular2.default.module('enquirySourceManagement', [_enquirySourceContainer2.default, _angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquirySourceManagement', {
	    url: '/enquirySourceManagement',
	    component: 'enquirySourceManagement'
	  });
	}]).component('enquirySourceManagement', _enquirySourceManagement2.default).service('enquirySourcesManagementService', _EnquirySourcesManagement2.default).name;
	
	exports.default = enquirySourceManagementModule;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquirySourceManagement = __webpack_require__(812);
	
	var _enquirySourceManagement2 = _interopRequireDefault(_enquirySourceManagement);
	
	var _enquirySourceManagement3 = __webpack_require__(813);
	
	var _enquirySourceManagement4 = _interopRequireDefault(_enquirySourceManagement3);
	
	__webpack_require__(814);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquirySourceManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquirySourceManagement2.default,
	  controller: _enquirySourceManagement4.default
	};
	
	exports.default = enquirySourceManagementComponent;

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquirySourceManagementController = function () {
	  EnquirySourceManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function EnquirySourceManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquirySourceManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(EnquirySourceManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('enquirySourceManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return EnquirySourceManagementController;
	}();
	
	exports.default = EnquirySourceManagementController;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(815);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquirySourceManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquirySourceManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquirySourceManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquirySourceContainer = __webpack_require__(817);
	
	var _enquirySourceContainer2 = _interopRequireDefault(_enquirySourceContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquirySourceContainerModule = _angular2.default.module('enquirySourceContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquirySourceManagement.container', {
	    url: '/:locationId',
	    component: 'enquirySourceContainer'
	  });
	}]).component('enquirySourceContainer', _enquirySourceContainer2.default).name;
	
	exports.default = enquirySourceContainerModule;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquirySourceContainer = __webpack_require__(818);
	
	var _enquirySourceContainer2 = _interopRequireDefault(_enquirySourceContainer);
	
	var _enquirySourceContainer3 = __webpack_require__(819);
	
	var _enquirySourceContainer4 = _interopRequireDefault(_enquirySourceContainer3);
	
	__webpack_require__(820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquirySourceContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquirySourceContainer2.default,
	  controller: _enquirySourceContainer4.default
	};
	
	exports.default = enquirySourceContainerComponent;

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"enquirySourcesList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Enquiry Sources Management</h2>\r\n      </header>\r\n      \r\n      <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n          <span class=\"glyphicon glyphicon-plus\"></span>\r\n          Add New\r\n      </a>      \r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-7\">Enquiry Source Name</th>\r\n          <th class=\"col-md-2\">Monthly Spend</th>\r\n          <th class=\"col-md-1\">Enabled</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"src in $ctrl.enquirySources\">\r\n            <td class=\"col-md-7\">{{src.name}}</td>\r\n            <td class=\"col-md-2\">{{src.spend | currency:'&euro;':2}}</th>\r\n            <td class=\"col-md-1\"><switch ng-model=\"src.enabled\" ng-change=\"$ctrl.toggleEnabled(src.enquirySourceId)\"></switch></td>\r\n            <td class=\"col-md-1\">\r\n              <a class=\"btn btn-link\" ng-click=\"$ctrl.showEdit(src)\">Update</a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n              <a class=\"btn btn-link\" ng-click=\"$ctrl.removeEnquirySource(src)\">Remove</a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquirySourceContainerController = function () {
	  EnquirySourceContainerController.$inject = ["authService", "enums", "$stateParams", "enquirySourcesManagementService", "loadingService", "$ngConfirm", "$scope"];
	  function EnquirySourceContainerController(authService, enums, $stateParams, enquirySourcesManagementService, loadingService, $ngConfirm, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquirySourceContainerController);
	    this.$stateParams = $stateParams;
	    this.enquirySourcesManagementService = enquirySourcesManagementService;
	    this.loadingService = loadingService;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	
	    this.enquirySources = [];
	    this.initializeEnquirySources();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(EnquirySourceContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializeEnquirySources',
	    value: function initializeEnquirySources() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquirySourcesList', 'Loading Enquiry Sources ...');
	
	      ctrl.enquirySourcesManagementService.list(ctrl.$stateParams.locationId, false).then(function (response) {
	        ctrl.enquirySources = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquirySourcesList');
	      });
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      var _this = this;
	
	      this.$scope.errMsg = null;
	
	      this.$scope.tempSource = {
	        name: null,
	        spend: null
	      };
	
	      this.$ngConfirm({
	        title: 'Add Enquiry Source',
	        contentUrl: 'templates/admin/editEnquirySourceTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (!_this.$scope.tempSource.name) {
	                _this.$scope.errMsg = "Please enter a name";
	                return false;
	              }
	
	              _this.addEnquirySource();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(src) {
	      var _this2 = this;
	
	      this.$scope.errMsg = null;
	
	      this.$scope.tempSource = {
	        enquirySourceId: src.enquirySourceId,
	        name: src.name,
	        spend: src.spend
	      };
	
	      this.$ngConfirm({
	        title: 'Update Enquiry Source',
	        contentUrl: 'templates/admin/editEnquirySourceTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              _this2.updateEnquirySource();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateAddEnquirySource',
	    value: function validateAddEnquirySource(name) {
	      var ctrl = this;
	
	      ctrl.resetNotification();
	
	      if (!name || name.length < 3 || name.length > 40) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Name is required field and must be between 3 and 40 characters'
	        };
	
	        return false;
	      } else if ((0, _lodash.find)(ctrl.enquirySources, function (e) {
	        return e.name.toLowerCase() === name.toLowerCase();
	      })) {
	        ctrl.notification = {
	          type: 'error',
	          msg: name + ' is already added to the list'
	        };
	
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'addEnquirySource',
	    value: function addEnquirySource() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquirySourcesList', 'Adding Enquiry Source ...');
	
	      ctrl.enquirySourcesManagementService.add(ctrl.$stateParams.locationId, ctrl.$scope.tempSource).then(function (response) {
	        ctrl.initializeEnquirySources();
	      }).catch(function (err) {
	        _this3.notification = {
	          type: 'error',
	          msg: 'An error occurred while adding source'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquirySourcesList');
	      });
	    }
	  }, {
	    key: 'updateEnquirySource',
	    value: function updateEnquirySource() {
	      var _this4 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquirySourcesList', 'Updating Enquiry Source ...');
	
	      ctrl.enquirySourcesManagementService.update(ctrl.$stateParams.locationId, this.$scope.tempSource).then(function (response) {
	        ctrl.initializeEnquirySources();
	      }).catch(function (err) {
	        _this4.notification = {
	          type: 'error',
	          msg: 'An error occurred while updating source'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquirySourcesList');
	      });
	    }
	  }, {
	    key: 'removeEnquirySource',
	    value: function removeEnquirySource(src) {
	      var _this5 = this;
	
	      var ctrl = this;
	      ctrl.initializeEnquirySources();
	
	      var sure = confirm('Are you sure you want to delete this enquiry source. ' + src.name);
	
	      if (!sure) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('enquirySourcesList', 'Removing Enquiry Source ...');
	
	      ctrl.enquirySourcesManagementService.delete(ctrl.$stateParams.locationId, src.enquirySourceId).then(function (response) {
	        ctrl.notification = {
	          type: 'success',
	          msg: 'Source removed successfully'
	        };
	
	        ctrl.initializeEnquirySources();
	      }).catch(function (err) {
	        _this5.notification = {
	          type: 'error',
	          msg: 'An error occurred while removed source'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquirySourcesList');
	      });
	    }
	  }, {
	    key: 'toggleEnabled',
	    value: function toggleEnabled(enquirySourceId) {
	      var _this6 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquirySourcesList', 'Updating Enquiry Source ...');
	
	      ctrl.enquirySourcesManagementService.toggleEnabled(ctrl.$stateParams.locationId, enquirySourceId).then(function (response) {
	        ctrl.notification = {
	          type: 'success',
	          msg: 'Source updated successfully'
	        };
	      }).catch(function (err) {
	        _this6.notification = {
	          type: 'error',
	          msg: 'An error occurred while adding source'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquirySourcesList');
	      });
	    }
	  }]);
	  return EnquirySourceContainerController;
	}();
	
	exports.default = EnquirySourceContainerController;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(821);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquirySourceContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquirySourceContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquirySourceContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquirySourcesManagementService = function () {
	  EnquirySourcesManagementService.$inject = ["$http", "appConfig"];
	  function EnquirySourcesManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquirySourcesManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(EnquirySourcesManagementService, [{
	    key: "list",
	    value: function list(entityId, enabledOnly) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/enquirysources/list/" + entityId + "/" + enabledOnly));
	    }
	  }, {
	    key: "add",
	    value: function add(entityId, enquirySource) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/enquirysources/add/" + entityId), enquirySource);
	    }
	  }, {
	    key: "update",
	    value: function update(entityId, enquirySource) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/enquirysources/update/" + entityId), enquirySource);
	    }
	  }, {
	    key: "delete",
	    value: function _delete(entityId, enquirySourceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/enquirysources/delete/" + entityId + "/" + enquirySourceId + "/"));
	    }
	  }, {
	    key: "toggleEnabled",
	    value: function toggleEnabled(entityId, enquirySourceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/enquirysources/toggle/" + entityId + "/" + enquirySourceId + "/"));
	    }
	  }]);
	  return EnquirySourcesManagementService;
	}();
	
	exports.default = EnquirySourcesManagementService;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _retailPriceList = __webpack_require__(824);
	
	var _retailPriceList2 = _interopRequireDefault(_retailPriceList);
	
	var _viewRetailPriceList = __webpack_require__(829);
	
	var _viewRetailPriceList2 = _interopRequireDefault(_viewRetailPriceList);
	
	var _retailPriceListEdit = __webpack_require__(835);
	
	var _retailPriceListEdit2 = _interopRequireDefault(_retailPriceListEdit);
	
	var _retailPriceList3 = __webpack_require__(841);
	
	var _retailPriceList4 = _interopRequireDefault(_retailPriceList3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var retailPriceListModule = _angular2.default.module('retailPriceList', [_angularUiRouter2.default, _viewRetailPriceList2.default, _retailPriceListEdit2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('retailPriceList', {
	    url: '/retailPriceList',
	    component: 'retailPriceList'
	  });
	}]).component('retailPriceList', _retailPriceList2.default).service('retailPriceListService', _retailPriceList4.default).name;
	
	exports.default = retailPriceListModule;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _retailPriceList = __webpack_require__(825);
	
	var _retailPriceList2 = _interopRequireDefault(_retailPriceList);
	
	var _retailPriceList3 = __webpack_require__(826);
	
	var _retailPriceList4 = _interopRequireDefault(_retailPriceList3);
	
	__webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var retailPriceListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _retailPriceList2.default,
	  controller: _retailPriceList4.default
	};
	
	exports.default = retailPriceListComponent;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\" block-ui=\"retailPriceListUpload\">\r\n\r\n      <div class=\"alert\" ng-show=\"$ctrl.notification.msg != ''\" ng-class=\"{'alert-danger': $ctrl.notification.type === 'error', 'alert-success': $ctrl.notification.type === 'success'}\">\r\n          {{$ctrl.notification.msg}}\r\n      </div>\r\n\r\n      <button upload-button class=\"btn btn-upload btn-primary\" url=\"{{$ctrl.uploadUrl}}\" on-upload=\"$ctrl.showUploading(response)\" on-error=\"$ctrl.showError(response)\"\r\n        on-success=\"$ctrl.onCsvUploadSuccess(response)\">\r\n        Click here to upload a new Reatil Price List file (.CSV Only)\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <table class=\"table table-striped table-bordered table-hover\">\r\n        <tr>\r\n          <th class=\"col-md-2\">Brand</th>\r\n          <th class=\"col-md-2\">Model</th>\r\n          <th class=\"col-md-2\">Variant</th>\r\n          <th class=\"col-md-1\">Retail Price</th>\r\n          <th class=\"col-md-1\">Body</th>\r\n          <th class=\"col-md-1\">Capacity</th>\r\n          <th class=\"col-md-1\">Transmission</th>\r\n          <th class=\"col-md-1\">Fuel Type</th>\r\n          <th class=\"col-md-1\">Vehicle Type</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"r in $ctrl.retailPriceList\" ng-class=\"{'retailPriceListModelNotFound' : (r.brandModelId === 0),  'retailPriceListModelFound' : (r.brandModelId !== 0)}\">\r\n            <td class=\"col-md-2\">{{r.brandName}}</td>\r\n            <td class=\"col-md-2\">{{r.brandModelName}}</td>\r\n            <td class=\"col-md-2\">{{r.variant}}</td>\r\n            <td class=\"col-md-1\">{{r.retailPrice | currency:'&euro;':2}}</td>\r\n            <td class=\"col-md-1\">{{r.bodyType}}</td>\r\n            <td class=\"col-md-1\">{{r.capacity}}</td>\r\n            <td class=\"col-md-1\">{{r.transmissionType}}</td>\r\n            <td class=\"col-md-1\">{{r.fuelType}}</td>\r\n            <td class=\"col-md-1\">{{r.vehicleType}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RetailPriceListController = function () {
	  RetailPriceListController.$inject = ["authService", "appConfig", "loadingService"];
	  function RetailPriceListController(authService, appConfig, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, RetailPriceListController);
	    if (!authService.authData.isAdmin) {
	      return;
	    }
	
	    this.loadingService = loadingService;
	    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/uploadRetailPriceList';
	
	    this.notification = {
	      type: '',
	      msg: ''
	    };
	  }
	
	  (0, _createClass3.default)(RetailPriceListController, [{
	    key: 'showUploading',
	    value: function showUploading() {
	      var ctrl = this;
	
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	
	      ctrl.loadingService.showLoading('retailPriceListUpload', 'Uploading Media Item(s)');
	    }
	  }, {
	    key: 'showError',
	    value: function showError(response) {
	      var ctrl = this;
	
	      if (response.status === 500) {
	        ctrl.notification = {
	          type: 'error',
	          msg: response.data.exceptionMessage
	        };
	      } else {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Something went wront'
	        };
	      }
	
	      ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
	    }
	  }, {
	    key: 'onCsvUploadSuccess',
	    value: function onCsvUploadSuccess(response) {
	      var ctrl = this;
	      ctrl.retailPriceList = response.data;
	
	      ctrl.notification = {
	        type: 'success',
	        msg: 'Retail Price List updated successfully'
	      };
	
	      ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
	    }
	  }]);
	  return RetailPriceListController;
	}();
	
	exports.default = RetailPriceListController;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(828);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./retailPriceList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./retailPriceList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".retailPriceListModelFound{color:green}.retailPriceListModelNotFound{color:red}", ""]);
	
	// exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _viewRetailPriceList = __webpack_require__(830);
	
	var _viewRetailPriceList2 = _interopRequireDefault(_viewRetailPriceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewRetailPriceListModule = _angular2.default.module('viewRetailPriceList', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('viewRetailPriceList', {
	    url: '/retailPriceList/view',
	    component: 'viewRetailPriceList'
	  });
	}]).component('viewRetailPriceList', _viewRetailPriceList2.default).name;
	
	exports.default = viewRetailPriceListModule;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _viewRetailPriceList = __webpack_require__(831);
	
	var _viewRetailPriceList2 = _interopRequireDefault(_viewRetailPriceList);
	
	var _viewRetailPriceList3 = __webpack_require__(832);
	
	var _viewRetailPriceList4 = _interopRequireDefault(_viewRetailPriceList3);
	
	__webpack_require__(833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewRetailPriceListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _viewRetailPriceList2.default,
	  controller: _viewRetailPriceList4.default
	};
	
	exports.default = viewRetailPriceListComponent;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"retailPriceList\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Retail Price List</h2>\r\n\r\n          <a class=\"btn btn-success\"\r\n            ui-sref=\"retailPriceList\">\r\n              <span class=\"glyphicon glyphicon-upload\"></span>\r\n              Upload Retail Price List\r\n          </a>\r\n\r\n          <a class=\"btn btn-warning\"\r\n            ng-click=\"$ctrl.clear()\">\r\n            <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\r\n              Clear Retail Price List\r\n          </a>          \r\n      </header><br />\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.updateBrandModel()\"\r\n              ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n              ng-model=\"$ctrl.filterParams.brand\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n              ng-model=\"$ctrl.filterParams.brandModel\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Variant\"\r\n              ng-model=\"$ctrl.filterParams.variant\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.viewAllRetailPriceList()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <tr>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('brand')\">\r\n                        Brand <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('model')\">\r\n                        Model <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-2\">Variant</th>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('retailPrice')\">\r\n                        Retail Price <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-1\">Body</th>\r\n                    <th class=\"col-md-1\">Capacity</th>\r\n                    <th class=\"col-md-1\">Transmission</th>\r\n                    <th class=\"col-md-1\">Fuel Type</th>\r\n                    <th class=\"col-md-1\">Vehicle Type</th>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('lastUpdated')\">\r\n                        Last Update <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"r in $ctrl.retailPriceList\">\r\n                    <td class=\"col-md-1\">{{r.brandName}}</td>\r\n                    <td class=\"col-md-1\">{{r.brandModelName}}</td>\r\n                    <td class=\"col-md-2\">{{r.variant}}</td>\r\n                    <td class=\"col-md-1\">{{r.retailPrice | currency:'&euro;':2}}</td>\r\n                    <td class=\"col-md-1\">{{r.bodyType}}</td>\r\n                    <td class=\"col-md-1\">{{r.capacity}}</td>\r\n                    <td class=\"col-md-1\">{{r.transmissionType}}</td>\r\n                    <td class=\"col-md-1\">{{r.fuelType}}</td>\r\n                    <td class=\"col-md-1\">{{r.vehicleType}}</td>\r\n                    <td class=\"col-md-1\">{{r.lastUpdated | date : 'dd MMM yy HH:mm'}}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\">\r\n                            <a ui-sref=\"retailPriceListEdit({retailPriceListId: r.retailPriceListId})\">Edit</a>\r\n                          </li>\r\n                          <li role=\"menuitem\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.deleteRetailPriceList(r.retailPriceListId)\">Delete</a>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.retailPriceList.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.viewAllRetailPriceList()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewRetailPriceListController = function () {
	  ViewRetailPriceListController.$inject = ["authService", "loadingService", "retailPriceListService", "$q", "enums", "lookupService", "$window", "$ngConfirm", "growl"];
	  function ViewRetailPriceListController(authService, loadingService, retailPriceListService, $q, enums, lookupService, $window, $ngConfirm, growl) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ViewRetailPriceListController);
	    if (!authService.authData.isAdmin) {
	      return;
	    }
	
	    this.loadingService = loadingService;
	    this.retailPriceListService = retailPriceListService;
	    this.$q = $q;
	    this.enums = enums;
	    this.lookupService = lookupService;
	    this.$window = $window;
	    this.$ngConfirm = $ngConfirm;
	    this.growl = growl;
	
	    this.filterParams = {};
	
	    this.initializeLookups().then(function () {
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(ViewRetailPriceListController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands[0].name = 'All Brands';
	        _this2.brands = brands;
	        _this2.filterParams.brand = _this2.brands[0];
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          _this2.updateBrandModel();
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.filterParams.brand.brandId;
	      });
	      this.brandModels = [{ brandModelId: 0, name: 'All Models' }].concat((0, _toConsumableArray3.default)(this.brandModels));
	      this.filterParams.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.brand = this.brands[0];
	      this.filterParams.brandModel = this.brandModels[0];
	      this.filterParams.variant = null;
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'lastUpdated',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.viewAllRetailPriceList();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.viewAllRetailPriceList();
	    }
	  }, {
	    key: 'viewAllRetailPriceList',
	    value: function viewAllRetailPriceList() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('retailPriceList', 'Loading All Retail Price List');
	
	      ctrl.retailPriceListService.listRetailPriceList(ctrl.filterParams).then(function (response) {
	        ctrl.retailPriceList = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
	          };
	        }
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('retailPriceList');
	      });
	    }
	  }, {
	    key: 'deleteRetailPriceList',
	    value: function deleteRetailPriceList(retailPriceListId) {
	      var _this4 = this;
	
	      var ctrl = this;
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to delete this Retail Price List ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('retailPriceList', 'Removing Retail Price List ...');
	
	      ctrl.retailPriceListService.updateState(retailPriceListId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
	        ctrl.viewAllRetailPriceList();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this4.loadingService.hideLoading('retailPriceList');
	      });
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      var _this5 = this;
	
	      this.$ngConfirm({
	        title: 'Clear Price List',
	        content: 'This will delete all existing retail price entries. </br></br> <b>Are you sure you want to continue ?</b>',
	        type: 'orange',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this5.retailPriceListService.clear().then(function () {
	                _this5.growl.success('Retail Price Lists cleared successfully', { ttl: 5000 });
	                _this5.reset();
	              });
	            }
	          },
	          no: {
	            text: 'No',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }]);
	  return ViewRetailPriceListController;
	}();
	
	exports.default = ViewRetailPriceListController;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(834);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./viewRetailPriceList.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./viewRetailPriceList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".viewRetailPriceList{color:red}", ""]);
	
	// exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _retailPriceListEdit = __webpack_require__(836);
	
	var _retailPriceListEdit2 = _interopRequireDefault(_retailPriceListEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var retailPriceListEditModule = _angular2.default.module('retailPriceListEdit', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('retailPriceListEdit', {
	    url: '/retailPriceList/edit/:retailPriceListId',
	    component: 'retailPriceListEdit'
	  });
	}]).component('retailPriceListEdit', _retailPriceListEdit2.default).name;
	
	exports.default = retailPriceListEditModule;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _retailPriceListEdit = __webpack_require__(837);
	
	var _retailPriceListEdit2 = _interopRequireDefault(_retailPriceListEdit);
	
	var _retailPriceListEdit3 = __webpack_require__(838);
	
	var _retailPriceListEdit4 = _interopRequireDefault(_retailPriceListEdit3);
	
	__webpack_require__(839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var retailPriceListEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _retailPriceListEdit2.default,
	  controller: _retailPriceListEdit4.default
	};
	
	exports.default = retailPriceListEditComponent;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Edit Retail Price List</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editRetailPriceList()\">\r\n          <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n          <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i> {{ $ctrl.state !== 'Saving' ? 'Save Changes'\r\n          : 'Saving Changes ...' }}\r\n        </a>\r\n        <a class=\"btn btn-warning\" ng-click=\"$ctrl.redirectToParent()\">\r\n          <span class=\"glyphicon glyphicon-remove\"></span> Cancel\r\n        </a>\r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n  <form class=\"form-horizontal\" name=\"retailPriceListForm\" novalidate>\r\n\r\n    <div class=\"col-md-12\">\r\n      <!-- Details Begin -->\r\n      <div uib-group class=\"panel\" block-ui=\"editRetailPriceList\">\r\n        <header>\r\n          <h2>Details</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Brand</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.retailPriceList.brandName\" disabled>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Model</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.retailPriceList.brandModelName\" disabled>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.variant }\">\r\n          <label class=\"control-label col-sm-2\">Variant *</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.retailPriceList.variant\" maxlength=\"250\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.retailPrice }\">\r\n          <label class=\"control-label col-sm-2\">Retail Price *</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.retailPriceList.retailPrice\" placeholder=\"Enter Retail Price\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Body Type</label>\r\n          <div class=\"col-sm-10\">\r\n            <select class=\"form-control\" ng-change=\"$ctrl.updateModelFromSelect('bodyTypeE')\" ng-options=\"item.name for item in $ctrl.selectOptions.bodyTypeE track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.bodyTypeE\">\r\n              </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.capacity }\">\r\n          <label class=\"control-label col-sm-2\">Capacity</label>\r\n          <div class=\"col-sm-10\">\r\n            <input class=\"form-control\" ng-model=\"$ctrl.retailPriceList.capacity\" placeholder=\"Enter capacity of the engine\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Transmission</label>\r\n          <div class=\"col-sm-10\">\r\n            <select class=\"form-control\" ng-change=\"$ctrl.updateModelFromSelect('transmissionTypeE')\" ng-options=\"item.name for item in $ctrl.selectOptions.transmissionTypeE track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.transmissionTypeE\">\r\n              </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Fuel Type</label>\r\n          <div class=\"col-sm-10\">\r\n            <select class=\"form-control\" ng-change=\"$ctrl.updateModelFromSelect('fuelTypeE')\" ng-options=\"item.name for item in $ctrl.selectOptions.fuelTypeE track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.fuelTypeE\">\r\n              </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Vehicle Type</label>\r\n          <div class=\"col-sm-10\">\r\n            <select class=\"form-control\" ng-change=\"$ctrl.updateModelFromSelect('vehicleTypeE')\" ng-options=\"item.name for item in $ctrl.selectOptions.vehicleTypeE track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.vehicleTypeE\">\r\n              </select>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <!-- Details End -->\r\n    </div>\r\n\r\n  </div>\r\n</form>\r\n\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RetailPriceListEditController = function () {
	  RetailPriceListEditController.$inject = ["$stateParams", "enums", "retailPriceListService", "loadingService", "$state"];
	  function RetailPriceListEditController($stateParams, enums, retailPriceListService, loadingService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, RetailPriceListEditController);
	    this.enums = enums;
	    this.retailPriceListService = retailPriceListService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.formValidationService = new _FormValidationService2.default();
	
	    this.retailPriceList = {};
	
	    this.selectOptions = {};
	    this.selectDefaults = {};
	
	    this.initializeEnums();
	    this.configureForm();
	
	    this.loadRetailPriceList();
	  }
	
	  (0, _createClass3.default)(RetailPriceListEditController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'VEHICLE_BODY_TYPE', propName: 'bodyTypeE' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionTypeE' }, { enumName: 'FUEL_TYPE', propName: 'fuelTypeE' }, { enumName: 'VEHICLE_TYPE', propName: 'vehicleTypeE' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName]);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
	        ctrl.updateModelFromSelect(item.propName);
	      });
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj) {
	      var objList = [];
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDefaultOption',
	    value: function getDefaultOption(enumsArray, propName) {
	      var propVal = void 0;
	
	      try {
	        propVal = eval('this.retailPriceList.' + propName);
	      } catch (e) {}
	
	      if (propVal) {
	        return (0, _lodash.find)(enumsArray, function (o) {
	          return o.id === propVal;
	        });
	      } else {
	        return enumsArray[0];
	      }
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      this.retailPriceList[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.retailPriceList);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'variant',
	        displayName: 'Variant',
	        type: 'text',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'retailPrice',
	        displayName: 'Retail Price',
	        type: 'float',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'capacity',
	        displayName: 'Capacity',
	        type: 'float',
	        allowedDecimals: 1,
	        range: {
	          min: 0.9,
	          max: 6.2
	        }
	      });
	    }
	  }, {
	    key: 'loadRetailPriceList',
	    value: function loadRetailPriceList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      if (ctrl.$stateParams.retailPriceListId) {
	        ctrl.loadingService.showLoading('editRetailPriceList', 'Loading Retail Price List ...');
	
	        ctrl.retailPriceListService.getRetailPriceList(ctrl.$stateParams.retailPriceListId).then(function (response) {
	          (0, _assign2.default)(ctrl.retailPriceList, response.data);
	          _this.initializeEnums();
	          _this.configureForm();
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('editRetailPriceList');
	        });
	      }
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(newCompanyId) {
	      this.$state.go('viewRetailPriceList');
	    }
	  }, {
	    key: 'editRetailPriceList',
	    value: function editRetailPriceList() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editRetailPriceList', 'Saving Changes ...');
	
	      //Massage data
	      ctrl.retailPriceList.bodyType = ctrl.retailPriceList.bodyTypeE;
	      ctrl.retailPriceList.transmissionType = ctrl.retailPriceList.transmissionTypeE;
	      ctrl.retailPriceList.fuelType = ctrl.retailPriceList.fuelTypeE;
	      ctrl.retailPriceList.vehicleType = ctrl.retailPriceList.vehicleTypeE;
	
	      ctrl.retailPriceListService.editRetailPriceList(ctrl.retailPriceList).then(function (response) {
	        _this2.state = 'Saved';
	        ctrl.redirectToParent();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editRetailPriceList');
	      });
	    }
	  }]);
	  return RetailPriceListEditController;
	}();
	
	exports.default = RetailPriceListEditController;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(840);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./retailPriceListEdit.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./retailPriceListEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".retailPriceListEdit{color:red}", ""]);
	
	// exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RetailPriceListService = function () {
	  RetailPriceListService.$inject = ["$http", "appConfig"];
	  function RetailPriceListService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, RetailPriceListService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(RetailPriceListService, [{
	    key: 'getRetailPriceList',
	    value: function getRetailPriceList(retailPriceListId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/retailPriceList/get/' + retailPriceListId));
	    }
	  }, {
	    key: 'editRetailPriceList',
	    value: function editRetailPriceList(retailPriceList) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/retailPriceList/add', retailPriceList);
	    }
	  }, {
	    key: 'listRetailPriceList',
	    value: function listRetailPriceList(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	
	      query += '&brandIds=' + filterParams.brand.brandId;
	
	      if (filterParams.brandModel.brandModelId !== 0) {
	        query += '&modelId=' + filterParams.brandModel.brandModelId;
	      }
	
	      if (filterParams.variant) {
	        query += '&variant=' + filterParams.variant;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/retailPriceList/list' + query);
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(retailPriceListId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/retailpricelist/update/' + retailPriceListId + '/' + state));
	    }
	  }, {
	    key: 'getRetailPriceListsByBrandId',
	    value: function getRetailPriceListsByBrandId(brandId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/retailPriceList/getretailrricelistbybrandId/' + brandId));
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/retailPriceList/clear');
	    }
	  }]);
	  return RetailPriceListService;
	}();
	
	exports.default = RetailPriceListService;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleTradersManagement = __webpack_require__(843);
	
	var _vehicleTradersManagement2 = _interopRequireDefault(_vehicleTradersManagement);
	
	var _vehicleTradersContainer = __webpack_require__(848);
	
	var _vehicleTradersContainer2 = _interopRequireDefault(_vehicleTradersContainer);
	
	var _vehicleTraderManagement = __webpack_require__(855);
	
	var _vehicleTraderManagement2 = _interopRequireDefault(_vehicleTraderManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleTradersManagementModule = _angular2.default.module('vehicleTradersManagement', [_angularUiRouter2.default, _vehicleTradersContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleTradersManagement', {
	    url: '/vehicleTradersManagement',
	    component: 'vehicleTradersManagement'
	  });
	}]).component('vehicleTradersManagement', _vehicleTradersManagement2.default).service('vehicleTraderManagementService', _vehicleTraderManagement2.default).name;
	
	exports.default = vehicleTradersManagementModule;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleTradersManagement = __webpack_require__(844);
	
	var _vehicleTradersManagement2 = _interopRequireDefault(_vehicleTradersManagement);
	
	var _vehicleTradersManagement3 = __webpack_require__(845);
	
	var _vehicleTradersManagement4 = _interopRequireDefault(_vehicleTradersManagement3);
	
	__webpack_require__(846);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleTradersManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleTradersManagement2.default,
	  controller: _vehicleTradersManagement4.default
	};
	
	exports.default = vehicleTradersManagementComponent;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleTradersManagementController = function () {
	  VehicleTradersManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function VehicleTradersManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleTradersManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(VehicleTradersManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('vehicleTradersManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return VehicleTradersManagementController;
	}();
	
	exports.default = VehicleTradersManagementController;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(847);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleTradersManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleTradersManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleTradersManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleTradersContainer = __webpack_require__(849);
	
	var _vehicleTradersContainer2 = _interopRequireDefault(_vehicleTradersContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleTradersContainerModule = _angular2.default.module('vehicleTradersContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleTradersManagement.container', {
	    url: '/:locationId',
	    component: 'vehicleTradersContainer'
	  });
	}]).component('vehicleTradersContainer', _vehicleTradersContainer2.default).name;
	
	exports.default = vehicleTradersContainerModule;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleTradersContainer = __webpack_require__(850);
	
	var _vehicleTradersContainer2 = _interopRequireDefault(_vehicleTradersContainer);
	
	var _vehicleTradersContainer3 = __webpack_require__(851);
	
	var _vehicleTradersContainer4 = _interopRequireDefault(_vehicleTradersContainer3);
	
	__webpack_require__(853);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleTradersContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleTradersContainer2.default,
	  controller: _vehicleTradersContainer4.default
	};
	
	exports.default = vehicleTradersContainerComponent;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehicleTradersList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Vehicle Traders Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-2\">Name</th>\r\n          <th class=\"col-md-2\">Phone</th>\r\n          <th class=\"col-md-2\">Email</th>\r\n          <th class=\"col-md-4\">Address</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"vt in $ctrl.vehicleTraders\">\r\n            <td class=\"col-md-2\">{{vt.name}}</td>\r\n            <td class=\"col-md-2\">{{vt.phone}}</td>\r\n            <td class=\"col-md-2\">{{vt.email}}</td>\r\n            <td class=\"col-md-4\">{{vt.address}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showEdit(vt)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeVehicleTrader(vt)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editVehicleTraderTemplate = __webpack_require__(852);
	
	var _editVehicleTraderTemplate2 = _interopRequireDefault(_editVehicleTraderTemplate);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleTradersContainerController = function () {
	  VehicleTradersContainerController.$inject = ["enums", "$stateParams", "loadingService", "vehicleTraderManagementService", "$uibModal", "$scope"];
	  function VehicleTradersContainerController(enums, $stateParams, loadingService, vehicleTraderManagementService, $uibModal, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleTradersContainerController);
	    this.enums = enums;
	    this.$stateParams = $stateParams;
	    this.loadingService = loadingService;
	    this.vehicleTraderManagementService = vehicleTraderManagementService;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	
	    this.vehicleTraders = [];
	    this.loadVehicleTraders();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(VehicleTradersContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'loadVehicleTraders',
	    value: function loadVehicleTraders() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehicleTradersList', 'Loading Traders ...');
	
	      ctrl.vehicleTraderManagementService.list(ctrl.$stateParams.locationId).then(function (response) {
	        ctrl.vehicleTraders = response.data.items;;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleTradersList');
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      this.$scope.closeModal = this.closeModal.bind(this);
	      this.$scope.editVehicleTrader = this.editVehicleTrader.bind(this);
	      this.$scope.vehicleTrader = { entityId: this.$stateParams.locationId };
	      this.$scope.editVehicleTraderMsg = '';
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editVehicleTraderTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(vehicleTrader) {
	      this.$scope.closeModal = this.closeModal.bind(this);
	      this.$scope.editVehicleTrader = this.editVehicleTrader.bind(this);
	      this.$scope.vehicleTrader = (0, _assign2.default)({}, vehicleTrader);
	      this.$scope.editVehicleTraderMsg = '';
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editVehicleTraderTemplate2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'editVehicleTrader',
	    value: function editVehicleTrader() {
	      var ctrl = this;
	
	      if (!this.$scope.vehicleTrader.vehicleTraderId) {
	
	        if (!this.validateForm()) {
	          return;
	        }
	
	        ctrl.loadingService.showLoading('vehicleTradersList', 'Saving Changes ...');
	
	        ctrl.vehicleTraderManagementService.add(ctrl.$stateParams.locationId, this.$scope.vehicleTrader).then(function (response) {
	          var vehicleTrader = (0, _assign2.default)({}, ctrl.$scope.vehicleTrader);
	          vehicleTrader.vehicleTraderId = response.data;
	
	          ctrl.vehicleTraders.push(vehicleTrader);
	          ctrl.closeModal();
	        }).finally(function () {
	          ctrl.loadingService.hideLoading('vehicleTradersList');
	        });
	      } else {
	        if (!this.validateForm()) {
	          return;
	        }
	
	        ctrl.loadingService.showLoading('vehicleTradersList', 'Saving Changes ...');
	
	        ctrl.vehicleTraderManagementService.edit(this.$scope.vehicleTrader).then(function (response) {
	          var vehicleTraderList = (0, _lodash.find)(ctrl.vehicleTraders, function (o) {
	            return o.vehicleTraderId === ctrl.$scope.vehicleTrader.vehicleTraderId;
	          });
	          (0, _assign2.default)(vehicleTraderList, ctrl.$scope.vehicleTrader);
	
	          ctrl.closeModal();
	        }).finally(function () {
	          ctrl.loadingService.hideLoading('vehicleTradersList');
	        });
	      }
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var _this = this;
	
	      this.$scope.editVehicleTraderMsg = '';
	
	      if (!this.$scope.vehicleTrader.name) {
	        this.$scope.editVehicleTraderMsg = 'Please enter a name for Vehicle Trader';
	        return false;
	      }
	
	      if (this.$scope.vehicleTrader) {
	        var dup = (0, _lodash.find)(this.vehicleTraders, function (o) {
	          return o.name.toLowerCase() === _this.$scope.vehicleTrader.name.toLowerCase() && o.vehicleTraderId !== _this.$scope.vehicleTrader.vehicleTraderId;
	        });
	        if (dup) {
	          this.$scope.editVehicleTraderMsg = 'A trader with the same name already exists';
	          return false;
	        }
	      } else {
	        var _dup = (0, _lodash.find)(this.vehicleTraders, function (o) {
	          return o.name.toLowerCase() === _this.$scope.vehicleTrader.name.toLowerCase();
	        });
	        if (_dup) {
	          this.$scope.editVehicleTraderMsg = 'A trader with the same name already exists';
	          return false;
	        }
	      }
	
	      if (this.$scope.vehicleTrader.email && !this.validateEmail(this.$scope.vehicleTrader.email)) {
	        this.$scope.editVehicleTraderMsg = 'Please enter a valid emaill address for Vehicle Trader';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'removeVehicleTrader',
	    value: function removeVehicleTrader(vehicleTrader) {
	      var ctrl = this;
	
	      var sure = window.confirm("Are you sure you want to delete this Vehicle Trader ?");
	
	      if (!sure) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('vehicleTradersList', 'Removing Trader ...');
	
	      ctrl.vehicleTraderManagementService.updateState(ctrl.$stateParams.locationId, vehicleTrader.vehicleTraderId, ctrl.enums.OBJECT_ROW_STATE.Deleted).finally(function () {
	        ctrl.vehicleTraders = (0, _lodash.without)(ctrl.vehicleTraders, vehicleTrader);
	        ctrl.loadingService.hideLoading('vehicleTradersList');
	      });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(email);
	    }
	  }]);
	  return VehicleTradersContainerController;
	}();
	
	exports.default = VehicleTradersContainerController;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Vehicle Trader </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"editVehicleTraderMsg !== ''\">\r\n        {{editVehicleTraderMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Name *</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            <input class=\"form-control\" placeholder=\"Name\" ng-model=\"vehicleTrader.name\" maxlength=\"50\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Phone</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            <input class=\"form-control\" placeholder=\"Phone\" ng-model=\"vehicleTrader.phone\" maxlength=\"100\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Email</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            <input class=\"form-control\" placeholder=\"Email\" ng-model=\"vehicleTrader.email\" maxlength=\"100\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Address</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            <textarea class=\"form-control\" placeholder=\"Address\" ng-model=\"vehicleTrader.address\" maxlength=\"200\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"editVehicleTrader()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n                    </button>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(854);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleTradersContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleTradersContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleTradersContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleTraderManagementService = function () {
	  VehicleTraderManagementService.$inject = ["$http", "appConfig"];
	  function VehicleTraderManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleTraderManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(VehicleTraderManagementService, [{
	    key: "add",
	    value: function add(entityId, trader) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/vehicletrader/add/" + entityId), trader);
	    }
	  }, {
	    key: "edit",
	    value: function edit(trader) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/vehicletrader/edit", trader);
	    }
	  }, {
	    key: "list",
	    value: function list(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/vehicletrader/list/" + entityId));
	    }
	  }, {
	    key: "updateState",
	    value: function updateState(entityId, vehicleTraderId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/vehicletrader/updatestate/" + entityId + "/" + vehicleTraderId + "/" + state));
	    }
	  }]);
	  return VehicleTraderManagementService;
	}();
	
	exports.default = VehicleTraderManagementService;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeCompaniesManagement = __webpack_require__(857);
	
	var _financeCompaniesManagement2 = _interopRequireDefault(_financeCompaniesManagement);
	
	var _financeCompaniesManagement3 = __webpack_require__(862);
	
	var _financeCompaniesManagement4 = _interopRequireDefault(_financeCompaniesManagement3);
	
	var _financeCompaniesContainer = __webpack_require__(863);
	
	var _financeCompaniesContainer2 = _interopRequireDefault(_financeCompaniesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeCompaniesManagementModule = _angular2.default.module('financeCompaniesManagement', [_angularUiRouter2.default, _financeCompaniesContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('financeCompaniesManagement', {
	    url: '/financeCompaniesManagement',
	    component: 'financeCompaniesManagement'
	  });
	}]).component('financeCompaniesManagement', _financeCompaniesManagement2.default).service('financeCompaniesManagementService', _financeCompaniesManagement4.default).name;
	
	exports.default = financeCompaniesManagementModule;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeCompaniesManagement = __webpack_require__(858);
	
	var _financeCompaniesManagement2 = _interopRequireDefault(_financeCompaniesManagement);
	
	var _financeCompaniesManagement3 = __webpack_require__(859);
	
	var _financeCompaniesManagement4 = _interopRequireDefault(_financeCompaniesManagement3);
	
	__webpack_require__(860);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeCompaniesManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financeCompaniesManagement2.default,
	  controller: _financeCompaniesManagement4.default
	};
	
	exports.default = financeCompaniesManagementComponent;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceCompaniesManagementController = function () {
	  FinanceCompaniesManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function FinanceCompaniesManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceCompaniesManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(FinanceCompaniesManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('financeCompaniesManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return FinanceCompaniesManagementController;
	}();
	
	exports.default = FinanceCompaniesManagementController;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(861);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeCompaniesManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeCompaniesManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeCompaniesManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceCompaniesManagementService = function () {
	  FinanceCompaniesManagementService.$inject = ["$http", "appConfig"];
	  function FinanceCompaniesManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceCompaniesManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(FinanceCompaniesManagementService, [{
	    key: "addFinanceCompany",
	    value: function addFinanceCompany(financeCompany) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/financecompanies/add", financeCompany);
	    }
	  }, {
	    key: "editFinanceCompany",
	    value: function editFinanceCompany(financeCompany) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/financecompanies/edit", financeCompany);
	    }
	  }, {
	    key: "listFinanceCompanies",
	    value: function listFinanceCompanies(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/financecompanies/list/" + entityId));
	    }
	  }, {
	    key: "removeFinanceCompany",
	    value: function removeFinanceCompany(entityId, financeCompanyId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/financecompanies/remove/" + entityId + "/" + financeCompanyId));
	    }
	  }]);
	  return FinanceCompaniesManagementService;
	}();
	
	exports.default = FinanceCompaniesManagementService;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeCompaniesContainer = __webpack_require__(864);
	
	var _financeCompaniesContainer2 = _interopRequireDefault(_financeCompaniesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeCompaniesContainerModule = _angular2.default.module('financeCompaniesContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('financeCompaniesManagement.container', {
	    url: '/:locationId',
	    component: 'financeCompaniesContainer'
	  });
	}]).component('financeCompaniesContainer', _financeCompaniesContainer2.default).name;
	
	exports.default = financeCompaniesContainerModule;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeCompaniesContainer = __webpack_require__(865);
	
	var _financeCompaniesContainer2 = _interopRequireDefault(_financeCompaniesContainer);
	
	var _financeCompaniesContainer3 = __webpack_require__(866);
	
	var _financeCompaniesContainer4 = _interopRequireDefault(_financeCompaniesContainer3);
	
	__webpack_require__(868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeCompaniesContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financeCompaniesContainer2.default,
	  controller: _financeCompaniesContainer4.default
	};
	
	exports.default = financeCompaniesContainerComponent;

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"financeCompaniesList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Finance Companies Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-6\">Name</th>\r\n          <th class=\"col-md-2\">Buy Rate %</th>\r\n          <th class=\"col-md-2\">Sell Rate %</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"fc in $ctrl.financeCompanies\">\r\n            <td class=\"col-md-6\">{{fc.name}}</td>\r\n            <td class=\"col-md-2\">{{fc.buyRate | number : 4}}</td>\r\n            <td class=\"col-md-2\">{{fc.sellRate | number : 4}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showEdit(fc)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeFinanceCompany(fc)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _editFinanceCompanyModal = __webpack_require__(867);
	
	var _editFinanceCompanyModal2 = _interopRequireDefault(_editFinanceCompanyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceCompaniesContainerController = function () {
	  FinanceCompaniesContainerController.$inject = ["authService", "enums", "$stateParams", "loadingService", "$scope", "$uibModal", "financeCompaniesManagementService"];
	  function FinanceCompaniesContainerController(authService, enums, $stateParams, loadingService, $scope, $uibModal, financeCompaniesManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceCompaniesContainerController);
	    this.$stateParams = $stateParams;
	    this.loadingService = loadingService;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.financeCompaniesManagementService = financeCompaniesManagementService;
	
	    this.financeCompanies = [];
	    this.initializeFinanceCompanies();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(FinanceCompaniesContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializeFinanceCompanies',
	    value: function initializeFinanceCompanies() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financeCompaniesList', 'Loading Finance Companies ...');
	
	      ctrl.financeCompaniesManagementService.listFinanceCompanies(ctrl.$stateParams.locationId).then(function (response) {
	        ctrl.financeCompanies = response.data.items;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('financeCompaniesList');
	      });
	    }
	  }, {
	    key: 'removeFinanceCompany',
	    value: function removeFinanceCompany(financeCompany) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financeCompaniesList', 'Removing Finance Company ...');
	
	      ctrl.financeCompaniesManagementService.removeFinanceCompany(ctrl.$stateParams.locationId, financeCompany.financeCompanyId).finally(function () {
	        ctrl.loadingService.hideLoading('financeCompaniesList');
	        ctrl.initializeFinanceCompanies();
	      });
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      this.$scope.errMsg = "";
	      this.$scope.tempCompany = {
	        entityId: this.$stateParams.locationId,
	        buyRate: 0,
	        sellRate: 0
	      };
	
	      this.$scope.closeModal = this.closeModal.bind(this);
	      this.$scope.save = this.save.bind(this);
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editFinanceCompanyModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(financeCompany) {
	      this.$scope.errMsg = "";
	      this.$scope.tempCompany = financeCompany;
	
	      this.$scope.closeModal = this.closeModal.bind(this);
	      this.$scope.save = this.save.bind(this);
	
	      this.$scope.modalInstance = this.$uibModal.open({
	        template: _editFinanceCompanyModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var ctrl = this;
	
	      if (ctrl.$scope.modalInstance) {
	        ctrl.$scope.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var ctrl = this;
	
	      if (!ctrl.validateForm(ctrl.$scope.tempCompany.financeCompanyId)) {
	        return;
	      }
	
	      if (!ctrl.$scope.tempCompany.financeCompanyId) {
	        ctrl.add();
	      } else {
	        ctrl.edit();
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this = this;
	
	      var ctrl = this;
	
	      ctrl.financeCompaniesManagementService.addFinanceCompany(ctrl.$scope.tempCompany).then(function (response) {
	        ctrl.financeCompanies.push({
	          financeCompanyId: response.data,
	          entityId: _this.$stateParams.locationId,
	          name: ctrl.$scope.tempCompany.name,
	          buyRate: ctrl.$scope.tempCompany.buyRate,
	          sellRate: ctrl.$scope.tempCompany.sellRate
	        });
	      }).finally(function () {
	        ctrl.closeModal();
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var ctrl = this;
	
	      ctrl.financeCompaniesManagementService.editFinanceCompany(ctrl.$scope.tempCompany).then(function (response) {}).finally(function () {
	        ctrl.closeModal();
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(financeCompanyId) {
	      var ctrl = this;
	
	      ctrl.$scope.errMsg = '';
	
	      if (!ctrl.$scope.tempCompany.name || ctrl.$scope.tempCompany.name.length < 3 || ctrl.$scope.tempCompany.name.length > 50) {
	        ctrl.$scope.errMsg = 'Name is a required field and must be between 3 and 50 characters';
	        return false;
	      }
	
	      if (ctrl.$scope.tempCompany.buyRate !== '' && ctrl.$scope.tempCompany.buyRate < 0) {
	        ctrl.$scope.errMsg = 'Buy Rate is a required field';
	        return false;
	      }
	
	      if (ctrl.$scope.tempCompany.sellRate !== '' && ctrl.$scope.tempCompany.sellRate < 0) {
	        ctrl.$scope.errMsg = 'Sell Rate is a required field';
	        return false;
	      }
	
	      if (ctrl.$scope.tempCompany.sellRate < ctrl.$scope.tempCompany.buyRate) {
	        ctrl.$scope.errMsg = 'Buy Rate cannot be greater than Sell Rate';
	        return false;
	      }
	
	      if ((0, _lodash.find)(this.financeCompanies, function (fc) {
	        var removeEdit = false;
	        if (financeCompanyId) {
	          removeEdit = fc.financeCompanyId !== financeCompanyId;
	        }
	
	        return fc.name.toLowerCase() === ctrl.$scope.tempCompany.name.toLowerCase() && removeEdit;
	      })) {
	        ctrl.$scope.errMsg = ctrl.$scope.tempCompany.name + ' is already added to the list';
	        return;
	      }
	
	      return true;
	    }
	  }]);
	  return FinanceCompaniesContainerController;
	}();
	
	exports.default = FinanceCompaniesContainerController;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"closeModal()\">x</button>\r\n    <h2>  Finance Company </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Name *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Name\" ng-model=\"tempCompany.name\" maxlength=\"50\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Buy Rate % *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" placeholder=\"Buy Rate\" ng-model=\"tempCompany.buyRate\" maxlength=\"50\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Sell Rate % *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" placeholder=\"Sell Rate\" ng-model=\"tempCompany.sellRate\" maxlength=\"50\" />\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"save()\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n                    </button>\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(869);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeCompaniesContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeCompaniesContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeCompaniesContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _deliveryPriceManagement = __webpack_require__(871);
	
	var _deliveryPriceManagement2 = _interopRequireDefault(_deliveryPriceManagement);
	
	var _deliveryPriceContainer = __webpack_require__(876);
	
	var _deliveryPriceContainer2 = _interopRequireDefault(_deliveryPriceContainer);
	
	var _deliveryPriceManagement3 = __webpack_require__(886);
	
	var _deliveryPriceManagement4 = _interopRequireDefault(_deliveryPriceManagement3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPriceManagementModule = _angular2.default.module('deliveryPriceManagement', [_angularUiRouter2.default, _deliveryPriceContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('deliveryPriceManagement', {
	    url: '/deliveryPriceManagement',
	    component: 'deliveryPriceManagement'
	  });
	}]).service('deliveryPriceManagementService', _deliveryPriceManagement4.default).component('deliveryPriceManagement', _deliveryPriceManagement2.default).name;
	
	exports.default = deliveryPriceManagementModule;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deliveryPriceManagement = __webpack_require__(872);
	
	var _deliveryPriceManagement2 = _interopRequireDefault(_deliveryPriceManagement);
	
	var _deliveryPriceManagement3 = __webpack_require__(873);
	
	var _deliveryPriceManagement4 = _interopRequireDefault(_deliveryPriceManagement3);
	
	__webpack_require__(874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPriceManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _deliveryPriceManagement2.default,
	  controller: _deliveryPriceManagement4.default
	};
	
	exports.default = deliveryPriceManagementComponent;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage delivery prices\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveryPriceManagementController = function () {
	  DeliveryPriceManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function DeliveryPriceManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeliveryPriceManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(DeliveryPriceManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('deliveryPriceManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return DeliveryPriceManagementController;
	}();
	
	exports.default = DeliveryPriceManagementController;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(875);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveryPriceManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveryPriceManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".deliveryPriceManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _deliveryPriceContainer = __webpack_require__(877);
	
	var _deliveryPriceContainer2 = _interopRequireDefault(_deliveryPriceContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPriceContainerModule = _angular2.default.module('deliveryPriceContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('deliveryPriceManagement.container', {
	    url: '/:locationId',
	    component: 'deliveryPriceContainer'
	  });
	}]).component('deliveryPriceContainer', _deliveryPriceContainer2.default).name;
	
	exports.default = deliveryPriceContainerModule;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deliveryPriceContainer = __webpack_require__(878);
	
	var _deliveryPriceContainer2 = _interopRequireDefault(_deliveryPriceContainer);
	
	var _deliveryPriceContainer3 = __webpack_require__(879);
	
	var _deliveryPriceContainer4 = _interopRequireDefault(_deliveryPriceContainer3);
	
	__webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPriceContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _deliveryPriceContainer2.default,
	  controller: _deliveryPriceContainer4.default
	};
	
	exports.default = deliveryPriceContainerComponent;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"container\">\r\n\r\n  <h3>New Delivery Price</h3> \r\n\r\n  <div class=\"errors-panel\" ng-show=\"$ctrl.errMsg !== ''\">      \r\n      <div class=\"errors\">          \r\n          {{$ctrl.errMsg}}\r\n      </div>\r\n  </div>  \r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <select\r\n        class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n        ng-options=\"item.brandId as item.name for item in $ctrl.allBrands\"\r\n        ng-model=\"$ctrl.deliveryPrice.brandId\">\r\n      </select>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n      <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.brandModelId as item.name for item in $ctrl.brandModels\"\r\n        ng-model=\"$ctrl.deliveryPrice.brandModelId\">\r\n      </select>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n      <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.deliveryPrice.price\" />\r\n    </div>    \r\n\r\n    <div class=\"col-md-3\">\r\n        <a class=\"btn btn-primary\" href=\"#\" ng-click=\"$ctrl.add()\">Add</a>\r\n        <a class=\"btn btn-default\" href=\"#\" ng-click=\"$ctrl.reset()\">Reset</a>\r\n    </div>    \r\n  </div>\r\n  <hr />\r\n\r\n  <h3>Delivery Price List</h3>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th class=\"col-md-2\">Brand</th>\r\n                <th class=\"col-md-2\">Model</th>\r\n                <th class=\"col-md-2\">Price</th>\r\n                <th class=\"col-md-1\">&nbsp;</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr ng-repeat=\"dp in $ctrl.deliveryPriceList\">\r\n                  <td class=\"col-md-2\">{{ dp.brandName }}</td>\r\n                  <td class=\"col-md-2\">{{ dp.brandModelName }}</td>\r\n                  <td class=\"col-md-2\">{{ dp.price | currency:'&euro;':0 }}</td>\r\n                  <td class=\"col-md-1\">\r\n                    <a class=\"btn btn-default\" href=\"#\" ng-click=\"$ctrl.remove(dp.deliveryPriceId)\">\r\n                        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\r\n                    </a>                    \r\n                  </td>\r\n              </tr>\r\n          </tbody>\r\n      </table> \r\n    </div>\r\n  </div>\r\n\r\n \r\n\r\n\r\n\r\n</div>"

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(880);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveryPriceContainerController = function () {
	  DeliveryPriceContainerController.$inject = ["$stateParams", "lookupService", "$q", "loadingService", "deliveryPriceManagementService"];
	  function DeliveryPriceContainerController($stateParams, lookupService, $q, loadingService, deliveryPriceManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeliveryPriceContainerController);
	    this.lookupService = lookupService;
	    this.$stateParams = $stateParams;
	    this.$q = $q;
	    this.loadingService = loadingService;
	    this.deliveryPriceManagementService = deliveryPriceManagementService;
	
	    this.errMsg = '';
	    this.deliveryPriceList = [];
	    this.deliveryPrice = {};
	
	    this.reset();
	    this.init();
	  }
	
	  (0, _createClass3.default)(DeliveryPriceContainerController, [{
	    key: 'reset',
	    value: function reset() {
	      this.deliveryPrice = {
	        entityId: this.$stateParams.locationId,
	        brandId: 1,
	        brandModelId: null,
	        price: null
	      };
	
	      this.errMsg = '';
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('container', 'Loading Delivery Prices');
	
	      ctrl.initializeLookups().then(function () {
	        ctrl.deliveryPriceManagementService.listDeliveryPrices(ctrl.$stateParams.locationId).then(function (response) {
	          ctrl.deliveryPriceList = response.data.items;
	
	          ctrl.loadingService.hideLoading('container');
	        });
	      });
	    }
	  }, {
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this = this;
	
	      var ctrl = this;
	      var deferred = this.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        _this.allBrands = brands;
	
	        _this.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this.allBrandModels = brandModels;
	          _this.updateBrandModel();
	
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this2 = this;
	
	      if (!this.validateAdd()) {
	        return;
	      }
	
	      this.loadingService.showLoading('container', 'Adding new Delivery Price ...');
	
	      this.deliveryPriceManagementService.addDeliveryPrice(this.deliveryPrice).then(function (response) {
	        _this2.reset();
	        _this2.init();
	        _this2.loadingService.hideLoading('container');
	      });
	    }
	  }, {
	    key: 'validateAdd',
	    value: function validateAdd() {
	      var _this3 = this;
	
	      if (!this.deliveryPrice.price || !(0, _isInteger2.default)(parseInt(this.deliveryPrice.price))) {
	        this.errMsg = 'Delivery Price must be a valid number';
	        return false;
	      }
	
	      var dup = (0, _lodash.find)(this.deliveryPriceList, function (o) {
	        return o.brandId === _this3.deliveryPrice.brandId && o.brandModelId == _this3.deliveryPrice.brandModelId;
	      });
	
	      if (dup) {
	        this.errMsg = 'Delivery Price for ' + dup.brandName + ' ' + dup.brandModelName + ' already exists';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(deliveryPriceId) {
	      var _this4 = this;
	
	      var sure = window.confirm('Are you sure you want to remove this delivery price');
	
	      if (!sure) {
	        return;
	      }
	      this.loadingService.showLoading('container', 'Removing Delivery Price ...');
	
	      this.deliveryPriceManagementService.removeDeliveryPrice(this.$stateParams.locationId, deliveryPriceId).then(function (response) {
	        _this4.init();
	        _this4.loadingService.hideLoading('container');
	      });
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this5 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this5.deliveryPrice.brandId;
	      });
	      this.brandModels.unshift({ brandModelId: null, name: 'All' });
	    }
	  }]);
	  return DeliveryPriceContainerController;
	}();
	
	exports.default = DeliveryPriceContainerController;

/***/ }),
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(885);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./deliveryPriceContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./deliveryPriceContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".deliveryPriceContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveryPriceManagementService = function () {
	  DeliveryPriceManagementService.$inject = ["$http", "appConfig"];
	  function DeliveryPriceManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeliveryPriceManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(DeliveryPriceManagementService, [{
	    key: "addDeliveryPrice",
	    value: function addDeliveryPrice(deliveryPrice) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/deliveryprices/add", deliveryPrice);
	    }
	  }, {
	    key: "listDeliveryPrices",
	    value: function listDeliveryPrices(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/deliveryprices/list/" + entityId));
	    }
	  }, {
	    key: "removeDeliveryPrice",
	    value: function removeDeliveryPrice(entityId, deliveryPriceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/deliveryprices/remove/" + entityId + "/" + deliveryPriceId));
	    }
	  }, {
	    key: "getDeliveryPrice",
	    value: function getDeliveryPrice(entityId, deliveryPriceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/deliveryprices/get/" + entityId + "/" + deliveryPriceId));
	    }
	  }]);
	  return DeliveryPriceManagementService;
	}();
	
	exports.default = DeliveryPriceManagementService;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _defaultTextManagement = __webpack_require__(888);
	
	var _defaultTextManagement2 = _interopRequireDefault(_defaultTextManagement);
	
	var _DefaultTextContainer = __webpack_require__(893);
	
	var _DefaultTextContainer2 = _interopRequireDefault(_DefaultTextContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTextManagementModule = _angular2.default.module('defaultTextManagement', [_angularUiRouter2.default, _DefaultTextContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('defaultTextManagement', {
	    url: '/defaultTextManagement',
	    component: 'defaultTextManagement'
	  });
	}]).component('defaultTextManagement', _defaultTextManagement2.default).name;
	
	exports.default = defaultTextManagementModule;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultTextManagement = __webpack_require__(889);
	
	var _defaultTextManagement2 = _interopRequireDefault(_defaultTextManagement);
	
	var _defaultTextManagement3 = __webpack_require__(890);
	
	var _defaultTextManagement4 = _interopRequireDefault(_defaultTextManagement3);
	
	__webpack_require__(891);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTextManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _defaultTextManagement2.default,
	  controller: _defaultTextManagement4.default
	};
	
	exports.default = defaultTextManagementComponent;

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage delivery prices\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultTextManagementController = function () {
	  DefaultTextManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function DefaultTextManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DefaultTextManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(DefaultTextManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('defaultTextManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return DefaultTextManagementController;
	}();
	
	exports.default = DefaultTextManagementController;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(892);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./defaultTextManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./defaultTextManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultTextManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _defaultTextContainer = __webpack_require__(894);
	
	var _defaultTextContainer2 = _interopRequireDefault(_defaultTextContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTextContainerModule = _angular2.default.module('defaultTextContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('defaultTextManagement.container', {
	    url: '/:locationId',
	    component: 'defaultTextContainer'
	  });
	}]).component('defaultTextContainer', _defaultTextContainer2.default).name;
	
	exports.default = defaultTextContainerModule;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultTextContainer = __webpack_require__(895);
	
	var _defaultTextContainer2 = _interopRequireDefault(_defaultTextContainer);
	
	var _defaultTextContainer3 = __webpack_require__(896);
	
	var _defaultTextContainer4 = _interopRequireDefault(_defaultTextContainer3);
	
	__webpack_require__(897);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTextContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _defaultTextContainer2.default,
	  controller: _defaultTextContainer4.default
	};
	
	exports.default = defaultTextContainerComponent;

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"container\">\r\n\r\n  <div class=\"col-md-12\">\r\n    <header class=\"empty\">\r\n      <h2>Default Texts</h2>\r\n    </header>\r\n\r\n    <!-- alerts -->\r\n    <div class=\"errors-panel\" ng-show=\"$ctrl.errMsg !== ''\">      \r\n      <div class=\"errors\">          \r\n          {{$ctrl.errMsg}}\r\n      </div>\r\n    </div>  \r\n  </div>\r\n\r\n  <a class=\"btn btn-success\" ng-click=\"$ctrl.saveChanges()\">\r\n      <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n      Save Changes\r\n  </a>  \r\n\r\n<div block-ui=\"defaultTexts\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      &nbsp;\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <h4>Warranty Text</h4>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <h4>Finance Text</h4>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <h4>Email Text</h4>\r\n    </div>        \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #1\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[0]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[0]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[0]\"></textarea>\r\n    </div>        \r\n  </div>\r\n\r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #2\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[1]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[1]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[1]\"></textarea>\r\n    </div>        \r\n  </div>  \r\n\r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #3\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[2]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[2]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[2]\"></textarea>\r\n    </div>        \r\n  </div>\r\n\r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #4\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[3]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[3]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[3]\"></textarea>\r\n    </div>        \r\n  </div> \r\n\r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #5\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[4]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[4]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[4]\"></textarea>\r\n    </div>        \r\n  </div>\r\n  \r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #6\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[5]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[5]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[5]\"></textarea>\r\n    </div>        \r\n  </div> \r\n  \r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #7\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[6]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[6]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[6]\"></textarea>\r\n    </div>        \r\n  </div>\r\n  \r\n  <hr />\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">      \r\n      #8\r\n    </div>      \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.warranty[7]\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.finance[7]\"></textarea>\r\n    </div>    \r\n    <div class=\"col-md-3\">      \r\n      <textarea class=\"form-control\" rows=\"3\" maxlength=\"300\" ng-model=\"$ctrl.defaultTexts.email[7]\"></textarea>\r\n    </div>        \r\n  </div>\r\n\r\n</div>\r\n \r\n\r\n\r\n\r\n</div>"

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultTextContainerController = function () {
	  DefaultTextContainerController.$inject = ["$stateParams", "adminService", "loadingService"];
	  function DefaultTextContainerController($stateParams, adminService, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DefaultTextContainerController);
	    this.$stateParams = $stateParams;
	    this.adminService = adminService;
	    this.loadingService = loadingService;
	
	    this.errMsg = '';
	    this.defaultTexts = {};
	
	    this.loadDefaultTexts();
	  }
	
	  (0, _createClass3.default)(DefaultTextContainerController, [{
	    key: 'loadDefaultTexts',
	    value: function loadDefaultTexts() {
	      var _this = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('defaultTexts', 'Loading Default Texts ...');
	
	      ctrl.adminService.listDefaultTexts(ctrl.$stateParams.locationId).then(function (response) {
	        _this.defaultTexts = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('defaultTexts');
	      });
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('defaultTexts', 'Saving Changes ...');
	
	      ctrl.adminService.updateDefaultTexts(ctrl.$stateParams.locationId, ctrl.defaultTexts).then(function (response) {}).finally(function () {
	        ctrl.loadingService.hideLoading('defaultTexts');
	      });
	    }
	  }]);
	  return DefaultTextContainerController;
	}();
	
	exports.default = DefaultTextContainerController;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(898);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./defaultTextContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./defaultTextContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultTextContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _brandModelManagement = __webpack_require__(900);
	
	var _brandModelManagement2 = _interopRequireDefault(_brandModelManagement);
	
	var _BrandModel = __webpack_require__(905);
	
	var _BrandModel2 = _interopRequireDefault(_BrandModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var brandModelManagementModule = _angular2.default.module('brandModelManagement', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('brandModelManagement', {
	    url: '/brandModelManagement',
	    component: 'brandModelManagement'
	  });
	}]).component('brandModelManagement', _brandModelManagement2.default).service('brandModelService', _BrandModel2.default).name;
	
	exports.default = brandModelManagementModule;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brandModelManagement = __webpack_require__(901);
	
	var _brandModelManagement2 = _interopRequireDefault(_brandModelManagement);
	
	var _brandModelManagement3 = __webpack_require__(902);
	
	var _brandModelManagement4 = _interopRequireDefault(_brandModelManagement3);
	
	__webpack_require__(903);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var brandModelManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _brandModelManagement2.default,
	  controller: _brandModelManagement4.default
	};
	
	exports.default = brandModelManagementComponent;

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"brandModelList\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Brand Models List</h2>                   \r\n      </header><br />\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Brand\"\r\n              ng-model=\"$ctrl.filterParams.brandName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Model\"\r\n              ng-model=\"$ctrl.filterParams.brandModelName\">\r\n            </select>\r\n          </span>          \r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.viewBrandModels()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <tr>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('brandName')\">\r\n                        Brand <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-1\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('brandModelName')\">\r\n                        Model <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"m in $ctrl.brandModels\">\r\n                    <td class=\"col-md-1\">{{m.brandName}}</td>\r\n                    <td class=\"col-md-1\">{{m.brandModelName}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.brandModels.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.viewBrandModels()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandModelManagementController = function () {
	  BrandModelManagementController.$inject = ["authService", "loadingService", "brandModelService"];
	  function BrandModelManagementController(authService, loadingService, brandModelService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BrandModelManagementController);
	    if (!authService.authData.isAdmin) {
	      return;
	    }
	
	    this.loadingService = loadingService;
	    this.brandModelService = brandModelService;
	
	    this.filterParams = {};
	
	    this.reset();
	  }
	
	  (0, _createClass3.default)(BrandModelManagementController, [{
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.brandName = null;
	      this.filterParams.brandModelName = null;
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 50
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'brandName',
	        ascending: true
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.viewBrandModels();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.viewBrandModels();
	    }
	  }, {
	    key: 'viewBrandModels',
	    value: function viewBrandModels() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('brandModelList', 'Loading Brand Models ...');
	
	      ctrl.brandModelService.listBrandModels(ctrl.filterParams).then(function (response) {
	        ctrl.brandModels = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
	          };
	        }
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('brandModelList');
	      });
	    }
	  }]);
	  return BrandModelManagementController;
	}();
	
	exports.default = BrandModelManagementController;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(904);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./brandModelManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./brandModelManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".brandModelManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandModelService = function () {
	  BrandModelService.$inject = ["$http", "appConfig"];
	  function BrandModelService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BrandModelService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(BrandModelService, [{
	    key: 'listBrandModels',
	    value: function listBrandModels(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	
	      if (filterParams.brandName) {
	        query += '&brandName=' + filterParams.brandName;
	      }
	
	      if (filterParams.brandModelName) {
	        query += '&brandModelName=' + filterParams.brandModelName;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/brandmodel/list' + query);
	    }
	  }]);
	  return BrandModelService;
	}();
	
	exports.default = BrandModelService;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _failedWebEnquiries = __webpack_require__(907);
	
	var _failedWebEnquiries2 = _interopRequireDefault(_failedWebEnquiries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failedWebEnquiriesModule = _angular2.default.module('failedWebEnquiries', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('failedWebEnquiries', {
	    url: '/failedWebEnquiries',
	    component: 'failedWebEnquiries'
	  });
	}]).component('failedWebEnquiries', _failedWebEnquiries2.default).name;
	
	exports.default = failedWebEnquiriesModule;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _failedWebEnquiries = __webpack_require__(908);
	
	var _failedWebEnquiries2 = _interopRequireDefault(_failedWebEnquiries);
	
	var _failedWebEnquiries3 = __webpack_require__(909);
	
	var _failedWebEnquiries4 = _interopRequireDefault(_failedWebEnquiries3);
	
	__webpack_require__(944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failedWebEnquiriesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _failedWebEnquiries2.default,
	  controller: _failedWebEnquiries4.default
	};
	
	exports.default = failedWebEnquiriesComponent;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>WebEnquiries Mailbox</h2>    \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <div ng-dropdown-multiselect=\"\" options=\"$ctrl.userLocations\" selected-model=\"$ctrl.reportCriteria.locationIds\" extra-settings=\"$ctrl.locationSelectSettings\"></div>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Status\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item for item in ['All', 'Processed', 'Junk', 'Error', 'Blocked', 'Ignored']\"\r\n                          ng-model=\"$ctrl.reportCriteria.additionalParameter1\">\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        From\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <input class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter2\" />\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Subject\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <input class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter3\" />\r\n                      </div>                      \r\n                    </div>    \r\n                    \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Source\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item for item in ['All', 'Email', 'Api']\"\r\n                          ng-model=\"$ctrl.reportCriteria.additionalParameter4\">\r\n                        </select>\r\n                      </div>                    \r\n                    </div>                        \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.viewWebEnquiries()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div block-ui=\"webEnquiriesList\">\r\n              <table class=\"table table-bordered table-hover table-striped\">\r\n                <thead>\r\n                    <tr>\r\n                      <tr>\r\n                        <th class=\"col-md-1\">Source</th>       \r\n                        <th class=\"col-md-1\">Received</th>       \r\n                        <th class=\"col-md-1\">Location</th>\r\n                        <th class=\"col-md-2\">From</th>                        \r\n                        <th class=\"col-md-3\">Subject</th>      \r\n                        <th class=\"col-md-1\">Status</th>    \r\n                        <th class=\"col-md-2\">Error</th>    \r\n                        <th class=\"col-md-1\">Actions</th>                            \r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <tr data-ng-repeat=\"we in $ctrl.webEnquiries\">\r\n                        <td class=\"col-md-1\">{{we.source}}</td>\r\n                        <td class=\"col-md-1\">{{we.received | date : 'dd MMM yy HH:mm'}}</td>\r\n                        <td class=\"col-md-1\">{{we.entityName}}</td>\r\n                        <td class=\"col-md-2\">{{we.from}}</td>\r\n                        <td class=\"col-md-3\" ng-if=\"we.status !== 'Blocked'\">\r\n                          <a target=\"_blank\" href=\"{{$ctrl.viewEmailUrl + we.entityId + '/' + we.provider + '/' + we.emailId}}\" ng-if=\"we.source === 'Email' && we.status === 'Processed'\">\r\n                            {{we.subject}}\r\n                          </a>\r\n                          <a target=\"_blank\" href=\"{{$ctrl.viewEmailUrl + we.entityId + '/' + we.status + '/' + we.emailId}}\" ng-if=\"we.source === 'Email' && we.status !== 'Processed'\">\r\n                           {{we.subject}}\r\n                          </a>                          \r\n                          <a target=\"_blank\" href=\"{{$ctrl.viewApiDataUrl + we.webEnquiryId}}\" ng-if=\"we.source === 'Api'\">\r\n                           {{we.subject}}\r\n                          </a>                          \r\n                        </td>\r\n                        <td class=\"col-md-3\" ng-if=\"we.status === 'Blocked'\">\r\n                          {{we.subject}}\r\n                        </td>                        \r\n                        <td class=\"col-md-1\">{{we.status}}</td>\r\n                        <td class=\"col-md-2\">{{we.error}}</td>\r\n                        <td class=\"col-md-1\">\r\n                          <a class=\"btn btn-primary\" ng-show=\"we.source !== 'Api' && we.status === 'Error'\" ng-click=\"$ctrl.reprocessConfirm(we.webEnquiryId)\">Reprocess</a>\r\n                        </td>\r\n                    </tr> \r\n                </tbody>\r\n            </table>              \r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FailedWebEnquiriesController = function (_BaseReportController) {
	  FailedWebEnquiriesController.$inject = ["authService", "reportingService", "appConfig", "enums", "loadingService", "utilsService", "adminService", "webEnquiriesService", "$ngConfirm", "growl"];
	  (0, _inherits3.default)(FailedWebEnquiriesController, _BaseReportController);
	
	  function FailedWebEnquiriesController(authService, reportingService, appConfig, enums, loadingService, utilsService, adminService, webEnquiriesService, $ngConfirm, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FailedWebEnquiriesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FailedWebEnquiriesController.__proto__ || (0, _getPrototypeOf2.default)(FailedWebEnquiriesController)).call(this, reportingService, loadingService, utilsService));
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.appConfig = appConfig;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.utilsService = utilsService;
	    _this.adminService = adminService;
	    _this.webEnquiriesService = webEnquiriesService;
	    _this.$ngConfirm = $ngConfirm;
	    _this.growl = growl;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportData: true
	    };
	
	    _this.locationSelectSettings = {
	      displayProp: 'item2',
	      idProp: 'item1',
	      enableSearch: true,
	      scrollableHeight: '500px',
	      scrollable: true,
	      styleActive: true,
	      closeOnBlur: true
	    };
	
	    _this.getLocations().then(function (response) {
	      _this.getDateRangeList();
	      _this.getSourceList();
	      _this.reset();
	    });
	
	    _this.viewEmailUrl = _this.appConfig.apiServiceBaseUri + 'api/file/getemail/';
	    _this.viewApiDataUrl = _this.appConfig.apiServiceBaseUri + 'api/file/getapidata/';
	    return _this;
	  }
	
	  (0, _createClass3.default)(FailedWebEnquiriesController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getSourceList',
	    value: function getSourceList() {
	      this.sourceList = [{ id: null, name: 'All' }, { id: 1, name: 'Email' }, { id: 2, name: 'Api' }];
	    }
	  }, {
	    key: 'getLocations',
	    value: function getLocations() {
	      var _this2 = this;
	
	      var source = this.adminService.getWebEnquiryLocations();
	
	      source.then(function (response) {
	        _this2.userLocations = response.data;
	      });
	
	      return source;
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.locationIds = [];
	      this.reportCriteria.additionalParameter1 = 'All';
	      this.reportCriteria.additionalParameter2 = null;
	      this.reportCriteria.additionalParameter3 = null;
	      this.reportCriteria.additionalParameter4 = 'All';
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.reportCriteria.locationIds.map(function (l) {
	        return l.item1;
	      });
	      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
	      parsedCriteria.additionalParameter2 = this.reportCriteria.additionalParameter2;
	      parsedCriteria.additionalParameter3 = this.reportCriteria.additionalParameter3;
	      parsedCriteria.additionalParameter4 = this.reportCriteria.additionalParameter4;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'viewWebEnquiries',
	    value: function viewWebEnquiries() {
	      var ctrl = this;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('webEnquiriesList', 'Loading Web Enquiries ...');
	
	      ctrl.webEnquiriesService.listWebEnquiries(this.parseCriteria()).then(function (response) {
	        ctrl.webEnquiries = response.data;
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('webEnquiriesList');
	      });
	    }
	  }, {
	    key: 'reprocessConfirm',
	    value: function reprocessConfirm(webEnquiryId) {
	      var _this3 = this;
	
	      this.$ngConfirm({
	        title: false,
	        content: 'Are you sure you want to mark this enquiry for reprocessing ?',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this3.reprocess(webEnquiryId);
	            }
	          },
	          no: {
	            text: 'Not Sure',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'reprocess',
	    value: function reprocess(webEnquiryId) {
	      var _this4 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('failedWebEnquiriesList', 'Updating Enquiries');
	
	      ctrl.webEnquiriesService.reprocess(webEnquiryId).then(function (response) {
	        _this4.growl.success('Enquiry marked for reprocessing successfully', { ttl: 5000 });
	        _this4.removeEnquiryAndUpdateCount(webEnquiryId);
	      }).catch(function (err) {
	        _this4.growl.error('An error occurred while reprocessing enquiry', { ttl: 5000 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('failedWebEnquiriesList');
	      });
	    }
	  }, {
	    key: 'removeEnquiryAndUpdateCount',
	    value: function removeEnquiryAndUpdateCount(webEnquiryId) {
	      var webEnquiry = this.webEnquiries.find(function (we) {
	        return we.webEnquiryId === webEnquiryId;
	      });
	      this.webEnquiries = (0, _lodash.without)(this.webEnquiries, webEnquiry);
	    }
	  }, {
	    key: 'viewApiData',
	    value: function viewApiData(webEnquiryId) {
	      alert(webEnquiryId);
	    }
	  }]);
	  return FailedWebEnquiriesController;
	}(_baseReportController2.default);
	
	exports.default = FailedWebEnquiriesController;

/***/ }),
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseReportController = function () {
	  function BaseReportController(reportingService, loadingService, utilsService) {
	    (0, _classCallCheck3.default)(this, BaseReportController);
	
	    this.reportingService = reportingService;
	    this.loadingService = loadingService;
	    this.utilsService = utilsService;
	  }
	
	  (0, _createClass3.default)(BaseReportController, [{
	    key: 'updateDateRange',
	    value: function updateDateRange() {
	      var _this = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	      var src = this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id);
	
	      src.then(function (response) {
	        _this.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
	        _this.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
	      }).finally(function () {
	        _this.loadingService.hideLoading('reportCriteria');
	      });
	
	      return src;
	    }
	  }, {
	    key: 'parseStartAndEndDate',
	    value: function parseStartAndEndDate(parsedCriteria) {
	      if (this.reportCriteria.startDate) {
	        parsedCriteria.startDate = this.reportCriteria.startDate.toUniversalFormat();
	      }
	
	      if (this.reportCriteria.endDate) {
	        parsedCriteria.endDate = this.reportCriteria.endDate.toUniversalFormat();
	      }
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      var _this2 = this;
	
	      var locationsWithRoles = this.authService.authData.userLocations.map(function (l) {
	        return {
	          id: l.key,
	          name: l.value,
	          roleId: (0, _lodash.find)(_this2.authService.authData.userRoles, function (o) {
	            return o.entityId === l.key;
	          }).roleId,
	          isDefault: l.defaultLocation
	        };
	      });
	
	      this.userLocations = (0, _lodash2.default)(locationsWithRoles).filter(function (o) {
	        return o.roleId !== 2 || o.isDefault;
	      }).map(function (o) {
	        return { id: o.id, name: o.name };
	      }).value();
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }]);
	  return BaseReportController;
	}();
	
	exports.default = BaseReportController;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(945);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./failedWebEnquiries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./failedWebEnquiries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".failedWebEnquiries{color:red}", ""]);
	
	// exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _autoPromiseManagement = __webpack_require__(947);
	
	var _autoPromiseManagement2 = _interopRequireDefault(_autoPromiseManagement);
	
	var _autoPromiseContainer = __webpack_require__(952);
	
	var _autoPromiseContainer2 = _interopRequireDefault(_autoPromiseContainer);
	
	var _autoPromiseManagement3 = __webpack_require__(959);
	
	var _autoPromiseManagement4 = _interopRequireDefault(_autoPromiseManagement3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoPromiseManagementModule = _angular2.default.module('autoPromiseManagement', [_angularUiRouter2.default, _autoPromiseContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('autoPromiseManagement', {
	    url: '/autoPromiseManagement',
	    component: 'autoPromiseManagement'
	  });
	}]).service('autoPromiseMagementService', _autoPromiseManagement4.default).component('autoPromiseManagement', _autoPromiseManagement2.default).name;
	
	exports.default = autoPromiseManagementModule;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autoPromiseManagement = __webpack_require__(948);
	
	var _autoPromiseManagement2 = _interopRequireDefault(_autoPromiseManagement);
	
	var _autoPromiseManagement3 = __webpack_require__(949);
	
	var _autoPromiseManagement4 = _interopRequireDefault(_autoPromiseManagement3);
	
	__webpack_require__(950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoPromiseManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _autoPromiseManagement2.default,
	  controller: _autoPromiseManagement4.default
	};
	
	exports.default = autoPromiseManagementComponent;

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity for Automatic Promises Management\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoPromiseManagementController = function () {
	  AutoPromiseManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function AutoPromiseManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AutoPromiseManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(AutoPromiseManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('autoPromiseManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return AutoPromiseManagementController;
	}();
	
	exports.default = AutoPromiseManagementController;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(951);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./autoPromiseManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./autoPromiseManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".autoPromiseManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _autoPromiseContainer = __webpack_require__(953);
	
	var _autoPromiseContainer2 = _interopRequireDefault(_autoPromiseContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoPromiseContainerModule = _angular2.default.module('autoPromiseContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('autoPromiseManagement.container', {
	    url: '/:locationId',
	    component: 'autoPromiseContainer'
	  });
	}]).component('autoPromiseContainer', _autoPromiseContainer2.default).name;
	
	exports.default = autoPromiseContainerModule;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autoPromiseContainer = __webpack_require__(954);
	
	var _autoPromiseContainer2 = _interopRequireDefault(_autoPromiseContainer);
	
	var _autoPromiseContainer3 = __webpack_require__(955);
	
	var _autoPromiseContainer4 = _interopRequireDefault(_autoPromiseContainer3);
	
	__webpack_require__(957);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoPromiseContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _autoPromiseContainer2.default,
	  controller: _autoPromiseContainer4.default
	};
	
	exports.default = autoPromiseContainerComponent;

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"autoPromiseList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Automatic Promises Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAutoPromiseAdd()\" href=\"#\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-3\">Trigger</th>\r\n          <th class=\"col-md-2\">Timespan</th>\r\n          <th class=\"col-md-5\">Subject</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n          <th class=\"col-md-1\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"ap in $ctrl.autoPromises\">\r\n            <td class=\"col-md-3\">{{ap.autopromiseTriggerDesc}}</td>\r\n            <td class=\"col-md-2\">{{ap.timespanDescription}}</td>\r\n            <td class=\"col-md-5\">{{ap.subject}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-default btn-small remove\" href=\"#\" ng-click=\"$ctrl.showAutoPromiseEdit(ap)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" href=\"#\" ng-click=\"$ctrl.removeAutoPromise(ap.automaticPromiseId)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _app = __webpack_require__(956);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoPromiseContainerController = function () {
	  AutoPromiseContainerController.$inject = ["authService", "$scope", "$ngConfirm", "enums", "autoPromiseMagementService", "loadingService", "$stateParams"];
	  function AutoPromiseContainerController(authService, $scope, $ngConfirm, enums, autoPromiseMagementService, loadingService, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AutoPromiseContainerController);
	    this.authService = authService;
	    this.$scope = $scope;
	    this.$ngConfirm = $ngConfirm;
	    this.enums = enums;
	    this.autoPromiseMagementService = autoPromiseMagementService;
	    this.loadingService = loadingService;
	    this.$stateParams = $stateParams;
	
	    this.autoPromises = [];
	
	    this.listAutoPromises();
	  }
	
	  (0, _createClass3.default)(AutoPromiseContainerController, [{
	    key: 'showAutoPromiseAdd',
	    value: function showAutoPromiseAdd() {
	      var _this = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.autoPromiseTriggers = (0, _app.convertEnumToKeyValueList)(this.enums.AUTO_PROMISE_TRIGGER, true);
	      this.$scope.timeSpanTypes = (0, _app.convertEnumToKeyValueList)(this.enums.TIMESPAN_TYPE, true);
	
	      this.$scope.autoPromise = {
	        entityId: this.$stateParams.locationId,
	        autopromiseTrigger: null,
	        timespanType: null,
	        timespan: 0,
	        subject: null
	      };
	
	      this.$ngConfirm({
	        title: 'Add Automatic Promise',
	        contentUrl: 'templates/promise/autoPromiseTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this.validateAutoPromise();
	
	              if (valid) {
	                _this.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');
	
	                _this.autoPromiseMagementService.add(_this.$stateParams.locationId, _this.$scope.autoPromise).then(function (response) {
	                  _this.autoPromises.push(response.data);
	                }).finally(function () {
	                  _this.loadingService.hideLoading('autoPromiseList');
	                });
	              } else {
	                return false;
	              }
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'listAutoPromises',
	    value: function listAutoPromises() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('autoPromiseList', 'Loading Autopromises ...');
	
	      this.autoPromiseMagementService.list(this.$stateParams.locationId).then(function (response) {
	        _this2.autoPromises = response.data.items;
	      }).finally(function () {
	        _this2.loadingService.hideLoading('autoPromiseList');
	      });
	    }
	  }, {
	    key: 'validateAutoPromise',
	    value: function validateAutoPromise() {
	      if (this.$scope.autoPromise.autopromiseTrigger == null) {
	        this.$scope.errMsg = 'Please select a Trigger';
	
	        return false;
	      }
	
	      if (this.$scope.autoPromise.timespanType == null || this.$scope.autoPromise.timespan === 0) {
	        this.$scope.errMsg = 'Please specify a valid duration';
	
	        return false;
	      }
	
	      if (!this.$scope.autoPromise.subject) {
	        this.$scope.errMsg = 'Please specify the subject';
	
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'removeAutoPromise',
	    value: function removeAutoPromise(autoPromiseId) {
	      var _this3 = this;
	
	      this.$ngConfirm({
	        title: null,
	        content: 'Are you sure you want to remove this Automatic Promise',
	        typeAnimation: false,
	        columnClass: 'm',
	        type: 'red',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Remove',
	            btnClass: 'btn-danger',
	            action: function action() {
	              _this3.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');
	
	              _this3.autoPromiseMagementService.remove(_this3.$stateParams.locationId, autoPromiseId).then(function (response) {
	                var autoPromise = (0, _lodash.find)(_this3.autoPromises, function (o) {
	                  return o.automaticPromiseId === autoPromiseId;
	                });
	                _this3.autoPromises = (0, _lodash.without)(_this3.autoPromises, autoPromise);
	              }).finally(function () {
	                _this3.loadingService.hideLoading('autoPromiseList');
	              });
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showAutoPromiseEdit',
	    value: function showAutoPromiseEdit(autoPromise) {
	      var _this4 = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.autoPromiseTriggers = (0, _app.convertEnumToKeyValueList)(this.enums.AUTO_PROMISE_TRIGGER, true);
	      this.$scope.timeSpanTypes = (0, _app.convertEnumToKeyValueList)(this.enums.TIMESPAN_TYPE, true);
	
	      this.$scope.autoPromise = {
	        automaticPromiseId: autoPromise.automaticPromiseId,
	        entityId: autoPromise.entityId,
	        autopromiseTrigger: autoPromise.autopromiseTrigger,
	        timespanType: autoPromise.timespanType,
	        timespan: autoPromise.timespan,
	        subject: autoPromise.subject
	      };
	
	      this.$ngConfirm({
	        title: 'Edit Automatic Promise',
	        contentUrl: 'templates/promise/autoPromiseTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this4.validateAutoPromise();
	
	              if (valid) {
	                _this4.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');
	
	                _this4.autoPromiseMagementService.edit(_this4.$stateParams.locationId, _this4.$scope.autoPromise).then(function (response) {
	                  autoPromise = (0, _assign2.default)(autoPromise, response.data);
	                }).finally(function () {
	                  _this4.loadingService.hideLoading('autoPromiseList');
	                });
	              } else {
	                return false;
	              }
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }]);
	  return AutoPromiseContainerController;
	}();
	
	exports.default = AutoPromiseContainerController;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertEnumToKeyValueList = convertEnumToKeyValueList;
	exports.getEnumPropName = getEnumPropName;
	var removeEvents = function removeEvents() {
	  $('.person-image img').unbind('dragstart');
	  $('.dashboard-sidenav > ul > li a').unbind('click');
	  $('.dashboard-sidenav').unbind('mouseleave');
	  $('.dealership > a').unbind('click');
	};
	
	var initJqElems = function initJqElems() {
	  removeEvents();
	
	  $('.person-image img').on('dragstart', function (event) {
	    event.preventDefault();
	    $(this).closest('.person-image').trigger('click');
	  });
	
	  window.setTimeout(function () {
	    $('.dashboard-sidenav > ul > li a').click(function () {
	      $(this).closest('.dashboard-sidenav').find('ul.active').removeClass('active');
	      $(this).next('ul').addClass('active');
	    });
	  }, 1);
	
	  $('.dashboard-sidenav').mouseleave(function () {
	    $('.dashboard-sidenav ul.active').removeClass('active');
	  });
	
	  $('.dealership > a').click(function () {
	    $(this).next('.dealership-menu').toggleClass('active');
	
	    $(this).next().find('a').click(function () {
	      $(this).parent().parent().removeClass('active');
	    });
	  });
	
	  $(function () {
	    $(window).resize(function () {
	      $('.dashboard-main-area').css('min-height', $(window).outerHeight() - $('.dashboard-header').outerHeight(true));
	    }).trigger('resize');
	  });
	};
	
	function convertEnumToKeyValueList(enumObj, defaultOption) {
	  var objList = [];
	
	  if (defaultOption) {
	    objList.push({
	      id: null,
	      name: 'Please Select'
	    });
	  }
	
	  for (var prop in enumObj) {
	    objList.push({
	      id: enumObj[prop],
	      name: prop
	    });
	  }
	
	  return objList;
	}
	
	function getEnumPropName(enumObj, value) {
	  for (var prop in enumObj) {
	    if (enumObj[prop] === value) {
	      return prop;
	    }
	  }
	  return null;
	}
	
	exports.initJqElems = initJqElems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(958);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./autoPromiseContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./autoPromiseContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".autoPromiseContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoPromiseManagementService = function () {
	    AutoPromiseManagementService.$inject = ["$http", "appConfig"];
	    function AutoPromiseManagementService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, AutoPromiseManagementService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(AutoPromiseManagementService, [{
	        key: "add",
	        value: function add(entityId, autoPromise) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/autopromise/add/" + entityId), autoPromise);
	        }
	    }, {
	        key: "edit",
	        value: function edit(entityId, autoPromise) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/autopromise/edit/" + entityId), autoPromise);
	        }
	    }, {
	        key: "list",
	        value: function list(entityId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/autopromise/list/" + entityId));
	        }
	    }, {
	        key: "remove",
	        value: function remove(entityId, autoPromiseId) {
	            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/autopromise/remove/" + entityId + "/" + autoPromiseId));
	        }
	    }]);
	    return AutoPromiseManagementService;
	}();
	
	exports.default = AutoPromiseManagementService;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _monthlyDistributionManagement = __webpack_require__(961);
	
	var _monthlyDistributionManagement2 = _interopRequireDefault(_monthlyDistributionManagement);
	
	var _monthlyDistributionContainer = __webpack_require__(966);
	
	var _monthlyDistributionContainer2 = _interopRequireDefault(_monthlyDistributionContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthlyDistributionManagementModule = _angular2.default.module('monthlyDistributionManagement', [_angularUiRouter2.default, _monthlyDistributionContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('monthlyDistributionManagement', {
	    url: '/monthlyDistributionManagement',
	    component: 'monthlyDistributionManagement'
	  });
	}]).component('monthlyDistributionManagement', _monthlyDistributionManagement2.default).name;
	
	exports.default = monthlyDistributionManagementModule;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _monthlyDistributionManagement = __webpack_require__(962);
	
	var _monthlyDistributionManagement2 = _interopRequireDefault(_monthlyDistributionManagement);
	
	var _monthlyDistributionManagement3 = __webpack_require__(963);
	
	var _monthlyDistributionManagement4 = _interopRequireDefault(_monthlyDistributionManagement3);
	
	__webpack_require__(964);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthlyDistributionManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _monthlyDistributionManagement2.default,
	  controller: _monthlyDistributionManagement4.default
	};
	
	exports.default = monthlyDistributionManagementComponent;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MonthlyDistributionManagementController = function () {
	  MonthlyDistributionManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function MonthlyDistributionManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MonthlyDistributionManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(MonthlyDistributionManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('monthlyDistributionManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return MonthlyDistributionManagementController;
	}();
	
	exports.default = MonthlyDistributionManagementController;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(965);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./monthlyDistributionManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./monthlyDistributionManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".monthlyDistributionManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _monthlyDistributionContainer = __webpack_require__(967);
	
	var _monthlyDistributionContainer2 = _interopRequireDefault(_monthlyDistributionContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthlyDistributionContainerModule = _angular2.default.module('monthlyDistributionContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('monthlyDistributionManagement.container', {
	    url: '/:locationId',
	    component: 'monthlyDistributionContainer'
	  });
	}]).component('monthlyDistributionContainer', _monthlyDistributionContainer2.default).name;
	
	exports.default = monthlyDistributionContainerModule;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _monthlyDistributionContainer = __webpack_require__(968);
	
	var _monthlyDistributionContainer2 = _interopRequireDefault(_monthlyDistributionContainer);
	
	var _monthlyDistributionContainer3 = __webpack_require__(969);
	
	var _monthlyDistributionContainer4 = _interopRequireDefault(_monthlyDistributionContainer3);
	
	__webpack_require__(970);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monthlyDistributionContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _monthlyDistributionContainer2.default,
	  controller: _monthlyDistributionContainer4.default
	};
	
	exports.default = monthlyDistributionContainerComponent;

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"monthlyDistributionList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Monthly Sales Distribution Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAddDistribution()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n        <div class=\"pull-right col-md-3\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.loadMonthlyDistributions()\"\r\n              ng-options=\"y for y in $ctrl.years\"\r\n              ng-model=\"$ctrl.selectedYear\">\r\n            </select>\r\n        </div>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th>Make/Model</th>\r\n          <th>Condition</th>\r\n          <th>For</th>\r\n          <th>Jan</th>\r\n          <th>Feb</th>\r\n          <th>Mar</th>\r\n          <th>Apr</th>\r\n          <th>May</th>\r\n          <th>Jun</th>\r\n          <th>Jul</th>\r\n          <th>Aug</th>\r\n          <th>Sep</th>\r\n          <th>Oct</th>\r\n          <th>Nov</th>\r\n          <th>Dec</th>\r\n          <th>Total</th>\r\n          <th>&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"md in $ctrl.monthlyDistributions\">\r\n            <td>{{md.brandName}} {{md.brandModelName}}</td>\r\n            <td>{{md.conditionText}}</td>\r\n            <td>{{md.targetTypeText}}</td>\r\n            <td>{{md.jan}}</td>\r\n            <td>{{md.feb}}</td>\r\n            <td>{{md.mar}}</td>\r\n            <td>{{md.apr}}</td>\r\n            <td>{{md.may}}</td>\r\n            <td>{{md.jun}}</td>\r\n            <td>{{md.jul}}</td>\r\n            <td>{{md.aug}}</td>\r\n            <td>{{md.sep}}</td>\r\n            <td>{{md.oct}}</td>\r\n            <td>{{md.nov}}</td>\r\n            <td>{{md.dec}}</td>\r\n            <td>{{md.jan + md.feb + md.mar + md.apr + md.may + md.jun + md.jul + md.aug + md.sep + md.oct + md.nov + md.dec}}</td>\r\n            <td>\r\n                <a class=\"btn btn-default btn-small remove\" ng-click=\"$ctrl.showEditDistribution(md)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showRemoveDistribution(md.monthlyDistributionId)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MonthlyDistributionContainerController = function () {
	  MonthlyDistributionContainerController.$inject = ["performanceManagementService", "lookupService", "$ngConfirm", "$scope", "$stateParams", "growl", "loadingService"];
	  function MonthlyDistributionContainerController(performanceManagementService, lookupService, $ngConfirm, $scope, $stateParams, growl, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MonthlyDistributionContainerController);
	    this.performanceManagementService = performanceManagementService;
	    this.lookupService = lookupService;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.growl = growl;
	    this.loadingService = loadingService;
	
	    this.years = [];
	    this.brands = [];
	    this.allBrandModels = [];
	    this.vehicleConditionList = [];
	    this.monthlyDistributions = [];
	
	    this.selectedYear = null;
	    this.emptyModel = { brandId: null, brandModelId: null, name: 'Please Select' };
	
	    this.loadYears();
	    this.loadMonthlyDistributions();
	    this.loadBrands();
	    this.loadBrandModels();
	    this.loadVehicleConditions();
	  }
	
	  (0, _createClass3.default)(MonthlyDistributionContainerController, [{
	    key: 'loadYears',
	    value: function loadYears() {
	      var startYear = 2014;
	      var endYear = new Date().getFullYear();
	
	      for (var i = endYear; i >= startYear - 1; i--) {
	        this.years.push(i);
	      }
	
	      this.selectedYear = endYear;
	    }
	  }, {
	    key: 'loadMonthlyDistributions',
	    value: function loadMonthlyDistributions() {
	      var _this = this;
	
	      this.loadingService.showLoading('monthlyDistributionList', 'Loading Monthly Distributions ...');
	
	      this.performanceManagementService.listMonthlyDistribution(this.$stateParams.locationId, this.selectedYear).then(function (response) {
	        return _this.monthlyDistributions = response.data;
	      }).finally(function () {
	        _this.loadingService.hideLoading('monthlyDistributionList');
	      });
	    }
	  }, {
	    key: 'loadBrands',
	    value: function loadBrands() {
	      var _this2 = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        return _this2.brands = brands;
	      });
	    }
	  }, {
	    key: 'loadBrandModels',
	    value: function loadBrandModels() {
	      var _this3 = this;
	
	      this.lookupService.lookupBrandModels().then(function (brandModels) {
	        return _this3.allBrandModels = brandModels;
	      });
	    }
	  }, {
	    key: 'loadVehicleConditions',
	    value: function loadVehicleConditions() {
	      this.vehicleConditionList.push({ id: 1, name: 'New' });
	      this.vehicleConditionList.push({ id: 2, name: 'Used' });
	    }
	  }, {
	    key: 'showAddDistribution',
	    value: function showAddDistribution() {
	      var _this4 = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.brands = this.brands;
	      this.$scope.allBrandModels = this.allBrandModels;
	      this.$scope.emptyModel = this.emptyModel;
	      this.$scope.brandModels = [this.emptyModel];
	      this.$scope.vehicleConditionList = this.vehicleConditionList;
	      this.$scope.filterBrandModels = this.filterBrandModels;
	
	      this.$scope.monthlyDistribution = {
	        entityId: this.$stateParams.locationId,
	        year: this.selectedYear, //Selected Year
	        condition: 1, //New
	        brandId: 1, //Default to All Brands New or Used
	        brandModelId: null,
	        targetType: 1, //For EnquiryCreated
	        jan: 0, feb: 0, mar: 0,
	        apr: 0, may: 0, jun: 0,
	        jul: 0, aug: 0, sep: 0,
	        oct: 0, nov: 0, dec: 0
	      };
	
	      this.$ngConfirm({
	        title: 'Add New Distribution',
	        contentUrl: 'templates/performance/editMonthlyDistributionTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (!_this4.validateAddDistribution()) {
	                return false;
	              }
	
	              _this4.addDistribution();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateAddDistribution',
	    value: function validateAddDistribution() {
	      var mdToAdd = this.$scope.monthlyDistribution;
	
	      if (this.getDistributionTotal(mdToAdd) <= 0) {
	        this.$scope.errMsg = 'Please enter at least one value';
	
	        return false;
	      }
	
	      var duplicate = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId);
	
	      if (duplicate) {
	        this.$scope.errMsg = 'This configuration is already added';
	
	        return false;
	      }
	
	      var brandId = this.$scope.monthlyDistribution.brandId;
	      var modelId = this.$scope.monthlyDistribution.brandModelId;
	
	      /*
	      * If there is a Brand Specified, without any Model
	      * We need to get total of all distributions with makes
	      * and the combined total should be less than All 
	      */
	      if (brandId && !modelId) {
	        //Get All Distribution First
	        var all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);
	
	        //If All Category Exist, then we can find other brands under All
	        if (all) {
	          var brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];
	          brandDistributions.push(mdToAdd);
	          var brandDistributionsCombined = this.combineDistributions(brandDistributions);
	          var month = this.isBelowLimit(brandDistributionsCombined, all);
	
	          if (month) {
	            this.$scope.errMsg = 'Combined total of all brand(s) for the month of ' + month + ', exceeds the All Category';
	            return false;
	          }
	        }
	      }
	
	      /*
	      * If the Brand and BrandModel both specified
	      * 1- If the Brand exists, we need to get the total of all distributions
	      * under the Brand, and the combined total should be less than Brand
	      * 2- If the Brand does not exist, we need to check the combined total
	      * of this brandmodel along with any others brands under all category
	      */
	      if (brandId && modelId) {
	        //Get Brand Distribution First
	        var brand = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null);
	
	        if (brand) {
	          var brandModelDistributions = this.findBrandModelDistributions(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId) || [];
	          brandModelDistributions.push(mdToAdd);
	          var brandModelDistributionsCombined = this.combineDistributions(brandModelDistributions);
	          var _month = this.isBelowLimit(brandModelDistributionsCombined, brand);
	
	          if (_month) {
	            this.$scope.errMsg = 'Combined total of all brand models(s) for the month of ' + _month + ', exceeds the All Category';
	            return false;
	          }
	        } else {
	          var _all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);
	
	          if (_all) {
	            var _brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];
	            _brandDistributions.push(mdToAdd);
	            var _brandDistributionsCombined = this.combineDistributions(_brandDistributions);
	            var _month2 = this.isBelowLimit(_brandDistributionsCombined, _all);
	
	            if (_month2) {
	              this.$scope.errMsg = 'Combined total of all brand(s) for the month of ' + _month2 + ', exceeds the All Category';
	              return false;
	            }
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'addDistribution',
	    value: function addDistribution() {
	      var _this5 = this;
	
	      this.loadingService.showLoading('monthlyDistributionList', 'Adding Monthly Distribution ...');
	
	      this.performanceManagementService.addMonthlyDistribution(this.$scope.monthlyDistribution).then(function (response) {
	        _this5.$scope.monthlyDistribution.monthlyDistributionId = response.data;
	        _this5.$scope.monthlyDistribution.conditionText = (0, _lodash.find)(_this5.vehicleConditionList, function (o) {
	          return o.id === _this5.$scope.monthlyDistribution.condition;
	        }).name;
	        _this5.$scope.monthlyDistribution.brandName = (0, _lodash.find)(_this5.brands, function (o) {
	          return o.brandId === _this5.$scope.monthlyDistribution.brandId;
	        }).name;
	        var brandModel = (0, _lodash.find)(_this5.allBrandModels, function (o) {
	          return o.brandModelId === _this5.$scope.monthlyDistribution.brandModelId;
	        });
	        _this5.$scope.monthlyDistribution.brandModelName = brandModel != null ? brandModel.name : '';
	        _this5.$scope.monthlyDistribution.targetTypeText = _this5.$scope.monthlyDistribution.targetType === 1 ? 'EnquiryCreated' : 'EnquiryDelivered';
	        _this5.$scope.monthlyDistribution.total = _this5.getDistributionTotal(_this5.$scope.monthlyDistribution);
	
	        _this5.monthlyDistributions.push(_this5.$scope.monthlyDistribution);
	
	        _this5.growl.success('Distribution added successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this5.loadingService.hideLoading('monthlyDistributionList');
	      });
	    }
	  }, {
	    key: 'showEditDistribution',
	    value: function showEditDistribution(md) {
	      var _this6 = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.brands = this.brands;
	      this.$scope.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === md.brandId;
	      });
	      this.$scope.vehicleConditionList = this.vehicleConditionList;
	
	      this.$scope.monthlyDistribution = (0, _assign2.default)({}, md);;
	
	      this.$ngConfirm({
	        title: 'Edit New Distribution',
	        contentUrl: 'templates/performance/editMonthlyDistributionTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (!_this6.validateEditDistribution()) {
	                return false;
	              }
	
	              _this6.editDistribution();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateEditDistribution',
	    value: function validateEditDistribution() {
	      var mdToAdd = this.$scope.monthlyDistribution;
	
	      if (this.getDistributionTotal(mdToAdd) <= 0) {
	        this.$scope.errMsg = 'Please enter at least one value';
	
	        return false;
	      }
	
	      var brandId = this.$scope.monthlyDistribution.brandId;
	      var modelId = this.$scope.monthlyDistribution.brandModelId;
	
	      /*
	      * If there is a Brand Specified, without any Model
	      * We need to get total of all distributions with makes
	      * and the combined total should be less than All 
	      */
	      if (brandId && brandId !== 1 && !modelId) {
	        //Get All Distribution First
	        var all = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);
	
	        //If All Category Exist, then we can find other brands under All
	        if (all) {
	          var brandDistributions = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];
	          //Exclude it self from Total
	          brandDistributions = (0, _lodash.without)(brandDistributions, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null));
	          brandDistributions.push(mdToAdd);
	          var brandDistributionsCombined = this.combineDistributions(brandDistributions);
	          var month = this.isBelowLimit(brandDistributionsCombined, all);
	
	          if (month) {
	            this.$scope.errMsg = 'Combined total of all brand(s) for the month of ' + month + ', exceeds the All Category';
	            return false;
	          }
	        }
	      }
	
	      /*
	      * If the Brand and BrandModel both specified
	      * 1- If the Brand exists, we need to get the total of all distributions
	      * under the Brand, and the combined total should be less than Brand
	      * 2- If the Brand does not exist, we need to check the combined total
	      * of this brandmodel along with any others brands under all category
	      */
	      if (brandId && modelId) {
	        //Get Brand Distribution First
	        var brand = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, null);
	
	        if (brand) {
	          var brandModelDistributions = this.findBrandModelDistributions(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId) || [];
	          //Exclude it self from Total
	          brandModelDistributions = (0, _lodash.without)(brandModelDistributions, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId));
	          brandModelDistributions.push(mdToAdd);
	          var brandModelDistributionsCombined = this.combineDistributions(brandModelDistributions);
	          var _month3 = this.isBelowLimit(brandModelDistributionsCombined, brand);
	
	          if (_month3) {
	            this.$scope.errMsg = 'Combined total of all brand models(s) for the month of ' + _month3 + ', exceeds the All Category';
	            return false;
	          }
	        } else {
	          var _all2 = this.findDistribution(mdToAdd.condition, mdToAdd.targetType, 1, null);
	
	          if (_all2) {
	            var _brandDistributions2 = this.findBrandDistributions(mdToAdd.condition, mdToAdd.targetType) || [];
	            //Exclude it self from Total
	            _brandDistributions2 = (0, _lodash.without)(_brandDistributions2, this.findDistribution(mdToAdd.condition, mdToAdd.targetType, mdToAdd.brandId, mdToAdd.brandModelId));
	            _brandDistributions2.push(mdToAdd);
	            var _brandDistributionsCombined2 = this.combineDistributions(_brandDistributions2);
	            var _month4 = this.isBelowLimit(_brandDistributionsCombined2, _all2);
	
	            if (_month4) {
	              this.$scope.errMsg = 'Combined total of all brand(s) for the month of ' + _month4 + ', exceeds the All Category';
	              return false;
	            }
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'editDistribution',
	    value: function editDistribution() {
	      var _this7 = this;
	
	      this.loadingService.showLoading('monthlyDistributionList', 'Updating Monthly Distribution ...');
	
	      this.performanceManagementService.editMonthlyDistribution(this.$scope.monthlyDistribution).then(function (response) {
	        var md = (0, _lodash.find)(_this7.monthlyDistributions, function (o) {
	          return o.monthlyDistributionId === _this7.$scope.monthlyDistribution.monthlyDistributionId;
	        });
	        md.jan = _this7.$scope.monthlyDistribution.jan;
	        md.feb = _this7.$scope.monthlyDistribution.feb;
	        md.mar = _this7.$scope.monthlyDistribution.mar;
	        md.apr = _this7.$scope.monthlyDistribution.apr;
	        md.may = _this7.$scope.monthlyDistribution.may;
	        md.jun = _this7.$scope.monthlyDistribution.jun;
	        md.jul = _this7.$scope.monthlyDistribution.jul;
	        md.aug = _this7.$scope.monthlyDistribution.aug;
	        md.sep = _this7.$scope.monthlyDistribution.sep;
	        md.oct = _this7.$scope.monthlyDistribution.oct;
	        md.nov = _this7.$scope.monthlyDistribution.nov;
	        md.dec = _this7.$scope.monthlyDistribution.dec;
	
	        _this7.growl.success('Distribution Updated successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this7.loadingService.hideLoading('monthlyDistributionList');
	      });
	    }
	  }, {
	    key: 'showRemoveDistribution',
	    value: function showRemoveDistribution(monthlyDistributionId) {
	      var _this8 = this;
	
	      this.$ngConfirm({
	        title: 'Remove Distribution',
	        content: 'Are you sure you want to delete this Distribution ?',
	        typeAnimation: false,
	        type: 'red',
	        buttons: {
	          yes: {
	            text: 'Delete',
	            btnClass: 'btn-danger',
	            action: function action() {
	              _this8.removeDistribution(monthlyDistributionId);
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeDistribution',
	    value: function removeDistribution(monthlyDistributionId) {
	      var _this9 = this;
	
	      this.loadingService.showLoading('monthlyDistributionList', 'Removing Monthly Distribution ...');
	
	      this.performanceManagementService.removeMonthlyDistribution(this.$stateParams.locationId, monthlyDistributionId).then(function (response) {
	        var md = (0, _lodash.find)(_this9.monthlyDistributions, function (o) {
	          return o.monthlyDistributionId === monthlyDistributionId;
	        });
	
	        _this9.monthlyDistributions = (0, _lodash.without)(_this9.monthlyDistributions, md);
	
	        _this9.growl.success('Distribution Deleted successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this9.loadingService.hideLoading('monthlyDistributionList');
	      });
	    }
	  }, {
	    key: 'isPositive',
	    value: function isPositive(number) {
	      return number >= 0;
	    }
	  }, {
	    key: 'filterBrandModels',
	    value: function filterBrandModels(md) {
	      var _brandModels;
	
	      this.brandModels = [this.emptyModel];
	      (_brandModels = this.brandModels).push.apply(_brandModels, (0, _toConsumableArray3.default)((0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === md.brandId;
	      })));
	
	      md.brandModelId = null;
	    }
	  }, {
	    key: 'getDistributionTotal',
	    value: function getDistributionTotal(md) {
	      return md.jan + md.feb + md.mar + md.apr + md.may + md.jun + md.jul + md.aug + md.sep + md.oct + md.nov + md.dec;
	    }
	  }, {
	    key: 'isBelowLimit',
	    value: function isBelowLimit(mdToUpdate, mdToCompare) {
	      if (mdToUpdate.jan > mdToCompare.jan) {
	        return "Jan";
	      }
	
	      if (mdToUpdate.feb > mdToCompare.feb) {
	        return "Feb";
	      }
	
	      if (mdToUpdate.mar > mdToCompare.mar) {
	        return "Mar";
	      }
	
	      if (mdToUpdate.apr > mdToCompare.apr) {
	        return "Apr";
	      }
	
	      if (mdToUpdate.may > mdToCompare.may) {
	        return "May";
	      }
	
	      if (mdToUpdate.jun > mdToCompare.jun) {
	        return "Jun";
	      }
	
	      if (mdToUpdate.jul > mdToCompare.jul) {
	        return "Jul";
	      }
	
	      if (mdToUpdate.aug > mdToCompare.aug) {
	        return "Aug";
	      }
	
	      if (mdToUpdate.sep > mdToCompare.sep) {
	        return "Sep";
	      }
	
	      if (mdToUpdate.oct > mdToCompare.oct) {
	        return "Oct";
	      }
	
	      if (mdToUpdate.nov > mdToCompare.nov) {
	        return "Nov";
	      }
	
	      if (mdToUpdate.dec > mdToCompare.dec) {
	        return "Dec";
	      }
	
	      return null;
	    }
	  }, {
	    key: 'combineDistributions',
	    value: function combineDistributions(distributions) {
	      var distribution = {};
	
	      distribution.jan = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.jan;
	      });
	      distribution.feb = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.feb;
	      });
	      distribution.mar = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.mar;
	      });
	      distribution.apr = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.apr;
	      });
	      distribution.may = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.may;
	      });
	      distribution.jun = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.jun;
	      });
	      distribution.jul = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.jul;
	      });
	      distribution.aug = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.aug;
	      });
	      distribution.sep = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.sep;
	      });
	      distribution.oct = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.oct;
	      });
	      distribution.nov = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.nov;
	      });
	      distribution.dec = (0, _lodash.sumBy)(distributions, function (o) {
	        return o.dec;
	      });
	
	      return distribution;
	    }
	  }, {
	    key: 'findDistribution',
	    value: function findDistribution(condition, targetType, brandId, brandModelId) {
	      return (0, _lodash.find)(this.monthlyDistributions, function (o) {
	        return o.condition === condition && o.targetType === targetType && o.brandId === brandId && o.brandModelId === brandModelId;
	      });
	    }
	  }, {
	    key: 'findBrandDistributions',
	    value: function findBrandDistributions(condition, targetType) {
	      return (0, _lodash.filter)(this.monthlyDistributions, function (o) {
	        return o.condition === condition && o.targetType === targetType && o.brandId !== 1 && o.brandModelId === null;
	      });
	    }
	  }, {
	    key: 'findBrandModelDistributions',
	    value: function findBrandModelDistributions(condition, targetType, brandId) {
	      return (0, _lodash.filter)(this.monthlyDistributions, function (o) {
	        return o.condition === condition && o.targetType === targetType && o.brandId === brandId && o.brandModelId !== null;
	      });
	    }
	  }]);
	  return MonthlyDistributionContainerController;
	}();
	
	exports.default = MonthlyDistributionContainerController;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(971);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./monthlyDistributionContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./monthlyDistributionContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".monthlyDistributionContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _userTargetsManagement = __webpack_require__(973);
	
	var _userTargetsManagement2 = _interopRequireDefault(_userTargetsManagement);
	
	var _userTargetsContainer = __webpack_require__(978);
	
	var _userTargetsContainer2 = _interopRequireDefault(_userTargetsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userTargetsManagementModule = _angular2.default.module('userTargetsManagement', [_angularUiRouter2.default, _userTargetsContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('userTargetsManagement', {
	    url: '/userTargetsManagement',
	    component: 'userTargetsManagement'
	  });
	}]).component('userTargetsManagement', _userTargetsManagement2.default).name;
	
	exports.default = userTargetsManagementModule;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userTargetsManagement = __webpack_require__(974);
	
	var _userTargetsManagement2 = _interopRequireDefault(_userTargetsManagement);
	
	var _userTargetsManagement3 = __webpack_require__(975);
	
	var _userTargetsManagement4 = _interopRequireDefault(_userTargetsManagement3);
	
	__webpack_require__(976);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userTargetsManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _userTargetsManagement2.default,
	  controller: _userTargetsManagement4.default
	};
	
	exports.default = userTargetsManagementComponent;

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        Select the entity to manage\r\n        <select\r\n          class=\"form-control\"\r\n          ng-change=\"$ctrl.updateSelectedEntity()\"\r\n          ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n          ng-model=\"$ctrl.selectedEntity\">\r\n        </select>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <div ui-view>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserTargetsManagementController = function () {
	  UserTargetsManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function UserTargetsManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserTargetsManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(UserTargetsManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('userTargetsManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return UserTargetsManagementController;
	}();
	
	exports.default = UserTargetsManagementController;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(977);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./userTargetsManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./userTargetsManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".userTargetsManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _userTargetsContainer = __webpack_require__(979);
	
	var _userTargetsContainer2 = _interopRequireDefault(_userTargetsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userTargetsContainerModule = _angular2.default.module('userTargetsContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('userTargetsManagement.container', {
	    url: '/:locationId',
	    component: 'userTargetsContainer'
	  });
	}]).component('userTargetsContainer', _userTargetsContainer2.default).name;
	
	exports.default = userTargetsContainerModule;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userTargetsContainer = __webpack_require__(980);
	
	var _userTargetsContainer2 = _interopRequireDefault(_userTargetsContainer);
	
	var _userTargetsContainer3 = __webpack_require__(981);
	
	var _userTargetsContainer4 = _interopRequireDefault(_userTargetsContainer3);
	
	__webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userTargetsContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _userTargetsContainer2.default,
	  controller: _userTargetsContainer4.default
	};
	
	exports.default = userTargetsContainerComponent;

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"userTargetsList\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>User Targets</h2>\r\n  \r\n          <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAddTarget()\">\r\n              <span class=\"glyphicon glyphicon-plus\"></span>\r\n              Add New\r\n          </a>\r\n  \r\n          <div class=\"pull-right col-md-3\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.loadUserTargets()\"\r\n                ng-options=\"y for y in $ctrl.years\"\r\n                ng-model=\"$ctrl.selectedYear\">\r\n              </select>\r\n          </div>\r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div>\r\n      <table class=\"table table-striped table-bordered table-hover\">\r\n        <tr>\r\n            <th>User</th>  \r\n            <th>Condition</th>\r\n            <th>Make/Model</th>            \r\n            <th>Enquiry Created</th>\r\n            <th>Enquiry Delivered</th>\r\n            <th>Finance Referred</th>\r\n            <th>Finance Accepted</th>\r\n            <th>Total</th>\r\n            <th>&nbsp;</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"ut in $ctrl.userTargets\">\r\n              <td>{{ut.user}}</td>  \r\n              <td>{{ut.conditionText}}</td>  \r\n              <td>{{ut.brandName}} {{ut.brandModelName}}</td>\r\n              <td>{{ut.enquiriesCreated}}</td>\r\n              <td>{{ut.enquiriesDelivered}}</td>\r\n              <td>{{ut.financesReferred}}</td>\r\n              <td>{{ut.financesAccepted}}</td>\r\n              <td>\r\n                  <a class=\"btn btn-default btn-small remove\" ng-click=\"$ctrl.showEditTarget(ut)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n                  <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showRemoveTarget(ut.userTargetId)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  "

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserTargetsContainerController = function () {
	  UserTargetsContainerController.$inject = ["performanceManagementService", "lookupService", "userService", "$ngConfirm", "$scope", "$stateParams", "growl", "loadingService"];
	  function UserTargetsContainerController(performanceManagementService, lookupService, userService, $ngConfirm, $scope, $stateParams, growl, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserTargetsContainerController);
	    this.performanceManagementService = performanceManagementService;
	    this.lookupService = lookupService;
	    this.userService = userService;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.growl = growl;
	    this.loadingService = loadingService;
	
	    this.years = [];
	    this.entityUsers = [];
	    this.brands = [];
	    this.allBrandModels = [];
	    this.vehicleConditionList = [];
	    this.userTargets = [];
	
	    this.selectedYear = null;
	    this.emptyModel = { brandId: null, brandModelId: null, name: 'Please Select' };
	
	    this.loadYears();
	    this.loadEntityUsers();
	    this.loadUserTargets();
	    this.loadBrands();
	    this.loadBrandModels();
	    this.loadVehicleConditions();
	  }
	
	  (0, _createClass3.default)(UserTargetsContainerController, [{
	    key: 'loadYears',
	    value: function loadYears() {
	      var startYear = 2014;
	      var endYear = new Date().getFullYear();
	
	      for (var i = endYear; i >= startYear - 1; i--) {
	        this.years.push(i);
	      }
	
	      this.selectedYear = endYear;
	    }
	  }, {
	    key: 'loadEntityUsers',
	    value: function loadEntityUsers() {
	      var _this = this;
	
	      this.userService.getLocationUsers(this.$stateParams.locationId, true).then(function (response) {
	        _this.entityUsers = response.data;
	        _this.entityUsers.unshift({ entityUserId: null, firstName: 'Please', lastName: 'Select' });
	      });
	    }
	  }, {
	    key: 'loadUserTargets',
	    value: function loadUserTargets() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('userTargetsList', 'Loading User Targets ...');
	
	      this.performanceManagementService.listUserTargets(this.$stateParams.locationId, this.selectedYear).then(function (response) {
	        return _this2.userTargets = response.data;
	      }).finally(function () {
	        _this2.loadingService.hideLoading('userTargetsList');
	      });
	    }
	  }, {
	    key: 'loadBrands',
	    value: function loadBrands() {
	      var _this3 = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        return _this3.brands = brands;
	      });
	    }
	  }, {
	    key: 'loadBrandModels',
	    value: function loadBrandModels() {
	      var _this4 = this;
	
	      this.lookupService.lookupBrandModels().then(function (brandModels) {
	        return _this4.allBrandModels = brandModels;
	      });
	    }
	  }, {
	    key: 'loadVehicleConditions',
	    value: function loadVehicleConditions() {
	      this.vehicleConditionList.push({ id: 1, name: 'New' });
	      this.vehicleConditionList.push({ id: 2, name: 'Used' });
	    }
	  }, {
	    key: 'showAddTarget',
	    value: function showAddTarget() {
	      var _this5 = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.entityUsers = this.entityUsers;
	      this.$scope.brands = this.brands;
	      this.$scope.allBrandModels = this.allBrandModels;
	      this.$scope.emptyModel = this.emptyModel;
	      this.$scope.brandModels = [this.emptyModel];
	      this.$scope.vehicleConditionList = this.vehicleConditionList;
	      this.$scope.filterBrandModels = this.filterBrandModels;
	
	      this.$scope.userTarget = {
	        entityId: this.$stateParams.locationId,
	        entityUserId: null,
	        year: this.selectedYear, //Selected Year
	        condition: 1, //New
	        brandId: 1, //Default to All Brands New or Used
	        brandModelId: null,
	        enquiriesCreated: 0,
	        enquiriesDelivered: 0,
	        financesReferred: 0,
	        financesAccepted: 0
	      };
	
	      this.$ngConfirm({
	        title: 'Add New Target',
	        contentUrl: 'templates/performance/editUserTargetsTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (!_this5.validateAddTarget()) {
	                return false;
	              }
	
	              _this5.addTarget();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateAddTarget',
	    value: function validateAddTarget() {
	      var utToAdd = this.$scope.userTarget;
	
	      if (!utToAdd.entityUserId) {
	        this.$scope.errMsg = 'Please select a user';
	
	        return false;
	      }
	
	      if (this.getTargetTotal(utToAdd) <= 0) {
	        this.$scope.errMsg = 'Please enter at least one value';
	
	        return false;
	      }
	
	      var duplicate = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId);
	
	      if (duplicate !== undefined) {
	        this.$scope.errMsg = 'This configuration is already added';
	        return false;
	      }
	
	      var brandId = utToAdd.brandId;
	      var modelId = utToAdd.brandModelId;
	
	      /*
	      * If there is a Brand Specified, without any Model
	      * We need to get total of all targets with makes
	      * and the combined total should be less than All 
	      */
	      if (brandId && !modelId) {
	        //Get All Distribution First
	        var all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);
	
	        //If All Category Exist, then we can find other brands under All
	        if (all) {
	          var brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
	          brandTargets.push(utToAdd);
	          var brandTargetsCombined = this.combineTargets(brandTargets);
	          var target = this.isBelowLimit(brandTargetsCombined, all);
	
	          if (target) {
	            this.$scope.errMsg = 'Combined total of all brand(s) for target ' + target + ', exceeds the All Category';
	            return false;
	          }
	        }
	      }
	
	      /*
	      * If the Brand and BrandModel both specified
	      * 1- If the Brand exists, we need to get the total of all distributions
	      * under the Brand, and the combined total should be less than Brand
	      * 2- If the Brand does not exist, we need to check the combined total
	      * of this brandmodel along with any others brands under all category
	      */
	      if (brandId && modelId) {
	        //Get Brand Distribution First
	        var brand = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null);
	
	        if (brand) {
	          var brandModelTargets = this.findBrandModelTargets(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId) || [];
	          brandModelTargets.push(utToAdd);
	          var brandModelTargetsCombined = this.combineTargets(brandModelTargets);
	          var _target = this.isBelowLimit(brandModelTargetsCombined, brand);
	
	          if (_target) {
	            this.$scope.errMsg = 'Combined total of all brand models(s) for the target of ' + _target + ', exceeds the All Category';
	            return false;
	          }
	        } else {
	          var _all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);
	
	          if (_all) {
	            var _brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
	            _brandTargets.push(utToAdd);
	            var _brandTargetsCombined = this.combineTargets(_brandTargets);
	            var _target2 = this.isBelowLimit(_brandTargetsCombined, _all);
	
	            if (_target2) {
	              this.$scope.errMsg = 'Combined total of all brand(s) for the target of ' + _target2 + ', exceeds the All Category';
	              return false;
	            }
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'addTarget',
	    value: function addTarget() {
	      var _this6 = this;
	
	      this.loadingService.showLoading('userTargetsList', 'Adding User Target ...');
	
	      this.performanceManagementService.addUserTarget(this.$scope.userTarget).then(function (response) {
	        _this6.$scope.userTarget.userTargetId = response.data;
	        var user = (0, _lodash.find)(_this6.entityUsers, function (o) {
	          return o.entityUserId === _this6.$scope.userTarget.entityUserId;
	        });
	        _this6.$scope.userTarget.user = user.firstName + ' ' + user.lastName;
	        _this6.$scope.userTarget.conditionText = (0, _lodash.find)(_this6.vehicleConditionList, function (o) {
	          return o.id === _this6.$scope.userTarget.condition;
	        }).name;
	        _this6.$scope.userTarget.brandName = (0, _lodash.find)(_this6.brands, function (o) {
	          return o.brandId === _this6.$scope.userTarget.brandId;
	        }).name;
	        var brandModel = (0, _lodash.find)(_this6.allBrandModels, function (o) {
	          return o.brandModelId === _this6.$scope.userTarget.brandModelId;
	        });
	        _this6.$scope.userTarget.brandModelName = brandModel != null ? brandModel.name : '';
	
	        _this6.userTargets.push(_this6.$scope.userTarget);
	
	        _this6.growl.success('User Target added successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this6.loadingService.hideLoading('userTargetsList');
	      });
	    }
	  }, {
	    key: 'showEditTarget',
	    value: function showEditTarget(ut) {
	      var _this7 = this;
	
	      this.$scope.errMsg = '';
	      this.$scope.entityUsers = this.entityUsers;
	      this.$scope.brands = this.brands;
	      this.$scope.allBrandModels = this.allBrandModels;
	      this.$scope.emptyModel = this.emptyModel;
	      this.$scope.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === ut.brandId;
	      });
	      this.$scope.vehicleConditionList = this.vehicleConditionList;
	      this.$scope.filterBrandModels = this.filterBrandModels;
	
	      this.$scope.userTarget = (0, _assign2.default)({}, ut);
	
	      this.$ngConfirm({
	        title: 'Edit User Target',
	        contentUrl: 'templates/performance/editUserTargetsTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (!_this7.validateEditTarget()) {
	                return false;
	              }
	
	              _this7.editTarget();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateEditTarget',
	    value: function validateEditTarget() {
	      var utToAdd = this.$scope.userTarget;
	
	      if (this.getTargetTotal(utToAdd) <= 0) {
	        this.$scope.errMsg = 'Please enter at least one value';
	        return false;
	      }
	
	      var brandId = utToAdd.brandId;
	      var modelId = utToAdd.brandModelId;
	
	      debugger;
	      /*
	      * If there is a Brand Specified, without any Model
	      * We need to get total of all targets with makes
	      * and the combined total should be less than All 
	      */
	      if (brandId && brandId !== 1 && !modelId) {
	        //Get All Distribution First
	        var all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);
	
	        //If All Category Exist, then we can find other brands under All
	        if (all) {
	          var brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
	          //Exclude it self from Total
	          brandTargets = (0, _lodash.without)(brandTargets, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null));
	          brandTargets.push(utToAdd);
	          var brandTargetsCombined = this.combineTargets(brandTargets);
	          var target = this.isBelowLimit(brandTargetsCombined, all);
	
	          if (target) {
	            this.$scope.errMsg = 'Combined total of all brand(s) for target ' + target + ', exceeds the All Category';
	            return false;
	          }
	        }
	      }
	
	      /*
	      * If the Brand and BrandModel both specified
	      * 1- If the Brand exists, we need to get the total of all distributions
	      * under the Brand, and the combined total should be less than Brand
	      * 2- If the Brand does not exist, we need to check the combined total
	      * of this brandmodel along with any others brands under all category
	      */
	      if (brandId && modelId) {
	        //Get Brand Distribution First
	        var brand = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null);
	
	        if (brand) {
	          var brandModelTargets = this.findBrandModelTargets(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId) || [];
	          //Exclude it self from Total
	          brandModelTargets = (0, _lodash.without)(brandModelTargets, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId));
	          brandModelTargets.push(utToAdd);
	          var brandModelTargetsCombined = this.combineTargets(brandModelTargets);
	          var _target3 = this.isBelowLimit(brandModelTargetsCombined, brand);
	
	          if (_target3) {
	            this.$scope.errMsg = 'Combined total of all brand models(s) for the target of ' + _target3 + ', exceeds the All Category';
	            return false;
	          }
	        } else {
	          var _all2 = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);
	
	          if (_all2) {
	            var _brandTargets2 = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
	            //Exclude it self from Total
	            _brandTargets2 = (0, _lodash.without)(_brandTargets2, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId));
	            _brandTargets2.push(utToAdd);
	            var _brandTargetsCombined2 = this.combineTargets(_brandTargets2);
	            var _target4 = this.isBelowLimit(_brandTargetsCombined2, _all2);
	
	            if (_target4) {
	              this.$scope.errMsg = 'Combined total of all brand(s) for the target of ' + _target4 + ', exceeds the All Category';
	              return false;
	            }
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'editTarget',
	    value: function editTarget() {
	      var _this8 = this;
	
	      this.loadingService.showLoading('userTargetsList', 'Updating User Target ...');
	
	      this.performanceManagementService.editUserTarget(this.$scope.userTarget).then(function (response) {
	        var ut = (0, _lodash.find)(_this8.userTargets, function (o) {
	          return o.userTargetId === _this8.$scope.userTarget.userTargetId;
	        });
	        ut.enquiriesCreated = _this8.$scope.userTarget.enquiriesCreated;
	        ut.enquiriesDelivered = _this8.$scope.userTarget.enquiriesDelivered;
	        ut.financesReferred = _this8.$scope.userTarget.financesReferred;
	        ut.financesAccepted = _this8.$scope.userTarget.financesAccepted;
	
	        _this8.growl.success('Target Updated successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this8.loadingService.hideLoading('userTargetsList');
	      });
	    }
	  }, {
	    key: 'showRemoveTarget',
	    value: function showRemoveTarget(userTargetId) {
	      var _this9 = this;
	
	      this.$ngConfirm({
	        title: 'Remove User Target',
	        content: 'Are you sure you want to delete this Target ?',
	        typeAnimation: false,
	        type: 'red',
	        buttons: {
	          yes: {
	            text: 'Delete',
	            btnClass: 'btn-danger',
	            action: function action() {
	              _this9.removeTarget(userTargetId);
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeTarget',
	    value: function removeTarget(userTargetId) {
	      var _this10 = this;
	
	      this.loadingService.showLoading('userTargetsList', 'Removing User Target ...');
	
	      this.performanceManagementService.removeUserTarget(this.$stateParams.locationId, userTargetId).then(function (response) {
	        var ut = (0, _lodash.find)(_this10.userTargets, function (o) {
	          return o.userTargetId === userTargetId;
	        });
	
	        _this10.userTargets = (0, _lodash.without)(_this10.userTargets, ut);
	
	        _this10.growl.success('Target Deleted successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this10.loadingService.hideLoading('userTargetsList');
	      });
	    }
	  }, {
	    key: 'isPositive',
	    value: function isPositive(number) {
	      return number >= 0;
	    }
	  }, {
	    key: 'filterBrandModels',
	    value: function filterBrandModels(ut) {
	      var _brandModels;
	
	      this.brandModels = [this.emptyModel];
	      (_brandModels = this.brandModels).push.apply(_brandModels, (0, _toConsumableArray3.default)((0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === ut.brandId;
	      })));
	
	      ut.brandModelId = null;
	    }
	  }, {
	    key: 'getTargetTotal',
	    value: function getTargetTotal(ut) {
	      return ut.enquiriesCreated + ut.enquiriesDelivered + ut.financesReferred + ut.financesAccepted;
	    }
	  }, {
	    key: 'findUserTarget',
	    value: function findUserTarget(entityUserId, condition, brandId, brandModelId) {
	      return (0, _lodash.find)(this.userTargets, function (o) {
	        return o.entityUserId === entityUserId && o.condition === condition && o.brandId === brandId && o.brandModelId === brandModelId;
	      });
	    }
	  }, {
	    key: 'findBrandTargets',
	    value: function findBrandTargets(entityUserId, condition) {
	      return (0, _lodash.filter)(this.userTargets, function (o) {
	        return o.entityUserId === entityUserId && o.condition === condition && o.brandId !== 1 && o.brandModelId === null;
	      });
	    }
	  }, {
	    key: 'findBrandModelTargets',
	    value: function findBrandModelTargets(entityUserId, condition, brandId) {
	      return (0, _lodash.filter)(this.userTargets, function (o) {
	        return o.entityUserId === entityUserId && o.condition === condition && o.brandId === brandId && o.brandModelId !== null;
	      });
	    }
	  }, {
	    key: 'combineTargets',
	    value: function combineTargets(targets) {
	      var target = {};
	
	      target.enquiriesCreated = (0, _lodash.sumBy)(targets, function (o) {
	        return o.enquiriesCreated;
	      });
	      target.enquiriesDelivered = (0, _lodash.sumBy)(targets, function (o) {
	        return o.enquiriesDelivered;
	      });
	      target.financesReferred = (0, _lodash.sumBy)(targets, function (o) {
	        return o.financesReferred;
	      });
	      target.financesAccepted = (0, _lodash.sumBy)(targets, function (o) {
	        return o.financesAccepted;
	      });
	
	      return target;
	    }
	  }, {
	    key: 'isBelowLimit',
	    value: function isBelowLimit(utToUpdate, utToCompare) {
	      if (utToUpdate.enquiriesCreated > utToCompare.enquiriesCreated) {
	        return "Enquiries Created";
	      }
	
	      if (utToUpdate.enquiriesDelivered > utToCompare.enquiriesDelivered) {
	        return "Enquiries Delivered";
	      }
	
	      if (utToUpdate.financesReferred > utToCompare.financesReferred) {
	        return "Finances Referred";
	      }
	
	      if (utToUpdate.financesAccepted > utToCompare.financesAccepted) {
	        return "Finances Accepted";
	      }
	
	      return null;
	    }
	  }]);
	  return UserTargetsContainerController;
	}();
	
	exports.default = UserTargetsContainerController;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(983);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./userTargetsContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./userTargetsContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".userTargetsContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _entityPreferences = __webpack_require__(985);
	
	var _entityPreferences2 = _interopRequireDefault(_entityPreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityPreferencesModule = _angular2.default.module('entityPreferences', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('entityPreferences', {
	    url: '/entityPreferences',
	    component: 'entityPreferences'
	  });
	}]).component('entityPreferences', _entityPreferences2.default).name;
	
	exports.default = entityPreferencesModule;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entityPreferences = __webpack_require__(986);
	
	var _entityPreferences2 = _interopRequireDefault(_entityPreferences);
	
	var _entityPreferences3 = __webpack_require__(987);
	
	var _entityPreferences4 = _interopRequireDefault(_entityPreferences3);
	
	__webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityPreferencesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _entityPreferences2.default,
	  controller: _entityPreferences4.default
	};
	
	exports.default = entityPreferencesComponent;

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"migration\">\r\n    <div class=\"panel\">\r\n  \r\n        <header>\r\n            <h2>Entity Preferences</h2>\r\n      </header>\r\n  \r\n      <br /><br />\r\n  \r\n        <div class=\"row\">\r\n          <label class=\"col-md-6\">Select Location</label>\r\n          <label class=\"col-md-6\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.loadPreferences()\"\r\n              ng-options=\"item.entityId as item.name for item in $ctrl.locations\"\r\n              ng-model=\"$ctrl.selectedLocationId\">\r\n            </select>\r\n          </label>\r\n        </div>\r\n        \r\n        <hr class=\"dashboard-seperator\">\r\n        \r\n        <div block-ui=\"entityPrefs\" ng-show=\"$ctrl.selectedLocationId\">\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Promises</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.promises\"></switch>\r\n              </label>          \r\n          </div>\r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Web Enquiries</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.webEnquiries\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Open Enquiries</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.openEnquiries\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Open Finance</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.openFinances\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Pending Deliveries</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.pendingDeliveries\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Top 10 Recent Contacts</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.top10RecentContacts\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Matching Contacts</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.matchingContacts\"></switch>\r\n              </label>          \r\n          </div>          \r\n\r\n          <div class=\"row\">            \r\n              <label class=\"col-md-6\">Matching Vehicles</label>\r\n              <label class=\"col-md-6\">\r\n                  <switch ng-model=\"$ctrl.selectedPref.matchingVehicles\"></switch>\r\n              </label>          \r\n          </div>    \r\n\r\n          <div class=\"row\">            \r\n            <label class=\"col-md-6\">Lead Monitor</label>\r\n            <label class=\"col-md-6\">\r\n                <switch ng-model=\"$ctrl.selectedPref.leadMonitor\"></switch>\r\n            </label>          \r\n          </div>              \r\n          \r\n          <div class=\"row\">            \r\n            <div class=\"col-md-offset-4 col-md-4\">\r\n              <button class=\"btn btn-large btn-success\" ng-click=\"$ctrl.confirmSavePreferences()\">Save Changes</button>\r\n            </div>               \r\n          </div>              \r\n        </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityPreferencesController = function () {
	  EntityPreferencesController.$inject = ["entityService", "loadingService", "$ngConfirm", "growl"];
	  function EntityPreferencesController(entityService, loadingService, $ngConfirm, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EntityPreferencesController);
	    this.entityService = entityService;
	    this.loadingService = loadingService;
	    this.$ngConfirm = $ngConfirm;
	    this.growl = growl;
	
	    this.selectedLocationId = null;
	    this.selectedPref = null;
	    this.locations = [];
	
	    this.initializeLocations();
	  }
	
	  (0, _createClass3.default)(EntityPreferencesController, [{
	    key: 'initializeLocations',
	    value: function initializeLocations() {
	      var _this = this;
	
	      this.entityService.listAllLocations().then(function (response) {
	        var firstItem = {
	          entityId: null,
	          name: '---- Select Location ----'
	        };
	
	        _this.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
	      });
	    }
	  }, {
	    key: 'loadPreferences',
	    value: function loadPreferences() {
	      var _this2 = this;
	
	      if (!this.selectedLocationId) {
	        return;
	      }
	
	      this.loadingService.showLoading('entityPrefs', 'Loading Preferences ...');
	
	      this.entityService.getEntityPreferences(this.selectedLocationId).then(function (response) {
	        _this2.selectedPref = response.data;
	      }).finally(function () {
	        _this2.loadingService.hideLoading('entityPrefs');
	      });
	    }
	  }, {
	    key: 'confirmSavePreferences',
	    value: function confirmSavePreferences() {
	      var _this3 = this;
	
	      this.$ngConfirm({
	        title: "Confirm",
	        content: 'Are you sure want to save changes ?',
	        type: 'orange',
	        buttons: {
	          ok: {
	            text: 'Save Changes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this3.savePreferences();
	            }
	          },
	          cancel: {
	            text: 'Leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'savePreferences',
	    value: function savePreferences() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('entityPrefs', 'Saving Preferences ...');
	
	      this.entityService.updateEntityPreferences(this.selectedPref).then(function (response) {
	        _this4.growl.success('Changes saved successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this4.loadingService.hideLoading('entityPrefs');
	      });
	    }
	  }]);
	  return EntityPreferencesController;
	}();
	
	exports.default = EntityPreferencesController;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(989);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entityPreferences.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entityPreferences.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".entityPreferences{color:red}", ""]);
	
	// exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportsAccess = __webpack_require__(991);
	
	var _reportsAccess2 = _interopRequireDefault(_reportsAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsAccessModule = _angular2.default.module('reportsAccess', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('reportsAccess', {
	    url: '/reportsAccess',
	    component: 'reportsAccess'
	  });
	}]).component('reportsAccess', _reportsAccess2.default).name;
	
	exports.default = reportsAccessModule;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportsAccess = __webpack_require__(992);
	
	var _reportsAccess2 = _interopRequireDefault(_reportsAccess);
	
	var _reportsAccess3 = __webpack_require__(993);
	
	var _reportsAccess4 = _interopRequireDefault(_reportsAccess3);
	
	__webpack_require__(994);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsAccessComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _reportsAccess2.default,
	  controller: _reportsAccess4.default
	};
	
	exports.default = reportsAccessComponent;

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"migration\">\r\n  <div class=\"panel\">\r\n\r\n      <header>\r\n          <h2>Reports Access</h2>\r\n    </header>\r\n\r\n    <br /><br />\r\n\r\n      <div class=\"row\">\r\n        <label class=\"col-md-6\">Select Location</label>\r\n        <label class=\"col-md-6\">\r\n          <select\r\n            class=\"form-control\"\r\n            ng-change=\"$ctrl.loadAccess()\"\r\n            ng-options=\"item.entityId as item.name for item in $ctrl.locations\"\r\n            ng-model=\"$ctrl.selectedLocationId\">\r\n          </select>\r\n        </label>\r\n      </div>\r\n      \r\n      <hr class=\"dashboard-seperator\">\r\n      \r\n      <div block-ui=\"reportsAccess\" ng-show=\"$ctrl.selectedLocationId\">\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th>\r\n                    Report \r\n                </th>\r\n                <th>\r\n                  Enabled\r\n              </th>                \r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"ra in $ctrl.selectedReportsAccess\">                  \r\n                <td>{{ra.name}}</td>\r\n                <td><switch ng-model=\"ra.enabled\" ng-change=\"$ctrl.toggleAccess(ra.reportId)\"></switch></td>\r\n              </tr>\r\n          </tbody>\r\n      </table>             \r\n      </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsAccessController = function () {
	  ReportsAccessController.$inject = ["entityService", "loadingService", "growl"];
	  function ReportsAccessController(entityService, loadingService, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportsAccessController);
	    this.entityService = entityService;
	    this.loadingService = loadingService;
	    this.growl = growl;
	
	    this.selectedLocationId = null;
	    this.selectedPref = null;
	    this.locations = [];
	
	    this.initializeLocations();
	  }
	
	  (0, _createClass3.default)(ReportsAccessController, [{
	    key: 'initializeLocations',
	    value: function initializeLocations() {
	      var _this = this;
	
	      this.entityService.listAllLocations().then(function (response) {
	        var firstItem = {
	          entityId: null,
	          name: '---- Select Location ----'
	        };
	
	        _this.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
	      });
	    }
	  }, {
	    key: 'loadAccess',
	    value: function loadAccess() {
	      var _this2 = this;
	
	      if (!this.selectedLocationId) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportsAccess', 'Loading Reports Access ...');
	
	      this.entityService.getEntityReportsAccess(this.selectedLocationId).then(function (response) {
	        _this2.selectedReportsAccess = response.data;
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportsAccess');
	      });
	    }
	  }, {
	    key: 'toggleAccess',
	    value: function toggleAccess(reportId) {
	      var _this3 = this;
	
	      if (!this.selectedLocationId) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportsAccess', 'Updating Reports Access ...');
	
	      this.entityService.toggleEntityReportAccess(this.selectedLocationId, reportId).then(function (response) {
	        _this3.growl.success('Report Access updated successfully', { ttl: 5000 });
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportsAccess');
	      });
	    }
	  }]);
	  return ReportsAccessController;
	}();
	
	exports.default = ReportsAccessController;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(995);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportsAccess.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportsAccess.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportsAccess{color:red}", ""]);
	
	// exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dataUtility = __webpack_require__(997);
	
	var _dataUtility2 = _interopRequireDefault(_dataUtility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataUtilityModule = _angular2.default.module('dataUtility', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dataUtility', {
	    url: '/admin/dataUtility',
	    component: 'dataUtility'
	  });
	}]).component('dataUtility', _dataUtility2.default).name;
	
	exports.default = dataUtilityModule;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dataUtility = __webpack_require__(998);
	
	var _dataUtility2 = _interopRequireDefault(_dataUtility);
	
	var _dataUtility3 = __webpack_require__(999);
	
	var _dataUtility4 = _interopRequireDefault(_dataUtility3);
	
	__webpack_require__(1000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataUtilityComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _dataUtility2.default,
	  controller: _dataUtility4.default
	};
	
	exports.default = dataUtilityComponent;

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Data Utility</h2> \r\n        \r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>             \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.locations track by item.entityId\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>                                       \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Contact\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <input class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter1\" />\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Enquiry Status\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                        </select>\r\n                      </div>                \r\n                    </div>                     \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-12\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.viewOpenEnquiries()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n\r\n                        <a class=\"btn btn-block1 btn-danger\" ng-click=\"$ctrl.confirmCloseOpenEnquiries()\">\r\n                          <i class=\"fa fa-times\"></i>\r\n                          Close Selected Enquiries\r\n                        </a>                        \r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div block-ui=\"webEnquiriesList\">\r\n              <table class=\"table table-bordered table-hover table-striped\">\r\n                <thead>\r\n                    <tr>\r\n                      <tr>\r\n                        <th class=\"col-md-1\"><input type=\"checkbox\" ng-checked=\"$ctrl.toggleState\" ng-click=\"$ctrl.toggleCheck()\"></th>\r\n                        <th class=\"col-md-1\">Created</th>       \r\n                        <th class=\"col-md-1\">Status</th>       \r\n                        <th class=\"col-md-2\">Contact Name</th>\r\n                        <th class=\"col-md-1\">Contact Phone</th>                        \r\n                        <th class=\"col-md-2\">Contact Email</th>      \r\n                        <th class=\"col-md-2\">Subject</th>    \r\n                        <th class=\"col-md-1\">Vehicle</th>    \r\n                        <th class=\"col-md-1\">Confirmed</th>                            \r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <tr data-ng-repeat=\"we in $ctrl.openEnquiries\">\r\n                        <td class=\"col-md-1\"><input type=\"checkbox\" ng-checked=\"we.checked\" ng-click=\"we.checked = !we.checked; $ctrl.checkToggle()\"></td>\r\n                        <td class=\"col-md-1\">{{we.created | date : 'dd MMM yy HH:mm'}}</td>\r\n                        <td class=\"col-md-1\">{{we.status}}</td>\r\n                        <td class=\"col-md-2\">{{we.contactName}}</td>\r\n                        <td class=\"col-md-1\">{{we.contactPhone}}</td>\r\n                        <td class=\"col-md-2\">{{we.contactEmail}}</td>\r\n                        <td class=\"col-md-2\">{{we.subject}}</td>\r\n                        <td class=\"col-md-1\">{{we.vehicle}}</td>\r\n                        <td class=\"col-md-1\">{{we.confirmed | date : 'dd MMM yy HH:mm'}}</td>\r\n                    </tr> \r\n                </tbody>\r\n            </table>              \r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataUtilityController = function (_BaseReportController) {
	  DataUtilityController.$inject = ["authService", "reportingService", "appConfig", "enums", "loadingService", "utilsService", "adminService", "webEnquiriesService", "$ngConfirm", "growl", "entityService", "exportService"];
	  (0, _inherits3.default)(DataUtilityController, _BaseReportController);
	
	  function DataUtilityController(authService, reportingService, appConfig, enums, loadingService, utilsService, adminService, webEnquiriesService, $ngConfirm, growl, entityService, exportService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DataUtilityController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DataUtilityController.__proto__ || (0, _getPrototypeOf2.default)(DataUtilityController)).call(this, reportingService, loadingService, utilsService));
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.appConfig = appConfig;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.utilsService = utilsService;
	    _this.adminService = adminService;
	    _this.webEnquiriesService = webEnquiriesService;
	    _this.$ngConfirm = $ngConfirm;
	    _this.growl = growl;
	    _this.entityService = entityService;
	    _this.exportService = exportService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportData: true
	    };
	
	    _this.getLocations().then(function (response) {
	      _this.getDateRangeList();
	      _this.getEnquiryStatusList();
	      _this.reset();
	    });
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(DataUtilityController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getLocations',
	    value: function getLocations() {
	      var _this2 = this;
	
	      var source = this.entityService.listAllLocations();
	
	      source.then(function (response) {
	        var firstItem = {
	          entityId: null,
	          name: '---- Select Location ----'
	        };
	
	        _this2.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
	      });
	
	      return source;
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = [{ id: null, name: 'All' }, { id: 1, name: 'Open' }, { id: 3, name: 'Confirmed' }];
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.errMsgs = [];
	      this.toggleState = null;
	      this.openEnquiries = null;
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.locations[0];
	      this.reportCriteria.additionalParameter1 = null;
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      if (this.reportCriteria.location.entityId == null) {
	        this.errMsgs.push('Please select a location');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = [this.reportCriteria.location.entityId];
	      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'viewOpenEnquiries',
	    value: function viewOpenEnquiries() {
	      var _this3 = this;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('webEnquiriesList', 'Loading Open Enquiries ...');
	
	      this.adminService.listOpenEnquiries(this.parseCriteria()).then(function (response) {
	        _this3.toggleState = null;
	        _this3.openEnquiries = response.data;
	      }).catch(function (err) {}).finally(function () {
	        _this3.loadingService.hideLoading('webEnquiriesList');
	      });
	    }
	  }, {
	    key: 'toggleCheck',
	    value: function toggleCheck() {
	      var _this4 = this;
	
	      if (!this.openEnquiries || !this.openEnquiries.length) {
	        this.toggleState = null;
	        return;
	      }
	
	      if (this.toggleState === null) {
	        this.toggleState = true;
	      } else {
	        this.toggleState = !this.toggleState;
	      }
	
	      this.openEnquiries.map(function (we) {
	        we.checked = _this4.toggleState;
	      });
	    }
	  }, {
	    key: 'checkToggle',
	    value: function checkToggle() {
	      var allChecked = true;
	
	      this.openEnquiries.map(function (we) {
	        allChecked = allChecked && we.checked;
	      });
	
	      this.toggleState = allChecked;
	    }
	  }, {
	    key: 'confirmCloseOpenEnquiries',
	    value: function confirmCloseOpenEnquiries() {
	      var _this5 = this;
	
	      if (!this.openEnquiries || !this.openEnquiries.length) {
	        return;
	      }
	
	      this.$ngConfirm({
	        title: "Close Open Enquiries",
	        content: 'Are you sure you want to close the selected open enquiries? \n        <br>This will mark Open Enquiries as <b>Lost</b> and Confirmed Enquiries as <b>Closed</b>. \n        <br>Any vehicles / trade ins attached will be updated accordinly. \n        <br><br>Changes cannot be undone',
	        type: 'orange',
	        columnClass: 'l',
	        buttons: {
	          renew: {
	            text: 'Im sure, close open enuiries',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this5.closeOpenEnquiries();
	            }
	          },
	          cancel: {
	            text: 'Leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'closeOpenEnquiries',
	    value: function closeOpenEnquiries() {
	      var _this6 = this;
	
	      var enquiryIds = this.openEnquiries.filter(function (oe) {
	        return oe.checked;
	      }).map(function (oe) {
	        return oe.enquiryId;
	      });
	
	      this.loadingService.showLoading('webEnquiriesList', 'Closing Open Enquiries ...');
	
	      this.adminService.closeOpenEnquiries(enquiryIds).then(function (response) {
	        _this6.growl.success('Successfully updated ' + response.data.length + ' out of ' + enquiryIds.length + ' enquiries', { ttl: 5000 });
	        var updatedEnuiries = (0, _lodash.filter)(_this6.openEnquiries, function (oe) {
	          return response.data.includes(oe.enquiryId);
	        });
	        _lodash.pull.apply(undefined, [_this6.openEnquiries].concat((0, _toConsumableArray3.default)(updatedEnuiries)));
	      }).catch(function (err) {
	        _this6.growl.error('Could not update enquiries', { ttl: 5000 });
	      }).finally(function () {
	        _this6.loadingService.hideLoading('webEnquiriesList');
	      });
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Data Utility', this.parseCriteria());
	    }
	  }]);
	  return DataUtilityController;
	}(_baseReportController2.default);
	
	exports.default = DataUtilityController;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1001);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./dataUtility.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./dataUtility.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataUtility{color:red}", ""]);
	
	// exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _scheduledReportsManagement = __webpack_require__(1003);
	
	var _scheduledReportsManagement2 = _interopRequireDefault(_scheduledReportsManagement);
	
	var _scheduledReportsContainer = __webpack_require__(1008);
	
	var _scheduledReportsContainer2 = _interopRequireDefault(_scheduledReportsContainer);
	
	var _scheduledReport = __webpack_require__(1014);
	
	var _scheduledReport2 = _interopRequireDefault(_scheduledReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduledReportsManagementModule = _angular2.default.module('scheduledReportsManagement', [_angularUiRouter2.default, _scheduledReportsContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('scheduledReportsManagement', {
	    url: '/scheduledReportsManagement',
	    component: 'scheduledReportsManagement'
	  });
	}]).component('scheduledReportsManagement', _scheduledReportsManagement2.default).service('scheduledReportService', _scheduledReport2.default).name;
	
	exports.default = scheduledReportsManagementModule;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scheduledReportsManagement = __webpack_require__(1004);
	
	var _scheduledReportsManagement2 = _interopRequireDefault(_scheduledReportsManagement);
	
	var _scheduledReportsManagement3 = __webpack_require__(1005);
	
	var _scheduledReportsManagement4 = _interopRequireDefault(_scheduledReportsManagement3);
	
	__webpack_require__(1006);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduledReportsManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _scheduledReportsManagement2.default,
	  controller: _scheduledReportsManagement4.default
	};
	
	exports.default = scheduledReportsManagementComponent;

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity for Automatic Promises Management\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduledReportsManagementController = function () {
	  ScheduledReportsManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function ScheduledReportsManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ScheduledReportsManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(ScheduledReportsManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('scheduledReportsManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return ScheduledReportsManagementController;
	}();
	
	exports.default = ScheduledReportsManagementController;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1007);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./scheduledReportsManagement.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./scheduledReportsManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".scheduledReportsManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _scheduledReportsContainer = __webpack_require__(1009);
	
	var _scheduledReportsContainer2 = _interopRequireDefault(_scheduledReportsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduledReportsContainerModule = _angular2.default.module('scheduledReportsContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('scheduledReportsManagement.container', {
	    url: '/:locationId',
	    component: 'scheduledReportsContainer'
	  });
	}]).component('scheduledReportsContainer', _scheduledReportsContainer2.default).name;
	
	exports.default = scheduledReportsContainerModule;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scheduledReportsContainer = __webpack_require__(1010);
	
	var _scheduledReportsContainer2 = _interopRequireDefault(_scheduledReportsContainer);
	
	var _scheduledReportsContainer3 = __webpack_require__(1011);
	
	var _scheduledReportsContainer4 = _interopRequireDefault(_scheduledReportsContainer3);
	
	__webpack_require__(1012);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scheduledReportsContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _scheduledReportsContainer2.default,
	  controller: _scheduledReportsContainer4.default
	};
	
	exports.default = scheduledReportsContainerComponent;

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"scheduledReportsList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Scheduled Reports Management</h2>\r\n\r\n        <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAdd()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span>\r\n            Add New\r\n        </a>\r\n\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-2\">Report</th>\r\n          <th class=\"col-md-2\">Frequency</th>\r\n          <th class=\"col-md-2\">Output</th>\r\n          <th class=\"col-md-4\">Recipients</th>\r\n          <th class=\"col-md-1\">Edit</th>\r\n          <th class=\"col-md-1\">Delete</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"sr in $ctrl.scheduledReports\">\r\n            <td class=\"col-md-2\">{{sr.reportType}}</td>\r\n            <td class=\"col-md-2\">{{sr.frequency}}</td>\r\n            <td class=\"col-md-2\">{{sr.outputType}}</td>\r\n            <td class=\"col-md-4\">{{sr.recipients}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-default btn-small remove\" ng-click=\"$ctrl.showEdit(sr.scheduledReportId)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.showDelete(sr)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduledReportsContainerController = function () {
	  ScheduledReportsContainerController.$inject = ["authService", "enums", "loadingService", "scheduledReportService", "$stateParams", "$ngConfirm", "$scope", "reportingService", "userService", "lookupService", "growl"];
	  function ScheduledReportsContainerController(authService, enums, loadingService, scheduledReportService, $stateParams, $ngConfirm, $scope, reportingService, userService, lookupService, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ScheduledReportsContainerController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.scheduledReportService = scheduledReportService;
	    this.$stateParams = $stateParams;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	    this.reportingService = reportingService;
	    this.userService = userService;
	    this.lookupService = lookupService;
	    this.growl = growl;
	
	    this.$scope.reportParameterData = {};
	
	    this.getAvailableReports();
	    this.getLocationUsers();
	    this.listScheduledReports();
	
	    this.prepareReportParameters();
	    this.prepareReportParametersData();
	  }
	
	  (0, _createClass3.default)(ScheduledReportsContainerController, [{
	    key: 'listScheduledReports',
	    value: function listScheduledReports() {
	      var _this = this;
	
	      this.loadingService.showLoading('scheduledReportsList', 'Loading Scheduled Reports ...');
	
	      this.scheduledReportService.listScheduledReports(this.$stateParams.locationId).then(function (response) {
	        _this.scheduledReports = response.data;
	      }).finally(function () {
	        _this.loadingService.hideLoading('scheduledReportsList');
	      });
	    }
	  }, {
	    key: 'getAvailableReports',
	    value: function getAvailableReports() {
	      var _this2 = this;
	
	      this.reportingService.availableReportsByCategory(this.$stateParams.locationId, 1).then(function (response) {
	        _this2.availableReports = response.data;
	        var availableReportIdsForNow = [1, 2, 3, 11, 26];
	        _this2.availableReports = (0, _lodash.filter)(_this2.availableReports, function (o) {
	          return availableReportIdsForNow.includes(o.reportId);
	        });
	        var defaultItem = { reportId: null, name: 'Please Select' };
	        _this2.availableReports = [defaultItem].concat((0, _toConsumableArray3.default)(_this2.availableReports));
	      });
	    }
	  }, {
	    key: 'getLocationUsers',
	    value: function getLocationUsers() {
	      var _this3 = this;
	
	      this.userService.getLocationUsers(this.$stateParams.locationId, true).then(function (response) {
	        _this3.locationUsers = response.data;
	        _this3.locationUsers = (0, _lodash.sortBy)(_this3.locationUsers, function (o) {
	          return o.firstName + ' ' + o.lastName;
	        });
	      });
	    }
	  }, {
	    key: 'selectUsers',
	    value: function selectUsers() {
	      var _$scope$selectedUsers;
	
	      var selUserIds = this.$scope.selAllUsers.map(function (r) {
	        return r.userId;
	      });
	      var selUserItems = (0, _lodash.filter)(this.locationUsers, function (o) {
	        return (0, _lodash.find)(selUserIds, function (uId) {
	          return o.userId === uId;
	        });
	      });
	      this.$scope.locationUsers = _lodash.without.apply(undefined, [this.$scope.locationUsers].concat((0, _toConsumableArray3.default)(selUserItems)));
	      (_$scope$selectedUsers = this.$scope.selectedUsers).push.apply(_$scope$selectedUsers, (0, _toConsumableArray3.default)(selUserItems));
	      this.$scope.selAllUsers = [];
	
	      this.$scope.locationUsers = (0, _lodash.sortBy)(this.$scope.locationUsers, function (o) {
	        return o.firstName + ' ' + o.lastName;
	      });
	      this.$scope.selectedUsers = (0, _lodash.sortBy)(this.$scope.selectedUsers, function (o) {
	        return o.firstName + ' ' + o.lastName;
	      });
	
	      this.$scope.scheduledReport.recipients = this.$scope.selectedUsers.map(function (r) {
	        return r.userId;
	      });
	    }
	  }, {
	    key: 'deSelectUsers',
	    value: function deSelectUsers() {
	      var _$scope$locationUsers;
	
	      var selUserIds = this.$scope.selUsers.map(function (r) {
	        return r.userId;
	      });
	      var selUserItems = (0, _lodash.filter)(this.$scope.selectedUsers, function (o) {
	        return (0, _lodash.find)(selUserIds, function (uId) {
	          return o.userId === uId;
	        });
	      });
	      this.$scope.selectedUsers = _lodash.without.apply(undefined, [this.$scope.selectedUsers].concat((0, _toConsumableArray3.default)(selUserItems)));
	      (_$scope$locationUsers = this.$scope.locationUsers).push.apply(_$scope$locationUsers, (0, _toConsumableArray3.default)(selUserItems));
	      this.$scope.selUsers = [];
	
	      this.$scope.locationUsers = (0, _lodash.sortBy)(this.$scope.locationUsers, function (o) {
	        return o.firstName + ' ' + o.lastName;
	      });
	      this.$scope.selectedUsers = (0, _lodash.sortBy)(this.$scope.selectedUsers, function (o) {
	        return o.firstName + ' ' + o.lastName;
	      });
	
	      this.$scope.scheduledReport.recipients = this.$scope.selectedUsers.map(function (r) {
	        return r.userId;
	      });
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'showAdd',
	    value: function showAdd() {
	      this.$scope.errors = null;
	      this.$scope.editMode = false;
	
	      this.$scope.scheduledReport = {
	        entityId: this.$stateParams.locationId,
	        reportId: null,
	        frequency: null,
	        outputType: null,
	        recipients: [],
	        additionalRecipients: null,
	        criteria: {}
	      };
	
	      this.$scope.reportsList = this.availableReports;
	      this.$scope.frequencyList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_FREQUENCY, true);
	      this.$scope.outputList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_OUTPUT_TYPE_TEMP, true);
	      this.$scope.locationUsers = this.locationUsers;
	      this.$scope.selAllUsers = [];
	      this.$scope.selectedUsers = [];
	      this.$scope.selUsers = [];
	      this.$scope.reportTypeChanged = this.reportTypeChanged.bind(this);
	      this.$scope.selectUsers = this.selectUsers.bind(this);
	      this.$scope.deSelectUsers = this.deSelectUsers.bind(this);
	
	      this.$ngConfirm({
	        title: 'Add Scheduled Report',
	        contentUrl: 'templates/reports/scheduledReportEditTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: this.add.bind(this)
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var _this4 = this;
	
	      if (!this.validateCriteria()) {
	        return false;
	      }
	
	      this.loadingService.showLoading('scheduledReportsList', 'Adding Scheduled Report ...');
	
	      this.$scope.scheduledReport.criteria = this.parseCriteria();
	
	      this.scheduledReportService.add(this.$scope.scheduledReport).then(function (response) {
	        _this4.scheduledReports.push(response.data);
	        _this4.growl.success('Successfully added Scheduled Report', { ttl: 5000 });
	      }).finally(function () {
	        _this4.loadingService.hideLoading('scheduledReportsList');
	      });
	    }
	  }, {
	    key: 'showDelete',
	    value: function showDelete(scheduledReport) {
	      var _this5 = this;
	
	      this.$ngConfirm({
	        title: 'Delete Scheduled Report',
	        content: 'Are you sure you want to delete this Scheduled Report ?',
	        typeAnimation: false,
	        scope: this.$scope,
	        type: 'red',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-danger',
	            action: function action() {
	              return _this5.delete(scheduledReport);
	            }
	          },
	          no: {
	            text: 'Leave it',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(scheduledReport) {
	      var _this6 = this;
	
	      this.loadingService.showLoading('scheduledReportsList', 'Removing Scheduled Report ...');
	
	      this.scheduledReportService.delete(this.$stateParams.locationId, scheduledReport.scheduledReportId).then(function (response) {
	        _this6.scheduledReports = (0, _lodash.without)(_this6.scheduledReports, scheduledReport);
	        _this6.growl.success('Successfully removed Scheduled Report', { ttl: 5000 });
	      }).finally(function () {
	        _this6.loadingService.hideLoading('scheduledReportsList');
	      });
	    }
	  }, {
	    key: 'showEdit',
	    value: function showEdit(scheduledReportId) {
	      var _this7 = this;
	
	      this.loadingService.showLoading('scheduledReportsList', 'Loading Scheduled Report ...');
	
	      this.scheduledReportService.get(this.$stateParams.locationId, scheduledReportId).then(function (response) {
	        _this7.showEditNext(response.data);
	      }).finally(function () {
	        _this7.loadingService.hideLoading('scheduledReportsList');
	      });
	    }
	  }, {
	    key: 'showEditNext',
	    value: function showEditNext(scheduledReport) {
	      var _this8 = this;
	
	      this.$scope.errors = null;
	      this.$scope.editMode = true;
	
	      this.$scope.scheduledReport = {
	        entityId: this.$stateParams.locationId,
	        reportId: scheduledReport.reportId,
	        frequency: scheduledReport.frequency,
	        outputType: scheduledReport.outputType,
	        recipients: [],
	        additionalRecipients: scheduledReport.additionalRecipients,
	        criteria: {}
	      };
	
	      this.$scope.reportsList = this.availableReports;
	      this.$scope.frequencyList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_FREQUENCY, true);
	      this.$scope.outputList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_OUTPUT_TYPE_TEMP, true);
	      this.$scope.locationUsers = this.locationUsers;
	      this.$scope.selAllUsers = [];
	      this.$scope.selectedUsers = [];
	      this.$scope.selUsers = [];
	      this.$scope.selectedReportName = scheduledReport.reportName;
	      this.$scope.reportTypeChanged = this.reportTypeChanged.bind(this);
	      this.$scope.selectUsers = this.selectUsers.bind(this);
	      this.$scope.deSelectUsers = this.deSelectUsers.bind(this);
	
	      //Selected Recipients
	      this.$scope.selAllUsers = scheduledReport.recipients.map(function (userId) {
	        return { userId: userId };
	      });
	      this.selectUsers();
	
	      //Update Criteria
	      this.reportTypeChanged(JSON.parse(scheduledReport.criteria));
	
	      this.$ngConfirm({
	        title: 'Edit Scheduled Report',
	        contentUrl: 'templates/reports/scheduledReportEditTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              return _this8.edit(scheduledReport.scheduledReportId);
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(scheduledReportId) {
	      var _this9 = this;
	
	      if (!this.validateCriteria()) {
	        return false;
	      }
	
	      this.loadingService.showLoading('scheduledReportsList', 'Updating Scheduled Report ...');
	
	      this.$scope.scheduledReport.criteria = this.parseCriteria();
	
	      this.scheduledReportService.edit(scheduledReportId, this.$scope.scheduledReport).then(function (response) {
	        var scheduledReport = (0, _lodash.find)(_this9.scheduledReports, function (o) {
	          return o.scheduledReportId === response.data.scheduledReportId;
	        });
	        scheduledReport.frequency = response.data.frequency;
	        scheduledReport.outputType = response.data.outputType;
	        scheduledReport.recipients = response.data.recipients;
	
	        _this9.growl.success('Successfully updated Scheduled Report', { ttl: 5000 });
	      }).finally(function () {
	        _this9.loadingService.hideLoading('scheduledReportsList');
	      });
	    }
	
	    //Parameter Methods
	
	  }, {
	    key: 'prepareReportParameters',
	    value: function prepareReportParameters() {
	      var _this10 = this;
	
	      this.reportParametersConfig = [{
	        reportId: 1, //Showroom Traffic
	        userLocations: true,
	        userList: true,
	        updateDefaults: function updateDefaults() {
	          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          _this10.$scope.reportParameterData.updateUserList();
	        },
	        editDefaults: function editDefaults(criteria) {
	          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
	            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          } else {
	            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
	              return o.id == criteria.LocationIds[0];
	            });
	          }
	
	          _this10.updateUserList().then(function () {
	            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
	              return o.id == criteria.SalesRepId;
	            });
	          });
	        }
	      }, {
	        reportId: 2, //All Enquiries
	        userLocations: true,
	        userList: true,
	        brands: true,
	        enquiryContact: true,
	        enquiryStatus: true,
	        updateDefaults: function updateDefaults() {
	          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          _this10.$scope.reportParameterData.updateUserList();
	
	          _this10.$scope.scheduledReport.criteria.brand = _this10.$scope.reportParameterData.brands[0];
	          _this10.$scope.reportParameterData.updateBrandModel();
	
	          _this10.$scope.scheduledReport.criteria.enquiryContact = _this10.$scope.reportParameterData.enquiryContactList[2];
	          _this10.$scope.scheduledReport.criteria.enquiryStatus = _this10.$scope.reportParameterData.enquiryStatusList[0];
	        },
	        editDefaults: function editDefaults(criteria) {
	          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
	            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          } else {
	            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
	              return o.id == criteria.LocationIds[0];
	            });
	          }
	
	          _this10.updateUserList().then(function () {
	            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
	              return o.id == criteria.SalesRepId;
	            });
	          });
	
	          _this10.$scope.scheduledReport.criteria.brand = (0, _lodash.find)(_this10.$scope.reportParameterData.brands, function (o) {
	            return o.brandId == criteria.BrandId;
	          });
	          _this10.$scope.reportParameterData.updateBrandModel();
	          _this10.$scope.scheduledReport.criteria.brandModel = (0, _lodash.find)(_this10.$scope.reportParameterData.brandModels, function (o) {
	            return o.brandModelId == criteria.BrandModelId;
	          });
	
	          _this10.$scope.scheduledReport.criteria.enquiryContact = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryContactList, function (o) {
	            return o.id == criteria.EnquiryContact;
	          });
	          _this10.$scope.scheduledReport.criteria.enquiryStatus = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryStatusList, function (o) {
	            return o.id == criteria.EnquiryStatus;
	          });
	        }
	      }, {
	        reportId: 3, //Sales Report
	        userLocations: true,
	        userList: true,
	        brands: true,
	        enquiryContact: true,
	        dateRangeType: true,
	        updateDefaults: function updateDefaults() {
	          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          _this10.$scope.reportParameterData.updateUserList();
	
	          _this10.$scope.scheduledReport.criteria.brand = _this10.$scope.reportParameterData.brands[0];
	          _this10.$scope.reportParameterData.updateBrandModel();
	
	          _this10.$scope.scheduledReport.criteria.enquiryContact = _this10.$scope.reportParameterData.enquiryContactList[2];
	          _this10.$scope.scheduledReport.criteria.dateRangeType = _this10.$scope.reportParameterData.dateRangeTypeList[0];
	        },
	        editDefaults: function editDefaults(criteria) {
	          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
	            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          } else {
	            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
	              return o.id == criteria.LocationIds[0];
	            });
	          }
	
	          _this10.updateUserList().then(function () {
	            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
	              return o.id == criteria.SalesRepId;
	            });
	          });
	
	          _this10.$scope.scheduledReport.criteria.brand = (0, _lodash.find)(_this10.$scope.reportParameterData.brands, function (o) {
	            return o.brandId == criteria.BrandId;
	          });
	          _this10.$scope.reportParameterData.updateBrandModel();
	          _this10.$scope.scheduledReport.criteria.brandModel = (0, _lodash.find)(_this10.$scope.reportParameterData.brandModels, function (o) {
	            return o.brandModelId == criteria.BrandModelId;
	          });
	
	          _this10.$scope.scheduledReport.criteria.enquiryContact = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryContactList, function (o) {
	            return o.id == criteria.EnquiryContact;
	          });
	          _this10.$scope.scheduledReport.criteria.dateRangeType = (0, _lodash.find)(_this10.$scope.reportParameterData.dateRangeTypeList, function (o) {
	            return o.id == criteria.DateRangeType;
	          });
	        }
	      }, {
	        reportId: 11, //Showroom Detailed
	        userLocations: true,
	        userList: true,
	        updateDefaults: function updateDefaults() {
	          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          _this10.$scope.reportParameterData.updateUserList();
	        },
	        editDefaults: function editDefaults(criteria) {
	          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
	            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          } else {
	            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
	              return o.id == criteria.LocationIds[0];
	            });
	          }
	
	          _this10.updateUserList().then(function () {
	            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
	              return o.id == criteria.SalesRepId;
	            });
	          });
	        }
	      }, {
	        reportId: 26, //Weekly Sales Activity
	        userLocations: true,
	        updateDefaults: function updateDefaults() {
	          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	        },
	        editDefaults: function editDefaults(criteria) {
	          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
	            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
	          } else {
	            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
	              return o.id == criteria.LocationIds[0];
	            });
	          }
	        }
	      }];
	    }
	  }, {
	    key: 'prepareReportParametersData',
	    value: function prepareReportParametersData() {
	      this.getUserLocations();
	      this.getBrandsAndModels();
	      this.getEnquiryContactList();
	      this.getDateRangeTypeList();
	      this.getEnquiryStatusList();
	    }
	  }, {
	    key: 'reportTypeChanged',
	    value: function reportTypeChanged(criteria) {
	      var _this11 = this;
	
	      this.$scope.selectedReportName = (0, _lodash.find)(this.availableReports, function (o) {
	        return o.reportId == _this11.$scope.scheduledReport.reportId;
	      }).name;
	      this.$scope.reportParameters = (0, _lodash.find)(this.reportParametersConfig, function (o) {
	        return o.reportId == _this11.$scope.scheduledReport.reportId;
	      });
	
	      if (!this.$scope.editMode) {
	        this.$scope.reportParameters.updateDefaults();
	      } else {
	        this.$scope.reportParameters.editDefaults(criteria);
	      }
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      var _this12 = this;
	
	      var errors = [];
	
	      if (!this.$scope.scheduledReport.reportId) {
	        errors.push('Please select a Report');
	      }
	
	      if (!this.$scope.scheduledReport.frequency) {
	        errors.push('Please select Frequency');
	      }
	
	      if (!this.$scope.scheduledReport.outputType) {
	        errors.push('Please select Output Type');
	      }
	
	      if (!this.$scope.scheduledReport.recipients.length) {
	        errors.push('Please select at least one recipient');
	      }
	
	      if (this.$scope.scheduledReport.additionalRecipients) {
	        var validEmails = true;
	        this.$scope.scheduledReport.additionalRecipients.split(',').filter(function (element) {
	          return element;
	        }).map(function (eml) {
	          return validEmails &= _this12.validateEmail(eml);
	        });
	
	        if (!validEmails) {
	          errors.push('One or more emails mentioned in additional recipients are not valid');
	        }
	      }
	
	      if (errors.length) {
	        this.$scope.errors = errors;
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      if (this.$scope.reportParameters.userLocations) {
	        parsedCriteria.locationIds = this.getLocationIds();
	      }
	
	      if (this.$scope.reportParameters.userList) {
	        parsedCriteria.salesRepId = this.$scope.scheduledReport.criteria.user.id;
	      }
	
	      if (this.$scope.reportParameters.brands) {
	        parsedCriteria.brandId = this.$scope.scheduledReport.criteria.brand.brandId;
	        parsedCriteria.brandModelId = this.$scope.scheduledReport.criteria.brandModel.brandModelId;
	      }
	
	      if (this.$scope.reportParameters.enquiryContact) {
	        parsedCriteria.enquiryContact = this.$scope.scheduledReport.criteria.enquiryContact.id;
	      }
	
	      if (this.$scope.reportParameters.dateRangeType) {
	        parsedCriteria.dateRangeType = this.$scope.scheduledReport.criteria.dateRangeType.id;
	      }
	
	      if (this.$scope.reportParameters.enquiryStatus) {
	        parsedCriteria.enquiryStatus = this.$scope.scheduledReport.criteria.enquiryStatus.id;
	      }
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      var userLocations = this.authService.authData.userLocations.map(function (l) {
	        return { id: l.key, name: l.value };
	      });
	
	      userLocations.unshift({ id: null, name: 'All' });
	
	      this.$scope.reportParameterData.userLocations = userLocations;
	      this.$scope.reportParameterData.updateUserList = this.updateUserList.bind(this);
	    }
	  }, {
	    key: 'getBrandsAndModels',
	    value: function getBrandsAndModels() {
	      var _this13 = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this13.$scope.reportParameterData.brands = brands;
	
	        _this13.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this13.$scope.reportParameterData.allBrandModels = brandModels;
	        });
	      });
	
	      this.$scope.reportParameterData.updateBrandModel = this.updateBrandModel.bind(this);
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.$scope.scheduledReport.criteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.$scope.reportParameterData.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.$scope.scheduledReport.criteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this14 = this;
	
	      this.loadingService.showLoading('scheduledReportsList', 'Updating Sales Rep List ...');
	
	      var src = this.userService.getEntityUsers(this.getLocationIds());
	
	      src.then(function (response) {
	        var userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        userList.unshift({ id: null, name: 'All' });
	
	        _this14.$scope.reportParameterData.userList = userList;
	
	        _this14.$scope.scheduledReport.criteria.user = userList[0];
	      }).finally(function () {
	        _this14.loadingService.hideLoading('scheduledReportsList');
	      });
	
	      return src;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this15 = this;
	
	      this.$scope.reportParameterData.brandModels = (0, _lodash.filter)(this.$scope.reportParameterData.allBrandModels, function (o) {
	        return o.brandId === _this15.$scope.scheduledReport.criteria.brand.brandId;
	      });
	      this.$scope.reportParameterData.brandModels.unshift({ id: null, name: 'All' });
	      this.$scope.scheduledReport.criteria.brandModel = this.$scope.reportParameterData.brandModels[0];
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.$scope.reportParameterData.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.$scope.reportParameterData.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.$scope.reportParameterData.dateRangeTypeList = [];
	      this.$scope.reportParameterData.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.$scope.reportParameterData.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.$scope.reportParameterData.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.$scope.reportParameterData.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(email);
	    }
	  }]);
	  return ScheduledReportsContainerController;
	}();
	
	exports.default = ScheduledReportsContainerController;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1013);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./scheduledReportsContainer.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./scheduledReportsContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".user-list{height:200px!important}.select-button-margin{margin-top:40px}", ""]);
	
	// exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduledReportService = function () {
	  ScheduledReportService.$inject = ["$http", "appConfig"];
	  function ScheduledReportService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ScheduledReportService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(ScheduledReportService, [{
	    key: "listScheduledReports",
	    value: function listScheduledReports(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/scheduledreports/list/" + entityId));
	    }
	  }, {
	    key: "add",
	    value: function add(scheduledReport) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/scheduledreports/add", scheduledReport);
	    }
	  }, {
	    key: "delete",
	    value: function _delete(entityId, schedledReportId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/scheduledreports/delete/" + entityId + "/" + schedledReportId));
	    }
	  }, {
	    key: "get",
	    value: function get(entityId, schedledReportId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/scheduledreports/get/" + entityId + "/" + schedledReportId));
	    }
	  }, {
	    key: "edit",
	    value: function edit(scheduledReportId, scheduledReport) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/scheduledreports/edit/" + scheduledReportId), scheduledReport);
	    }
	  }]);
	  return ScheduledReportService;
	}();
	
	exports.default = ScheduledReportService;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(1016);
	
	var _login2 = _interopRequireDefault(_login);
	
	__webpack_require__(1021);
	
	var _loginCarsNow = __webpack_require__(1023);
	
	var _loginCarsNow2 = _interopRequireDefault(_loginCarsNow);
	
	var _loginLeadManager = __webpack_require__(1030);
	
	var _loginLeadManager2 = _interopRequireDefault(_loginLeadManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('login', [_angularUiRouter2.default, _loginCarsNow2.default, _loginLeadManager2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/login');
	
	  $stateProvider.state('userLogin', {
	    url: '/login',
	    component: 'login'
	  });
	
	  $stateProvider.state('adminLogin', {
	    url: '/admin/login',
	    component: 'login',
	    params: {
	      isAdmin: true
	    }
	  });
	}]).component('login', _login2.default).name;
	
	exports.default = loginModule;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(1017);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(1018);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(1019);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default
	};
	
	exports.default = loginComponent;

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports = "<login-cars-now ng-if=\"!$ctrl.appConfig.isLeadManager\"></login-cars-now>\r\n<login-lead-manager ng-if=\"$ctrl.appConfig.isLeadManager\"></login-lead-manager >"

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function LoginController(appConfig) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, LoginController);
	  this.appConfig = appConfig;
	};
	LoginController.$inject = ["appConfig"];
	
	exports.default = LoginController;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1020);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./login.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./login.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1022);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./login.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./login.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;width:100%;margin:0;padding:0;overflow:hidden;font-family:Roboto,sans-serif}body .loginform{width:400px;background-color:#fff;margin:15% auto;padding:0 30px;box-shadow:0 0 17px -5px #000}body .loginform header{background:var(--logo-path) no-repeat 50%;width:100%;min-height:150px}body .loginform main{margin-bottom:20px}body .loginform main a{width:118%;margin-left:-30px;padding:15px 0;font-size:16px}body .loginform input{border-radius:0;max-width:400px}body .loginform input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}body .loginform i{margin-right:5px}body .loginform p{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loginCarsNow = __webpack_require__(1024);
	
	var _loginCarsNow2 = _interopRequireDefault(_loginCarsNow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginCarsNowModule = _angular2.default.module('loginCarsNow', [_angularUiRouter2.default]).component('loginCarsNow', _loginCarsNow2.default).name;
	
	exports.default = loginCarsNowModule;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loginCarsNow = __webpack_require__(1025);
	
	var _loginCarsNow2 = _interopRequireDefault(_loginCarsNow);
	
	var _loginCarsNow3 = __webpack_require__(1026);
	
	var _loginCarsNow4 = _interopRequireDefault(_loginCarsNow3);
	
	__webpack_require__(1028);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginCarsNowComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loginCarsNow2.default,
	  controller: _loginCarsNow4.default
	};
	
	exports.default = loginCarsNowComponent;

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"!$ctrl.directLogin\">\r\n  <header class=\"home-header\" ng-show=\"$ctrl.loginType !== 'Admin' && $ctrl.status !== 'UserAuthorizing'\">\r\n    <div class=\"container\">\r\n        <a href=\"index.html\" title=\"Car Now\" class=\"logo\">\r\n            <img src=\"images/logo.png\" alt=\"Car Now\">\r\n        </a>\r\n        <nav class=\"home-nav\">\r\n            <ul>\r\n                <li><a href=\"#\">Partners</a></li>\r\n                <li><a href=\"#\">Partners</a></li>\r\n                <li><a href=\"#\">Partners</a></li>\r\n                <li><a href=\"#\">Partners</a></li>\r\n                <li><a href=\"#\">Partners</a></li>\r\n                <li><a href=\"#\">Partners</a></li>\r\n            </ul>\r\n        </nav>\r\n    </div>\r\n</header>\r\n\r\n  <section class=\"home-banner\" ng-show=\"$ctrl.loginType !== 'Admin' && $ctrl.status !== 'UserAuthorizing'\">\r\n    <div class=\"container\">\r\n        <div class=\"home-banner-content\">\r\n            <h2>Welcome to CarsNow.ie</h2>\r\n            <p>CarsNow is Ireland's only online car showroom vehicle management and customer management system.</p>\r\n            <hr>\r\n            <h4>Helping You Sell More Cars</h4>\r\n            <p><small>CarsNow records the details of your customers and vehicles to help you sell your vehicles.</small></p>\r\n            <p><small>You can see how busy your showroom is at various times, the percentage of sales that are won and lost, the staff that are performing at their best, and how much finance you are selling.</small></p>\r\n            <div class=\"clearfix\">\r\n                <a class=\"btn btn-success pull-left\" ng-click=\"$ctrl.externalLogin()\">Login External - Mirror 1</a>\r\n                <a class=\"btn btn-success pull-left\" ng-click=\"$ctrl.externalLogin2()\">Login External - Mirror 2</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>\r\n\r\n  <div class=\"loginform\" ng-show=\"$ctrl.loginType === 'Admin' || $ctrl.status === 'UserAuthorizing'\">\r\n\r\n    <div class=\"row main\">\r\n        <div class=\"col-md-12\" style=\"margin-bottom:20px;\">\r\n          <header></header>\r\n\r\n          <section id=\"loginForm\">\r\n            <div data-ng-show=\"$ctrl.status === 'UserAuthorizing'\">\r\n              <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>Authorizing your Account Details\r\n            </div>\r\n\r\n            <div ng-show=\"$ctrl.loginType === 'Admin'\">\r\n              <form class=\"form-horizontal\" name=\"loginForm\" novalidate>\r\n                  <div class=\"form-group\" ng-class=\"{ 'has-error': loginForm.email.$dirty && loginForm.email.$invalid && loginForm.email.length}\">\r\n                    <div class=\"col-md-12\">\r\n                      <div class=\"input-group\">\r\n                        <span class=\"input-group-addon\"><i class=\"fa fa-user\"></i></span>\r\n                        <input type=\"email\" class=\"form-control\" ng-model=\"$ctrl.loginData.email\" placeholder=\"Enter email\" required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\" ng-class=\"{ 'has-error': loginForm.password.$dirty || loginForm.password.$invalid }\">\r\n                    <div class=\"col-sm-12\">\r\n                      <div class=\"input-group\">\r\n                        <span class=\"input-group-addon\"><i class=\"fa fa-key\"></i></span>\r\n                        <input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.loginData.password\" placeholder=\"Enter password\" required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"form-group\">\r\n                    <div class=\"col-md-6\">\r\n\r\n                      <a href='#' ng-click=\"$ctrl.hideAdminLogin()\" ng-hide=\"true\">Cancel</a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <button ng-click=\"$ctrl.login()\" class=\"btn btn-default pull-right\" ng-disabled=\"loginForm.$invalid || $ctrl.status !== ''\">\r\n                        <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.status !== ''\"></i>\r\n                        {{ $ctrl.status === '' ? 'Login' : 'Logging In ...' }}\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </form>\r\n            </div>\r\n\r\n            <div class=\"alert alert-danger\" role=\"alert\" ng-hide=\"$ctrl.errorMessage === ''\">\r\n              {{$ctrl.errorMessage}}\r\n            </div>\r\n\r\n          </section>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _LoginControllerBase2 = __webpack_require__(1027);
	
	var _LoginControllerBase3 = _interopRequireDefault(_LoginControllerBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginCarsNowController = function (_LoginControllerBase) {
	  LoginCarsNowController.$inject = ["$location", "$state", "$stateParams", "authService", "appConfig", "pushService", "angularAuth0", "enums"];
	  (0, _inherits3.default)(LoginCarsNowController, _LoginControllerBase);
	
	  function LoginCarsNowController($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LoginCarsNowController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginCarsNowController.__proto__ || (0, _getPrototypeOf2.default)(LoginCarsNowController)).call(this, $location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums));
	
	    _this.initialize();
	    return _this;
	  }
	
	  return LoginCarsNowController;
	}(_LoginControllerBase3.default);
	
	exports.default = LoginCarsNowController;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginControllerBase = function () {
	  function LoginControllerBase($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
	    (0, _classCallCheck3.default)(this, LoginControllerBase);
	
	
	    this.$state = $state;
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.authService = authService;
	    this.appConfig = appConfig;
	    this.pushService = pushService;
	    this.angularAuth0 = angularAuth0;
	    this.enums = enums;
	
	    this.loginType = '';
	    this.status = "";
	    this.errorMessage = "";
	
	    this.loginData = {
	      email: "",
	      password: ""
	    };
	  }
	
	  (0, _createClass3.default)(LoginControllerBase, [{
	    key: 'initialize',
	    value: function initialize() {
	      console.log('Use Auth0', this.appConfig.useAuth0);
	
	      //OAuth Integrations with External Providers
	      if (this.$location.search().code) {
	        var state = JSON.parse(this.$location.search().state);
	
	        if (!state.provider) {
	          this.$state.go('enquiryEditCode', { enquiryId: state.enquiryId, action: state.action, code: this.$location.search().code });
	        } else if (state.provider === 'mazda') {
	          this.status = "UserAuthorizing";
	          var _state = JSON.parse(this.$location.search().state);
	
	          this.authService.mazdaLoginBackend(this.$location.search().code, _state.stateName, _state.stateParams);
	        }
	
	        return;
	      }
	
	      if (this.appConfig.useAuth0) {
	        if (!this.redirectIfAlreadyLoggedIn2()) {
	          if (this.$location.hash()) {
	            console.log('$location.hash()', this.$location.hash());
	            var hashParams = this.splitHash();
	
	            this.status = "UserAuthorizing";
	            if (hashParams.id_token) {
	              //Auth0 Client Side Authentication Validaton
	              this.handleAuth0Authentication();
	            } else {
	              //Auth0 Server Side Authentication Validaton
	              this.authorize_Auth0(hashParams.access_token);
	            }
	
	            return;
	          }
	        }
	      } else {
	        if (this.$location.search().code) {
	          this.status = "UserAuthorizing";
	          this.authorize(this.$location.search().code);
	        } else {
	          this.redirectIfAlreadyLoggedIn();
	        }
	      }
	
	      if (this.$stateParams.isAdmin) {
	        this.showAdminLogin();
	      }
	    }
	  }, {
	    key: 'externalLogin',
	    value: function externalLogin() {
	      var state = this.$location.search().state || '';
	      if (state) {
	        window.sessionStorage.setItem('redirectState', state);
	      }
	      if (this.appConfig.useAuth0) {
	        this.angularAuth0.authorize({
	          redirectUri: this.appConfig.oauthCallbackUrl
	        });
	      } else {
	        var redirectUri = location.protocol + '//' + location.host + '/login';
	        var msSigninUri = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=' + this.appConfig.msClientId + '&scope=openid profile offline_access User.Read email&response_type=code&redirect_uri=' + redirectUri;
	        window.location = msSigninUri;
	      }
	    }
	  }, {
	    key: 'externalLogin2',
	    value: function externalLogin2() {
	      var redirectUri = location.protocol + '//' + location.host + '/login';
	      var auth0SigninUri = 'https://' + this.appConfig.auth0.domain + '/authorize?response_type=token&client_id=' + this.appConfig.auth0.clientId + '&connection=&redirect_uri=' + this.appConfig.oauthCallbackUrl + '&scope=openid profile email';
	      window.location = auth0SigninUri;
	    }
	  }, {
	    key: 'handleAuth0Authentication',
	    value: function handleAuth0Authentication() {
	      var _this = this;
	
	      console.log('handleAuth0Authentication');
	      var loginCtrl = this;
	
	      this.angularAuth0.parseHash(function (err, authResult) {
	        console.log('parseHash', authResult);
	        if (authResult && authResult.accessToken && authResult.idToken) {
	          _this.authorize(authResult.idTokenPayload.email);
	        } else {
	          alert('There was an error logging in. Following are the error details.\nError Code: ' + err.error + '\nError Description: ' + err.errorDescription + '\n\n The system will now make an attempt to resolve the issue, after which you can try to login again');
	          _this.authService.logOut();
	        }
	      });
	    }
	  }, {
	    key: 'handleAuth0AuthenticationServer',
	    value: function handleAuth0AuthenticationServer() {
	      var _this2 = this;
	
	      console.log('handleAuth0Authentication');
	      var loginCtrl = this;
	
	      this.angularAuth0.parseHash(function (err, authResult) {
	        console.log('parseHash', authResult);
	        if (authResult && authResult.accessToken && authResult.idToken) {
	          _this2.authorize(authResult.idTokenPayload.email);
	        } else {
	          alert('There was an error logging in. Following are the error details.\nError Code: ' + err.error + '\nError Description: ' + err.errorDescription + '\n\n The system will now make an attempt to resolve the issue, after which you can try to login again');
	          _this2.authService.logOut();
	        }
	      });
	    }
	  }, {
	    key: 'authorize',
	    value: function authorize(codeOrEmail) {
	      var _this3 = this;
	
	      var loginCtrl = this;
	
	      this.authService.authorize(codeOrEmail).then(function (response) {
	        _this3.pushService.init();
	        var loc = _this3.$location;
	        var redirectState = _this3.getRedirectState();
	
	        if (redirectState) {
	          var state = JSON.parse(redirectState);
	
	          if (state.entityId) {
	            _this3.authService.updateLocationLogin(state.entityId);
	          }
	
	          loginCtrl.$state.go(state.name, state.params);
	        } else {
	          _this3.redirectToLandingPage();
	        }
	      }).catch(function (err) {
	        _this3.status = "";
	        loginCtrl.$location.url('/login');
	
	        var errors = [];
	        for (var key in err.modelState) {
	          for (var i = 0; i < err.modelState[key].length; i++) {
	            errors.push(err.modelState[key][i]);
	          }
	        }
	        loginCtrl.errorMessage = errors.join(' ');
	      });
	    }
	  }, {
	    key: 'authorize_Auth0',
	    value: function authorize_Auth0(accessToken) {
	      var _this4 = this;
	
	      var loginCtrl = this;
	
	      this.authService.authorize_Auth0(accessToken).then(function (response) {
	        _this4.pushService.init();
	        var loc = _this4.$location;
	        var redirectState = _this4.getRedirectState();
	
	        if (redirectState) {
	          var state = JSON.parse(redirectState);
	
	          if (state.entityId) {
	            _this4.authService.updateLocationLogin(state.entityId);
	          }
	
	          loginCtrl.$state.go(state.name, state.params);
	        } else {
	          _this4.redirectToLandingPage();
	        }
	      }).catch(function (err) {
	        _this4.status = "";
	        loginCtrl.$location.url('/login');
	
	        var errors = [];
	        for (var key in err.modelState) {
	          for (var i = 0; i < err.modelState[key].length; i++) {
	            errors.push(err.modelState[key][i]);
	          }
	        }
	        loginCtrl.errorMessage = errors.join(' ');
	      });
	    }
	  }, {
	    key: 'redirectIfAlreadyLoggedIn',
	    value: function redirectIfAlreadyLoggedIn() {
	      var loginCtrl = this;
	
	      if (loginCtrl.authService.isLoggedIn()) {
	        if (loginCtrl.authService.authData.isAdmin) {
	          loginCtrl.$state.go('admin.listEntities');
	        } else {
	          loginCtrl.$state.go('user');
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'redirectIfAlreadyLoggedIn2',
	    value: function redirectIfAlreadyLoggedIn2() {
	      var loginCtrl = this;
	
	      if (loginCtrl.authService.isLoggedIn_NoRedirect()) {
	        if (loginCtrl.authService.authData.isAdmin) {
	          loginCtrl.$state.go('admin.listEntities');
	        } else {
	          this.redirectToLandingPage();
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      var _this5 = this;
	
	      var loginCtrl = this;
	
	      this.status = 'AdminAuthorizing';
	
	      loginCtrl.authService.login(loginCtrl.loginData).then(function (response) {
	        loginCtrl.redirectIfAlreadyLoggedIn();
	      }, function (err) {
	        _this5.status = '';
	
	        if (err.status === 404) {
	          loginCtrl.errorMessage = 'Invalid Login Details Suppplied';
	        } else {
	          loginCtrl.errorMessage = err.data.message;
	        }
	      });
	    }
	  }, {
	    key: 'showAdminLogin',
	    value: function showAdminLogin() {
	      this.hideAdminLogin();
	      this.loginType = "Admin";
	    }
	  }, {
	    key: 'hideAdminLogin',
	    value: function hideAdminLogin() {
	      this.loginData = {
	        email: "",
	        password: ""
	      };
	
	      this.loginType = '';
	      this.errorMessage = '';
	    }
	  }, {
	    key: 'getRedirectState',
	    value: function getRedirectState() {
	      var state = window.sessionStorage.getItem('redirectState');
	      window.sessionStorage.removeItem('redirectState');
	      return state;
	    }
	  }, {
	    key: 'splitHash',
	    value: function splitHash() {
	      var hash = this.$location.hash();
	      var params = {};
	      hash.split('&').map(function (hk) {
	        var temp = hk.split('=');
	        params[temp[0]] = temp[1];
	      });
	
	      return params;
	    }
	  }, {
	    key: 'redirectToLandingPage',
	    value: function redirectToLandingPage() {
	      switch (this.authService.authData.currentLocation.landingPage) {
	        case this.enums.DEFAULT_LANDING_PAGE.WelcomeCentre:
	          this.$state.go('welcomeCentre');
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.Dashboard:
	          this.$state.go('dashboard');
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_Today:
	          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE.Today });
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_ThisWeek:
	          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['This Week'] });
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_LastWeek:
	          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['Last Week'] });
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_Today:
	          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE.Today });
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_ThisWeek:
	          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['This Week'] });
	          break;
	
	        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_LastWeek:
	          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['Last Week'] });
	          break;
	      }
	    }
	  }]);
	  return LoginControllerBase;
	}();
	
	exports.default = LoginControllerBase;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1029);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./loginCarsNow.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./loginCarsNow.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".loginCarsNow{color:red}", ""]);
	
	// exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loginLeadManager = __webpack_require__(1031);
	
	var _loginLeadManager2 = _interopRequireDefault(_loginLeadManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginLeadManagerModule = _angular2.default.module('loginLeadManager', [_angularUiRouter2.default]).component('loginLeadManager', _loginLeadManager2.default).name;
	
	exports.default = loginLeadManagerModule;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loginLeadManager = __webpack_require__(1032);
	
	var _loginLeadManager2 = _interopRequireDefault(_loginLeadManager);
	
	var _loginLeadManager3 = __webpack_require__(1033);
	
	var _loginLeadManager4 = _interopRequireDefault(_loginLeadManager3);
	
	__webpack_require__(1034);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginLeadManagerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loginLeadManager2.default,
	  controller: _loginLeadManager4.default
	};
	
	exports.default = loginLeadManagerComponent;

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"$ctrl.loginType !== 'Admin' && $ctrl.status !== 'UserAuthorizing'\">\r\n  <nav class=\"navbar navbar-default login-nav\">\r\n    <div class=\"container-fluid\">\r\n      <!-- Brand and toggle get grouped for better mobile display -->\r\n      <div class=\"navbar-header\">\r\n        <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\r\n          <span class=\"sr-only\">Toggle navigation</span>\r\n          <span class=\"icon-bar\"></span>\r\n          <span class=\"icon-bar\"></span>\r\n          <span class=\"icon-bar\"></span>\r\n        </button>\r\n        <a class=\"navbar-brand\" href=\"#\">\r\n          <img title=\"Lead Manager\" src=\"images/leadmanager/logo.png\" class=\"login-nav-logo\">\r\n        </a>\r\n      </div>\r\n  \r\n      <!-- Collect the nav links, forms, and other content for toggling -->\r\n      <div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\">\r\n        <ul class=\"nav navbar-nav\">\r\n          <li ng-repeat=\"section in $ctrl.sections track by $index\"          \r\n            ng-class=\"{'active': $ctrl.sections[$index].visible}\">\r\n            <a href=\"#\" ng-click=\"$ctrl.updateSection($index)\">{{section.name}}</a>\r\n          </li>\r\n        </ul>\r\n        <ul class=\"nav navbar-nav navbar-right\">\r\n          <li class=\"dropdown\">\r\n            <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Login <span class=\"caret\"></span></a>\r\n            <ul class=\"dropdown-menu\">\r\n              <li><a href=\"#\" ng-click=\"$ctrl.externalLogin()\">Login using Mirror 1</a></li>\r\n              <li><a href=\"#\" ng-click=\"$ctrl.externalLogin2()\">Login using Mirror 2</a></li>\r\n            </ul>\r\n          </li>\r\n        </ul>\r\n      </div><!-- /.navbar-collapse -->\r\n    </div><!-- /.container-fluid -->\r\n  </nav>\r\n\r\n  <section ng-repeat=\"section in $ctrl.sections track by $index\" ng-show=\"$ctrl.sections[$index].visible\">\r\n    <header class=\"home-header\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"main-div\" ng-class=\"section.bgClass\">\r\n          <span>\r\n            {{section.text}}\r\n          </span>        \r\n          <button>\r\n            Learn More\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </header>\r\n  </section>\r\n\r\n  <div class=\"footer-dark\">\r\n    <footer>\r\n        <div class=\"container\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-4 item\">\r\n                    <h3>Our Services</h3>\r\n                    <ul>\r\n                        <li><a href=\"#\">Lead Management</a></li>\r\n                        <li><a href=\"#\">Lead Reporting</a></li>\r\n                        <li><a href=\"#\">Order Form Management</a></li>\r\n                        <li><a href=\"#\">Sales Process Audits</a></li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"col-md-4 item\">\r\n                    <h3>Information</h3>\r\n                    <ul>\r\n                        <li><a href=\"#\">Our Clients</a></li>\r\n                        <li><a href=\"#\">Testimonials</a></li>\r\n                        <li><a href=\"#\">Contact Us</a></li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"col-md-4 item\">\r\n                  <h3>Legal</h3>\r\n                  <ul>\r\n                      <li><a href=\"#\">Terms of Use</a></li>\r\n                      <li><a href=\"#\">Our Promise</a></li>\r\n                      <li><a href=\"#\">Privacy Policy</a></li>\r\n                      <li><a href=\"#\">Cookie Policy</a></li>\r\n                  </ul>\r\n              </div>                \r\n                <div class=\"col-md-6 item text\" ng-hide=\"true\">\r\n                    <h3>Company Name</h3>\r\n                    <p>Praesent sed lobortis mi. Suspendisse vel placerat ligula. Vivamus ac sem lacus. Ut vehicula rhoncus elementum. Etiam quis tristique lectus. Aliquam in arcu eget velit pulvinar dictum vel in justo.</p>\r\n                </div>                \r\n            </div>\r\n            <p class=\"copyright\">© 2021 Lead Manager. All rights reserved</p>\r\n        </div>\r\n    </footer>\r\n  </div>\r\n</div>\r\n\r\n  <div class=\"loginform\" ng-show=\"$ctrl.loginType === 'Admin' || $ctrl.status === 'UserAuthorizing'\">\r\n    <div class=\"row main\">\r\n        <div class=\"col-md-12\" style=\"margin-bottom:20px;\">\r\n          <header></header>\r\n\r\n          <section id=\"loginForm\">\r\n            <div data-ng-show=\"$ctrl.status === 'UserAuthorizing'\">\r\n              <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>Authorizing your Account Details\r\n            </div>\r\n\r\n            <div ng-show=\"$ctrl.loginType === 'Admin'\">\r\n              <form class=\"form-horizontal\" name=\"loginForm\" novalidate>\r\n                  <div class=\"form-group\" ng-class=\"{ 'has-error': loginForm.email.$dirty && loginForm.email.$invalid && loginForm.email.length}\">\r\n                    <div class=\"col-md-12\">\r\n                      <div class=\"input-group\">\r\n                        <span class=\"input-group-addon\"><i class=\"fa fa-user\"></i></span>\r\n                        <input type=\"email\" class=\"form-control\" ng-model=\"$ctrl.loginData.email\" placeholder=\"Enter email\" required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\" ng-class=\"{ 'has-error': loginForm.password.$dirty || loginForm.password.$invalid }\">\r\n                    <div class=\"col-sm-12\">\r\n                      <div class=\"input-group\">\r\n                        <span class=\"input-group-addon\"><i class=\"fa fa-key\"></i></span>\r\n                        <input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.loginData.password\" placeholder=\"Enter password\" required>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"form-group\">\r\n                    <div class=\"col-md-6\">\r\n\r\n                      <a href='#' ng-click=\"$ctrl.hideAdminLogin()\" ng-hide=\"true\">Cancel</a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                      <button ng-click=\"$ctrl.login()\" class=\"btn btn-default pull-right\" ng-disabled=\"loginForm.$invalid || $ctrl.status !== ''\">\r\n                        <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.status !== ''\"></i>\r\n                        {{ $ctrl.status === '' ? 'Login' : 'Logging In ...' }}\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </form>\r\n            </div>\r\n\r\n            <div class=\"alert alert-danger\" role=\"alert\" ng-hide=\"$ctrl.errorMessage === ''\">\r\n              {{$ctrl.errorMessage}}\r\n            </div>\r\n\r\n          </section>\r\n        </div>\r\n\r\n\r\n\r\n    </div>\r\n</div>  \r\n\r\n\r\n"

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _LoginControllerBase2 = __webpack_require__(1027);
	
	var _LoginControllerBase3 = _interopRequireDefault(_LoginControllerBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginLeadManagerController = function (_LoginControllerBase) {
	  LoginLeadManagerController.$inject = ["$location", "$state", "$stateParams", "authService", "appConfig", "pushService", "angularAuth0", "enums"];
	  (0, _inherits3.default)(LoginLeadManagerController, _LoginControllerBase);
	
	  function LoginLeadManagerController($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LoginLeadManagerController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginLeadManagerController.__proto__ || (0, _getPrototypeOf2.default)(LoginLeadManagerController)).call(this, $location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums));
	
	    _this.sections = [{ name: 'Home', visible: true, text: 'Welcome to Lead Manager ... Europes #1 Lead Management Tool', bgClass: 'bg1' }, { name: 'What We Do', visible: false, text: 'Capture measure & manage every lead regardless of source', bgClass: 'bg2' }, { name: 'Contact Us', visible: false, text: 'Understand the best source of leads for your business', bgClass: 'bg3' }];
	
	    _this.selectedSection = _this.sections[0];
	
	    _this.initialize();
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginLeadManagerController, [{
	    key: "updateSection",
	    value: function updateSection(index) {
	      this.sections.map(function (s) {
	        return s.visible = false;
	      });
	      this.selectedSection = this.sections[index];
	      this.selectedSection.visible = true;
	    }
	  }]);
	  return LoginLeadManagerController;
	}(_LoginControllerBase3.default);
	
	exports.default = LoginLeadManagerController;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1035);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./loginLeadManager.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./loginLeadManager.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".login-nav{background-color:#014f86}.login-nav-logo{height:50px;top:-12px;position:relative}.navbar-default .navbar-nav>li>a{color:#fff}.lm-front{height:800px}.lm-front,.main-div{display:block;width:100%}.main-div{background-repeat:no-repeat;background-size:100% 100%;height:600px}.main-div>span{background-color:#fff;color:#014f86;top:150px;left:0;display:inline-block;width:550px;padding:20px;line-height:1.6;border:1px solid #014f86}.main-div>button,.main-div>span{position:relative;font-size:22px}.main-div>button{background-color:#014f86;color:#fff;float:left;top:450px;left:150px;width:150px;padding:10px}.bg1{background-image:url(\"/images/lm_front.png\")}.bg2{background-image:url(\"/images/lm_front2.png\")}.bg3{background-image:url(\"/images/lm_front3.png\")}.footer-dark{position:absolute;bottom:0;width:100%;height:180px;color:#f0f9ff;background-color:#014f86;padding-top:20px}.footer-dark h3{margin-top:0;margin-bottom:12px;font-weight:700;font-size:16px}.footer-dark ul{padding:0;list-style:none;line-height:1.6;font-size:14px;margin-bottom:0}.footer-dark ul a{color:inherit;text-decoration:none;opacity:.6}.footer-dark ul a:hover{opacity:.8}.footer-dark .item.text{margin-bottom:36px}@media (max-width:767px){.footer-dark .item.text{margin-bottom:0}}.footer-dark .item.text p{opacity:.6;margin-bottom:0}.footer-dark .copyright{text-align:center;padding-top:24px;opacity:.3;font-size:13px;margin-bottom:0;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _user = __webpack_require__(1037);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _user3 = __webpack_require__(1042);
	
	var _user4 = _interopRequireDefault(_user3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('user', {
	    url: '/user',
	    component: 'user'
	  });
	}]).service('userService', _user4.default).component('user', _user2.default).name;
	
	exports.default = userModule;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(1038);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _user3 = __webpack_require__(1039);
	
	var _user4 = _interopRequireDefault(_user3);
	
	__webpack_require__(1040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _user2.default,
	  controller: _user4.default
	};
	
	exports.default = userComponent;

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n\r\n      <header>\r\n          <h2>Logged in as <b>{{ $ctrl.authService.authData.email }}</b></h2>\r\n      </header>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserController = function UserController(authService, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserController);
	    this.authService = authService;
	
	    if (!authService.validateUser(false)) {
	        return;
	    }
	
	    this.locations = (0, _lodash.filter)(authService.authData.userRoles, function (o) {
	        return o.entityType === enums.ENTITY_TYPE.Location;
	    });
	
	    if (this.locations.length && !authService.authData.currentLocationId) {
	        authService.authData.currentLocationId = this.locations[0].entityId.toString();
	    }
	};
	UserController.$inject = ["authService", "enums"];
	
	exports.default = UserController;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1041);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./user.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./user.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".user{color:red}", ""]);
	
	// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserService = function () {
	  UserService.$inject = ["$http", "appConfig"];
	  function UserService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(UserService, [{
	    key: 'loadDashoardPanelData',
	    value: function loadDashoardPanelData(panel, entityId, userId, isManager, userIdOverride, selectedDate, page) {
	      var url = this.appConfig.apiServiceBaseUri + ('api/user/' + panel + '/' + entityId);
	
	      if (isManager && userIdOverride) {
	        url += '/' + (userIdOverride || userId);
	
	        if (selectedDate) {
	          url += '/' + selectedDate.toUniversalFormat();
	        }
	      } else {
	        url += '/' + (isManager ? null : userId);
	
	        if (selectedDate) {
	          url += '/' + selectedDate.toUniversalFormat();
	        }
	      }
	
	      if (page) {
	        url += '/' + page;
	      }
	
	      return this.$http.get(url);
	    }
	  }, {
	    key: 'promisesStats',
	    value: function promisesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
	      return this.loadDashoardPanelData('stats/promises', entityId, userId, isManager, userIdOverride, selectedDate);
	    }
	  }, {
	    key: 'promises',
	    value: function promises(entityId, userId, isManager, userIdOverride, selectedDate, page) {
	      return this.loadDashoardPanelData('promises', entityId, userId, isManager, userIdOverride, selectedDate, page);
	    }
	  }, {
	    key: 'recentContacts',
	    value: function recentContacts(entityId, userId, isManager, userIdOverride) {
	      return this.loadDashoardPanelData('recentcontacts', entityId, userId, isManager, userIdOverride);
	    }
	  }, {
	    key: 'openEnquiriesStats',
	    value: function openEnquiriesStats(entityId, userId, isManager, userIdOverride) {
	      return this.loadDashoardPanelData('stats/openenquiries', entityId, userId, isManager, userIdOverride);
	    }
	  }, {
	    key: 'openEnquiries',
	    value: function openEnquiries(entityId, userId, isManager, userIdOverride, page) {
	      return this.loadDashoardPanelData('openenquiries', entityId, userId, isManager, userIdOverride, null, page);
	    }
	  }, {
	    key: 'openFinancesStats',
	    value: function openFinancesStats(entityId, userId, isManager, userIdOverride) {
	      return this.loadDashoardPanelData('stats/openfinances', entityId, userId, isManager, userIdOverride);
	    }
	  }, {
	    key: 'openFinances',
	    value: function openFinances(entityId, userId, isManager, userIdOverride, page) {
	      return this.loadDashoardPanelData('openfinances', entityId, userId, isManager, userIdOverride, null, page);
	    }
	  }, {
	    key: 'pendingDeliveriesStats',
	    value: function pendingDeliveriesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
	      return this.loadDashoardPanelData('stats/pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate);
	    }
	  }, {
	    key: 'pendingDeliveries',
	    value: function pendingDeliveries(entityId, userId, isManager, userIdOverride, selectedDate, page) {
	      return this.loadDashoardPanelData('pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate, page);
	    }
	  }, {
	    key: 'salesMatches',
	    value: function salesMatches(entityId, userId, isManager, userIdOverride) {
	      return this.loadDashoardPanelData('salesmatches', entityId, userId, isManager, userIdOverride);
	    }
	  }, {
	    key: 'webEnquiriesStats',
	    value: function webEnquiriesStats(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/stats/webenquiries/' + entityId));
	    }
	  }, {
	    key: 'webEnquiries',
	    value: function webEnquiries(entityId, page) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/webenquiries/' + entityId + '/' + page));
	    }
	  }, {
	    key: 'expiringContactsStats',
	    value: function expiringContactsStats(entityId, userId, isManager, userIdOverride) {
	      return this.loadDashoardPanelData('stats/expiringcontacts', entityId, userId, isManager, userIdOverride);
	    }
	  }, {
	    key: 'expiringContacts',
	    value: function expiringContacts(entityId, userId, isManager, userIdOverride, page) {
	      return this.loadDashoardPanelData('expiringcontacts', entityId, userId, isManager, userIdOverride, null, page);
	    }
	  }, {
	    key: 'getLocationUsers',
	    value: function getLocationUsers(entityId, includeCurrent, workType) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/location/' + entityId + '/' + (includeCurrent ? includeCurrent : 'null') + '/' + workType));
	    }
	  }, {
	    key: 'getEntityUsers',
	    value: function getEntityUsers(locationIds) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/entityusers/' + locationIds));
	    }
	  }, {
	    key: 'getUserStats',
	    value: function getUserStats(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/userstats/' + entityId));
	    }
	  }]);
	  return UserService;
	}();
	
	exports.default = UserService;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _unauthorized = __webpack_require__(1044);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unauthorizedModule = _angular2.default.module('unauthorized', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('unauthorized', {
	    url: '/unauthorized',
	    component: 'unauthorized',
	    params: {
	      msg: ''
	    }
	  });
	}]).component('unauthorized', _unauthorized2.default).name;
	
	exports.default = unauthorizedModule;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _unauthorized = __webpack_require__(1045);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	var _unauthorized3 = __webpack_require__(1046);
	
	var _unauthorized4 = _interopRequireDefault(_unauthorized3);
	
	__webpack_require__(1047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unauthorizedComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _unauthorized2.default,
	  controller: _unauthorized4.default
	};
	
	exports.default = unauthorizedComponent;

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">      \r\n      <h1>\r\n          <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\" style=\"color: red;font-size:32px;\"></i>&nbsp;<b>We're sorry.</b> <br><br>\r\n          \r\n          Either the page you're looking for does not exist on our system <br>\r\n          or you do not have permissions to view this resource\r\n      </h1>\r\n\r\n      <h3 ng-if=\"$ctrl.$stateParams.msg\">\r\n        <b>Error Details:</b><br />\r\n        {{$ctrl.$stateParams.msg}}\r\n      </h3>\r\n\r\n      <h3>Click <a ui-sref='welcomeCentre'>here</a> to go back to your home page</h3>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnauthorizedController = function UnauthorizedController(authService, $stateParams) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, UnauthorizedController);
	  this.authService = authService;
	  this.$stateParams = $stateParams;
	};
	UnauthorizedController.$inject = ["authService", "$stateParams"];
	
	exports.default = UnauthorizedController;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1048);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./unauthorized.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./unauthorized.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".unauthorized{color:red}", ""]);
	
	// exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicle = __webpack_require__(1050);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _vehicleList = __webpack_require__(1055);
	
	var _vehicleList2 = _interopRequireDefault(_vehicleList);
	
	var _vehicleEdit = __webpack_require__(1067);
	
	var _vehicleEdit2 = _interopRequireDefault(_vehicleEdit);
	
	var _vehiclePublish = __webpack_require__(1129);
	
	var _vehiclePublish2 = _interopRequireDefault(_vehiclePublish);
	
	var _vehicle3 = __webpack_require__(1135);
	
	var _vehicle4 = _interopRequireDefault(_vehicle3);
	
	var _vehicleAppraisal = __webpack_require__(1136);
	
	var _vehicleAppraisal2 = _interopRequireDefault(_vehicleAppraisal);
	
	var _deliveredVehicles = __webpack_require__(1168);
	
	var _deliveredVehicles2 = _interopRequireDefault(_deliveredVehicles);
	
	var _simiLookup = __webpack_require__(1174);
	
	var _simiLookup2 = _interopRequireDefault(_simiLookup);
	
	var _vehicleAddSkupenet = __webpack_require__(1180);
	
	var _vehicleAddSkupenet2 = _interopRequireDefault(_vehicleAddSkupenet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleModule = _angular2.default.module('vehicle', [_angularUiRouter2.default, _vehicleList2.default, _vehicleEdit2.default, _vehiclePublish2.default, _vehicleAppraisal2.default, _deliveredVehicles2.default, _simiLookup2.default, _vehicleAddSkupenet2.default]).component('vehicle', _vehicle2.default).service('vehicleService', _vehicle4.default).name;
	
	exports.default = vehicleModule;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicle = __webpack_require__(1051);
	
	var _vehicle2 = _interopRequireDefault(_vehicle);
	
	var _vehicle3 = __webpack_require__(1052);
	
	var _vehicle4 = _interopRequireDefault(_vehicle3);
	
	__webpack_require__(1053);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicle2.default,
	  controller: _vehicle4.default
	};
	
	exports.default = vehicleComponent;

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleController = function VehicleController() {
	  (0, _classCallCheck3.default)(this, VehicleController);
	
	  this.name = 'vehicle';
	};
	
	exports.default = VehicleController;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1054);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./vehicle.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./vehicle.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicle{color:red}", ""]);
	
	// exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleList = __webpack_require__(1056);
	
	var _vehicleList2 = _interopRequireDefault(_vehicleList);
	
	var _pagination = __webpack_require__(716);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _dropdown = __webpack_require__(723);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _vehicleView = __webpack_require__(1061);
	
	var _vehicleView2 = _interopRequireDefault(_vehicleView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleListModule = _angular2.default.module('vehicleList', [_angularUiRouter2.default, _pagination2.default, _dropdown2.default, _vehicleView2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleList', {
	    url: '/vehicle/list',
	    component: 'vehicleList',
	    params: {
	      vehicleConditionSearch: null
	    }
	  });
	}]).component('vehicleList', _vehicleList2.default).name;
	
	exports.default = vehicleListModule;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleList = __webpack_require__(1057);
	
	var _vehicleList2 = _interopRequireDefault(_vehicleList);
	
	var _vehicleList3 = __webpack_require__(1058);
	
	var _vehicleList4 = _interopRequireDefault(_vehicleList3);
	
	__webpack_require__(1059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleListComponent = {
	  restrict: 'E',
	  bindings: {
	    publishMode: '<'
	  },
	  template: _vehicleList2.default,
	  controller: _vehicleList4.default
	};
	
	exports.default = vehicleListComponent;

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"vehicleListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>{{$ctrl.publishMode ? 'Published Vehicles' : 'Vehicle List'}}</h2>\r\n\r\n          <a class=\"btn btn-success\"\r\n            ng-hide=\"$ctrl.publishMode\"\r\n            ui-sref=\"vehicleAdd\"\r\n            ng-show=\"$ctrl.authService.checkFeatureAccess('Vehicle', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n              <span class=\"glyphicon glyphicon-plus\"></span>\r\n              Add Vehicle\r\n          </a>\r\n\r\n          <a class=\"btn btn-default\"\r\n            ng-click=\"$ctrl.print()\" ng-disabled=\"$ctrl.filterParams.vehicleStatus.id === null || $ctrl.filterParams.vehicleStatus.id === 3\"\r\n            ng-hide=\"$ctrl.publishMode\">\r\n              <span class=\"glyphicon glyphicon-print\"></span>\r\n              Print\r\n          </a>          \r\n\r\n          <a class=\"btn btn-success\" ng-show=\"$ctrl.authService.hasStockLoader()\" ng-click=\"$ctrl.publishVehicles()\">\r\n              Export Vehicles\r\n          </a>\r\n\r\n          <button ng-click=\"$ctrl.listVehicles()\" class=\"btn btn-primary pull-right\" ng-hide=\"$ctrl.publishMode\">\r\n            <i class=\"glyphicon glyphicon-search\"></i>\r\n            Search\r\n          </button>          \r\n          &nbsp;&nbsp;\r\n          <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\" ng-hide=\"$ctrl.publishMode\">\r\n            <i class=\"fa fa-eraser\"></i>\r\n            Clear Filters\r\n          </button>         \r\n      </header>\r\n\r\n        <section class=\"search\" ng-hide=\"$ctrl.publishMode\">\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.key as item.value for item in $ctrl.myLocations\"\r\n              ng-model=\"$ctrl.filterParams.entityId\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.initializeLookups()\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleConditionSearch track by item.id\"\r\n                ng-model=\"$ctrl.filterParams.vehicleConditionSearch\">\r\n              </select>\r\n            </span>          \r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleStatus track by item.id\"\r\n              ng-model=\"$ctrl.filterParams.vehicleStatus\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.updateBrandModel()\"\r\n              ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n              ng-model=\"$ctrl.filterParams.brand\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n              ng-model=\"$ctrl.filterParams.brandModel\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.filterParams.registration\" placeholder=\"Search by Reg\" />\r\n          </span> \r\n        </section>\r\n\r\n        <div ng-show=\"$ctrl.published\">\r\n          {{$ctrl.publishMsg}}\r\n          <div ng-show=\"$ctrl.publishFileName\">\r\n            Click <a class=\"btn btn-link\" ng-click=\"$ctrl.viewPublishedFiled()\">here</a> to view the file\r\n          </div>\r\n        </div>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\" ng-hide=\"$ctrl.published\">\r\n            <thead>\r\n                <tr>\r\n                    <th ng-hide=\"$ctrl.publishMode\">Image</th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('brand')\" ng-hide=\"$ctrl.publishMode\">\r\n                        Make <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">Make</label>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('model')\" ng-hide=\"$ctrl.publishMode\">\r\n                        Model <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">Model</label>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('registration')\" ng-hide=\"$ctrl.publishMode\">\r\n                        Registration <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">Registration</label>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('year')\" ng-hide=\"$ctrl.publishMode\">\r\n                        Year <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">Year</label>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('price')\" ng-hide=\"$ctrl.publishMode\">\r\n                        Price <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">Price</label>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('state')\" ng-hide=\"$ctrl.publishMode\">\r\n                        State <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                      <label ng-show=\"$ctrl.publishMode\">State</label>\r\n                    </th>\r\n                    <th ng-hide=\"$ctrl.publishMode\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"v in $ctrl.vehicles | filter:{ publishToWeb: $ctrl.publishMode && true }\">\r\n                    <td ng-hide=\"$ctrl.publishMode\">\r\n                        <img ng-src=\"{{v.imageUrl}}\" class=\"vehicleAvatar\"/>\r\n                    </td>\r\n                    <td>{{ v.brand }}</td>\r\n                    <td>{{ v.model }}</td>\r\n                    <td ng-if=\"!$ctrl.publishMode\">{{ v.registration }}</td>\r\n                    <td ng-if=\"$ctrl.publishMode\">\r\n                      <a ui-sref=\"vehicleEdit({vehicleId: v.vehicleId, origin: {source:'vehiclePublish'}})\">{{ v.registration }}</a>                      \r\n                    </td>\r\n                    <td>{{ v.year }}</td>\r\n                    <td>{{ ($ctrl.publishMode ? v.webPrice : v.price) | currency:'&euro;':0 }}</td>\r\n                    <td>{{ v.state }}</td>\r\n                    <td ng-hide=\"$ctrl.publishMode || v.entityId !== $ctrl.authService.authData.currentLocation.key\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Vehicle', $ctrl.enums.PERMISSION_TYPE.Edit, false, v.brandId)\">\r\n                            <a ui-sref=\"vehicleEdit({vehicleId: v.vehicleId})\">Edit Vehicle</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Vehicle', $ctrl.enums.PERMISSION_TYPE.Edit, false, v.brandId)\">\r\n                            <a ui-sref=\"editAppraisal({vehicleId: v.vehicleId})\">Edit Appraisal</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Vehicle', $ctrl.enums.PERMISSION_TYPE.Delete, false, v.brandId)\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.deleteVehicle(v.vehicleId)\">Delete</a>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer ng-hide=\"$ctrl.publishMode\">\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-8 pages\" ng-hide=\"!$ctrl.vehicles.length\">\r\n              <ul uib-pagination\r\n                boundary-link-numbers=\"true\"\r\n                max-size=\"7\"\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listVehicles()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>  \r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleListController = function () {
	  VehicleListController.$inject = ["authService", "vehicleService", "loadingService", "lookupService", "enums", "$q", "$window", "appConfig", "$stateParams", "printService", "fileService"];
	  function VehicleListController(authService, vehicleService, loadingService, lookupService, enums, $q, $window, appConfig, $stateParams, printService, fileService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VehicleListController);
	    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.vehicleService = vehicleService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.enums = enums;
	    this.$q = $q;
	    this.$window = $window;
	    this.appConfig = appConfig;
	    this.$stateParams = $stateParams;
	    this.printService = printService;
	    this.fileService = fileService;
	
	    this.filterParams = {};
	
	    this.initializeEnumLookups().then(function () {
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(VehicleListController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        //If New Vehicle then filter brands with only allowed brands on roles in this location
	        if (ctrl.filterParams.vehicleConditionSearch.id === 1) {
	          var allowedBrands = ctrl.authService.getLocationBrands(ctrl.enums.PERMISSION_TYPE.View);
	          var hasAllBrand = (0, _lodash.find)(allowedBrands, function (brandId) {
	            return brandId === 1;
	          });
	
	          if (hasAllBrand) {
	            brands[0].name = 'All Brands';
	            _this2.brands = brands;
	          } else {
	            _this2.brands = (0, _lodash.filter)(brands, function (o) {
	              return (0, _lodash.find)(allowedBrands, function (brandId) {
	                return brandId === o.brandId;
	              }) !== undefined;
	            });
	
	            //Add this specific list in filterParams so it can be used to send it to server
	            ctrl.filterParams.allowedBrands = _this2.brands;
	
	            //Add a special 0 brandId which will be used to filter only on the allowed brands
	            _this2.brands = [{ brandId: 0, name: 'All Brands' }].concat((0, _toConsumableArray3.default)(_this2.brands));
	          }
	        } else {
	          brands[0].name = 'All Brands';
	          _this2.brands = brands;
	        }
	
	        _this2.filterParams.brand = _this2.brands[0];
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          _this2.updateBrandModel();
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.filterParams.brand.brandId;
	      });
	      this.brandModels = [{ brandModelId: 0, name: 'All Models' }].concat((0, _toConsumableArray3.default)(this.brandModels));
	      this.filterParams.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this4 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	      var lookups = ['VehicleConditionSearch', 'VehicleStatus'];
	      this.enumLookupCollection = [];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        if (enumLookupCollection.vehicleStatus) {
	          enumLookupCollection['vehicleStatus'] = enumLookupCollection['vehicleStatus'].slice(0, 3);
	          enumLookupCollection['vehicleStatus'].unshift({ id: null, name: 'All States' });
	        }
	
	        _this4.enumLookupCollection = enumLookupCollection;
	
	        (0, _lodash.map)(enumLookupCollection, function (itemsArray, index) {
	          _this4.filterParams[index] = itemsArray[0];
	        });
	
	        _this4.initializeLookups().then(function () {
	          _this4.initializeMyLocations().then(function () {
	            return deferred.resolve();
	          });
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'initializeMyLocations',
	    value: function initializeMyLocations() {
	      var _this5 = this;
	
	      var promise = this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key);
	
	      promise.then(function (response) {
	        _this5.myLocations = response.data;
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _this6 = this;
	
	      var ctrl = this;
	
	      if (ctrl.$stateParams.vehicleConditionSearch) {
	        /*
	        * This check is added to select a Vehicle Condition (New, Used Retail or Used Trade)
	        * After coming back from Add / Edit vehicle
	        */
	        ctrl.filterParams.vehicleConditionSearch = (0, _lodash.find)(ctrl.enumLookupCollection.vehicleConditionSearch, function (o) {
	          return o.id === ctrl.$stateParams.vehicleConditionSearch;
	        });
	        ctrl.$stateParams.vehicleConditionSearch = null;
	      } else {
	        //Set Condition to New
	        this.filterParams.vehicleConditionSearch = this.enumLookupCollection.vehicleConditionSearch[0];
	      }
	
	      this.filterParams.vehicleStatus = this.enumLookupCollection.vehicleStatus[0];
	      this.filterParams.registration = null;
	
	      var promise = this.initializeLookups();
	
	      promise.then(function () {
	        _this6.pagination = {
	          totalItems: 0,
	          currentPage: 1,
	          pageSize: ctrl.publishMode ? -1 : 10
	        };
	
	        _this6.filterParams.entityId = _this6.authService.authData.currentLocation.key;
	        _this6.filterParams.pageCriteria = {
	          pageStart: 0,
	          itemsToFetch: _this6.pagination.pageSize,
	          sortExpression: 'condition',
	          ascending: true
	        };
	
	        _this6.notification = {
	          type: 'info',
	          msg: ''
	        };
	
	        _this6.listVehicles();
	      });
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listVehicles();
	    }
	  }, {
	    key: 'listVehicles',
	    value: function listVehicles() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('vehicleListing', 'Loading Vehicles ...');
	
	      ctrl.vehicleService.listVehicles(ctrl.filterParams).then(function (response) {
	        //response.data.items.map(entity => listCtrl.getActionsDropdown(entity));
	        ctrl.vehicles = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleListing');
	      });
	    }
	  }, {
	    key: 'deleteVehicle',
	    value: function deleteVehicle(vehicleId) {
	      var _this7 = this;
	
	      var ctrl = this;
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to delete this vehicle ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('vehicleListing', 'Removing Vehicle ...');
	
	      ctrl.vehicleService.updateVehicleState(this.authService.authData.currentLocation.key, vehicleId, this.enums.VEHICLE_STATUS.Discontinued).then(function (response) {
	        ctrl.listVehicles();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this7.loadingService.hideLoading('vehicleListing');
	      });
	    }
	  }, {
	    key: 'selectAllVehicles',
	    value: function selectAllVehicles() {
	      var ctrl = this;
	
	      ctrl.vehicles.map(function (v) {
	        v.publishToWeb = ctrl.allVehicles;
	      });
	    }
	  }, {
	    key: 'publishVehicles',
	    value: function publishVehicles() {
	      var ctrl = this;
	
	      ctrl.fileService.exportVehicles(ctrl.authService.authData.currentLocation.key);
	    }
	  }, {
	    key: 'viewPublishedFiled',
	    value: function viewPublishedFiled() {
	      var fileName = this.publishFileName.split('.')[0];
	      var fileExt = this.publishFileName.split('.')[1];
	      window.location = this.appConfig.apiServiceBaseUri + 'api/file/getfile/' + fileName + '/' + fileExt;
	      //alert(this.publishFileName);
	    }
	  }, {
	    key: 'print',
	    value: function print() {
	      var queryParams = this.vehicleService.getQueryParams(this.filterParams);
	
	      this.printService.printVehicleList(queryParams);
	    }
	  }]);
	  return VehicleListController;
	}();
	
	exports.default = VehicleListController;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1060);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleAvatar{width:32px;height:32px}", ""]);
	
	// exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleView = __webpack_require__(1062);
	
	var _vehicleView2 = _interopRequireDefault(_vehicleView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleViewModule = _angular2.default.module('vehicleView', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleEnquiryView', {
	    url: '/enquiry/selectVehicle/',
	    component: 'vehicleView',
	    params: {
	      source: null,
	      enquiry: null,
	      condition: null,
	      vehicleId: null
	    }
	  });
	}]).component('vehicleView', _vehicleView2.default).name;
	
	exports.default = vehicleViewModule;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleView = __webpack_require__(1063);
	
	var _vehicleView2 = _interopRequireDefault(_vehicleView);
	
	var _vehicleView3 = __webpack_require__(1064);
	
	var _vehicleView4 = _interopRequireDefault(_vehicleView3);
	
	__webpack_require__(1065);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleViewComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleView2.default,
	  controller: _vehicleView4.default
	};
	
	exports.default = vehicleViewComponent;

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n      <!-- Being Header Panel -->\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Vehicle Search</h2>\r\n\r\n          <span>\r\n              <a class=\"btn btn-primary\" ng-click=\"$ctrl.selectEnquiryVehicle()\" ng-hide=\"$ctrl.isSingleView\">Select Vehicle</a>\r\n              <a class=\"btn btn-primary\" ng-click=\"$ctrl.redirectToParent(true)\">Go Back</a>\r\n          </span>\r\n        </header>\r\n      </div>\r\n      <!-- End Header Panel -->\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg\">\r\n            {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <!-- Being Search Panel -->\r\n      <div class=\"panel\" ng-hide=\"$ctrl.isSingleView\">\r\n        <section class=\"search\">\r\n          <div class=\"row\">\r\n            <span class=\"col-md-2\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-options=\"item.key as item.value for item in $ctrl.myLocations\"\r\n                ng-model=\"$ctrl.criteria.entityId\">\r\n              </select>\r\n            </span>\r\n\r\n            <span class=\"col-md-2\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-options=\"r.id as r.name for r in $ctrl.selectOptions.condition\"\r\n                ng-model=\"$ctrl.criteria.condition\"\r\n                ng-change=\"$ctrl.updateBrands()\">\r\n              </select>\r\n            </span>\r\n\r\n            <span class=\"col-md-3 nopadding\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateBrandModel()\"\r\n                ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                ng-model=\"$ctrl.criteria.brand\">\r\n              </select>\r\n            </span>\r\n\r\n            <span class=\"col-md-3 nopadding\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateBodyTypes()\"\r\n                ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                ng-model=\"$ctrl.criteria.brandModel\">\r\n              </select>\r\n            </span>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n              <span class=\"col-md-3\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"r.id as r.name for r in $ctrl.selectOptions.bodyType\"\r\n                  ng-model=\"$ctrl.criteria.bodyType\">\r\n                </select>\r\n              </span>\r\n  \r\n              <span class=\"col-md-3\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"r.id as r.name for r in $ctrl.selectOptions.transmissionType\"\r\n                  ng-model=\"$ctrl.criteria.transmissionType\">\r\n                </select>\r\n              </span>\r\n  \r\n              <span class=\"col-md-3\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"r.id as r.name for r in $ctrl.selectOptions.fuelType\"\r\n                  ng-model=\"$ctrl.criteria.fuelType\">\r\n                </select>\r\n              </span>\r\n            </div>          \r\n\r\n          <div class=\"row\">\r\n            <span class=\"col-md-2\">\r\n              <input\r\n                type=\"number\"\r\n                step=\"0.1\"\r\n                max=\"6.2\"\r\n                class=\"form-control\"\r\n                placeholder=\"Capacity From\"\r\n                ng-model=\"$ctrl.criteria.capacityFrom\">\r\n            </span>\r\n\r\n            <span class=\"col-md-2\">\r\n              <input\r\n                type=\"number\"\r\n                step=\"0.1\"\r\n                max=\"6.2\"\r\n                class=\"form-control\"\r\n                placeholder=\"Capacity To\"\r\n                ng-model=\"$ctrl.criteria.capacityTo\">\r\n            </span>\r\n\r\n            <span class=\"col-md-2\">\r\n              <input\r\n                type=\"number\"\r\n                class=\"form-control\"\r\n                placeholder=\"Year From\"\r\n                ng-model=\"$ctrl.criteria.yearFrom\">\r\n            </span>\r\n\r\n            <span class=\"col-md-2\">\r\n              <input\r\n                type=\"number\"\r\n                class=\"form-control\"\r\n                placeholder=\"Year To\"\r\n                ng-model=\"$ctrl.criteria.yearTo\">\r\n            </span>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n            <span class=\"col-md-2 nopadding\">\r\n              <input\r\n                type=\"number\"\r\n                class=\"form-control\"\r\n                placeholder=\"Price From\"\r\n                ng-model=\"$ctrl.criteria.priceFrom\">\r\n            </span>\r\n\r\n            <span class=\"col-md-2 nopadding\">\r\n              <input\r\n                type=\"number\"\r\n                class=\"form-control\"\r\n                placeholder=\"Price To\"\r\n                ng-model=\"$ctrl.criteria.priceTo\">\r\n            </span>\r\n\r\n            <span class=\"col-md-2 pull-right\">\r\n              <button ng-click=\"$ctrl.searchVehicles()\" class=\"btn btn-primary\">\r\n                <i class=\"glyphicon glyphicon-search\"></i>\r\n                Search\r\n              </button>\r\n            </span>\r\n\r\n            <span class=\"col-md-2 pull-right\">\r\n              <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n                <i class=\"fa fa-eraser\"></i>\r\n                Clear Filters\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </section>\r\n      </div>\r\n      <!-- End Search Panel -->\r\n\r\n      <!-- Begin Vehicle Count Panel -->\r\n      <div class=\"alert alert-info\" ng-show=\"$ctrl.vehicles.length && !$ctrl.isSingleView\">\r\n            Found {{$ctrl.vehicles.length}} vehicles matching your criteria\r\n      </div>\r\n      <!-- End Vehicle Count Panel -->\r\n\r\n      <!-- Begin Stock Vehicle Listing -->\r\n      <div class=\"row\" ng-show=\"$ctrl.vehicles.length && $ctrl.criteria.condition !== 0\">\r\n        <div class=\"col-md-3\" ng-hide=\"$ctrl.isSingleView\">\r\n          <div class=\"panel\" style=\"overflow-y: scroll; height:500px;\">\r\n            <ul class=\"list-group\">\r\n              <span ng-repeat=\"v in $ctrl.vehicles\">\r\n                \r\n                <span class=\"list-group-item justify-content-between\" ng-if=\"$ctrl.isMultiSelect\" ng-click=\"$ctrl.vehicle = v\">                  \r\n                  <input type=\"checkbox\" id=\"chk{{v.vehicleId}}\" ng-click=\"$ctrl.multi_selectUnselectVehicle(v)\" />\r\n                  <img ng-src=\"{{v.defaultImage}}\" class=\"vehicleAvatar\"/>                                    \r\n                  <label for=\"chk{{v.vehicleId}}\">{{v.model}} {{v.registration}}</label>\r\n                </span>\r\n\r\n                <span ng-if=\"!$ctrl.isMultiSelect\">\r\n                  <a class=\"list-group-item justify-content-between\" ng-click=\"$ctrl.vehicle = v\" href=\"#\" ng-class=\"{'selectedRow' : v === $ctrl.vehicle}\">\r\n                    <img ng-src=\"{{v.defaultImage}}\" class=\"vehicleAvatar\"/>                \r\n                    {{v.model}} {{v.registration}}\r\n                  </a>\r\n                </span>\r\n\r\n              </span>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-9\">\r\n          <div class=\"panel\">\r\n            <div class=\"col-xs-8 col-sm-9\" id=\"slider\">\r\n                <div id=\"main_area\" ng-show=\"$ctrl.vehicle.mediaItems.length\">\r\n                    <!-- Slider -->\r\n                    <div id=\"carousel-bounding-box\">\r\n                        <div class=\"carousel slide\" id=\"myCarousel\">\r\n                            <!-- Carousel items -->\r\n                            <div class=\"carousel-inner\">\r\n                                <div class=\"item\" ng-class=\"{'active': mi.isCover}\" ng-repeat=\"mi in $ctrl.vehicle.mediaItems\" data-slide-number=\"{{$index}}\">\r\n                                    <img ng-src=\"{{mi.url}}\" ng-if=\"mi.mediaType === $ctrl.enums.MEDIA_TYPE.Image || mi.mediaType === $ctrl.enums.MEDIA_TYPE.ExternalImage\"\r\n                                    />\r\n                                </div>\r\n                            </div>\r\n                            <!-- Carousel nav -->\r\n                            <a class=\"left carousel-control\" href=\"#myCarousel\" role=\"button\" data-slide=\"prev\">\r\n                                <span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n                            </a>\r\n                            <a class=\"right carousel-control\" href=\"#myCarousel\" role=\"button\" data-slide=\"next\">\r\n                                <span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                    <div id=\"slider-thumbs\">\r\n                        <!-- Bottom switcher of slider -->\r\n                        <ul class=\"hide-bullets\">\r\n                            <li class=\"col-xs-6 col-sm-4 col-md-3\" ng-repeat=\"mi in $ctrl.vehicle.mediaItems\">\r\n                                <a class=\"thumbnail\" ng-click=\"$ctrl.updateVehicleMedia($index)\" ng-if=\"mi.mediaType === $ctrl.enums.MEDIA_TYPE.Image || mi.mediaType === $ctrl.enums.MEDIA_TYPE.ExternalImage\">\r\n                                    <img ng-src=\"{{mi.url}}\">\r\n                                </a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n                <div class=\"image-stock-container\" ng-show=\"!$ctrl.vehicle.mediaItems.length\">\r\n                    <img class=\"image-stock\" ng-src=\"../../../../../images/carIcon.png\" />\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-4 col-sm-3\">\r\n                <dl>\r\n                    <dt>Condition:</dt>\r\n                    <dd>{{$ctrl.vehicle.condition || '-'}}</dd>\r\n                    <dt>Vehicle Type:</dt>\r\n                    <dd>{{$ctrl.vehicle.vehicleType || '-'}}</dd>\r\n\r\n                    <dt>Status:</dt>\r\n                    <dd>{{$ctrl.vehicle.state || '-'}}</dd>\r\n                    <dt>Model:</dt>\r\n                    <dd>{{$ctrl.vehicle.model || '-'}}</dd>\r\n\r\n                    <dt>Registration:</dt>\r\n                    <dd>{{$ctrl.vehicle.registration || '-'}}</dd>\r\n                    <dt>Chassis No:</dt>\r\n                    <dd>{{$ctrl.vehicle.chassisNo || '-'}}</dd>\r\n\r\n                    <dt>Variant:</dt>\r\n                    <dd>{{$ctrl.vehicle.variant || '-'}}</dd>\r\n                    <dt>Mileage:</dt>\r\n                    <dd>{{$ctrl.vehicle.mileage || '-'}}</dd>\r\n                    <dt>First Registration:</dt>\r\n                    <dd>{{$ctrl.vehicle.firstRegistration || '-'}}</dd>\r\n\r\n                    <dt>Color:</dt>\r\n                    <dd>{{$ctrl.vehicle.color || '-'}}</dd>\r\n                    <dt>Year:</dt>\r\n                    <dd>{{$ctrl.vehicle.year || '-'}}</dd>\r\n\r\n                    <dt>Fuel Type:</dt>\r\n                    <dd>{{$ctrl.vehicle.fuelType || '-'}}</dd>\r\n                    <dt>Engine Capacity:</dt>\r\n                    <dd>{{$ctrl.vehicle.capacity || '-'}}</dd>\r\n                    <dt>Price:</dt>\r\n                    <dd>{{($ctrl.vehicle.price | currency:'&euro;':2) || '-'}}</dd>\r\n\r\n                    <dt>Body Type:</dt>\r\n                    <dd>{{$ctrl.vehicle.bodyType || '-'}}</dd>\r\n                    <dt>Transmission Type:</dt>\r\n                    <dd>{{$ctrl.vehicle.transmissionType || '-'}}</dd>\r\n\r\n                </dl>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- End Stock Vehicle Listing -->\r\n\r\n      <!-- Begin Price Book Vehicle Listing -->\r\n      <div class=\"row\" ng-show=\"$ctrl.vehicles.length && $ctrl.criteria.condition === 0\">\r\n        <div class=\"list-group\" ng-if=\"false\">\r\n          <a href=\"#\" class=\"list-group-item\" ng-repeat=\"v in $ctrl.vehicles\">\r\n            <div class=\"col-md-2\">{{v.model}}</div>\r\n\r\n          </a>\r\n        </div>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th>Model</th>\r\n                  <th>Body</th>\r\n                  <th>Retail Price</th>\r\n                  <th>Capacity</th>\r\n                  <th>Transmission</th>\r\n                  <th>Fuel</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr class=\"mouse-pointer\" data-ng-repeat=\"v in $ctrl.vehicles\" ng-class=\"{'selectedRow' : v === $ctrl.vehicle}\" ng-click=\"$ctrl.vehicle = v\">\r\n                    <td>\r\n                      <a href=\"#\" ng-click=\"$ctrl.vehicle = v\">\r\n                        {{v.model + ' ' + (v.variant || '')}}\r\n                      </a>\r\n                    </td>\r\n                    <td>{{v.bodyType}}</td>\r\n                    <td>{{(v.price | currency:'&euro;':2)}}</td>\r\n                    <td>{{v.capacity}}</td>\r\n                    <td>{{v.transmissionType}}</td>\r\n                    <td>{{v.fuelType}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n      </div>\r\n      <!-- End Price Book Vehicle Listing -->\r\n\r\n      <div class=\"row\" ng-hide=\"$ctrl.vehicles.length\">\r\n        <div class=\"col-md-12\">\r\n          No vehicles found\r\n        </div>\r\n      </div>\r\n  </div>\r\n"

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleViewController = function () {
	  VehicleViewController.$inject = ["authService", "$stateParams", "enums", "vehicleService", "loadingService", "$state", "lookupService", "$q", "retailPriceListService", "deliveryPriceManagementService"];
	  function VehicleViewController(authService, $stateParams, enums, vehicleService, loadingService, $state, lookupService, $q, retailPriceListService, deliveryPriceManagementService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VehicleViewController);
	    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.$stateParams = $stateParams;
	    this.vehicleService = vehicleService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	    this.$state = $state;
	    this.lookupService = lookupService;
	    this.$q = $q;
	    this.retailPriceListService = retailPriceListService;
	    this.deliveryPriceManagementService = deliveryPriceManagementService;
	
	    this.vehicle = null;
	
	    //For Selecting multiple vehicles when its a Trader contact type
	    this.selectedVehicles = [];
	
	    if (!$stateParams.enquiry) {
	      $state.go('welcomeCentre');
	      return;
	    }
	
	    this.selectOptions = {};
	    this.criteria = {};
	    this.deliveryPriceList = [];
	
	    //If this is for a multi select contact
	    this.isMultiSelect = $stateParams.enquiry.contactType === enums.CONTACT_TYPE.Trader;
	
	    //Initialization
	    this.initializeVehicleConditions();
	    this.initializeLookups().then(function () {
	      _this.updateBrands(_this.$stateParams.enquiry.criteria.condition);
	      _this.listDeliveryPriceList();
	    });
	
	    this.isSingleView = $stateParams.vehicleId !== null;
	  }
	
	  (0, _createClass3.default)(VehicleViewController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        _this2.allBrands = brands;
	        _this2.brands = _this2.allBrands;
	        _this2.brands.unshift({ brandId: null, name: 'Any Brand' });
	
	        _this2.criteria.brand = _this2.brands[0];
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          _this2.updateBrandModel();
	
	          _this2.initializeMyLocations().then(function () {
	            _this2.initializeEnums();
	            deferred.resolve();
	          });
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'initializeVehicleConditions',
	    value: function initializeVehicleConditions() {
	      this.selectOptions.condition = [{ id: null, name: "Please Select" }, { id: 0, name: "New Order" }, { id: 1, name: "New (In Stock)" }, { id: 2, name: "Used (In Stock)" }];
	
	      if (this.isMultiSelect) {
	        this.selectOptions.condition = (0, _lodash.without)(this.selectOptions.condition, this.selectOptions.condition[1]);
	      }
	    }
	  }, {
	    key: 'initializeMyLocations',
	    value: function initializeMyLocations() {
	      var _this3 = this;
	
	      var promise = this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key);
	
	      promise.then(function (response) {
	        _this3.myLocations = response.data;
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      if (this.criteria.condition === 0) {
	        this.updateBrandModelPriceList();
	      } else {
	        this.updateBrandModelStock();
	      }
	    }
	  }, {
	    key: 'updateBrandModelStock',
	    value: function updateBrandModelStock() {
	      var _this4 = this;
	
	      var ctrl = this;
	
	      if (ctrl.criteria.condition === 0) {
	        /*
	        * #577
	        * This is to display only the brand models that we have the models available
	        * in retail price list. This is to reduce customer selecting a brand model
	        * clicking search and no results returned, this will make sure
	        * that if there is a brand model and you search for that
	        * there will be variants for that
	        */
	        var locationBrandModelIds = (0, _lodash.map)((0, _lodash.uniqBy)(ctrl.allVehiclesPriceList, 'brandModelId'), function (o) {
	          return o.brandModelId;
	        });
	        var locationBrandModels = (0, _lodash.map)(ctrl.allBrandModels, function (o) {
	          var hasBrandModel = (0, _lodash.find)(locationBrandModelIds, function (brandModelId) {
	            return brandModelId === o.brandModelId;
	          });
	          if (hasBrandModel) {
	            return o;
	          }
	        });
	
	        locationBrandModels = (0, _lodash.filter)(locationBrandModels, function (o) {
	          return o;
	        });
	        this.brandModels = (0, _lodash.filter)(locationBrandModels, function (o) {
	          return o.brandId === _this4.criteria.brand.brandId;
	        });
	      } else {
	        this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	          return o.brandId === _this4.criteria.brand.brandId;
	        });
	      }
	
	      this.brandModels.unshift({ brandModelId: null, name: 'Any Model' });
	
	      this.criteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'updateBrandModelPriceList',
	    value: function updateBrandModelPriceList() {
	      var ctrl = this;
	
	      if (!this.criteria.brand.brandId) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('vehicleView', 'Loading Vehicles');
	
	      ctrl.retailPriceListService.getRetailPriceListsByBrandId(this.criteria.brand.brandId).then(function (response) {
	        ctrl.vehicles = [];
	        ctrl.allVehiclesPriceList = response.data.items;
	        ctrl.updateBrandModelStock();
	        ctrl.updateBodyTypes();
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleView');
	      });
	    }
	  }, {
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'VEHICLE_BODY_TYPE', propName: 'bodyType', propNameU: 'BodyTypes', defaultOption: true, defaultText: 'Any Body Type' }, { enumName: 'FUEL_TYPE', propName: 'fuelType', propNameU: 'FuelTypes', defaultOption: true, defaultText: 'Any Fuel Type' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionType', propNameU: 'TransmissionType', defaultOption: true, defaultText: 'Any Transmission Type' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultText);
	        ctrl['all' + item.propNameU] = enumsArray;
	        ctrl.selectOptions[item.propName] = enumsArray;
	      });
	
	      ctrl.reset(ctrl.$stateParams.enquiry.criteria, ctrl.$stateParams.condition);
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultText) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: defaultText || 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'reset',
	    value: function reset(criteria, initialCondition) {
	      var ctrl = this;
	
	      if (criteria) {
	        ctrl.criteria = criteria;
	
	        criteria.brand = (0, _lodash.find)(ctrl.brands, function (o) {
	          return o.brandId === criteria.brandId;
	        });
	        ctrl.updateBrandModel();
	        criteria.brandModel = (0, _lodash.find)(ctrl.brandModels, function (o) {
	          return o.brandModelId === criteria.brandModelId;
	        });
	      } else {
	        ctrl.criteria.enquiryId = ctrl.$stateParams.enquiry.enquiryId;
	        ctrl.criteria.condition = initialCondition || null;
	        ctrl.criteria.bodyType = null;
	        ctrl.criteria.fuelType = null;
	        ctrl.criteria.transmissionType = null;
	        ctrl.criteria.capacityFrom = null;
	        ctrl.criteria.capacityTo = null;
	        ctrl.criteria.yearFrom = null;
	        ctrl.criteria.yearTo = null;
	        ctrl.criteria.priceFrom = null;
	        ctrl.criteria.priceTo = null;
	        ctrl.criteria.brand = ctrl.brands[0];
	        ctrl.updateBrands();
	        ctrl.updateBrandModel();
	      }
	
	      ctrl.criteria.entityId = ctrl.authService.authData.currentLocation.key;
	      ctrl.searchVehicles();
	    }
	  }, {
	    key: 'searchVehicles',
	    value: function searchVehicles() {
	      var _this5 = this;
	
	      var ctrl = this;
	
	      if (ctrl.criteria.condition === 0) {
	        ctrl.filterRetailPriceLists();
	        return;
	      }
	
	      ctrl.vehicle = null;
	      ctrl.errMsg = null;
	      ctrl.loadingService.showLoading('vehicleView', 'Loading Vehicles');
	
	      ctrl.criteria.brandId = ctrl.criteria.brand.brandId;
	      ctrl.criteria.brandModelId = ctrl.criteria.brandModel.brandModelId;
	
	      ctrl.vehicleService.searchVehicles(ctrl.criteria.entityId, ctrl.criteria).then(function (response) {
	        //Update Enquiry Search criteria
	        ctrl.criteria.brand = (0, _lodash.find)(ctrl.brands, function (o) {
	          return o.brandId === ctrl.criteria.brandId;
	        });
	        ctrl.updateBrandModel();
	        ctrl.criteria.brandModel = (0, _lodash.find)(ctrl.brandModels, function (o) {
	          return o.brandModelId === ctrl.criteria.brandModelId;
	        });
	        ctrl.$stateParams.enquiry.criteria = ctrl.criteria;
	
	        ctrl.vehicles = response.data.items;
	
	        if (ctrl.vehicles.length) {
	          if (!_this5.isMultiSelect) {
	            if (ctrl.$stateParams.vehicleId) {
	              ctrl.vehicle = (0, _lodash.find)(_this5.vehicles, function (o) {
	                return o.vehicleId === ctrl.$stateParams.vehicleId;
	              });
	            } else {
	              ctrl.vehicle = _this5.vehicles[0];
	            }
	          } else {
	            _this5.selectedVehicles = [];
	          }
	        }
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleView');
	      });
	    }
	  }, {
	    key: 'updateVehicleMedia',
	    value: function updateVehicleMedia(id) {
	      jQuery('#myCarousel').carousel(parseInt(id));
	
	      jQuery('video.carousel').each(function (i, val) {
	        val.pause();
	      });
	    }
	  }, {
	    key: 'selectEnquiryVehicle',
	    value: function selectEnquiryVehicle() {
	      if (!this.vehicle && !this.selectedVehicles.length) {
	        this.errMsg = "Please select a vehicle first";
	        return;
	      }
	
	      this.selectVehicle();
	    }
	  }, {
	    key: 'selectVehicle',
	    value: function selectVehicle() {
	      if (this.isMultiSelect) {
	        this.multiSelectVehicles();
	      } else {
	        if (this.criteria.condition === 0) {
	          this.selectVehiclePriceList();
	        } else {
	          this.selectVehicleStock();
	        }
	      }
	    }
	  }, {
	    key: 'selectVehicleStock',
	    value: function selectVehicleStock() {
	      var _this6 = this;
	
	      var isNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.errMsg = '';
	
	      if (this.vehicle.entityId !== this.authService.authData.currentLocation.key) {
	        var sure = window.confirm('This vehicle is not in your location are you sure you want to add it ?');
	        if (!sure) {
	          return;
	        }
	      }
	
	      var dupVehicle = (0, _lodash.find)(this.$stateParams.enquiry.enquiryVehicles, function (o) {
	        return o.vehicleId === _this6.vehicle.vehicleId;
	      });
	
	      if (!dupVehicle) {
	        var enquiryVehicle = {
	          vehicleId: this.vehicle.vehicleId,
	          vehicle: this.vehicle,
	          isSelected: false,
	          isRemoved: false
	        };
	
	        this.$stateParams.enquiry.enquiryVehicles.push(enquiryVehicle);
	
	        //Add a unconfirmed test drive for this selected vehicle
	        this.$stateParams.enquiry.testDrives.push({
	          vehicleId: this.vehicle.vehicleId,
	          model: this.vehicle.model,
	          comments: null,
	          timeStamp: null,
	          isConfirmed: false
	        });
	
	        /*
	        * This is a price book vehicle
	        * Need to check if there's not a delivery price extra to this enquiry
	        * then add one
	        */
	        if (isNew && this.vehicle.defaultDeliveryPrice) {
	          var deliveryPrice = (0, _lodash.find)(this.$stateParams.enquiry.enquiryPrices, function (o) {
	            return o.groupType === _this6.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras && o.name === 'Delivery Price';
	          });
	
	          if (deliveryPrice) {
	            deliveryPrice.amount = this.vehicle.defaultDeliveryPrice;
	          } else {
	            this.$stateParams.enquiry.enquiryPrices.push({
	              priceType: this.enums.ENQUIRY_PRICE_TYPE.Cost,
	              groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras,
	              name: 'Delivery Price',
	              amount: this.vehicle.defaultDeliveryPrice,
	              removed: false
	            });
	          }
	        }
	
	        this.redirectToParent();
	      } else {
	        this.errMsg = 'This vehicle is already added to the enquiry';
	      }
	    }
	  }, {
	    key: 'selectVehiclePriceList',
	    value: function selectVehiclePriceList() {
	      var _this7 = this;
	
	      this.loadingService.showLoading('vehicleView', 'Saving Changes ...');
	
	      //Create Vehicle From Price List first
	      this.vehicleService.createFromPriceList(this.authService.authData.currentLocation.key, this.vehicle.vehicleId).then(function (response) {
	        _this7.vehicle = response.data;
	        _this7.selectVehicleStock(true);
	      }).finally(function () {
	        _this7.loadingService.hideLoading('vehicleView');
	      });
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(isCancel) {
	      var _this8 = this;
	
	      /*
	      * This request is coming form Welcome Centre,
	      * so assume the selected vehicle is of interest to the customer
	      */
	      if (!isCancel && this.$stateParams.enquiry.enquiryVehicles.length) {
	        this.$stateParams.enquiry.enquiryVehicles.map(function (ev) {
	          ev.isSelected = false;
	        });
	
	        var ev = this.$stateParams.enquiry.enquiryVehicles[this.$stateParams.enquiry.enquiryVehicles.length - 1];
	        ev.isSelected = true;
	        var costPrice = (0, _lodash.find)(this.$stateParams.enquiry.enquiryPrices, function (o) {
	          return o.priceType === _this8.enums.ENQUIRY_PRICE_TYPE.Cost && o.groupType === _this8.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing;
	        });
	
	        if (costPrice) {
	          costPrice.amount = ev.vehicle.price || 0;
	        } else {
	          this.$stateParams.enquiry.enquiryPrices.push({
	            priceType: this.enums.ENQUIRY_PRICE_TYPE.Cost,
	            groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
	            name: 'Vehicle Price',
	            amount: ev.vehicle.price || 0
	          });
	        }
	      }
	
	      if (this.$stateParams.source === 'welcomeCentre') {
	        this.$state.go('welcomeCentre', {
	          enquiry: this.$stateParams.enquiry
	        });
	      } else {
	        var _ev = this.$stateParams.enquiry.enquiryVehicles[this.$stateParams.enquiry.enquiryVehicles.length - 1];
	
	        if (_ev && !this.$stateParams.enquiry.subject) {
	          this.$stateParams.enquiry.subject = _ev.vehicle.model + ' ' + _ev.vehicle.variant;
	        }
	
	        if (_ev && !this.$stateParams.enquiry.amountToSpend) {
	          this.$stateParams.enquiry.amountToSpend = _ev.vehicle.price;
	        }
	
	        if (this.$stateParams.enquiry.enquiryId) {
	          this.$state.go('enquiryEdit', {
	            enquiryId: this.$stateParams.enquiry.enquiryId,
	            enquiry: this.$stateParams.enquiry,
	            activeTab: 'vehicles'
	          });
	        } else {
	          this.$state.go('enquiryAdd', {
	            enquiry: this.$stateParams.enquiry,
	            activeTab: 'vehicles'
	          });
	        }
	      }
	    }
	  }, {
	    key: 'updateBrands',
	    value: function updateBrands(initialCondition) {
	      var condition = initialCondition || this.criteria.condition;
	
	      if (this.criteria.condition === 0) {
	        var locationBrandIds = this.authService.getLocationBrands(this.enums.PERMISSION_TYPE.View);
	        var allBrands = (0, _lodash.find)(locationBrandIds, function (o) {
	          return o === 1;
	        });
	
	        if (allBrands) {
	          this.brands = this.allBrands.map(function (b) {
	            return b;
	          }).splice(1);
	        } else {
	          this.brands = (0, _lodash.filter)(this.allBrands, function (o) {
	            return (0, _lodash.includes)(locationBrandIds, o.brandId);
	          });
	        }
	
	        this.criteria.brand = this.brands[0];
	        this.updateBrandModelPriceList();
	        this.filterRetailPriceLists();
	      } else {
	        this.brands = this.allBrands;
	        this.criteria.brand = this.brands[0];
	        this.updateBrandModel();
	        this.updateBodyTypes();
	      }
	    }
	  }, {
	    key: 'updateBodyTypes',
	    value: function updateBodyTypes() {
	      var _this9 = this;
	
	      if (this.criteria.condition === 0) {
	        var availableModels = (0, _lodash.filter)(this.allVehiclesPriceList, function (o) {
	          return o.brandModelId === _this9.criteria.brandModel.brandModelId;
	        });
	        var bodyTypeIds = (0, _lodash.filter)((0, _lodash.map)((0, _lodash.uniqBy)(availableModels, 'bodyTypeId'), function (o) {
	          return o.bodyTypeId;
	        }), function (o) {
	          return o;
	        });
	        this.selectOptions.bodyType = (0, _lodash.filter)(this.allBodyTypes, function (o) {
	          return (0, _lodash.includes)(bodyTypeIds, o.id);
	        });
	        this.selectOptions.bodyType.unshift({ id: null, name: 'Any Body Type' });
	        this.criteria.bodyType = this.selectOptions.bodyType[0].id;
	      } else {
	        this.selectOptions.bodyType = this.allBodyTypes;
	        this.criteria.bodyType = this.selectOptions.bodyType[0].id;
	      }
	    }
	  }, {
	    key: 'filterRetailPriceLists',
	    value: function filterRetailPriceLists() {
	      var selectedVehicles = (0, _lodash.filter)(this.allVehiclesPriceList, this.vehicleSelector.bind(this));
	
	      this.vehicles = selectedVehicles;
	      this.vehicle = this.vehicles[0];
	    }
	  }, {
	    key: 'vehicleSelector',
	    value: function vehicleSelector(v) {
	      var shouldSelect = false;
	
	      if (this.criteria.brandModel.brandModelId) {
	        shouldSelect = v.brandModelId === this.criteria.brandModel.brandModelId;
	      } else {
	        shouldSelect = true;
	      }
	
	      if (this.criteria.bodyType) {
	        shouldSelect &= v.bodyTypeId === this.criteria.bodyType;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.transmissionType) {
	        shouldSelect &= v.transmissionTypeId === this.criteria.transmissionType;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.fuelType) {
	        shouldSelect &= v.fuelTypeId === this.criteria.fuelType;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.fuelType) {
	        shouldSelect &= v.fuelTypeId === this.criteria.fuelType;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.capacityFrom) {
	        shouldSelect &= v.capacity >= this.criteria.capacityFrom;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.capacityTo) {
	        shouldSelect &= v.capacity <= this.criteria.capacityTo;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.priceFrom) {
	        shouldSelect &= v.price >= this.criteria.priceFrom;
	      } else {
	        shouldSelect &= true;
	      }
	
	      if (this.criteria.priceTo) {
	        shouldSelect &= v.price <= this.criteria.priceTo;
	      } else {
	        shouldSelect &= true;
	      }
	
	      return shouldSelect;
	    }
	  }, {
	    key: 'listDeliveryPriceList',
	    value: function listDeliveryPriceList() {
	      var _this10 = this;
	
	      this.deliveryPriceManagementService.listDeliveryPrices(this.$stateParams.enquiry.entityId).then(function (response) {
	        _this10.deliveryPriceList = response.data.items;
	      });
	    }
	  }, {
	    key: 'multi_selectUnselectVehicle',
	    value: function multi_selectUnselectVehicle(v) {
	      if (this.multi_isVehicleSelected(v)) {
	        this.selectedVehicles = (0, _lodash.without)(this.selectedVehicles, v);
	      } else {
	        this.selectedVehicles.push(v);
	      }
	    }
	  }, {
	    key: 'multi_isVehicleSelected',
	    value: function multi_isVehicleSelected(v) {
	      return (0, _lodash.find)(this.selectedVehicles, function (o) {
	        return o.vehicleId === v.vehicleId;
	      });
	    }
	  }, {
	    key: 'multiSelectVehicles',
	    value: function multiSelectVehicles() {
	      var _this11 = this,
	          _$stateParams$enquiry;
	
	      this.errMsg = '';
	
	      //If any vehicle outside for current location
	      var matching_External = (0, _lodash.filter)(this.searchVehicles, function (o) {
	        return o.entityId === _this11.authService.authData.currentLocation.key;
	      });
	      if (matching_External.length > 0) {
	        var sure = window.confirm('Certain vehicles are outside your current location. Are you sure you want to add them all?');
	        if (!sure) {
	          return;
	        }
	      }
	
	      //Check for duplicate vehicles
	      var dupVehicles = (0, _lodash.filter)(this.$stateParams.enquiry.enquiryVehicles, function (o) {
	        return (0, _lodash.find)(_this11.selectedVehicles, function (sv) {
	          return sv.vehicleId === o.vehicleId;
	        });
	      });
	      if (dupVehicles.length) {
	        this.errMsg = 'Thie following vehicles have already been added to the enquiry. ' + dupVehicles.map(function (v) {
	          return v.vehicle.registration;
	        }).toString();
	        return;
	      }
	
	      //Get the selected enquiry vehicles
	      var enquiryVehiclesToAdd = this.selectedVehicles.map(function (v) {
	        return {
	          vehicleId: v.vehicleId,
	          vehicle: v,
	          isSelected: true,
	          isRemoved: false
	        };
	      });
	
	      (_$stateParams$enquiry = this.$stateParams.enquiry.enquiryVehicles).push.apply(_$stateParams$enquiry, (0, _toConsumableArray3.default)(enquiryVehiclesToAdd));
	
	      //Set the enquiry subject
	      if (!this.$stateParams.enquiry.subject) {
	        this.$stateParams.enquiry.subject = 'Trade Deal';
	      }
	
	      this.$state.go('enquiryEdit', {
	        enquiryId: this.$stateParams.enquiry.enquiryId,
	        enquiry: this.$stateParams.enquiry,
	        activeTab: 'vehicles'
	      });
	    }
	  }]);
	  return VehicleViewController;
	}();
	
	exports.default = VehicleViewController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1066);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleView.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleView.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".hide-bullets{list-style:none;margin-left:-40px;margin-top:20px}.thumbnail{padding:0}.carousel-inner>.item>a>img,.carousel-inner>.item>img{width:100%}.selectedRow{background-color:var(--primary-color)!important}.mouse-pointer{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleEdit = __webpack_require__(1068);
	
	var _vehicleEdit2 = _interopRequireDefault(_vehicleEdit);
	
	var _vehicleInformation = __webpack_require__(1073);
	
	var _vehicleInformation2 = _interopRequireDefault(_vehicleInformation);
	
	var _vehiclePricing = __webpack_require__(1098);
	
	var _vehiclePricing2 = _interopRequireDefault(_vehiclePricing);
	
	var _vehicleDetails = __webpack_require__(1104);
	
	var _vehicleDetails2 = _interopRequireDefault(_vehicleDetails);
	
	var _vehicleImages = __webpack_require__(1110);
	
	var _vehicleImages2 = _interopRequireDefault(_vehicleImages);
	
	var _serviceHistory = __webpack_require__(1119);
	
	var _serviceHistory2 = _interopRequireDefault(_serviceHistory);
	
	var _tabs = __webpack_require__(1125);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleEditModule = _angular2.default.module('vehicleEdit', [_angularUiRouter2.default, _tabs2.default, _vehicleInformation2.default, _vehiclePricing2.default, _vehicleDetails2.default, _vehicleImages2.default, _serviceHistory2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleAdd', {
	    url: '/vehicle/add',
	    component: 'vehicleEdit',
	    params: {
	      origin: {}
	    }
	  });
	
	  $stateProvider.state('vehicleEdit', {
	    url: '/vehicle/edit/:vehicleId',
	    component: 'vehicleEdit',
	    params: {
	      origin: {}
	    }
	  });
	}]).component('vehicleEdit', _vehicleEdit2.default).name;
	
	exports.default = vehicleEditModule;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleEdit = __webpack_require__(1069);
	
	var _vehicleEdit2 = _interopRequireDefault(_vehicleEdit);
	
	var _vehicleEdit3 = __webpack_require__(1070);
	
	var _vehicleEdit4 = _interopRequireDefault(_vehicleEdit3);
	
	__webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleEdit2.default,
	  controller: _vehicleEdit4.default
	};
	
	exports.default = vehicleEditComponent;

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>{{$ctrl.$stateParams.vehicleId ? 'Edit Vehicle' : 'Add Vehicle'}}</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editVehicle()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n        <a\r\n          class=\"btn btn-warning\"\r\n          ng-hide=\"$ctrl.params.isEntityManagement\"\r\n          ng-click=\"$ctrl.redirectToParent()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n            Cancel\r\n        </a>\r\n\r\n        <a\r\n          class=\"btn btn-primary pull-right\"\r\n          ng-show=\"!$ctrl.params.isEntityManagement && $ctrl.vehicle.vehicleId && $ctrl.authService.hasEasierAd()\"\r\n          ng-click=\"$ctrl.updateExternal()\">\r\n            Update with Easier Ad\r\n        </a>        \r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"editVehicle\">\r\n    <div class=\"panel\">\r\n        <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n          <uib-tabset active=\"activeJustified\" justified=\"true\">\r\n            <uib-tab index=\"0\" heading=\"Vehicle Information\">\r\n              <vehicle-Information\r\n                vehicle=\"$ctrl.vehicle\"\r\n                extras=\"$ctrl.extras\"\r\n                form-validation-service=\"$ctrl.formValidationService\"\r\n                on-component-ready=\"$ctrl.childComponentsReady()\"\r\n                    on-easier-ad=\"$ctrl.easierAd()\"\r\n                on-lookup-vehicle-selected=\"$ctrl.onLookupVehicleSelected()\">\r\n              </vehicle-Information>\r\n            </uib-tab>\r\n\r\n            <uib-tab index=\"1\" heading=\"Vehicle Pricing\">\r\n              <vehicle-Pricing vehicle=\"$ctrl.vehicle\"></vehicle-Pricing>\r\n            </uib-tab>\r\n\r\n            <uib-tab index=\"2\" heading=\"Media\">\r\n              <vehicle-Images vehicle=\"$ctrl.vehicle\" form-validation-service=\"$ctrl.formValidationService\"></vehicle-Images>\r\n            </uib-tab>\r\n\r\n            <uib-tab index=\"3\" heading=\"Service History\">\r\n              <service-history vehicle=\"$ctrl.vehicle\"></service-history>\r\n            </uib-tab>            \r\n          </uib-tabset>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleEditController = function () {
	  VehicleEditController.$inject = ["authService", "vehicleService", "loadingService", "enums", "$state", "$stateParams", "$timeout", "lookupService", "utilsService", "$scope"];
	  function VehicleEditController(authService, vehicleService, loadingService, enums, $state, $stateParams, $timeout, lookupService, utilsService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleEditController);
	    var permissionToCheck = void 0;
	    if ($stateParams.vehicleId) {
	      permissionToCheck = enums.PERMISSION_TYPE.Edit;
	    } else {
	      permissionToCheck = enums.PERMISSION_TYPE.Add;
	    }
	    if (!authService.validateUser(false, 'Vehicle', permissionToCheck, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.vehicleService = vehicleService;
	    this.loadingService = loadingService;
	    this.formValidationService = new _FormValidationService2.default();
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.enums = enums;
	    this.lookupService = lookupService;
	    this.utilsService = utilsService;
	    this.$scope = $scope;
	
	    this.state = '';
	
	    this.vehicle = {
	      entityId: this.authService.authData.currentLocation.key,
	      notes: [],
	      extras: [],
	      mediaItems: [],
	      dueInStock: new Date()
	    };
	
	    this.origin = $stateParams.origin;
	
	    this.enumLookupCollection = [];
	    this.initializeEnumLookups();
	
	    this.keyValueFields = ['Annual Motor Tax', 'Number of Seats', 'Number of Doors', 'Country of Origin', 'Serial Number', 'Motor Tax Class', 'Previous Owners', 'Current Owners', 'Tax Expiry Date', 'NCT Certificate No', 'UK Reg', 'UK Previous Owners', 'NCT Expiry', 'Date First Registered in Ireland', 'CO2', 'NCT Pass Date'];
	
	    this.extras = {};
	
	    this.initializeExtras();
	  }
	
	  (0, _createClass3.default)(VehicleEditController, [{
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this = this;
	
	      var ctrl = this;
	      ctrl.selectDefaults = {};
	
	      var lookups = ['Color'];
	      this.enumLookupCollection = [];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        _this.enumLookupCollection = enumLookupCollection;
	      });
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.vehicle);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'vehicleCondition',
	        displayName: 'New or Used',
	        type: 'select',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'registration',
	        displayName: 'Registration',
	        type: 'text'
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'brandModelId',
	        displayName: 'Make and Model',
	        type: 'select',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'dueInStock',
	        displayName: 'Due In Stock',
	        type: 'datetime',
	        allowPastDate: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'capacity',
	        displayName: 'Engine Capacity',
	        type: 'int',
	        range: {
	          min: 0,
	          max: 9999
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'year',
	        displayName: 'Year',
	        type: 'int',
	        range: {
	          min: 1950,
	          max: new Date().getFullYear() + 2
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'reconCost',
	        displayName: 'Recon Cost',
	        type: 'float'
	      });
	    }
	  }, {
	    key: 'loadVehicle',
	    value: function loadVehicle() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      this.configureForm();
	
	      if (ctrl.$stateParams.vehicleId) {
	        ctrl.loadingService.showLoading('editVehicle', 'Loading Vehicle ...');
	
	        ctrl.vehicleService.getVehicle(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.vehicleId).then(function (response) {
	          (0, _assign2.default)(ctrl.vehicle, response.data);
	
	          ctrl.vehicle.firstRegistration = ctrl.utilsService.getDatePart(ctrl.vehicle.firstRegistration);
	          ctrl.vehicle.dueInStock = ctrl.utilsService.getDatePart(ctrl.vehicle.dueInStock);
	
	          _this2.configureForm();
	
	          _this2.populateExtras();
	
	          _this2.showMazdaServiceHistory();
	          _this2.$scope.$broadcast('vehicle:initialized');
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('editVehicle');
	        });
	      }
	    }
	  }, {
	    key: 'editVehicle',
	    value: function editVehicle() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editVehicle', 'Saving Changes ...');
	
	      //massage data
	      if (typeof ctrl.vehicle.brandModel === 'string') {
	        ctrl.vehicle.brandModel = null;
	      }
	
	      //Convert New Extras Format into Vehicle Extras
	      this.convertToVehicleExtras();
	
	      //Get the Images in Right Order
	      this.getImagesInOrder();
	
	      ctrl.vehicleService.editVehicle(ctrl.vehicle).then(function (response) {
	        _this3.state = 'Saved';
	        var vehicleConditionSearch = null;
	
	        if (ctrl.vehicle.vehicleCondition === ctrl.enums.VEHICLE_CONDITION.New) {
	          vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.New;
	        } else {
	          if (ctrl.vehicle.autoSold === ctrl.enums.AUTO_SOLD.Retail) {
	            vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.UsedRetail;
	          } else {
	            vehicleConditionSearch = ctrl.enums.VEHICLE_CONDITION_SEARCH.UsedTrade;
	          }
	        }
	
	        ctrl.redirectToParent(vehicleConditionSearch, response.data);
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editVehicle');
	      });
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(vehicleConditionSearch, vehicleId) {
	      if (!this.origin.source) {
	        this.$state.go('vehicleList', { vehicleConditionSearch: vehicleConditionSearch });
	      } else if (this.origin.source === 'enquiry') {
	        this.$state.go('enquiryEdit', {
	          enquiryId: this.origin.enquiryId,
	          activeTab: 'vehicles'
	        });
	      } else if (this.origin.source === 'editFinance') {
	        this.$state.go('financeEdit', {
	          financeId: this.origin.financeId
	        });
	      } else if (this.origin.source === 'vehiclePublish') {
	        this.$state.go('vehiclePublish');
	      } else {
	        var output = this.origin.processResult(vehicleId, this.vehicle);
	
	        this.$state.go(output.stateName, output.params);
	      }
	    }
	  }, {
	    key: 'childComponentsReady',
	    value: function childComponentsReady() {
	      this.loadVehicle();
	    }
	  }, {
	    key: 'easierAd',
	    value: function easierAd() {
	      this.vehicleService.easierAd(this.authService.authData.currentLocation.key);
	    }
	  }, {
	    key: 'updateExternal',
	    value: function updateExternal() {
	      var _this4 = this;
	
	      if (this.vehicle.vehicleId) {
	        var color = '';
	
	        if (this.vehicle.color) {
	          color = (0, _lodash.find)(this.enumLookupCollection.color, function (o) {
	            return o.id === _this4.vehicle.color;
	          }).name;
	        }
	
	        this.$state.go('vehicleEditSkupenet', {
	          skupenetId: this.vehicle.skupenetId,
	          price: this.vehicle.price,
	          color: color
	        });
	      } else {
	        this.$state.go('vehicleAddSkupenet', {
	          registration: this.vehicle.registration,
	          vehicleCondition: this.vehicle.vehicleCondition === this.enums.VEHICLE_CONDITION.Used ? this.enums.VEHICLE_CONDITION.Used : this.enums.VEHICLE_CONDITION.New,
	          autoSold: this.vehicle.autoSold,
	          vehicleStatus: this.vehicle.state
	        });
	      }
	    }
	  }, {
	    key: 'initializeExtras',
	    value: function initializeExtras() {
	      var _this5 = this;
	
	      this.keyValueFields.map(function (field) {
	        _this5.extras[field] = null;
	      });
	    }
	  }, {
	    key: 'populateExtras',
	    value: function populateExtras() {
	      var _this6 = this;
	
	      if (this.vehicle && this.vehicle.extras.length) {
	        this.vehicle.extras.map(function (ext) {
	          _this6.extras[ext.key] = ext.value;
	        });
	      }
	    }
	  }, {
	    key: 'convertToVehicleExtras',
	    value: function convertToVehicleExtras() {
	      var _this7 = this;
	
	      (0, _lodash.map)(this.extras, function (val, key) {
	
	        var vehExt = (0, _lodash.find)(_this7.vehicle.extras, function (o) {
	          return o.key === key;
	        });
	
	        /*
	        * Case1: If Vehicle Extra Exists and value is not null
	        * Update the Vehicle Extra with the new Value
	        * */
	        if (vehExt && val) {
	          vehExt.value = val;
	        }
	
	        /*
	        * Case2: If Vehicle Extra Exists and value is null
	        * User wants to remove the Vehicle Extra Value
	        * So we can remove it from the final list 
	        * as it will not be saved back in db and save some space
	        * */
	        if (vehExt && !val) {
	          _this7.vehicle.extras = (0, _lodash.without)(_this7.vehicle.extras, vehExt);
	        }
	
	        /*
	        * Case3: If Vehicle Extra Does Not Exists and value is not null
	        * User wants to enter a new Extra so we need to add it to the collection
	        * */
	        if (!vehExt && val) {
	          _this7.vehicle.extras.push({
	            key: key,
	            value: val
	          });
	        }
	
	        /*
	        * Case4: If Vehicle Extra Does Not Exists and value is null
	        * No need to do anything here
	        * */
	      });
	    }
	  }, {
	    key: 'getImagesInOrder',
	    value: function getImagesInOrder() {
	      var _this8 = this;
	
	      if (this.vehicle.mediaItems && this.vehicle.mediaItems.length) {
	        var video = (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
	          return mi.mediaType === _this8.enums.MEDIA_TYPE.Youtube;
	        });
	        var mediaItems = [];
	
	        var $imagesInOrder = $('.imgGallery');
	
	        (0, _lodash.map)($imagesInOrder, function (el, ind) {
	          var imgUrl = $(el).attr('src');
	          var img = (0, _lodash.find)(_this8.vehicle.mediaItems, function (mi) {
	            return mi.url === imgUrl;
	          });
	
	          if (!img) {
	            img = (0, _lodash.find)(_this8.vehicle.mediaItems, function (mi) {
	              return mi.tempUrl === imgUrl;
	            });
	          }
	
	          img.order = ind + 1;
	          img.isCover = false;
	
	          mediaItems.push(img);
	        });
	
	        if (video) {
	          mediaItems.push(video);
	        }
	
	        //Set The First Image as Cover Image
	        var firstImage = (0, _lodash.find)(mediaItems, function (mi) {
	          return mi.mediaType === _this8.enums.MEDIA_TYPE.Image || mi.mediaType === _this8.enums.MEDIA_TYPE.ExternalImage;
	        });
	        if (firstImage) {
	          firstImage.isCover = true;
	        }
	
	        this.vehicle.mediaItems = mediaItems;
	      }
	    }
	  }, {
	    key: 'onLookupVehicleSelected',
	    value: function onLookupVehicleSelected() {
	      this.populateExtras();
	      this.showMazdaServiceHistory();
	    }
	  }, {
	    key: 'showMazdaServiceHistory',
	    value: function showMazdaServiceHistory() {
	      var _this9 = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        var mazdaBrand = (0, _lodash.find)(brands, function (b) {
	          return b.name.toLowerCase() === 'mazda';
	        });
	
	        _this9.$scope.$broadcast('vehicleEdit:lookupVehicleSelected', { chassisNo: _this9.vehicle.chassisNo, isMazda: _this9.vehicle.brandId == mazdaBrand.brandId });
	      });
	    }
	  }]);
	  return VehicleEditController;
	}();
	
	exports.default = VehicleEditController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1072);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleEdit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleEdit{color:red}", ""]);
	
	// exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleInformation = __webpack_require__(1074);
	
	var _vehicleInformation2 = _interopRequireDefault(_vehicleInformation);
	
	var _datePickerPopup = __webpack_require__(1080);
	
	var _datePickerPopup2 = _interopRequireDefault(_datePickerPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleInformationModule = _angular2.default.module('vehicleInformation', [_angularUiRouter2.default, _datePickerPopup2.default]).component('vehicleInformation', _vehicleInformation2.default).name;
	
	exports.default = vehicleInformationModule;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleInformation = __webpack_require__(1075);
	
	var _vehicleInformation2 = _interopRequireDefault(_vehicleInformation);
	
	var _vehicleInformation3 = __webpack_require__(1076);
	
	var _vehicleInformation4 = _interopRequireDefault(_vehicleInformation3);
	
	__webpack_require__(1078);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleInformationComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '=',
	    extras: '=',
	    formValidationService: '<',
	    onComponentReady: '&',
	    onEasierAd: '&',
	    onLookupVehicleSelected: '&'
	  },
	  template: _vehicleInformation2.default,
	  controller: _vehicleInformation4.default
	};
	
	exports.default = vehicleInformationComponent;

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehicleInfo\">    \r\n  <uib-accordion close-others=\"true\">\r\n\r\n    <!-- Basic Begin -->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.basic.visible\">\r\n      <uib-accordion-heading>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-11\">\r\n            Vehicle Details\r\n          </div>\r\n          <div class=\"col-md-1\">\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.basic.visible, 'glyphicon-chevron-down': !$ctrl.panels.basic.visible}\"></i>\r\n          </div>\r\n        </div>\r\n      </uib-accordion-heading>\r\n\r\n    <!-- New Used / Publish to Web -->\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.vehicleCondition }\">\r\n            <label class=\"control-label col-sm-4\">New or Used *</label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"         \r\n                ng-disabled=\"$ctrl.vehicle.vehicleId\"   \r\n                ng-change=\"$ctrl.updateModelFromSelect('vehicleCondition')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleCondition track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.vehicleCondition\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <label class=\"control-label col-sm-4\">Publish To Web</label>\r\n          <div class=\"col-sm-8 checkbox no-margin\">\r\n              <switch ng-model=\"$ctrl.vehicle.publishToWeb\"></switch>\r\n          </div>          \r\n        </div>        \r\n      </div>  \r\n\r\n      <!-- Search Vehicle from Price List -->\r\n      <div class=\"form-group\" ng-show=\"$ctrl.selectDefaults.vehicleCondition.id === 3\">\r\n        <label class=\"control-label col-sm-2\">Search Vehicle</label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"input-group\">\r\n            <div angucomplete-alt\r\n              placeholder=\"Search Vehicle by Make, Model or Variant\"\r\n              id=\"searchVehicle\"\r\n              selected-object=\"$ctrl.vehicleSelected\"\r\n              remote-url=\"{{$ctrl.searchRetailPriceListUrl}}\"\r\n              title-field=\"brandName,brandModelName,variant\"\r\n              minlength=\"2\"\r\n              input-class=\"form-control form-control-small\"\r\n              initial-value = \"$ctrl.initialCompanyName\"\r\n              match-class=\"autocomplete-highlight\">\r\n            </div>\r\n            <a class=\"input-group-addon btn btn-primary btn-small\" ng-click=\"$ctrl.clearVehicle()\" ng-if=\"$ctrl.authService.checkFeatureAccess('Company', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n              <span class=\"glyphicon glyphicon-remove\"></span>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div> \r\n\r\n      <!-- Registration / Number of Seats -->\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">\r\n          <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Registration</img>\r\n          <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n        </label>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.registration\" placeholder=\"Enter vehicle registration\" maxLength=\"20\" input-restrictor>\r\n\r\n              <a class=\"input-group-addon btn btn-default btn-small\" \r\n                ng-disabled=\"$ctrl.vehicle.vehicleId\"   \r\n                ng-show=\"$ctrl.authService.authData.currentLocation.lookupEnabled\"\r\n                ng-click=\"$ctrl.lookupVehicle()\"\r\n                ng-class=\"{'disabled' : !$ctrl.selectDefaults.vehicleCondition.id || $ctrl.selectDefaults.vehicleCondition.id === 3 || !$ctrl.vehicle.registration}\">\r\n                <span class=\"fa fa-search\"></span>\r\n              </a>\r\n            </div>                    \r\n        </div>\r\n\r\n        <label class=\"control-label col-sm-2\">\r\n          Number of Seats\r\n          <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n        </label>\r\n        <div class=\"col-sm-4\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Number of Seats']\" placeholder=\"number of seats\">\r\n        </div>\r\n      </div>    \r\n\r\n      <!-- Year / Number of Doors -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.year }\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Year\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n\r\n            <div class=\"col-sm-8\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.vehicle.year\" placeholder=\"Enter year of the vehicle\" maxlength=\"4\">\r\n            </div>\r\n          </div>                \r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Number of Doors\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Number of Doors']\" placeholder=\"number of doors\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Brand / BodyType -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.brandModelId }\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Make *</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                ng-disabled=\"$ctrl.vehicle.vehicleId\"   \r\n                class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                ng-model=\"$ctrl.selectDefaults.brand\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Body Type\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('vehicleBodyType')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleBodyType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.vehicleBodyType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>        \r\n      </div>  \r\n\r\n      <!-- Brand Model / Transmission Type -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.brandModelId }\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Model *</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-disabled=\"$ctrl.vehicle.vehicleId\"   \r\n                ng-change=\"$ctrl.updateModelFromSelect('brandModelId','brandModel','brandModelId')\"\r\n                ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                ng-model=\"$ctrl.selectDefaults.brandModel\">\r\n              </select>\r\n            </div>\r\n          </div>   \r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Transmission Type\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('transmissionType')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.transmissionType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.transmissionType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>        \r\n      </div>   \r\n      \r\n      <!-- Variant / NCT Expiry -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Variant</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.variant\" placeholder=\"Enter vehicle variant\" maxLength=50>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              NCT Expiry\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['NCT Expiry']\" placeholder=\"nct expiry\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Variant Code / Tax Expiry -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Variant Code</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.variantCode\" placeholder=\"Enter vehicle variant code\" maxLength=50>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Tax Expiry</label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Tax Expiry Date']\" placeholder=\"tax expiry\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>  \r\n      \r\n      <!-- Trim / Annual Motor Tax -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Trim</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.trim\" placeholder=\"Enter Trim\" maxLength=\"50\">\r\n            </div>\r\n          </div>            \r\n        </div>\r\n\r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Annual Motor Tax</label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Annual Motor Tax']\" placeholder=\"annual motor tax amount\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div> \r\n      \r\n      <!-- Engine Capacity / Previous Owners Ireland -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.capacity }\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Capacity</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.vehicle.capacity\" placeholder=\"Enter capacity of the engine\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Prev Irish Owners\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Previous Owners']\" placeholder=\"Previous Owners\" ng-readonly=\"true\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>     \r\n      \r\n      <!-- Color / Current Irish Owners Ireland -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Colour</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('color')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.color track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.color\">\r\n              </select>\r\n            </div>\r\n          </div> \r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n              <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Current Irish Owners</img>\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Current Owners']\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>\r\n\r\n      <!-- Color Shade / Featured -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">              \r\n                  <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Colour Shade</img>\r\n                  <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.colorShade\" placeholder=\"Enter colour shade\" maxLength=\"30\">\r\n              </div>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Featured\r\n              <sup title=\"This field is sent to Stock Loader. Max of 5 allowed only at one time\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-8 checkbox no-margin\">\r\n                <switch ng-model=\"$ctrl.vehicle.featured\"></switch>                \r\n            </div>                      \r\n          </div>\t\r\n        </div>\t\r\n      </div>\r\n\r\n      <!-- Price / Web Price -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Price</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.vehicle.price\">\r\n            </div>\r\n          </div>            \r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                Web Price\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.vehicle.webPrice\">\r\n            </div>\r\n          </div>            \r\n        </div>\r\n      </div>  \r\n      \r\n      <!-- Fuel Type / NCT Pass Date -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Fuel Type</img>\r\n                <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('fuelType')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.fuelType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.fuelType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">          \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">NCT Pass Date</label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['NCT Pass Date']\" placeholder=\"NCT Pass Date\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Chassis No / Est. Recon Cost -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Chassis No</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.chassisNo\" placeholder=\"Enter chassis number\" maxLength=20>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Estimated Recon Cost</label>\r\n            <div class=\"col-sm-8\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.vehicle.estReconCost\" readonly>\r\n            </div>\r\n          </div>\r\n        </div>\t\r\n      </div>   \r\n      \r\n      <!-- Engine No / Actual Recon Cost -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Engine No</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.vehicle.engineNo\" placeholder=\"Enter Engine No\" maxLength=50>\r\n            </div>\r\n          </div>      \r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.reconCost }\">\r\n            <label class=\"control-label col-sm-4\">Actual Recon Cost</label>\r\n            <div class=\"col-sm-8\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.vehicle.reconCost\" placeholder=\"Enter the Actual Reconditioning Cost\">\r\n            </div>\r\n          </div>\r\n        </div>\t\r\n      </div> \r\n      \r\n      <!-- Mileage Type / Sale Type -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">\r\n              Mileage Type\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n            </label>\r\n            \r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('mileageType')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.mileageType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.mileageType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Sale Type</label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('autoSold')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.autoSold track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.autoSold\">\r\n              </select>\r\n            </div>\r\n          </div>\t\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Mileage / UK Previous Owners -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">              \r\n                  <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Mileage</img>\r\n                  <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.vehicle.mileage\" placeholder=\"Enter vehicle mileage\" maxLength=\"20\">\r\n              </div>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">UK Previous Owners</label>\r\n            <div class=\"col-sm-8\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.extras['UK Previous Owners']\" placeholder=\"UK Previous Owners\">\r\n            </div>\r\n          </div>\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Due In Stock / UK Reg -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Due In Stock</label>\r\n            <div class=\"col-sm-8\">\r\n              <p class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('dueInStock')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.vehicle.dueInStock\" is-open=\"$ctrl.dtPopups.dueInStock\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('dueInStock')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                </span>\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">UK Reg</label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['UK Reg']\" placeholder=\"UK Reg\">\r\n            </div>          \r\n          </div>\r\n        </div>\t\r\n      </div>    \r\n      \r\n      <!-- First Registered / First Irish Registration -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">First Registration</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <p class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('firstReg')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.vehicle.firstRegistration\" is-open=\"$ctrl.dtPopups.firstReg\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('firstReg')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                </span>\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">First Irish Registration</label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Date First Registered in Ireland']\" placeholder=\"First Registered in Ireland\">\r\n            </div>            \r\n          </div>\t\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Country of Origin / Status -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Country of Origin</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['Country of Origin']\" placeholder=\"Country of Origin\">\r\n            </div>            \r\n          </div>\t            \r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Status</label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-disabled=\"$ctrl.vehicle.vehicleId\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('state', 'vehicleStatus')\"\r\n                ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleStatus track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.vehicleStatus\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Other / Location -->\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\t\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">Location</label>\r\n            <div class=\"col-sm-8\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-options=\"item.key as item.value for item in $ctrl.myLocations\"\r\n                ng-model=\"$ctrl.vehicle.entityId\">\r\n              </select>\r\n            </div>\r\n          </div>  \r\n        </div>\r\n        \r\n        <div class=\"col-md-6\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-4\">              \r\n                <img title=\"This field appears in the Order Form\" src=\"/images/simi.gif\" class=\"simi-field-indicator\" ng-show=\"$ctrl.authService.isSimi()\">Other</img>\r\n            </label>\r\n            <div class=\"col-sm-8\">\r\n              <textarea class=\"form-control\" ng-model=\"$ctrl.vehicle.other\" placeholder=\"other details\" maxLength=\"250\"></textarea>\r\n            </div>\r\n          </div>\t\r\n        </div>\t\r\n      </div>      \r\n\r\n      <!-- Website Descipriont -->\r\n      <div class=\"row\">          \r\n        <div class=\"col-md-12\">\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">\r\n              Website Description\r\n              <sup title=\"This field is sent to Stock Loader\" ng-show=\"$ctrl.authService.hasStockLoader()\">SL</sup>          \r\n            </label>\r\n            <div class=\"col-sm-10\">\r\n              <textarea class=\"form-control\" ng-model=\"$ctrl.vehicle.websiteDescription\" placeholder=\"Enter description for this vehicle to go up on Sale\" maxLength=\"1000\" rows=\"5\"></textarea>\r\n            </div>\r\n          </div>\r\n        </div>\t\r\n      </div>       \r\n    </div>\r\n    <!-- Basic End -->\r\n\r\n    <!-- More Begin -->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.more.visible\">\r\n      <uib-accordion-heading>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-11\">\r\n            Show More\r\n          </div>\r\n          <div class=\"col-md-1\">\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.more.visible, 'glyphicon-chevron-down': !$ctrl.panels.more.visible}\"></i>\r\n          </div>\r\n        </div>\r\n      </uib-accordion-heading>\r\n\r\n              <!-- Serial No / CO2 -->\r\n              <div class=\"row\">\r\n                  <div class=\"col-md-6\">\t\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">Serial Number</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <input class=\"form-control\" ng-model=\"$ctrl.extras['Serial Number']\" placeholder=\"Serial Number\">\r\n                      </div>\r\n                    </div>                \r\n                  </div>\r\n          \r\n                  <div class=\"col-md-6\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">CO2</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['CO2']\" placeholder=\"CO2\">\r\n                      </div>          \r\n                    </div>\r\n                  </div>\t\r\n                </div>    \r\n                \r\n                <!-- Motor Tax Class / NCT Certificate Number -->\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-6\">\t\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">Motor Tax Class</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <input class=\"form-control\" ng-model=\"$ctrl.extras['Motor Tax Class']\" placeholder=\"Motor Tax Class\">\r\n                      </div>\r\n                    </div>                \r\n                  </div>\r\n          \r\n                  <div class=\"col-md-6\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">NCT Certificate No</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.extras['NCT Certificate No']\" placeholder=\"NCT Certificate No\">\r\n                      </div>          \r\n                    </div>\r\n                  </div>\t\r\n                </div>  \r\n                \r\n                <!-- GMFV / Proposed Mileage -->\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-6\">\t\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">GMFV</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.vehicle.gmfv\" placeholder=\"Enter vehicle GMFV\">\r\n                      </div>                \r\n                    </div>\r\n                  </div>\r\n                  \r\n                  <div class=\"col-md-6\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">Proposed Mileage</label>\r\n                      <div class=\"col-sm-8\">\r\n                          <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.vehicle.proposedMileage\" placeholder=\"Enter Propose Mileage against GMFV\" maxLength=20>\r\n                      </div>                \r\n                    </div>\t\r\n                  </div>\t\r\n                </div>                       \r\n                \r\n                <!-- Vehicle Type / AdId -->\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-6\">\t\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">Vehicle Type</label>\r\n                      <div class=\"col-sm-8\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-change=\"$ctrl.updateModelFromSelect('vehicleType')\"\r\n                          ng-options=\"item.name for item in $ctrl.enumLookupCollection.vehicleType track by item.id\"\r\n                          ng-model=\"$ctrl.selectDefaults.vehicleType\">\r\n                        </select>\r\n                      </div>\r\n                    </div>                       \r\n                  </div>\r\n\r\n                  <div class=\"col-md-6\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-4\">Ad Id</label>\r\n                      <div class=\"col-sm-8\">\r\n                          <input class=\"form-control\" ng-model=\"$ctrl.vehicle.adId\" placeholder=\"Enter external ad id for the vehicle\" maxLength=20>\r\n                      </div>                \r\n                    </div>\t\r\n                  </div>\t                  \r\n                </div>        \r\n    </div>\r\n    <!-- More End -->   \r\n\r\n    <!-- Notes Begin -->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.notes.visible\">\r\n      <uib-accordion-heading>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-11\">\r\n            Notes\r\n          </div>\r\n          <div class=\"col-md-1\">\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.notes.visible, 'glyphicon-chevron-down': !$ctrl.panels.notes.visible}\"></i>\r\n          </div>\r\n        </div>\r\n      </uib-accordion-heading>\r\n\r\n      <notes notes-Collection=\"$ctrl.vehicle.notes\" />\r\n    </div>\r\n    <!-- Notes End -->\r\n\r\n  </uib-accordion>\r\n</div>\r\n\r\n"

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _isInteger = __webpack_require__(880);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _vehicleLookupModal = __webpack_require__(1077);
	
	var _vehicleLookupModal2 = _interopRequireDefault(_vehicleLookupModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleInformationController = function () {
	  VehicleInformationController.$inject = ["lookupService", "authService", "enums", "$q", "loadingService", "$uibModal", "$scope", "appConfig"];
	  function VehicleInformationController(lookupService, authService, enums, $q, loadingService, $uibModal, $scope, appConfig) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VehicleInformationController);
	    this.lookupService = lookupService;
	    this.authService = authService;
	    this.enums = enums;
	    this.$q = $q;
	    this.loadingService = loadingService;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	
	    this.initializeEnumLookups();
	    this.initializeMyLocations();
	
	    this.searchRetailPriceListUrl = appConfig.apiServiceBaseUri + 'api/retailPriceList/search/';
	
	    this.dtPopups = {}; //Cleanup
	
	    this.panels = {
	      vehicleInformation: true
	    };
	
	    this.panels = [];
	    this.panels['basic'] = { visible: true };
	    this.panels['more'] = { visible: false };
	    this.panels['notes'] = { visible: false };
	
	    $scope.selectVehicle = this.selectVehicle.bind(this);
	    this.vehicleSelected = this.vehicleSelected.bind(this);
	
	    $scope.$watch("$ctrl.extras['Previous Owners']", function (newValue, oldValue) {
	      if (newValue && (0, _isInteger2.default)(parseInt(newValue))) {
	        if (!_this.extras['Current Owners']) {
	          _this.extras['Current Owners'] = parseInt(newValue) + 1;
	        }
	      } else {
	        _this.extras['Current Owners'] = null;
	      }
	    });
	
	    this.$scope.$on('vehicle:initialized', this.updateSelectDefaults.bind(this));
	  }
	
	  (0, _createClass3.default)(VehicleInformationController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var updateBrandModels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      if (!ctrl.selectDefaults.vehicleCondition.id) {
	        this.brands = [];
	        this.selectDefaults.brand = null;
	        this.brandModels = [];
	        this.selectDefaults.brandModel = null;
	        return;
	      }
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        //Remove 'All Brands' item from this list
	        brands.shift();
	
	        _this2.allBrands = brands;
	
	        //If New Vehicle then filter brands with only allowed brands on roles in this location
	        if (ctrl.selectDefaults.vehicleCondition.id === 1) {
	          var allowedBrands = ctrl.authService.getLocationBrands(ctrl.enums.PERMISSION_TYPE.Add);
	          var hasAllBrand = (0, _lodash.find)(allowedBrands, function (brandId) {
	            return brandId === 1;
	          });
	
	          if (hasAllBrand) {
	            _this2.brands = brands;
	          } else {
	            _this2.brands = (0, _lodash.filter)(brands, function (o) {
	              return (0, _lodash.find)(allowedBrands, function (brandId) {
	                return brandId === o.brandId;
	              }) !== undefined;
	            });
	          }
	        } else {
	          _this2.brands = brands;
	        }
	
	        _this2.selectDefaults.brand = _this2.brands[0];
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          if (updateBrandModels) {
	            _this2.updateBrandModel();
	          }
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this3 = this;
	
	      var ctrl = this;
	      ctrl.selectDefaults = {};
	
	      var lookups = ['VehicleType', 'AutoSold', 'MileageType', 'VehicleCondition', 'VehicleBodyType', 'Color', 'FuelType', 'TransmissionType', 'VehicleStatus'];
	      this.enumLookupCollection = [];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        if (enumLookupCollection.vehicleBodyType) {
	          //Sort Vehicle Body List Bug Id 3263
	          enumLookupCollection.vehicleBodyType = (0, _lodash.sortBy)(enumLookupCollection.vehicleBodyType, function (o) {
	            return o.name;
	          });
	        }
	
	        _this3.enumLookupCollection = enumLookupCollection;
	
	        (0, _lodash.map)(enumLookupCollection, function (itemsArray, index) {
	          //Add New for Price List option
	          if (index === 'vehicleCondition') {
	            itemsArray.unshift({ id: 3, name: 'New (From Price List)' });
	          }
	
	          //Add the Please Select option for the Dropdowns
	          if (index !== 'vehicleType' && index !== 'autoSold') {
	            itemsArray.unshift({ id: null, name: 'Please Select' });
	          }
	
	          _this3.selectDefaults[index] = itemsArray[0];
	
	          _this3.updateModelFromSelect(index);
	        });
	
	        //First Component Ready
	        _this3.onComponentReady();
	      });
	    }
	  }, {
	    key: 'initializeMyLocations',
	    value: function initializeMyLocations() {
	      var _this4 = this;
	
	      this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key).then(function (response) {
	        _this4.myLocations = response.data;
	      });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(id) {
	      this.dtPopups[id] = true;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this5 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this5.selectDefaults.brand.brandId;
	      });
	      this.selectDefaults.brandModel = this.brandModels[0];
	      this.updateModelFromSelect('brandModelId', 'brandModel', 'brandModelId');
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      this.vehicle[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];
	
	      if (modelProperty === 'vehicleCondition') {
	        this.initializeLookups();
	      }
	    }
	  }, {
	    key: 'updateSelectDefaults',
	    value: function updateSelectDefaults() {
	      var ctrl = this;
	
	      (0, _lodash.map)(ctrl.selectDefaults, function (index, item) {
	        var editSelectDefault = void 0;
	
	        if (item === 'vehicleStatus') {
	          editSelectDefault = (0, _lodash.find)(ctrl.enumLookupCollection[item], function (o) {
	            return o.id === ctrl.vehicle.state;
	          });
	        } else {
	          editSelectDefault = (0, _lodash.find)(ctrl.enumLookupCollection[item], function (o) {
	            return o.id === ctrl.vehicle[item];
	          });
	        }
	
	        if (editSelectDefault) {
	          ctrl.selectDefaults[item] = editSelectDefault;
	        } else {
	          if (ctrl.enumLookupCollection[item]) {
	            ctrl.selectDefaults[item] = ctrl.enumLookupCollection[item][0];
	          }
	        }
	      });
	      ctrl.initializeLookups(false).then(function () {
	        var editBrand = (0, _lodash.find)(ctrl.brands, function (o) {
	          return o.brandId === ctrl.vehicle.brandId;
	        });
	        ctrl.selectDefaults.brand = editBrand;
	
	        var tempBrandModelId = ctrl.vehicle.brandModelId;
	        ctrl.updateBrandModel();
	        var editBrandModel = (0, _lodash.find)(ctrl.brandModels, function (o) {
	          return o.brandModelId === tempBrandModelId;
	        });
	        ctrl.selectDefaults.brandModel = editBrandModel;
	        ctrl.updateModelFromSelect('brandModelId', 'brandModel', 'brandModelId');
	      });
	    }
	  }, {
	    key: 'lookupVehicle',
	    value: function lookupVehicle() {
	      var ctrl = this;
	
	      if (ctrl.selectDefaults.vehicleCondition.id === 0 || !ctrl.vehicle.registration) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle Information');
	
	      ctrl.lookupService.lookupVehicleByRegNo(ctrl.authService.authData.currentLocation.key, ctrl.vehicle.vehicleCondition, ctrl.vehicle.registration).then(function (response) {
	        ctrl.$scope.lookupData = ctrl.getVehicleViewModel(response.data);
	        ctrl.$scope.brandModels = ctrl.getBrandModels(response.data.brandId);
	        ctrl.$scope.errMsg = '';
	        ctrl.lookupModalInstance = ctrl.$uibModal.open({
	          template: _vehicleLookupModal2.default,
	          scope: ctrl.$scope
	        });
	      }).catch(function (err) {
	        if (err.status === 500) {
	          ctrl.$scope.lookupData = {};
	          ctrl.$scope.errMsg = err.data.exceptionMessage;
	          ctrl.lookupModalInstance = ctrl.$uibModal.open({
	            template: _vehicleLookupModal2.default,
	            scope: ctrl.$scope
	          });
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleInfo');
	      });
	    }
	  }, {
	    key: 'getVehicleViewModel',
	    value: function getVehicleViewModel(vehicleEditViewModel) {
	      var vehicleVM = {};
	
	      vehicleVM.make = (0, _lodash.find)(this.allBrands, function (o) {
	        return o.brandId === vehicleEditViewModel.brandId;
	      }).name;
	      vehicleVM.brandId = vehicleEditViewModel.brandId;
	
	      vehicleVM.model = vehicleEditViewModel.brandModelId ? (0, _lodash.find)(this.allBrandModels, function (o) {
	        return o.brandModelId === vehicleEditViewModel.brandModelId;
	      }).name : '';
	      vehicleVM.brandModelId = vehicleEditViewModel.brandModelId;
	
	      vehicleVM.variant = vehicleEditViewModel.variant;
	      vehicleVM.variantCode = vehicleEditViewModel.variantCode;
	      vehicleVM.registration = vehicleEditViewModel.registration;
	      vehicleVM.chassisNo = vehicleEditViewModel.chassisNo;
	      vehicleVM.engineNo = vehicleEditViewModel.engineNo;
	      vehicleVM.firstRegistration = vehicleEditViewModel.firstRegistration;
	
	      vehicleVM.year = vehicleEditViewModel.year;
	
	      if (vehicleEditViewModel.capacity && vehicleEditViewModel.capacity.toString().length === 1) {
	        vehicleVM.capacity = vehicleEditViewModel.capacity + '.0';
	      } else {
	        vehicleVM.capacity = vehicleEditViewModel.capacity;
	      }
	
	      vehicleVM.color = vehicleEditViewModel.color;
	      vehicleVM.colorName = (0, _lodash.find)(this.enumLookupCollection.color, function (o) {
	        return o.id === vehicleEditViewModel.color;
	      }).name;
	
	      vehicleVM.vehicleBodyType = vehicleEditViewModel.vehicleBodyType;
	      vehicleVM.vehicleBodyTypeName = (0, _lodash.find)(this.enumLookupCollection.vehicleBodyType, function (o) {
	        return o.id === vehicleEditViewModel.vehicleBodyType;
	      }).name;
	
	      vehicleVM.transmissionType = vehicleEditViewModel.transmissionType;
	      vehicleVM.transmissionTypeName = (0, _lodash.find)(this.enumLookupCollection.transmissionType, function (o) {
	        return o.id === vehicleEditViewModel.transmissionType;
	      }).name;
	
	      vehicleVM.fuelType = vehicleEditViewModel.fuelType;
	      vehicleVM.fuelTypeName = (0, _lodash.find)(this.enumLookupCollection.fuelType, function (o) {
	        return o.id === vehicleEditViewModel.fuelType;
	      }).name;
	
	      vehicleVM.extras = vehicleEditViewModel.extras;
	
	      return vehicleVM;
	    }
	  }, {
	    key: 'getBrandModels',
	    value: function getBrandModels(brandId) {
	      var brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === brandId;
	      });
	
	      brandModels.unshift({ brandModelId: null, brandId: brandId, name: 'Please Select' });
	
	      return brandModels;
	    }
	  }, {
	    key: 'selectVehicle',
	    value: function selectVehicle(update) {
	      var ctrl = this;
	
	      if (update) {
	        if (!ctrl.$scope.lookupData.brandModelId) {
	          alert('Please select the model first');
	          return;
	        }
	
	        (0, _assign2.default)(ctrl.vehicle, ctrl.$scope.lookupData);
	        if (ctrl.vehicle.firstRegistration) {
	          ctrl.vehicle.firstRegistration = new Date(ctrl.vehicle.firstRegistration);
	        }
	
	        ctrl.updateSelectDefaults();
	        ctrl.onLookupVehicleSelected();
	      }
	
	      ctrl.lookupModalInstance.close();
	    }
	  }, {
	    key: 'vehicleSelected',
	    value: function vehicleSelected(item) {
	      if (item) {
	        this.vehicle.vehicleCondition = 1;
	
	        var selectedBrand = (0, _lodash.find)(this.allBrands, function (o) {
	          return o.brandId === item.originalObject.brandId;
	        });
	        this.selectDefaults.brand = selectedBrand;
	
	        this.updateBrandModel();
	        var selectedModel = (0, _lodash.find)(this.brandModels, function (o) {
	          return o.brandModelId === item.originalObject.brandModelId;
	        });
	        this.selectDefaults.brandModel = selectedModel;
	        this.vehicle.brandModelId = selectedModel.brandModelId;
	
	        this.vehicle.variant = item.originalObject.variant;
	
	        var vehicleType = (0, _lodash.find)(this.enumLookupCollection['vehicleType'], function (o) {
	          return o.id === item.originalObject.vehicleTypeE;
	        });
	        this.selectDefaults.vehicleType = vehicleType;
	        this.vehicle.vehicleType = vehicleType.id;
	
	        if (item.originalObject.bodyTypeE) {
	          var bodyType = (0, _lodash.find)(this.enumLookupCollection['vehicleBodyType'], function (o) {
	            return o.id === item.originalObject.bodyTypeE;
	          });
	          this.selectDefaults.vehicleBodyType = bodyType;
	          this.vehicle.vehicleBodyType = bodyType.id;
	        }
	
	        if (item.originalObject.transmissionTypeE) {
	          var transmissionType = (0, _lodash.find)(this.enumLookupCollection['transmissionType'], function (o) {
	            return o.id === item.originalObject.transmissionTypeE;
	          });
	          this.selectDefaults.transmissionType = transmissionType;
	          this.vehicle.transmissionType = transmissionType.id;
	        }
	
	        if (item.originalObject.fuelTypeE) {
	          var fuelType = (0, _lodash.find)(this.enumLookupCollection['fuelType'], function (o) {
	            return o.id === item.originalObject.fuelTypeE;
	          });
	          this.selectDefaults.fuelType = fuelType;
	          this.vehicle.fuelType = fuelType.id;
	        }
	      }
	    }
	  }, {
	    key: 'clearVehicle',
	    value: function clearVehicle() {
	      var _this6 = this;
	
	      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchVehicle');
	
	      this.vehicle.variant = null;
	      this.initializeLookups(true).then(function () {
	        _this6.initializeEnumLookups();
	      });
	    }
	  }]);
	  return VehicleInformationController;
	}();
	
	exports.default = VehicleInformationController;

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    Vehicle Lookup Result\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Make</div>\r\n            <div class=\"col-md-6\">{{lookupData.make}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Model</div>\r\n            <div class=\"col-md-6\">\r\n                <select\r\n                class=\"form-control\"\r\n                ng-options=\"item.brandModelId as item.name for item in brandModels\"\r\n                ng-model=\"lookupData.brandModelId\">\r\n                </select>                \r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Variant</div>\r\n            <div class=\"col-md-6\">{{lookupData.variant}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Variant Code</div>\r\n            <div class=\"col-md-6\">{{lookupData.variantCode}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Registration</div>\r\n            <div class=\"col-md-6\">{{lookupData.registration}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Chassis No</div>\r\n            <div class=\"col-md-6\">{{lookupData.chassisNo}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">First Registered</div>\r\n            <div class=\"col-md-6\">{{lookupData.firstRegistration | date : 'dd-MMM-yyyy'}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Year</div>\r\n            <div class=\"col-md-6\">{{lookupData.year}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Engine Size</div>\r\n            <div class=\"col-md-6\">{{lookupData.capacity}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Color</div>\r\n            <div class=\"col-md-6\">{{lookupData.colorName}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Body Type</div>\r\n            <div class=\"col-md-6\">{{lookupData.vehicleBodyTypeName}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Tranmission Type</div>\r\n            <div class=\"col-md-6\">{{lookupData.transmissionTypeName}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">Fuel Type</div>\r\n            <div class=\"col-md-6\">{{lookupData.fuelTypeName}}</div>\r\n        </div>\r\n\r\n        <div class=\"row\" ng-repeat=\"item in lookupData.extras\">\r\n          <div class=\"col-md-6\">{{item.key}}</div>\r\n          <div class=\"col-md-6\">{{item.value}}</div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-6\">\r\n                  <div class=\"form-group\">\r\n                    <button type=\"submit\" ng-click=\"selectVehicle(true)\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\" ng-show=\"errMsg === ''\">\r\n                        Select Vehicle\r\n                    </button>\r\n                  </div>\r\n              </div>\r\n\r\n              <div class=\"col-md-6\">\r\n                  <div class=\"form-group\">\r\n                    <button type=\"submit\" ng-click=\"selectVehicle(false)\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        Cancel\r\n                    </button>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1079);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleInformation.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleInformation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicle-indicators{float:left}.simi-field-indicator,.vehicle-indicators img{height:16px;widht:16px}.simi-field-indicator{margin-right:5px}", ""]);
	
	// exports


/***/ }),
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehiclePricing = __webpack_require__(1099);
	
	var _vehiclePricing2 = _interopRequireDefault(_vehiclePricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehiclePricingModule = _angular2.default.module('vehiclePricing', [_angularUiRouter2.default]).component('vehiclePricing', _vehiclePricing2.default).name;
	
	exports.default = vehiclePricingModule;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehiclePricing = __webpack_require__(1100);
	
	var _vehiclePricing2 = _interopRequireDefault(_vehiclePricing);
	
	var _vehiclePricing3 = __webpack_require__(1101);
	
	var _vehiclePricing4 = _interopRequireDefault(_vehiclePricing3);
	
	__webpack_require__(1102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehiclePricingComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '='
	  },
	  template: _vehiclePricing2.default,
	  controller: _vehiclePricing4.default
	};
	
	exports.default = vehiclePricingComponent;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <uib-accordion close-others=\"false\">\r\n    <!-- Price Fields Begin -->\r\n    <div uib-group is-open=\"$ctrl.panels.priceFields\">\r\n\r\n      <header class=\"extra-margin-top\">\r\n        <h2>Price Fields</h2>\r\n      </header>\r\n\r\n    <div>\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Formula</label>\r\n        <div class=\"control-label col-sm-10\">\r\n          <label class=\"pull-left\">{{$ctrl.priceFormula || 'N / A'}}</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div>\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Price Calculation</label>\r\n        <div class=\"control-label col-sm-10\">\r\n          <label class=\"pull-left\">{{$ctrl.formulaCalculation || 'N / A'}}</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div>\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Vehicle Price</label>\r\n        <div class=\"control-label col-sm-10\">\r\n          <label class=\"pull-left\">{{$ctrl.vehicle.price | currency:'&euro;':2}}</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n      <table class=\"table table-striped table-bordered table-hover\">\r\n        <tr>\r\n            <th class=\"col-md-2\">Code</th>\r\n            <th class=\"col-md-5\">Field</th>\r\n            <th class=\"col-md-5\">Value</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"priceValue in $ctrl.vehicle.priceValues\">\r\n              <td class=\"col-md-2\">{{priceValue.code}}</td>\r\n              <td class=\"col-md-5\">{{priceValue.name}}</td>\r\n              <td class=\"col-md-5\">\r\n                <div class = \"input-group\">\r\n                   <span class=\"input-group-addon\"><i class=\"fa fa-eur\" aria-hidden=\"true\"></i></span>\r\n                   <input type=\"number\" class=\"form-control\" ng-model=\"priceValue.value\" ng-change=\"$ctrl.updateVehiclePrice()\">\r\n                </div>\r\n              </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <!-- Price Fields End -->\r\n\r\n  </uib-accordion>\r\n</div>\r\n"

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehiclePricingController = function () {
	  VehiclePricingController.$inject = ["lookupService", "authService", "priceManagementService", "$scope"];
	  function VehiclePricingController(lookupService, authService, priceManagementService, $scope) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, VehiclePricingController);
	    this.lookupService = lookupService;
	    this.authService = authService;
	    this.priceManagementService = priceManagementService;
	    this.$scope = $scope;
	
	    this.$scope.$on('vehicle:initialized', function () {
	      setTimeout(_this.vehicleInitialized.bind(_this), 500);
	    });
	
	    this.initializeLookups();
	    this.initializeEntityPriceFormula();
	
	    this.panels = {
	      priceFields: true
	    };
	
	    this.editLoad = false;
	  }
	
	  (0, _createClass3.default)(VehiclePricingController, [{
	    key: 'vehicleInitialized',
	    value: function vehicleInitialized() {
	      var ctrl = this;
	
	      if (ctrl.vehicle && ctrl.vehicle.vehicleId) {
	        var editPriceValues = ctrl.vehicle.priceValues;
	        var newPriceValues = (0, _lodash.map)(ctrl.priceLookups, function (item) {
	          var matchingPriceValue = (0, _lodash.find)(editPriceValues, function (o) {
	            return o.priceLookupId === item.priceLookupId;
	          });
	          var value = matchingPriceValue && matchingPriceValue.value ? matchingPriceValue.value : '';
	
	          return {
	            priceLookupId: item.priceLookupId,
	            code: item.code,
	            name: item.name,
	            value: value
	          };
	        });
	
	        ctrl.vehicle.priceValues = newPriceValues;
	        ctrl.updateVehiclePrice();
	      }
	    }
	  }, {
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      this.lookupService.lookupPriceLookups(this.authService.authData.currentLocation.key).then(function (priceLookups) {
	        ctrl.priceLookups = priceLookups;
	
	        _this2.vehicle.priceValues = (0, _lodash.map)(ctrl.priceLookups, function (item) {
	          /*
	          * 849
	          * This is to ensure that the price values dont get wiped off
	          * if for latency this block of code runs late
	          */
	          var pv = (0, _lodash.find)(_this2.vehicle.priceValues, function (o) {
	            return o.priceLookupId === item.priceLookupId;
	          });
	          var value = pv != null && pv.value ? pv.value : '';
	
	          return {
	            priceLookupId: item.priceLookupId,
	            code: item.code,
	            name: item.name,
	            value: value
	          };
	        });
	      });
	    }
	  }, {
	    key: 'initializeEntityPriceFormula',
	    value: function initializeEntityPriceFormula() {
	      var ctrl = this;
	
	      ctrl.priceManagementService.getPriceFormula(ctrl.authService.authData.currentLocation.key).then(function (response) {
	        ctrl.priceFormula = response.data;
	        ctrl.formulaCalculation = '';
	      });
	    }
	  }, {
	    key: 'updateVehiclePrice',
	    value: function updateVehiclePrice() {
	      if (!this.priceFormula) {
	        return;
	      }
	
	      var ctrl = this;
	      var pattern = new RegExp(/{(\w*?)}/g);
	      var matches = void 0;
	      var temp = ctrl.priceFormula.toUpperCase();
	      var priceLookup = void 0;
	
	      while (matches = pattern.exec(ctrl.priceFormula.toUpperCase())) {
	        priceLookup = (0, _lodash.find)(ctrl.vehicle.priceValues, function (o) {
	          return o.code === matches[1];
	        });
	        if (priceLookup && priceLookup.value) {
	          temp = temp.replace(matches[0], priceLookup.value);
	        } else {
	          temp = temp.replace(matches[0], 0);
	        }
	      }
	
	      try {
	        ctrl.formulaCalculation = temp;
	        ctrl.vehicle.price = eval(temp);
	      } catch (e) {
	        ctrl.vehicle.price = 0;
	      }
	    }
	  }]);
	  return VehiclePricingController;
	}();
	
	exports.default = VehiclePricingController;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehiclePricing.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehiclePricing.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehiclePricing{color:red}", ""]);
	
	// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleDetails = __webpack_require__(1105);
	
	var _vehicleDetails2 = _interopRequireDefault(_vehicleDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleDetailsModule = _angular2.default.module('vehicleDetails', [_angularUiRouter2.default]).component('vehicleDetails', _vehicleDetails2.default).name;
	
	exports.default = vehicleDetailsModule;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleDetails = __webpack_require__(1106);
	
	var _vehicleDetails2 = _interopRequireDefault(_vehicleDetails);
	
	var _vehicleDetails3 = __webpack_require__(1107);
	
	var _vehicleDetails4 = _interopRequireDefault(_vehicleDetails3);
	
	__webpack_require__(1108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '='
	  },
	  template: _vehicleDetails2.default,
	  controller: _vehicleDetails4.default
	};
	
	exports.default = vehicleDetailsComponent;

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <uib-accordion close-others=\"false\">\r\n    <!-- Extras Begin -->\r\n    <div uib-group class=\"panel-default\" is-open=\"$ctrl.panels.extras\">\r\n\r\n      <header class=\"extra-margin-top\">\r\n        <h2>Extras</h2>\r\n      </header>\r\n\r\n      <div class=\"form-horizontal\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-sm-12\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.tempField\" maxlength=\"50\" placeholder=\"Custom Field\" />\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-success iconBtn\" ng-click=\"$ctrl.addField()\"><i class=\"glyphicon glyphicon-plus\"></i>Add</button>\r\n              </span>\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <table class=\"table table-striped table-bordered table-hover no-margin-top\" ng-show=\"$ctrl.vehicle.extras.length\">\r\n        <tr>\r\n          <th class=\"col-md-6\">Field</th>\r\n          <th class=\"col-md-6\">Value</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"extra in $ctrl.vehicle.extras\">\r\n            <td class=\"col-md-6\">{{extra.key}}</td>\r\n            <td class=\"col-md-6\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"extra.value\" maxlength=\"50\">\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n      <p class=\"no-content\" ng-show=\"!$ctrl.vehicle.extras.length\">Extras list is currently empty.</p>\r\n    </div>\r\n    <!-- Extras End -->\r\n\r\n    <!-- Accessories Begin -->\r\n    <div uib-group class=\"panel-default\" is-open=\"$ctrl.panels.accessories\">\r\n      <header class=\"extra-margin-top\">\r\n        <h2>Accessories</h2>\r\n      </header>\r\n\r\n      <div class=\"checkboxList\" ng-show=\"$ctrl.vehicle.accessories.length\">\r\n        <div ng-repeat=\"accessory in $ctrl.vehicle.accessories | orderBy: 'name'\" class=\"checkbox col-sm-6 col-md-4\">\r\n          <label>\r\n            <input type=\"checkbox\" ng-model=\"accessory.enabled\" />\r\n            <span>{{accessory.name}}</span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <p class=\"no-content\" ng-show=\"!$ctrl.vehicle.accessories.length\">Accessories list is currently empty.</p>\r\n    </div>\r\n    <!-- Accessories End -->\r\n  </uib-accordion>\r\n</div>"

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleDetailsController = function () {
	  VehicleDetailsController.$inject = ["lookupService", "authService"];
	  function VehicleDetailsController(lookupService, authService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleDetailsController);
	    this.lookupService = lookupService;
	    this.authService = authService;
	
	    this.initializeLookups();
	
	    this.panels = {
	      extras: true
	    };
	
	    this.editLoad = false;
	
	    this.defaultExtrasList = [];
	  }
	
	  (0, _createClass3.default)(VehicleDetailsController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var ctrl = this;
	
	      this.lookupService.lookupAccessoryLookups(this.authService.authData.currentLocation.key).then(function (accessoryLookups) {
	        ctrl.accessoryLookups = accessoryLookups;
	
	        ctrl.vehicle.extras = (0, _lodash.map)(ctrl.defaultExtrasList, function (item) {
	          return {
	            key: item.key,
	            value: ''
	          };
	        });
	
	        ctrl.vehicle.accessories = (0, _lodash.map)(ctrl.accessoryLookups, function (item) {
	          return {
	            accessoryLookupId: item.accessoryLookupId,
	            name: item.name,
	            enabled: false
	          };
	        });
	      });
	    }
	  }, {
	    key: '$doCheck',
	    value: function $doCheck() {
	      var ctrl = this;
	
	      if (!ctrl.editLoad && ctrl.vehicle && ctrl.vehicle.vehicleId) {
	        var editAccessories = ctrl.vehicle.accessories;
	        var newAccessories = (0, _lodash.map)(ctrl.accessoryLookups, function (item) {
	          var matchingAccessory = (0, _lodash.find)(editAccessories, function (o) {
	            return o.accessoryLookupId === item.accessoryLookupId;
	          });
	          var enabled = matchingAccessory ? matchingAccessory.enabled : false;
	
	          return {
	            accessoryLookupId: item.accessoryLookupId,
	            name: item.name,
	            enabled: enabled
	          };
	        });
	        ctrl.vehicle.accessories = newAccessories;
	
	        var missingElements = (0, _lodash.differenceBy)(this.defaultExtrasList, this.vehicle.extras, 'key');
	        missingElements.map(function (item) {
	          ctrl.vehicle.extras.push({
	            key: item.key,
	            value: ''
	          });
	        });
	
	        this.editLoad = true;
	      }
	    }
	  }, {
	    key: 'addField',
	    value: function addField() {
	      if (this.tempField) {
	        this.vehicle.extras.push({ key: this.tempField, value: '' });
	        this.tempField = '';
	      }
	    }
	  }]);
	  return VehicleDetailsController;
	}();
	
	exports.default = VehicleDetailsController;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1109);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleDetails.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleDetails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleDetails{color:red}", ""]);
	
	// exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleImages = __webpack_require__(1111);
	
	var _vehicleImages2 = _interopRequireDefault(_vehicleImages);
	
	var _angularUpload = __webpack_require__(1116);
	
	var _angularUpload2 = _interopRequireDefault(_angularUpload);
	
	__webpack_require__(1117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleImagesModule = _angular2.default.module('vehicleImages', [_angularUiRouter2.default, 'lr.upload']).component('vehicleImages', _vehicleImages2.default).name;
	
	exports.default = vehicleImagesModule;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleImages = __webpack_require__(1112);
	
	var _vehicleImages2 = _interopRequireDefault(_vehicleImages);
	
	var _vehicleImages3 = __webpack_require__(1113);
	
	var _vehicleImages4 = _interopRequireDefault(_vehicleImages3);
	
	__webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleImagesComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '=',
	    formValidationService: '<'
	  },
	  template: _vehicleImages2.default,
	  controller: _vehicleImages4.default
	};
	
	exports.default = vehicleImagesComponent;

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"mediaItems\">\r\n\r\n  <div class=\"alert alert-info\">\r\n    The first picture in the gallery will be the main picture in your adverts and will appear on the sales quotation\r\n    <br />\r\n    Images can be reordered by drag and drop\r\n  </div>\r\n\r\n  <div class=\"alert alert-warning\" ng-show=\"$ctrl.brandingApplied && $ctrl.brandingSaved\">\r\n    The images have been altered, saving changes to the vehicle now will permanently update these images and it can't be undone      \r\n  </div>  \r\n\r\n  <header class=\"extra-margin-top\">\r\n    <div class=\"btn-group pull-right\" uib-dropdown dropdown-append-to-body>\r\n\r\n      <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-hide=\"true\">\r\n        Add Media Item <span class=\"caret\"></span>\r\n      </button>\r\n\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n        <li role=\"menuitem\">\r\n          <div upload-button class=\"btn btn-upload\" url=\"{{$ctrl.uploadUrl}}\" on-upload=\"$ctrl.showUploading(response)\" on-error=\"$ctrl.hideUploading(response)\"\r\n            on-success=\"$ctrl.onMediaUploadSuccess(response)\" multiple=\"true\">\r\n            Upload Media Item(s) Max 10 MBs\r\n          </div>\r\n        </li>\r\n        <li role=\"menuitem\">\r\n          <a class=\"btn btn-link\" ng-click=\"$ctrl.addExternalImage()\">Add External Image</a>\r\n        </li>\r\n        <li role=\"menuitem\">\r\n          <a class=\"btn btn-link\" ng-click=\"$ctrl.addYoutube()\">Add Youtube Video</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n\r\n  </header>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-1\">\r\n      <h3>Images</h3>\r\n\r\n      <div upload-button class=\"btn btn-default btn-upload\" url=\"{{$ctrl.uploadUrl}}\" on-upload=\"$ctrl.showUploading(response)\" on-error=\"$ctrl.hideUploading(response)\"\r\n        on-success=\"$ctrl.onMediaUploadSuccess(response)\" multiple=\"true\">\r\n        Add Image(s)\r\n      </div>      \r\n\r\n      <br>\r\n      <button class=\"btn btn-primary\" ng-click=\"$ctrl.showBranding()\" ng-show=\"$ctrl.hasImages()\">\r\n        Apply Branding\r\n      </button>\r\n    </div>\r\n    <div class=\"col-md-11\">\r\n      <ul class=\"image-list\" ng-sortable=\"$ctrl.sortableConfig\">\r\n          <li ng-repeat=\"m in $ctrl.vehicle.mediaItems | filter: $ctrl.isImage | orderBy:'order'\">\r\n              <img ng-src=\"{{m.tempUrl || m.url}}\" class=\"imgGallery\" />          \r\n              <div class=\"imgOptions\">\r\n                  <div class=\"order-no\">#{{m.order}}</div>\r\n                  <div class=\"delete-image\">\r\n                    <a href=\"#\" ng-click=\"$ctrl.showRemoveMedia(m)\">\r\n                      <i class=\"fa fa-trash-o\"></i>\r\n                    </a>\r\n                  </div>\r\n              </div>\r\n          </li>\r\n        </ul>  \r\n    </div>    \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-1\">\r\n      <h3>Video</h3>\r\n\r\n      <a class=\"btn btn-default\" ng-click=\"$ctrl.addYoutube()\" ng-hide=\"$ctrl.video\">Add Youtube Video</a>\r\n      <a class=\"btn btn-default\" ng-click=\"$ctrl.showRemoveMedia($ctrl.video)\" ng-show=\"$ctrl.video\">\r\n          <i class=\"fa fa-trash-o\" class=\"remove-video\"></i>Remove Video\r\n      </a>      \r\n    </div>\r\n\r\n    <div class=\"col-md-11\">\r\n      <iframe class=\"video-youtube\" ng-src=\"{{('https://www.youtube.com/embed/' + $ctrl.video.url) | trustUrl}}\" ng-show=\"$ctrl.video\"\r\n        frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>    \r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleImagesController = function () {
	  VehicleImagesController.$inject = ["appConfig", "enums", "loadingService", "vehicleService", "$scope", "$ngConfirm", "brandingService", "authService"];
	  function VehicleImagesController(appConfig, enums, loadingService, vehicleService, $scope, $ngConfirm, brandingService, authService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleImagesController);
	    this.appConfig = appConfig;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.vehicleService = vehicleService;
	    this.$scope = $scope;
	    this.$ngConfirm = $ngConfirm;
	    this.brandingService = brandingService;
	    this.authService = authService;
	
	    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
	    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';
	
	    this.sortableConfig = {
	      onEnd: this.dragEndHandler.bind(this)
	    };
	
	    this.$scope.$on('vehicle:initialized', this.vehicleInitialized.bind(this));
	
	    this.video = null;
	
	    this.initializeBrandingTemplates();
	    this.brandingApplied = false;
	    this.brandingSaved = false;
	  }
	
	  (0, _createClass3.default)(VehicleImagesController, [{
	    key: 'vehicleInitialized',
	    value: function vehicleInitialized() {
	      var _this = this;
	
	      this.video = (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
	        return mi.mediaType === _this.enums.MEDIA_TYPE.Youtube;
	      });
	    }
	  }, {
	    key: 'showUploading',
	    value: function showUploading() {
	      this.formValidationService.resetValidations();
	      this.loadingService.showLoading('mediaItems', 'Uploading Media Item(s)');
	    }
	  }, {
	    key: 'hideUploading',
	    value: function hideUploading(response) {
	      this.loadingService.hideLoading('mediaItems');
	
	      if (response) {
	        this.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	      }
	    }
	  }, {
	    key: 'onMediaUploadSuccess',
	    value: function onMediaUploadSuccess(response) {
	      var _this2 = this;
	
	      this.hideUploading();
	
	      response.data.map(function (item) {
	        _this2.vehicle.mediaItems.push({
	          mediaType: item.key,
	          url: item.value,
	          tempUrl: _this2.mediaUrl + '/' + item.value,
	          isCover: false,
	          order: _this2.vehicle.mediaItems.length + 1
	        });
	      });
	    }
	  }, {
	    key: 'makeCover',
	    value: function makeCover(img) {
	      var coverImg = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
	        return o.isCover;
	      });
	      coverImg.isCover = false;
	
	      var newCoverImg = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
	        return o.url === img.url;
	      });
	      newCoverImg.isCover = true;
	    }
	  }, {
	    key: 'showRemoveMedia',
	    value: function showRemoveMedia(mediaItem) {
	      var _this3 = this;
	
	      this.$ngConfirm({
	        title: "Warning",
	        content: 'Are you sure you want to remove this item ?',
	        type: 'orange',
	        buttons: {
	          renew: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this3.removeMedia(mediaItem);
	            }
	          },
	          cancel: {
	            text: 'Leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeMedia',
	    value: function removeMedia(mediaItem) {
	      this.vehicle.mediaItems = (0, _lodash.without)(this.vehicle.mediaItems, mediaItem);
	
	      this.vehicle.mediaItems.map(function (val, ind) {
	        val.order = ind + 1;
	      });
	
	      if (mediaItem.mediaType === this.enums.MEDIA_TYPE.Youtube) {
	        this.video = null;
	      }
	    }
	  }, {
	    key: 'addExternalImage',
	    value: function addExternalImage() {
	      var url = prompt("Please enter the URL for the Image");
	
	      var isCover = (0, _lodash.find)(this.vehicle.mediaItems, function (o) {
	        return o.isCover;
	      });
	
	      if (url) {
	        this.vehicle.mediaItems.push({
	          mediaType: this.enums.MEDIA_TYPE.ExternalImage,
	          url: url,
	          isCover: !isCover
	        });
	      }
	    }
	  }, {
	    key: 'addYoutube',
	    value: function addYoutube() {
	      var _this4 = this;
	
	      var url = prompt("Please enter the URL for the Youtube Video");
	
	      if (url) {
	        var youtubeId = this.getYoutubeId(url);
	
	        if (!youtubeId) {
	          this.$ngConfirm({
	            title: "Error !",
	            content: 'The URL provided is not a valid <br /> <b>Youtube Link: </b> ' + url,
	            type: 'red',
	            buttons: {
	              renew: {
	                text: 'Ok',
	                btnClass: 'btn-default'
	              }
	            }
	          });
	
	          return;
	        }
	
	        this.vehicle.mediaItems.push({
	          mediaType: this.enums.MEDIA_TYPE.Youtube,
	          url: youtubeId
	        });
	
	        this.video = (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
	          return mi.mediaType === _this4.enums.MEDIA_TYPE.Youtube;
	        });
	      }
	    }
	  }, {
	    key: 'listToMatrix',
	    value: function listToMatrix(list, elementsPerSubArray) {
	      var matrix = [],
	          i,
	          k;
	
	      for (i = 0, k = -1; i < list.length; i++) {
	        if (i % elementsPerSubArray === 0) {
	          k++;
	          matrix[k] = [];
	        }
	
	        matrix[k].push(list[i]);
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'dragEndHandler',
	    value: function dragEndHandler() {
	      this.updateOrderNo();
	    }
	  }, {
	    key: 'updateOrderNo',
	    value: function updateOrderNo() {
	      $('.order-no').each(function (ind, el) {
	        $(el).text('#' + (ind + 1));
	      });
	    }
	  }, {
	    key: 'getYoutubeId',
	    value: function getYoutubeId(url) {
	      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
	      var match = url.match(regExp);
	      return match && match[7].length == 11 ? match[7] : false;
	    }
	  }, {
	    key: 'hasImages',
	    value: function hasImages() {
	      var _this5 = this;
	
	      return this.vehicle.mediaItems && (0, _lodash.find)(this.vehicle.mediaItems, function (mi) {
	        return mi.mediaType === _this5.enums.MEDIA_TYPE.Image;
	      }) != null;
	    }
	  }, {
	    key: 'initializeBrandingTemplates',
	    value: function initializeBrandingTemplates() {
	      var _this6 = this;
	
	      this.brandingService.list(this.authService.authData.currentLocation.key).then(function (response) {
	        var firstItem = { brandingTemplateId: null, name: 'Select Template' };
	        _this6.brandingTemplates = [firstItem].concat((0, _toConsumableArray3.default)(response.data));
	      });
	    }
	  }, {
	    key: 'showBranding',
	    value: function showBranding() {
	      var _this7 = this;
	
	      var images = (0, _lodash.filter)(this.vehicle.mediaItems, function (mi) {
	        return mi.mediaType === _this7.enums.MEDIA_TYPE.Image;
	      }).map(function (val) {
	        return {
	          originalUrl: val.url.search(/amazon/) === -1 ? val.tempUrl : val.url,
	          url: val.url.search(/amazon/) === -1 ? val.tempUrl : val.url,
	          selected: false,
	          loading: false
	        };
	      });
	
	      this.$scope.images = images;
	      this.$scope.selectedImage = images[0];
	
	      this.$scope.templates = this.brandingTemplates;
	
	      this.$scope.selectedTemplateId = null;
	
	      var updateImage = function updateImage(img) {
	        _this7.$scope.selectedImage = img;
	      };
	
	      this.$scope.updateImage = updateImage.bind(this);
	
	      this.brandingModal = this.$ngConfirm({
	        title: "Image Branding",
	        contentUrl: 'templates/vehicle/vehicleBrandingTemplate',
	        type: 'black',
	        columnClass: 'xl',
	        scope: this.$scope,
	        buttons: {
	          applySelected: {
	            text: 'Apply to Selected',
	            btnClass: 'btn-dark',
	            action: function action() {
	              var selectedImages = (0, _lodash.filter)(_this7.$scope.images, function (img) {
	                return img.selected;
	              });
	
	              if (!selectedImages || !selectedImages.length) {
	                alert('Please select images first');
	                return false;
	              }
	
	              if (!_this7.$scope.selectedTemplateId) {
	                alert('Please select a template first');
	                return false;
	              }
	
	              _this7.applyBranding((0, _lodash.filter)(_this7.$scope.images, function (img) {
	                return img.selected;
	              }));
	              return false;
	            }
	          },
	          applyAll: {
	            text: 'Apply to All',
	            btnClass: 'btn-dark',
	            action: function action() {
	              if (!_this7.$scope.selectedTemplateId) {
	                alert('Please select a template first');
	                return false;
	              }
	
	              _this7.$scope.images.map(function (img) {
	                return img.selected = true;
	              });
	              _this7.applyBranding((0, _lodash.filter)(_this7.$scope.images, function (img) {
	                return img.selected;
	              }));
	
	              return false;
	            }
	          },
	          save: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              return _this7.updateImageBranding();
	            }
	          },
	          cancel: {
	            text: 'Cancel',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'applyBranding',
	    value: function applyBranding(selectedImages) {
	      var _this8 = this;
	
	      (0, _lodash.map)(this.brandingModal.buttons, function (btn) {
	        return btn.setDisabled(true);
	      });
	      (0, _lodash.map)(selectedImages, function (img) {
	        return img.loading = true;
	      });
	
	      this.brandingService.applyBranding(this.authService.authData.currentLocation.key, this.$scope.selectedTemplateId, selectedImages).then(function (response) {
	        response.data.map(function (img) {
	          var matching = (0, _lodash.find)(_this8.$scope.images, function (o) {
	            return o.originalUrl === img.originalUrl;
	          });
	          matching.url = _this8.mediaUrl + '/' + img.url;
	        });
	      }).finally(function () {
	        _this8.brandingApplied = true;
	
	        (0, _lodash.map)(_this8.brandingModal.buttons, function (btn) {
	          return btn.setDisabled(false);
	        });
	        (0, _lodash.map)(selectedImages, function (img) {
	          return img.loading = false;
	        });
	      });
	    }
	  }, {
	    key: 'updateImageBranding',
	    value: function updateImageBranding() {
	      var _this9 = this;
	
	      this.$scope.images.map(function (img) {
	        if (img.originalUrl !== img.url) {
	          var mi = (0, _lodash.find)(_this9.vehicle.mediaItems, function (mi) {
	            return mi.url === img.originalUrl || mi.tempUrl === img.originalUrl;
	          });
	          mi.mediaId = 0;
	          mi.url = img.url.substring(img.url.lastIndexOf('/') + 1);
	          mi.tempUrl = img.url;
	
	          _this9.brandingSaved = true;
	        }
	      });
	    }
	  }, {
	    key: 'isImage',
	    value: function isImage(mediaItem) {
	      return mediaItem.mediaType === 1 || mediaItem.mediaType === 3;
	    }
	  }]);
	  return VehicleImagesController;
	}();
	
	exports.default = VehicleImagesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleImages.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleImages.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".imageRow{margin:80px 0}.isCover{border:1px solid red}.image-list{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;list-style-type:none}.imgOptions{height:30px;margin-bottom:20px;background-color:#666;border:2px solid #999;border-radius:0 0 10px 10px;border-top:none}.imgGallery,.imgOptions{width:220px;margin-left:5px}.imgGallery{margin-right:25px;margin-top:10px;height:210px;text-align:center;cursor:move;cursor:grab;cursor:-webkit-grab;border:2px solid #999;border-radius:10px 10px 0 0;border-bottom:none}.imgGallery:active{cursor:grabbing;cursor:-webkit-grabbing}.order-no{color:gold;font-size:16px;padding-left:10px;padding-top:6px;float:left}.delete-image{float:right;padding-top:3px}.delete-image i{font-size:22px}.delete-image a{padding-right:10px;color:gold}.video-youtube{margin-left:45px;width:975px;height:400px;border:2px solid #999;border-radius:10px 10px 10px 10px}.remove-video li{color:gold}.ximgGallery:hover{cursor:pointer;transform:scale(2);transition-duration:.3s;-webkit-transition-duration:.3s;box-shadow:10px 10px 5px #888;z-index:99999}.branding-preview{width:100%;height:500px!important}.branding-list-container{margin-top:20px;height:400px;width:100%;overflow-y:scroll}.branding-image-list{display:grid;grid-template-columns:1fr 1fr 1fr;list-style-type:none}.branding-imgGallery{width:150px!important;height:110px!important;cursor:pointer;border:1px solid #999;border-radius:5px 5px 0 0}.branding-imgOptions{width:150px;height:20px;padding-left:5px;margin-bottom:15px;background-color:#666;border:1px solid #999;border-radius:0 0 10px 10px;border-top:none}.css-hide{visibility:hidden}.img-loader{position:relative;top:-60px;left:50px;float:left}", ""]);
	
	// exports


/***/ }),
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _serviceHistory = __webpack_require__(1120);
	
	var _serviceHistory2 = _interopRequireDefault(_serviceHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceHistoryModule = _angular2.default.module('serviceHistory', [_angularUiRouter2.default]).component('serviceHistory', _serviceHistory2.default).name;
	
	exports.default = serviceHistoryModule;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _serviceHistory = __webpack_require__(1121);
	
	var _serviceHistory2 = _interopRequireDefault(_serviceHistory);
	
	var _serviceHistory3 = __webpack_require__(1122);
	
	var _serviceHistory4 = _interopRequireDefault(_serviceHistory3);
	
	__webpack_require__(1123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceHistoryComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicle: '='
	  },
	  template: _serviceHistory2.default,
	  controller: _serviceHistory4.default
	};
	
	exports.default = serviceHistoryComponent;

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>Vehicle Service History</h1>\r\n  <button class=\"btn btn-default\" ng-click=\"$ctrl.showMazdaAuth()\" ng-show=\"!$ctrl.authService.hasActiveMazdaToken()\">Login with Mazda</button>\r\n</div>\r\n\r\n<div ng-show=\"$ctrl.serviceHistory\" block-ui=\"serviceHistory\">\r\n  <label>Retail Sale Date: {{$ctrl.serviceHistory.retailSaleDate | date : 'dd MMM yyyy'}}</label>\r\n  <br /><br />\r\n\r\n  <label>Next Service</label><br />\r\n  <label>Date: {{$ctrl.serviceHistory.nextDueService.nextDueDate | date : 'dd MMM yyyy'}}</label><br />\r\n  <label>Mileage: {{($ctrl.serviceHistory.nextDueService.mileage | number : 0) + ' ' + $ctrl.serviceHistory.nextDueService.mileageType}}</label><br /><br />\r\n\r\n  <div class=\"alert alert-warning\" ng-show=\"$ctrl.getOpenDefects().length\">\r\n    The following open defects are reported for this Vehicle\r\n\r\n    <ul ng-repeat=\"od in $ctrl.getOpenDefects(sr) track by $index\">\r\n      <li>{{od.location.locationCode}} {{od.location.definitionLabel}}, reported {{od.creationDate | date : 'dd MMM yyyy'}}</li>\r\n    </ul>  \r\n  </div>\r\n\r\n  <uib-accordion close-others=\"true\">\r\n\r\n    <!-- Begin Service History -->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.serviceHistory.visible\">\r\n      <uib-accordion-heading>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-11\">\r\n            Service History\r\n          </div>\r\n          <div class=\"col-md-1\">\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.serviceHistory.visible, 'glyphicon-chevron-down': !$ctrl.panels.serviceHistory.visible}\"></i>\r\n          </div>\r\n        </div>\r\n      </uib-accordion-heading>\r\n\r\n      <table class=\"table table-striped table-bordered table-hover\">\r\n        <tr>\r\n            <th class=\"col-md-3\">Dealer</th>\r\n            <th class=\"col-md-3\">Date</th>\r\n            <th class=\"col-md-3\">Mileage</th>\r\n            <th class=\"col-md-3\">Service Items</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"sr in $ctrl.serviceHistory.serviceHistory.serviceRecords\">\r\n              <td class=\"col-md-3\">{{sr.dealer.name}}</td>\r\n              <td class=\"col-md-3\">{{sr.date | date : 'dd MMM yyyy'}}</td>\r\n              <td class=\"col-md-3\">{{(sr.mileage | number : 0) + ' ' + sr.mileageType}}</td>\r\n              <td class=\"col-md-3\">\r\n                <ul ng-repeat=\"si in $ctrl.getServiceItems(sr) track by $index\">\r\n                  <li>{{si}}</li>\r\n                </ul>\r\n              </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>  \r\n    </div>\r\n    <!-- End Service History -->\r\n\r\n    <!-- Begin Recall History -->\r\n    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.recallHistory.visible\">\r\n      <uib-accordion-heading>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-11\">\r\n            Recall Information\r\n          </div>\r\n          <div class=\"col-md-1\">\r\n            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.recallHistory.visible, 'glyphicon-chevron-down': !$ctrl.panels.recallHistory.visible}\"></i>\r\n          </div>\r\n        </div>\r\n      </uib-accordion-heading>\r\n\r\n      <table class=\"table table-striped table-bordered table-hover\">\r\n        <tr>\r\n            <th class=\"col-md-4\">Description</th>\r\n            <th class=\"col-md-1\">Date Range</th>\r\n            <th class=\"col-md-1\">Status</th>\r\n            <th class=\"col-md-3\">Parts</th>\r\n            <th class=\"col-md-3\">Operations</th>\r\n        </tr>\r\n        <tbody>\r\n          <tr ng-repeat=\"rh in $ctrl.recallHistory\">\r\n              <td class=\"col-md-4\">{{rh.description}}</td>\r\n              <td class=\"col-md-1\">{{rh.startDate | date : 'dd MMM yyyy'}} to {{rh.endDate | date : 'dd MMM yyyy'}}</td>\r\n              <td class=\"col-md-1\">{{rh.statusVin}}</td>\r\n              <td class=\"col-md-3\">\r\n                <ul ng-repeat=\"part in $ctrl.getRecallCampaign(rh).campaignParts track by $index\">\r\n                  <li>{{part.description}}</li>\r\n                </ul>\r\n              </td>\r\n              <td class=\"col-md-3\">\r\n                <ul ng-repeat=\"op in $ctrl.getRecallCampaign(rh).campaignOperations track by $index\">\r\n                  <li>{{op.description}}</li>\r\n                </ul>\r\n              </td>              \r\n          </tr>\r\n        </tbody>\r\n      </table>  \r\n    </div>\r\n    <!-- End Recall History -->    \r\n\r\n  </uib-accordion>  \r\n\r\n</div>\r\n"

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceHistoryController = function () {
	  ServiceHistoryController.$inject = ["authService", "$scope", "loadingService", "integrationService", "$ngConfirm", "$state"];
	  function ServiceHistoryController(authService, $scope, loadingService, integrationService, $ngConfirm, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ServiceHistoryController);
	    this.authService = authService;
	    this.$scope = $scope;
	    this.loadingService = loadingService;
	    this.integrationService = integrationService;
	    this.$ngConfirm = $ngConfirm;
	    this.$state = $state;
	
	    this.$scope.$on('vehicleEdit:lookupVehicleSelected', this.showHistory.bind(this));
	
	    this.serviceHistory = null;
	    this.recallHistory = null;
	  }
	
	  (0, _createClass3.default)(ServiceHistoryController, [{
	    key: 'showMazdaAuth',
	    value: function showMazdaAuth() {
	      var _this = this;
	
	      this.$ngConfirm({
	        title: 'Mazda Auth',
	        contentUrl: 'templates/vehicle/mazdaAuthConsentTemplate',
	        columnClass: 'm',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Yes, take me to Mazda',
	            btnClass: 'btn-primary',
	            action: function action() {
	              if (_this.$state.current.name === 'vehicleAdd') {
	                _this.authService.mazdaLogin('vehicleAdd');
	              } else {
	                _this.authService.mazdaLogin('vehicleEdit', { vehicleId: _this.$state.params.vehicleId });
	              }
	            }
	          },
	          no: {
	            text: 'No, leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showHistory',
	    value: function showHistory(eventData, data) {
	      if (!this.authService.hasActiveMazdaToken() || !data.isMazda || !data.chassisNo) {
	        this.serviceHistory = null;
	        return;
	      }
	
	      this.getMazdaServiceHistory(data.chassisNo);
	      this.getMazdaRecallHistory(data.chassisNo);
	    }
	  }, {
	    key: 'getMazdaServiceHistory',
	    value: function getMazdaServiceHistory(chassisNo) {
	      var _this2 = this;
	
	      this.loadingService.showLoading('serviceHistory', 'Loading Service History ...');
	
	      this.integrationService.getMazdaServiceHistory(this.authService.authData.mazdaToken.access_token, this.authService.authData.mazdaToken.defaultDomain, chassisNo).then(function (response) {
	        _this2.serviceHistory = JSON.parse(response.data);
	      }).finally(function () {
	        _this2.loadingService.hideLoading('serviceHistory');
	      });
	    }
	  }, {
	    key: 'getMazdaRecallHistory',
	    value: function getMazdaRecallHistory(chassisNo) {
	      var _this3 = this;
	
	      this.loadingService.showLoading('serviceHistory', 'Loading Service History ...');
	
	      this.integrationService.getMazdaRecallHistory(this.authService.authData.mazdaToken.access_token, this.authService.authData.mazdaToken.defaultDomain, chassisNo).then(function (response) {
	        _this3.recallHistory = (0, _lodash.reverse)(JSON.parse(response.data));
	      }).finally(function () {
	        _this3.loadingService.hideLoading('serviceHistory');
	      });
	    }
	  }, {
	    key: 'getServiceItems',
	    value: function getServiceItems(serviceRecord) {
	      var serviceItems = (0, _lodash.filter)(serviceRecord.serviceItems, function (si) {
	        return si.description !== 'Not Applicable';
	      });
	      return serviceItems.map(function (si) {
	        return si.description;
	      });
	    }
	  }, {
	    key: 'getRecallCampaign',
	    value: function getRecallCampaign(recallRecord) {
	      var campaign = (0, _lodash.find)(recallRecord.campaignVariants, function (cv) {
	        return cv.processNumber === recallRecord.campaignNumber;
	      });
	      return campaign;
	    }
	  }, {
	    key: 'getOpenDefects',
	    value: function getOpenDefects() {
	      if (this.serviceHistory) {
	        return (0, _lodash.filter)(this.serviceHistory.openDefects, function (od) {
	          return od.repairStatus === 'OPEN';
	        });
	      }
	    }
	  }]);
	  return ServiceHistoryController;
	}();
	
	exports.default = ServiceHistoryController;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1124);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./serviceHistory.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./serviceHistory.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".serviceHistory{color:red}", ""]);
	
	// exports


/***/ }),
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehiclePublish = __webpack_require__(1130);
	
	var _vehiclePublish2 = _interopRequireDefault(_vehiclePublish);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehiclePublishModule = _angular2.default.module('vehiclePublish', [_angularUiRouter2.default]).component('vehiclePublish', _vehiclePublish2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehiclePublish', {
	    url: '/vehicle/publish',
	    component: 'vehiclePublish'
	  });
	}]).name;
	
	exports.default = vehiclePublishModule;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehiclePublish = __webpack_require__(1131);
	
	var _vehiclePublish2 = _interopRequireDefault(_vehiclePublish);
	
	var _vehiclePublish3 = __webpack_require__(1132);
	
	var _vehiclePublish4 = _interopRequireDefault(_vehiclePublish3);
	
	__webpack_require__(1133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehiclePublishComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehiclePublish2.default,
	  controller: _vehiclePublish4.default
	};
	
	exports.default = vehiclePublishComponent;

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <vehicle-List publish-Mode=\"true\"></vehicle-List>\r\n</div>\r\n"

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehiclePublishController = function VehiclePublishController(authService, enums) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, VehiclePublishController);
	  if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View, true)) {
	    return;
	  }
	
	  this.name = 'vehiclePublish';
	};
	VehiclePublishController.$inject = ["authService", "enums"];
	
	exports.default = VehiclePublishController;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehiclePublish.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehiclePublish.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehiclePublish{color:red}", ""]);
	
	// exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleService = function () {
	  VehicleService.$inject = ["$http", "appConfig"];
	  function VehicleService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(VehicleService, [{
	    key: 'getVehicle',
	    value: function getVehicle(entityId, vehicleId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/vehicle/get/' + entityId + '/' + vehicleId));
	    }
	  }, {
	    key: 'getVehicleAppraisal',
	    value: function getVehicleAppraisal(entityId, vehicleId, enquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/vehicle/get/appraisal/' + entityId + '/' + vehicleId + '/' + (enquiryId ? enquiryId : null)));
	    }
	  }, {
	    key: 'editVehicle',
	    value: function editVehicle(vehicle) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/vehicle/add', vehicle);
	    }
	  }, {
	    key: 'editVehicleAppraisal',
	    value: function editVehicleAppraisal(contactId, enquiryId, vehicleAppraisal) {
	      //return this.$http.post(this.appConfig.apiServiceBaseUri + `api/vehicle/addappraisal/${contactId ? contactId : null}/${enquiryId ? enquiryId : null}`, vehicleAppraisal);
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/vehicle/addappraisal/' + (contactId ? contactId : '0') + '/' + (enquiryId ? enquiryId : '0')), vehicleAppraisal);
	    }
	  }, {
	    key: 'listVehicles',
	    value: function listVehicles(filterParams) {
	      var query = this.getQueryParams(filterParams);
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/list' + query);
	    }
	  }, {
	    key: 'getQueryParams',
	    value: function getQueryParams(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	
	      query += '&entityId=' + filterParams.entityId;
	      query += '&condition=' + filterParams.vehicleConditionSearch.id;
	      query += '&registration=' + (filterParams.registration || '');
	
	      /*
	      * Check if selected brand is 0
	      * this means that User is only allowed to see certain brands in new category
	      * in which case send the allowed brandIds
	      */
	      if (filterParams.brand.brandId === 0) {
	        query += '&brandIds=' + filterParams.allowedBrands.map(function (b) {
	          return b.brandId;
	        });
	      } else {
	        /*
	        * In this case it is either that User is Viewing old vehicles
	        * which means it will be All brands with brandId = 1
	        * or the User has wished to see a specific brand
	        */
	        query += '&brandIds=' + filterParams.brand.brandId;
	      }
	
	      if (filterParams.brandModel.brandModelId !== 0) {
	        query += '&modelId=' + filterParams.brandModel.brandModelId;
	      }
	
	      if (filterParams.vehicleStatus.id) {
	        query += '&state=' + filterParams.vehicleStatus.id;
	      }
	
	      return query;
	    }
	  }, {
	    key: 'updateVehicleState',
	    value: function updateVehicleState(entityId, vehicleId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/vehicle/update/' + entityId + '/' + vehicleId + '/' + state));
	    }
	  }, {
	    key: 'publishToWeb',
	    value: function publishToWeb(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/vehicle/publish/' + entityId));
	    }
	  }, {
	    key: 'easierAd',
	    value: function easierAd(locationId) {
	      var tokenRequest = {
	        method: 'POST',
	        url: 'http://www.easierad.ie/admin/thirdparty/api/edit?dpid=' + locationId,
	        headers: {
	          'Authorization': 'Basic Y2Fyc25vd2RwOlIkbWYyMzRlZWbCo2RkIQ=='
	        }
	      };
	
	      this.$http(tokenRequest).then(function (response) {}).catch(function (err) {});
	    }
	  }, {
	    key: 'searchVehicles',
	    value: function searchVehicles(entityId, criteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/vehicle/search/' + entityId), criteria);
	    }
	  }, {
	    key: 'annotateImage',
	    value: function annotateImage(height, width, imageBase, imgData) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/file/annotateImage/' + height + '/' + width + '/' + imageBase), imgData, {
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
	    }
	  }, {
	    key: 'listDeliveredVehicles',
	    value: function listDeliveredVehicles(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	
	      query += '&entityId=' + filterParams.entityId;
	
	      query += '&startDate=' + filterParams.startDate.toUniversalFormat();
	      query += '&endDate=' + filterParams.endDate.toUniversalFormat();
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/list/delivered' + query);
	    }
	  }, {
	    key: 'locationVehicles',
	    value: function locationVehicles(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/locationvehicles/' + entityId);
	    }
	  }, {
	    key: 'createFromPriceList',
	    value: function createFromPriceList(entityId, priceListId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/vehicle/createfrompricelist/' + entityId + '/' + priceListId));
	    }
	  }]);
	  return VehicleService;
	}();
	
	exports.default = VehicleService;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleAppraisal = __webpack_require__(1137);
	
	var _vehicleAppraisal2 = _interopRequireDefault(_vehicleAppraisal);
	
	var _basicDetails = __webpack_require__(1142);
	
	var _basicDetails2 = _interopRequireDefault(_basicDetails);
	
	var _bodywork = __webpack_require__(1149);
	
	var _bodywork2 = _interopRequireDefault(_bodywork);
	
	var _reconCost = __webpack_require__(1156);
	
	var _reconCost2 = _interopRequireDefault(_reconCost);
	
	var _appraisalConclude = __webpack_require__(1162);
	
	var _appraisalConclude2 = _interopRequireDefault(_appraisalConclude);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleAppraisalModule = _angular2.default.module('vehicleAppraisal', [_angularUiRouter2.default, _basicDetails2.default, _reconCost2.default, _bodywork2.default, _appraisalConclude2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleTradeIn', {
	    url: '/vehicle/tradeIn',
	    component: 'vehicleAppraisal',
	    params: {
	      origin: {},
	      contactId: null,
	      enquiryId: null,
	      settlement: null
	    }
	  });
	
	  $stateProvider.state('editAppraisal', {
	    url: '/vehicle/editAppraisal/:vehicleId',
	    component: 'vehicleAppraisal',
	    params: {
	      origin: {},
	      enquiryId: null,
	      settlement: null
	    }
	  });
	}]).component('vehicleAppraisal', _vehicleAppraisal2.default).name;
	
	exports.default = vehicleAppraisalModule;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleAppraisal = __webpack_require__(1138);
	
	var _vehicleAppraisal2 = _interopRequireDefault(_vehicleAppraisal);
	
	var _vehicleAppraisal3 = __webpack_require__(1139);
	
	var _vehicleAppraisal4 = _interopRequireDefault(_vehicleAppraisal3);
	
	__webpack_require__(1140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleAppraisalComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicleAppraisal: '='
	  },
	  template: _vehicleAppraisal2.default,
	  controller: _vehicleAppraisal4.default
	};
	
	exports.default = vehicleAppraisalComponent;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Vehicle Appraisal</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editVehicle()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n        <a class=\"btn btn-success\" ng-click=\"$ctrl.editVehicle(true)\" ng-show=\"$ctrl.vehicleAppraisal.vehicleAppraisalId && $ctrl.$stateParams.enquiryId\">\r\n          <span class=\"glyphicon glyphicon-print\"></span>\r\n          <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n          {{ $ctrl.state !== 'Saving' ? 'Save Changes and Print' : 'Saving Changes ...' }}\r\n      </a>        \r\n        <a\r\n          class=\"btn btn-warning\"\r\n          ng-hide=\"$ctrl.params.isEntityManagement\"\r\n          ng-click=\"$ctrl.redirectToParent()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n            Cancel\r\n        </a>\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"editVehicle\">\r\n    <div class=\"panel\">\r\n        <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n\r\n          <div class=\"col-md-12\" block-ui=\"editEnquiry\">\r\n            <div class=\"panel\">\r\n                <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n                  <uib-accordion close-others=\"true\">\r\n\r\n                    <!-- Basic Details Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.basicDetails\">\r\n                      <uib-accordion-heading>\r\n                            Basic Details\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.basicDetails, 'glyphicon-chevron-down': !$ctrl.panels.basicDetails}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <basic-Details vehicle-Appraisal=\"$ctrl.vehicleAppraisal\" settlement=\"$ctrl.settlement\" on-Reset-Vehicle=\"$ctrl.resetVehicle(autoSold)\" on-Vehicle-Lookup=\"$ctrl.showMazdaServiceHistory()\"></basic-Details>\r\n                    </div>\r\n                    <!-- Basic Details End -->\r\n\r\n                    <!-- Bodywork Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.bodywork\">\r\n                      <uib-accordion-heading>\r\n                            Vehicle Bodywork\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.bodywork, 'glyphicon-chevron-down': !$ctrl.panels.bodywork}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <bodywork vehicle-Appraisal=\"$ctrl.vehicleAppraisal\"></bodywork>\r\n                    </div>\r\n                    <!-- Bodywork End -->\r\n\r\n                    <!-- Notes Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.notes\">\r\n                        <uib-accordion-heading>\r\n                              Notes\r\n                              <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.notes, 'glyphicon-chevron-down': !$ctrl.panels.notes}\"></i>\r\n                        </uib-accordion-heading>\r\n  \r\n                        <textarea class=\"form-control\" ng-model=\"$ctrl.vehicleAppraisal.notes\" rows=\"10\" maxlength=\"500\"></textarea>\r\n                      </div>\r\n                    <!-- Notes End -->\r\n\r\n                    <!-- Recon Cost Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reconCost\">\r\n                      <uib-accordion-heading>\r\n                            Reconditioning Cost\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reconCost, 'glyphicon-chevron-down': !$ctrl.panels.reconCost}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <recon-Cost vehicle-Appraisal=\"$ctrl.vehicleAppraisal\"></recon-Cost>\r\n                    </div>\r\n                    <!-- Recon Cost End -->\r\n\r\n                    <!-- Appraisal Conclude Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.conclude\">\r\n                      <uib-accordion-heading>\r\n                            Conclude\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.conclude, 'glyphicon-chevron-down': !$ctrl.panels.conclude}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <appraisal-conclude vehicle-Appraisal=\"$ctrl.vehicleAppraisal\"></appraisal-conclude>\r\n                    </div>\r\n                    <!-- Appraisal Conclude End -->                    \r\n\r\n                    <!-- Media Items Begin -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.media\">\r\n                      <uib-accordion-heading>\r\n                            Media Items\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.media, 'glyphicon-chevron-down': !$ctrl.panels.media}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <vehicle-Images vehicle=\"$ctrl.vehicleAppraisal.vehicle\" form-validation-service=\"$ctrl.formValidationService\"></vehicle-Images>\r\n                    </div>\r\n                    <!-- Media Items End -->\r\n\r\n                    <!-- Service History -->\r\n                    <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.serviceHistory\">\r\n                      <uib-accordion-heading>\r\n                            Service History\r\n                            <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.serviceHistory, 'glyphicon-chevron-down': !$ctrl.panels.serviceHistory}\"></i>\r\n                      </uib-accordion-heading>\r\n\r\n                      <service-history vehicle=\"$ctrl.vehicleAppraisal.vehicle\"></service-history>\r\n                    </div>\r\n                    <!-- Media Items End -->                    \r\n\r\n                  </uib-accordion>\r\n                </form>\r\n              </div>\r\n            </div>\r\n\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleAppraisalController = function () {
	  VehicleAppraisalController.$inject = ["authService", "$state", "enums", "vehicleService", "loadingService", "$stateParams", "$scope", "printService", "lookupService"];
	  function VehicleAppraisalController(authService, $state, enums, vehicleService, loadingService, $stateParams, $scope, printService, lookupService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleAppraisalController);
	    this.authService = authService;
	    this.$state = $state;
	    this.enums = enums;
	    this.vehicleService = vehicleService;
	    this.loadingService = loadingService;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.printService = printService;
	    this.lookupService = lookupService;
	
	    this.formValidationService = new _FormValidationService2.default();
	
	    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.Add, true)) {
	      return;
	    }
	
	    this.panels = {
	      'basicDetails': true
	    };
	
	    this.state = '';
	    this.settlement = this.$stateParams.settlement;
	
	    this.vehicleAppraisal = {
	      imageUrl: '/images/appraisal.png',
	      imageBase: null,
	      vehicleTraderId: null,
	      financeCompanyId: null,
	      appearance: null,
	      roadTest: null
	    };
	    this.resetVehicle();
	
	    this.origin = $stateParams.origin;
	
	    this.loadVehicleAppraisal();
	  }
	
	  (0, _createClass3.default)(VehicleAppraisalController, [{
	    key: 'resetVehicle',
	    value: function resetVehicle(autoSold) {
	      var reg = void 0;
	
	      if (this.vehicleAppraisal.vehicle) {
	        reg = this.vehicleAppraisal.vehicle.registration;
	      }
	
	      this.vehicleAppraisal.vehicle = {
	        registration: reg,
	        entityId: this.authService.authData.currentLocation.key,
	        vehicleCondition: this.enums.VEHICLE_CONDITION.Used,
	        autoSold: autoSold || null,
	        mediaItems: [],
	        brandModelId: null
	      };
	
	      this.configureForm();
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.vehicleAppraisal);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'autoSold',
	        displayName: 'Trade / Retail',
	        model: ctrl.vehicleAppraisal.vehicle,
	        type: 'select',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'registration',
	        displayName: 'Registration',
	        model: ctrl.vehicleAppraisal.vehicle,
	        type: 'text',
	        required: true
	      });
	
	      if (this.$state.current.name === 'vehicleTradeIn') {
	        ctrl.formValidationService.addField({
	          fieldName: 'mileage',
	          displayName: 'Mileage',
	          model: ctrl.vehicleAppraisal.vehicle,
	          type: 'int',
	          required: true
	        });
	      }
	
	      ctrl.formValidationService.addField({
	        fieldName: 'brandModelId',
	        displayName: 'Model',
	        model: ctrl.vehicleAppraisal.vehicle,
	        required: true
	      });
	
	      this.$scope.$broadcast('vehicleAppraisal:parentFormConfigured');
	    }
	  }, {
	    key: 'editVehicle',
	    value: function editVehicle(print) {
	      var _this = this;
	
	      var ctrl = this;
	
	      if (!ctrl.formValidationService.validateForm() || !this.allowanceCheck()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editVehicle', 'Saving Changes ...');
	
	      //massage data
	      if (typeof ctrl.vehicleAppraisal.vehicle.brandModel === 'string') {
	        ctrl.vehicleAppraisal.vehicle.brandModel = null;
	      }
	
	      if (!ctrl.vehicleAppraisal.allowance) {
	        ctrl.vehicleAppraisal.allowance = 0;
	      }
	
	      ctrl.vehicleService.editVehicleAppraisal(ctrl.$stateParams.contactId, ctrl.$stateParams.enquiryId, ctrl.vehicleAppraisal).then(function (response) {
	        _this.state = 'Saved';
	
	        if (print) {
	          ctrl.printService.printVehicleAppraisal(ctrl.vehicleAppraisal.vehicleAppraisalId, ctrl.$stateParams.enquiryId);
	        }
	
	        ctrl.redirectToParent(response.data);
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editVehicle');
	      });
	    }
	  }, {
	    key: 'allowanceCheck',
	    value: function allowanceCheck() {
	      if (this.vehicleAppraisal.overAllowance && this.vehicleAppraisal.overAllowance > this.vehicleAppraisal.allowance) {
	        this.formValidationService.addModelError('allowance', 'Overallowance cannot be greater than allowance');
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(vehicleId) {
	      if (this.origin.source) {
	        var output = this.origin.processResult(vehicleId, this.vehicleAppraisal, this.settlement);
	        this.$state.go(output.stateName, output.params);
	      } else {
	        this.$state.go('vehicleList');
	      }
	    }
	  }, {
	    key: 'loadVehicleAppraisal',
	    value: function loadVehicleAppraisal() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      if (ctrl.$stateParams.vehicleId) {
	        ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle ...');
	
	        ctrl.vehicleService.getVehicleAppraisal(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.vehicleId, ctrl.$stateParams.enquiryId).then(function (response) {
	          (0, _assign2.default)(ctrl.vehicleAppraisal, response.data);
	
	          _this2.loadExtras();
	
	          _this2.configureForm();
	
	          _this2.showMazdaServiceHistory();
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('vehicleInfo');
	        });
	      } else {
	        this.configureForm();
	      }
	    }
	  }, {
	    key: 'loadExtras',
	    value: function loadExtras() {
	      var ctrl = this;
	
	      var nctExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'NCT Expiry Date';
	      });
	      var taxExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'Tax Expiry Date';
	      });
	      var prevOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'Previous Owners';
	      });
	
	      if (nctExpiry) {
	        ctrl.vehicleAppraisal.vehicle.nctExpiry = nctExpiry.value;
	      }
	
	      if (taxExpiry) {
	        ctrl.vehicleAppraisal.vehicle.taxExpiry = taxExpiry.value;
	      }
	
	      if (prevOwners) {
	        ctrl.vehicleAppraisal.vehicle.prevOwners = prevOwners.value;
	      }
	    }
	  }, {
	    key: 'showMazdaServiceHistory',
	    value: function showMazdaServiceHistory() {
	      var _this3 = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        var mazdaBrand = (0, _lodash.find)(brands, function (b) {
	          return b.name.toLowerCase() === 'mazda';
	        });
	
	        _this3.$scope.$broadcast('vehicleEdit:lookupVehicleSelected', { chassisNo: _this3.vehicleAppraisal.vehicle.chassisNo, isMazda: _this3.vehicleAppraisal.vehicle.brandId == mazdaBrand.brandId });
	      });
	    }
	  }]);
	  return VehicleAppraisalController;
	}();
	
	exports.default = VehicleAppraisalController;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleAppraisal.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleAppraisal.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleAppraisal{color:red}", ""]);
	
	// exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _basicDetails = __webpack_require__(1143);
	
	var _basicDetails2 = _interopRequireDefault(_basicDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var basicDetailsModule = _angular2.default.module('basicDetails', [_angularUiRouter2.default]).component('basicDetails', _basicDetails2.default).name;
	
	exports.default = basicDetailsModule;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _basicDetails = __webpack_require__(1144);
	
	var _basicDetails2 = _interopRequireDefault(_basicDetails);
	
	var _basicDetails3 = __webpack_require__(1145);
	
	var _basicDetails4 = _interopRequireDefault(_basicDetails3);
	
	__webpack_require__(1147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var basicDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicleAppraisal: '=',
	    settlement: '=',
	    onResetVehicle: '&',
	    onVehicleLookup: '&'
	  },
	  template: _basicDetails2.default,
	  controller: _basicDetails4.default
	};
	
	exports.default = basicDetailsComponent;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehicleInfo\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-6\">                   \r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Reg *</label>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <input class=\"form-control\" placeholder=\"Registration\" maxlength=\"20\" ng-model=\"$ctrl.vehicleAppraisal.vehicle.registration\" ng-disabled=\"$ctrl.vehicleAppraisal.vehicleAppraisalId\" input-restrictor/>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.lookupVehicle()\" ng-disabled=\"$ctrl.vehicleAppraisal.vehicleAppraisalId\">\r\n              <span class=\"glyphicon glyphicon-search\"></span>\r\n            </button>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Mileage *</label>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <input type=\"number\" class=\"form-control\" placeholder=\"Mileage\" ng-model=\"$ctrl.vehicleAppraisal.vehicle.mileage\" ng-disabled=\"$ctrl.vehicleAppraisal.vehicleAppraisalId\"/>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-disabled=\"$ctrl.vehicleAppraisal.vehicleAppraisalId\"\r\n              ng-change=\"$ctrl.updateModelFromSelect('mileageType')\"\r\n              ng-options=\"item.name for item in $ctrl.selectOptions.mileageType track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.mileageType\">\r\n            </select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>T/R *</label>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-disabled=\"$ctrl.vehicleAppraisal.vehicleAppraisalId\"\r\n                ng-options=\"item.id as item.name for item in $ctrl.autoSolds\"\r\n                ng-model=\"$ctrl.vehicleAppraisal.vehicle.autoSold\">\r\n              </select>\r\n          </div>\r\n      </div>         \r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Allowance</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          <input type=\"number\" class=\"form-control\" placeholder=\"Allowance\" ng-model=\"$ctrl.vehicleAppraisal.allowance\"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Over</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          <input type=\"number\" class=\"form-control\" placeholder=\"Over Allowance\" ng-model=\"$ctrl.vehicleAppraisal.overAllowance\"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Settlement</label>\r\n      </div>\r\n      <div class=\"col-md-9\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Settlement\" ng-model=\"$ctrl.settlement\"/>\r\n      </div>\r\n    </div>    \r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Settlement With</label>\r\n      </div>\r\n      <div class=\"col-md-9\">\r\n        <select\r\n          class=\"form-control\"\r\n          ng-options=\"item.financeCompanyId as item.name for item in $ctrl.financeCompanies\"\r\n          ng-model=\"$ctrl.vehicleAppraisal.financeCompanyId\">\r\n        </select>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Vehicle Trader</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.vehicleTraderId as item.name for item in $ctrl.vehicleTraders\"\r\n            ng-model=\"$ctrl.vehicleAppraisal.vehicleTraderId\">\r\n          </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Trader Offer</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          <input type=\"number\" class=\"form-control\" placeholder=\"Offer Value\" ng-model=\"$ctrl.vehicleAppraisal.traderOffer\"/>\r\n        </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Make</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.make}}\r\n          </div>\r\n      </div>      \r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Model</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          <div class=\"col-md-6\">\r\n              <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.brandModelId as item.name for item in $ctrl.brandModels\"\r\n              ng-model=\"$ctrl.vehicleAppraisal.vehicle.brandModelId\"\r\n              ng-change=\"$ctrl.updateBrandModel()\">\r\n              </select>                \r\n          </div>            \r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Variant</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.variant}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Code</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.variantCode}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Colour</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.colorName}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Transmission</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.transmissionTypeName}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Fuel Type</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.fuelTypeName}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Chassis No</label>\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            {{$ctrl.vehicleAppraisal.vehicle.chassisNo}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>NCT Expiry</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          {{$ctrl.vehicleAppraisal.vehicle.nctExpiry}}\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Tax Expiry</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          {{$ctrl.vehicleAppraisal.vehicle.taxExpiry}}\r\n        </div>\r\n      </div>   \r\n      \r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Previous Owners</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          {{$ctrl.vehicleAppraisal.vehicle.prevOwners}}\r\n        </div>\r\n      </div>  \r\n      \r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>UK Reg</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          {{$ctrl.vehicleAppraisal.vehicle.ukReg}}\r\n        </div>\r\n      </div>        \r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>UK Owners</label>\r\n        </div>\r\n        <div class=\"col-md-9\">\r\n          {{$ctrl.vehicleAppraisal.vehicle.ukOwners}}\r\n        </div>\r\n      </div>        \r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _manualModelSelectModal = __webpack_require__(1146);
	
	var _manualModelSelectModal2 = _interopRequireDefault(_manualModelSelectModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BasicDetailsController = function () {
	  BasicDetailsController.$inject = ["authService", "enums", "lookupService", "loadingService", "$uibModal", "$scope", "vehicleTraderManagementService", "financeCompaniesManagementService"];
	  function BasicDetailsController(authService, enums, lookupService, loadingService, $uibModal, $scope, vehicleTraderManagementService, financeCompaniesManagementService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, BasicDetailsController);
	    this.authService = authService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.vehicleTraderManagementService = vehicleTraderManagementService;
	    this.financeCompaniesManagementService = financeCompaniesManagementService;
	
	    this.selectOptions = {};
	    this.selectDefaults = {};
	    this.financeCompanies = [];
	
	    this.brandModels = this.getBrandModels();
	
	    this.initializeLookups();
	
	    this.$scope.$on('vehicleAppraisal:parentFormConfigured', function () {
	      _this.reverseLookup();
	    });
	  }
	
	  (0, _createClass3.default)(BasicDetailsController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var ctrl = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        //Remove 'All Brands' item from this list
	        brands.shift();
	
	        ctrl.allBrands = brands;
	
	        ctrl.lookupService.lookupBrandModels().then(function (brandModels) {
	          ctrl.allBrandModels = brandModels;
	
	          ctrl.initializeVehicleTraders();
	          ctrl.initializeEnums();
	          ctrl.loadFinanceCompanies();
	        });
	      });
	    }
	  }, {
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'MILEAGE_TYPE', propName: 'mileageType' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionType' }, { enumName: 'FUEL_TYPE', propName: 'fuelType' }, { enumName: 'COLOR', propName: 'color' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = enumsArray[0];
	        ctrl.updateModelFromSelect(item.propName);
	      });
	
	      this.initializeTradeRetail();
	    }
	  }, {
	    key: 'initializeTradeRetail',
	    value: function initializeTradeRetail() {
	      this.autoSolds = [];
	      this.autoSolds.push({ id: null, name: 'Please Select' });
	      this.autoSolds.push({ id: 1, name: 'Retail' });
	      this.autoSolds.push({ id: 2, name: 'Trade' });
	    }
	  }, {
	    key: 'initializeVehicleTraders',
	    value: function initializeVehicleTraders() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      this.vehicleTraderManagementService.list(this.authService.authData.currentLocation.key).then(function (response) {
	        _this2.vehicleTraders = response.data.items;
	        _this2.vehicleTraders.unshift({ vehicleTraderId: null, name: 'Please Select' });
	      });
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: defaultOptionText || 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      var val = this.selectDefaults[selectDefaultProperty][idProperty];
	      eval('this.vehicleAppraisal.vehicle.' + modelProperty + ' = ' + val);
	    }
	  }, {
	    key: 'lookupVehicle',
	    value: function lookupVehicle() {
	      var ctrl = this;
	      var currentMileage = ctrl.vehicleAppraisal.vehicle.mileage;
	      var mediaItems = ctrl.vehicleAppraisal.vehicle.mediaItems;
	      var autoSold = ctrl.vehicleAppraisal.vehicle.autoSold;
	
	      ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle Information');
	
	      ctrl.lookupService.lookupVehicleByRegNo(ctrl.authService.authData.currentLocation.key, ctrl.vehicleAppraisal.vehicle.vehicleCondition, ctrl.vehicleAppraisal.vehicle.registration).then(function (response) {
	        (0, _assign2.default)(ctrl.vehicleAppraisal.vehicle, response.data);
	        ctrl.vehicleAppraisal.vehicle.mileage = currentMileage;
	        ctrl.vehicleAppraisal.vehicle.entityId = ctrl.authService.authData.currentLocation.key;
	        ctrl.vehicleAppraisal.vehicle.autoSold = autoSold;
	        ctrl.vehicleAppraisal.vehicle.mediaItems = mediaItems;
	
	        ctrl.loadExtras();
	        ctrl.reverseLookup();
	        ctrl.onVehicleLookup();
	      }).catch(function (err) {
	        ctrl.onResetVehicle({ autoSold: ctrl.vehicleAppraisal.vehicle.autoSold });
	
	        ctrl.manualSelect();
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleInfo');
	      });
	    }
	  }, {
	    key: 'loadExtras',
	    value: function loadExtras() {
	      var ctrl = this;
	
	      var nctExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'NCT Expiry';
	      });
	      var taxExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'Tax Expiry Date';
	      });
	      var prevOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'Previous Owners';
	      });
	      var ukReg = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'UK Reg';
	      });
	      var ukOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
	        return o.key === 'UK Previous Owners';
	      });
	
	      if (nctExpiry) {
	        ctrl.vehicleAppraisal.vehicle.nctExpiry = nctExpiry.value;
	      }
	
	      if (taxExpiry) {
	        ctrl.vehicleAppraisal.vehicle.taxExpiry = taxExpiry.value;
	      }
	
	      if (prevOwners) {
	        ctrl.vehicleAppraisal.vehicle.prevOwners = prevOwners.value;
	      }
	
	      if (ukReg) {
	        ctrl.vehicleAppraisal.vehicle.ukReg = ukReg.value;
	      }
	
	      if (ukOwners) {
	        ctrl.vehicleAppraisal.vehicle.ukOwners = ukOwners.value;
	      }
	    }
	  }, {
	    key: 'reverseLookup',
	    value: function reverseLookup() {
	      var _this3 = this;
	
	      var make = (0, _lodash.find)(this.allBrands, function (o) {
	        return o.brandId === _this3.vehicleAppraisal.vehicle.brandId;
	      });
	      var model = this.vehicleAppraisal.vehicle.brandModelId ? (0, _lodash.find)(this.allBrandModels, function (o) {
	        return o.brandModelId === _this3.vehicleAppraisal.vehicle.brandModelId;
	      }) : null;
	      var color = (0, _lodash.find)(this.selectOptions.color, function (o) {
	        return o.id === _this3.vehicleAppraisal.vehicle.color;
	      });
	      var transmissionType = (0, _lodash.find)(this.selectOptions.transmissionType, function (o) {
	        return o.id === _this3.vehicleAppraisal.vehicle.transmissionType;
	      });
	      var fuelType = (0, _lodash.find)(this.selectOptions.fuelType, function (o) {
	        return o.id === _this3.vehicleAppraisal.vehicle.fuelType;
	      });
	
	      this.vehicleAppraisal.vehicle.make = make.name;
	
	      if (model) {
	        this.vehicleAppraisal.vehicle.model = make.name + ' ' + model.name;
	      }
	
	      if (color) {
	        this.vehicleAppraisal.vehicle.colorName = color.name;
	      }
	
	      if (transmissionType) {
	        this.vehicleAppraisal.vehicle.transmissionTypeName = transmissionType.name;
	      }
	
	      if (fuelType) {
	        this.vehicleAppraisal.vehicle.fuelTypeName = fuelType.name;
	      }
	
	      this.brandModels = this.getBrandModels(this.vehicleAppraisal.vehicle.brandId);
	    }
	  }, {
	    key: 'manualSelect',
	    value: function manualSelect() {
	      this.$scope.errMsg = '';
	      this.selectedBrand = this.allBrands[0];
	      this.updateBrandModels();
	
	      this.modalInstance = this.$uibModal.open({
	        template: _manualModelSelectModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'cancelManualSelect',
	    value: function cancelManualSelect() {
	      this.modalInstance.close();
	    }
	  }, {
	    key: 'updateBrandModels',
	    value: function updateBrandModels() {
	      var _this4 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this4.selectedBrand.brandId;
	      });
	      this.selectedBrandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'selectModelManually',
	    value: function selectModelManually() {
	      this.vehicleAppraisal.vehicle.brandId = this.selectedBrand.brandId;
	      this.vehicleAppraisal.vehicle.brandModelId = this.selectedBrandModel.brandModelId;
	
	      this.reverseLookup();
	      this.cancelManualSelect();
	    }
	  }, {
	    key: 'getBrandModels',
	    value: function getBrandModels(brandId) {
	      var brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === brandId;
	      });
	
	      brandModels.unshift({ brandModelId: null, brandId: brandId, name: 'Please Select' });
	
	      return brandModels;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this5 = this;
	
	      var make = (0, _lodash.find)(this.allBrands, function (o) {
	        return o.brandId === _this5.vehicleAppraisal.vehicle.brandId;
	      });
	      var model = this.vehicleAppraisal.vehicle.brandModelId ? (0, _lodash.find)(this.allBrandModels, function (o) {
	        return o.brandModelId === _this5.vehicleAppraisal.vehicle.brandModelId;
	      }) : null;
	
	      if (model) {
	        this.vehicleAppraisal.vehicle.model = make.name + ' ' + model.name;
	      }
	    }
	  }, {
	    key: 'loadFinanceCompanies',
	    value: function loadFinanceCompanies() {
	      var _this6 = this;
	
	      this.financeCompaniesManagementService.listFinanceCompanies(this.authService.authData.currentLocation.key).then(function (response) {
	        _this6.financeCompanies = response.data.items;
	        _this6.financeCompanies.unshift({ 'financeCompanyId': null, name: 'Please Select' });
	      });
	    }
	  }]);
	  return BasicDetailsController;
	}();
	
	exports.default = BasicDetailsController;

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    Vehicle Lookup Result\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n      <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n      </div>\r\n\r\n      <div ng-hide=\"doManualSelect\">\r\n        The Vehicle with Registration <b>{{$ctrl.vehicleAppraisal.vehicle.registration}}</b> could not be found. Do you want to manually select the make and model ?\r\n      </div>\r\n\r\n      <div ng-show=\"doManualSelect\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            Brand\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.updateBrandModels()\"\r\n              ng-options=\"item.name for item in $ctrl.allBrands track by item.brandId\"\r\n              ng-model=\"$ctrl.selectedBrand\">\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            Model\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n              ng-model=\"$ctrl.selectedBrandModel\">\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n                    <button type=\"submit\" ng-click=\"$ctrl.selectModelManually()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\" ng-show=\"doManualSelect\">\r\n                        Select Model\r\n                    </button>\r\n\r\n                    <div ng-hide=\"doManualSelect\">\r\n                      <a class=\"btn btn-primary btn-lg\" ng-click=\"doManualSelect = true\">Yes</a>\r\n                      <a class=\"btn btn-warning btn-lg\" ng-click=\"$ctrl.cancelManualSelect()\">No</a>\r\n                    </div>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./basicDetails.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./basicDetails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".basicDetails{color:red}", ""]);
	
	// exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bodywork = __webpack_require__(1150);
	
	var _bodywork2 = _interopRequireDefault(_bodywork);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bodyworkModule = _angular2.default.module('bodywork', [_angularUiRouter2.default]).component('bodywork', _bodywork2.default).name;
	
	exports.default = bodyworkModule;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bodywork = __webpack_require__(1151);
	
	var _bodywork2 = _interopRequireDefault(_bodywork);
	
	var _bodywork3 = __webpack_require__(1152);
	
	var _bodywork4 = _interopRequireDefault(_bodywork3);
	
	__webpack_require__(1154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bodyworkComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicleAppraisal: '='
	  },
	  template: _bodywork2.default,
	  controller: _bodywork4.default
	};
	
	exports.default = bodyworkComponent;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"appraisal-container\">\r\n  <input type=\"button\" class=\"btn btn-warning\" value=\"Reset\" ng-click=\"$ctrl.reset()\"/>\r\n</div>\r\n"

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _canvasStuff = __webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BodyworkController = function () {
	  BodyworkController.$inject = ["vehicleService", "$scope"];
	  function BodyworkController(vehicleService, $scope) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, BodyworkController);
	    this.vehicleService = vehicleService;
	    this.$scope = $scope;
	
	    this.height = 900;
	    this.width = 700;
	
	    this.editImage();
	
	    this.$scope.$on('vehicleAppraisal:parentFormConfigured', function () {
	      _this.editImage();
	    });
	  }
	
	  (0, _createClass3.default)(BodyworkController, [{
	    key: 'editImage',
	    value: function editImage(img) {
	      var ctrl = this;
	
	      var height = this.height;
	      var width = this.width;
	      //var $imgToLoad = $('#appraisalImage');
	      //var height = parseInt($imgToLoad.height());
	      //var width = parseInt($imgToLoad.width());
	
	      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'' + this.vehicleAppraisal.imageUrl + '\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + '" height="' + height + '" style="opacity: .33;" id="sig-canvas"></canvas></div>');
	      $('.appraisal-container').empty().append($divCanvas);
	      (0, _canvasStuff.doMagic)(this.saveEdit.bind(this));
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      (0, _canvasStuff.clearCanvas)();
	      this.saveEdit();
	    }
	  }, {
	    key: 'saveEdit',
	    value: function saveEdit() {
	      var ctrl = this;
	      var imgData = (0, _canvasStuff.getCanvasData)();
	
	      this.vehicleService.annotateImage(this.height, this.width, this.vehicleAppraisal.imageBase, imgData).then(function (response) {
	        ctrl.vehicleAppraisal.imageUrl = response.data;
	      });
	    }
	  }]);
	  return BodyworkController;
	}();
	
	exports.default = BodyworkController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.doMagic = doMagic;
	exports.clearCanvas = clearCanvas;
	exports.getCanvasData = getCanvasData;
	exports.isCanvasEmpty = isCanvasEmpty;
	function doMagic(mouseUpHandler, isSignature) {
	  // Set up the canvas
	  var canvas = document.getElementById("sig-canvas");
	  var ctx = canvas.getContext("2d");
	  //ctx.strokeStyle = "#222222";
	  //ctx.lineWith = 2;
	
	  ctx.strokeStyle = isSignature ? '#000' : 'red';
	  ctx.lineJoin = 'round';
	  ctx.lineCap = 'round';
	  ctx.lineWidth = isSignature ? 2 : 10;
	
	  // Set up mouse events for drawing
	  var drawing = false;
	  var mousePos = { x: 0, y: 0 };
	  var lastPos = mousePos;
	  canvas.addEventListener("mousedown", function (e) {
	    drawing = true;
	    lastPos = getMousePos(canvas, e);
	  }, false);
	  canvas.addEventListener("mouseup", function (e) {
	    drawing = false;
	    if (mouseUpHandler) {
	      mouseUpHandler();
	    }
	  }, false);
	  canvas.addEventListener("mousemove", function (e) {
	    mousePos = getMousePos(canvas, e);
	  }, false);
	
	  // Get the position of the mouse relative to the canvas
	  function getMousePos(canvasDom, mouseEvent) {
	    var rect = canvasDom.getBoundingClientRect();
	    return {
	      x: mouseEvent.clientX - rect.left,
	      y: mouseEvent.clientY - rect.top
	    };
	  }
	
	  // Get a regular interval for drawing to the screen
	  window.requestAnimFrame = function (callback) {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimaitonFrame || function (callback) {
	      window.setTimeout(callback, 1000 / 60);
	    };
	  }();
	
	  // Draw to the canvas
	  function renderCanvas() {
	    if (drawing) {
	      ctx.moveTo(lastPos.x, lastPos.y);
	      ctx.lineTo(mousePos.x, mousePos.y);
	      ctx.stroke();
	      lastPos = mousePos;
	    }
	  }
	
	  // Allow for animation
	  (function drawLoop() {
	    requestAnimFrame(drawLoop);
	    renderCanvas();
	  })();
	
	  // Set up touch events for mobile, etc
	  canvas.addEventListener("touchstart", function (e) {
	    mousePos = getTouchPos(canvas, e);
	    var touch = e.touches[0];
	    var mouseEvent = new MouseEvent("mousedown", {
	      clientX: touch.clientX,
	      clientY: touch.clientY
	    });
	    canvas.dispatchEvent(mouseEvent);
	  }, false);
	  canvas.addEventListener("touchend", function (e) {
	    var mouseEvent = new MouseEvent("mouseup", {});
	    canvas.dispatchEvent(mouseEvent);
	  }, false);
	  canvas.addEventListener("touchmove", function (e) {
	    var touch = e.touches[0];
	    var mouseEvent = new MouseEvent("mousemove", {
	      clientX: touch.clientX,
	      clientY: touch.clientY
	    });
	    canvas.dispatchEvent(mouseEvent);
	  }, false);
	
	  // Get the position of a touch relative to the canvas
	  function getTouchPos(canvasDom, touchEvent) {
	    var rect = canvasDom.getBoundingClientRect();
	    return {
	      x: touchEvent.touches[0].clientX - rect.left,
	      y: touchEvent.touches[0].clientY - rect.top
	    };
	  }
	
	  // Prevent scrolling when touching the canvas
	  document.body.addEventListener("touchstart", function (e) {
	    if (e.target == canvas) {
	      e.preventDefault();
	    }
	  }, false);
	  document.body.addEventListener("touchend", function (e) {
	    if (e.target == canvas) {
	      e.preventDefault();
	    }
	  }, false);
	  document.body.addEventListener("touchmove", function (e) {
	    if (e.target == canvas) {
	      e.preventDefault();
	    }
	  }, false);
	}
	
	function clearCanvas(isSignature) {
	  var canvas = document.getElementById("sig-canvas");
	  canvas.width = canvas.width;
	
	  var ctx = canvas.getContext("2d");
	  ctx.strokeStyle = isSignature ? '#000' : 'red';
	  ctx.lineJoin = 'round';
	  ctx.lineCap = 'round';
	  ctx.lineWidth = isSignature ? 2 : 10;
	}
	
	function getCanvasData() {
	  var canvas = document.getElementById("sig-canvas");
	  return '=' + encodeURIComponent(canvas.toDataURL());
	}
	
	function isCanvasEmpty() {
	  var canvas = document.getElementById("sig-canvas");
	  var hiddenCanvas = document.getElementById("hidden-canvas");
	  return canvas.toDataURL() === hiddenCanvas.toDataURL();
	}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1155);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./bodywork.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./bodywork.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reconCost = __webpack_require__(1157);
	
	var _reconCost2 = _interopRequireDefault(_reconCost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reconCostModule = _angular2.default.module('reconCost', [_angularUiRouter2.default]).component('reconCost', _reconCost2.default).name;
	
	exports.default = reconCostModule;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reconCost = __webpack_require__(1158);
	
	var _reconCost2 = _interopRequireDefault(_reconCost);
	
	var _reconCost3 = __webpack_require__(1159);
	
	var _reconCost4 = _interopRequireDefault(_reconCost3);
	
	__webpack_require__(1160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reconCostComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicleAppraisal: '='
	  },
	  template: _reconCost2.default,
	  controller: _reconCost4.default
	};
	
	exports.default = reconCostComponent;

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Service</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Service\" ng-model=\"$ctrl.vehicleAppraisal.service\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.serviceNotes\" maxlength=\"100\"/>\r\n      </div>      \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Timing Belt</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Timing Belt\" ng-model=\"$ctrl.vehicleAppraisal.timingBelt\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.timingBeltNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Other</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Other\" ng-model=\"$ctrl.vehicleAppraisal.other\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.otherNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Bodywork</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Bodywork\" ng-model=\"$ctrl.vehicleAppraisal.bodywork\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.bodyworkNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Brakes</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Brakes\" ng-model=\"$ctrl.vehicleAppraisal.brakes\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.brakesNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Electrical</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Electrical\" ng-model=\"$ctrl.vehicleAppraisal.electrical\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.electricalNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Tyres</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Tyres\" ng-model=\"$ctrl.vehicleAppraisal.tyres\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.tyresNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Interior Repairs</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Interior Repairs\" ng-model=\"$ctrl.vehicleAppraisal.interiorRepairs\"/>\r\n      </div>\r\n      <div class=\"col-md-6\">\r\n        <input class=\"form-control\" placeholder=\"Description\" ng-model=\"$ctrl.vehicleAppraisal.interiorNotes\" maxlength=\"100\"/>\r\n      </div>            \r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReconCostController = function ReconCostController() {
	  (0, _classCallCheck3.default)(this, ReconCostController);
	};
	
	exports.default = ReconCostController;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1161);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./reconCost.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./reconCost.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reconCost{color:red}", ""]);
	
	// exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appraisalConclude = __webpack_require__(1163);
	
	var _appraisalConclude2 = _interopRequireDefault(_appraisalConclude);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appraisalConcludeModule = _angular2.default.module('appraisalConclude', [_angularUiRouter2.default]).component('appraisalConclude', _appraisalConclude2.default).name;
	
	exports.default = appraisalConcludeModule;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appraisalConclude = __webpack_require__(1164);
	
	var _appraisalConclude2 = _interopRequireDefault(_appraisalConclude);
	
	var _appraisalConclude3 = __webpack_require__(1165);
	
	var _appraisalConclude4 = _interopRequireDefault(_appraisalConclude3);
	
	__webpack_require__(1166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appraisalConcludeComponent = {
	  restrict: 'E',
	  bindings: {
	    vehicleAppraisal: '='
	  },
	  template: _appraisalConclude2.default,
	  controller: _appraisalConclude4.default
	};
	
	exports.default = appraisalConcludeComponent;

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <label>Spare Key</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <switch ng-model=\"$ctrl.vehicleAppraisal.spareKey\"></switch>\r\n      </div>            \r\n\r\n      <div class=\"col-md-3\">\r\n        <label>VLC</label>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <switch ng-model=\"$ctrl.vehicleAppraisal.vlc\"></switch>\r\n      </div>                  \r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Service History</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <switch ng-model=\"$ctrl.vehicleAppraisal.serviceHistory\"></switch>\r\n    </div>            \r\n\r\n    <div class=\"col-md-3\">\r\n      <label>HPI</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <switch ng-model=\"$ctrl.vehicleAppraisal.hpi\"></switch>\r\n    </div>                      \r\n  </div>  \r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Last Service Date</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <switch ng-model=\"$ctrl.vehicleAppraisal.lastService\"></switch>\r\n    </div>            \r\n\r\n    <div class=\"col-md-3\">\r\n      <label>CHC</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <switch ng-model=\"$ctrl.vehicleAppraisal.chc\"></switch>\r\n    </div>                   \r\n  </div> \r\n  \r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Appearance</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.id as item.name for item in $ctrl.appraisalQualityList\"\r\n        ng-model=\"$ctrl.vehicleAppraisal.appearance\">\r\n    </select>\r\n    </div>               \r\n\r\n    <div class=\"col-md-3\">\r\n      <label>Road Test</label>\r\n    </div>\r\n    <div class=\"col-md-3\">\r\n      <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.id as item.name for item in $ctrl.appraisalQualityList\"\r\n        ng-model=\"$ctrl.vehicleAppraisal.roadTest\">\r\n    </select>\r\n    </div>                   \r\n  </div>   \r\n\r\n</div>\r\n"

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppraisalConcludeController = function () {
	  AppraisalConcludeController.$inject = ["enums"];
	  function AppraisalConcludeController(enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AppraisalConcludeController);
	    this.enums = enums;
	
	    this.getAppraisalQuality();
	  }
	
	  (0, _createClass3.default)(AppraisalConcludeController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getAppraisalQuality',
	    value: function getAppraisalQuality() {
	      this.appraisalQualityList = this.convertEnumToKeyValueList(this.enums.APPRAISAL_QUALITY);
	      this.appraisalQualityList.unshift({ id: null, name: 'Please Select' });
	    }
	  }]);
	  return AppraisalConcludeController;
	}();
	
	exports.default = AppraisalConcludeController;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1167);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./appraisalConclude.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./appraisalConclude.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".appraisalConclude{color:red}", ""]);
	
	// exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _deliveredVehicles = __webpack_require__(1169);
	
	var _deliveredVehicles2 = _interopRequireDefault(_deliveredVehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveredVehiclesModule = _angular2.default.module('deliveredVehicles', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('deliveredVehicles', {
	    url: '/vehicle/delivered',
	    component: 'deliveredVehicles',
	    params: {
	      vehicleConditionSearch: null
	    }
	  });
	}]).component('deliveredVehicles', _deliveredVehicles2.default).name;
	
	exports.default = deliveredVehiclesModule;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deliveredVehicles = __webpack_require__(1170);
	
	var _deliveredVehicles2 = _interopRequireDefault(_deliveredVehicles);
	
	var _deliveredVehicles3 = __webpack_require__(1171);
	
	var _deliveredVehicles4 = _interopRequireDefault(_deliveredVehicles3);
	
	__webpack_require__(1172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveredVehiclesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _deliveredVehicles2.default,
	  controller: _deliveredVehicles4.default
	};
	
	exports.default = deliveredVehiclesComponent;

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"vehicleListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Delivered Vehicles</h2>\r\n      </header>\r\n\r\n        <section class=\"search\">\r\n\r\n          <span class=\"col-md-4 nopadding\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"dateRangeStart = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.filterParams.startDate\" is-open=\"dateRangeStart\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"dateRangeStart = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n          </span>\r\n\r\n          <span class=\"col-md-4 nopadding\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"dateRangeEnd = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.filterParams.endDate\" is-open=\"dateRangeEnd\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"dateRangeEnd = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listVehicles()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <div ng-show=\"$ctrl.published\">\r\n          {{$ctrl.publishMsg}}\r\n          <div ng-show=\"$ctrl.publishFileName\">\r\n            Click <a class=\"btn btn-link\" ng-click=\"$ctrl.viewPublishedFiled()\">here</a> to view the file\r\n          </div>\r\n        </div>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\" ng-hide=\"$ctrl.published\">\r\n            <thead>\r\n                <tr>\r\n                    <th>Image</th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('brand')\">\r\n                        Make <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('model')\">\r\n                        Model <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('registration')\">\r\n                        Registration <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('year')\">\r\n                        Sold <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('price')\">\r\n                        Est. Recon Cost <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('state')\">\r\n                        Recon Cost <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th>&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"v in $ctrl.vehicles\">\r\n                    <td>\r\n                        <img ng-src=\"{{v.imageUrl}}\" class=\"vehicleAvatar\"/>\r\n                    </td>\r\n                    <td>{{ v.brand }}</td>\r\n                    <td>{{ v.model }}</td>\r\n                    <td>{{ v.registration }}</td>\r\n                    <td>{{ v.sold | date : 'dd-MMMM-yyyy HH:mm' }}</td>\r\n                    <td>{{ v.estReconCost | currency:'&euro;':0 }}</td>\r\n                    <td>{{ v.actualReconCost | currency:'&euro;':0 }}</td>\r\n                    <td>\r\n                      <a ui-sref=\"vehicleEdit({vehicleId: v.vehicleId, origin: {source: 'deliveredVehicles', processResult: $ctrl.processResult}})\" class=\"btn btn-primary\">Edit</a>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.vehicles.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listVehicles()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveredVehiclesController = function () {
	  DeliveredVehiclesController.$inject = ["authService", "vehicleService", "loadingService", "lookupService", "enums", "$q", "$window", "appConfig", "$stateParams"];
	  function DeliveredVehiclesController(authService, vehicleService, loadingService, lookupService, enums, $q, $window, appConfig, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeliveredVehiclesController);
	    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.vehicleService = vehicleService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.enums = enums;
	    this.$q = $q;
	    this.$window = $window;
	    this.appConfig = appConfig;
	    this.$stateParams = $stateParams;
	
	    this.filterParams = {};
	
	    this.reset();
	  }
	
	  (0, _createClass3.default)(DeliveredVehiclesController, [{
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      var startDate = new Date();
	      var prev30Days = startDate.getDate() - 30;
	      startDate.setDate(prev30Days);
	
	      this.filterParams.startDate = startDate;
	      this.filterParams.endDate = new Date();
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: ctrl.publishMode ? -1 : 10
	      };
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'condition',
	        ascending: true
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listVehicles();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listVehicles();
	    }
	  }, {
	    key: 'listVehicles',
	    value: function listVehicles() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('vehicleListing', 'Loading Vehicles ...');
	
	      ctrl.vehicleService.listDeliveredVehicles(ctrl.filterParams).then(function (response) {
	        //response.data.items.map(entity => listCtrl.getActionsDropdown(entity));
	        ctrl.vehicles = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehicleListing');
	      });
	    }
	  }, {
	    key: 'processResult',
	    value: function processResult() {
	      return {
	        stateName: 'deliveredVehicles'
	      };
	    }
	  }]);
	  return DeliveredVehiclesController;
	}();
	
	exports.default = DeliveredVehiclesController;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1173);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveredVehicles.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveredVehicles.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".deliveredVehicles{color:red}", ""]);
	
	// exports


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _simiLookup = __webpack_require__(1175);
	
	var _simiLookup2 = _interopRequireDefault(_simiLookup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simiLookupModule = _angular2.default.module('simiLookup', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('simiLookup', {
	    url: '/vehicle/simiLookup',
	    component: 'simiLookup',
	    params: {
	      vehicleConditionSearch: null
	    }
	  });
	}]).component('simiLookup', _simiLookup2.default).name;
	
	exports.default = simiLookupModule;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simiLookup = __webpack_require__(1176);
	
	var _simiLookup2 = _interopRequireDefault(_simiLookup);
	
	var _simiLookup3 = __webpack_require__(1177);
	
	var _simiLookup4 = _interopRequireDefault(_simiLookup3);
	
	__webpack_require__(1178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simiLookupComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _simiLookup2.default,
	  controller: _simiLookup4.default
	};
	
	exports.default = simiLookupComponent;

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Simi Lookup</h2>\r\n        </header>\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-10 nopadding\">\r\n              <input class=\"form-control\" type=\"text\" placeholder=\"Search Vehicle by Registration Number\" ng-model=\"$ctrl.regNo\" />\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.lookupVehicle()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n        </section>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"vehicleData\">\r\n    <div class=\"panel\">\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.msg != ''\">\r\n          {{$ctrl.msg}}\r\n      </div>\r\n\r\n      <table ng-show=\"$ctrl.data\" class=\"vehicle-lookup\">\r\n        <tr>\r\n          <td class=\"col-md-5\"><b>Make</b></td>\r\n          <td class=\"col-md-7\">{{$ctrl.data.make}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Model</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.model}}</td>\r\n        </tr>        \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Variant</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.variant}}</td>\r\n        </tr>                \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Variant Code</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.variantCode}}</td>\r\n        </tr>                \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Registration</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.registration}}</td>\r\n        </tr> \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Chassis No</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.chassisNo}}</td>          \r\n        </tr>                               \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>First Registered</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.firstRegistration | date : 'dd-MMM-yyyy'}}</td>\r\n        </tr>                \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Year</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.year}}</td>          \r\n        </tr>                                   \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Engine Size</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.capacity}}</td>          \r\n        </tr>                                       \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Colour</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.colorName}}</td>          \r\n        </tr>                                        \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Body Type</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.vehicleBodyTypeName}}</td>          \r\n        </tr>                                  \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Transmission</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.transmissionTypeName}}</td>          \r\n        </tr>                                               \r\n        <tr>\r\n          <td class=\"col-md-3\"><b>Fuel Type</b></td>\r\n          <td class=\"col-md-9\">{{$ctrl.data.fuelTypeName}}</td>          \r\n        </tr>               \r\n        <tr ng-repeat=\"item in $ctrl.data.extras\">\r\n          <td class=\"col-md-3\"><b>{{item.key}}</b></td>\r\n          <td class=\"col-md-9\">{{item.value}}</td>          \r\n        </tr>                        \r\n      </table>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimiLookupController = function () {
	  SimiLookupController.$inject = ["authService", "lookupService", "loadingService", "enums", "$q"];
	  function SimiLookupController(authService, lookupService, loadingService, enums, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SimiLookupController);
	    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	    this.$q = $q;
	
	    this.regNo = '';
	    this.msg = '';
	    this.data = null;
	
	    this.initializeLookups();
	    this.loadEnumLists();
	  }
	
	  (0, _createClass3.default)(SimiLookupController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        _this.allBrands = brands;
	
	        _this.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this.allBrandModels = brandModels;
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'loadEnumLists',
	    value: function loadEnumLists() {
	      this.enumLists = {
	        color: this.convertEnumToKeyValueList(this.enums.COLOR),
	        vehicleBodyType: this.convertEnumToKeyValueList(this.enums.VEHICLE_BODY_TYPE),
	        transmissionType: this.convertEnumToKeyValueList(this.enums.TRANSMISSION_TYPE),
	        fuelType: this.convertEnumToKeyValueList(this.enums.FUEL_TYPE)
	      };
	    }
	  }, {
	    key: 'lookupVehicle',
	    value: function lookupVehicle() {
	      var _this2 = this;
	
	      this.msg = '';
	
	      if (!this.regNo) {
	        return;
	      }
	
	      this.loadingService.showLoading('vehicleData', 'Looking up vehicle ...');
	
	      this.lookupService.lookupVehicleByRegNo(this.authService.authData.currentLocation.key, 1, this.regNo, false).then(function (response) {
	        _this2.data = response.data;
	
	        _this2.data.make = (0, _lodash.find)(_this2.allBrands, function (o) {
	          return o.brandId === _this2.data.brandId;
	        }).name;
	        _this2.data.model = _this2.data.brandModelId ? (0, _lodash.find)(_this2.allBrandModels, function (o) {
	          return o.brandModelId === _this2.data.brandModelId;
	        }).name : '';
	        _this2.data.colorName = _this2.reverseLookup(_this2.enumLists.color, _this2.data.color);
	        _this2.data.vehicleBodyTypeName = _this2.reverseLookup(_this2.enumLists.vehicleBodyType, _this2.data.vehicleBodyType);
	        _this2.data.transmissionTypeName = _this2.reverseLookup(_this2.enumLists.transmissionType, _this2.data.transmissionType);
	        _this2.data.fuelTypeName = _this2.reverseLookup(_this2.enumLists.fuelType, _this2.data.fuelType);
	      }).catch(function (err) {
	        _this2.msg = 'Could not fetch vehicle ' + _this2.regNo + '. Please check registration number or lookup settings and try again';
	      }).finally(function () {
	        _this2.loadingService.hideLoading('vehicleData');
	      });
	    }
	  }, {
	    key: 'reverseLookup',
	    value: function reverseLookup(list, id) {
	      var item = (0, _lodash.find)(list, function (o) {
	        return o.id === id;
	      });
	
	      if (item) {
	        return item.name;
	      }
	    }
	  }]);
	  return SimiLookupController;
	}();
	
	exports.default = SimiLookupController;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1179);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./simiLookup.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./simiLookup.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".simiLookup{color:red}.vehicle-lookup{margin-top:10px;margin-left:auto;margin-right:auto}.vehicle-lookup td{padding-top:5px;padding-bottom:5px;border-bottom:1px solid #000}.vehicle-lookup tbody tr:nth-child(odd){background-color:#f9f9f9}.vehicle-lookup tbody tr:nth-child(2n){background-color:var(--report-even-row)}", ""]);
	
	// exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleAddSkupenet = __webpack_require__(1181);
	
	var _vehicleAddSkupenet2 = _interopRequireDefault(_vehicleAddSkupenet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleAddSkupenetModule = _angular2.default.module('vehicleAddSkupenet', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleAddSkupenet', {
	    url: '/vehicle/addskupenet',
	    component: 'vehicleAddSkupenet',
	    params: {
	      vehicleCondition: null,
	      autoSold: null,
	      vehicleStatus: null,
	      registration: null
	    }
	  });
	
	  $stateProvider.state('vehicleEditSkupenet', {
	    url: '/vehicle/editskupenet/',
	    component: 'vehicleAddSkupenet',
	    params: {
	      skupenetId: null,
	      price: null,
	      color: null
	    }
	  });
	}]).component('vehicleAddSkupenet', _vehicleAddSkupenet2.default).name;
	
	exports.default = vehicleAddSkupenetModule;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleAddSkupenet = __webpack_require__(1182);
	
	var _vehicleAddSkupenet2 = _interopRequireDefault(_vehicleAddSkupenet);
	
	var _vehicleAddSkupenet3 = __webpack_require__(1183);
	
	var _vehicleAddSkupenet4 = _interopRequireDefault(_vehicleAddSkupenet3);
	
	__webpack_require__(1184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleAddSkupenetComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleAddSkupenet2.default,
	  controller: _vehicleAddSkupenet4.default
	};
	
	exports.default = vehicleAddSkupenetComponent;

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-lg-9 col-md-7 mt-1-desktop-lg\">\r\n      <h1 class=\"dashboard-title\">Add Vehicle (Skupenet)</h1>\r\n  </div>\r\n  <div class=\"col-lg-3 col-md-5\">\r\n  </div>\r\n</div>\r\n\r\n<div ng-show=\"$ctrl.$stateParams.skupenetId\">\r\n  <h1>Redirecting to Skupenet ....</h1>\r\n</div>\r\n\r\n<div ng-hide=\"$ctrl.$stateParams.skupenetId\">\r\n    <div class=\"errors-panel\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <h4 ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please Correct the following errors before proceeding\r\n        </h4>\r\n        <ul class=\"errors\">\r\n            <li ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">{{msg}}</li>\r\n        </ul>\r\n    </div>\r\n    \r\n    <hr class=\"dashboard-seperator\">\r\n    \r\n    <div block-ui=\"vehicleInfo\">\r\n      \r\n      <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.vehicleCondition }\">\r\n              <label class=\"control-label col-sm-2\">New or Used *</label>\r\n              <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.enumLookupCollection.vehicleCondition\"\r\n                  ng-model=\"$ctrl.skupenetVehicle.vehicleCondition\">\r\n                </select>\r\n              </div>\r\n            </div>\r\n          \r\n            <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.autoSold }\">\r\n              <label class=\"control-label col-sm-2\">Sale Type *</label>\r\n              <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.enumLookupCollection.autoSold\"\r\n                  ng-model=\"$ctrl.skupenetVehicle.autoSold\">\r\n                </select>\r\n              </div>\r\n            </div>      \r\n    \r\n            <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.vehicleStatus }\">\r\n                <label class=\"control-label col-sm-2\">Status *</label>\r\n                <div class=\"col-sm-10\">\r\n                  <select\r\n                    class=\"form-control\"\r\n                    ng-options=\"item.id as item.name for item in $ctrl.enumLookupCollection.vehicleStatus\"\r\n                    ng-model=\"$ctrl.skupenetVehicle.vehicleStatus\">\r\n                  </select>\r\n                </div>\r\n              </div>        \r\n          \r\n            <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.registration }\">\r\n              <label class=\"control-label col-sm-2\">Registration *</label>\r\n              <div class=\"col-sm-10\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.skupenetVehicle.registration\" placeholder=\"Enter vehicle registration\" maxLength=20>\r\n              </div>\r\n            </div>\r\n    \r\n            <div class=\"form-group\">            \r\n                <div class=\"col-sm-10\" style=\"align-content: center\">\r\n                    <button type=\"submit\" class=\"btn btn-primary btn-lg\" ng-click=\"$ctrl.proceedToSkupenet()\">Proceed to Skupenet</button>\r\n                </div>\r\n            </div>                \r\n      </form>\r\n    \r\n    </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleAddSkupenetController = function () {
	  VehicleAddSkupenetController.$inject = ["lookupService", "authService", "enums", "loadingService", "$state", "$stateParams"];
	  function VehicleAddSkupenetController(lookupService, authService, enums, loadingService, $state, $stateParams) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleAddSkupenetController);
	    this.lookupService = lookupService;
	    this.authService = authService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.formValidationService = new _FormValidationService2.default();
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	
	    if (this.$stateParams.skupenetId) {
	      this.proceedToSkupenetEdit();
	    } else {
	      this.initializeEnumLookups();
	
	      this.skupenetVehicle = {
	        entityId: this.authService.authData.currentLocation.key,
	        skupenetUserId: this.authService.authData.currentLocation.webPublisherUsername,
	        registration: this.$stateParams.registration || this.getDefaultReg(),
	        vehicleCondition: this.$stateParams.vehicleCondition,
	        autoSold: this.$stateParams.autoSold,
	        vehicleStatus: this.$stateParams.vehicleStatus
	      };
	    }
	  }
	
	  (0, _createClass3.default)(VehicleAddSkupenetController, [{
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this = this;
	
	      var ctrl = this;
	      ctrl.selectDefaults = {};
	
	      var lookups = ['AutoSold', 'VehicleCondition', 'VehicleStatus'];
	      this.enumLookupCollection = [];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        _this.enumLookupCollection = enumLookupCollection;
	
	        (0, _lodash.map)(enumLookupCollection, function (itemsArray, index) {
	          //Only leave Due In or In Stock for Vehicle Status
	          if (index === 'vehicleStatus') {
	            itemsArray.unshift({ id: null, name: 'Please Select' });
	            enumLookupCollection['vehicleStatus'] = itemsArray.splice(0, 3);
	          }
	
	          itemsArray.unshift({ id: null, name: 'Please Select' });
	        });
	
	        _this.configureForm();
	      });
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.skupenetVehicle);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'vehicleCondition',
	        displayName: 'New or Used',
	        type: 'select',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'registration',
	        displayName: 'Registration',
	        type: 'text',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'autoSold',
	        displayName: 'Sale Type',
	        type: 'select',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'vehicleStatus',
	        displayName: 'Status',
	        type: 'select',
	        required: true
	      });
	    }
	  }, {
	    key: 'getDefaultReg',
	    value: function getDefaultReg() {
	      var dt = new Date();
	
	      var yr = dt.getFullYear().toString().substr(2, 2);
	      var month = dt.getMonth() <= 5 ? 1 : 2;
	
	      return '' + yr + month + 'D';
	    }
	  }, {
	    key: 'proceedToSkupenet',
	    value: function proceedToSkupenet() {
	      var _this2 = this;
	
	      if (!this.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.loadingService.showLoading('vehicleInfo', 'Creating Vehicle ...');
	
	      this.authService.getSkupenetToken(this.skupenetVehicle).then(function (response) {
	        var $form = $("<form></form>");
	        $form.attr('method', 'post');
	        $form.attr('action', 'http://www.easierad.ie/admin/thirdparty/api/edit');
	        $form.append('<input type="submit" id="skupenetSubmit" formtarget="_blank" style="display:none;" />');
	        $('body').append($form);
	
	        $form.append('<input type="hidden" name="dpid" value="' + _this2.authService.authData.currentLocation.webPublisherUsername + '" />');
	        $form.append('<input type="hidden" name="dpref" value="' + response.data.skupenetId + '" />');
	        $form.append('<input type="hidden" name="token" value="' + response.data.token + '" />');
	        $form.append('<input type="hidden" name="cat" value="428" />');
	        $form.append('<input type="hidden" name="f50" value="' + _this2.skupenetVehicle.registration + '" />');
	        $form.append('<input type="hidden" name="f18" value="" />');
	        $form.append('<input type="hidden" name="f46" value="km" />');
	        $form.append('<input type="hidden" name="f47" value="" />');
	        $form.append('<input type="hidden" name="f197" value="" />');
	
	        $('#skupenetSubmit').click();
	        $form.remove();
	
	        _this2.$state.go('welcomeCentre');
	      }).finally(function () {
	        _this2.loadingService.hideLoading('vehicleInfo');
	      });
	    }
	  }, {
	    key: 'proceedToSkupenetEdit',
	    value: function proceedToSkupenetEdit() {
	      var _this3 = this;
	
	      this.authService.getSkupenetTokenEdit(this.$stateParams.skupenetId).then(function (response) {
	        var $form = $("<form></form>");
	        $form.attr('method', 'post');
	        $form.attr('action', 'http://www.easierad.ie/admin/thirdparty/api/edit');
	        $form.append('<input type="submit" id="skupenetSubmit" formtarget="_blank" style="display:none;" />');
	        $('body').append($form);
	
	        $form.append('<input type="hidden" name="dpid" value="' + _this3.authService.authData.currentLocation.webPublisherUsername + '" />');
	        $form.append('<input type="hidden" name="dpref" value="' + _this3.$stateParams.skupenetId + '" />');
	        $form.append('<input type="hidden" name="token" value="' + response.data.token + '" />');
	        $form.append('<input type="hidden" name="cat" value="428" />');
	        $form.append('<input type="hidden" name="f50" value="' + response.data.registration + '" />');
	        $form.append('<input type="hidden" name="f18" value="' + _this3.$stateParams.price + '" />');
	        $form.append('<input type="hidden" name="f48" value="" />');
	        $form.append('<input type="hidden" name="f47" value="" />');
	        $form.append('<input type="hidden" name="f197" value="' + _this3.$stateParams.color + '" />');
	
	        $('#skupenetSubmit').click();
	        $form.remove();
	
	        _this3.$state.go('welcomeCentre');
	      }).finally(function () {});
	    }
	  }]);
	  return VehicleAddSkupenetController;
	}();
	
	exports.default = VehicleAddSkupenetController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1185);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleAddSkupenet.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleAddSkupenet.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleAddSkupenet{color:red}", ""]);
	
	// exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _notes = __webpack_require__(1187);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notesModule = _angular2.default.module('notes', [_angularUiRouter2.default]).component('notes', _notes2.default).name;
	
	exports.default = notesModule;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _notes = __webpack_require__(1188);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _notes3 = __webpack_require__(1189);
	
	var _notes4 = _interopRequireDefault(_notes3);
	
	__webpack_require__(1190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notesComponent = {
	  restrict: 'E',
	  bindings: {
	    notesCollection: '=',
	    withPromises: '<',
	    contact: '<',
	    contactId: '<'
	  },
	  template: _notes2.default,
	  controller: _notes4.default
	};
	
	exports.default = notesComponent;

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n\r\n  <header class=\"extra-margin-top\">\r\n    <h2>Notes</h2>\r\n  </header>\r\n  \r\n  <div class=\"form-group\">\r\n    <ul class=\"list-group\" ng-show=\"$ctrl.notesCollection.length\">\r\n      <li class=\"list-group-item\" ng-repeat=\"note in $ctrl.notesCollection\">\r\n        <h4 class=\"list-group-item-heading\">Added {{note.date === 'Now' ? 'Now' : note.timeStamp}}</h4>\r\n        <p class=\"list-group-item-text\">\r\n          <a target=\"_blank\" href=\"{{note.text}}\" ng-if=\"note.text.startsWith('http')\">\r\n              {{note.text}}  \r\n          </a>\r\n          <span ng-if=\"!note.text.startsWith('http')\" marked=\"note.text\">\r\n          </span>          \r\n        </p>\r\n      </li>\r\n    </ul>\r\n\r\n    <div class=\"col-md-10\">\r\n      <textarea class=\"form-control\" ng-model=\"$ctrl.tempNote\" placeholder=\"Enter a note\" maxlength=\"500\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-2\">\r\n      <a ng-click=\"$ctrl.addNote()\" class=\"btn btn-primary pull-right\">\r\n        <i class=\"glyphicon glyphicon-plus\"></i>\r\n        Add Note\r\n      </a>\r\n\r\n      <a ng-click=\"$ctrl.addNoteWithPromise()\" class=\"btn btn-primary pull-right\" ng-if=\"$ctrl.withPromises\">\r\n        <i class=\"glyphicon glyphicon-plus\"></i>\r\n        Add Note with Promise\r\n      </a>\r\n    </div>\r\n  </div>\r\n\r\n  <p class=\"no-content\" ng-show=\"!$ctrl.notesCollection.length\">Notes list is currently empty.</p>\r\n</div>\r\n"

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotesController = function () {
	  NotesController.$inject = ["addPromiseService", "authService", "contactService"];
	  function NotesController(addPromiseService, authService, contactService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NotesController);
	    this.addPromiseService = addPromiseService;
	    this.authService = authService;
	    this.contactService = contactService;
	  }
	
	  (0, _createClass3.default)(NotesController, [{
	    key: 'addNote',
	    value: function addNote() {
	      if (this.tempNote) {
	        var newNote = {
	          text: this.tempNote,
	          date: 'Now',
	          timeStamp: new Date()
	        };
	
	        this.notesCollection = [newNote].concat((0, _toConsumableArray3.default)(this.notesCollection));
	
	        /*
	        * There was a contact id passed in arguments to this NotesController
	        * which means that this should be saved to the contact instantly
	        */
	        if (this.contactId) {
	          this.contactService.addNote(this.authService.authData.currentLocation.key, this.contactId, this.tempNote);
	        }
	
	        this.tempNote = '';
	      }
	    }
	  }, {
	    key: 'addNoteWithPromise',
	    value: function addNoteWithPromise() {
	      if (this.tempNote) {
	        this.addPromiseService.showAddPromise(this.addPromise.bind(this), true, this.tempNote, this.contact, true);
	      }
	    }
	  }, {
	    key: 'addPromise',
	    value: function addPromise(promise) {
	      var ctrl = this;
	
	      var newNote = {
	        text: this.tempNote,
	        date: 'Now',
	        timeStamp: new Date(),
	        promise: promise
	      };
	
	      this.notesCollection = [newNote].concat((0, _toConsumableArray3.default)(this.notesCollection));
	
	      this.tempNote = '';
	    }
	  }]);
	  return NotesController;
	}();
	
	exports.default = NotesController;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./notes.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./notes.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".notes{color:red}", ""]);
	
	// exports


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _entityManagement = __webpack_require__(1193);
	
	var _entityManagement2 = _interopRequireDefault(_entityManagement);
	
	var _entityContainer = __webpack_require__(1198);
	
	var _entityContainer2 = _interopRequireDefault(_entityContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityManagementModule = _angular2.default.module('entityManagement', [_angularUiRouter2.default, _entityContainer2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('entityManagement', {
	    url: '/entityManagement',
	    component: 'entityManagement'
	  });
	}]).component('entityManagement', _entityManagement2.default).name;
	
	exports.default = entityManagementModule;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entityManagement = __webpack_require__(1194);
	
	var _entityManagement2 = _interopRequireDefault(_entityManagement);
	
	var _entityManagement3 = __webpack_require__(1195);
	
	var _entityManagement4 = _interopRequireDefault(_entityManagement3);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _entityManagement2.default,
	  controller: _entityManagement4.default
	};
	
	exports.default = entityManagementComponent;

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityManagementController = function () {
	  EntityManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function EntityManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EntityManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(EntityManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement();
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Entity ----'
	        };
	
	        _this.selectedEntity = firstItem;
	
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      var entMgt = {
	        entityId: this.selectedEntity.entityId,
	        entityType: this.selectedEntity.entityType,
	        parent: {
	          entityId: this.selectedEntity.parentId || 0,
	          entityName: this.selectedEntity.parentName || ''
	        },
	        isEntityManagement: true
	      };
	
	      this.$state.go('entityManagement.container', { entityManagement: entMgt }, { reload: true });
	    }
	  }]);
	  return EntityManagementController;
	}();
	
	exports.default = EntityManagementController;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./entityManagement.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./entityManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".entityManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _entityContainer = __webpack_require__(1199);
	
	var _entityContainer2 = _interopRequireDefault(_entityContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityContainerModule = _angular2.default.module('entityContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('entityManagement.container', {
	    component: 'entityContainer',
	    params: {
	      entityManagement: {
	        entityId: '',
	        entityType: '',
	        parent: {
	          entityId: '',
	          entityName: ''
	        }
	      }
	    }
	  });
	}]).component('entityContainer', _entityContainer2.default).name;
	
	exports.default = entityContainerModule;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entityContainer = __webpack_require__(1200);
	
	var _entityContainer2 = _interopRequireDefault(_entityContainer);
	
	var _entityContainer3 = __webpack_require__(1201);
	
	var _entityContainer4 = _interopRequireDefault(_entityContainer3);
	
	__webpack_require__(1202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var entityContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _entityContainer2.default,
	  controller: _entityContainer4.default
	};
	
	exports.default = entityContainerComponent;

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <edit entity-Management=\"$ctrl.$stateParams.entityManagement\" />\r\n</div>\r\n"

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntityContainerController = function EntityContainerController($stateParams) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, EntityContainerController);
	  this.$stateParams = $stateParams;
	};
	EntityContainerController.$inject = ["$stateParams"];
	
	exports.default = EntityContainerController;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1203);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entityContainer.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./entityContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".entityContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _accessoryManagement = __webpack_require__(1205);
	
	var _accessoryManagement2 = _interopRequireDefault(_accessoryManagement);
	
	var _accessoryContainer = __webpack_require__(1210);
	
	var _accessoryContainer2 = _interopRequireDefault(_accessoryContainer);
	
	var _accessoryManagement3 = __webpack_require__(1216);
	
	var _accessoryManagement4 = _interopRequireDefault(_accessoryManagement3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accessoryManagementModule = _angular2.default.module('accessoryManagement', [_angularUiRouter2.default, _accessoryContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('accessoryManagement', {
	    url: '/accessoryManagement',
	    component: 'accessoryManagement'
	  });
	}]).component('accessoryManagement', _accessoryManagement2.default).service('accessoryManagementService', _accessoryManagement4.default).name;
	
	exports.default = accessoryManagementModule;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accessoryManagement = __webpack_require__(1206);
	
	var _accessoryManagement2 = _interopRequireDefault(_accessoryManagement);
	
	var _accessoryManagement3 = __webpack_require__(1207);
	
	var _accessoryManagement4 = _interopRequireDefault(_accessoryManagement3);
	
	__webpack_require__(1208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accessoryManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _accessoryManagement2.default,
	  controller: _accessoryManagement4.default
	};
	
	exports.default = accessoryManagementComponent;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessoryManagementController = function () {
	  AccessoryManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function AccessoryManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AccessoryManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(AccessoryManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('accessoryManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return AccessoryManagementController;
	}();
	
	exports.default = AccessoryManagementController;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1209);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accessoryManagement.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accessoryManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".accessoryManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _accessoryContainer = __webpack_require__(1211);
	
	var _accessoryContainer2 = _interopRequireDefault(_accessoryContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accessoryContainerModule = _angular2.default.module('accessoryContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('accessoryManagement.container', {
	    url: '/:locationId',
	    component: 'accessoryContainer'
	  });
	}]).component('accessoryContainer', _accessoryContainer2.default).name;
	
	exports.default = accessoryContainerModule;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accessoryContainer = __webpack_require__(1212);
	
	var _accessoryContainer2 = _interopRequireDefault(_accessoryContainer);
	
	var _accessoryContainer3 = __webpack_require__(1213);
	
	var _accessoryContainer4 = _interopRequireDefault(_accessoryContainer3);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accessoryContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _accessoryContainer2.default,
	  controller: _accessoryContainer4.default
	};
	
	exports.default = accessoryContainerComponent;

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"accessoryList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Accessory Management</h2>\r\n\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.saveChanges()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n        \r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert\" ng-show=\"$ctrl.notification.msg != ''\" ng-class=\"{'alert-danger': $ctrl.notification.type === 'error', 'alert-success': $ctrl.notification.type === 'success'}\">\r\n          {{$ctrl.notification.msg}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-2\">Accessory Name</label>\r\n      <div class=\"col-sm-10\">\r\n        <p class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.tempName\" />\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.addAccessory()\"><i class=\"glyphicon glyphicon-plus\"></i></button>\r\n          </span>\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-10\">Accessory Name</th>\r\n          <th class=\"col-md-2\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"a in $ctrl.accessoryLookups\">\r\n            <td class=\"col-md-10\">{{a.name}}</td>\r\n            <td class=\"col-md-2\">\r\n              <a class=\"btn btn-link\" ng-click=\"$ctrl.removeAccessory(a)\">Remove</a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessoryContainerController = function () {
	  AccessoryContainerController.$inject = ["authService", "enums", "$stateParams", "lookupService", "loadingService", "accessoryManagementService"];
	  function AccessoryContainerController(authService, enums, $stateParams, lookupService, loadingService, accessoryManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AccessoryContainerController);
	    this.$stateParams = $stateParams;
	    this.lookupService = lookupService;
	    this.loadingService = loadingService;
	    this.accessoryManagementService = accessoryManagementService;
	
	    this.accessoryLookups = [];
	    this.initializeAccessories();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(AccessoryContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializeAccessories',
	    value: function initializeAccessories() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('accessoryList', 'Loading Accessories ...');
	
	      ctrl.lookupService.lookupAccessoryLookups(ctrl.$stateParams.locationId, true).then(function (accessoryLookups) {
	        ctrl.accessoryLookups = accessoryLookups;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('accessoryList');
	      });
	    }
	  }, {
	    key: 'addAccessory',
	    value: function addAccessory() {
	      var ctrl = this;
	
	      ctrl.resetNotification();
	
	      if (!ctrl.tempName || ctrl.tempName.length < 3 || ctrl.tempName.length > 40) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Name is required field and must be between 3 and 40 characters'
	        };
	
	        return;
	      } else if ((0, _lodash.find)(ctrl.accessoryLookups, function (a) {
	        return a.name === ctrl.tempName;
	      })) {
	        ctrl.notification = {
	          type: 'error',
	          msg: ctrl.tempName + ' is already added to the list'
	        };
	
	        return;
	      } else {
	        ctrl.accessoryLookups.push({ name: ctrl.tempName });
	        ctrl.tempName = '';
	      }
	    }
	  }, {
	    key: 'removeAccessory',
	    value: function removeAccessory(accessory) {
	      this.accessoryLookups = (0, _lodash.without)(this.accessoryLookups, accessory);
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var accessoryList = ctrl.accessoryLookups.map(function (a) {
	        return a.name;
	      });
	
	      ctrl.loadingService.showLoading('accessoryList', 'Updating Accessories ...');
	
	      ctrl.accessoryManagementService.updateAccessories(ctrl.$stateParams.locationId, accessoryList).then(function (response) {
	        _this.notification = {
	          type: 'success',
	          msg: 'Accessories updated successfully'
	        };
	      }).catch(function (err) {
	        _this.notification = {
	          type: 'error',
	          msg: 'An error occurred while updating accessories'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('accessoryList');
	      });
	    }
	  }]);
	  return AccessoryContainerController;
	}();
	
	exports.default = AccessoryContainerController;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1215);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./accessoryContainer.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./accessoryContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".accessoryContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessoryManagementService = function () {
	  AccessoryManagementService.$inject = ["$http", "appConfig"];
	  function AccessoryManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AccessoryManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(AccessoryManagementService, [{
	    key: "updateAccessories",
	    value: function updateAccessories(entityId, accessories) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/accessory/update/' + entityId, accessories);
	    }
	  }]);
	  return AccessoryManagementService;
	}();
	
	exports.default = AccessoryManagementService;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _priceManagement = __webpack_require__(1218);
	
	var _priceManagement2 = _interopRequireDefault(_priceManagement);
	
	var _priceContainer = __webpack_require__(1223);
	
	var _priceContainer2 = _interopRequireDefault(_priceContainer);
	
	var _priceManagement3 = __webpack_require__(1229);
	
	var _priceManagement4 = _interopRequireDefault(_priceManagement3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceManagementModule = _angular2.default.module('priceManagement', [_angularUiRouter2.default, _priceContainer2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('priceManagement', {
	    url: '/priceManagement',
	    component: 'priceManagement'
	  });
	}]).component('priceManagement', _priceManagement2.default).service('priceManagementService', _priceManagement4.default).name;
	
	exports.default = priceManagementModule;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _priceManagement = __webpack_require__(1219);
	
	var _priceManagement2 = _interopRequireDefault(_priceManagement);
	
	var _priceManagement3 = __webpack_require__(1220);
	
	var _priceManagement4 = _interopRequireDefault(_priceManagement3);
	
	__webpack_require__(1221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceManagementComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _priceManagement2.default,
	  controller: _priceManagement4.default
	};
	
	exports.default = priceManagementComponent;

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      Select the entity to manage\r\n      <select\r\n        class=\"form-control\"\r\n        ng-change=\"$ctrl.updateSelectedEntity()\"\r\n        ng-options=\"item.name for item in $ctrl.entities track by item.entityId\"\r\n        ng-model=\"$ctrl.selectedEntity\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceManagementController = function () {
	  PriceManagementController.$inject = ["authService", "enums", "lookupService", "$state"];
	  function PriceManagementController(authService, enums, lookupService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PriceManagementController);
	    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.lookupService = lookupService;
	    this.$state = $state;
	
	    this.initializeEntityList();
	  }
	
	  (0, _createClass3.default)(PriceManagementController, [{
	    key: 'initializeEntityList',
	    value: function initializeEntityList() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var entityIds = ctrl.authService.getEntitiesForManagement(3);
	
	      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
	        var firstItem = {
	          entityId: 0,
	          name: '---- Select Location ----'
	        };
	
	        _this.selectedEntity = firstItem;
	        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
	      });
	    }
	  }, {
	    key: 'updateSelectedEntity',
	    value: function updateSelectedEntity() {
	      this.$state.go('priceManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
	    }
	  }]);
	  return PriceManagementController;
	}();
	
	exports.default = PriceManagementController;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1222);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./priceManagement.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./priceManagement.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".priceManagement{color:red}", ""]);
	
	// exports


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _priceContainer = __webpack_require__(1224);
	
	var _priceContainer2 = _interopRequireDefault(_priceContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceContainerModule = _angular2.default.module('priceContainer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('priceManagement.container', {
	    url: '/:locationId',
	    component: 'priceContainer'
	  });
	}]).component('priceContainer', _priceContainer2.default).name;
	
	exports.default = priceContainerModule;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _priceContainer = __webpack_require__(1225);
	
	var _priceContainer2 = _interopRequireDefault(_priceContainer);
	
	var _priceContainer3 = __webpack_require__(1226);
	
	var _priceContainer4 = _interopRequireDefault(_priceContainer3);
	
	__webpack_require__(1227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceContainerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _priceContainer2.default,
	  controller: _priceContainer4.default
	};
	
	exports.default = priceContainerComponent;

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"priceList\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Price Management</h2>\r\n\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.saveChanges()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert\" ng-show=\"$ctrl.notification.msg != ''\" ng-class=\"{'alert-danger': $ctrl.notification.type === 'error', 'alert-success': $ctrl.notification.type === 'success'}\">\r\n          {{$ctrl.notification.msg}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-2\">Price Field</label>\r\n      <div class=\"col-sm-10\">\r\n        <p class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.tempCode\" maxlength=\"6\" placeholder=\"Price Code\" style=\"text-transform: uppercase\"/>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.tempName\" maxlength=\"20\" placeholder=\"Price Name\"/>\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.addPrice()\"><i class=\"glyphicon glyphicon-plus\"></i></button>\r\n          </span>\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-2\">Code</th>\r\n          <th class=\"col-md-6\">Price Name</th>\r\n          <th class=\"col-md-2\">Random Value</th>\r\n          <th class=\"col-md-2\">&nbsp;</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"p in $ctrl.priceLookups\">\r\n            <td class=\"col-md-2\">{{p.code}}</td>\r\n            <td class=\"col-md-6\">{{p.name}}</td>\r\n            <td class=\"col-md-2\">{{p.random | currency:'&euro;':0}}</td>\r\n            <td class=\"col-md-2\">\r\n              <a class=\"btn btn-link\" ng-click=\"$ctrl.removePrice(p)\" ng-hide=\"p.entityId === null\">Remove</a>\r\n            </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div class=\"form-horizontal\">\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Price Formula</label>\r\n          <div class=\"col-sm-10\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.formula\" placeholder=\"Price formula\" style=\"text-transform: uppercase\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.updateFormula()\"><i class=\"fa fa-check\"></i></button>\r\n              </span>\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Calculated Expression</label>\r\n          <div class=\"col-sm-10\">\r\n            {{$ctrl.formulaExpression}}\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Calculated Value</label>\r\n          <div class=\"col-sm-10\">\r\n            {{$ctrl.formulaEvaluated | currency:'&euro;':2}}\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceContainerController = function () {
	  PriceContainerController.$inject = ["$stateParams", "lookupService", "loadingService", "priceManagementService"];
	  function PriceContainerController($stateParams, lookupService, loadingService, priceManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PriceContainerController);
	    this.$stateParams = $stateParams;
	    this.lookupService = lookupService;
	    this.loadingService = loadingService;
	    this.priceManagementService = priceManagementService;
	
	    this.priceLookups = [];
	    this.formula = '';
	    this.priceFormula = '';
	    this.formulaExpression = '';
	    this.formulaEvaluated = '';
	    this.initializePrices();
	
	    this.state = '';
	    this.resetNotification();
	  }
	
	  (0, _createClass3.default)(PriceContainerController, [{
	    key: 'resetNotification',
	    value: function resetNotification() {
	      this.notification = {
	        type: '',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'initializePrices',
	    value: function initializePrices() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('priceList', 'Loading Price List ...');
	
	      ctrl.lookupService.lookupPriceLookups(ctrl.$stateParams.locationId).then(function (priceLookups) {
	        priceLookups.map(function (p) {
	          p.random = ctrl.getRandomInt(1, 10);
	        });
	        ctrl.priceLookups = priceLookups;
	
	        ctrl.initializeFormula();
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('priceList');
	      });
	    }
	  }, {
	    key: 'initializeFormula',
	    value: function initializeFormula() {
	      var ctrl = this;
	
	      ctrl.priceManagementService.getPriceFormula(ctrl.$stateParams.locationId).then(function (response) {
	        ctrl.priceFormula = response.data;
	        ctrl.formula = response.data;
	      });
	    }
	  }, {
	    key: 'addPrice',
	    value: function addPrice() {
	      var ctrl = this;
	      var codePattern = new RegExp('^[A-Z][\A-Z0-9]{2,5}$');
	
	      ctrl.resetNotification();
	
	      if (!codePattern.test(ctrl.tempCode.toUpperCase())) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Code is required field and must be between 3 and 6 characters. It should start with a letter and can only contain letters and digits'
	        };
	
	        return;
	      } else if ((0, _lodash.find)(ctrl.priceLookups, function (a) {
	        return a.code === ctrl.tempCode.toUpperCase();
	      })) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Code ' + ctrl.tempCode + ' is already added to the list'
	        };
	
	        return;
	      } else if (!ctrl.tempName || ctrl.tempName.length < 3 || ctrl.tempName.length > 20) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Name is required field and must be between 3 and 20 characters'
	        };
	
	        return;
	      } else if ((0, _lodash.find)(ctrl.priceLookups, function (a) {
	        return a.name === ctrl.tempName;
	      })) {
	        ctrl.notification = {
	          type: 'error',
	          msg: 'Name ' + ctrl.tempName + ' is already added to the list'
	        };
	
	        return;
	      } else {
	        ctrl.priceLookups.push({ code: ctrl.tempCode.toUpperCase(), name: ctrl.tempName });
	        ctrl.tempCode = '';
	        ctrl.tempName = '';
	      }
	    }
	  }, {
	    key: 'removePrice',
	    value: function removePrice(price) {
	      var ctrl = this;
	
	      if (ctrl.priceFormula && ctrl.priceFormula.includes('' + price.code.toUpperCase())) {
	        alert('Cannot remove price field as its used in the formula');
	      } else {
	        ctrl.priceLookups = (0, _lodash.without)(ctrl.priceLookups, price);
	      }
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges() {
	      var _this = this;
	
	      var ctrl = this;
	
	      var priceList = (0, _lodash.filter)(ctrl.priceLookups, function (o) {
	        return o.entityId !== null;
	      });
	
	      ctrl.loadingService.showLoading('priceList', 'Updating Price List ...');
	
	      ctrl.priceManagementService.updatePrices(ctrl.$stateParams.locationId, priceList, ctrl.priceFormula).then(function (response) {
	        _this.notification = {
	          type: 'success',
	          msg: 'Prices updated successfully'
	        };
	      }).catch(function (err) {
	        _this.notification = {
	          type: 'error',
	          msg: 'An error occurred while updating prices'
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('priceList');
	      });
	    }
	  }, {
	    key: 'getRandomInt',
	    value: function getRandomInt(min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    }
	  }, {
	    key: 'updateFormula',
	    value: function updateFormula() {
	      var ctrl = this;
	      var pattern = new RegExp(/{(\w*?)}/g);
	      var priceLookup = void 0;
	      var matches = void 0;
	      var temp = ctrl.formula.toUpperCase();
	      var isValid = true;
	
	      while (matches = pattern.exec(ctrl.formula.toUpperCase())) {
	        priceLookup = (0, _lodash.find)(ctrl.priceLookups, function (o) {
	          return o.code === matches[1];
	        });
	        if (!priceLookup) {
	          ctrl.formulaExpression = 'Invalid Price Code. ' + matches[1];
	          isValid = false;
	          break;
	        }
	        temp = temp.replace(matches[0], priceLookup.random);
	      }
	
	      if (isValid) {
	        ctrl.priceFormula = ctrl.formula.toUpperCase();
	
	        try {
	          ctrl.formulaExpression = temp;
	          ctrl.formulaEvaluated = eval(temp);
	        } catch (e) {
	          ctrl.formulaExpression = 'Malformed Formula';
	          ctrl.formulaEvaluated = '';
	        }
	      }
	    }
	  }]);
	  return PriceContainerController;
	}();
	
	exports.default = PriceContainerController;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1228);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./priceContainer.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./priceContainer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".priceContainer{color:red}", ""]);
	
	// exports


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceManagementService = function () {
	  PriceManagementService.$inject = ["$http", "appConfig"];
	  function PriceManagementService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PriceManagementService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(PriceManagementService, [{
	    key: 'getPriceFormula',
	    value: function getPriceFormula(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/pricelookup/formula/' + entityId);
	    }
	  }, {
	    key: 'updatePrices',
	    value: function updatePrices(entityId, prices, formula) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/pricelookup/update/' + entityId + '?priceFormula=' + encodeURIComponent(formula), prices);
	    }
	  }]);
	  return PriceManagementService;
	}();
	
	exports.default = PriceManagementService;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _company = __webpack_require__(1231);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _companyEdit = __webpack_require__(1236);
	
	var _companyEdit2 = _interopRequireDefault(_companyEdit);
	
	var _companyList = __webpack_require__(1242);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	var _company3 = __webpack_require__(1248);
	
	var _company4 = _interopRequireDefault(_company3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyModule = _angular2.default.module('company', [_angularUiRouter2.default, _companyEdit2.default, _companyList2.default]).component('company', _company2.default).service('companyService', _company4.default).name;
	
	exports.default = companyModule;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _company = __webpack_require__(1232);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _company3 = __webpack_require__(1233);
	
	var _company4 = _interopRequireDefault(_company3);
	
	__webpack_require__(1234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _company2.default,
	  controller: _company4.default
	};
	
	exports.default = companyComponent;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompanyController = function CompanyController() {
	  (0, _classCallCheck3.default)(this, CompanyController);
	
	  this.name = 'company';
	};
	
	exports.default = CompanyController;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1235);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./company.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./company.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".company{color:red}", ""]);
	
	// exports


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _companyEdit = __webpack_require__(1237);
	
	var _companyEdit2 = _interopRequireDefault(_companyEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyEditModule = _angular2.default.module('companyEdit', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('companyAdd', {
	    url: '/enquiry/company/add',
	    component: 'companyEdit',
	    params: {
	      contact: null
	    }
	  });
	
	  $stateProvider.state('companyEdit', {
	    url: '/enquiry/company/edit/:companyId',
	    component: 'companyEdit'
	  });
	}]).component('companyEdit', _companyEdit2.default).name;
	
	exports.default = companyEditModule;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _companyEdit = __webpack_require__(1238);
	
	var _companyEdit2 = _interopRequireDefault(_companyEdit);
	
	var _companyEdit3 = __webpack_require__(1239);
	
	var _companyEdit4 = _interopRequireDefault(_companyEdit3);
	
	__webpack_require__(1240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _companyEdit2.default,
	  controller: _companyEdit4.default
	};
	
	exports.default = companyEditComponent;

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>{{$ctrl.$stateParams.companyId ? 'Edit Company' : 'Add Company'}}</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editCompany()\">\r\n          <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n          <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i> {{ $ctrl.state !== 'Saving' ? 'Save Changes'\r\n          : 'Saving Changes ...' }}\r\n        </a>\r\n        <a class=\"btn btn-warning\" ng-click=\"$ctrl.redirectToParent()\">\r\n          <span class=\"glyphicon glyphicon-remove\"></span> Cancel\r\n        </a>\r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <form class=\"form-horizontal\" name=\"companyForm\" novalidate>\r\n\r\n    <div class=\"col-md-6\">\r\n      <!-- Details Begin -->\r\n      <div uib-group class=\"panel\" is-open=\"$ctrl.panels.company\">\r\n        <header>\r\n          <h2>Company Details</h2>\r\n        </header>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Company Type</label>\r\n          <div class=\"col-sm-10\">\r\n            <select class=\"form-control\" ng-change=\"$ctrl.updateModelFromSelect('companyType')\" ng-options=\"item.name for item in $ctrl.selectOptions.companyType track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.companyType\">\r\n              </select>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.legalName }\">\r\n          <label class=\"control-label col-sm-2\">Legal Name *</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.legalName\" placeholder=\"Enter Legal Name\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.tradingName }\">\r\n          <label class=\"control-label col-sm-2\">Trading Name</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.tradingName\" placeholder=\"Enter Trading Name\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div>\r\n\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Business Type</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.businessType\" placeholder=\"Enter Business Type\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Company Website</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.website\" placeholder=\"Enter Company Website\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Company Reg No</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.companyRegNo\" placeholder=\"Enter Company Registration Number\"\r\n              maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">VAT No</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.vatNo\" placeholder=\"Enter Company VAT Number\" maxLength=50>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Phone</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.phone\" placeholder=\"Enter Company Phone\" maxLength=50>\r\n          </div>\r\n        </div>        \r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Email</label>\r\n          <div class=\"col-sm-10\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.company.email\" placeholder=\"Enter Company Email\" maxLength=100>\r\n          </div>\r\n        </div>                \r\n      </div>\r\n      <!-- Details End -->\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <!-- Address Begin -->\r\n      <div class=\"panel\">\r\n        <div uib-group class=\"panel-default\" is-open=\"$ctrl.panels.address\">\r\n\r\n          <header>\r\n            <h2>Address</h2>\r\n          </header>\r\n\r\n          <address container=\"$ctrl.company.address\" form-validation-service=\"$ctrl.formValidationService\" first-Line-Req=\"true\"></address>\r\n        </div>\r\n      </div>\r\n      <!-- Address End -->\r\n    </div>\r\n\r\n  <div class=\"col-md-12\"></div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <!-- Contact Phones Begin -->\r\n      <div uib--group class=\"panel-default\" is-open=\"$ctrl.panels.contactPhones\">\r\n        <contact-Phones container=\"$ctrl.company\"></contact-Phones>\r\n      </div>\r\n      <!-- Contact Phones Begin -->\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n      <!-- Contact Emails Begin -->\r\n      <div uib-group class=\"panel-default\" is-open=\"$ctrl.panels.contactEmails\">\r\n        <contact-Emails container=\"$ctrl.company\"></contact-Emails>\r\n      </div>\r\n      <!-- Contact Emails Begin -->\r\n    </div>\r\n</div>\r\n</form>\r\n\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompanyEditController = function () {
	  CompanyEditController.$inject = ["authService", "$stateParams", "enums", "companyService", "loadingService", "$state"];
	  function CompanyEditController(authService, $stateParams, enums, companyService, loadingService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CompanyEditController);
	    this.authService = authService;
	    this.enums = enums;
	    this.companyService = companyService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.formValidationService = new _FormValidationService2.default();
	
	    var permissionToCheck = void 0;
	    if ($stateParams.companyId) {
	      permissionToCheck = enums.PERMISSION_TYPE.Edit;
	    } else {
	      permissionToCheck = enums.PERMISSION_TYPE.Add;
	    }
	    if (!authService.validateUser(false, 'Company', permissionToCheck, true)) {
	      return;
	    }
	
	    this.panels = {
	      company: true
	    };
	
	    this.company = {
	      entityId: authService.authData.currentLocation.key,
	      address: {},
	      contactPhones: [],
	      contactEmails: []
	    };
	    this.selectOptions = {};
	    this.selectDefaults = {};
	
	    this.initializeEnums();
	    this.configureForm();
	
	    this.loadCompany();
	  }
	
	  (0, _createClass3.default)(CompanyEditController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'COMPANY_TYPE', propName: 'companyType' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName]);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
	        ctrl.updateModelFromSelect(item.propName);
	      });
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj) {
	      var objList = [];
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDefaultOption',
	    value: function getDefaultOption(enumsArray, propName) {
	      var propVal = void 0;
	
	      try {
	        propVal = eval('this.company.' + propName);
	      } catch (e) {}
	
	      if (propVal) {
	        return (0, _lodash.find)(enumsArray, function (o) {
	          return o.id === propVal;
	        });
	      } else {
	        return enumsArray[0];
	      }
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      this.company[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.company);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'legalName',
	        displayName: 'Legal Name',
	        type: 'text',
	        required: true,
	        stringLength: {
	          min: 2,
	          max: 50
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'tradingName',
	        displayName: 'Trading Name',
	        type: 'text',
	        stringLength: {
	          min: 2,
	          max: 50
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'website',
	        displayName: 'Website',
	        type: 'url'
	      });
	    }
	  }, {
	    key: 'loadCompany',
	    value: function loadCompany() {
	      var _this = this;
	
	      var ctrl = this;
	
	      if (ctrl.$stateParams.companyId) {
	        ctrl.loadingService.showLoading('editCompany', 'Loading Company ...');
	
	        ctrl.companyService.getCompany(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.companyId).then(function (response) {
	          (0, _assign2.default)(ctrl.company, response.data);
	          _this.initializeEnums();
	          _this.configureForm();
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('editCompany');
	        });
	      }
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(newCompanyId) {
	      /*
	      * We need to check if there was a contact object passed in stateParams
	      * This will mean that we wanted to create a new company while creating a new contact
	      * So if the company was created or someone cancelled it
	      * We will send the user back add or edit contact passing in the same contact
	      * That was passed originally from that screen
	      */
	      if (this.$stateParams.contact) {
	        var params = {
	          contact: this.$stateParams.contact
	        };
	
	        if (newCompanyId) {
	          params.contact.companyId = newCompanyId;
	          params.companyName = this.company.legalName;
	        }
	
	        /*
	        * If the Contact has a ContactId this means that user was editing a contact
	        * and decided a attach it to a newly created company
	        * otherwise user was in add contact mode and adding new company
	        */
	        if (params.contact.contactId) {
	          params.contactId = params.contact.contactId;
	          this.$state.go('contactEdit', params);
	        } else {
	          this.$state.go('contactAdd', params);
	        }
	      } else {
	        this.$state.go('companyList');
	      }
	    }
	  }, {
	    key: 'editCompany',
	    value: function editCompany() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editCompany', 'Saving Changes ...');
	
	      ctrl.companyService.editCompany(ctrl.company).then(function (response) {
	        _this2.state = 'Saved';
	        ctrl.redirectToParent(response.data);
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editCompany');
	      });
	    }
	  }]);
	  return CompanyEditController;
	}();
	
	exports.default = CompanyEditController;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1241);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./companyEdit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./companyEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".companyEdit{color:red}", ""]);
	
	// exports


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _companyList = __webpack_require__(1243);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyListModule = _angular2.default.module('companyList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('companyList', {
	    component: 'companyList',
	    url: '/enquiry/company/list'
	  });
	}]).component('companyList', _companyList2.default).name;
	
	exports.default = companyListModule;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _companyList = __webpack_require__(1244);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	var _companyList3 = __webpack_require__(1245);
	
	var _companyList4 = _interopRequireDefault(_companyList3);
	
	__webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _companyList2.default,
	  controller: _companyList4.default
	};
	
	exports.default = companyListComponent;

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"companyListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Companies List</h2>\r\n\r\n          <a class=\"btn btn-success\"\r\n            ui-sref=\"companyAdd\"\r\n            ng-show=\"$ctrl.authService.checkFeatureAccess('Company', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n              <span class=\"glyphicon glyphicon-plus\"></span>\r\n              Add Company\r\n          </a>\r\n      </header>\r\n\r\n        <section class=\"search\">\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.name for item in $ctrl.enumLookupCollection.companyType track by item.id\"\r\n              ng-model=\"$ctrl.filterParams.companyType\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Legal Name\"\r\n              ng-model=\"$ctrl.filterParams.legalName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listCompanies()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('companyType')\">\r\n                      Company Type <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('legalName')\">\r\n                      Legal Name <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('tradingName')\">\r\n                      Trading Name <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('businessType')\">\r\n                      Business Type <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('address')\">\r\n                      Address <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"c in $ctrl.companies\">\r\n                    <td class=\"col-md-2\">{{ c.companyType }}</td>\r\n                    <td class=\"col-md-2\" ng-if=\"!c.website\">{{ c.legalName }}</td>\r\n                    <td class=\"col-md-2\" ng-if=\"c.website\">\r\n                      <a href=\"{{c.website}}\" target=\"_blank\">\r\n                      {{ c.legalName }}\r\n                      </a>\r\n                    </td>\r\n                    <td class=\"col-md-2\">{{ c.tradingName }}</td>\r\n                    <td class=\"col-md-2\">{{ c.businessType }}</td>\r\n                    <td class=\"col-md-3\">{{ c.line1 }}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Company', $ctrl.enums.PERMISSION_TYPE.Edit, false)\">\r\n                            <a ui-sref=\"companyEdit({companyId: c.companyId})\">Edit</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Company', $ctrl.enums.PERMISSION_TYPE.Delete, false)\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.deleteCompany(c.companyId)\">Delete</a>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.vehicles.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listVehicles()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompanyListController = function () {
	  CompanyListController.$inject = ["authService", "companyService", "loadingService", "lookupService", "$q", "enums", "$window"];
	  function CompanyListController(authService, companyService, loadingService, lookupService, $q, enums, $window) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, CompanyListController);
	    if (!authService.validateUser(false, 'Company', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.companyService = companyService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.$q = $q;
	    this.enums = enums;
	    this.$window = $window;
	
	    this.filterParams = {};
	
	    this.initializeEnumLookups().then(function () {
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(CompanyListController, [{
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	      var lookups = ['CompanyType'];
	      this.enumLookupCollection = [];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        var allOption = { id: null, name: 'All Types' };
	        enumLookupCollection.companyType.unshift(allOption);
	        _this2.enumLookupCollection = enumLookupCollection;
	        _this2.filterParams.companyType = allOption;
	
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.companyType = this.enumLookupCollection.companyType[0];
	      this.filterParams.legalName = '';
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'companyId',
	        ascending: true
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listCompanies();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listCompanies();
	    }
	  }, {
	    key: 'listCompanies',
	    value: function listCompanies() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('companyListing', 'Loading Companies ...');
	
	      ctrl.companyService.listCompanies(ctrl.filterParams).then(function (response) {
	        ctrl.companies = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' companies'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('companyListing');
	      });
	    }
	  }, {
	    key: 'deleteCompany',
	    value: function deleteCompany(companyId) {
	      var _this3 = this;
	
	      var ctrl = this;
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to delete this Company ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('companyListing', 'Removing Company ...');
	
	      ctrl.companyService.updateCompanyState(this.authService.authData.currentLocation.key, companyId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
	        ctrl.listCompanies();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this3.loadingService.hideLoading('companyListing');
	      });
	    }
	  }]);
	  return CompanyListController;
	}();
	
	exports.default = CompanyListController;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1247);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./companyList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./companyList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".companyList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompanyService = function () {
	  CompanyService.$inject = ["$http", "appConfig"];
	  function CompanyService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CompanyService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(CompanyService, [{
	    key: 'getCompany',
	    value: function getCompany(entityId, companyId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/company/get/' + entityId + '/' + companyId));
	    }
	  }, {
	    key: 'editCompany',
	    value: function editCompany(company) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/company/edit', company);
	    }
	  }, {
	    key: 'listCompanies',
	    value: function listCompanies(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&entityId=' + filterParams.entityId;
	
	      if (filterParams.companyType.id) {
	        query += '&companyType=' + filterParams.companyType.id;
	      }
	
	      query += '&legalName=' + filterParams.legalName;
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/company/list' + query);
	    }
	  }, {
	    key: 'updateCompanyState',
	    value: function updateCompanyState(entityId, companyId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/company/update/' + entityId + '/' + companyId + '/' + state));
	    }
	  }]);
	  return CompanyService;
	}();
	
	exports.default = CompanyService;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contact = __webpack_require__(1250);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contactSearch = __webpack_require__(1255);
	
	var _contactSearch2 = _interopRequireDefault(_contactSearch);
	
	var _contactEdit = __webpack_require__(1261);
	
	var _contactEdit2 = _interopRequireDefault(_contactEdit);
	
	var _contactList = __webpack_require__(1267);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	var _contactView = __webpack_require__(1273);
	
	var _contactView2 = _interopRequireDefault(_contactView);
	
	var _contact3 = __webpack_require__(1298);
	
	var _contact4 = _interopRequireDefault(_contact3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactModule = _angular2.default.module('contact', [_angularUiRouter2.default, _contactEdit2.default, _contactList2.default, _contactSearch2.default, _contactView2.default]).component('contact', _contact2.default).service('contactService', _contact4.default).name;
	
	exports.default = contactModule;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contact = __webpack_require__(1251);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contact3 = __webpack_require__(1252);
	
	var _contact4 = _interopRequireDefault(_contact3);
	
	__webpack_require__(1253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contact2.default,
	  controller: _contact4.default
	};
	
	exports.default = contactComponent;

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactController = function ContactController() {
	  (0, _classCallCheck3.default)(this, ContactController);
	
	  this.name = 'contact';
	};
	
	exports.default = ContactController;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1254);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./contact.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./contact.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contact{color:red}", ""]);
	
	// exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactSearch = __webpack_require__(1256);
	
	var _contactSearch2 = _interopRequireDefault(_contactSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactSearchModule = _angular2.default.module('contactSearch', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('contactSearch', {
	    url: '/enquiry/contact/search',
	    component: 'contactSearch',
	    params: {
	      contact: null,
	      companyName: null,
	      enquiry: null,
	      origin: {}
	    }
	  });
	}]).component('contactSearch', _contactSearch2.default).name;
	
	exports.default = contactSearchModule;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactSearch = __webpack_require__(1257);
	
	var _contactSearch2 = _interopRequireDefault(_contactSearch);
	
	var _contactSearch3 = __webpack_require__(1258);
	
	var _contactSearch4 = _interopRequireDefault(_contactSearch3);
	
	__webpack_require__(1259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactSearchComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contactSearch2.default,
	  controller: _contactSearch4.default
	};
	
	exports.default = contactSearchComponent;

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Search Contact</h2>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\" block-ui=\"editContact\">\r\n      <form class=\"form-horizontal\" name=\"contactForm\" novalidate>\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Search Term</label>\r\n          <div class=\"col-sm-10\">\r\n            <input class=\"form-control\"  placeholder=\"Search by Name, Phone, Email or Current Registration\" ng-model=\"$ctrl.searchTerm\" />\r\n          </div>\r\n        </div>\r\n\r\n        <button class=\"btn btn-primary form-submit\" ng-click=\"$ctrl.searchContacts()\">\r\n            <span class=\"fa fa-search\"></span>\r\n            Search Contacts\r\n        </button>\r\n\r\n        <button class=\"btn btn-default\" ng-click=\"$ctrl.clearSearch()\">\r\n            <span class=\"fa fa-eraser\"></span>\r\n            Clear Search\r\n        </button>\r\n        <button class=\"btn btn-success form-submit\" ng-class=\"{'disabled' : !($ctrl.searched)}\" ng-click=\"$ctrl.createNewContact()\" ng-disabled=\"!($ctrl.searched)\">\r\n            <span class=\"fa fa-plus\"></span>\r\n            Add New Contact\r\n        </button>\r\n\r\n        <button\r\n          class=\"btn btn-warning\"\r\n          ng-click=\"$ctrl.redirectToParent()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n            Cancel\r\n        </button>\r\n      </form>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\" block-ui=\"searchContact\">\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n      <thead>\r\n          <tr>\r\n            <th class=\"col-md-2\"> Contact Name </th>\r\n            <th class=\"col-md-2\"> Phone </th>\r\n            <th class=\"col-md-3\"> Email </th>\r\n            <th class=\"col-md-2\"> Reg </th>\r\n            <th class=\"col-md-3\"> Address </th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"c in $ctrl.contacts\">\r\n              <td class=\"col-md-2\">\r\n                <a ui-sref=\"contactView({contactId: c.contactId})\">\r\n                  {{ c.contactName }}\r\n                </a>\r\n              </td>\r\n              <td class=\"col-md-2\">{{ c.phone }}</td>\r\n              <td class=\"col-md-3\">{{ c.email }}</td>\r\n              <td class=\"col-md-2\">{{ c.currentReg }}</td>\r\n              <td class=\"col-md-3\">{{ c.line1 }}</td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n    </div>\r\n  </div>\r\n\r\n  </div>\r\n"

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactSearchController = function () {
	  ContactSearchController.$inject = ["authService", "enums", "contactService", "$state", "loadingService"];
	  function ContactSearchController(authService, enums, contactService, $state, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactSearchController);
	    if (!authService.validateUser(false, 'Contact', enums.PERMISSION_TYPE.Add, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.contactService = contactService;
	    this.$state = $state;
	    this.loadingService = loadingService;
	
	    this.clearSearch();
	  }
	
	  (0, _createClass3.default)(ContactSearchController, [{
	    key: 'searchContacts',
	    value: function searchContacts() {
	      var ctrl = this;
	
	      if (!ctrl.searchTerm) {
	        return;
	      }
	
	      ctrl.searched = true;
	
	      ctrl.loadingService.showLoading('searchContact', 'Loading Contacts ...');
	
	      ctrl.contactService.searchContacts(ctrl.authService.authData.currentLocation.key, ctrl.searchTerm).then(function (response) {
	        ctrl.contacts = response.data.items;
	
	        ctrl.contactNotFound = !(ctrl.contacts || ctrl.contacts.length);
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('searchContact');
	      });
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent() {
	      this.$state.go('contactList');
	    }
	  }, {
	    key: 'createNewContact',
	    value: function createNewContact() {
	      var contact = {
	        currentReg: this.regFilter,
	        ownerName: this.authService.authData.firstName + ' ' + this.authService.authData.lastName,
	        contactPerson: {
	          firstName: this.firstNameFilter,
	          lastName: this.lastNameFilter,
	          title: 2
	        }
	      };
	
	      this.$state.go('contactAdd', { contact: contact });
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      this.contacts = [];
	      this.searchTerm = '';
	
	      this.searched = false;
	    }
	  }]);
	  return ContactSearchController;
	}();
	
	exports.default = ContactSearchController;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1260);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactSearch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactSearch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactSearch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactEdit = __webpack_require__(1262);
	
	var _contactEdit2 = _interopRequireDefault(_contactEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactEditModule = _angular2.default.module('contactEdit', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('contactAdd', {
	    url: '/enquiry/contact/add',
	    component: 'contactEdit',
	    params: {
	      contact: null,
	      companyName: null,
	      enquiry: null,
	      origin: {}
	    }
	  });
	
	  $stateProvider.state('contactEdit', {
	    url: '/enquiry/contact/edit/:contactId',
	    component: 'contactEdit',
	    params: {
	      contact: null,
	      companyName: null,
	      origin: {}
	    }
	  });
	}]).component('contactEdit', _contactEdit2.default).name;
	
	exports.default = contactEditModule;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactEdit = __webpack_require__(1263);
	
	var _contactEdit2 = _interopRequireDefault(_contactEdit);
	
	var _contactEdit3 = __webpack_require__(1264);
	
	var _contactEdit4 = _interopRequireDefault(_contactEdit3);
	
	__webpack_require__(1265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contactEdit2.default,
	  controller: _contactEdit4.default
	};
	
	exports.default = contactEditComponent;

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>{{$ctrl.$stateParams.contactId ? 'Edit Contact' : 'Add Contact'}}</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editContact()\" ng-show=\"$ctrl.canEdit()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n        <a\r\n          class=\"btn btn-warning\"\r\n          ng-click=\"$ctrl.redirectToParent()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n            Cancel\r\n        </a>\r\n\r\n      </header>\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\" block-ui=\"editContact\">\r\n      <form class=\"form-horizontal\" name=\"contactForm\" novalidate>\r\n        <uib-accordion close-others=\"false\">\r\n\r\n        <!-- Details Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.contact\">\r\n          <uib-accordion-heading>\r\n            Contact Details <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.contact, 'glyphicon-chevron-down': !$ctrl.panels.contact}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Contact Type</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('contactType')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.contactType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.contactType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Salutation&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('contactPerson.title')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions['contactPerson.title'] track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults['contactPerson.title']\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Gender</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('gender')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.gender track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.gender\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.firstName }\">\r\n            <label class=\"control-label col-sm-2\">First Name *</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.contactPerson.firstName\" placeholder=\"First Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.lastName }\">\r\n            <label class=\"control-label col-sm-2\">Last Name *</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.contactPerson.lastName\" placeholder=\"Last Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Phone</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.phone\" placeholder=\"Phone\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Email</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.email\" placeholder=\"Email\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Date of Birth</label>\r\n            <div class=\"col-sm-10\">\r\n              <p class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('dob')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.contact.dateOfBirth\" is-open=\"$ctrl.dtPopups.dob\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('dob')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                </span>\r\n              </p>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Place Of Birth</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.placeOfBirth\" placeholder=\"Place of Birth\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Marital Status</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('maritalStatus')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.maritalStatus track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.maritalStatus\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Dependent Children</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.contact.dependentChildren\" placeholder=\"No of Dependent Children\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Mother's Maiden Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.mothersMaidenName\" placeholder=\"Mother's Maiden Name\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">External Id</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.externalId\" placeholder=\"External Id\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Job Title</label>\r\n            <div class=\"col-sm-10\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.contact.jobTitle\" placeholder=\"Enter Job Title\" maxLength=50>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Contact Method</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('contactMethod')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.contactMethod track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.contactMethod\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Current Reg</label>\r\n            <div class=\"col-sm-10\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.contact.currentReg\" placeholder=\"Enter Current Registration\" maxLength=50 input-restrictor>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Company</label>\r\n            <div class=\"col-sm-8\">\r\n              <div class=\"input-group\">\r\n                <div angucomplete-alt\r\n                  placeholder=\"Search Companies by Legal Name or Trading Name\"\r\n                  id=\"searchCompanies\"\r\n                  selected-object=\"$ctrl.companySelected\"\r\n                  remote-url=\"{{$ctrl.searchCompanyUrl}}\"\r\n                  title-field=\"legalName\"\r\n                  minlength=\"2\"\r\n                  input-class=\"form-control form-control-small\"\r\n                  initial-value = \"$ctrl.initialCompanyName\"\r\n                  match-class=\"autocomplete-highlight\">\r\n                </div>\r\n                <a class=\"input-group-addon btn btn-primary btn-small\" ng-click=\"$ctrl.clearCompany()\" ng-if=\"$ctrl.authService.checkFeatureAccess('Company', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n                  <span class=\"glyphicon glyphicon-remove\"></span>\r\n                </a>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-2\">\r\n              <a class=\"btn btn-primary\" ui-sref=\"companyAdd({contact: $ctrl.contact})\"><span class=\"glyphicon glyphicon-plus\"></span>Create New</a>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-show=\"$ctrl.authService.isManager()\">\r\n            <label class=\"control-label col-sm-2\">Owner</label>\r\n            <div class=\"col-sm-10\">\r\n              <div angucomplete-alt\r\n                id=\"searchUsers\"\r\n                placeholder=\"Search Users by Email, First Name or Last Name\"\r\n                pause=\"400\"\r\n                selected-object=\"$ctrl.ownerSelected\"\r\n                remote-url=\"{{$ctrl.searchUsersUrl}}\"\r\n                title-field=\"firstName,lastName\"\r\n                minlength=\"2\"\r\n                input-class=\"form-control form-control-small\"\r\n                initial-value = \"$ctrl.initialOwnerName\"\r\n                match-class=\"autocomplete-highlight\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-hide=\"$ctrl.authService.isManager()\">\r\n            <label class=\"control-label col-sm-2\">Owner</label>\r\n            <label class=\"control-label take-left col-sm-10\">{{$ctrl.initialOwnerName}}</label>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-hide=\"true\">\r\n              <label class=\"control-label col-sm-2\">Data Protection Authorisation</label>\r\n              <div class=\"col-sm-10\">\r\n                <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.viaEmail }\">\r\n                  <label class=\"control-label col-sm-2\">Via Email *</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <label class=\"control-label\" for=\"yes1\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaEmail\" ng-value=\"true\" id=\"yes1\">\r\n                      Yes\r\n                    </label>\r\n                    <label class=\"control-label\" for=\"no1\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaEmail\" ng-value=\"false\" id=\"no1\">\r\n                      No\r\n                    </label>\r\n                  </div>\r\n                </div>\r\n  \r\n                <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.viaPost }\">\r\n                  <label class=\"control-label col-sm-2\">Via Post *</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <label class=\"control-label\" for=\"yes2\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaPost\" ng-value=\"true\" id=\"yes2\">\r\n                      Yes\r\n                    </label>\r\n                    <label class=\"control-label\" for=\"no2\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaPost\" ng-value=\"false\" id=\"no2\">\r\n                      No\r\n                    </label>\r\n                  </div>\r\n                </div>\r\n  \r\n                <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.viaText }\">\r\n                  <label class=\"control-label col-sm-2\">Via Text *</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <label class=\"control-label\" for=\"yes3\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaText\" ng-value=\"true\" id=\"yes3\">\r\n                      Yes\r\n                    </label>\r\n                    <label class=\"control-label\" for=\"no3\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaText\" ng-value=\"false\" id=\"no3\">\r\n                      No\r\n                    </label>\r\n                  </div>\r\n                </div>\r\n  \r\n                <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.viaPhone }\">\r\n                  <label class=\"control-label col-sm-2\">Via Phone *</label>\r\n                  <div class=\"col-sm-10\">\r\n                    <label class=\"control-label\" for=\"yes4\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaPhone\" ng-value=\"true\" id=\"yes4\">\r\n                      Yes\r\n                    </label>\r\n                    <label class=\"control-label\" for=\"no4\">\r\n                      <input type=\"radio\" ng-model=\"$ctrl.contact.viaPhone\" ng-value=\"false\" id=\"no4\">\r\n                      No\r\n                    </label>\r\n                  </div>\r\n                </div>\r\n            </div>\r\n       </div>\r\n\r\n          <div class=\"form-group\" ng-hide=\"true\">\r\n            <label class=\"control-label\" for=\"chk2\">Allow creation of Anniversary todos for this customer</label>\r\n            <input type=\"checkbox\" id=\"chk2\" ng-model=\"$ctrl.contact.todosEnabled\">\r\n          </div>\r\n        </div>\r\n        <!-- Details End -->\r\n\r\n        <!-- Partner Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.partner\">\r\n          <uib-accordion-heading>\r\n            Partner Details <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.partner, 'glyphicon-chevron-down': !$ctrl.panels.partner}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Salutation&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('partner.title')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions['partner.title'] track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults['partner.title']\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.firstName2 }\">\r\n            <label class=\"control-label col-sm-2\">First Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.partner.firstName\" placeholder=\"First Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.lastName2 }\">\r\n            <label class=\"control-label col-sm-2\">Last Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.partner.lastName\" placeholder=\"Last Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Partner End -->\r\n\r\n        <!-- Address Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.address\">\r\n          <uib-accordion-heading>\r\n            Address <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.address, 'glyphicon-chevron-down': !$ctrl.panels.address}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Residence Type</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('residenceType')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.residenceType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.residenceType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <address container=\"$ctrl.contact.address\" form-validation-service=\"$ctrl.formValidationService\" first-Line-Req=\"false\"></address>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Length of Stay</label>\r\n            <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.yearsCollection\"\r\n                  ng-model=\"$ctrl.contact.yearsAtAddress\">\r\n                </select>\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.monthsCollection\"\r\n                  ng-model=\"$ctrl.contact.monthsAtAddress\">\r\n                </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Address End -->\r\n\r\n        <!-- Previous Address Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.prevAddress\">\r\n          <uib-accordion-heading>\r\n            Previous Address <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.prevAddress, 'glyphicon-chevron-down': !$ctrl.panels.prevAddress}\"></i>\r\n          </uib-accordion-heading>\r\n          \r\n          <address container=\"$ctrl.contact.previousAddress\" first-Line-Req=\"false\"></address>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Length of Stay</label>\r\n            <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.yearsCollection\"\r\n                  ng-model=\"$ctrl.contact.yearsAtPrevAddress\">\r\n                </select>\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.monthsCollection\"\r\n                  ng-model=\"$ctrl.contact.monthsAtPrevAddress\">\r\n                </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Address End -->\r\n\r\n        <!-- Contact Phones Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.contactPhones\">\r\n          <uib-accordion-heading>\r\n            Additional Phones <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.contactPhones, 'glyphicon-chevron-down': !$ctrl.panels.contactPhones}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <contact-Phones container=\"$ctrl.contact\"></contact-Phones>\r\n        </div>\r\n        <!-- Contact Phones Begin -->\r\n\r\n        <!-- Contact Emails Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.contactEmails\">\r\n          <uib-accordion-heading>\r\n            Additional Emails <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.contactEmails, 'glyphicon-chevron-down': !$ctrl.panels.contactEmails}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <contact-Emails container=\"$ctrl.contact\"></contact-Emails>\r\n        </div>\r\n        <!-- Contact Emails End -->\r\n\r\n        <!-- Employment Details Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.empDetails\">\r\n          <uib-accordion-heading>\r\n            Employment Details <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.empDetails, 'glyphicon-chevron-down': !$ctrl.panels.empDetails}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Emlpoyer Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.employerName\" placeholder=\"Employer Name\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <address container=\"$ctrl.contact.employerAddress\" first-Line-Req=\"false\"></address>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Length of Stay</label>\r\n            <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.yearsCollection\"\r\n                  ng-model=\"$ctrl.contact.yearsAtEmployment\">\r\n                </select>\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.monthsCollection\"\r\n                  ng-model=\"$ctrl.contact.monthsAtEmployment\">\r\n                </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Occupation</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.occupation\" placeholder=\"Occupation\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Employment Type</label>\r\n            <div class=\"col-sm-10\">\r\n              <select\r\n                class=\"form-control\"\r\n                ng-change=\"$ctrl.updateModelFromSelect('employmentType')\"\r\n                ng-options=\"item.name for item in $ctrl.selectOptions.employmentType track by item.id\"\r\n                ng-model=\"$ctrl.selectDefaults.employmentType\">\r\n              </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Work Permit No</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.workPermitNo\" placeholder=\"Work Permit No\" maxlength=\"20\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Work Permit Expiry</label>\r\n            <div class=\"col-sm-10\">\r\n              <p class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('wpe')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.contact.workPermitExpiry\" is-open=\"$ctrl.dtPopups.wpe\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('wpe')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                </span>\r\n              </p>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Previous Emlpoyer</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.prevEmployerName\" placeholder=\"Previous Employer Name\" maxlength=\"100\">\r\n            </div>\r\n          </div>\r\n\r\n          <address container=\"$ctrl.contact.prevEmployerAddress\" first-Line-Req=\"false\"></address>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Length of Stay</label>\r\n            <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.yearsCollection\"\r\n                  ng-model=\"$ctrl.contact.yearsAtPrevEmployment\">\r\n                </select>\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.monthsCollection\"\r\n                  ng-model=\"$ctrl.contact.monthsAtPrevEmployment\">\r\n                </select>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n        <!-- Employment Details End -->\r\n\r\n        <!-- Financial Details Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.financialDetails\">\r\n          <uib-accordion-heading>\r\n            Financial Details <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.financialDetails, 'glyphicon-chevron-down': !$ctrl.panels.financialDetails}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Bank Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.bankName\" placeholder=\"Bank Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Branch Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.branchName\" placeholder=\"Branch Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Sort Code</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.sortCode\" placeholder=\"Sort Code\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Account No</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.accountNo\" placeholder=\"Account No\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">IBAN</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.iban\" placeholder=\"IBAN\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Account Name</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" ng-model=\"$ctrl.contact.accountName\" placeholder=\"Account Name\" maxlength=\"50\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Length of Stay</label>\r\n            <div class=\"col-sm-10\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.yearsCollection\"\r\n                  ng-model=\"$ctrl.contact.yearsAtBank\">\r\n                </select>\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.id as item.name for item in $ctrl.monthsCollection\"\r\n                  ng-model=\"$ctrl.contact.monthsAtBank\">\r\n                </select>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Monthly Income</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.contact.monthlyIncome\" placeholder=\"Monthly Income\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Other Income</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.contact.otherIncome\" placeholder=\"Other Income\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Mortgage / Rent</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.contact.mortgage\" placeholder=\"Mortgage\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Other Borrowing</label>\r\n            <div class=\"col-sm-10\">\r\n              <input class=\"form-control\" type=\"number\" ng-model=\"$ctrl.contact.otherBorrowing\" placeholder=\"Other Borrowing\">\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n        <!-- Employment Details End -->\r\n\r\n        <!-- DPA Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.dpa\">\r\n          <uib-accordion-heading>\r\n            Data Protection Authorisation <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.dpa, 'glyphicon-chevron-down': !$ctrl.panels.dpa}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n                <table class=\"table table-bordered table-striped\">\r\n                    <thead>\r\n                        <tr>\r\n                          <th class=\"col-md-4\">Reason</th>\r\n                          <th class=\"col-md-2\">Email</th>\r\n                          <th class=\"col-md-2\">Post</th>\r\n                          <th class=\"col-md-2\">Text</th>\r\n                          <th class=\"col-md-2\">Phone</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                      <tr>\r\n                        <td class=\"col-md-4\">Marketing</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.marketing_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.marketing_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.marketing_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.marketing_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Service</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.service_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.service_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.service_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.service_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Manufacturer</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.manufacturer_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.manufacturer_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.manufacturer_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.manufacturer_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Surveys</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.surveys_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.surveys_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.surveys_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.surveys_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Change Cycle</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.changeCycle_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.changeCycle_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.changeCycle_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.contact.dpa.changeCycle_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                    </tbody>\r\n                </table>                            \r\n            </div>\r\n            <div class=\"col-md-3\">\r\n              Signature 1\r\n              <img class=\"signature-image\" ng-src=\"{{$ctrl.contact.dpa.signatureUrl1 || '/images/no-data.jpg'}}\" />\r\n\r\n              Signature 2\r\n              <img class=\"signature-image\" ng-src=\"{{$ctrl.contact.dpa.signatureUrl2 || '/images/no-data.jpg'}}\" />\r\n            </div>\r\n          </div>\r\n            \r\n        </div>\r\n        <!-- DPA End -->    \r\n\r\n        <!-- Update History -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.updateHistory\">\r\n          <uib-accordion-heading>\r\n            Update History <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.updateHistory, 'glyphicon-chevron-down': !$ctrl.panels.updateHistory}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <table class=\"table table-bordered table-striped\">\r\n              <thead>\r\n                  <tr>\r\n                    <th class=\"col-md-3\">Update By</th>\r\n                    <th class=\"col-md-3\">Modified At</th>\r\n                  </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"t in $ctrl.contact.dpa.trail\">\r\n                  <td class=\"col-md-3\">{{t.item1}}</td>\r\n                  <td class=\"col-md-3\">{{t.item2 | date : 'dd MMM yy HH:mm'}}</switch></td>\r\n                </tr>\r\n              </tbody>\r\n          </table>  \r\n        </div>\r\n        <!-- Update History -->  \r\n\r\n        <!-- Notes Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.notes\">\r\n          <uib-accordion-heading>\r\n            Notes <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.notes, 'glyphicon-chevron-down': !$ctrl.panels.notes}\"></i>\r\n          </uib-accordion-heading>\r\n\r\n          <notes notes-Collection=\"$ctrl.contact.notes\" />\r\n        </div>\r\n        <!-- Notes End -->   \r\n\r\n        </uib-accordion>\r\n      </form>\r\n    </div>\r\n  </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactEditController = function () {
	  ContactEditController.$inject = ["authService", "$stateParams", "enums", "contactService", "loadingService", "$state", "appConfig", "$scope", "utilsService"];
	  function ContactEditController(authService, $stateParams, enums, contactService, loadingService, $state, appConfig, $scope, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactEditController);
	    this.authService = authService;
	    this.enums = enums;
	    this.contactService = contactService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.utilsService = utilsService;
	
	    this.formValidationService = new _FormValidationService2.default();
	
	    var permissionToCheck = void 0;
	    if ($stateParams.companyId) {
	      permissionToCheck = enums.PERMISSION_TYPE.Edit;
	    } else {
	      permissionToCheck = enums.PERMISSION_TYPE.Add;
	    }
	
	    if (!authService.validateUser(false, 'Contact', permissionToCheck, true)) {
	      return;
	    }
	
	    this.searchCompanyUrl = appConfig.apiServiceBaseUri + 'api/company/search/' + authService.authData.currentLocation.key + '/';
	    this.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';
	
	    this.dtPopups = {}; //Cleanup
	    this.yearsCollection = this.getYearsCollection();
	    this.monthsCollection = this.getMonthsCollection();
	
	    this.panels = {
	      contact: true
	    };
	
	    this.contact = {
	      entityId: authService.authData.currentLocation.key,
	      ownerId: authService.authData.userId,
	      contactPerson: {
	        title: this.enums.PERSON_TITLE.Mr
	      },
	      partner: {},
	      address: {},
	      previousAddress: {},
	      employerAddress: {},
	      prevEmployerAddress: {},
	      contactPhones: [],
	      contactEmails: [],
	      notes: [],
	      yearsAtAddress: null,
	      monthsAtAddress: null,
	      yearsAtPrevAddress: null,
	      monthsAtPrevAddress: null,
	      yearsAtEmployment: null,
	      monthsAtEmployment: null,
	      yearsAtPrevEmployment: null,
	      monthsAtPrevEmployment: null,
	      yearsAtBank: null,
	      monthsAtBank: null
	    };
	    this.selectOptions = {};
	    this.selectDefaults = {};
	
	    this.initializeEnums();
	    this.configureForm();
	
	    this.initialCompanyName = '';
	    this.initialOwnerName = '';
	    this.loadContact();
	
	    this.companySelected = this.companySelected.bind(this);
	    this.ownerSelected = this.ownerSelected.bind(this);
	
	    this.origin = $stateParams.origin;
	  }
	
	  (0, _createClass3.default)(ContactEditController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'CONTACT_TYPE', propName: 'contactType' }, { enumName: 'PERSON_TITLE', propName: 'contactPerson.title' }, { enumName: 'CONTACT_METHOD', propName: 'contactMethod', defaultOption: true }, { enumName: 'PERSON_TITLE', propName: 'partner.title', defaultOption: true }, { enumName: 'GENDER', propName: 'gender', defaultOption: true }, { enumName: 'MARITAL_STATUS', propName: 'maritalStatus', defaultOption: true }, { enumName: 'RESIDENCE_TYPE', propName: 'residenceType', defaultOption: true }, { enumName: 'EMPLOYMENT_TYPE', propName: 'employmentType', defaultOption: true }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
	        ctrl.updateModelFromSelect(item.propName);
	      });
	    }
	  }, {
	    key: 'getDefaultOption',
	    value: function getDefaultOption(enumsArray, propName) {
	      var propVal = void 0;
	
	      try {
	        propVal = eval('this.contact.' + propName);
	      } catch (e) {}
	
	      if (propVal) {
	        return (0, _lodash.find)(enumsArray, function (o) {
	          return o.id === propVal;
	        });
	      } else {
	        return enumsArray[0];
	      }
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      var val = this.selectDefaults[selectDefaultProperty][idProperty];
	
	      try {
	        eval('this.contact.' + modelProperty + ' = ' + val);
	      } catch (e) {}
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.contact);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'firstName',
	        displayName: 'First Name',
	        model: ctrl.contact.contactPerson,
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'lastName',
	        displayName: 'Last Name',
	        model: ctrl.contact.contactPerson,
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'firstName',
	        displayName: 'Partner First Name',
	        model: ctrl.contact.partner,
	        condition: '{MODEL}.partner && {MODEL}.partner.title',
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'lastName',
	        displayName: 'Partner Last Name',
	        model: ctrl.contact.partner,
	        condition: '{MODEL}.partner && {MODEL}.partner.title',
	        required: true,
	        stringLength: {
	          min: 3,
	          max: 50
	        }
	      });
	
	      var checkDpa = true;
	
	      if (!this.contact.contactId) {
	        if (this.$stateParams.origin.source === 'welcomeCentre') {
	          checkDpa = false;
	        }
	      }
	
	      this.$scope.$broadcast('parentFormConfigured');
	    }
	  }, {
	    key: 'loadContact',
	    value: function loadContact() {
	      var ctrl = this;
	
	      if (ctrl.$stateParams.contact) {
	        /*
	        * If there is a contact in State Params
	        * This means that we wanted to create a Company while Adding / Updating a contact
	        * And we passed the same contact object back, which we sent before creating the company
	        */
	        (0, _assign2.default)(ctrl.contact, ctrl.$stateParams.contact);
	        ctrl.initialCompanyName = ctrl.$stateParams.companyName;
	        ctrl.initialOwnerName = ctrl.$stateParams.contact.ownerName;
	        this.configureForm();
	      } else if (ctrl.$stateParams.contactId) {
	        ctrl.loadingService.showLoading('editContact', 'Loading Contact ...');
	
	        ctrl.contactService.getContact(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.contactId).then(function (response) {
	          (0, _assign2.default)(ctrl.contact, response.data);
	          ctrl.contact.dateOfBirth = ctrl.utilsService.getDatePart(ctrl.contact.dateOfBirth);
	          ctrl.contact.workPermitExpiry = ctrl.utilsService.getDatePart(ctrl.contact.workPermitExpiry);
	          ctrl.contact.partner = ctrl.contact.partner || {};
	          ctrl.contact.previousAddress = ctrl.contact.previousAddress || {};
	          ctrl.contact.employerAddress = ctrl.contact.employerAddress || {};
	          ctrl.contact.prevEmployerAddress = ctrl.contact.prevEmployerAddress || {};
	          ctrl.initialCompanyName = response.data.companyName;
	          ctrl.initialOwnerName = response.data.ownerName;
	          ctrl.initializeEnums();
	          ctrl.configureForm();
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('editContact');
	        });
	      } else {
	        /*
	        * Its a New Contact
	        * Set the Initial Owner Name
	        */
	        this.initialOwnerName = ctrl.authService.authData.firstName + ' ' + ctrl.authService.authData.lastName;
	      }
	    }
	  }, {
	    key: 'companySelected',
	    value: function companySelected(item) {
	      if (item) {
	        this.contact.companyId = item.originalObject.companyId;
	      }
	    }
	  }, {
	    key: 'clearCompany',
	    value: function clearCompany() {
	      this.contact.companyId = null;
	      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchCompanies');
	    }
	  }, {
	    key: 'ownerSelected',
	    value: function ownerSelected(item) {
	      if (item) {
	        this.contact.ownerId = item.originalObject.userId;
	      }
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(newContactId) {
	      if (!this.origin.source) {
	        this.$state.go('contactList');
	      } else {
	        var output = this.origin.processResult(newContactId, this.contact);
	
	        this.$state.go(output.stateName, output.params);
	      }
	    }
	  }, {
	    key: 'editContact',
	    value: function editContact() {
	      var _this = this;
	
	      var ctrl = this;
	
	      if (!ctrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      if (!ctrl.contact.partner || !ctrl.contact.partner.title) {
	        ctrl.contact.partner = null;
	      }
	
	      //Convert Dpa to GDPR for saving
	      this.contact.contactGDPR = (0, _assign2.default)({}, this.contact.dpa);
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editContact', 'Saving Changes ...');
	
	      ctrl.contactService.editContact(ctrl.contact).then(function (response) {
	        _this.state = 'Saved';
	        ctrl.redirectToParent(response.data);
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editContact');
	      });
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      var ctrl = this;
	      var retValue = false;
	
	      if (!ctrl.contact.contactId) {
	        return true;
	      }
	
	      retValue = ctrl.authService.checkFeatureAccess('Contact', ctrl.enums.PERMISSION_TYPE.Edit, false) && ctrl.contact.state !== ctrl.enums.OBJECT_ROW_STATE.Deleted;
	
	      return retValue;
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(id) {
	      this.dtPopups[id] = true;
	    }
	  }, {
	    key: 'getYearsCollection',
	    value: function getYearsCollection() {
	      return [{ id: null, name: 'Please Select' }, { id: 0, name: '0 Years' }, { id: 1, name: '1 Year' }, { id: 2, name: '2 Years' }, { id: 3, name: '3 Years' }, { id: 4, name: '4 Years' }, { id: 5, name: '5+ Years' }];
	    }
	  }, {
	    key: 'getMonthsCollection',
	    value: function getMonthsCollection() {
	      return [{ id: null, name: 'Please Select' }, { id: 1, name: '1 Month' }, { id: 2, name: '2 Months' }, { id: 3, name: '3 Months' }, { id: 4, name: '4 Months' }, { id: 5, name: '5 Months' }, { id: 6, name: '6 Months' }, { id: 7, name: '7 Months' }, { id: 8, name: '8 Months' }, { id: 9, name: '9 Months' }, { id: 10, name: '10 Months' }, { id: 11, name: '11 Months' }, { id: 12, name: '12 Months' }];
	    }
	  }]);
	  return ContactEditController;
	}();
	
	exports.default = ContactEditController;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1266);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactEdit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactEdit{color:red}.signature-image{margin-top:9px;margin-bottom:9px;border:1px solid #ccc;height:125px;width:350px}", ""]);
	
	// exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactList = __webpack_require__(1268);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactListModule = _angular2.default.module('contactList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('contactList', {
	    component: 'contactList',
	    url: '/enquiry/contact/list'
	  });
	}]).component('contactList', _contactList2.default).name;
	
	exports.default = contactListModule;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactList = __webpack_require__(1269);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	var _contactList3 = __webpack_require__(1270);
	
	var _contactList4 = _interopRequireDefault(_contactList3);
	
	__webpack_require__(1271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contactList2.default,
	  controller: _contactList4.default
	};
	
	exports.default = contactListComponent;

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"contactListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>Contact List</h2>\r\n\r\n          <a class=\"btn btn-success\"\r\n            ui-sref=\"contactSearch\"\r\n            ng-show=\"$ctrl.authService.checkFeatureAccess('Contact', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n              <span class=\"glyphicon glyphicon-plus\"></span>\r\n              Add Contact\r\n          </a>\r\n\r\n          <a class=\"btn btn-primary\"\r\n              ng-hide=\"true\"\r\n              ng-show=\"$ctrl.authService.authData.currentLocation.telecomProvider.name\"\r\n              ng-click=\"$ctrl.showExportContactsToTelecomProvider()\">\r\n              <span class=\"fa fa-exchange\"></span>\r\n              Export All Contacts to {{$ctrl.authService.authData.currentLocation.telecomProvider.name}}\r\n          </a>          \r\n      </header>\r\n\r\n        <section class=\"search\">\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.updateModelFromSelect('contactType')\"\r\n              ng-options=\"item.name for item in $ctrl.selectOptions.contactType track by item.id\"\r\n              ng-model=\"$ctrl.selectDefaults.contactType\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Contact Name\"\r\n              ng-model=\"$ctrl.filterParams.contactName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Company Name\"\r\n              ng-model=\"$ctrl.filterParams.companyName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Owner Name\"\r\n              ng-model=\"$ctrl.filterParams.ownerName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listContacts()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contactType')\">\r\n                      Contact Type <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contactName')\">\r\n                      Contact Name <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('phone')\">\r\n                      Phone <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('email')\">\r\n                      Email <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('owner')\">\r\n                      Owner <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('address')\">\r\n                      Address <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"c in $ctrl.contacts\">\r\n                    <td class=\"col-md-1\">{{ c.contactType }}</td>\r\n                    <td class=\"col-md-2\">\r\n                      <a ui-sref=\"contactView({contactId: c.contactId})\">\r\n                      {{ c.contactName }}\r\n                      </a>\r\n                    </td>\r\n                    <td class=\"col-md-2\">{{ c.phone }}</td>\r\n                    <td class=\"col-md-2\">{{ c.email }}</td>\r\n                    <td class=\"col-md-2\">{{ c.owner }}</td>\r\n                    <td class=\"col-md-2\">{{ c.line1 }}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\">\r\n                            <a ui-sref=\"contactView({contactId: c.contactId})\">View</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Add, false)\" ng-hide=\"true\">\r\n                            <a ui-sref=\"enquiryAdd({contactId: c.contactId, contactName: c.contactName, isDpaSet: c.isDpaSet, isAllDpaSet: c.isAllDpaSet})\">Create Enquiry</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.canEdit(c)\">\r\n                            <a ui-sref=\"contactEdit({contactId: c.contactId})\">Edit</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"$ctrl.authService.checkFeatureAccess('Contact', $ctrl.enums.PERMISSION_TYPE.Delete, false)\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.deleteContact(c.contactId)\">Delete</a>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-8 pages\" ng-hide=\"!$ctrl.contacts.length\">\r\n              <ul uib-pagination\r\n                boundary-link-numbers=\"true\"\r\n                max-size=\"7\"\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listContacts()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactListController = function () {
	  ContactListController.$inject = ["authService", "contactService", "loadingService", "lookupService", "enums", "$window", "$ngConfirm", "$scope", "growl", "$state"];
	  function ContactListController(authService, contactService, loadingService, lookupService, enums, $window, $ngConfirm, $scope, growl, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactListController);
	    if (!authService.validateUser(false, 'Company', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.contactService = contactService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.enums = enums;
	    this.$window = $window;
	    this.$ngConfirm = $ngConfirm;
	    this._$scope = $scope;
	    this.growl = growl;
	    this.$state = $state;
	
	    this.selectOptions = {};
	    this.selectDefaults = {};
	    this.filterParams = {};
	
	    this.initializeEnums();
	
	    this.authService.getLocationExtendedProperties('telecomProvider');
	  }
	
	  (0, _createClass3.default)(ContactListController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'CONTACT_TYPE', propName: 'contactType', defaultOption: true, defaultOptionText: 'All Types' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = enumsArray[0];
	        ctrl.updateModelFromSelect(item.propName);
	      });
	
	      this.reset();
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: defaultOptionText || 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      var val = this.selectDefaults[selectDefaultProperty][idProperty];
	      eval('this.filterParams.' + modelProperty + ' = ' + val);
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.selectDefaults.contactType = this.selectOptions.contactType[0];
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.contactType = this.selectDefaults.contactType.id;
	      this.filterParams.contactName = '';
	      this.filterParams.companyName = '';
	      this.filterParams.ownerName = '';
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'companyId',
	        ascending: true
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listContacts();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listContacts();
	    }
	  }, {
	    key: 'listContacts',
	    value: function listContacts() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('contactListing', 'Loading Contacts ...');
	
	      ctrl.contactService.listContacts(ctrl.filterParams).then(function (response) {
	        ctrl.contacts = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' contacts'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('contactListing');
	      });
	    }
	  }, {
	    key: 'deleteContact',
	    value: function deleteContact(contactId) {
	      var _this = this;
	
	      var ctrl = this;
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to delete this Contact ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('contactListing', 'Removing Contact ...');
	
	      ctrl.contactService.updateContactState(this.authService.authData.currentLocation.key, contactId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
	        ctrl.listContacts();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this.loadingService.hideLoading('contactListing');
	      });
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit(contact) {
	      var ctrl = this;
	      var retValue = false;
	
	      retValue = ctrl.authService.checkFeatureAccess('Contact', ctrl.enums.PERMISSION_TYPE.Edit, false);
	
	      return retValue;
	    }
	  }, {
	    key: 'showExportContactsToTelecomProvider',
	    value: function showExportContactsToTelecomProvider() {
	      var _this2 = this;
	
	      this._$scope.telecomProviderName = this.authService.authData.currentLocation.telecomProvider.name;
	      this._$scope.inProgress = false;
	      this._$scope.completed = false;
	      this._$scope.editContact = function (contactId) {
	        _this2._$scope.exportDialog.close();
	        _this2.$state.go('contactEdit', { contactId: contactId });
	      };
	
	      this._$scope.exportDialog = this.$ngConfirm({
	        title: 'Export Contacts',
	        contentUrl: 'templates/contact/exportContactsTemplate',
	        scope: this._$scope,
	        columnClass: 'm',
	        type: 'dark',
	        buttons: {
	          confirm: {
	            text: 'Confirm',
	            btnClass: 'btn-primary',
	            action: this.exportContactsToTelecomProvider.bind(this)
	          },
	          cancel: {
	            text: 'Leave It',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'exportContactsToTelecomProvider',
	    value: function exportContactsToTelecomProvider() {
	      var _this3 = this;
	
	      this._$scope.exportDialog.buttons.confirm.setShow(false);
	      this._$scope.exportDialog.buttons.cancel.setShow(false);
	
	      this._$scope.inProgress = true;
	
	      this.contactService.exportContactsToTelecomProvider(this.authService.authData.currentLocation.key).then(function (response) {
	        _this3._$scope.completed = true;
	        _this3._$scope.stats = response.data;
	
	        _this3._$scope.exportDialog.buttons.cancel.setText('Close');
	        _this3._$scope.exportDialog.buttons.cancel.setShow(true);
	      }).catch(function (err) {
	        _this3._$scope.exportDialog.close();
	        _this3.growl.error('An error occurred while exporting contacts. Please contact system administrator', { ttl: 5000 });
	      });
	
	      return false;
	    }
	  }]);
	  return ContactListController;
	}();
	
	exports.default = ContactListController;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactView = __webpack_require__(1274);
	
	var _contactView2 = _interopRequireDefault(_contactView);
	
	var _contactLifeCycle = __webpack_require__(1279);
	
	var _contactLifeCycle2 = _interopRequireDefault(_contactLifeCycle);
	
	var _contactPromises = __webpack_require__(1285);
	
	var _contactPromises2 = _interopRequireDefault(_contactPromises);
	
	var _contactFinances = __webpack_require__(1292);
	
	var _contactFinances2 = _interopRequireDefault(_contactFinances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactViewModule = _angular2.default.module('contactView', [_angularUiRouter2.default, _contactLifeCycle2.default, _contactPromises2.default, _contactFinances2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('contactView', {
	    component: 'contactView',
	    url: '/enquiry/contact/view/:contactId'
	  });
	}]).component('contactView', _contactView2.default).name;
	
	exports.default = contactViewModule;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactView = __webpack_require__(1275);
	
	var _contactView2 = _interopRequireDefault(_contactView);
	
	var _contactView3 = __webpack_require__(1276);
	
	var _contactView4 = _interopRequireDefault(_contactView3);
	
	__webpack_require__(1277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactViewComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contactView2.default,
	  controller: _contactView4.default
	};
	
	exports.default = contactViewComponent;

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Contact View</h2>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div block-ui=\"viewContact\">\r\n    <div class=\"col-md-9\">\r\n      <div class=\"panel\">\r\n        <uib-tabset active=\"activeJustified\">\r\n          <uib-tab index=\"0\" heading=\"Enquiries\">\r\n            <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-3\"> Subject </th>\r\n                  <th class=\"col-md-2\"> Created </th>\r\n                  <th class=\"col-md-2\"> Last Modified </th>\r\n                  <th class=\"col-md-1\"> Reg(s) </th>\r\n                  <th class=\"col-md-2\"> Owner </th>\r\n                  <th class=\"col-md-1\"> Status </th>\r\n                  <th class=\"col-md-1\"> &nbsp; </th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"e in $ctrl.contact.enquiries\">\r\n                  <td class=\"col-md-3\"> {{ e.subject }} </td>\r\n                  <td class=\"col-md-2\"> {{ e.created | date : 'dd MMM yy HH:mm' }} </td>\r\n                  <td class=\"col-md-2\"> {{ e.lastModified | date : 'dd MMM yy HH:mm' }} </td>\r\n                  <td class=\"col-md-1\"> <a href=\"#\" ui-sref=\"vehicleEdit({vehicleId: e.defaultRegId})\">{{ e.regToShow }}</a>  <br /> <a href=\"#\" ng-click=\"$ctrl.showExtraRegs(e.regs)\">{{ e.regToShowExtra }} </a></td>\r\n                  <td class=\"col-md-2\"> {{ e.ownerName }} </td>\r\n                  <td class=\"col-md-1\"> {{ e.statusName }} </td>\r\n                  <td class=\"col-md-1\">\r\n                    <button class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: e.enquiryId})\"\r\n                      ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Edit, false)\r\n                      && (e.status === $ctrl.enums.ENQUIRY_STATE.Open || e.status === $ctrl.enums.ENQUIRY_STATE.Confirmed)\">\r\n                        Edit\r\n                    </button>\r\n\r\n                    <button class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: e.enquiryId})\"\r\n                      ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.View, false)\r\n                      && (e.status === $ctrl.enums.ENQUIRY_STATE.Lost || e.status === $ctrl.enums.ENQUIRY_STATE.Closed)\">\r\n                        View\r\n                    </button>\r\n\r\n                    <button class=\"btn btn-default\"\r\n                      ng-click=\"$ctrl.duplicate(e.enquiryId)\"\r\n                      ng-if=\"e.canDuplicate && $ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n                        Duplicate\r\n                    </button>\r\n                  </td>\r\n                </tr>\r\n            </tbody>\r\n            </table>\r\n\r\n            <a class=\"btn btn-success\"\r\n              ui-sref=\"enquiryAdd({contactId: $ctrl.contact.contactId, contactName: $ctrl.contact.contactName})\"\r\n              ng-hide=\"true\"\r\n              ng-show=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n                <span class=\"glyphicon glyphicon-plus\"></span>\r\n                Create New Enquiry\r\n            </a>\r\n\r\n            <a class=\"btn btn-default\" ng-click=\"$ctrl.printDpaHistory()\">\r\n              <i class=\"fa fa-print\"></i>\r\n                Print Dpa History\r\n            </a>            \r\n\r\n            <a class=\"btn btn-default\" ng-click=\"$ctrl.mailDpaHistory()\">\r\n              <i class=\"fa fa-envelope-o\"></i>\r\n                Email Dpa History\r\n            </a>                        \r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"1\" heading=\"Finance Deals\">\r\n            <contact-Finances finances=\"$ctrl.contact.finances\"></contact-Finances>\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"2\" heading=\"Life Cycle\">\r\n            <contact-Life-Cycle life-Cycle-Events=\"$ctrl.contact.contactLifeCycle\"></contact-Life-Cycle>\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"3\" heading=\"Promises\">\r\n            <contact-Promises promises=\"$ctrl.contact.promises\" contact=\"$ctrl.contact\"></contact-Promises>\r\n          </uib-tab>\r\n\r\n          <uib-tab index=\"4\" heading=\"Notes\">\r\n            <notes notes-Collection=\"$ctrl.contact.notes\" contact-Id=\"$ctrl.contact.contactId\"></notes>\r\n          </uib-tab>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n      <div class=\"panel\">\r\n        <div class=\"col-md-12\">\r\n            <dl>\r\n              <dt>Contact Type</dt>\r\n              <dd>{{$ctrl.contact.contactType}}</dd>\r\n              <dt>Contact Name</dt>\r\n              <dd ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Edit, false) && $ctrl.contact.state !== $ctrl.enums.OBJECT_ROW_STATE.Deleted\">\r\n                <a ui-sref=\"contactEdit({contactId: $ctrl.contact.contactId})\">{{$ctrl.contact.contactName}}</a>\r\n              </dd>\r\n\r\n              <dt>External Id</dt>\r\n              <dd>{{$ctrl.contact.externalId}}</dd>\r\n\r\n              <dt>Job Title</dt>\r\n              <dd>{{$ctrl.contact.jobTitle || '-'}}</dd>\r\n              <dt>Company</dt>\r\n              <dd ng-if=\"$ctrl.contact.companyName !== null\">\r\n                <a ui-sref=\"companyEdit({companyId: $ctrl.contact.companyId})\">{{$ctrl.contact.companyName}}</a>\r\n              </dd>              \r\n              <!--<dd>{{$ctrl.contact.companyName || '-'}}</dd>-->\r\n\r\n              <dt>Current Reg</dt>\r\n              <dd>{{$ctrl.contact.currentReg || '-'}}</dd>\r\n              <dt>Phone</dt>\r\n              <dd>{{$ctrl.contact.phone}}</dd>\r\n\r\n              <dt>Email</dt>\r\n              <dd>{{$ctrl.contact.email}}</dd>\r\n              <dt>Address</dt>\r\n              <dd>{{$ctrl.contact.address}}</dd>\r\n\r\n              <dt>Current Owner</dt>\r\n              <dd>{{$ctrl.contact.owner}}</dd>\r\n\r\n              <dt>Created</dt>\r\n              <dd>{{$ctrl.contact.auditLog.created | date : 'dd MMM yy HH:mm'}}</dd>              \r\n\r\n              <dt>Created By</dt>\r\n              <dd>{{$ctrl.contact.auditLog.createdBy}}</dd>                            \r\n\r\n              <dt>Last Modified</dt>\r\n              <dd>{{$ctrl.contact.auditLog.lastModified | date : 'dd MMM yy HH:mm'}}</dd>              \r\n\r\n              <dt>Last Modified By</dt>\r\n              <dd>{{$ctrl.contact.auditLog.lastModifiedBy}}</dd>                                          \r\n          </dl>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactViewController = function () {
	  ContactViewController.$inject = ["authService", "enums", "contactService", "loadingService", "$stateParams", "enquiryService", "printService", "mailService", "$scope", "$ngConfirm", "$state"];
	  function ContactViewController(authService, enums, contactService, loadingService, $stateParams, enquiryService, printService, mailService, $scope, $ngConfirm, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactViewController);
	    if (!authService.validateUser(false, 'Contact', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.enums = enums;
	    this.contactService = contactService;
	    this.loadingService = loadingService;
	    this.enquiryService = enquiryService;
	    this.printService = printService;
	    this.mailService = mailService;
	    this.$scope = $scope;
	    this.$ngConfirm = $ngConfirm;
	    this.$state = $state;
	
	    this.loadContact($stateParams.contactId);
	  }
	
	  (0, _createClass3.default)(ContactViewController, [{
	    key: 'loadContact',
	    value: function loadContact(contactId) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('viewContact', 'Loading Contact Details ...');
	
	      ctrl.contactService.viewContact(ctrl.authService.authData.currentLocation.key, contactId).then(function (response) {
	        ctrl.contact = response.data;
	        ctrl.contact.enquiry = ctrl.parseRegs(ctrl.contact.enquiries);
	        ctrl.contact.address = ctrl.formatAddress(ctrl.contact.address);
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('viewContact');
	      });
	    }
	  }, {
	    key: 'parseRegs',
	    value: function parseRegs(data) {
	      (0, _lodash.map)(data, function (item) {
	        if (item.regs.length == 0) {
	          item.hasRegs = false;
	          item.regToShow = "N/A";
	        } else if (item.regs.length == 1) {
	          item.hasRegs = true;
	          item.defaultRegId = item.regs[0].item1;
	          item.regToShow = item.regs[0].item2;
	        } else {
	          item.hasRegs = true;
	          item.regToShow = item.regs[0].item2;
	          item.defaultRegId = item.regs[0].item1;
	          item.regToShowExtra = '+ ' + (item.regs.length - 1) + ' more';
	        }
	      });
	
	      return data;
	    }
	  }, {
	    key: 'formatAddress',
	    value: function formatAddress(address) {
	      var addressString = address.line1;
	
	      if (address.line2) {
	        addressString += ', ' + address.line2;
	      }
	
	      if (address.line3) {
	        addressString += ', ' + address.line3;
	      }
	
	      if (address.city) {
	        addressString += ', ' + address.city;
	      }
	
	      if (address.country) {
	        addressString += ', ' + address.country;
	      }
	
	      if (address.zip) {
	        addressString += ', ' + address.zip;
	      }
	
	      return addressString;
	    }
	  }, {
	    key: 'duplicate',
	    value: function duplicate(enquiryId) {
	      var ctrl = this;
	
	      var sure = window.confirm("Are you sure you want to duplicate this enquiry ?");
	
	      if (!sure) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('viewContact', 'Duplicating Enquiry ...');
	
	      ctrl.enquiryService.duplicate(enquiryId).then(function (response) {
	        ctrl.contact.enquiries.unshift(response.data);
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('viewContact');
	      });
	    }
	  }, {
	    key: 'printDpaHistory',
	    value: function printDpaHistory() {
	      this.printService.printDpaHistory(this.contact.contactId);
	    }
	  }, {
	    key: 'mailDpaHistory',
	    value: function mailDpaHistory() {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('viewContact', 'Emailing DPA History ...');
	
	      ctrl.mailService.mailDpaHistory(this.contact.contactId).then(function (response) {
	        alert('Email sent successfully');
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('viewContact');
	      });
	    }
	  }, {
	    key: 'showExtraRegs',
	    value: function showExtraRegs(regs) {
	      this.$scope.regs = regs;
	      this.$scope.goToVehicle = this.goToVehicle.bind(this);
	
	      this.showMoreModal = this.$ngConfirm({
	        title: 'All Vehicle Regs',
	        type: 'green',
	        contentUrl: 'templates/contact/contactViewEnquiryRegs',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          close: {
	            text: 'Close',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'goToVehicle',
	    value: function goToVehicle(vehicleId) {
	      this.showMoreModal.close();
	      this.$state.go('vehicleEdit', { vehicleId: vehicleId });
	    }
	  }]);
	  return ContactViewController;
	}();
	
	exports.default = ContactViewController;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1278);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactView.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactView.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactView{color:red}", ""]);
	
	// exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactLifeCycle = __webpack_require__(1280);
	
	var _contactLifeCycle2 = _interopRequireDefault(_contactLifeCycle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactLifeCycleModule = _angular2.default.module('contactLifeCycle', [_angularUiRouter2.default]).component('contactLifeCycle', _contactLifeCycle2.default).name;
	
	exports.default = contactLifeCycleModule;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactLifeCycle = __webpack_require__(1281);
	
	var _contactLifeCycle2 = _interopRequireDefault(_contactLifeCycle);
	
	var _contactLifeCycle3 = __webpack_require__(1282);
	
	var _contactLifeCycle4 = _interopRequireDefault(_contactLifeCycle3);
	
	__webpack_require__(1283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactLifeCycleComponent = {
	  restrict: 'E',
	  bindings: {
	    lifeCycleEvents: '='
	  },
	  template: _contactLifeCycle2.default,
	  controller: _contactLifeCycle4.default
	};
	
	exports.default = contactLifeCycleComponent;

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <table class=\"table table-bordered table-hover table-striped\">\r\n  <thead>\r\n      <tr>\r\n        <th class=\"col-md-3\"> Timestamp </th>\r\n        <th class=\"col-md-3\"> Contact Method </th>\r\n        <th class=\"col-md-3\"> Handled By </th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr data-ng-repeat=\"e in $ctrl.lifeCycleEvents | filter : $ctrl.tempFilterFn\">\r\n        <td class=\"col-md-3\"> {{ e.timeStamp | date : 'dd-MMMM-yyyy HH:mm' }} </td>        \r\n        <td class=\"col-md-3\" ng-if=\"e.contactMethod === 'InboundCall' || e.contactMethod === 'OutboundCall'\"> \r\n          <a href=\"#\" ng-click=\"$ctrl.viewCallDetails(e.contactLifeCycleId)\">{{ e.contactMethod }} </a>\r\n        </td>\r\n        <td class=\"col-md-3\" ng-if=\"e.contactMethod !== 'InboundCall' && e.contactMethod !== 'OutboundCall'\"> {{ e.contactMethod }} </td>\r\n        <td class=\"col-md-3\"> {{ e.handledBy }} </td>\r\n      </tr>\r\n  </tbody>\r\n  </table>\r\n</div>\r\n"

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactLifeCycleController = function () {
	  ContactLifeCycleController.$inject = ["enums", "contactService", "$ngConfirm", "$scope"];
	  function ContactLifeCycleController(enums, contactService, $ngConfirm, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactLifeCycleController);
	    this.enums = enums;
	    this.contactService = contactService;
	    this.$ngConfirm = $ngConfirm;
	    this._$scope = $scope;
	  }
	
	  (0, _createClass3.default)(ContactLifeCycleController, [{
	    key: 'viewCallDetails',
	    value: function viewCallDetails(contactLifeCycleId) {
	      var _this = this;
	
	      this.contactService.getCallLog(contactLifeCycleId).then(function (response) {
	        _this._$scope.callLog = response.data;
	
	        _this._$scope.exportDialog = _this.$ngConfirm({
	          title: 'Call Details',
	          contentUrl: 'templates/contact/callLogViewTemplate',
	          scope: _this._$scope,
	          columnClass: 'm',
	          type: 'dark',
	          buttons: {
	            cancel: {
	              text: 'Close',
	              btnClass: 'btn-default'
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'tempFilterFn',
	    value: function tempFilterFn(obj) {
	      return obj.contactMethod !== 'InboundCall' && obj.contactMethod !== 'OutboundCall';
	    }
	  }]);
	  return ContactLifeCycleController;
	}();
	
	exports.default = ContactLifeCycleController;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactLifeCycle.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactLifeCycle.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".marginBottom{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactPromises = __webpack_require__(1286);
	
	var _contactPromises2 = _interopRequireDefault(_contactPromises);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactPromisesModule = _angular2.default.module('contactPromises', [_angularUiRouter2.default]).component('contactPromises', _contactPromises2.default).name;
	
	exports.default = contactPromisesModule;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactPromises = __webpack_require__(1287);
	
	var _contactPromises2 = _interopRequireDefault(_contactPromises);
	
	var _contactPromises3 = __webpack_require__(1288);
	
	var _contactPromises4 = _interopRequireDefault(_contactPromises3);
	
	__webpack_require__(1290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactPromisesComponent = {
	  restrict: 'E',
	  bindings: {
	    promises: '=',
	    contact: '<'
	  },
	  template: _contactPromises2.default,
	  controller: _contactPromises4.default
	};
	
	exports.default = contactPromisesComponent;

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <table class=\"table table-bordered table-hover table-striped\">\r\n  <thead>\r\n      <tr>\r\n        <th> Subject </th>\r\n        <th> Notes </th>\r\n        <th> Comments </th>\r\n        <th> Due </th>        \r\n        <th> Owner </th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr data-ng-repeat=\"p in $ctrl.promises\">\r\n        <td>\r\n          <a href=\"#\" ng-click=\"$ctrl.viewPromise(p)\" ng-if=\"!p.completed\">\r\n            {{ p.subject }}\r\n          </a>\r\n          <span class=\"promiseCompleted\" ng-if=\"p.completed\">\r\n            {{ p.subject }}\r\n          </span>\r\n        </td>\r\n        <td> {{ p.note }} </td>\r\n        <td> {{ p.comments }} </td>\r\n        <td> {{ p.dueDate | date : 'dd-MMM-yyyy HH:mm' }} </td>\r\n        <td> {{ p.owner }} </td>\r\n      </tr>\r\n  </tbody>\r\n  </table>\r\n\r\n  <button class=\"btn btn-primary\" ng-click=\"$ctrl.showAddPromise()\">\r\n    Add Promise\r\n  </button>  \r\n</div>\r\n"

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _viewPromiseModal = __webpack_require__(1289);
	
	var _viewPromiseModal2 = _interopRequireDefault(_viewPromiseModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPromisesController = function () {
	  ContactPromisesController.$inject = ["promiseService", "$uibModal", "$scope", "addPromiseService"];
	  function ContactPromisesController(promiseService, $uibModal, $scope, addPromiseService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactPromisesController);
	    this.promiseService = promiseService;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.addPromiseService = addPromiseService;
	  }
	
	  (0, _createClass3.default)(ContactPromisesController, [{
	    key: 'complete',
	    value: function complete(addAnother) {
	      var _this = this;
	
	      var ctrl = this;
	
	      var sure = window.confirm('Are you sure you want to complete this promise');
	
	      if (!sure) {
	        return;
	      }
	
	      ctrl.promiseService.complete(this.selectedPromise.promiseId, this.tempComments).finally(function () {
	        ctrl.selectedPromise.completed = new Date();
	        ctrl.selectedPromise.comments = _this.tempComments;
	        ctrl.closeModal();
	        if (addAnother) {
	          ctrl.showAddPromise();
	        }
	        ctrl.listPromises();
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var ctrl = this;
	
	      if (ctrl.modalInstance) {
	        ctrl.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'viewPromise',
	    value: function viewPromise(promise) {
	      this.errMsg = '';
	      this.tempComments = '';
	      this.selectedPromise = promise;
	      this.modalInstance = this.$uibModal.open({
	        template: _viewPromiseModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'completePromise',
	    value: function completePromise(addAnother) {
	      if (!this.tempComments) {
	        this.errMsg = "Please enter some comments first";
	        return;
	      }
	
	      this.complete(addAnother);
	    }
	  }, {
	    key: 'showAddPromise',
	    value: function showAddPromise() {
	      this.addPromiseService.showAddPromise(this.addPromise.bind(this), false, '', { contactId: this.contact.contactId, contactName: this.contact.contactName }, true);
	    }
	  }, {
	    key: 'addPromise',
	    value: function addPromise(promise) {
	      this.promises.push(promise);
	      this.promises = (0, _lodash.reverse)((0, _lodash.sortBy)(this.promises, 'dueDate'));
	    }
	  }]);
	  return ContactPromisesController;
	}();
	
	exports.default = ContactPromisesController;

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  View Promise </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Subject</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.subject}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Category</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.category}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\" ng-show=\"$ctrl.selectedPromise.categoryId === $ctrl.enums.PROMISE_CATEGORY.Customer\">\r\n          <div class=\"col-md-3\">\r\n            <label>Contact</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.contactName}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\" ng-show=\"$ctrl.selectedPromise.categoryId === $ctrl.enums.PROMISE_CATEGORY.Customer\">\r\n        <div class=\"col-md-3\">\r\n          <label>Contact Phone</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          {{$ctrl.selectedPromise.contactPhone}}\r\n        </div>\r\n      </div>      \r\n\r\n      <div class=\"row\" ng-show=\"$ctrl.selectedPromise.categoryId === $ctrl.enums.PROMISE_CATEGORY.Customer\">\r\n        <div class=\"col-md-3\">\r\n          <label>Contact Email</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <a href=\"mailto:{{$ctrl.selectedPromise.contactEmail}}\">\r\n            {{$ctrl.selectedPromise.contactEmail}}\r\n          </a>\r\n        </div>\r\n      </div>      \r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Created</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.createdDate | date : 'dd MMM yy HH:mm'}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Due</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.dueDate | date : 'dd MMM yy HH:mm'}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Note</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            {{$ctrl.selectedPromise.note}}\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Comments</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea class=\"form-control\" ng-model=\"$ctrl.tempComments\" placeholder=\"Enter some comments\" maxlength=\"300\"></textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <a class=\"btn btn-primary\" ng-click=\"$ctrl.completePromise()\">Complete</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"$ctrl.completePromise(true)\">Complete and add another</a>\r\n          </div>\r\n      </div>   \r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactPromises.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactPromises.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".promiseCompleted{text-decoration:line-through}", ""]);
	
	// exports


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactFinances = __webpack_require__(1293);
	
	var _contactFinances2 = _interopRequireDefault(_contactFinances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactFinancesModule = _angular2.default.module('contactFinances', [_angularUiRouter2.default]).component('contactFinances', _contactFinances2.default).name;
	
	exports.default = contactFinancesModule;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactFinances = __webpack_require__(1294);
	
	var _contactFinances2 = _interopRequireDefault(_contactFinances);
	
	var _contactFinances3 = __webpack_require__(1295);
	
	var _contactFinances4 = _interopRequireDefault(_contactFinances3);
	
	__webpack_require__(1296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactFinancesComponent = {
	  restrict: 'E',
	  bindings: {
	    finances: '='
	  },
	  template: _contactFinances2.default,
	  controller: _contactFinances4.default
	};
	
	exports.default = contactFinancesComponent;

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-bordered table-hover table-striped\">\r\n  <thead>\r\n      <tr>\r\n        <th> Subject </th>\r\n        <th> Vehicle </th>\r\n        <th> Amount </th>\r\n        <th> Status </th>\r\n        <th> Last Updated </th>\r\n        <th> &nbsp; </th>\r\n        <th> &nbsp; </th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr data-ng-repeat=\"f in $ctrl.finances\">\r\n        <td> {{ f.name }} </td>\r\n        <td> {{ f.vehicle }} </td>\r\n        <td> {{ f.amount | currency:'&euro;':2 }} </td>\r\n        <td> {{ f.state }} </td>\r\n        <td> {{ f.lastModified | date : 'dd-MMM-yy HH:mm' }} </td>\r\n        <td>\r\n          <button class=\"btn btn-primary\" ui-sref=\"financeEdit({financeId: f.financeId})\">\r\n              View Finance\r\n          </button>\r\n        </td>\r\n        <td>\r\n          <button class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: f.financeId})\">\r\n              View Enquiry\r\n          </button>\r\n        </td>\r\n      </tr>\r\n  </tbody>\r\n  </table>"

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactFinancesController = function ContactFinancesController() {
	  (0, _classCallCheck3.default)(this, ContactFinancesController);
	
	  this.name = 'contactFinances';
	};
	
	exports.default = ContactFinancesController;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactFinances.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactFinances.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactFinances{color:red}", ""]);
	
	// exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactService = function () {
	  ContactService.$inject = ["$http", "appConfig"];
	  function ContactService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(ContactService, [{
	    key: 'getContact',
	    value: function getContact(entityId, contactId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/get/' + entityId + '/' + contactId));
	    }
	  }, {
	    key: 'editContact',
	    value: function editContact(contact) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/edit', contact);
	    }
	  }, {
	    key: 'quickEdit',
	    value: function quickEdit(contact) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/quickedit', contact);
	    }
	  }, {
	    key: 'listContacts',
	    value: function listContacts(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&entityId=' + filterParams.entityId;
	
	      if (filterParams.contactType) {
	        query += '&contactType=' + filterParams.contactType;
	      }
	
	      if (filterParams.contactName) {
	        query += '&contactName=' + filterParams.contactName;
	      }
	
	      if (filterParams.companyName) {
	        query += '&companyName=' + filterParams.companyName;
	      }
	
	      if (filterParams.ownerName) {
	        query += '&ownerName=' + filterParams.ownerName;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/contact/list' + query);
	    }
	  }, {
	    key: 'updateContactState',
	    value: function updateContactState(entityId, contactId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/update/' + entityId + '/' + contactId + '/' + state));
	    }
	  }, {
	    key: 'searchContacts',
	    value: function searchContacts(entityId, searchTerm) {
	      var query = '?entityId=' + entityId;
	
	      if (searchTerm) {
	        query += '&searchTerm=' + searchTerm;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/search' + query));
	    }
	  }, {
	    key: 'viewContact',
	    value: function viewContact(entityId, contactId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/view/' + entityId + '/' + contactId));
	    }
	  }, {
	    key: 'addEvent',
	    value: function addEvent(contactId, contactMethod, handledBy, enquiryId) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/addEvent/' + contactId + '/' + contactMethod + '/' + handledBy + '/' + enquiryId));
	    }
	  }, {
	    key: 'updateDpa',
	    value: function updateDpa(entityId, dpa) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/updatedpa/' + entityId), dpa);
	    }
	  }, {
	    key: 'updateAllDpa',
	    value: function updateAllDpa(entityId, dpa) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/updatealldpa/' + entityId), dpa);
	    }
	  }, {
	    key: 'addNote',
	    value: function addNote(entityId, contactId, noteText) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/addNote/' + entityId + '/' + contactId), { text: noteText });
	    }
	  }, {
	    key: 'updateOwner',
	    value: function updateOwner(contactId, ownerId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/updateOwner/' + contactId + '/' + ownerId));
	    }
	  }, {
	    key: 'anonymize',
	    value: function anonymize(contactId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/anonymize/' + contactId));
	    }
	  }, {
	    key: 'exportContactsToTelecomProvider',
	    value: function exportContactsToTelecomProvider(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/exportContactsToTelecomProvider/' + entityId));
	    }
	  }, {
	    key: 'getCallLog',
	    value: function getCallLog(contactLifeCycleId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/getcalllog/' + contactLifeCycleId));
	    }
	  }]);
	  return ContactService;
	}();
	
	exports.default = ContactService;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _address = __webpack_require__(1300);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressModule = _angular2.default.module('address', [_angularUiRouter2.default]).component('address', _address2.default).name;
	
	exports.default = addressModule;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _address = __webpack_require__(1301);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _address3 = __webpack_require__(1302);
	
	var _address4 = _interopRequireDefault(_address3);
	
	__webpack_require__(1303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressComponent = {
	  restrict: 'E',
	  bindings: {
	    container: '<',
	    formValidationService: '<',
	    firstLineReq: '<'
	  },
	  template: _address2.default,
	  controller: _address4.default
	};
	
	exports.default = addressComponent;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-horizontal\">\r\n  <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.firstLineReq && !$ctrl.formValidationService.validations.line1 }\">\r\n    <label class=\"control-label col-sm-2\">Line1 {{$ctrl.firstLineReq ? '*' : ''}}</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"$ctrl.container.line1\" placeholder=\"Line 1\" maxLength=100>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Line2&nbsp;&nbsp;</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"$ctrl.container.line2\" placeholder=\"Line 2\" maxLength=100>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Line3&nbsp;&nbsp;</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"$ctrl.container.line3\" placeholder=\"Line 3\"  maxLength=100>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">City&nbsp;&nbsp;</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\"ng-model=\"$ctrl.container.city\" placeholder=\"City\"   maxLength=20>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Country&nbsp;&nbsp;</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"$ctrl.container.country\" placeholder=\"Country\"   maxLength=10>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Zip&nbsp;&nbsp;</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"$ctrl.container.zip\" placeholder=\"Zip code\"   maxLength=10>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddressController = function () {
	  AddressController.$inject = ["$scope"];
	  function AddressController($scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AddressController);
	    if (this.firstLineReq) {
	      this.configureForm();
	
	      $scope.$on('parentFormConfigured', this.configureForm.bind(this));
	    }
	  }
	
	  (0, _createClass3.default)(AddressController, [{
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      if (this.firstLineReq) {
	        ctrl.formValidationService.addField({
	          fieldName: 'line1',
	          displayName: 'Address Line 1',
	          model: ctrl.container,
	          required: true,
	          stringLength: {
	            min: 5,
	            max: 100
	          }
	        });
	      }
	    }
	  }]);
	  return AddressController;
	}();
	
	exports.default = AddressController;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./address.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./address.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".address{color:red}", ""]);
	
	// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactPhones = __webpack_require__(1306);
	
	var _contactPhones2 = _interopRequireDefault(_contactPhones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactPhonesModule = _angular2.default.module('contactPhones', [_angularUiRouter2.default]).component('contactPhones', _contactPhones2.default).name;
	
	exports.default = contactPhonesModule;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactPhones = __webpack_require__(1307);
	
	var _contactPhones2 = _interopRequireDefault(_contactPhones);
	
	var _contactPhones3 = __webpack_require__(1308);
	
	var _contactPhones4 = _interopRequireDefault(_contactPhones3);
	
	__webpack_require__(1310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactPhonesComponent = {
	  restrict: 'E',
	  bindings: {
	    container: '<'
	  },
	  template: _contactPhones2.default,
	  controller: _contactPhones4.default
	};
	
	exports.default = contactPhonesComponent;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel\">\r\n    <header>\r\n        <h2>Contact Phones</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editContactPhone()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Add Contact Phone\r\n        </a>\r\n    </header>\r\n\r\n    <table class=\"table table-hover\" ng-show=\"$ctrl.container.contactPhones.length\">\r\n        <thead>\r\n            <tr>\r\n                <th class=\"col-md-3\">Phone Type</th>\r\n                <th class=\"col-md-7\">Phone No</th>\r\n                <th class=\"col-md-1\">&nbsp;</th>\r\n                <th class=\"col-md-1\">&nbsp;</th>\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n            <tr data-ng-repeat=\"p in $ctrl.container.contactPhones\">\r\n                <td class=\"col-md-3\">\r\n                    {{ p.phoneTypeName }}\r\n                </td>\r\n                <td class=\"col-md-6\">\r\n                    {{ p.phone }}\r\n                </td>\r\n                <td class=\"col-md-3 xs-padding\">\r\n\r\n                    <div class=\"btn-group\">\r\n\r\n                        <button type=\"button\" ng-click=\"$ctrl.editContactPhone(p)\" title=\"Edit User\" class=\"btn btn-primary full-width\">\r\n                            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Edit\r\n                        </button>\r\n\r\n                        <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                        <span class=\"caret\"></span>\r\n                        <span class=\"sr-only\">Toggle Dropdown</span>\r\n                      </button>\r\n\r\n                        <ul class=\"dropdown-menu\">\r\n                            <li><a class=\"btn\" ng-click=\"$ctrl.removePhone(p)\" title=\"Delete User\">Remove Phone</a></li>\r\n                        </ul>\r\n                    </div>\r\n\r\n\r\n                </td>\r\n\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n\r\n    <p ng-show=\"!$ctrl.container.contactPhones.length\">\r\n        Contact Phones List is Empty\r\n    </p>\r\n\r\n</div>\r\n"

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editContactphoneModal = __webpack_require__(1309);
	
	var _editContactphoneModal2 = _interopRequireDefault(_editContactphoneModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPhonesController = function () {
	  ContactPhonesController.$inject = ["$scope", "$uibModal", "lookupService"];
	  function ContactPhonesController($scope, $uibModal, lookupService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactPhonesController);
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.lookupService = lookupService;
	
	    this.initializeEnumLookups();
	
	    this.errMsg = '';
	  }
	
	  (0, _createClass3.default)(ContactPhonesController, [{
	    key: 'initializeEnumLookups',
	    value: function initializeEnumLookups() {
	      var _this = this;
	
	      var ctrl = this;
	      ctrl.selectDefaults = {};
	
	      var lookups = ['PhoneType'];
	
	      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
	        var pleaseSelectOption = { id: null, name: 'Please Select' };
	        enumLookupCollection.phoneType.unshift(pleaseSelectOption);
	
	        _this.enumLookupCollection = enumLookupCollection;
	        _this.selectDefaults.phoneType = pleaseSelectOption;
	      });
	    }
	  }, {
	    key: 'editContactPhone',
	    value: function editContactPhone(phone) {
	      this.errMsg = '';
	      this.saveButtonTitle = 'Add';
	
	      if (phone) {
	        this.selectDefaults.phoneType = (0, _lodash.find)(this.enumLookupCollection.phoneType, function (o) {
	          return o.id === phone.phoneType;
	        });
	        this.tempPhoneNo = phone.phone;
	
	        phone.editMode = true;
	        this.editPhone = phone;
	
	        this.saveButtonTitle = 'Update';
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editContactphoneModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.selectDefaults.phoneType = this.enumLookupCollection.phoneType[0];
	      this.tempPhoneNo = '';
	      this.$uibModalInstance.close();
	
	      if (this.editPhone) {
	        this.editPhone.editMode = false;
	      }
	    }
	  }, {
	    key: 'addPhone',
	    value: function addPhone() {
	      var _this2 = this;
	
	      if (this.selectDefaults.phoneType.id === null) {
	        this.errMsg = 'Please select a Phone Type';
	        return;
	      }
	
	      if (!this.tempPhoneNo) {
	        this.errMsg = 'Please enter a Phone Number';
	        return;
	      }
	
	      var phone = (0, _lodash.find)(this.container.contactPhones, function (o) {
	        return !o.editMode && o.phone === _this2.tempPhoneNo;
	      });
	      if (phone) {
	        this.errMsg = 'This Phone No is already added to the list';
	        return;
	      }
	
	      if (!this.editPhone) {
	        this.container.contactPhones.push({
	          phoneType: this.selectDefaults.phoneType.id,
	          phoneTypeName: this.selectDefaults.phoneType.name,
	          phone: this.tempPhoneNo
	        });
	      } else {
	        this.editPhone.phoneType = this.selectDefaults.phoneType.id;
	        this.editPhone.phoneTypeName = this.selectDefaults.phoneType.name;
	        this.editPhone.phone = this.tempPhoneNo;
	      }
	
	      this.closeModal();
	    }
	  }, {
	    key: 'removePhone',
	    value: function removePhone(phone) {
	      this.container.contactPhones = (0, _lodash.without)(this.container.contactPhones, phone);
	    }
	  }]);
	  return ContactPhonesController;
	}();
	
	exports.default = ContactPhonesController;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Contact Phone </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Phone Type</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n              <div class=\"section\">\r\n                <select\r\n                  class=\"form-control\"\r\n                  ng-options=\"item.name for item in $ctrl.enumLookupCollection.phoneType track by item.id\"\r\n                  ng-model=\"$ctrl.selectDefaults.phoneType\">\r\n                </select>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Phone Number</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input class=\"form-control\" placeholder=\"Phone number\" ng-model=\"$ctrl.tempPhoneNo\" maxlength=\"50\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addPhone()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> {{$ctrl.saveButtonTitle}}\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactPhones.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactPhones.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactPhones{color:red}", ""]);
	
	// exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactEmails = __webpack_require__(1313);
	
	var _contactEmails2 = _interopRequireDefault(_contactEmails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactEmailsModule = _angular2.default.module('contactEmails', [_angularUiRouter2.default]).component('contactEmails', _contactEmails2.default).name;
	
	exports.default = contactEmailsModule;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactEmails = __webpack_require__(1314);
	
	var _contactEmails2 = _interopRequireDefault(_contactEmails);
	
	var _contactEmails3 = __webpack_require__(1315);
	
	var _contactEmails4 = _interopRequireDefault(_contactEmails3);
	
	__webpack_require__(1317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactEmailsComponent = {
	  restrict: 'E',
	  bindings: {
	    container: '<'
	  },
	  template: _contactEmails2.default,
	  controller: _contactEmails4.default
	};
	
	exports.default = contactEmailsComponent;

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel\">\r\n    <header>\r\n        <h2>Contact Emails</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editContactEmail()\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Add Contact Email\r\n        </a>\r\n    </header>\r\n\r\n    <table class=\"table table-hover\" ng-show=\"$ctrl.container.contactEmails.length\">\r\n        <thead>\r\n            <tr>\r\n                <th class=\"col-md-10\">Email Addresses</th>\r\n                <th class=\"col-md-1\">&nbsp;</th>\r\n                <th class=\"col-md-1\">&nbsp;</th>\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n            <tr ng-repeat=\"e in $ctrl.container.contactEmails\">\r\n                <td class=\"col-md-9\">\r\n                    {{ e.email }}\r\n                </td>\r\n                <td class=\"col-md-3 xs-padding\">\r\n\r\n                    <div class=\"btn-group\">\r\n\r\n                        <button type=\"button\" ng-click=\"$ctrl.editContactEmail(e)\" title=\"Edit User\" class=\"btn btn-primary full-width\">\r\n                            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Edit\r\n                        </button>\r\n\r\n                        <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                        <span class=\"caret\"></span>\r\n                        <span class=\"sr-only\">Toggle Dropdown</span>\r\n                      </button>\r\n\r\n                        <ul class=\"dropdown-menu\">\r\n                            <li><a class=\"btn\" ng-click=\"$ctrl.removeEmail(e)\" title=\"Delete User\">Remove Email</a></li>\r\n                        </ul>\r\n                    </div>\r\n\r\n\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n    <p ng-show=\"!$ctrl.container.contactEmails.length\">Contact Emails List is Empty</p>\r\n</div>\r\n"

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editContactEmailModal = __webpack_require__(1316);
	
	var _editContactEmailModal2 = _interopRequireDefault(_editContactEmailModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPhonesController = function () {
	  ContactPhonesController.$inject = ["$scope", "$uibModal", "lookupService"];
	  function ContactPhonesController($scope, $uibModal, lookupService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactPhonesController);
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.lookupService = lookupService;
	
	    this.errMsg = '';
	  }
	
	  (0, _createClass3.default)(ContactPhonesController, [{
	    key: 'editContactEmail',
	    value: function editContactEmail(eml) {
	      this.errMsg = '';
	      this.saveButtonTitle = 'Add';
	
	      if (eml) {
	        this.tempEmail = eml.email;
	
	        eml.editMode = true;
	        this.editEmail = eml;
	
	        this.saveButtonTitle = 'Update';
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editContactEmailModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.tempEmail = '';
	      this.$uibModalInstance.close();
	
	      if (this.editEmail) {
	        this.editEmail.editMode = false;
	      }
	    }
	  }, {
	    key: 'addEmail',
	    value: function addEmail() {
	      var _this = this;
	
	      if (!this.tempEmail) {
	        this.errMsg = 'Please enter a valid email address';
	        return;
	      }
	
	      var email = (0, _lodash.find)(this.container.contactEmails, function (o) {
	        return !o.editMode && o.email === _this.tempEmail;
	      });
	      if (email) {
	        this.errMsg = 'This Email is already added to the list';
	        return;
	      }
	
	      if (!this.editEmail) {
	        this.container.contactEmails.push({
	          email: this.tempEmail
	        });
	      } else {
	        this.editEmail.email = this.tempEmail;
	      }
	
	      this.closeModal();
	    }
	  }, {
	    key: 'removeEmail',
	    value: function removeEmail(email) {
	      this.container.contactEmails = (0, _lodash.without)(this.container.contactEmails, email);
	    }
	  }]);
	  return ContactPhonesController;
	}();
	
	exports.default = ContactPhonesController;

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Contact Email </h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Contact Email</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n\r\n            <input type=\"email\" class=\"form-control\" placeholder=\"Email address\" ng-model=\"$ctrl.tempEmail\" required/>\r\n\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addEmail()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> {{$ctrl.saveButtonTitle}}\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactEmails.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactEmails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactEmails{color:red}", ""]);
	
	// exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _gaugeChart = __webpack_require__(1320);
	
	var _gaugeChart2 = _interopRequireDefault(_gaugeChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gaugeChartModule = _angular2.default.module('gaugeChart', [_angularUiRouter2.default]).component('gaugeChart', _gaugeChart2.default).name;
	
	exports.default = gaugeChartModule;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gaugeChart = __webpack_require__(1321);
	
	var _gaugeChart2 = _interopRequireDefault(_gaugeChart);
	
	var _gaugeChart3 = __webpack_require__(1322);
	
	var _gaugeChart4 = _interopRequireDefault(_gaugeChart3);
	
	__webpack_require__(1325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gaugeChartComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '@',
	    eventId: '@'
	  },
	  template: _gaugeChart2.default,
	  controller: _gaugeChart4.default
	};
	
	exports.default = gaugeChartComponent;

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	module.exports = "<div style=\"width: 420px; height: 350px;\">\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-if=\"$ctrl.hasNoTarget\">No data to display</div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" style=\"width: 400px; height: 290px;\" ng-show=\"!$ctrl.hasNoTarget\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _highchartsMore = __webpack_require__(1323);
	
	var _highchartsMore2 = _interopRequireDefault(_highchartsMore);
	
	var _solidGauge = __webpack_require__(1324);
	
	var _solidGauge2 = _interopRequireDefault(_solidGauge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GaugeChartController = function () {
	  GaugeChartController.$inject = ["$scope"];
	  function GaugeChartController($scope) {
	    "ngInject";
	
	    //Begin Services
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GaugeChartController);
	    this.$scope = $scope;
	    //End Services
	
	    //Begin Data
	    this.hasNoTarget = false;
	    this.chartContainerId = "chartContainer" + this.getGuid();
	    this.chart = null;
	    //End Data
	
	    //Begin Initialize
	    this.$onChanges = function (changesObj) {
	      if (changesObj.eventId.currentValue) {
	        _this.$scope.$on("kpiAnalytics:targetsOverviewUpdated." + changesObj.eventId.currentValue, _this.refresh.bind(_this));
	      }
	    };
	
	    //Init Highcharts and Modules
	    (0, _highchartsMore2.default)(_highcharts2.default);
	    (0, _solidGauge2.default)(_highcharts2.default);
	
	    //End Initialize 
	  }
	
	  (0, _createClass3.default)(GaugeChartController, [{
	    key: "refresh",
	    value: function refresh(evt, params) {
	      if (this.chart) {
	        this.chart.destroy();
	      }
	
	      if (!params.target) {
	        this.hasNoTarget = true;
	      } else {
	        this.hasNoTarget = false;
	        this.generateChart(params.target, params.achieved);
	      }
	    }
	  }, {
	    key: "generateChart",
	    value: function generateChart(target, achieved) {
	      var limit1 = target;
	      var limit2 = limit1 + limit1 * 0.3;
	
	      //Chart Code Start     
	      var gaugeOptions = {
	        chart: {
	          type: 'gauge'
	        },
	        title: null,
	        pane: {
	          center: ['50%', '85%'],
	          size: '150%',
	          startAngle: -90,
	          endAngle: 90,
	          background: {
	            innerRadius: '60%',
	            outerRadius: '100%',
	            shape: 'arc'
	          }
	        },
	        tooltip: {
	          enabled: false
	        },
	        yAxis: {
	          lineWidth: 0,
	          minorTickInterval: null,
	          tickPixelInterval: 400,
	          tickWidth: 0,
	          labels: {
	            y: 16,
	            color: '#FFF'
	          }
	        }
	      };
	
	      var chartOptions = {
	        yAxis: {
	          min: 0,
	          max: limit2,
	          title: {
	            text: null
	          },
	          plotBands: [{
	            from: 0,
	            to: limit1,
	            color: '#f7e065',
	            innerRadius: '60%'
	          }, {
	            from: limit1,
	            to: limit2,
	            innerRadius: '60%',
	            color: '#5cd65c' // yellow
	          }]
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          data: [{ y: achieved }],
	          dataLabels: {
	            enabled: true
	          }
	        }]
	      };
	
	      // The speed gauge
	      return _highcharts2.default.chart(this.chartContainerId, _highcharts2.default.merge(gaugeOptions, chartOptions));
	
	      //Chart Code End
	    }
	  }, {
	    key: "getGuid",
	    value: function getGuid() {
	      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0,
	            v = c == 'x' ? r : r & 0x3 | 0x8;
	        return v.toString(16);
	      });
	    }
	  }]);
	  return GaugeChartController;
	}();
	
	exports.default = GaugeChartController;

/***/ }),
/* 1323 */,
/* 1324 */,
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./gaugeChart.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./gaugeChart.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".gaugeChart{color:red}.no-data{font-size:20px;height:300px;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiry = __webpack_require__(1328);
	
	var _enquiry2 = _interopRequireDefault(_enquiry);
	
	var _enquiryEdit = __webpack_require__(1333);
	
	var _enquiryEdit2 = _interopRequireDefault(_enquiryEdit);
	
	var _enquiryList = __webpack_require__(1415);
	
	var _enquiryList2 = _interopRequireDefault(_enquiryList);
	
	var _enquiry3 = __webpack_require__(1421);
	
	var _enquiry4 = _interopRequireDefault(_enquiry3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryModule = _angular2.default.module('enquiry', [_angularUiRouter2.default, _enquiryEdit2.default, _enquiryList2.default]).component('enquiry', _enquiry2.default).service('enquiryService', _enquiry4.default).name;
	
	exports.default = enquiryModule;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiry = __webpack_require__(1329);
	
	var _enquiry2 = _interopRequireDefault(_enquiry);
	
	var _enquiry3 = __webpack_require__(1330);
	
	var _enquiry4 = _interopRequireDefault(_enquiry3);
	
	__webpack_require__(1331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiry2.default,
	  controller: _enquiry4.default
	};
	
	exports.default = enquiryComponent;

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryController = function EnquiryController() {
	  (0, _classCallCheck3.default)(this, EnquiryController);
	
	  this.name = 'enquiry';
	};
	
	exports.default = EnquiryController;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1332);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./enquiry.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./enquiry.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiry{color:red}", ""]);
	
	// exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryEdit = __webpack_require__(1334);
	
	var _enquiryEdit2 = _interopRequireDefault(_enquiryEdit);
	
	var _enquiryBasicDetails = __webpack_require__(1341);
	
	var _enquiryBasicDetails2 = _interopRequireDefault(_enquiryBasicDetails);
	
	var _enquiryVehicles = __webpack_require__(1347);
	
	var _enquiryVehicles2 = _interopRequireDefault(_enquiryVehicles);
	
	var _enquiryTestDrives = __webpack_require__(1353);
	
	var _enquiryTestDrives2 = _interopRequireDefault(_enquiryTestDrives);
	
	var _enquiryTradeIns = __webpack_require__(1360);
	
	var _enquiryTradeIns2 = _interopRequireDefault(_enquiryTradeIns);
	
	var _enquiryPricing = __webpack_require__(1366);
	
	var _enquiryPricing2 = _interopRequireDefault(_enquiryPricing);
	
	var _enquiryConclude = __webpack_require__(1375);
	
	var _enquiryConclude2 = _interopRequireDefault(_enquiryConclude);
	
	var _simpleDpa = __webpack_require__(1384);
	
	var _simpleDpa2 = _interopRequireDefault(_simpleDpa);
	
	var _allDpa = __webpack_require__(1390);
	
	var _allDpa2 = _interopRequireDefault(_allDpa);
	
	var _ngsticky = __webpack_require__(1396);
	
	var _ngsticky2 = _interopRequireDefault(_ngsticky);
	
	var _enquiryTimeline = __webpack_require__(1397);
	
	var _enquiryTimeline2 = _interopRequireDefault(_enquiryTimeline);
	
	var _enquiryQuotes = __webpack_require__(1403);
	
	var _enquiryQuotes2 = _interopRequireDefault(_enquiryQuotes);
	
	var _customForms = __webpack_require__(1409);
	
	var _customForms2 = _interopRequireDefault(_customForms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryEditModule = _angular2.default.module('enquiryEdit', [_angularUiRouter2.default, _enquiryBasicDetails2.default, _enquiryVehicles2.default, _enquiryTestDrives2.default, _enquiryTradeIns2.default, _enquiryPricing2.default, _enquiryConclude2.default, _simpleDpa2.default, _allDpa2.default, 'sticky', _enquiryTimeline2.default, _enquiryQuotes2.default, _customForms2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquiryAdd', {
	    url: '/enquiry/add',
	    component: 'enquiryEdit',
	    params: {
	      contactId: null,
	      contactName: null,
	      enquiry: null,
	      activeTab: null,
	      isDpaSet: null,
	      isAllDpaSet: null
	    }
	  });
	
	  $stateProvider.state('enquiryEdit', {
	    url: '/enquiry/edit/:enquiryId',
	    component: 'enquiryEdit',
	    params: {
	      enquiry: null,
	      activeTab: null,
	      origin: null
	    }
	  });
	
	  $stateProvider.state('enquiryEditCode', {
	    url: '/enquiry/edit/:enquiryId',
	    component: 'enquiryEdit',
	    params: {
	      enquiry: null,
	      activeTab: 'conclusion',
	      origin: null,
	      code: null,
	      action: null
	    }
	  });
	}]).component('enquiryEdit', _enquiryEdit2.default).name;
	
	exports.default = enquiryEditModule;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryEdit = __webpack_require__(1335);
	
	var _enquiryEdit2 = _interopRequireDefault(_enquiryEdit);
	
	var _enquiryEdit3 = __webpack_require__(1336);
	
	var _enquiryEdit4 = _interopRequireDefault(_enquiryEdit3);
	
	__webpack_require__(1339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiryEdit2.default,
	  controller: _enquiryEdit4.default
	};
	
	exports.default = enquiryEditComponent;

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>{{$ctrl.$stateParams.enquiryId ? 'Edit Enquiry' : 'New Enquiry'}}</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editEnquiry()\" ng-hide=\"!$ctrl.canEdit() || $ctrl.enquiry.readonly || $ctrl.otherLocationVehicle\" ng-show=\"$ctrl.canLose()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n\r\n        <div class=\"btn-group pull-right\" uib-dropdown dropdown-append-to-body ng-hide=\"!$ctrl.canEdit() || $ctrl.enquiry.readonly || $ctrl.otherLocationVehicle\">\r\n          <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle>\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes and goto' : 'Saving Changes ...' }} <span class=\"caret\"></span>\r\n          </button>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n            <li role=\"menuitem\" ng-repeat=\"link in $ctrl.saveAndGoToList\">\r\n              <a ng-click=\"$ctrl.editEnquiry(true, link.state.name, link.state.params)\">{{link.name}}</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n\r\n        <a\r\n          class=\"btn btn-primary\"\r\n          ng-hide=\"$ctrl.params.isEntityManagement\"\r\n          ng-click=\"$ctrl.redirectToParent(true)\">\r\n            Go to Dashboard\r\n        </a>\r\n\r\n        <a\r\n          class=\"btn btn-default\"\r\n          ng-hide=\"!$ctrl.canEdit() || $ctrl.enquiry.readonly || $ctrl.otherLocationVehicle\"\r\n          ng-click=\"$ctrl.showFollowUpEmail()\">\r\n            <span class=\"fa fa-envelope-o\"></span>\r\n            Send Follow Up Email\r\n        </a>        \r\n\r\n      </header>\r\n      <br />\r\n      <!-- DPA Warning Basic -->\r\n      <div class=\"alert alert-warning\" ng-show=\"$ctrl.basicDpaCheck() || $ctrl.allDpaCheck()\">\r\n        <h2>Warning</h2>\r\n        <strong>Data Protection Authorization</strong> record(s) for this customer are not updated.\r\n        <br /><br/>\r\n        <ul>\r\n          <li ng-show=\"$ctrl.basicDpaCheck()\">\r\n            <a href=\"#\" ng-click=\"$ctrl.showUpdateDpa()\"><i>Marketing Consent</i></a> click here to update\r\n          </li>\r\n          <li ng-show=\"$ctrl.allDpaCheck()\">\r\n              <a href=\"#\" ng-click=\"$ctrl.showUpdateAllDpa()\"><i>Full Consent</i></a> click here to update\r\n          </li>\r\n        </ul>        \r\n      </div>\r\n\r\n      <!-- DPA Warning All-->\r\n      <div class=\"alert alert-warning\" ng-hide=\"true\">\r\n        <h2>Warning</h2>\r\n        <strong>Data Protection Authorization</strong> record for this customer is not updated.\r\n        <br />\r\n        <a href=\"#\" ng-click=\"$ctrl.showUpdateAllDpa()\">Please click here to update dpa</a>\r\n      </div>\r\n\r\n      <!-- Other Location Vehicle Warning -->\r\n      <div class=\"alert alert-warning\" ng-show=\"$ctrl.otherLocationVehicle\">\r\n          <h2>Warning</h2>\r\n          The selected vehicle is currently under a different location. Changes wont be allowed to this enquiry until the vehicle has been migrated across\r\n          <br />\r\n      </div>   \r\n      \r\n      <!-- Make Model Warning -->\r\n      <div class=\"alert alert-warning\" ng-show=\"$ctrl.noMakeModel()\">\r\n        <h2>Warning</h2>\r\n        <strong>Missing make / model info from this enquiry.</strong>\r\n        <br /><br/>\r\n        <ul>\r\n          <li ng-show=\"$ctrl.noMakeModel()\">\r\n            You need to select a Vehicle to this enquiry or specify a search criteria with Make / Model to be able to progress this enquiry\r\n          </li>\r\n        </ul>        \r\n      </div>\r\n\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"editEnquiry\">\r\n    <div class=\"panel\">\r\n        <form class=\"form-horizontal\" name=\"entityForm\" novalidate>\r\n          <uib-accordion close-others=\"true\">\r\n            <!-- Basic Information Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.basicDetails.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummary('basicDetails')\">\r\n                  <div class=\"col-md-2\">\r\n                    Basic Information\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!$ctrl.panels.basicDetails.visible\">{{$ctrl.panels.basicDetails.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.basicDetails.visible, 'glyphicon-chevron-down': !$ctrl.panels.basicDetails.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Basic-Details\r\n                enquiry=\"$ctrl.enquiry\"\r\n                form-Validation-Service=\"$ctrl.formValidationService\">\r\n              </enquiry-Basic-Details>\r\n            </div>\r\n            <!-- Basic Information End -->\r\n\r\n            <!-- Vehicles Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.vehicles.visible\" ng-show=\"$ctrl.enquiry.enquirySubType !== $ctrl.enums.ENQUIRY_SUBTYPE.BuyIn\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Vehicles\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!$ctrl.panels.vehicles.visible\">{{$ctrl.panels.vehicles.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.vehicles.visible, 'glyphicon-chevron-down': !$ctrl.panels.vehicles.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Vehicles\r\n                enquiry=\"$ctrl.enquiry\"\r\n                on-Vehicle-Selected=\"$ctrl.vehicleSelected()\"\r\n                form-Validation-Service=\"$ctrl.formValidationService\">\r\n              </enquiry-Vehicles>\r\n            </div>\r\n            <!-- Vehicles End -->\r\n\r\n            <!-- Test Drives Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.testDrives.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales && $ctrl.enquiry.enquirySubType !== $ctrl.enums.ENQUIRY_SUBTYPE.BuyIn && $ctrl.enquiry.contactType !== $ctrl.enums.CONTACT_TYPE.Trader\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Test Drives\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.testDrives.visible\">{{$ctrl.panels.testDrives.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.testDrives.visible, 'glyphicon-chevron-down': !ctrl.panels.testDrives.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Test-Drives\r\n                enquiry=\"$ctrl.enquiry\">\r\n              </enquiry-Test-Drives>\r\n            </div>\r\n            <!-- Test Drives End -->\r\n\r\n            <!-- Trade Ins Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.tradeIns.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales && $ctrl.enquiry.contactType !== $ctrl.enums.CONTACT_TYPE.Trader || ($ctrl.enquiry.contactType === $ctrl.enums.CONTACT_TYPE.Trader && $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.BuyIn)\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Trade Ins\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.tradeIns.visible\">{{$ctrl.panels.tradeIns.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.tradeIns.visible, 'glyphicon-chevron-down': !ctrl.panels.tradeIns.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Trade-Ins\r\n                enquiry=\"$ctrl.enquiry\"\r\n                on-Trade-In=\"$ctrl.vehicleTradedIn(allowance)\"\r\n                on-Remove-Trade-In=\"$ctrl.confirmRemoveTradeIn()\"\r\n                form-Validation-Service=\"$ctrl.formValidationService\"\r\n                >\r\n              </enquiry-Trade-Ins>\r\n            </div>\r\n            <!-- Trade Ins End -->\r\n\r\n            <!-- Pricing Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.pricing.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales && $ctrl.enquiry.contactType !== $ctrl.enums.CONTACT_TYPE.Trader\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Pricing\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.pricing.visible\">{{$ctrl.panels.pricing.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.pricing.visible, 'glyphicon-chevron-down': !ctrl.panels.pricing.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Pricing\r\n                enquiry=\"$ctrl.enquiry\"\r\n                amount-To-Pay=\"$ctrl.amountToPay\"\r\n                balance-Due=\"$ctrl.balanceDue\">\r\n              </enquiry-Pricing>\r\n            </div>\r\n            <!-- Pricing End -->\r\n\r\n            <!-- Enquiry Quotes Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.quotes.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales && $ctrl.enquiry.contactType !== $ctrl.enums.CONTACT_TYPE.Trader\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Enquiry Quotes\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.quotes.visible\">{{$ctrl.panels.quotes.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.quotes.visible, 'glyphicon-chevron-down': !ctrl.panels.quotes.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Quotes\r\n                enquiry=\"$ctrl.enquiry\">\r\n              </enquiry-Quotes>\r\n            </div>\r\n            <!-- Enquiry Quotes End -->            \r\n\r\n            <!-- Conclusion Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.conclusion.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Conclusion\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.conclusion.visible\">{{$ctrl.panels.conclusion.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.conclusion.visible, 'glyphicon-chevron-down': !ctrl.panels.conclusion.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Conclude enquiry=\"$ctrl.enquiry\" summaryLine=\"$ctrl.summaryLines.conclusion\"></enquiry-Conclude>\r\n            </div>\r\n            <!-- Conclusion End -->\r\n\r\n            <!-- Notes Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.notes.visible\" ng-show=\"$ctrl.enquiry.enquiryType !== $ctrl.enums.ENQUIRY_TYPE.Aftersales\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Notes\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.notes.visible\">{{$ctrl.panels.notes.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.notes.visible, 'glyphicon-chevron-down': !ctrl.panels.notes.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <notes notes-Collection=\"$ctrl.enquiry.notes\" with-Promises=\"true\" contact=\"{contactId: $ctrl.enquiry.contactId, contactName: $ctrl.enquiry.contactName}\"/>\r\n            </div>\r\n            <!-- Notes End -->\r\n\r\n            <!-- Enquiry Timeline -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.enquiryTimeline.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Enquiry Timeline\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.enquiryTimeline.visible\">{{$ctrl.panels.enquiryTimeline.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.enquiryTimeline.visible, 'glyphicon-chevron-down': !ctrl.panels.enquiryTimeline.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <enquiry-Timeline\r\n                enquiry=\"$ctrl.enquiry\"\r\n                >\r\n              </enquiry-Timeline>\r\n            </div>\r\n            <!-- Enquiry Timeline -->      \r\n            \r\n            <!-- Custom Forms -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.customForms.visible\" \r\n              ng-show=\"$ctrl.enquiry.enquiryType === $ctrl.enums.ENQUIRY_TYPE.Sales\r\n              && ($ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.New || $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.Used || $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.BuyIn || $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.Unsure)\r\n              && ($ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed)\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Custom Forms\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.customForms.visible\">{{$ctrl.panels.customForms.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.customForms.visible, 'glyphicon-chevron-down': !ctrl.panels.customForms.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <custom-Forms\r\n                enquiry=\"$ctrl.enquiry\"\r\n                >\r\n            </custom-Forms>\r\n            </div>\r\n            <!-- Custom Forms -->                  \r\n\r\n          </uib-accordion>\r\n        </form>\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _canvasStuff = __webpack_require__(1153);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _updateConactDpaTemplate = __webpack_require__(1337);
	
	var _updateConactDpaTemplate2 = _interopRequireDefault(_updateConactDpaTemplate);
	
	var _updateContactAllDpaTemplate = __webpack_require__(1338);
	
	var _updateContactAllDpaTemplate2 = _interopRequireDefault(_updateContactAllDpaTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryEditController = function () {
	  EnquiryEditController.$inject = ["authService", "$stateParams", "enums", "$scope", "loadingService", "enquiryService", "$state", "$timeout", "$filter", "addPromiseService", "$q", "$uibModal", "contactService", "$ngConfirm", "integrationService", "growl", "printService", "fileService", "adminService", "$sce", "appConfig", "lookupService"];
	  function EnquiryEditController(authService, $stateParams, enums, $scope, loadingService, enquiryService, $state, $timeout, $filter, addPromiseService, $q, $uibModal, contactService, $ngConfirm, integrationService, growl, printService, fileService, adminService, $sce, appConfig, lookupService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EnquiryEditController);
	    var permissionToCheck = void 0;
	    if ($stateParams.enquiryId) {
	      permissionToCheck = enums.PERMISSION_TYPE.Edit;
	    } else {
	      permissionToCheck = enums.PERMISSION_TYPE.Add;
	    }
	    if (!authService.validateUser(false, 'Enquiry', permissionToCheck, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.$stateParams = $stateParams;
	    this.enums = enums;
	    this.$scope = $scope;
	    this.loadingService = loadingService;
	    this.enquiryService = enquiryService;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$filter = $filter;
	    this.addPromiseService = addPromiseService;
	    this.$q = $q;
	    this.$uibModal = $uibModal;
	    this.contactService = contactService;
	    this.$ngConfirm = $ngConfirm;
	    this.integrationService = integrationService;
	    this.growl = growl;
	    this.printService = printService;
	    this.fileService = fileService;
	    this.adminService = adminService;
	    this.$sce = $sce;
	    this.appConfig = appConfig;
	    this.lookupService = lookupService;
	
	    this.authService.getLocationExtendedProperties('customForms');
	    this.authService.getLocationExtendedProperties('webLeadFollowUpEmail');
	    this.authService.getLocationExtendedProperties('makeModelMandatory');
	
	    this.formValidationService = new _FormValidationService2.default();
	
	    this.enquiry = {
	      entityId: authService.authData.currentLocation.key,
	      enquiryVehicles: [],
	      testDrives: [],
	      tradeInVehicles: [],
	      enquiryPrices: [],
	      enquiryPayments: [],
	      notes: [],
	      enquiryQuotes: [],
	      enquiryLostReason: null,
	      enquirySourceId: null,
	      state: enums.ENQUIRY_STATE.Open,
	      isDpaSet: $stateParams.isDpaSet !== null ? $stateParams.isDpaSet : true,
	      isAllDpaSet: $stateParams.isAllDpaSet !== null ? $stateParams.isAllDpaSet : true
	    };
	
	    this.amountToPay = 0;
	    this.balanceDue = 0;
	
	    this.panelNames = ['basicDetails', 'vehicles', 'testDrives', 'tradeIns', 'pricing', 'quotes', 'conclusion', 'notes', 'enquiryTimeline', 'customForms'];
	
	    this.panels = {};
	
	    this.saveAndGoToList = [];
	    this.saveAndGoToList.push({ name: 'My Dasboard', state: { name: 'dashboard', params: {} } });
	    this.saveAndGoToList.push({ name: 'All Enquiries List', state: { name: 'enquiryList', params: {} } });
	
	    this.initialized = false;
	    this.$scope.$on('enquiryPricing:initialized', this.enquiryPricingInitialized.bind(this));
	    this.$scope.$on('enquiryPricing:notesUpdated', this.notesUpdated.bind(this));
	    this.$scope.$on('enquiryConclude:enquiryConfirmed', this.enquiryConfirmed.bind(this));
	    this.$scope.$on('enquiry:proxyEvent', this.proxyEvent.bind(this));
	
	    this.lookupService.lookupBrands().then(function (response) {
	      return _this.brands = response;
	    });
	    this.lookupService.lookupBrandModels().then(function (response) {
	      return _this.brandModels = response;
	    });
	
	    this.loadEnquiry();
	  }
	
	  (0, _createClass3.default)(EnquiryEditController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'initializeTabs',
	    value: function initializeTabs() {
	      var _this2 = this;
	
	      this.panelNames.map(function (panelName) {
	        _this2.panels[panelName] = {
	          visible: true
	        };
	
	        if (_this2.$stateParams.activeTab === panelName) {
	          _this2.panels[panelName].visible = true;
	        } else {
	          _this2.panels[panelName].visible = false;
	        }
	
	        _this2.updateSummaries(panelName);
	      });
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      //Check if selected vehicle belongs to this location
	      var ev = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	      if (ev && ev.vehicle.entityId != this.authService.authData.currentLocation.key) {
	        this.otherLocationVehicle = true;
	      } else {
	        this.otherLocationVehicle = false;
	      }
	
	      //Add this to the enquiry so all other sub components can have access to it
	      this.enquiry.otherLocationVehicle = this.otherLocationVehicle;
	
	      this.saveAndGoToList.push({ name: ctrl.enquiry.contactName + '\'s Console', state: { name: 'contactView', params: { contactId: ctrl.enquiry.contactId } } });
	
	      ctrl.formValidationService.initialize(ctrl.enquiry);
	
	      //Is Enquiry open
	      ctrl.enquiry.isOpen = ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Open;
	      //If this is a Multi Vehicle Deal
	      ctrl.enquiry.isMultiSelect = ctrl.enquiry.contactType === ctrl.enums.CONTACT_TYPE.Trader;
	
	      this.$scope.$broadcast('enquiry:initialized');
	
	      if (this.$stateParams.code) {
	        if (this.$stateParams.action === 'requestSignature') {
	          this.requestSignature();
	        } else if (this.$stateParams.action === 'viewSignedOrderForm') {
	          this.printService.printSignedOrderForm(this.enquiry.enquiryId, this.authService.authData.currentLocation.key, this.$stateParams.code);
	        }
	      }
	    }
	  }, {
	    key: 'loadEnquiry',
	    value: function loadEnquiry() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      if (ctrl.$stateParams.enquiry) {
	        /*
	        * If there is an enquiry in State Params
	        * This means that we left the enquiry edit page to select vehicle / quotation / form etc
	        * And we passed the same enquiry object back, which we sent before creating the contact
	        * We want to save this enquiry so unsaved changes may not get lost and will cause
	        * unwanted results
	        */
	        (0, _assign2.default)(ctrl.enquiry, ctrl.$stateParams.enquiry);
	        ctrl.editEnquiry(null, null, null, true).then(function () {
	          ctrl.initializeTabs();
	          ctrl.configureForm();
	        });
	      } else if (ctrl.$stateParams.enquiryId) {
	        ctrl.loadingService.showLoading('editEnquiry', 'Loading Enquiry ...');
	
	        ctrl.enquiryService.getEnquiry(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.enquiryId).then(function (response) {
	          (0, _assign2.default)(ctrl.enquiry, response.data);
	          _this3.initializeTabs();
	          ctrl.configureForm();
	        }).catch(function (err) {}).finally(function () {
	          ctrl.loadingService.hideLoading('editEnquiry');
	        });
	      } else {
	        /*
	        * Its a New Enquiry
	        */
	        if (!ctrl.$stateParams.contactId || !ctrl.$stateParams.contactName) {
	          ctrl.authService.unauthorized('Contact is missing');
	        }
	
	        ctrl.enquiry.contactId = ctrl.$stateParams.contactId;
	        ctrl.enquiry.contactName = ctrl.$stateParams.contactName;
	        ctrl.initializeTabs();
	        ctrl.configureForm();
	      }
	    }
	  }, {
	    key: 'vehicleSelected',
	    value: function vehicleSelected() {
	      this.$scope.$broadcast('vehicleSelected');
	
	      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	
	      if (!this.enquiry.subject) {
	        this.enquiry.subject = selectedVehicle.vehicle.model;
	      }
	
	      if (!this.enquiry.amountToSpend) {
	        this.enquiry.amountToSpend = selectedVehicle.vehicle.price;
	      }
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent(goBack) {
	
	      if (this.redirectFromSource()) {
	        return;
	      }
	
	      if (goBack) {
	        this.$state.go('dashboard');
	      } else {
	        this.$state.go(this.gotoState, this.gotoStateParams);
	      }
	    }
	  }, {
	    key: 'redirectFromSource',
	    value: function redirectFromSource() {
	      if (this.$stateParams.origin) {
	        switch (this.$stateParams.origin) {
	          case 'editFinance':
	            this.$state.go('financeEdit', { financeId: this.enquiry.enquiryId });
	            break;
	        }
	
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'showAddPromise',
	    value: function showAddPromise(goBack, state, stateParams) {
	      this.goBack = goBack;
	      this.gotoState = state, this.gotoStateParams = stateParams, this.addPromiseService.showAddPromise(this.redirectToParent.bind(this), false, null, {
	        contactId: this.enquiry.contactId,
	        contactName: this.enquiry.contactName
	      });
	    }
	  }, {
	    key: 'editEnquiry',
	    value: function editEnquiry(goBack, state, stateParams) {
	      var _this4 = this,
	          _arguments = arguments;
	
	      var isInternalSave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var isEnquiryConfirmed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	      var enquiryClone = (0, _stringify2.default)(ctrl.enquiry);
	
	      if (this.authService.authData.currentLocation.makeModelMandatory.enabled && !isInternalSave && !ctrl.validateMakeAndModel()) {
	        return;
	      }
	
	      if (!ctrl.formValidationService.validateForm()) {
	        return;
	      }
	
	      if (!ctrl.enquiryCloseDpaCheck(isInternalSave, goBack, state, stateParams)) {
	        return;
	      }
	
	      //Disabled for now ! this may not be needed
	      if (!isInternalSave && ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Confirmed && !ctrl.enquiry.isAllDpaSet) {
	        //ctrl.showUpdateAllDpa(true, goBack, state, stateParams, isInternalSave);
	        //return;
	      }
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');
	
	      //Remove All Vehicle Objects and just leave their IDs
	      var clonedEqVehicles = JSON.parse((0, _stringify2.default)(ctrl.enquiry.enquiryVehicles));
	      ctrl.enquiry.enquiryVehicles.map(function (ev) {
	        ev.vehicle = null;
	      });
	
	      //Remove All Vehicle from Vehicle Trade Ins and just leave their IDs
	      var clonedEqTradeIns = JSON.parse((0, _stringify2.default)(ctrl.enquiry.tradeInVehicles));
	      ctrl.enquiry.tradeInVehicles.map(function (v) {
	        v.vehicle = null;
	      });
	
	      //Remove All Enquiry Prices where the amount is 0 (except for complimentary)
	      (0, _lodash.remove)(ctrl.enquiry.enquiryPrices, function (o) {
	        return !o.complimentary && !o.removed && (o.amount === 0 || o.amount === null);
	      });
	
	      if (ctrl.enquiry.criteria) {
	        ctrl.enquiry.criteria.brand = null;
	        ctrl.enquiry.criteria.brandModel = null;
	      }
	
	      ctrl.enquiryService.editEnquiry(ctrl.enquiry).then(function (response) {
	        _this4.state = 'Saved';
	
	        ctrl.enquiry.enquiryVehicles = clonedEqVehicles;
	        ctrl.enquiry.tradeInVehicles = clonedEqTradeIns;
	
	        if (!isInternalSave) {
	          ctrl.showAddPromise(goBack, state, stateParams);
	        }
	
	        if (!isEnquiryConfirmed) {
	          ctrl.enquiry.isAllDpaSet = response.data.allDpaSet;
	          ctrl.enquiry.marketing_Email = response.data.viaEmail;
	          ctrl.enquiry.marketing_Post = response.data.viaPost;
	          ctrl.enquiry.marketing_Text = response.data.viaText;
	          ctrl.enquiry.marketing_Phone = response.data.viaPhone;
	        }
	
	        ctrl.enquiry.followUpWebLeadEmail = false;
	
	        deferred.resolve();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.loadEnquiry();
	          ctrl.state = 'ModelError';
	
	          if (err.data.map) {
	            err.data.map(function (item) {
	              ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	            });
	          } else {
	            ctrl.formValidationService.addSystemError(null, err.data);
	          }
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, 'A system error occurred while processing your request. Please try again later or contact system administrator if problem persists. Error details: ' + err.data.exceptionMessage);
	        } else if (err.status === 600) {
	          ctrl.warnLinkedEnquiries(err.data, _arguments);
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateSummaries',
	    value: function updateSummaries() {
	      var ctrl = this;
	      /*
	      * It is important to note that when this method will be triggered
	      * the visibility control variable defined in this.panels.XXX would
	      * not have been updated. This method will fire before the control
	      * variable gets updated. Therefore if condition defined in the next
	      * block is the inverse of what it should have been.
	      */
	      (0, _lodash.map)(this.panels, function (panel, panelName) {
	        panel.summary = eval('ctrl.updateSummary_' + panelName + '()');
	      });
	    }
	  }, {
	    key: 'updateSummary_basicDetails',
	    value: function updateSummary_basicDetails() {
	      return this.enquiry.contactName;
	    }
	  }, {
	    key: 'updateSummary_vehicles',
	    value: function updateSummary_vehicles() {
	      var _this5 = this;
	
	      if (this.enquiry.enquiryVehicles.length) {
	
	        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	          return o.isSelected;
	        });
	
	        if (!vehicle) {
	          vehicle = this.enquiry.enquiryVehicles[this.enquiry.enquiryVehicles.length - 1];
	        }
	
	        return vehicle.vehicle.model + ' ' + vehicle.vehicle.variant;
	      } else if (this.enquiry.criteria.brandModelId != null) {
	        var brand = (0, _lodash.find)(this.brands, function (o) {
	          return o.brandId === _this5.enquiry.criteria.brandId;
	        });
	        var brandModel = (0, _lodash.find)(this.brandModels, function (o) {
	          return o.brandModelId === _this5.enquiry.criteria.brandModelId;
	        });
	
	        return 'Interested in ' + brand.name + ' ' + brandModel.name;
	      }
	    }
	  }, {
	    key: 'updateSummary_testDrives',
	    value: function updateSummary_testDrives() {
	      if (this.enquiry.testDrives.length) {
	        var testDrive = this.enquiry.testDrives[this.enquiry.testDrives.length - 1];
	        var formattedDate = '';
	
	        if (testDrive.timeStamp) {
	          formattedDate = this.$filter('date')(testDrive.timeStamp, 'dd-MMMM-yyyy');
	        }
	        return testDrive.model + ', ' + formattedDate;
	      }
	    }
	  }, {
	    key: 'updateSummary_tradeIns',
	    value: function updateSummary_tradeIns() {
	      if (this.enquiry.tradeInVehicles.length) {
	        var tradeInVehicle = this.enquiry.tradeInVehicles[this.enquiry.tradeInVehicles.length - 1].vehicle;
	
	        return (tradeInVehicle.brand ? tradeInVehicle.brand : '') + ' ' + tradeInVehicle.model;
	      }
	    }
	  }, {
	    key: 'updateSummary_pricing',
	    value: function updateSummary_pricing() {
	      return 'Amount To Pay: ' + this.$filter('currency')(this.amountToPay, '€', 2) + ', Balance Due: ' + this.$filter('currency')(this.balanceDue, '€', 2);
	    }
	  }, {
	    key: 'updateSummary_quotes',
	    value: function updateSummary_quotes() {
	      if (this.enquiry.enquiryQuotes.length) {
	        var eq = this.enquiry.enquiryQuotes[0];
	
	        var formattedDate = this.$filter('date')(eq.created, 'dd MMM yy HH:mm');
	
	        return 'Last Save Quote On ...' + formattedDate;
	      }
	
	      return 'No Quotes Saved';
	    }
	  }, {
	    key: 'updateSummary_conclusion',
	    value: function updateSummary_conclusion() {
	      switch (this.enquiry.state) {
	        case this.enums.ENQUIRY_STATE.Open:
	          return 'Status: Open';
	          break;
	
	        case this.enums.ENQUIRY_STATE.Lost:
	          return 'Status: Lost';
	          break;
	
	        case this.enums.ENQUIRY_STATE.Confirmed:
	          return 'Status: Confirmed - Awaiting Delivery';
	          break;
	
	        case this.enums.ENQUIRY_STATE.Closed:
	          return 'Status: Customer Delivered';
	          break;
	      }
	    }
	  }, {
	    key: 'updateSummary_notes',
	    value: function updateSummary_notes() {
	      if (this.enquiry.notes.length) {
	        var note = this.enquiry.notes[this.enquiry.notes.length - 1];
	
	        return note.text.substring(0, 90);
	      }
	    }
	  }, {
	    key: 'updateSummary_enquiryTimeline',
	    value: function updateSummary_enquiryTimeline() {}
	  }, {
	    key: 'updateSummary_customForms',
	    value: function updateSummary_customForms() {
	      return "";
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      var ctrl = this;
	      var retValue = false;
	
	      retValue = ctrl.authService.checkFeatureAccess('Enquiry', ctrl.enums.PERMISSION_TYPE.Edit, false) && (ctrl.authService.isEntityOwner(this.enquiry) || ctrl.authService.isManager());
	
	      /* 
	      * Adding a check for Mandatory Make Model 
	      * This will return false if makeModelMandatory setting is enabled and there
	      * is no makeModelId in the enquiry criteria
	      */
	      if (this.authService.authData.currentLocation.makeModelMandatory && this.authService.authData.currentLocation.makeModelMandatory.enabled && this.enquiry && this.enquiry.criteria && this.enquiry.enquiryVehicles) {
	        retValue = !!(retValue && (this.enquiry.enquiryVehicles.length > 0 || this.enquiry.criteria.brandModelId));
	      }
	
	      return retValue;
	    }
	  }, {
	    key: 'canLose',
	    value: function canLose() {
	      return !this.enquiry.readonly && this.enquiry.enquiryLostReason != null;
	    }
	  }, {
	    key: 'enquiryPricingInitialized',
	    value: function enquiryPricingInitialized(e, data) {
	      this.initialized = true;
	      this.amountToPay = data.amountToPay;
	      this.balanceDue = data.balanceDue;
	
	      this.updateSummaries();
	    }
	  }, {
	    key: 'editImage',
	    value: function editImage(img) {
	      var $container = $('.signature-container');
	      var width = $container.width();
	      var height = $container.height();
	
	      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + 'px" height="' + height + 'px" id="sig-canvas"></canvas><canvas width="' + width + 'px" height="' + height + 'px" style="display:none;" id="hidden-canvas"></canvas></div>');
	      $('.signature-container').empty().append($divCanvas);
	      (0, _canvasStuff.doMagic)(null, true);
	    }
	  }, {
	    key: 'showUpdateDpa',
	    value: function showUpdateDpa(saveEnquiry, goBack, state, stateParams, isInternalSave) {
	      var _this6 = this;
	
	      //debugger;
	
	      var dpa = {
	        contactId: this.enquiry.contactId
	      };
	
	      if (this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Email || this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Web) {
	        dpa.verbalConsent = true;
	      }
	
	      this.$state.go('simpleDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, dpa: dpa });
	      return;
	
	      this.$scope.errUpdateDpa = '';
	      this.$scope.updateDpa = this.updateDpa.bind(this);
	      this.$scope.clearSignature = this.clearSignature.bind(this);
	      this.$scope.confirmVerbalConsent = this.confirmVerbalConsent.bind(this);
	      this.$scope.checkOptions = this.checkOptionsDpa.bind(this);
	      this.$scope.dpa = dpa;
	
	      if (saveEnquiry) {
	        this.$scope.saveEnquiry = {
	          doSave: true,
	          goBack: goBack,
	          state: state,
	          stateParams: stateParams,
	          isInternalSave: isInternalSave
	        };
	      } else {
	        this.$scope.saveEnquiry = {
	          doSave: false
	        };
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _updateConactDpaTemplate2.default,
	        scope: this.$scope,
	        size: 'lg'
	      });
	
	      this.$uibModalInstance.opened.then(function () {
	        setTimeout(_this6.editImage, 0);
	      });
	    }
	  }, {
	    key: 'checkOptionsDpa',
	    value: function checkOptionsDpa(val) {
	      this.$scope.dpa.viaEmail = val;
	      this.$scope.dpa.viaText = val;
	      this.$scope.dpa.viaPost = val;
	      this.$scope.dpa.viaPhone = val;
	    }
	  }, {
	    key: 'confirmVerbalConsent',
	    value: function confirmVerbalConsent() {
	      if (this.$scope.dpa.verbalConsent) {
	        this.$scope.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');
	      }
	    }
	  }, {
	    key: 'validateDpa',
	    value: function validateDpa() {
	      this.$scope.errUpdateDpa = '';
	
	      if ((0, _canvasStuff.isCanvasEmpty)()) {
	        this.$scope.errUpdateDpa = 'Please sign the form before submitting';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'updateDpa',
	    value: function updateDpa() {
	      var _this7 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.validateDpa()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Updating DPA ...');
	
	      ctrl.$scope.dpa.signData = (0, _canvasStuff.getCanvasData)();
	      ctrl.contactService.updateDpa(ctrl.authService.authData.currentLocation.key, ctrl.$scope.dpa).then(function (response) {
	        _this7.closeModal();
	        _this7.enquiry.isDpaSet = true;
	        if (_this7.$scope.saveEnquiry.doSave) {
	          _this7.editEnquiry(_this7.$scope.saveEnquiry.goBack, _this7.$scope.saveEnquiry.state, _this7.$scope.saveEnquiry.stateParams, _this7.$scope.saveEnquiry.isInternalSave);
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'showUpdateAllDpa',
	    value: function showUpdateAllDpa(saveEnquiry, goBack, state, stateParams, isInternalSave) {
	      var _this8 = this;
	
	      var marketing = {
	        email: this.enquiry.marketing_Email,
	        post: this.enquiry.marketing_Post,
	        text: this.enquiry.marketing_Text,
	        phone: this.enquiry.marketing_Phone
	      };
	
	      this.$state.go('allDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, marketing: marketing });
	      return;
	
	      this.$scope.errUpdateDpa = '';
	      this.$scope.updateDpa = this.updateAllDpa.bind(this);
	      this.$scope.clearSignature = this.clearSignature.bind(this);
	      this.$scope.confirmVerbalConsent = this.confirmVerbalConsent.bind(this);
	      this.$scope.checkOptions = this.checkOptionsDpaAll.bind(this);
	
	      this.$scope.dpa = {
	        contactId: this.enquiry.contactId,
	        marketing_Email: this.enquiry.marketing_Email,
	        marketing_Post: this.enquiry.marketing_Post,
	        marketing_Text: this.enquiry.marketing_Text,
	        marketing_Phone: this.enquiry.marketing_Phone
	      };
	
	      if (saveEnquiry) {
	        this.$scope.saveEnquiry = {
	          doSave: true,
	          goBack: goBack,
	          state: state,
	          stateParams: stateParams,
	          isInternalSave: isInternalSave
	        };
	      } else {
	        this.$scope.saveEnquiry = {
	          doSave: false
	        };
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _updateContactAllDpaTemplate2.default,
	        scope: this.$scope,
	        size: 'lg'
	      });
	
	      this.$uibModalInstance.opened.then(function () {
	        setTimeout(_this8.editImage, 0);
	      });
	    }
	  }, {
	    key: 'checkOptionsDpaAll',
	    value: function checkOptionsDpaAll(val) {
	      this.$scope.dpa.marketing_Email = val;
	      this.$scope.dpa.marketing_Text = val;
	      this.$scope.dpa.marketing_Post = val;
	      this.$scope.dpa.marketing_Phone = val;
	
	      this.$scope.dpa.service_Email = val;
	      this.$scope.dpa.service_Text = val;
	      this.$scope.dpa.service_Post = val;
	      this.$scope.dpa.service_Phone = val;
	
	      this.$scope.dpa.manufacturer_Email = val;
	      this.$scope.dpa.manufacturer_Text = val;
	      this.$scope.dpa.manufacturer_Post = val;
	      this.$scope.dpa.manufacturer_Phone = val;
	
	      this.$scope.dpa.surveys_Email = val;
	      this.$scope.dpa.surveys_Text = val;
	      this.$scope.dpa.surveys_Post = val;
	      this.$scope.dpa.surveys_Phone = val;
	
	      this.$scope.dpa.changeCycle_Email = val;
	      this.$scope.dpa.changeCycle_Text = val;
	      this.$scope.dpa.changeCycle_Post = val;
	      this.$scope.dpa.changeCycle_Phone = val;
	    }
	  }, {
	    key: 'updateAllDpa',
	    value: function updateAllDpa() {
	      var _this9 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.validateDpa()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Updating DPA ...');
	
	      ctrl.$scope.dpa.signData = (0, _canvasStuff.getCanvasData)();
	      ctrl.contactService.updateAllDpa(ctrl.authService.authData.currentLocation.key, ctrl.$scope.dpa).then(function (response) {
	        _this9.closeModal();
	        _this9.enquiry.isAllDpaSet = true;
	        if (_this9.$scope.saveEnquiry.doSave) {
	          _this9.editEnquiry(_this9.$scope.saveEnquiry.goBack, _this9.$scope.saveEnquiry.state, _this9.$scope.saveEnquiry.stateParams, _this9.$scope.saveEnquiry.isInternalSave);
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'clearSignature',
	    value: function clearSignature() {
	      (0, _canvasStuff.clearCanvas)(true);
	    }
	  }, {
	    key: 'notesUpdated',
	    value: function notesUpdated() {
	      this.editEnquiry(null, null, null, true);
	    }
	  }, {
	    key: 'confirmRemoveTradeIn',
	    value: function confirmRemoveTradeIn() {
	      var _this10 = this;
	
	      this.$ngConfirm({
	        title: "Warning",
	        content: 'Are you sure you want to remove this trade in ?',
	        type: 'orange',
	        columnClass: 'm',
	        buttons: {
	          ok: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              return _this10.removeTradeIn();
	            }
	          },
	          cancel: {
	            text: 'Not sure',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeTradeIn',
	    value: function removeTradeIn() {
	      var _this11 = this;
	
	      var ctrl = this;
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Removing Trade In ...');
	
	      ctrl.enquiryService.removeTradeIn(this.enquiry.enquiryId).then(function (response) {
	        _this11.state = 'Saved';
	
	        _this11.growl.success('Trade In removed successfully', { ttl: 5000 });
	        _this11.enquiry.tradeInVehicles = [];
	      }).catch(function (err) {
	        if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, 'Could not remove trade in due to the following error. ' + err.data.exceptionMessage);
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'enquiryConfirmed',
	    value: function enquiryConfirmed() {
	      this.editEnquiry(null, null, null, true, true);
	    }
	  }, {
	    key: 'proxyEvent',
	    value: function proxyEvent(e, data) {
	      this.$scope.$broadcast(data.eventName);
	    }
	  }, {
	    key: 'warnLinkedEnquiries',
	    value: function warnLinkedEnquiries(linkedEnquiries, editArgs) {
	      var _this12 = this;
	
	      var arrLinkedEnquiries = linkedEnquiries.toString().replace(/\"/g, '').split(',');
	      this.$ngConfirm({
	        title: 'Multiple Enquiries',
	        content: 'There are <b>' + arrLinkedEnquiries.length + '</b> other open enquirie(s) for this Contact with the same trade in vehicle. <br /><br />Confirming this enquiry will mark the other one\'s as lost.</br></br> <b>Are you sure you want to continue ?</b>',
	        type: 'orange',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes, Confirm this and Close others',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this12.enquiryService.closeLinkedEnquiries(arrLinkedEnquiries).then(function () {
	                _this12.editEnquiry.apply(_this12, (0, _toConsumableArray3.default)(editArgs));
	              });
	            }
	          },
	          no: {
	            text: 'No, I will decide later',
	            btnClass: 'btn-default',
	            action: function action() {
	              _this12.$scope.$apply(function () {
	                _this12.state = 'Saved';
	                _this12.enquiry.state = _this12.enums.ENQUIRY_STATE.Open;
	              });
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'basicDpaCheck',
	    value: function basicDpaCheck() {
	      return !this.otherLocationVehicle && this.initialized && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet;
	    }
	  }, {
	    key: 'allDpaCheck',
	    value: function allDpaCheck() {
	      return !this.otherLocationVehicle && this.initialized && (this.enquiry.state === this.enums.ENQUIRY_STATE.Confirmed || this.enquiry.state === this.enums.ENQUIRY_STATE.Closed) && !this.enquiry.isAllDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet;
	    }
	  }, {
	    key: 'enquiryCloseDpaCheck',
	    value: function enquiryCloseDpaCheck(isInternalSave, goBack, state, stateParams) {
	      if (isInternalSave || this.enquiry.state != this.enums.ENQUIRY_STATE.Closed) {
	        return true;
	      }
	
	      //Check for Basic Dpa if its not optinal in the location
	      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
	        this.showUpdateDpa(true, goBack, state, stateParams, isInternalSave);
	        return false;
	      }
	
	      /*if (!isInternalSave && ctrl.enquiry.state === ctrl.enums.ENQUIRY_STATE.Confirmed && !ctrl.enquiry.isDpaSet && ctrl.enquiry.contactType !== ctrl.enums.CONTACT_TYPE.Trader && ctrl.enquiry.contactType !== ctrl.enums.CONTACT_TYPE.RetailFleet) {
	        ctrl.showUpdateDpa(true, goBack, state, stateParams, isInternalSave);
	        return;
	      }*/
	
	      return true;
	    }
	  }, {
	    key: 'requestSignature',
	    value: function requestSignature() {
	      var _this13 = this;
	
	      this.loadingService.showLoading('editEnquiry', 'Sending request for Signature ...');
	
	      var apiCall = this.integrationService.sendForSignature.bind(this.integrationService);
	
	      if (this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader) {
	        apiCall = this.integrationService.sendTradeFormForSignature.bind(this.integrationService);
	      }
	
	      apiCall(this.enquiry.entityId, this.enquiry.enquiryId, this.$stateParams.additionalRecipients, this.$stateParams.code, this.enquiry.orderFormVersion).then(function (response) {
	        _this13.enquiry.signatureStatus = _this13.enums.SIGNATURE_STATUS.Created;
	        _this13.enquiry.signatureState = "Awaiting Customer Signature";
	
	        _this13.growl.success('Signature Request sent successfully', { ttl: 5000 });
	      }).catch(function (err) {
	        _this13.growl.error('Error sending signature request', { ttl: 5000 });
	      }).finally(function () {
	        _this13.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'viewSignedOrderForm',
	    value: function viewSignedOrderForm() {}
	  }, {
	    key: 'loadWebLeadFollowUpData',
	    value: function loadWebLeadFollowUpData() {
	      var _this14 = this;
	
	      var deferred = this.$q.defer();
	
	      if (this.defaultTexts && this.webLeadFollowUpTemplate) {
	        deferred.resolve();
	        return deferred.promise;
	      }
	
	      this.adminService.listDefaultTexts(this.authService.authData.currentLocation.key).then(function (response) {
	        _this14.defaultTexts = (0, _lodash.without)(response.data['email'], '');
	
	        _this14.fileService.getWebLeadFollowUpEmailTemplate(_this14.authService.authData.currentLocation.key, _this14.enquiry.enquiryId, _this14.authService.authData.userId).then(function (response) {
	          _this14.webLeadFollowUpTemplate = response.data;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'showFollowUpEmail',
	    value: function showFollowUpEmail() {
	      if (!this.enquiry.contactHasEmail) {
	        this.$ngConfirm({
	          title: 'ERROR',
	          content: 'Cannot Send Follow up Email. Contact does not have an email set',
	          type: 'red',
	          typeAnimation: false,
	          columnClass: 'm',
	          buttons: {
	            tryAgain: {
	              text: 'Close',
	              btnClass: 'btn-danger'
	            }
	          }
	        });
	
	        return;
	      } else {
	        this.showFollowUpEmailNext('requestSignature');
	      }
	    }
	  }, {
	    key: 'showFollowUpEmailNext',
	    value: function showFollowUpEmailNext() {
	      var _this15 = this;
	
	      this.loadWebLeadFollowUpData().then(function () {
	        _this15.$scope.emailText = null;
	
	        _this15.$scope.selectedText = null;
	        _this15.$scope.template = _this15.$sce.trustAsHtml(_this15.webLeadFollowUpTemplate.replace('{{freeText}}', ''));
	        _this15.$scope.emailTexts = _this15.defaultTexts;
	        _this15.$scope.customLinks = [];
	        _this15.$scope.uploadUrl = _this15.appConfig.apiServiceBaseUri + ('api/file/upload/followupimage/' + _this15.enquiry.enquiryId);
	        _this15.$scope.imgUrl = _this15.appConfig.apiServiceBaseUri + ('api/file/get/followupimage/' + _this15.enquiry.enquiryId);
	        _this15.$scope.images = [];
	        _this15.$scope.imagesOverLimit = false;
	        _this15.$scope.onMediaUploadSuccess = _this15.onMediaUploadSuccess.bind(_this15);
	        _this15.$scope.onMediaUploadError = _this15.onMediaUploadError.bind(_this15);
	        _this15.$scope.removeFollowUpImage = _this15.removeFollowUpImage.bind(_this15);
	
	        _this15.$scope.selectEmailText = _this15.selectEmailText.bind(_this15);
	        _this15.$scope.updateText = _this15.updateText.bind(_this15);
	        _this15.$scope.addCustomLink = _this15.addCustomLink.bind(_this15);
	        _this15.$scope.removeLink = _this15.removeLink.bind(_this15);
	
	        _this15.$ngConfirm({
	          title: 'Follow Up Email',
	          contentUrl: 'templates/enquiry/webLeadFollowUpEmailTemplate',
	          typeAnimation: false,
	          columnClass: 'xl',
	          scope: _this15.$scope,
	          buttons: {
	            yes: {
	              text: 'Send Email',
	              btnClass: 'btn-primary',
	              action: function action() {
	                if (!_this15.updateText() || _this15.$scope.imagesOverLimit) {
	                  return false;
	                }
	
	                _this15.followUpEmail();
	              }
	            },
	            no: {
	              text: 'Leave it',
	              btnClass: 'btn-default',
	              action: function action() {
	                return _this15.removeFollowUpImage();
	              }
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'selectEmailText',
	    value: function selectEmailText(text) {
	      this.$scope.selectedText = text;
	      this.updateText();
	    }
	  }, {
	    key: 'updateText',
	    value: function updateText() {
	      var text = this.$scope.selectedText || '';
	      text = text.replaceAll('\n', '<br>');
	
	      if (!text) {
	        return '';
	      }
	
	      var allLinks = (0, _lodash.map)(this.$scope.customLinks, function (item) {
	        return '<a href="' + item.link + '" target=_blank>' + item.text + '</a>';
	      });
	      text += '<br /><br />' + (0, _lodash.join)(allLinks, '<br />');
	
	      var template = this.webLeadFollowUpTemplate.replace('{{freeText}}', text);
	      this.$scope.template = this.$sce.trustAsHtml(template);
	
	      return text;
	    }
	  }, {
	    key: 'addCustomLink',
	    value: function addCustomLink() {
	      if (!this.$scope.tempTextLink) {
	        alert('Please enter text for the link');
	        return;
	      }
	
	      if (!this.$scope.tempLink) {
	        alert('Please enter link value');
	        return;
	      }
	
	      this.$scope.customLinks.push({ text: this.$scope.tempTextLink, link: this.$scope.tempLink });
	      this.updateText();
	      this.$scope.tempTextLink = null;
	      this.$scope.tempLink = null;
	    }
	  }, {
	    key: 'removeLink',
	    value: function removeLink(link) {
	      this.$scope.customLinks = (0, _lodash.without)(this.$scope.customLinks, link);
	      this.updateText();
	    }
	  }, {
	    key: 'followUpEmail',
	    value: function followUpEmail() {
	      var _this16 = this;
	
	      var data = {
	        emailText: this.updateText(),
	        entityId: this.authService.authData.currentLocation.key,
	        enquiryId: this.enquiry.enquiryId,
	        userId: this.authService.authData.userId
	      };
	
	      this.enquiryService.sendWebLeadFollowUpEmail(data).then(function (response) {
	        _this16.enquiry.followUpWebLeadEmail = false;
	        _this16.growl.success('Follow up email sent successfully', { ttl: 5000 });
	      });
	    }
	  }, {
	    key: 'onMediaUploadSuccess',
	    value: function onMediaUploadSuccess(response) {
	      var _this17 = this;
	
	      this.$scope.imagesOverLimit = response.data.item1;
	      this.$scope.images = response.data.item2.map(function (imgUrl) {
	        return _this17.$scope.imgUrl + '/?fileName=' + imgUrl;
	      });
	    }
	  }, {
	    key: 'onMediaUploadError',
	    value: function onMediaUploadError(response) {
	      alert(response.data[0].value);
	    }
	  }, {
	    key: 'removeFollowUpImage',
	    value: function removeFollowUpImage(fileName) {
	      var _this18 = this;
	
	      this.fileService.removeFollowUpImage(this.enquiry.enquiryId, fileName).then(function (response) {
	        if (response.data.item2 !== null) {
	          _this18.$scope.imagesOverLimit = response.data.item1;
	          _this18.$scope.images = response.data.item2.map(function (imgUrl) {
	            return _this18.$scope.imgUrl + '/?fileName=' + imgUrl;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'noMakeModel',
	    value: function noMakeModel() {
	      if (this.enquiry && this.enquiry.criteria && this.enquiry.enquiryVehicles) {
	        return this.authService.authData.currentLocation.makeModelMandatory.enabled && this.enquiry.enquiryVehicles.length == 0 && !this.enquiry.criteria.brandModelId;
	      }
	    }
	  }, {
	    key: 'validateMakeAndModel',
	    value: function validateMakeAndModel() {
	      if (this.enquiry.enquiryVehicles.length == 0 && !this.enquiry.criteria.brandModelId) {
	        this.formValidationService.addModelError("Vehicles", "Please add a Vehicle to this enquiry or specify a search criteria with Make / Model first", false);
	
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	  return EnquiryEditController;
	}();
	
	exports.default = EnquiryEditController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>Data Protection Authorization</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"errUpdateDpa !== ''\">\r\n        {{errUpdateDpa}}\r\n      </div>\r\n\r\n      <div class=\"dpaReasons\">\r\n        <p class=\"bold\">Marketing Consent</p>\r\n        <p>\r\n          We have exciting offers and news about our products and services that we hope you’d like to hear about. Your opinion is important to us and we may contact you to ensure you are satisfied with our services. We will treat your data with respect and store it safely in accordance with the current data protection regulations. We may share your data with Franchise partners  and affiliated companies to improve your experience.\r\n          <br /><br />\r\n          Please visit our website  for further details on our data protection policy, including how you may access and correct your personal data or withdraw consent to the collection, use or disclosure of your personal data\r\n        </p>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-sm-offset-2 col-sm-10\">            \r\n            <input type=\"checkbox\" id=\"chkVerbal\" ng-model=\"dpa.verbalConsent\" ng-change=\"confirmVerbalConsent()\"/>\r\n            <label for=\"chkVerbal\">Verbal notification of Privacy Notice Given and Marketing Consent Received</label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-sm-offset-2 col-sm-10\">\r\n            <a href=\"#\" class=\"btn btn-sm btn-success\" ng-click=\"checkOptions(true)\">Select All</a>\r\n            <a href=\"#\" class=\"btn btn-sm btn-default\" ng-click=\"checkOptions(false)\">Deselect All</a>\r\n          </div>\r\n        </div>\r\n      </div>      \r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Via Email</label>\r\n          <div class=\"col-sm-10\">\r\n            <switch ng-model=\"dpa.viaEmail\"></switch>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Via Post</label>\r\n          <div class=\"col-sm-10\">\r\n            <label class=\"control-label\" for=\"yes2\">\r\n              <switch ng-model=\"dpa.viaPost\"></switch>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Via Text</label>\r\n          <div class=\"col-sm-10\">\r\n            <switch ng-model=\"dpa.viaText\"></switch>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <label class=\"control-label col-sm-2\">Via Phone</label>\r\n          <div class=\"col-sm-10\">\r\n            <switch ng-model=\"dpa.viaPhone\"></switch>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <label class=\"control-label col-sm-2\">\r\n          Signature\r\n\r\n          <button class=\"btn btn-sm btn-default\" ng-click=\"clearSignature()\">Clear</button>\r\n        </label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"signature-container\"></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"updateDpa()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"fa fa-times-circle\"></span> Save Changes\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>Data Protection Authorization</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"errUpdateDpa !== ''\">\r\n        {{errUpdateDpa}}\r\n      </div>\r\n\r\n      <div class=\"dpaReasons\">\r\n        <p class=\"bold\">Privacy Statement</p>\r\n        <p>\r\n            We have exciting offers and news about our products and services that we hope you’d like to hear about. Your opinion is important to us and we may contact you to ensure you are satisfied with our services. We will treat your data with respect and store it safely in accordance with the current data protection regulations. We may share your data with Franchise partners  and affiliated companies to improve your experience.\r\n            <br /><br />\r\n            Please visit our website  for further details on our data protection policy, including how you may access and correct your personal data or withdraw consent to the collection, use or disclosure of your personal data\r\n        </p>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-sm-offset-2 col-sm-10\">            \r\n            <input type=\"checkbox\" id=\"chkVerbal\" ng-model=\"dpa.verbalConsent\" ng-change=\"confirmVerbalConsent()\"/>\r\n            <label for=\"chkVerbal\">Verbal notification of Privacy Notice Given and Marketing Consent Received</label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      \r\n      <div class=\"row\">\r\n        <div class=\"form-group\">\r\n          <div class=\"col-sm-offset-2 col-sm-10\">\r\n            <a href=\"#\" class=\"btn btn-sm btn-success\" ng-click=\"checkOptions(true)\">Select All</a>\r\n            <a href=\"#\" class=\"btn btn-sm btn-default\" ng-click=\"checkOptions(false)\">Deselect All</a>\r\n          </div>\r\n        </div>\r\n      </div>          \r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <table class=\"table table-bordered table-hover table-striped\">\r\n              <thead>\r\n                  <tr>\r\n                    <th class=\"col-md-4\">Reason</th>\r\n                    <th class=\"col-md-2\">Via Email</th>\r\n                    <th class=\"col-md-2\">Via Post</th>\r\n                    <th class=\"col-md-2\">Via Text</th>\r\n                    <th class=\"col-md-2\">Via Phone</th>\r\n                  </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr>\r\n                  <td class=\"col-md-4\">Marketing - New Products, Services and Events</td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.marketing_Email\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.marketing_Post\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.marketing_Text\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.marketing_Phone\"></switch></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td class=\"col-md-4\">Service -  Vehicle All service related contact - service reminders  on known vehicles</td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.service_Email\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.service_Post\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.service_Text\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.service_Phone\"></switch></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td class=\"col-md-4\">Manufacturer based  contacts - as per manufactures</td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.manufacturer_Email\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.manufacturer_Post\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.manufacturer_Text\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.manufacturer_Phone\"></switch></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td class=\"col-md-4\">Surveys - Sales and Aftersales based customer surveys</td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.surveys_Email\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.surveys_Post\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.surveys_Text\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.surveys_Phone\"></switch></td>\r\n                </tr>\r\n\r\n                <tr>\r\n                  <td class=\"col-md-4\">Change Cycle</td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.changeCycle_Email\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.changeCycle_Post\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.changeCycle_Text\"></switch></td>\r\n                  <td class=\"col-md-2\"><switch ng-model=\"dpa.changeCycle_Phone\"></switch></td>\r\n                </tr>\r\n\r\n              </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <label class=\"control-label col-sm-2\">\r\n          Signature\r\n\r\n          <button class=\"btn btn-sm btn-default\" ng-click=\"clearSignature()\">Clear</button>\r\n        </label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"signature-container\"></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"updateDpa()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"fa fa-times-circle\"></span> Save Changes\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1340);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryEdit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".signature-container{border:1px solid #000;width:550px;height:180px}.dpaReasons{border:1px solid #000;padding-top:10px;padding-left:10px;margin-bottom:20px}.dpaReasons .bold{color:red;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryBasicDetails = __webpack_require__(1342);
	
	var _enquiryBasicDetails2 = _interopRequireDefault(_enquiryBasicDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryBasicDetailsModule = _angular2.default.module('enquiryBasicDetails', [_angularUiRouter2.default]).component('enquiryBasicDetails', _enquiryBasicDetails2.default).name;
	
	exports.default = enquiryBasicDetailsModule;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryBasicDetails = __webpack_require__(1343);
	
	var _enquiryBasicDetails2 = _interopRequireDefault(_enquiryBasicDetails);
	
	var _enquiryBasicDetails3 = __webpack_require__(1344);
	
	var _enquiryBasicDetails4 = _interopRequireDefault(_enquiryBasicDetails3);
	
	__webpack_require__(1345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryBasicDetailsComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '=',
	    formValidationService: '<'
	  },
	  template: _enquiryBasicDetails2.default,
	  controller: _enquiryBasicDetails4.default
	};
	
	exports.default = enquiryBasicDetailsComponent;

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-group\">\r\n  <label class=\"control-label col-sm-2\">Contact</label>\r\n  <div class=\"col-sm-10\">\r\n    <label class=\"control-label\">\r\n      <a class=\"btn btn-link\" ng-click=\"$ctrl.editContact()\">\r\n        {{$ctrl.enquiry.contactName}}\r\n      </a>\r\n    </label>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\">\r\n  <label class=\"control-label col-sm-2\">Subject</label>\r\n  <div class=\"col-sm-10\">\r\n    <input class=\"form-control\" ng-model=\"$ctrl.enquiry.subject\" placeholder=\"Enter subject here\" maxLength=250>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.amountToSpend }\">\r\n  <label class=\"control-label col-sm-2\">Amount To Spend</label>\r\n  <div class=\"col-sm-10\">\r\n    <input class=\"form-control\" ng-model=\"$ctrl.enquiry.amountToSpend\" placeholder=\"Enter Amount to Spend here\">\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\" ng-class=\"{ 'has-error': !$ctrl.formValidationService.validations.enquiryOrigination }\">\r\n  <label class=\"control-label col-sm-2\">Enquiry Origination</label>\r\n  <div class=\"col-sm-10\">\r\n    <select\r\n      class=\"form-control\"\r\n      ng-change=\"$ctrl.updateModelFromSelect('enquiryOrigination')\"\r\n      ng-options=\"item.name for item in $ctrl.selectOptions.enquiryOrigination track by item.id\"\r\n      ng-model=\"$ctrl.selectDefaults.enquiryOrigination\">\r\n    </select>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\">\r\n  <label class=\"control-label col-sm-2\">Trade / Retail</label>\r\n  <div class=\"col-sm-10\">\r\n    <select\r\n      class=\"form-control\"\r\n      ng-change=\"$ctrl.updateModelFromSelect('enquiryContact')\"\r\n      ng-options=\"item.name for item in $ctrl.selectOptions.enquiryContact track by item.id\"\r\n      ng-model=\"$ctrl.selectDefaults.enquiryContact\">\r\n    </select>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\">\r\n  <label class=\"control-label col-sm-2\">Enquiry Source</label>\r\n  <div class=\"col-sm-10\">\r\n    <select\r\n      class=\"form-control\"\r\n      ng-options=\"item.enquirySourceId as item.name for item in $ctrl.enquirySources\"\r\n      ng-model=\"$ctrl.enquiry.enquirySourceId\">\r\n    </select>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\" ng-show=\"$ctrl.authService.isManager()\">\r\n  <label class=\"control-label col-sm-2\">Owner</label>\r\n  <div class=\"col-sm-10\">\r\n    <div angucomplete-alt\r\n      id=\"searchUsers\"\r\n      placeholder=\"Search Users by Email, First Name or Last Name\"\r\n      pause=\"400\"\r\n      selected-object=\"$ctrl.ownerSelected\"\r\n      remote-url=\"{{$ctrl.searchUsersUrl}}\"\r\n      title-field=\"firstName,lastName\"\r\n      minlength=\"2\"\r\n      input-class=\"form-control form-control-small\"\r\n      initial-value = \"$ctrl.initialOwnerName\"\r\n      match-class=\"autocomplete-highlight\">\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"form-group\" ng-hide=\"$ctrl.authService.isManager()\">\r\n  <label class=\"control-label col-sm-2\">Owner</label>\r\n  <label class=\"control-label take-left col-sm-10\">{{$ctrl.initialOwnerName}}</label>\r\n</div>\r\n"

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryBasicDetailsController = function () {
	  EnquiryBasicDetailsController.$inject = ["authService", "appConfig", "enums", "$scope", "$state", "enquirySourcesManagementService"];
	  function EnquiryBasicDetailsController(authService, appConfig, enums, $scope, $state, enquirySourcesManagementService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryBasicDetailsController);
	    this.enums = enums;
	    this.authService = authService;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.enquirySourcesManagementService = enquirySourcesManagementService;
	
	    this.enquirySources = [];
	
	    this.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';
	
	    this.enumList = [{ enumName: 'ENQUIRY_ORIGINATION', propName: 'enquiryOrigination', defaultOption: true }, { enumName: 'ENQUIRY_CONTACT', propName: 'enquiryContact', defaultOption: true }];
	
	    this.ownerSelected = this.ownerSelected.bind(this);
	
	    $scope.$on('enquiry:initialized', this.setInitialState.bind(this));
	
	    this.setInitialState();
	
	    this.personTitles = this.convertEnumToKeyValueList(enums.PERSON_TITLE);
	  }
	
	  (0, _createClass3.default)(EnquiryBasicDetailsController, [{
	    key: 'setInitialState',
	    value: function setInitialState() {
	      /*
	      * This method will be called First when initialize this component
	      * Second when its recieved an event enquiry:initialized
	      * which will signal that enquiry is in edit mode
	      */
	
	      var ctrl = this;
	
	      ctrl.selectOptions = {};
	      ctrl.selectDefaults = {};
	
	      ctrl.initializeEnums();
	      ctrl.initializeEnquirySources();
	
	      if (!ctrl.enquiry.enquiryId) {
	        /*
	        * We need to check if the enquiry already has an OwnerId.
	        * This means that this is not the first time this screen is loaded
	        * We are redirected back to this screen after creating a contact,
	        * Adding a vehicle / price book vehicle or any other external screen
	        */
	        if (!ctrl.enquiry.ownerId) {
	          ctrl.enquiry.ownerId = ctrl.authService.authData.userId, ctrl.enquiry.ownerName = ctrl.authService.authData.firstName + ' ' + ctrl.authService.authData.lastName;
	        }
	
	        ctrl.initialOwnerName = ctrl.enquiry.ownerName;
	      } else {
	        ctrl.initialOwnerName = ctrl.enquiry.ownerName;
	
	        //Dirty hack ! but no choice, should not be setting it directly using jQuery
	        $('#searchUsers input').val(ctrl.enquiry.ownerName);
	
	        ctrl.enumList.map(function (item) {
	          var selectedOption = (0, _lodash.find)(ctrl.selectOptions[item.propName], function (o) {
	            return o.id === ctrl.enquiry[item.propName];
	          });
	
	          ctrl.selectDefaults[item.propName] = selectedOption;
	        });
	      }
	
	      ctrl.configureForm();
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.addField({
	        fieldName: 'subject',
	        displayName: 'Subject',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'amountToSpend',
	        displayName: 'Amount To Spend',
	        type: 'int',
	        allowedDecimals: 2
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'enquiryOrigination',
	        displayName: 'Enquiry Origination',
	        required: true,
	        type: 'select'
	      });
	    }
	  }, {
	    key: 'ownerSelected',
	    value: function ownerSelected(item) {
	      if (item) {
	        this.enquiry.ownerId = item.originalObject.userId;
	        this.enquiry.ownerName = item.originalObject.firstName + ' ' + item.originalObject.lastName;
	      }
	    }
	  }, {
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	
	      ctrl.enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
	        ctrl.updateModelFromSelect(item.propName);
	      });
	    }
	  }, {
	    key: 'getDefaultOption',
	    value: function getDefaultOption(enumsArray, propName) {
	      var propVal = void 0;
	
	      try {
	        propVal = eval('this.enquiry.' + propName);
	      } catch (e) {}
	
	      if (propVal) {
	        return (0, _lodash.find)(enumsArray, function (o) {
	          return o.id === propVal;
	        });
	      } else {
	        return enumsArray[0];
	      }
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      var val = this.selectDefaults[selectDefaultProperty][idProperty];
	
	      try {
	        eval('this.enquiry.' + modelProperty + ' = ' + val);
	      } catch (e) {}
	    }
	  }, {
	    key: 'initializeEnquirySources',
	    value: function initializeEnquirySources() {
	      var ctrl = this;
	
	      ctrl.enquirySourcesManagementService.list(ctrl.authService.authData.currentLocation.key, true).then(function (response) {
	        ctrl.enquirySources = response.data;
	        ctrl.enquirySources.unshift({ enquirySourceId: null, name: 'Please Select' });
	      });
	    }
	  }, {
	    key: 'editContact',
	    value: function editContact() {
	      var origin = {
	        source: 'enquiry',
	        processResult: this.getReturnParams.bind(this)
	      };
	
	      this.$state.go('contactEdit', { contactId: this.enquiry.contactId, origin: origin });
	    }
	  }, {
	    key: 'getReturnParams',
	    value: function getReturnParams(newContactId, contact) {
	      return {
	        stateName: 'enquiryEdit',
	        params: { enquiryId: this.enquiry.enquiryId, activeTab: 'basicDetails' }
	      };
	    }
	  }]);
	  return EnquiryBasicDetailsController;
	}();
	
	exports.default = EnquiryBasicDetailsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1346);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryBasicDetails.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryBasicDetails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryBasicDetails{color:red}", ""]);
	
	// exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryVehicles = __webpack_require__(1348);
	
	var _enquiryVehicles2 = _interopRequireDefault(_enquiryVehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryVehiclesModule = _angular2.default.module('enquiryVehicles', [_angularUiRouter2.default]).component('enquiryVehicles', _enquiryVehicles2.default).name;
	
	exports.default = enquiryVehiclesModule;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryVehicles = __webpack_require__(1349);
	
	var _enquiryVehicles2 = _interopRequireDefault(_enquiryVehicles);
	
	var _enquiryVehicles3 = __webpack_require__(1350);
	
	var _enquiryVehicles4 = _interopRequireDefault(_enquiryVehicles3);
	
	__webpack_require__(1351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryVehiclesComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '=',
	    onVehicleSelected: '&',
	    formValidationService: '='
	  },
	  template: _enquiryVehicles2.default,
	  controller: _enquiryVehicles4.default
	};
	
	exports.default = enquiryVehiclesComponent;

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"btn-group\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n    <a type=\"button\" class=\"btn btn-primary\" ng-if=\"$ctrl.enquiry.isOpen\" ng-click=\"$ctrl.selectVehicle()\">\r\n      Add Vehicle To Enquiry\r\n    </a>\r\n  </div>\r\n</div>\r\n\r\n<div>\r\n<div>\r\n  <table class=\"table table-bordered table-hover table-striped\">\r\n      <thead>\r\n          <tr>\r\n            <th ng-if=\"!$ctrl.enquiry.isMultiSelect\">&nbsp;</th>\r\n            <th>Reg</th>\r\n            <th>Model</th>\r\n            <th>Variant</th>\r\n            <th>Price</th>\r\n            <th>Body Type</th>\r\n            <th>Color</th>\r\n            <th>&nbsp;</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr data-ng-repeat=\"v in $ctrl.enquiry.enquiryVehicles | filter:{ isRemoved: false }\">\r\n              <td ng-if=\"!$ctrl.enquiry.isMultiSelect\">\r\n                <input type=\"radio\" name=\"selectedVehicle\"  ng-model=\"v.isSelected\" ng-value=\"true\" ng-change=\"$ctrl.vehicleSelected(v.vehicleId)\"/>\r\n              </td>           \r\n              <td>{{v.vehicle.registration}}</td>\r\n              <td>\r\n                <a href=\"#\" ng-click=\"$ctrl.gotoVehicle(v)\">\r\n                  {{v.vehicle.model}}\r\n                </a>\r\n              </td>\r\n              <td>{{v.vehicle.variant}}</td>\r\n              <td>{{(v.vehicle.price | currency:'&euro;':2)}}</td>\r\n              <td>{{v.vehicle.bodyType}}</td>\r\n              <td>{{v.vehicle.color}}</td>\r\n              <td ng-hide=\"!$ctrl.enquiry.isMultiSelect && v.isSelected\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-if=\"$ctrl.enquiry.isOpen\" ng-click=\"$ctrl.removeEnquiryVehicleConfirm(v)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n          </tr>\r\n\r\n          <tr ng-show=\"$ctrl.enquiry.isMultiSelect\">\r\n            <td colspan=\"3\">&nbsp;</td>\r\n            <td>Total</td>\r\n            <td colspan=\"3\">{{$ctrl.total | currency:'&euro;':2}}</td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryVehiclesController = function () {
	  EnquiryVehiclesController.$inject = ["authService", "enums", "$state", "printService", "$ngConfirm", "$scope"];
	  function EnquiryVehiclesController(authService, enums, $state, printService, $ngConfirm, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryVehiclesController);
	    this.authService = authService;
	    this.enums = enums;
	    this.$state = $state;
	    this.printService = printService;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	
	    this.total = 0;
	
	    this.$scope.$on('enquiry:initialized', this.getTotal.bind(this));
	  }
	
	  (0, _createClass3.default)(EnquiryVehiclesController, [{
	    key: 'vehicleSelected',
	    value: function vehicleSelected(vehicleId) {
	      var enquiryVehicles = void 0;
	
	      enquiryVehicles = (0, _lodash.filter)(this.enquiry.enquiryVehicles, function (o) {
	        return o.vehicleId !== vehicleId;
	      });
	
	      enquiryVehicles.map(function (ev) {
	        ev.isSelected = false;
	      });
	
	      this.onVehicleSelected();
	    }
	  }, {
	    key: 'quotation',
	    value: function quotation() {
	      if (this.enquiry.enquiryVehicles.length) {
	        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	          return o.isSelected;
	        }).vehicle;
	
	        if (!vehicle.price || vehicle.price === 0) {
	          this.$ngConfirm({
	            title: 'ERROR',
	            content: 'Selected vehicle does not have a retail price',
	            type: 'red',
	            typeAnimation: false,
	            columnClass: 'm',
	            buttons: {
	              tryAgain: {
	                text: 'Close',
	                btnClass: 'btn-danger'
	              }
	            }
	          });
	        } else {
	          this.printService.printQuotation(this.enquiry.enquiryId);
	        }
	      }
	    }
	  }, {
	    key: 'gotoVehicle',
	    value: function gotoVehicle(v) {
	      this.editVehicle = v;
	      this.$state.go('vehicleEdit', {
	        vehicleId: v.vehicle.vehicleId,
	        origin: {
	          source: 'enquiryEdit',
	          processResult: this.getReturnParams.bind(this)
	        }
	      });
	    }
	  }, {
	    key: 'getReturnParams',
	    value: function getReturnParams(vehicleId, vehicle) {
	      var ctrl = this;
	      var stateName = 'enquiryEdit';
	
	      this.editVehicle.vehicle.price = vehicle.price;
	
	      /*
	      * #1310
	      * Update entityid of vehicle, if a vehicle was attached
	      * in case, the location of the vehicle was changed
	      */
	      var ev = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	      if (ev) {
	        ev.vehicle.entityId = vehicle.entityId;
	      }
	
	      var params = {
	        activeTab: 'vehicles',
	        enquiryId: ctrl.enquiry.enquiryId,
	        enquiry: ctrl.enquiry
	      };
	
	      var vehiclePrice = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
	        return o.name === 'Vehicle Price';
	      });
	      if (vehiclePrice) {
	        vehiclePrice.amount = vehicle.price;
	      }
	
	      return {
	        stateName: stateName,
	        params: params
	      };
	    }
	  }, {
	    key: 'selectVehicle',
	    value: function selectVehicle() {
	      if (!this.enquiry.enquiryOrigination) {
	        this.formValidationService.addSystemError(null, 'Please specify Enquiry Origination first', false);
	        return;
	      }
	
	      this.$state.go('vehicleEnquiryView', { source: 'enquiry', enquiry: this.enquiry });
	    }
	  }, {
	    key: 'removeEnquiryVehicleConfirm',
	    value: function removeEnquiryVehicleConfirm(v) {
	      var _this = this;
	
	      this.$ngConfirm({
	        title: 'Remove Vehicle',
	        content: 'Are you sure youn want to remove this vehicle ?',
	        type: 'red',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-danger',
	            action: function action() {
	              return _this.removeEnquiryVehicle(v);
	            }
	          },
	          no: {
	            text: 'no',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeEnquiryVehicle',
	    value: function removeEnquiryVehicle(vehicle) {
	      if (this.enquiry.isMultiSelect) {
	        this.enquiry.enquiryVehicles = (0, _lodash.without)(this.enquiry.enquiryVehicles, vehicle);
	      } else {
	        vehicle.isRemoved = true;
	      }
	
	      this.getTotal();
	      this.$scope.$apply();
	    }
	  }, {
	    key: 'getTotal',
	    value: function getTotal() {
	      this.total = (0, _lodash.sum)(this.enquiry.enquiryVehicles.map(function (ev) {
	        return ev.vehicle.price || 0;
	      }));
	    }
	  }]);
	  return EnquiryVehiclesController;
	}();
	
	exports.default = EnquiryVehiclesController;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1352);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryVehicles.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryVehicles.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".horizontalScroll{width:1040px;overflow-x:auto;white-space:nowrap}", ""]);
	
	// exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryTestDrives = __webpack_require__(1354);
	
	var _enquiryTestDrives2 = _interopRequireDefault(_enquiryTestDrives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTestDrivesModule = _angular2.default.module('enquiryTestDrives', [_angularUiRouter2.default]).component('enquiryTestDrives', _enquiryTestDrives2.default).name;
	
	exports.default = enquiryTestDrivesModule;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryTestDrives = __webpack_require__(1355);
	
	var _enquiryTestDrives2 = _interopRequireDefault(_enquiryTestDrives);
	
	var _enquiryTestDrives3 = __webpack_require__(1356);
	
	var _enquiryTestDrives4 = _interopRequireDefault(_enquiryTestDrives3);
	
	__webpack_require__(1358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTestDrivesComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '='
	  },
	  template: _enquiryTestDrives2.default,
	  controller: _enquiryTestDrives4.default
	};
	
	exports.default = enquiryTestDrivesComponent;

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"testDrives\">\r\n  <header>\r\n    <h2>Test Drives</h2>\r\n    <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editTestDrive()\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n        <span class=\"glyphicon glyphicon-plus\"></span>\r\n        Add Test Drive\r\n    </a>\r\n  </header>\r\n\r\n  <table class=\"table table-hover\" ng-show=\"$ctrl.enquiry.testDrives.length\">\r\n      <thead>\r\n          <tr>\r\n              <th class=\"col-md-3\">Model</th>\r\n              <th class=\"col-md-2\">TimeStamp</th>\r\n              <th class=\"col-md-4\">Comments</th>\r\n              <th class=\"col-md-1\">Status</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr ng-repeat=\"td in $ctrl.enquiry.testDrives\">\r\n            <td class=\"col-md-3\">{{td.model}}</td>\r\n            <td class=\"col-md-2\">{{td.timeStamp | date : 'dd-MMMM-yyyy'}}</td>\r\n            <td class=\"col-md-4\">{{td.comments}}</td>\r\n            <td class=\"col-md-1\">{{td.isConfirmed ? 'Confirmed' : 'Unconfirmed'}}</td>\r\n              <td class=\"col-md-1\">\r\n                  <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.editTestDrive(td)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n              </td>\r\n              <td class=\"col-md-1\">\r\n                  <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeTestDrive(td)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n  <p ng-show=\"!$ctrl.enquiry.testDrives.length\">No Test Drives recorded</p>\r\n</div>\r\n"

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _editTestDriveModal = __webpack_require__(1357);
	
	var _editTestDriveModal2 = _interopRequireDefault(_editTestDriveModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryTestDrivesController = function () {
	  EnquiryTestDrivesController.$inject = ["$uibModal", "$scope", "vehicleService", "authService", "loadingService", "$q"];
	  function EnquiryTestDrivesController($uibModal, $scope, vehicleService, authService, loadingService, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryTestDrivesController);
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.vehicleService = vehicleService;
	    this.authService = authService;
	    this.loadingService = loadingService;
	    this.$q = $q;
	
	    this.vehicleList = [];
	  }
	
	  (0, _createClass3.default)(EnquiryTestDrivesController, [{
	    key: 'initializeVehicleList',
	    value: function initializeVehicleList() {
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      if (ctrl.vehicleList.length) {
	        deferred.resolve();
	        return deferred.promise;
	      }
	
	      ctrl.loadingService.showLoading('testDrives', 'Loading Vehicles');
	
	      ctrl.vehicleService.locationVehicles(ctrl.authService.authData.currentLocation.key, 'vehicle', ctrl.enquiry.enquiryId).then(function (response) {
	        if (response.data.items.length) {
	          var itemsArray = response.data.items;
	          itemsArray.unshift({
	            vehicleId: null,
	            model: '--- Please Select ---'
	          });
	          ctrl.vehicleList = itemsArray;
	        }
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('testDrives');
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'editTestDrive',
	    value: function editTestDrive(testDrive) {
	      var _this = this;
	
	      this.errMsg = '';
	      this.saveButtonTitle = 'Add';
	
	      if (testDrive) {
	        this.tempTestDrive = testDrive;
	        this.tempTestDrive.editMode = true;
	        this.tempVehicle = (0, _lodash.find)(this.vehicleList, function (o) {
	          return o.vehicleId === _this.tempTestDrive.vehicleId;
	        });
	        this.saveButtonTitle = 'Update';
	
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _editTestDriveModal2.default,
	          scope: this.$scope
	        });
	      } else {
	        this.initializeVehicleList().then(function () {
	          _this.tempVehicle = _this.vehicleList[0];
	          _this.tempTestDrive = {
	            isConfirmed: true
	          };
	
	          _this.$uibModalInstance = _this.$uibModal.open({
	            template: _editTestDriveModal2.default,
	            scope: _this.$scope
	          });
	        });
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'vehicleSelected',
	    value: function vehicleSelected() {
	      this.tempTestDrive.vehicleId = this.tempVehicle.vehicleId;
	      this.tempTestDrive.model = this.tempVehicle.model;
	    }
	  }, {
	    key: 'addTestDrive',
	    value: function addTestDrive() {
	      if (!this.tempTestDrive.vehicleId) {
	        this.errMsg = 'Please select a Vehicle First';
	        return;
	      }
	
	      if (!this.tempTestDrive.timeStamp) {
	        this.errMsg = 'Please select a Date First';
	        return;
	      }
	
	      if (!this.tempTestDrive.editMode) {
	        this.enquiry.testDrives.push(this.tempTestDrive);
	      } else {
	        this.tempTestDrive.editMode = false;
	      }
	
	      this.closeModal();
	    }
	  }, {
	    key: 'removeTestDrive',
	    value: function removeTestDrive(testDrive) {
	      this.enquiry.testDrives = (0, _lodash.without)(this.enquiry.testDrives, testDrive);
	    }
	  }]);
	  return EnquiryTestDrivesController;
	}();
	
	exports.default = EnquiryTestDrivesController;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Test Drive</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\" ng-show=\"!$ctrl.tempTestDrive.editMode\">\r\n          <div class=\"col-md-3\">\r\n            <label>Vehicle *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-change=\"$ctrl.vehicleSelected()\"\r\n              ng-options=\"vehicle as vehicle.brand + ' ' + vehicle.model for vehicle in $ctrl.vehicleList\"\r\n              ng-model=\"$ctrl.tempVehicle\">\r\n            </select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\" ng-show=\"$ctrl.tempTestDrive.editMode\">\r\n        <div class=\"col-md-3\">\r\n          <label>Vehicle *</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <label>{{$ctrl.tempTestDrive.model}}</label>\r\n        </div>\r\n    </div>      \r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Date *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.timeStamp = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.tempTestDrive.timeStamp\" is-open=\"$ctrl.timeStamp\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.timeStamp = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Is Confirmed</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                  <input type=\"checkbox\" data-toggle=\"toggle\" ng-model=\"$ctrl.tempTestDrive.isConfirmed\" />\r\n              </label>\r\n            </div>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Comments</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea\r\n              maxlength=\"250\"\r\n              class=\"form-control\"\r\n              placeholder=\"Comments\"\r\n              ng-model=\"$ctrl.tempTestDrive.comments\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addTestDrive()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> {{$ctrl.saveButtonTitle}}\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1359);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTestDrives.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTestDrives.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryTestDrives{color:red}", ""]);
	
	// exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryTradeIns = __webpack_require__(1361);
	
	var _enquiryTradeIns2 = _interopRequireDefault(_enquiryTradeIns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTradeInsModule = _angular2.default.module('enquiryTradeIns', [_angularUiRouter2.default]).component('enquiryTradeIns', _enquiryTradeIns2.default).name;
	
	exports.default = enquiryTradeInsModule;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryTradeIns = __webpack_require__(1362);
	
	var _enquiryTradeIns2 = _interopRequireDefault(_enquiryTradeIns);
	
	var _enquiryTradeIns3 = __webpack_require__(1363);
	
	var _enquiryTradeIns4 = _interopRequireDefault(_enquiryTradeIns3);
	
	__webpack_require__(1364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTradeInsComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '=',
	    onTradeIn: '&',
	    onRemoveTradeIn: '&',
	    formValidationService: '<'
	  },
	  template: _enquiryTradeIns2.default,
	  controller: _enquiryTradeIns4.default
	};
	
	exports.default = enquiryTradeInsComponent;

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"tradeIns\">\r\n  <header>\r\n    <h2>Vehicle Trade Ins</h2>\r\n    <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.addTradeInVehicle()\" ng-hide=\"$ctrl.enquiry.readonly || $ctrl.enquiry.tradeInVehicles.length\">\r\n        <span class=\"glyphicon glyphicon-plus\"></span>\r\n        Add Vehicle for Trade In\r\n    </a>\r\n    <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.existingTradeIn()\" ng-hide=\"$ctrl.enquiry.readonly || $ctrl.enquiry.tradeInVehicles.length\">\r\n      <span class=\"glyphicon glyphicon-plus\"></span>\r\n      Add Trade In Vehicle From an Existing Enquiry\r\n    </a>    \r\n  </header>\r\n\r\n  <table class=\"table table-hover\" ng-show=\"$ctrl.enquiry.tradeInVehicles.length\">\r\n      <thead>\r\n          <tr>\r\n              <th class=\"col-md-2\">Registration</th>\r\n              <th class=\"col-md-2\">Make & Model</th>\r\n              <th class=\"col-md-3\">Variant</th>\r\n              <th class=\"col-md-2\">Allowance</th>\r\n              <th class=\"col-md-2\">Over Allowance</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr ng-repeat=\"v in $ctrl.enquiry.tradeInVehicles\">\r\n            <td class=\"col-md-2\">\r\n              <a href=\"#\" ng-click=\"$ctrl.editTradeInVehicle(v.vehicleId)\">\r\n                {{v.vehicle.registration}}\r\n              </a>\r\n            </td>\r\n            <td class=\"col-md-3\">\r\n              <a href=\"#\" ng-click=\"$ctrl.gotoVehicle(v)\">\r\n                {{v.vehicle.model}}\r\n              </a>\r\n            </td>\r\n            <td class=\"col-md-4\">{{v.vehicle.variant + ' ' + v.vehicle.variantCode}}</td>\r\n            <td class=\"col-md-2\">{{v.allowance}}</td>\r\n            <td class=\"col-md-2\">{{v.overAllowance}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.onRemoveTradeIn()\" ng-hide=\"$ctrl.enquiry.readonly\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n              </td>            \r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n  <p ng-show=\"!$ctrl.enquiry.tradeInVehicles.length\">No Vehicles Traded In</p>\r\n</div>\r\n"

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryTradeInsController = function () {
	  EnquiryTradeInsController.$inject = ["$state", "lookupService", "enums", "loadingService", "enquiryService", "$scope"];
	  function EnquiryTradeInsController($state, lookupService, enums, loadingService, enquiryService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryTradeInsController);
	    this.$state = $state;
	    this.lookupService = lookupService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.enquiryService = enquiryService;
	    this.$scope = $scope;
	
	    this.lookupBrands();
	    this.lookupBrandModels();
	
	    this.getReturnParams = this.getReturnParams.bind(this);
	    this.getReturnParamsEdit = this.getReturnParamsEdit.bind(this);
	  }
	
	  (0, _createClass3.default)(EnquiryTradeInsController, [{
	    key: 'lookupBrands',
	    value: function lookupBrands() {
	      var ctrl = this;
	      this.lookupService.lookupBrands().then(function (brands) {
	        ctrl.brands = brands;
	      });
	    }
	  }, {
	    key: 'lookupBrandModels',
	    value: function lookupBrandModels() {
	      var ctrl = this;
	      this.lookupService.lookupBrandModels().then(function (brandModels) {
	        ctrl.brandModels = brandModels;
	      });
	    }
	  }, {
	    key: 'addTradeInVehicle',
	    value: function addTradeInVehicle() {
	      var _this = this;
	
	      var epSettlement = (0, _lodash.find)(this.enquiry.enquiryPrices, function (o) {
	        return o.groupType === _this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
	      });
	      var settlement = null;
	
	      if (epSettlement) {
	        settlement = epSettlement.amount;
	      }
	
	      var origin = {
	        source: 'enquiry',
	        processResult: this.getReturnParams
	      };
	
	      this.$state.go('vehicleTradeIn', { origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement });
	    }
	  }, {
	    key: 'editTradeInVehicle',
	    value: function editTradeInVehicle(vehicleId) {
	      var _this2 = this;
	
	      var epSettlement = (0, _lodash.find)(this.enquiry.enquiryPrices, function (o) {
	        return o.groupType === _this2.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement' && !o.removed;
	      });
	      var settlement = null;
	
	      if (epSettlement) {
	        settlement = epSettlement.amount;
	      }
	
	      var origin = {
	        source: 'enquiry',
	        processResult: this.getReturnParamsEdit
	      };
	
	      this.$state.go('editAppraisal', { vehicleId: vehicleId, origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement });
	    }
	  }, {
	    key: 'getReturnParams',
	    value: function getReturnParams(vehicleId, vehicleAppraisal, settlement) {
	      var ctrl = this;
	      var stateName = void 0;
	
	      var params = {
	        activeTab: 'tradeIns'
	      };
	
	      if (vehicleId) {
	        ctrl.enquiry.tradeInVehicles.push({
	          vehicleId: vehicleId,
	          vehicle: vehicleAppraisal.vehicle,
	          allowance: vehicleAppraisal.allowance,
	          overAllowance: vehicleAppraisal.overAllowance || 0
	        });
	      }
	
	      params.enquiry = ctrl.enquiry;
	
	      var tradeInAll = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
	        return o.name === 'Trade In Allowance(s)';
	      });
	      if (tradeInAll) {
	        tradeInAll.amount = vehicleAppraisal.allowance;
	      } else {
	        params.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
	          name: 'Trade In Allowance(s)',
	          amount: vehicleAppraisal.allowance,
	          removed: false
	        });
	      }
	
	      var epSettlement = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
	        return o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
	      });
	
	      if (epSettlement) {
	        epSettlement.removed = false;
	        epSettlement.amount = settlement;
	      } else {
	        params.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
	          name: 'Settlement',
	          amount: settlement,
	          removed: false
	        });
	      }
	
	      if (ctrl.enquiry.enquiryId) {
	        stateName = 'enquiryEdit';
	        params.enquiryId = ctrl.enquiry.enquiryId;
	      } else {
	        stateName = 'enquiryAdd';
	      }
	
	      return {
	        stateName: stateName,
	        params: params
	      };
	    }
	  }, {
	    key: 'getReturnParamsEdit',
	    value: function getReturnParamsEdit(vehicleId, vehicleAppraisal, settlement) {
	      var ctrl = this;
	      var stateName = void 0;
	
	      var params = {
	        activeTab: 'tradeIns'
	      };
	
	      if (vehicleId) {
	        var tradeInVehicle = (0, _lodash.find)(ctrl.enquiry.tradeInVehicles, function (o) {
	          return o.vehicleId === vehicleId;
	        });
	
	        tradeInVehicle.allowance = vehicleAppraisal.allowance;
	        tradeInVehicle.overAllowance = vehicleAppraisal.overAllowance || 0;
	      }
	
	      params.enquiry = ctrl.enquiry;
	
	      var tradeInAll = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
	        return o.name === 'Trade In Allowance(s)';
	      });
	      if (tradeInAll) {
	        tradeInAll.amount = vehicleAppraisal.allowance;
	      } else {
	        params.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
	          name: 'Trade In Allowance(s)',
	          amount: vehicleAppraisal.allowance,
	          removed: false
	        });
	      }
	
	      var epSettlement = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
	        return o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement';
	      });
	      if (epSettlement) {
	        epSettlement.amount = settlement;
	        if (settlement) {
	          epSettlement.removed = false;
	        }
	      } else {
	        params.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
	          name: 'Settlement',
	          amount: settlement,
	          removed: false
	        });
	      }
	
	      if (ctrl.enquiry.enquiryId) {
	        stateName = 'enquiryEdit';
	        params.enquiryId = ctrl.enquiry.enquiryId;
	      } else {
	        stateName = 'enquiryAdd';
	      }
	
	      return {
	        stateName: stateName,
	        params: params
	      };
	    }
	  }, {
	    key: 'gotoVehicle',
	    value: function gotoVehicle(v) {
	      this.$state.go('vehicleEdit', {
	        vehicleId: v.vehicle.vehicleId,
	        origin: {
	          source: 'enquiry',
	          enquiryId: this.enquiry.enquiryId
	        }
	      });
	    }
	  }, {
	    key: 'existingTradeIn',
	    value: function existingTradeIn() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('tradeIns', 'Adding Trade In ...');
	
	      ctrl.enquiryService.addExistingTradeIn(ctrl.enquiry.enquiryId).then(function (response) {
	        //Push Trade In
	        ctrl.enquiry.tradeInVehicles.push(response.data);
	
	        //Push price
	        var tradeInAllowance = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	          return o.name === 'Trade In Allowance(s)';
	        });
	        tradeInAllowance.amount = response.data.allowance;
	
	        //Update Calc through Event
	        ctrl.$scope.$emit('enquiry:proxyEvent', { eventName: 'vehicleSelected' });
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          if (err.data.map) {
	            err.data.map(function (item) {
	              ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	            });
	          } else {
	            ctrl.formValidationService.addSystemError(null, err.data);
	          }
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        _this3.loadingService.hideLoading('tradeIns');
	      });
	    }
	  }]);
	  return EnquiryTradeInsController;
	}();
	
	exports.default = EnquiryTradeInsController;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1365);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTradeIns.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTradeIns.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryTradeIns{color:red}", ""]);
	
	// exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryPricing = __webpack_require__(1367);
	
	var _enquiryPricing2 = _interopRequireDefault(_enquiryPricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryPricingModule = _angular2.default.module('enquiryPricing', [_angularUiRouter2.default]).component('enquiryPricing', _enquiryPricing2.default).name;
	
	exports.default = enquiryPricingModule;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryPricing = __webpack_require__(1368);
	
	var _enquiryPricing2 = _interopRequireDefault(_enquiryPricing);
	
	var _enquiryPricing3 = __webpack_require__(1369);
	
	var _enquiryPricing4 = _interopRequireDefault(_enquiryPricing3);
	
	__webpack_require__(1373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryPricingComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '=',
	    amountToPay: '=',
	    balanceDue: '='
	  },
	  template: _enquiryPricing2.default,
	  controller: _enquiryPricing4.default
	};
	
	exports.default = enquiryPricingComponent;

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <header>\r\n    <h2>Enquiry Pricing</h2>\r\n  </header>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-4\">\r\n        <div>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <h4 class=\"pull-right\">Amount To Pay</h4>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <h4 class=\"cost\">{{$ctrl.amountToPay | currency:'&euro;':2 }}</h4>\r\n              </div>\r\n            </div>\r\n        \r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <h4 class=\"pull-right\">\r\n                    <a href=\"#\" ng-click=\"$ctrl.updateDeposit()\">Deposit</a>\r\n                  </h4>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <h4 class=\"discount\">{{$ctrl.enquiry.deposit | currency:'&euro;':2 }}</h4>\r\n                </div>\r\n              </div>    \r\n        \r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <h4 class=\"pull-right\">Balance Due</h4>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <h4 class=\"discount\">{{$ctrl.balanceDue | currency:'&euro;':2 }}</h4>\r\n              </div>\r\n            </div>\r\n          </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-8\">\r\n      <table class=\"table table-hover\">\r\n        <tr>\r\n          <td><h5>Finance</h5></td>\r\n          <td><h5>{{$ctrl.breakdownSummary.finance | currency:'&euro;':2 }}</h5></td>\r\n          <td><h5>EFT</h5></td>\r\n          <td><h5>{{$ctrl.breakdownSummary.eft | currency:'&euro;':2 }}</h5></td>\r\n        </tr>       \r\n        <tr>\r\n          <td><h5>Cheque</h5></td>\r\n          <td><h5>{{$ctrl.breakdownSummary.cheque | currency:'&euro;':2 }}</h5></td>\r\n          <td><h5>Cash</h5></td>\r\n          <td><h5>{{$ctrl.breakdownSummary.cash | currency:'&euro;':2 }}</h5></td>\r\n        </tr>     \r\n        <tr>\r\n          <td colspan=\"2\"><h4>Total Paid</h4></td>\r\n          <td colspan=\"2\"><h4 class=\"cost\">{{$ctrl.breakdownSummary.total | currency:'&euro;':2 }}</h4></td>\r\n        </tr>                   \r\n      </table>\r\n    </div>    \r\n  </div>\r\n\r\n  <table class=\"table table-hover\">\r\n    <thead>\r\n        <tr>\r\n            <th class=\"col-md-7\">Item</th>\r\n            <th class=\"col-md-2\">Discount</th>\r\n            <th class=\"col-md-2\">Cost</th>\r\n            <th class=\"col-md-1\">&nbsp;</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr>\r\n          <td colspan=\"4\"><b>Vehicle Pricing</b></td>\r\n        </tr>\r\n        <tr ng-repeat=\"p in $ctrl.enquiry.enquiryPrices | filter:{ groupType: $ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing }\">\r\n          <td class=\"col-md-8\">\r\n              <a href=\"#\" ng-click=\"$ctrl.editVehiclePrice()\" ng-if=\"p.name === 'Vehicle Price'\">Vehicle Price</a>\r\n              <span ng-if=\"p.name !== 'Vehicle Price'\">{{p.name}}</span>\r\n          </td>\r\n          <td class=\"col-md-2 discount\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Discount ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-2 cost\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Cost ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-1\">&nbsp;</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <b>Extras</b>\r\n            (\r\n            <a href=\"#\" ng-click=\"$ctrl.addEnquiryExtra(false)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n                Add New \r\n            </a>\r\n            &nbsp; | &nbsp;\r\n            <a href=\"#\" ng-click=\"$ctrl.addEnquiryExtra(true)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n              Add Complimentary\r\n            </a>\r\n            )\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"p in $ctrl.enquiry.enquiryPrices | filter:{ groupType: $ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras, removed: false } | orderBy:'name'\">\r\n          <td class=\"col-md-7\">\r\n            <a href=\"#\" ng-click=\"$ctrl.updateValue(p.name, p.groupType, p.amount)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n              <span ng-class=\"{'highlight': p.reportable}\">{{p.name}}</span>\r\n            </a>\r\n            <span ng-show=\"$ctrl.enquiry.readonly\">\r\n              <span ng-class=\"{'highlight': p.reportable}\">{{p.name}}</span>\r\n            </span>\r\n          </td>\r\n          <td class=\"col-md-2 discount\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Discount ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-2 cost\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Cost ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-1\">\r\n            <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEnquiryPrice(p)\" ng-hide=\"$ctrl.enquiry.readonly\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <b>Financial Products</b>\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.addFinancialProduct()\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n                (Add New)\r\n            </a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"p in $ctrl.enquiry.enquiryPrices | filter:{ groupType: $ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts, removed: false } | orderBy:'name'\">\r\n          <td class=\"col-md-7\">\r\n            <a href=\"#\" ng-click=\"$ctrl.updateValue(p.name, p.groupType, p.amount)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n              <span ng-class=\"{'highlight': p.reportable}\">{{p.name}}</span>\r\n            </a>\r\n            <span ng-show=\"$ctrl.enquiry.readonly\">\r\n              <span ng-class=\"{'highlight': p.reportable}\">{{p.name}}</span>\r\n            </span>\r\n          </td>\r\n          <td class=\"col-md-2 discount\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Discount ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-2 cost\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Cost ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-1\">\r\n            <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEnquiryPrice(p)\" ng-hide=\"$ctrl.enquiry.readonly\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td colspan=\"4\">\r\n            <b>Misc. Discounts</b>\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.editEnquiryPrice()\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n                (Add New)\r\n            </a>\r\n          </td>\r\n        </tr>\r\n        <tr ng-repeat=\"p in $ctrl.enquiry.enquiryPrices | filter:{ groupType: $ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc } | orderBy:'name'\">\r\n          <td class=\"col-md-7\">\r\n            <a href=\"#\" ng-click=\"$ctrl.updateValue(p.name, p.groupType, p.amount)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n              {{p.name}}\r\n            </a>\r\n            <span ng-show=\"$ctrl.enquiry.readonly\">{{p.name}}</span>\r\n          </td>\r\n          <td class=\"col-md-2 discount\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Discount ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-2 cost\">{{p.priceType === $ctrl.enums.ENQUIRY_PRICE_TYPE.Cost ? (p.amount | currency:'&euro;':2) : '&nbsp;' }}</td>\r\n          <td class=\"col-md-1\">\r\n              <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.removeEnquiryPrice(p)\" ng-hide=\"$ctrl.enquiry.readonly\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-7\">\r\n            <b>Total</b>\r\n          </td>\r\n          <td class=\"col-md-2 discount\"><b>{{$ctrl.totalDiscount | currency:'&euro;':2 }}</b></td>\r\n          <td class=\"col-md-2 cost\"><b>{{$ctrl.totalPrice | currency:'&euro;':2 }}</b></td>\r\n          <td class=\"col-md-1\">&nbsp;</td>\r\n        </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n\r\n<div class=\"panel\">  \r\n  <a class=\"btn btn-success\" ng-click=\"$ctrl.editNotes('Warranty', $ctrl.enquiry.warrantyNotes)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n      <span class=\"fa fa-file-text-o\"></span>\r\n      Update Warranty Notes\r\n  </a>\r\n\r\n  <a class=\"btn btn-success\" ng-click=\"$ctrl.editNotes('Finance', $ctrl.enquiry.financeNotes)\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n      <span class=\"fa fa-file-text-o\"></span>\r\n      Update Finance Notes\r\n  </a>  \r\n</div>\r\n\r\n<div class=\"panel\">\r\n  <header>\r\n    <h2>Enquiry Payments</h2>\r\n    <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editEnquiryPayment()\" ng-hide=\"$ctrl.enquiry.readonly\">\r\n        <span class=\"glyphicon glyphicon-plus\"></span>\r\n        Add Payment\r\n    </a>\r\n    <a class=\"btn btn-default form-submit\" ng-click=\"$ctrl.printPaymentReceipt()\" ng-hide=\"$ctrl.enquiry.enquiryPayments.length === 0\">\r\n      <span class=\"glyphicon glyphicon-print\"></span>\r\n      Print Payment Receipt\r\n  </a>    \r\n  </header>\r\n\r\n  <table class=\"table table-hover\" ng-show=\"$ctrl.enquiry.enquiryPayments.length\">\r\n      <thead>\r\n          <tr>\r\n              <th class=\"col-md-2\">Payment For</th>\r\n              <th class=\"col-md-2\">Payment Mode</th>\r\n              <th class=\"col-md-2\">Dated</th>\r\n              <th class=\"col-md-2\">Amount</th>\r\n              <th class=\"col-md-2\">Comments</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n              <th class=\"col-md-1\">&nbsp;</th>\r\n          </tr>\r\n      </thead>\r\n      <tbody>\r\n          <tr ng-repeat=\"p in $ctrl.enquiry.enquiryPayments | orderBy : 'timeStamp'\">\r\n            <td class=\"col-md-2\">{{p.paymentForDeposit ? 'Deposit' : 'Balance Due'}}</td>\r\n            <td class=\"col-md-2\">{{p.paymentModeName}}</td>\r\n            <td class=\"col-md-2\">{{p.timeStamp | date : 'dd-MMMM-yyyy'}}</td>\r\n            <td class=\"col-md-2\">{{p.amount | currency:'&euro;':2 }}</td>            \r\n            <td class=\"col-md-2\">{{p.comments}}</td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.editEnquiryPayment(p)\"><span class=\"glyphicon glyphicon-edit\"></span></a>\r\n            </td>\r\n            <td class=\"col-md-1\">\r\n                <a class=\"btn btn-danger btn-small remove\" ng-click=\"$ctrl.deleteEnquiryPayment(p)\"><span class=\"glyphicon glyphicon-remove\"></span></a>\r\n            </td>\r\n          </tr>\r\n      </tbody>\r\n  </table>\r\n  <p ng-show=\"!$ctrl.enquiry.enquiryPayments.length\">No Payments made under this inquiry</p>\r\n</div>\r\n"

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _editEnquiryPriceModal = __webpack_require__(1370);
	
	var _editEnquiryPriceModal2 = _interopRequireDefault(_editEnquiryPriceModal);
	
	var _editEnquiryPaymentModal = __webpack_require__(1371);
	
	var _editEnquiryPaymentModal2 = _interopRequireDefault(_editEnquiryPaymentModal);
	
	var _editEnquiryNotesModal = __webpack_require__(1372);
	
	var _editEnquiryNotesModal2 = _interopRequireDefault(_editEnquiryNotesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryPricingController = function () {
	  EnquiryPricingController.$inject = ["enums", "$scope", "$uibModal", "lookupService", "authService", "addEditFinancialProductService", "addEditEnquiryExtraService", "$state", "printService", "adminService", "$ngConfirm", "enquiryService", "growl"];
	  function EnquiryPricingController(enums, $scope, $uibModal, lookupService, authService, addEditFinancialProductService, addEditEnquiryExtraService, $state, printService, adminService, $ngConfirm, enquiryService, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryPricingController);
	    this.enums = enums;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.lookupService = lookupService;
	    this.authService = authService;
	    this.addEditFinancialProductService = addEditFinancialProductService;
	    this.addEditEnquiryExtraService = addEditEnquiryExtraService;
	    this.$state = $state;
	    this.printService = printService;
	    this.adminService = adminService;
	    this.$ngConfirm = $ngConfirm;
	    this.enquiryService = enquiryService;
	    this.growl = growl;
	
	    this.amountToPay = 0;
	    this.totalPrice = 0;
	    this.totalDiscount = 0;
	    this.balanceDue = 0;
	
	    this.priceTypes = this.convertEnumToKeyValueList(enums.ENQUIRY_PRICE_TYPE, true);
	    this.paymentModes = this.convertEnumToKeyValueList(enums.ENQUIRY_PAYMENT_MODE, true);
	
	    this.defaultTexts = {};
	
	    //lookupService.lookupEnquiryPrices(this.authService.authData.currentLocation.key)
	    //.then((defaultPrices) => {
	    //this.defaultPrices = defaultPrices;
	
	    $scope.$on('vehicleSelected', this.initializePrices.bind(this));
	    $scope.$on('enquiry:initialized', this.enquiryInitialized.bind(this));
	
	    this.vehicleCost = 0;
	    this.tradeInAllowance = 0;
	    this.loadDefaultTexts();
	    //});
	
	    this.breakdownSummary = {
	      finance: 0,
	      cash: 0,
	      eft: 0,
	      cheque: 0,
	      total: 0
	    };
	  }
	
	  (0, _createClass3.default)(EnquiryPricingController, [{
	    key: 'enquiryInitialized',
	    value: function enquiryInitialized() {
	      var ctrl = this;
	
	      ctrl.lookupService.lookupEnquiryPrices(this.authService.authData.currentLocation.key).then(function (defaultPrices) {
	        ctrl.defaultPrices = defaultPrices;
	
	        ctrl.loadDefaultPrices();
	        ctrl.initializePrices();
	
	        ctrl.$scope.$emit('enquiryPricing:initialized', { amountToPay: ctrl.amountToPay, balanceDue: ctrl.balanceDue });
	      });
	    }
	  }, {
	    key: 'loadDefaultPrices',
	    value: function loadDefaultPrices() {
	      var _this = this;
	
	      this.defaultPrices.enquiryExtras.map(function (item) {
	        _this.addPrice(item.name, _this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras, item.defaultPrice, item.reportable);
	      });
	
	      this.defaultPrices.financialProducts.map(function (item) {
	        _this.addPrice(item.name, _this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts, item.defaultPrice, item.reportable);
	      });
	    }
	  }, {
	    key: 'addPrice',
	    value: function addPrice(name, groupType, amount, reportable) {
	      var ctrl = this;
	      var priceField = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	        return o.groupType === groupType && o.name === name;
	      });
	      if (!priceField) {
	        ctrl.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
	          groupType: groupType,
	          name: name,
	          amount: amount || 0,
	          reportable: reportable || false,
	          removed: false
	        });
	      }
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'initializePrices',
	    value: function initializePrices() {
	      var ctrl = this;
	      var vehicle = void 0;
	
	      //Get the selected Vehicle if there is one
	      var enquiryVehicle = (0, _lodash.find)(ctrl.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	
	      var vehicleCostPrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	        return o.name === 'Vehicle Price';
	      });
	
	      if (!vehicleCostPrice) {
	        ctrl.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
	          name: 'Vehicle Price',
	          amount: 0
	        });
	
	        vehicleCostPrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	          return o.name === 'Vehicle Price';
	        });
	      } else {
	        /*
	        * #726
	        * The vehicle price was not getting updated after a vehicle selection was updated
	        */
	        vehicleCostPrice.amount = enquiryVehicle.vehicle.price;
	      }
	
	      if (enquiryVehicle) {
	        vehicle = enquiryVehicle.vehicle;
	
	        if (!vehicleCostPrice.amount && vehicle) {
	          vehicleCostPrice.amount = vehicle.price || 0;
	        }
	      }
	
	      var allowancePrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	        return o.name === 'Trade In Allowance(s)';
	      });
	
	      if (!allowancePrice) {
	        ctrl.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
	          groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
	          name: 'Trade In Allowance(s)',
	          amount: 0
	        });
	
	        allowancePrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	          return o.name === 'Trade In Allowance(s)';
	        });
	      }
	
	      //Get the enquiry trade in if any
	      allowancePrice.amount = 0;
	      ctrl.enquiry.tradeInVehicles.map(function (v) {
	        allowancePrice.amount += v.allowance;
	      });
	
	      ctrl.updateCalculations();
	    }
	  }, {
	    key: 'updateCalculations',
	    value: function updateCalculations() {
	      var ctrl = this;
	      var tempPrice = 0;
	
	      /*
	      * Prices should only have a value if there is a Vehicle Selected
	      * in Enquiry. Otherwise default prices for new Enquiry will show up
	      * without any vehicles which will look odd
	      */
	      if (!ctrl.enquiry.enquiryVehicles.length) {
	        return;
	      }
	
	      ctrl.totalPrice = 0;
	      ctrl.totalDiscount = 0;
	
	      ctrl.enquiry.enquiryPrices.map(function (price) {
	        if (price.removed) {
	          return;
	        }
	
	        if (price.priceType === ctrl.enums.ENQUIRY_PRICE_TYPE.Cost) {
	          ctrl.totalPrice += price.amount;
	        } else {
	          ctrl.totalDiscount += price.amount;
	        }
	      });
	
	      ctrl.amountToPay = ctrl.totalPrice - ctrl.totalDiscount;
	      ctrl.balanceDue = ctrl.totalPrice - ctrl.totalDiscount;
	
	      ctrl.balanceDue -= ctrl.enquiry.deposit || 0;
	
	      //Update Breakdown Summary
	      ctrl.breakdownSummary.finance = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Finance);
	      ctrl.breakdownSummary.eft = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.EFT);
	      ctrl.breakdownSummary.cheque = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Cheque);
	      ctrl.breakdownSummary.cash = ctrl.getEnquiryPaymentSummary(ctrl.enums.ENQUIRY_PAYMENT_MODE.Cash);
	      ctrl.breakdownSummary.total = ctrl.getEnquiryPaymentTotal();
	    }
	  }, {
	    key: 'editEnquiryPrice',
	    value: function editEnquiryPrice(enquiryPrice) {
	      this.errMsg = '';
	      this.saveButtonTitle = 'Add';
	
	      if (enquiryPrice) {
	        this.tempEnquiryPrice = enquiryPrice;
	        this.tempEnquiryPrice.editMode = true;
	        this.saveButtonTitle = 'Update';
	      } else {
	        this.tempEnquiryPrice = {
	          priceType: this.enums.ENQUIRY_PRICE_TYPE.Discount,
	          groupType: this.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc
	        };
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editEnquiryPriceModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'addEnquiryPrice',
	    value: function addEnquiryPrice() {
	      var ctrl = this;
	
	      if (!ctrl.tempEnquiryPrice.name) {
	        ctrl.errMsg = 'Please enter a Name First';
	        return;
	      }
	
	      var floatPattern = new RegExp('^-?\\d*(\\.\\d{0,10})?$');
	
	      if (!floatPattern.exec(ctrl.tempEnquiryPrice.amount) || parseFloat(ctrl.tempEnquiryPrice.amount) <= 0) {
	        ctrl.errMsg = 'Please enter amount as a valid floating point number above 0';
	        return;
	      }
	
	      var enquiryPrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	        return !o.editMode && o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc && o.name.toLowerCase() === ctrl.tempEnquiryPrice.name.toLowerCase();
	      });
	
	      if (enquiryPrice) {
	        ctrl.errMsg = 'This Price has already been recorded';
	        return;
	      }
	
	      if (!ctrl.tempEnquiryPrice.editMode) {
	        ctrl.enquiry.enquiryPrices.push(ctrl.tempEnquiryPrice);
	      } else {
	        ctrl.tempEnquiryPrice.editMode = false;
	      }
	
	      ctrl.updateCalculations();
	      ctrl.closeModal();
	    }
	  }, {
	    key: 'removeEnquiryPrice',
	    value: function removeEnquiryPrice(enquiryPrice) {
	      switch (enquiryPrice.groupType) {
	        case this.enums.ENQUIRY_PRICE_GROUP_TYPE.Misc:
	          this.enquiry.enquiryPrices = (0, _lodash.without)(this.enquiry.enquiryPrices, enquiryPrice);
	          break;
	
	        case this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras:
	        case this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts:
	          enquiryPrice.removed = true;
	          break;
	      }
	
	      this.updateCalculations();
	    }
	  }, {
	    key: 'editEnquiryPayment',
	    value: function editEnquiryPayment(enquiryPayment) {
	
	      if (this.enquiry.enquiryVehicles.length === 0) {
	        this.$ngConfirm({
	          title: null,
	          content: 'Please select a vehicle first',
	          typeAnimation: false,
	          columnClass: 'm',
	          type: 'red',
	          scope: this.$scope,
	          buttons: {
	            ok: {
	              text: 'Ok',
	              btnClass: 'btn-default'
	            }
	          }
	        });
	
	        return;
	      }
	
	      this.errMsg = '';
	      this.saveButtonTitle = 'Add';
	
	      if (enquiryPayment) {
	        this.tempEnquiryPayment = enquiryPayment;
	        this.tempEnquiryPayment.timeStamp = new Date(this.tempEnquiryPayment.timeStamp);
	        this.tempEnquiryPayment.editMode = true;
	        this.saveButtonTitle = 'Update';
	      } else {
	        this.tempEnquiryPayment = {
	          paymentMode: null,
	          paymentForDeposit: true
	        };
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editEnquiryPaymentModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'addEnquiryPayment',
	    value: function addEnquiryPayment() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.tempEnquiryPayment.paymentMode) {
	        ctrl.errMsg = 'Please select a Payment Mode First';
	        return;
	      }
	
	      if (!this.tempEnquiryPayment.timeStamp) {
	        this.errMsg = 'Please select a Date First';
	        return;
	      }
	
	      var floatPattern = new RegExp('^-?\\d*(\\.\\d{0,10})?$');
	
	      if (!floatPattern.exec(ctrl.tempEnquiryPayment.amount) || parseFloat(ctrl.tempEnquiryPayment.amount) <= 0) {
	        ctrl.errMsg = 'Please enter amount as a valid floating point number above 0';
	        return;
	      }
	
	      ctrl.tempEnquiryPayment.paymentModeName = (0, _lodash.find)(ctrl.paymentModes, function (o) {
	        return o.id === ctrl.tempEnquiryPayment.paymentMode;
	      }).name;
	
	      if (!ctrl.tempEnquiryPayment.editMode) {
	        this.enquiryService.addPayment(this.enquiry.enquiryId, ctrl.tempEnquiryPayment).then(function (response) {
	          ctrl.tempEnquiryPayment.enquiryPaymentId = response.data;
	          ctrl.enquiry.enquiryPayments.push(ctrl.tempEnquiryPayment);
	
	          ctrl.updateCalculations();
	          ctrl.closeModal();
	
	          _this2.growl.success('Payment added successfully', { ttl: 5000 });
	        });
	      } else {
	        this.enquiryService.editPayment(ctrl.tempEnquiryPayment).then(function (response) {
	
	          ctrl.updateCalculations();
	          ctrl.closeModal();
	
	          ctrl.tempEnquiryPayment.editMode = false;
	
	          _this2.growl.success('Payment updated successfully', { ttl: 5000 });
	        });
	      }
	    }
	  }, {
	    key: 'addEnquiryExtra',
	    value: function addEnquiryExtra(complimentary) {
	      this.addNewItem(this.addEditEnquiryExtraService, this.enums.ENQUIRY_PRICE_GROUP_TYPE.Extras, complimentary);
	    }
	  }, {
	    key: 'addFinancialProduct',
	    value: function addFinancialProduct() {
	      this.addNewItem(this.addEditFinancialProductService, this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts);
	    }
	  }, {
	    key: 'addNewItem',
	    value: function addNewItem(svc, groupType) {
	      var complimentary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var ctrl = this;
	
	      svc.showAdd([], function (newItem) {
	        ctrl.enquiry.enquiryPrices.push({
	          priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
	          groupType: groupType,
	          name: newItem.name,
	          amount: newItem.defaultPrice || 0,
	          complimentary: complimentary,
	          reportable: newItem.reportable,
	          removed: false
	        });
	
	        ctrl.updateCalculations();
	        ctrl.$scope.$emit('enquiryPricing:initialized', { amountToPay: ctrl.amountToPay, balanceDue: ctrl.balanceDue });
	      }, true, complimentary);
	    }
	  }, {
	    key: 'updateDeposit',
	    value: function updateDeposit() {
	      var ctrl = this;
	      var deposit = ctrl.enquiry.deposit || 0;
	
	      try {
	        deposit = window.prompt('Please enter a value for Deposit', deposit);
	        if (deposit === '' || parseInt(deposit) === 0 || isNaN(parseInt(deposit))) {
	          deposit = 0;
	        } else {
	          deposit = parseInt(deposit);
	        }
	
	        ctrl.enquiry.deposit = deposit;
	      } catch (e) {
	        ctrl.enquiry.deposit = ctrl.enquiry.deposit || 0;
	      }
	
	      ctrl.updateCalculations();
	    }
	  }, {
	    key: 'updateValue',
	    value: function updateValue(priceName, groupType, amount) {
	      var ctrl = this;
	      var value = 0;
	
	      try {
	        value = parseInt(window.prompt('Please enter a value for ' + priceName, amount > 0 ? amount : ''));
	      } catch (e) {
	        value = 0;
	      }
	
	      if (value >= 0) {
	        var enquiryPrice = (0, _lodash.find)(ctrl.enquiry.enquiryPrices, function (o) {
	          return o.groupType === groupType && o.name === priceName;
	        });
	
	        enquiryPrice.amount = value;
	
	        ctrl.updateCalculations();
	      }
	    }
	  }, {
	    key: 'editNotes',
	    value: function editNotes(noteType, modelProp) {
	      this.errMsg = '';
	      this.noteType = noteType;
	      this.modelProp = modelProp;
	
	      if (this.noteType === 'Warranty') {
	        this.presetTexts = this.defaultTexts.warranty;
	        this.modalHeader = 'Update Warranty Notes';
	      } else {
	        this.presetTexts = this.defaultTexts.finance;
	        this.modalHeader = 'Update Finance Notes';
	      }
	
	      this.presetTexts = (0, _lodash.filter)(this.presetTexts, function (o) {
	        return o !== '';
	      });
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _editEnquiryNotesModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'saveNotes',
	    value: function saveNotes() {
	      if (this.noteType === 'Warranty') {
	        this.enquiry.warrantyNotes = this.modelProp;
	      } else {
	        this.enquiry.financeNotes = this.modelProp;
	      }
	
	      this.$scope.$emit('enquiryPricing:notesUpdated');
	      this.closeModal();
	    }
	  }, {
	    key: 'quotation',
	    value: function quotation() {
	      if (this.enquiry.enquiryVehicles.length) {
	        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	          return o.isSelected;
	        }).vehicle;
	
	        if (!vehicle.price || vehicle.price === 0) {
	          this.$ngConfirm({
	            title: 'ERROR',
	            content: 'Selected vehicle does not have a retail price',
	            type: 'red',
	            typeAnimation: false,
	            columnClass: 'm',
	            buttons: {
	              tryAgain: {
	                text: 'Close',
	                btnClass: 'btn-danger'
	              }
	            }
	          });
	        } else {
	          this.printService.printQuotation(this.enquiry.enquiryId);
	        }
	      }
	    }
	  }, {
	    key: 'loadDefaultTexts',
	    value: function loadDefaultTexts() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      ctrl.adminService.listDefaultTexts(ctrl.authService.authData.currentLocation.key).then(function (response) {
	        _this3.defaultTexts = response.data;
	      });
	    }
	  }, {
	    key: 'editVehiclePrice',
	    value: function editVehiclePrice() {
	      var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      }).vehicle;
	
	      this.$state.go('vehicleEdit', {
	        vehicleId: vehicle.vehicleId,
	        origin: {
	          source: 'enquiry',
	          enquiryId: this.enquiry.enquiryId
	        }
	      });
	    }
	  }, {
	    key: 'getEnquiryPaymentSummary',
	    value: function getEnquiryPaymentSummary(paymentMode) {
	      var filteredPayments = (0, _lodash.filter)(this.enquiry.enquiryPayments, function (o) {
	        return o.paymentMode === paymentMode;
	      });
	
	      return (0, _lodash.sum)(filteredPayments.map(function (o) {
	        return o.amount;
	      }));
	    }
	  }, {
	    key: 'getEnquiryPaymentTotal',
	    value: function getEnquiryPaymentTotal() {
	      return (0, _lodash.sum)(this.enquiry.enquiryPayments.map(function (o) {
	        return o.amount;
	      }));
	    }
	  }, {
	    key: 'printPaymentReceipt',
	    value: function printPaymentReceipt() {
	      this.printService.paymentReceipt(this.enquiry.enquiryId, this.authService.authData.userId);
	    }
	  }, {
	    key: 'deleteEnquiryPayment',
	    value: function deleteEnquiryPayment(enquiryPayment) {
	      var ctrl = this;
	
	      this.$ngConfirm({
	        title: null,
	        content: 'Are you sure you want to remove this payment?',
	        typeAnimation: false,
	        columnClass: 'm',
	        type: 'red',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Remove',
	            btnClass: 'btn-danger',
	            action: function action() {
	              ctrl.enquiryService.deletePayment(enquiryPayment.enquiryPaymentId).then(function (response) {
	                debugger;
	                ctrl.enquiry.enquiryPayments = (0, _lodash.without)(ctrl.enquiry.enquiryPayments, enquiryPayment);
	                ctrl.updateCalculations();
	                ctrl.growl.success('Payment removed successfully', { ttl: 5000 });
	              });
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }]);
	  return EnquiryPricingController;
	}();
	
	exports.default = EnquiryPricingController;

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Discount</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\" ng-hide=\"true\">\r\n          <div class=\"col-md-3\">\r\n            <label>Price Type</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <select\r\n              ng-options=\"p.id as p.name for p in $ctrl.priceTypes\"\r\n              ng-model=\"$ctrl.tempEnquiryPrice.priceType\"\r\n              class=\"form-control\">\r\n            </select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Name *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.tempEnquiryPrice.name\" placeholder=\"Enter name here\" maxlength=\"20\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Amount *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.tempEnquiryPrice.amount\" placeholder=\"Enter amount here\"/>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addEnquiryPrice()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> {{$ctrl.saveButtonTitle}}\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Add Payment</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n          <label>Payment For *</label>\r\n        </div>\r\n        <div class=\"col-md-9 ph10 mb5\">\r\n          <label>\r\n            <input type=\"radio\" ng-model=\"$ctrl.tempEnquiryPayment.paymentForDeposit\" ng-value=\"true\">\r\n            Deposit\r\n          </label>\r\n          <label>\r\n            <input type=\"radio\" ng-model=\"$ctrl.tempEnquiryPayment.paymentForDeposit\" ng-value=\"false\">\r\n            Balance Due\r\n          </label>\r\n        </div>\r\n    </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Payment Mode *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <select\r\n              ng-options=\"p.id as p.name for p in $ctrl.paymentModes\"\r\n              ng-model=\"$ctrl.tempEnquiryPayment.paymentMode\"\r\n              class=\"form-control\">\r\n            </select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Date *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.timeStamp = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.tempEnquiryPayment.timeStamp\" is-open=\"$ctrl.timeStamp\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.timeStamp = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Amount Paid*</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.tempEnquiryPayment.amount\" placeholder=\"Enter amount here\"/>\r\n          </div>\r\n      </div>\r\n      \r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Comments</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea\r\n              maxlength=\"250\"\r\n              class=\"form-control\"\r\n              placeholder=\"Comments\"\r\n              ng-model=\"$ctrl.tempEnquiryPayment.comments\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.addEnquiryPayment()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"glyphicon glyphicon-plus\"></span> {{$ctrl.saveButtonTitle}}\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>{{$ctrl.modalHeader}}</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">      \r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>{{$ctrl.noteType}} Notes</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea\r\n              maxlength=\"300\"\r\n              rows=\"6\"\r\n              class=\"form-control\"\r\n              placeholder=\"Enter {{$ctrl.noteType}} notes here\"\r\n              ng-model=\"$ctrl.modelProp\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <hr />\r\n      <h4>Presets</h4>\r\n      <div class=\"list-group\">\r\n        <a href=\"#\" ng-click=\"$ctrl.modelProp = t\" ng-repeat=\"t in $ctrl.presetTexts track by $index\" class=\"list-group-item list-group-item-action\">\r\n            {{t.toString().substring(0, 85)}} ...\r\n        </a>\r\n      </div>  \r\n      \r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.saveNotes()\" name=\"save\" class=\"btn btn-success\" >\r\n                        <span class=\"fa fa-floppy-o\"></span> Save Changes\r\n                    </button>\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.closeModal()\" name=\"save\" class=\"btn btn-warning\" >\r\n                        <span class=\"fa fa-times\"></span> Cancel\r\n                    </button>                    \r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1374);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryPricing.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryPricing.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".cost{color:red}.discount{color:green}.highlight{background-color:#ff0}", ""]);
	
	// exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryConclude = __webpack_require__(1376);
	
	var _enquiryConclude2 = _interopRequireDefault(_enquiryConclude);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryConcludeModule = _angular2.default.module('enquiryConclude', [_angularUiRouter2.default]).component('enquiryConclude', _enquiryConclude2.default).name;
	
	exports.default = enquiryConcludeModule;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryConclude = __webpack_require__(1377);
	
	var _enquiryConclude2 = _interopRequireDefault(_enquiryConclude);
	
	var _enquiryConclude3 = __webpack_require__(1378);
	
	var _enquiryConclude4 = _interopRequireDefault(_enquiryConclude3);
	
	__webpack_require__(1382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryConcludeComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '='
	  },
	  template: _enquiryConclude2.default,
	  controller: _enquiryConclude4.default
	};
	
	exports.default = enquiryConcludeComponent;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"testDrives\">\r\n  <header>\r\n    <h2>Conclude Enquiry</h2>\r\n  </header>\r\n\r\n  <div ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Open || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed\">\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Enquiry Status: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Open ? 'Open' : 'Closed'}}</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed\">\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Enquiry Status: </span>\r\n      <span class=\"col-md-7 statusLine\">Confirmed</span>\r\n    </div>\r\n\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Delivery Date: </span>\r\n      <span class=\"col-md-7 statusLine\"><a href=# ng-click=\"$ctrl.confirmDeal()\">{{$ctrl.enquiry.deliveryDate | date : 'dd MMMM yyyy'}}</a></span>\r\n    </div>\r\n\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Comments: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.enquiry.comments}}</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Lost\">\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Enquiry Status: </span>\r\n      <span class=\"col-md-7 statusLine\">Lost</span>\r\n    </div>\r\n\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Reason: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.lostReason}}</span>\r\n    </div>\r\n\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Comments: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.enquiry.comments}}</span>\r\n    </div>\r\n  </div>\r\n\r\n  <div>\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Finance Status: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.enquiry.financeState || 'N / A'}}</span>\r\n    </div>    \r\n  </div>  \r\n\r\n  <div ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed\">\r\n    <div class=\"col-md-offset-3 col-md-6\">\r\n      <span class=\"col-md-5 statusHeading\">Signature Status: </span>\r\n      <span class=\"col-md-7 statusLine\">{{$ctrl.enquiry.signatureState || 'N / A'}}</span>\r\n    </div>    \r\n  </div>    \r\n\r\n  <br \\><br \\>\r\n\r\n  <div class=\"col-md-offset-3 col-md-6\" block-ui=\"enquiryConclusion\">\r\n    <button class=\"btn btn-default btn-block btn-lg\" ng-click=\"$ctrl.notifyFinance()\" ng-show=\"(($ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Open || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed) && !$ctrl.enquiry.financeNotified)\">\r\n        Notify Finance\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-danger btn-block btn-lg\" ng-click=\"$ctrl.lostDeal()\" ng-disabled=\"$ctrl.enquiry.state !== $ctrl.enums.ENQUIRY_STATE.Open  && $ctrl.enquiry.state !== $ctrl.enums.ENQUIRY_STATE.Confirmed\">\r\n        Lost Deal\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-success btn-block btn-lg\" ng-click=\"$ctrl.confirmDeal()\" ng-disabled=\"$ctrl.enquiry.state !== $ctrl.enums.ENQUIRY_STATE.Open\">\r\n        Confirm Deal\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-primary btn-block btn-lg\" ng-click=\"$ctrl.closeDeal()\" ng-disabled=\"$ctrl.enquiry.state != $ctrl.enums.ENQUIRY_STATE.Confirmed\">\r\n        Customer Delivered\r\n    </button>\r\n  </div>\r\n\r\n  <button class=\"btn btn-success\" ng-click=\"$ctrl.showRequestSignature()\" \r\n    ng-show=\"$ctrl.enquiry.isSimiMember\r\n    && ($ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed)\r\n    && (!$ctrl.enquiry.signatureStatus || $ctrl.enquiry.signatureStatus === $ctrl.enums.SIGNATURE_STATUS.Voided || $ctrl.enquiry.signatureStatus === $ctrl.enums.SIGNATURE_STATUS.CustomerDeclined || $ctrl.enquiry.signatureStatus === $ctrl.enums.SIGNATURE_STATUS.DealerDeclined)\">\r\n    Request Signature\r\n  </button>\r\n\r\n  <button class=\"btn btn-success\" ng-click=\"$ctrl.orderForm()\" ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed\">\r\n      View Order\r\n  </button>\r\n  <br /> <br />\r\n  <a href=# ng-show=\"$ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Confirmed || $ctrl.enquiry.state === $ctrl.enums.ENQUIRY_STATE.Closed\" ng-click=\"$ctrl.printOrderFormGuide()\">Click here to view the order form guide</a>\r\n\r\n</div>\r\n"

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lostDealModal = __webpack_require__(1379);
	
	var _lostDealModal2 = _interopRequireDefault(_lostDealModal);
	
	var _confirmDealModal = __webpack_require__(1380);
	
	var _confirmDealModal2 = _interopRequireDefault(_confirmDealModal);
	
	var _updateDpaConfirmModal = __webpack_require__(1381);
	
	var _updateDpaConfirmModal2 = _interopRequireDefault(_updateDpaConfirmModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryConcludeController = function () {
	  EnquiryConcludeController.$inject = ["enums", "$scope", "$uibModal", "$sce", "$filter", "$window", "$state", "loadingService", "enquiryService", "printService", "$ngConfirm", "authService", "notificationService", "userService"];
	  function EnquiryConcludeController(enums, $scope, $uibModal, $sce, $filter, $window, $state, loadingService, enquiryService, printService, $ngConfirm, authService, notificationService, userService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EnquiryConcludeController);
	    this.enums = enums;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.$sce = $sce;
	    this.$filter = $filter;
	    this.$window = $window;
	    this.$state = $state;
	    this.loadingService = loadingService;
	    this.enquiryService = enquiryService;
	    this.printService = printService;
	    this.$ngConfirm = $ngConfirm;
	    this.authService = authService;
	    this.notificationService = notificationService;
	    this.userService = userService;
	
	    this.enquiryLostReasons = this.convertEnumToKeyValueList(enums.ENQUIRY_LOST_REASON, true);
	
	    this.updateState();
	
	    $scope.$on('enquiry:initialized', function () {
	      _this.updateState.bind(_this)();
	    });
	
	    this.authService.getLocationExtendedProperties('marketingSourceRequired');
	  }
	
	  (0, _createClass3.default)(EnquiryConcludeController, [{
	    key: 'updateState',
	    value: function updateState(state) {
	      var ctrl = this;
	
	      if (state) {
	        ctrl.enquiry.state = state;
	      }
	
	      switch (ctrl.enquiry.state) {
	        case ctrl.enums.ENQUIRY_STATE.Open:
	          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Open</b>');
	          break;
	
	        case ctrl.enums.ENQUIRY_STATE.Lost:
	          var reason = (0, _lodash.find)(ctrl.enquiryLostReasons, function (o) {
	            return o.id === ctrl.enquiry.enquiryLostReason;
	          }).name;
	          ctrl.lostReason = reason;
	          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Lost</b> <br> <b>Reason</b>: ' + reason + ' <br> <b>Addition Comments</b>: ' + (ctrl.enquiry.comments || ''));
	          ctrl.enquiry.followUpWebLeadEmail = false;
	          break;
	
	        case ctrl.enums.ENQUIRY_STATE.Confirmed:
	          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Confirmed</b> <br> <b>Delivery Date</b>: ' + ctrl.$filter('date')(ctrl.enquiry.deliveryDate, 'dd-MMMM-yyyy') + ' <br> <b>Addition Comments</b>: ' + (ctrl.enquiry.comments || ''));
	          break;
	
	        case ctrl.enums.ENQUIRY_STATE.Closed:
	          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Closed</b>');
	          break;
	      }
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'notifyFinance',
	    value: function notifyFinance() {
	      var ctrl = this;
	
	      if (!ctrl.enquiry.enquiryVehicles || !ctrl.enquiry.enquiryVehicles.length) {
	        alert('Please select a vehicle first');
	        return;
	      }
	
	      ctrl.loadingService.showLoading('enquiryConclusion', 'Notifying Finance Team ...');
	
	      ctrl.enquiryService.notifyFinance(ctrl.enquiry.enquiryId).then(function (response) {
	        ctrl.enquiry.financeNotified = true;
	        ctrl.enquiry.financeState = 'Awaiting Approval';
	
	        ctrl.notificationService.sendFinanceCreatedNotification(ctrl.enquiry.enquiryId);
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiryConclusion');
	      });
	    }
	  }, {
	    key: 'lostDeal',
	    value: function lostDeal() {
	      this.errMsg = '';
	
	      //Check for Basic DPA before closing
	      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
	        this.fnUpdateDpa = this.showUpdateBasicDpa;
	
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _updateDpaConfirmModal2.default,
	          scope: this.$scope
	        });
	
	        return;
	      }
	
	      if (!this.authService.authData.currentLocation.allDpaOptional && !this.enquiry.isAllDpaSet && this.enquiry.state === this.enums.ENQUIRY_STATE.Confirmed && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
	        this.fnUpdateDpa = this.showUpdateAllDpaYes;
	
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _updateDpaConfirmModal2.default,
	          scope: this.$scope
	        });
	
	        return;
	      }
	
	      if (this.authService.authData.currentLocation.marketingSourceRequired.enabled && !this.enquiry.enquirySourceId) {
	        this.$ngConfirm({
	          title: "Error",
	          content: 'Please select an enquiry source first',
	          type: 'red',
	          columnClass: 'm',
	          buttons: {
	            ok: {
	              text: 'Ok',
	              btnClass: 'btn-default'
	            }
	          }
	        });
	
	        return;
	      }
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _lostDealModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'lostDealSelected',
	    value: function lostDealSelected() {
	      var ctrl = this;
	
	      if (!ctrl.enquiry.enquiryLostReason) {
	        ctrl.errMsg = 'Please selected a reason first';
	        return;
	      }
	
	      ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Lost);
	      ctrl.closeModal();
	    }
	  }, {
	    key: 'confirmDeal',
	    value: function confirmDeal() {
	      this.errMsg = '';
	
	      /*if (this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet && !this.enquiry.isAllDpaSet) {
	        this.$uibModalInstance = this.$uibModal.open({
	          template: UpdateDpaConfirmTemplate,
	          scope: this.$scope
	        });
	          return;
	      }*/
	
	      this.$uibModalInstance = this.$uibModal.open({
	        template: _confirmDealModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'maybeLater',
	    value: function maybeLater() {
	      this.closeModal();
	
	      if (this.enquiry.state !== this.enums.ENQUIRY_STATE.Confirmed) {
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _confirmDealModal2.default,
	          scope: this.$scope
	        });
	      }
	    }
	  }, {
	    key: 'confirmDealSelected',
	    value: function confirmDealSelected() {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.enquiry.deliveryDate) {
	        ctrl.errMsg = 'Please selected a delivery date first';
	        return;
	      }
	
	      ctrl.closeModal();
	
	      ctrl.enquiryService.canConfirmEnquiry(ctrl.enquiry).then(function (response) {
	        ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Confirmed);
	        ctrl.$scope.$emit('enquiryConclude:enquiryConfirmed');
	      }).catch(function (err) {
	        if (err.status === 400) {
	          var key = err.data[0].key;
	
	          if (key === 'linkedEnquiries') {
	            _this2.warnLinkedEnquiries(err.data[0].value);
	          } else {
	            _this2.enquiryConfirmError(err.data[0].value);
	          }
	        } else if (err.status === 600) {} else {
	          _this2.enquiryConfirmError("Enquiry could not be confirmed");
	        }
	      });
	    }
	  }, {
	    key: 'enquiryConfirmError',
	    value: function enquiryConfirmError(errMsg) {
	      this.$ngConfirm({
	        title: 'Enquiry Confirm Error',
	        content: '' + errMsg,
	        type: 'red',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          ok: {
	            text: 'Ok'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'warnLinkedEnquiries',
	    value: function warnLinkedEnquiries(linkedEnquiries, editArgs) {
	      var _this3 = this;
	
	      var arrLinkedEnquiries = linkedEnquiries.toString().replace(/\"/g, '').split(',');
	      this.$ngConfirm({
	        title: 'Multiple Enquiries',
	        content: 'There are <b>' + arrLinkedEnquiries.length + '</b> other open enquirie(s) for this Contact with the same trade in vehicle. <br /><br />Confirming this enquiry will mark the other one\'s as lost.</br></br> <b>Are you sure you want to continue ?</b>',
	        type: 'orange',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes, Confirm this and Close others',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this3.enquiryService.closeLinkedEnquiries(arrLinkedEnquiries).then(function () {
	                _this3.updateState(_this3.enums.ENQUIRY_STATE.Confirmed);
	                _this3.$scope.$emit('enquiryConclude:enquiryConfirmed');
	              });
	            }
	          },
	          no: {
	            text: 'No, I will decide later',
	            btnClass: 'btn-default',
	            action: function action() {
	              _this3.enquiry.deliveryDate = null;
	              _this3.enquiry.comments = null;
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'closeDeal',
	    value: function closeDeal() {
	      var ctrl = this;
	
	      //Check for Basic DPA before closing
	      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
	        this.fnUpdateDpa = this.showUpdateBasicDpa;
	
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _updateDpaConfirmModal2.default,
	          scope: this.$scope
	        });
	
	        return;
	      }
	
	      if (!this.authService.authData.currentLocation.allDpaOptional && !this.enquiry.isAllDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
	        this.fnUpdateDpa = this.showUpdateAllDpaYes;
	
	        this.$uibModalInstance = this.$uibModal.open({
	          template: _updateDpaConfirmModal2.default,
	          scope: this.$scope
	        });
	
	        return;
	      }
	
	      /*if (this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && !this.enquiry.isAllDpaSet) {
	        this.$uibModalInstance = this.$uibModal.open({
	          template: UpdateDpaConfirmTemplate,
	          scope: this.$scope
	        });
	          return;
	      }*/
	
	      var sure = ctrl.$window.confirm('Are you sure you want to Close this Enquiry. Selected Vehicle will be marked as sold in Stock and any Traded in Vehicles will be marked as Available in Stock');
	
	      if (sure) {
	        ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Closed);
	      }
	    }
	  }, {
	    key: 'orderForm',
	    value: function orderForm() {
	      if (this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader) {
	        if (this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.BuyIn) {
	          this.printService.nonSimiOrderForm(this.enquiry.enquiryId);
	        } else {
	          if (this.enquiry.isSimiMember) {
	            /*
	            * Show the Order form from DocuSign since it was requested for Signature
	            * Check the status is either Created, or Signed by Customer or Completed
	            */
	            if (this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Created || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.CustomerSigned || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Completed) {
	              this.showDocuSignAuth('viewSignedOrderForm');
	            } else {
	              this.printService.printSimiTradeOrderForm(this.enquiry.enquiryId);
	            }
	          } else {
	            this.printService.printTradeOrderForm(this.enquiry.enquiryId, this.enquiry.isSimiMember);
	          }
	        }
	      } else {
	        if (this.enquiry.isSimiMember) {
	          /*
	          * Show the Order form from DocuSign since it was requested for Signature
	          * Check the status is either Created, or Signed by Customer or Completed
	          */
	          if (this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Created || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.CustomerSigned || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Completed) {
	            this.showDocuSignAuth('viewSignedOrderForm');
	          } else {
	            this.printService.printSimiOrderForm(this.enquiry.enquiryId);
	          }
	        } else {
	          this.printService.nonSimiOrderForm(this.enquiry.enquiryId);
	        }
	      }
	    }
	  }, {
	    key: 'showUpdateBasicDpa',
	    value: function showUpdateBasicDpa() {
	      var dpa = {
	        contactId: this.enquiry.contactId
	      };
	
	      if (this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Email || this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Web) {
	        dpa.verbalConsent = true;
	      }
	
	      this.$state.go('simpleDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, dpa: dpa });
	    }
	  }, {
	    key: 'showUpdateAllDpaYes',
	    value: function showUpdateAllDpaYes() {
	      var marketing = {
	        email: this.enquiry.marketing_Email,
	        post: this.enquiry.marketing_Post,
	        text: this.enquiry.marketing_Text,
	        phone: this.enquiry.marketing_Phone
	      };
	
	      this.$state.go('allDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, marketing: marketing });
	    }
	  }, {
	    key: 'showRequestSignature',
	    value: function showRequestSignature() {
	      if (!this.enquiry.contactHasEmail) {
	        this.$ngConfirm({
	          title: 'ERROR',
	          content: 'Cannot Request Signature. Contact does not have an email set',
	          type: 'red',
	          typeAnimation: false,
	          columnClass: 'm',
	          buttons: {
	            tryAgain: {
	              text: 'Close',
	              btnClass: 'btn-danger'
	            }
	          }
	        });
	
	        return;
	      } else {
	        this.showDocuSignAuth('requestSignature');
	      }
	    }
	  }, {
	    key: 'showDocuSignAuth',
	    value: function showDocuSignAuth(_action) {
	      var _this4 = this;
	
	      this.$ngConfirm({
	        title: 'DocuSign Auth',
	        contentUrl: 'templates/enquiry/docuSignAuthConsentTemplate',
	        columnClass: 'm',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Yes, take me to DocuSign',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this4.authService.docuSignLogin(_this4.enquiry.enquiryId, _action);
	            }
	          },
	          no: {
	            text: 'No, leave it',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'printOrderFormGuide',
	    value: function printOrderFormGuide() {
	      this.printService.printOrderFormGuid_CustomForm(this.enquiry.enquiryId);
	    }
	  }]);
	  return EnquiryConcludeController;
	}();
	
	exports.default = EnquiryConcludeController;

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Enquiry Lost</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Reason *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <select\r\n              ng-options=\"r.id as r.name for r in $ctrl.enquiryLostReasons\"\r\n              ng-model=\"$ctrl.enquiry.enquiryLostReason\"\r\n              class=\"form-control\">\r\n            </select>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Additional Comments</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea\r\n              maxlength=\"250\"\r\n              class=\"form-control\"\r\n              placeholder=\"Comments\"\r\n              ng-model=\"$ctrl.enquiry.comments\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.lostDealSelected()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"fa fa-times-circle\"></span> Close Enquiry\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n    <button type=\"button\"\r\n            class=\"close\"\r\n            data-dismiss=\"modal\"\r\n            aria-hidden=\"true\"\r\n            ng-click=\"$ctrl.closeModal()\">x</button>\r\n    <h2>  Enquiry Confirmed</h2>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n\r\n  <div id=\"result\" class=\"result\"></div>\r\n  <div class=\"form-horizontal\">\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n        {{$ctrl.errMsg}}\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Delivery Date *</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.timeStamp = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.enquiry.deliveryDate\" is-open=\"$ctrl.timeStamp\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.timeStamp = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <label>Additional Comments</label>\r\n          </div>\r\n          <div class=\"col-md-9 ph10 mb5\">\r\n            <textarea\r\n              maxlength=\"250\"\r\n              class=\"form-control\"\r\n              placeholder=\"Comments\"\r\n              ng-model=\"$ctrl.enquiry.comments\">\r\n            </textarea>\r\n          </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n          <div class=\"modal-footer\">\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.confirmDealSelected()\" ng-hide=\"$ctrl.enquiry.otherLocationVehicle\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                        <span class=\"fa fa-floppy-o\"></span> Confirm Enquiry\r\n                    </button>\r\n\r\n\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n        <button type=\"button\"\r\n                class=\"close\"\r\n                data-dismiss=\"modal\"\r\n                aria-hidden=\"true\"\r\n                ng-click=\"$ctrl.closeModal()\">x</button>\r\n        <h2>Data Protection Authorization Confirmation</h2>\r\n</div>\r\n    \r\n    <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                The Data Protection Authorisation has not been fully completed for this contact.\r\n                <br><br>\r\n\r\n                Please click <b>Update Now</b> to update the Data Protection Authorisation.\r\n                <br><br>\r\n        \r\n                Otherwise click <b>Cancel</b> to stay on this page\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"modal-footer\">\r\n                <div class=\"col-md-12\">\r\n                    <div class=\"form-group\">\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.fnUpdateDpa()\" name=\"save\" class=\"btn btn-primary\" style=\"width:48%\">\r\n                        Update Now\r\n                    </button>\r\n\r\n                    <button type=\"submit\" ng-click=\"$ctrl.maybeLater()\" name=\"save\" class=\"btn btn-default\" style=\"width:48%\">\r\n                        Maybe Later \r\n                    </button>                    \r\n\r\n\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    "

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1383);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryConclude.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryConclude.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".statusHeading,.statusLine{font-size:16px;padding-bottom:10px;padding-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _simpleDpa = __webpack_require__(1385);
	
	var _simpleDpa2 = _interopRequireDefault(_simpleDpa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simpleDpaModule = _angular2.default.module('simpleDpa', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('simpleDpa', {
	    url: '/enquiry/contact/simplaDpa/:contactId',
	    component: 'simpleDpa',
	    params: {
	      enquiryId: null,
	      dpa: null
	    }
	  });
	}]).component('simpleDpa', _simpleDpa2.default).name;
	
	exports.default = simpleDpaModule;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleDpa = __webpack_require__(1386);
	
	var _simpleDpa2 = _interopRequireDefault(_simpleDpa);
	
	var _simpleDpa3 = __webpack_require__(1387);
	
	var _simpleDpa4 = _interopRequireDefault(_simpleDpa3);
	
	__webpack_require__(1388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simpleDpaComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _simpleDpa2.default,
	  controller: _simpleDpa4.default
	};
	
	exports.default = simpleDpaComponent;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-lg-9 col-md-7 mt-1-desktop-lg\">\r\n        <h1 class=\"dashboard-title\">Data Protection Authorsation</h1>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"errors-panel\" ng-show=\"$ctrl.errUpdateDpa !== ''\">    \r\n    <ul>\r\n        <li>{{$ctrl.errUpdateDpa}}</li>\r\n    </ul>\r\n</div>\r\n\r\n<hr class=\"dashboard-seperator\">\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-2 col-xs-6\">\r\n        &nbsp;<br><br>\r\n    </div>\r\n    <div class=\"col-md-3 mt-2 col-xs-6\">\r\n      &nbsp;<br><br>\r\n    </div>\r\n\r\n    <div class=\"mt-1 col-md-7 col-xs-12 mb-tablet\">\r\n        <div class=\"pull-sm-right\">                \r\n            <div class=\"pull-right\">\r\n                <button type=\"button\" class=\"btn btn-warning mr-1\" ng-click=\"$ctrl.goBack()\">Go Back</button>\r\n                <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.updateDpa()\">Save Changes</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" block-ui=\"dpa\">\r\n    <uib-accordion close-others=\"true\">\r\n        <!-- Consent Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n          <uib-accordion-heading>\r\n            Marketing Consent\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"dpaReasons\">\r\n              <p class=\"bold\">Marketing Consent</p>\r\n              <p>\r\n                We have exciting offers and news about our products and services that we hope you’d like to hear about. Your opinion is important to us and we may contact you to ensure you are satisfied with our services. We will treat your data with respect and store it safely in accordance with the current data protection regulations. We may share your data with Franchise partners  and affiliated companies to improve your experience.\r\n                <br /><br />\r\n                Please visit our website  for further details on our data protection policy, including how you may access and correct your personal data or withdraw consent to the collection, use or disclosure of your personal data\r\n              </p>\r\n            </div>\r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <div class=\"col-sm-offset-2 col-sm-10\">            \r\n                  <input type=\"checkbox\" id=\"chkVerbal\" ng-model=\"$ctrl.dpa.verbalConsent\" ng-change=\"$ctrl.confirmVerbalConsent()\"/>\r\n                  <label for=\"chkVerbal\">Verbal notification of Privacy Notice Given and Marketing Consent Received</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <div class=\"col-sm-offset-2 col-sm-10\">\r\n                  <a href=\"#\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.checkOptions(true)\">Select All</a>\r\n                  <a href=\"#\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.checkOptions(false)\">Deselect All</a>\r\n                </div>\r\n              </div>\r\n            </div>      \r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-2\">Via Email</label>\r\n                <div class=\"col-sm-10\">\r\n                  <switch ng-model=\"$ctrl.dpa.viaEmail\"></switch>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-2\">Via Post</label>\r\n                <div class=\"col-sm-10\">\r\n                  <label class=\"control-label\" for=\"yes2\">\r\n                    <switch ng-model=\"$ctrl.dpa.viaPost\"></switch>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-2\">Via Text</label>\r\n                <div class=\"col-sm-10\">\r\n                  <switch ng-model=\"$ctrl.dpa.viaText\"></switch>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-2\">Via Phone</label>\r\n                <div class=\"col-sm-10\">\r\n                  <switch ng-model=\"$ctrl.dpa.viaPhone\"></switch>\r\n                </div>\r\n              </div>\r\n            </div>\r\n        </div>\r\n        <!-- Consent End -->\r\n\r\n        <!-- Signature Begin -->\r\n        <div uib-accordion-group class=\"panel-default\">\r\n          <uib-accordion-heading>\r\n            Signature\r\n          </uib-accordion-heading>\r\n\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">\r\n                  Signature\r\n        \r\n                  <button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.clearSignature()\">Clear</button>\r\n                </label>\r\n                <div class=\"col-sm-10\">\r\n                  <div class=\"signature-container\"></div>\r\n                </div>\r\n              </div>\r\n        </div>\r\n        <!-- Signature End -->\r\n\r\n      </uib-accordion>\r\n  <div class=\"col-md-12\">\r\n    \r\n\r\n  \r\n\r\n    \r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _canvasStuff = __webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleDpaController = function () {
	  SimpleDpaController.$inject = ["$state", "$stateParams", "loadingService", "contactService", "authService"];
	  function SimpleDpaController($state, $stateParams, loadingService, contactService, authService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SimpleDpaController);
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.loadingService = loadingService;
	    this.contactService = contactService;
	    this.authService = authService;
	
	    if (!$stateParams.contactId || !$stateParams.enquiryId) {
	      $state.go('welcomeCentre');
	    }
	
	    this.dpa = $stateParams.dpa;
	
	    this.errUpdateDpa = '';
	
	    //this.preventTabletScroll();
	    window.setTimeout(this.editImage, 10);
	  }
	
	  (0, _createClass3.default)(SimpleDpaController, [{
	    key: 'goBack',
	    value: function goBack() {
	      this.$state.go('enquiryEdit', { enquiryId: this.$stateParams.enquiryId });
	    }
	  }, {
	    key: 'editImage',
	    value: function editImage() {
	      var $container = $('.signature-container');
	      var width = $container.width();
	      var height = $container.height();
	
	      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + 'px" height="' + height + 'px" id="sig-canvas"></canvas><canvas width="' + width + 'px" height="' + height + 'px" style="display:none;" id="hidden-canvas"></canvas></div>');
	      $('.signature-container').empty().append($divCanvas);
	      (0, _canvasStuff.doMagic)(null, true);
	    }
	  }, {
	    key: 'clearSignature',
	    value: function clearSignature() {
	      (0, _canvasStuff.clearCanvas)(true);
	    }
	  }, {
	    key: 'confirmVerbalConsent',
	    value: function confirmVerbalConsent() {
	      if (this.dpa.verbalConsent) {
	        this.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');
	      }
	    }
	  }, {
	    key: 'checkOptions',
	    value: function checkOptions(val) {
	      this.dpa.viaEmail = val;
	      this.dpa.viaText = val;
	      this.dpa.viaPost = val;
	      this.dpa.viaPhone = val;
	    }
	  }, {
	    key: 'updateDpa',
	    value: function updateDpa() {
	      var ctrl = this;
	
	      if (!ctrl.validateDpa()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('dpa', 'Updating DPA ...');
	
	      ctrl.dpa.signData = (0, _canvasStuff.getCanvasData)();
	      ctrl.contactService.updateDpa(ctrl.authService.authData.currentLocation.key, ctrl.dpa).then(function (response) {
	        ctrl.loadingService.hideLoading('dpa');
	        ctrl.goBack();
	      });
	    }
	  }, {
	    key: 'validateDpa',
	    value: function validateDpa() {
	      this.errUpdateDpa = '';
	
	      if ((0, _canvasStuff.isCanvasEmpty)()) {
	        this.errUpdateDpa = 'Please sign the form before submitting';
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	  return SimpleDpaController;
	}();
	
	exports.default = SimpleDpaController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1389);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./simpleDpa.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./simpleDpa.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".simpleDpa{color:red}", ""]);
	
	// exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _allDpa = __webpack_require__(1391);
	
	var _allDpa2 = _interopRequireDefault(_allDpa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allDpaModule = _angular2.default.module('allDpa', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('allDpa', {
	    url: '/enquiry/contact/allDpa/:contactId',
	    component: 'allDpa',
	    params: {
	      enquiryId: null,
	      marketing: null
	    }
	  });
	}]).component('allDpa', _allDpa2.default).name;
	
	exports.default = allDpaModule;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _allDpa = __webpack_require__(1392);
	
	var _allDpa2 = _interopRequireDefault(_allDpa);
	
	var _allDpa3 = __webpack_require__(1393);
	
	var _allDpa4 = _interopRequireDefault(_allDpa3);
	
	__webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allDpaComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _allDpa2.default,
	  controller: _allDpa4.default
	};
	
	exports.default = allDpaComponent;

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-lg-9 col-md-7 mt-1-desktop-lg\">\r\n        <h1 class=\"dashboard-title\">Data Protection Authorsation</h1>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"errors-panel\" ng-show=\"$ctrl.errUpdateDpa !== ''\">    \r\n    <ul>\r\n        <li>{{$ctrl.errUpdateDpa}}</li>\r\n    </ul>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-2 col-xs-6\">\r\n        &nbsp;<br><br>\r\n    </div>\r\n    <div class=\"col-md-3 mt-2 col-xs-6\">\r\n      &nbsp;<br><br>\r\n    </div>\r\n\r\n    <div class=\"mt-1 col-md-7 col-xs-12 mb-tablet\">\r\n        <div class=\"pull-sm-right\">                \r\n            <div class=\"pull-right\">\r\n                <button type=\"button\" class=\"btn btn-warning mr-1\" ng-click=\"$ctrl.goBack()\">Go Back</button>\r\n                <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.updateDpa()\">Save Changes</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" block-ui=\"dpa\">\r\n    <uib-accordion close-others=\"true\">\r\n        <!-- Consent Begin -->\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n          <uib-accordion-heading>\r\n            Marketing Consent\r\n          </uib-accordion-heading>\r\n\r\n          <div class=\"dpaReasons\">\r\n              <p class=\"bold\">Marketing Consent</p>\r\n              <p>\r\n                We have exciting offers and news about our products and services that we hope you’d like to hear about. Your opinion is important to us and we may contact you to ensure you are satisfied with our services. We will treat your data with respect and store it safely in accordance with the current data protection regulations. We may share your data with Franchise partners  and affiliated companies to improve your experience.\r\n                <br /><br />\r\n                Please visit our website  for further details on our data protection policy, including how you may access and correct your personal data or withdraw consent to the collection, use or disclosure of your personal data\r\n              </p>\r\n            </div>\r\n\r\n          <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <div class=\"col-sm-offset-2 col-sm-10\">            \r\n                  <input type=\"checkbox\" id=\"chkVerbal\" ng-model=\"$ctrl.dpa.verbalConsent\" ng-change=\"$ctrl.confirmVerbalConsent()\"/>\r\n                  <label for=\"chkVerbal\">Verbal notification of Privacy Notice Given and Marketing Consent Received</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            \r\n            <div class=\"row\">\r\n              <div class=\"form-group\">\r\n                <div class=\"col-sm-offset-2 col-sm-10\">\r\n                  <a href=\"#\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.checkOptions(true)\">Select All</a>\r\n                  <a href=\"#\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.checkOptions(false)\">Deselect All</a>\r\n                </div>\r\n              </div>\r\n            </div>          \r\n      \r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <table class=\"table table-bordered table-hover table-striped\">\r\n                    <thead>\r\n                        <tr>\r\n                          <th class=\"col-md-4\">Reason</th>\r\n                          <th class=\"col-md-2\">Via Email</th>\r\n                          <th class=\"col-md-2\">Via Post</th>\r\n                          <th class=\"col-md-2\">Via Text</th>\r\n                          <th class=\"col-md-2\">Via Phone</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                      <tr>\r\n                        <td class=\"col-md-4\">Marketing - New Products, Services and Events</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.marketing_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.marketing_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.marketing_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.marketing_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Service -  Vehicle All service related contact - service reminders  on known vehicles</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.service_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.service_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.service_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.service_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Manufacturer based  contacts - as per manufactures</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.manufacturer_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.manufacturer_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.manufacturer_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.manufacturer_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Surveys - Sales and Aftersales based customer surveys</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.surveys_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.surveys_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.surveys_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.surveys_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                      <tr>\r\n                        <td class=\"col-md-4\">Change Cycle</td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.changeCycle_Email\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.changeCycle_Post\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.changeCycle_Text\"></switch></td>\r\n                        <td class=\"col-md-2\"><switch ng-model=\"$ctrl.dpa.changeCycle_Phone\"></switch></td>\r\n                      </tr>\r\n      \r\n                    </tbody>\r\n                </table>\r\n              </div>\r\n            </div>\r\n        </div>\r\n        <!-- Consent End -->\r\n\r\n        <!-- Signature Begin -->\r\n        <div uib-accordion-group class=\"panel-default\">\r\n          <uib-accordion-heading>\r\n            Signature\r\n          </uib-accordion-heading>\r\n\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">\r\n                  Signature\r\n        \r\n                  <button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.clearSignature()\">Clear</button>\r\n                </label>\r\n                <div class=\"col-sm-10\">\r\n                  <div class=\"signature-container\"></div>\r\n                </div>\r\n              </div>\r\n        </div>\r\n        <!-- Signature End -->\r\n\r\n      </uib-accordion>\r\n  <div class=\"col-md-12\">\r\n    \r\n\r\n  \r\n\r\n    \r\n\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _canvasStuff = __webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllDpaController = function () {
	  AllDpaController.$inject = ["$state", "$stateParams", "loadingService", "contactService", "authService"];
	  function AllDpaController($state, $stateParams, loadingService, contactService, authService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AllDpaController);
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.loadingService = loadingService;
	    this.contactService = contactService;
	    this.authService = authService;
	
	    if (!$stateParams.contactId || !$stateParams.enquiryId) {
	      $state.go('welcomeCentre');
	    }
	
	    this.dpa = {
	      contactId: $stateParams.contactId,
	      marketing_Email: $stateParams.marketing.email,
	      marketing_Post: $stateParams.marketing.post,
	      marketing_Text: $stateParams.marketing.text,
	      marketing_Phone: $stateParams.marketing.phone
	    };
	
	    this.errUpdateDpa = '';
	    window.setTimeout(this.editImage, 10);
	  }
	
	  (0, _createClass3.default)(AllDpaController, [{
	    key: 'goBack',
	    value: function goBack() {
	      this.$state.go('enquiryEdit', { enquiryId: this.$stateParams.enquiryId });
	    }
	  }, {
	    key: 'editImage',
	    value: function editImage() {
	      var $container = $('.signature-container');
	      var width = $container.width();
	      var height = $container.height();
	
	      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + 'px" height="' + height + 'px" id="sig-canvas"></canvas><canvas width="' + width + 'px" height="' + height + 'px" style="display:none;" id="hidden-canvas"></canvas></div>');
	      $('.signature-container').empty().append($divCanvas);
	      (0, _canvasStuff.doMagic)(null, true);
	    }
	  }, {
	    key: 'clearSignature',
	    value: function clearSignature() {
	      (0, _canvasStuff.clearCanvas)(true);
	    }
	  }, {
	    key: 'confirmVerbalConsent',
	    value: function confirmVerbalConsent() {
	      if (this.dpa.verbalConsent) {
	        this.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');
	      }
	    }
	  }, {
	    key: 'checkOptions',
	    value: function checkOptions(val) {
	      this.dpa.marketing_Email = val;
	      this.dpa.marketing_Text = val;
	      this.dpa.marketing_Post = val;
	      this.dpa.marketing_Phone = val;
	
	      this.dpa.service_Email = val;
	      this.dpa.service_Text = val;
	      this.dpa.service_Post = val;
	      this.dpa.service_Phone = val;
	
	      this.dpa.manufacturer_Email = val;
	      this.dpa.manufacturer_Text = val;
	      this.dpa.manufacturer_Post = val;
	      this.dpa.manufacturer_Phone = val;
	
	      this.dpa.surveys_Email = val;
	      this.dpa.surveys_Text = val;
	      this.dpa.surveys_Post = val;
	      this.dpa.surveys_Phone = val;
	
	      this.dpa.changeCycle_Email = val;
	      this.dpa.changeCycle_Text = val;
	      this.dpa.changeCycle_Post = val;
	      this.dpa.changeCycle_Phone = val;
	    }
	  }, {
	    key: 'updateDpa',
	    value: function updateDpa() {
	      var ctrl = this;
	
	      if (!ctrl.validateDpa()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('dpa', 'Updating DPA ...');
	
	      ctrl.dpa.signData = (0, _canvasStuff.getCanvasData)();
	      ctrl.contactService.updateAllDpa(ctrl.authService.authData.currentLocation.key, ctrl.dpa).then(function (response) {
	        ctrl.loadingService.hideLoading('dpa');
	        ctrl.goBack();
	      });
	    }
	  }, {
	    key: 'validateDpa',
	    value: function validateDpa() {
	      this.errUpdateDpa = '';
	
	      if ((0, _canvasStuff.isCanvasEmpty)()) {
	        this.errUpdateDpa = 'Please sign the form before submitting';
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	  return AllDpaController;
	}();
	
	exports.default = AllDpaController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1395);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./allDpa.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./allDpa.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".allDpa{color:red}", ""]);
	
	// exports


/***/ }),
/* 1396 */,
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryTimeline = __webpack_require__(1398);
	
	var _enquiryTimeline2 = _interopRequireDefault(_enquiryTimeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTimelineModule = _angular2.default.module('enquiryTimeline', [_angularUiRouter2.default]).component('enquiryTimeline', _enquiryTimeline2.default).name;
	
	exports.default = enquiryTimelineModule;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryTimeline = __webpack_require__(1399);
	
	var _enquiryTimeline2 = _interopRequireDefault(_enquiryTimeline);
	
	var _enquiryTimeline3 = __webpack_require__(1400);
	
	var _enquiryTimeline4 = _interopRequireDefault(_enquiryTimeline3);
	
	__webpack_require__(1401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryTimelineComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '='
	  },
	  template: _enquiryTimeline2.default,
	  controller: _enquiryTimeline4.default
	};
	
	exports.default = enquiryTimelineComponent;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-hover\">\r\n  <thead>\r\n      <tr>\r\n          <th class=\"col-md-3\">Event</th>\r\n          <th class=\"col-md-3\">Date Time</th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr>\r\n        <td class=\"col-md-3\">Created</td>\r\n        <td class=\"col-md-2\">{{$ctrl.enquiry.created | date : 'dd MMM yyyy HH:mm'}}</td>\r\n      </tr>\r\n\r\n      <tr>\r\n        <td class=\"col-md-3\">Last Follow up Email</td>\r\n        <td class=\"col-md-2\">{{$ctrl.enquiry.lastFollowUpEmail | date : 'dd MMM yyyy HH:mm'}}</td>\r\n      </tr>\r\n\r\n      <tr>\r\n        <td class=\"col-md-3\">Confirmed/Lost</td>\r\n        <td class=\"col-md-2\">{{$ctrl.enquiry.confirmed | date : 'dd MMM yyyy HH:mm'}}</td>\r\n      </tr>      \r\n\r\n      <tr>\r\n        <td class=\"col-md-3\">Delivery</td>\r\n        <td class=\"col-md-2\">{{$ctrl.enquiry.deliveryDate | date : 'dd MMM yyyy'}}</td>\r\n      </tr>            \r\n\r\n      <tr>\r\n        <td class=\"col-md-3\">Closed</td>\r\n        <td class=\"col-md-2\">{{$ctrl.enquiry.closed | date : 'dd MMM yyyy HH:mm'}}</td>\r\n      </tr>                  \r\n  </tbody>\r\n</table>"

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryTimelineController = function EnquiryTimelineController() {
	  (0, _classCallCheck3.default)(this, EnquiryTimelineController);
	
	  this.name = 'enquiryTimeline';
	};
	
	exports.default = EnquiryTimelineController;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1402);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTimeline.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryTimeline.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryTimeline{color:red}", ""]);
	
	// exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryQuotes = __webpack_require__(1404);
	
	var _enquiryQuotes2 = _interopRequireDefault(_enquiryQuotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryQuotesModule = _angular2.default.module('enquiryQuotes', [_angularUiRouter2.default]).component('enquiryQuotes', _enquiryQuotes2.default).name;
	
	exports.default = enquiryQuotesModule;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryQuotes = __webpack_require__(1405);
	
	var _enquiryQuotes2 = _interopRequireDefault(_enquiryQuotes);
	
	var _enquiryQuotes3 = __webpack_require__(1406);
	
	var _enquiryQuotes4 = _interopRequireDefault(_enquiryQuotes3);
	
	__webpack_require__(1407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryQuotesComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '='
	  },
	  template: _enquiryQuotes2.default,
	  controller: _enquiryQuotes4.default
	};
	
	exports.default = enquiryQuotesComponent;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"enquiryQuotesList\">\r\n  <a type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.printHtml()\">\r\n    <i class=\"fa fa-print\"></i>\r\n    Print Quotation\r\n  </a>  \r\n\r\n  <a type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.printPdf()\">\r\n    <i class=\"fa fa-file-pdf-o\"></i>\r\n    Print And Save Pdf\r\n  </a>    \r\n\r\n  <a type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.showEmailPdf()\">\r\n    <i class=\"fa fa-envelope-o\"></i>\r\n    Save And Email Quotation\r\n  </a>\r\n\r\n  <br /><br />\r\n\r\n  <table class=\"table table-striped table-bordered table-hover\">\r\n      <tr>\r\n          <th class=\"col-md-3\">Saved by</th>\r\n          <th class=\"col-md-3\">Date Time</th>\r\n          <th class=\"col-md-3\">Action</th>\r\n          <th class=\"col-md-3\">View</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr ng-repeat=\"eq in $ctrl.enquiry.enquiryQuotes\">\r\n            <td class=\"col-md-3\">{{eq.userName}}</td>\r\n            <td class=\"col-md-3\">{{eq.created | date : 'dd MMM yy HH:mm'}}</td>\r\n            <td class=\"col-md-3\">{{eq.action}}</td>\r\n            <td class=\"col-md-3\"><a ng-click=\"$ctrl.viewSavedQuotation(eq.enquiryQuoteId)\" href=\"#\">View Quotation</a></td>\r\n        </tr>\r\n      </tbody>\r\n  </table>  \r\n</div>\r\n"

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryQuotesController = function () {
	  EnquiryQuotesController.$inject = ["authService", "printService", "$ngConfirm", "loadingService", "fileService", "growl", "contactService"];
	  function EnquiryQuotesController(authService, printService, $ngConfirm, loadingService, fileService, growl, contactService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryQuotesController);
	    this.authService = authService;
	    this.printService = printService;
	    this.$ngConfirm = $ngConfirm;
	    this.loadingService = loadingService;
	    this.fileService = fileService;
	    this.growl = growl;
	    this.contactService = contactService;
	  }
	
	  (0, _createClass3.default)(EnquiryQuotesController, [{
	    key: 'checkCanQuote',
	    value: function checkCanQuote() {
	      var canQuote = false;
	
	      if (this.enquiry.enquiryVehicles.length) {
	        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	          return o.isSelected;
	        }).vehicle;
	
	        canQuote = vehicle.price && vehicle.price >= 0;
	      }
	
	      if (!canQuote) {
	        this.$ngConfirm({
	          title: 'ERROR',
	          content: 'Cannot quote. Please select a vehicle with a retail price',
	          type: 'red',
	          typeAnimation: false,
	          columnClass: 'm',
	          buttons: {
	            tryAgain: {
	              text: 'Close',
	              btnClass: 'btn-danger'
	            }
	          }
	        });
	      }
	
	      return canQuote;
	    }
	  }, {
	    key: 'printHtml',
	    value: function printHtml() {
	      if (!this.checkCanQuote()) {
	        return;
	      } else {
	        this.printService.printQuotation(this.enquiry.enquiryId);
	      }
	    }
	  }, {
	    key: 'printPdf',
	    value: function printPdf() {
	      var _this = this;
	
	      if (!this.checkCanQuote()) {
	        return;
	      } else {
	        this.loadingService.showLoading('enquiryQuotesList', 'Saving Quotation ...');
	
	        this.printService.saveQuotation(this.enquiry.enquiryId, this.authService.authData.userId).then(function (response) {
	          _this.enquiry.enquiryQuotes = response.data.data;
	
	          _this.viewSavedQuotation(_this.enquiry.enquiryQuotes[0].enquiryQuoteId);
	        }).catch(function (err) {}).finally(function () {
	          _this.loadingService.hideLoading('enquiryQuotesList');
	        });
	      }
	    }
	  }, {
	    key: 'showEmailPdf',
	    value: function showEmailPdf() {
	      if (!this.checkCanQuote()) {
	        return;
	      }
	      if (!this.enquiry.contactHasEmail) {
	        this.$ngConfirm({
	          title: 'ERROR',
	          content: 'Cannot Email Quote. Contact does not have an email set',
	          type: 'red',
	          typeAnimation: false,
	          columnClass: 'm',
	          buttons: {
	            tryAgain: {
	              text: 'Close',
	              btnClass: 'btn-danger'
	            }
	          }
	        });
	
	        return;
	      } else {
	        this.$ngConfirm({
	          title: 'Confirm',
	          content: 'Are you sure you want to email quote to the contact ?',
	          typeAnimation: false,
	          columnClass: 'm',
	          buttons: {
	            yes: {
	              text: 'Email Quote',
	              btnClass: 'btn-primary',
	              action: this.emailPdf.bind(this)
	            },
	            no: {
	              text: 'Cancel',
	              btnClass: 'btn-default'
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'emailPdf',
	    value: function emailPdf() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('enquiryQuotesList', 'Emailing Quotation ...');
	
	      this.printService.emailQuotation(this.enquiry.enquiryId, this.authService.authData.userId).then(function (response) {
	        _this2.enquiry.enquiryQuotes = response.data.data;
	
	        _this2.growl.success('Quotation emailed successfully', { ttl: 5000 });
	      }).catch(function (err) {}).finally(function () {
	        _this2.loadingService.hideLoading('enquiryQuotesList');
	      });
	    }
	  }, {
	    key: 'viewSavedQuotation',
	    value: function viewSavedQuotation(enquiryQuoteId) {
	      this.fileService.getQuotation(enquiryQuoteId);
	    }
	  }]);
	  return EnquiryQuotesController;
	}();
	
	exports.default = EnquiryQuotesController;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1408);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryQuotes.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./enquiryQuotes.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryQuotes{color:red}", ""]);
	
	// exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _customForms = __webpack_require__(1410);
	
	var _customForms2 = _interopRequireDefault(_customForms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customFormsModule = _angular2.default.module('customForms', [_angularUiRouter2.default]).component('customForms', _customForms2.default).name;
	
	exports.default = customFormsModule;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _customForms = __webpack_require__(1411);
	
	var _customForms2 = _interopRequireDefault(_customForms);
	
	var _customForms3 = __webpack_require__(1412);
	
	var _customForms4 = _interopRequireDefault(_customForms3);
	
	__webpack_require__(1413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customFormsComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '='
	  },
	  template: _customForms2.default,
	  controller: _customForms4.default
	};
	
	exports.default = customFormsComponent;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-hover\">\r\n  <thead>\r\n      <tr>\r\n          <th>Form</th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr ng-repeat=\"cf in $ctrl.customForms\">\r\n        <td><a href=\"#\" ng-click=\"$ctrl.action(cf.action)\" ng-show=\"$ctrl.show(cf.condition)\">{{cf.name}}</td>\r\n      </tr>\r\n  </tbody>\r\n</table>"

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomFormsController = function () {
	  CustomFormsController.$inject = ["authService", "printService", "lookupService", "$scope", "enums"];
	  function CustomFormsController(authService, printService, lookupService, $scope, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CustomFormsController);
	    this.authService = authService;
	    this.printService = printService;
	    this.lookupService = lookupService;
	    this.$scope = $scope;
	    this.enums = enums;
	
	    this.authService.getLocationExtendedProperties('customForms');
	
	    this.loadAllBrands();
	
	    this.customForms = [];
	
	    this.$scope.$on('enquiry:initialized', this.selectCustomForms.bind(this));
	  }
	
	  (0, _createClass3.default)(CustomFormsController, [{
	    key: 'loadAllBrands',
	    value: function loadAllBrands() {
	      var _this = this;
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        _this.brands = brands;
	      });
	    }
	  }, {
	    key: 'selectCustomForms',
	    value: function selectCustomForms() {
	      var _this2 = this;
	
	      this.customForms = (0, _lodash.filter)(this.authService.authData.currentLocation.customForms, function (o) {
	        return _this2.show(o.condition);
	      });
	    }
	  }, {
	    key: 'action',
	    value: function action(actionName) {
	      if (actionName === 'viewDns') {
	        this.viewDns();
	      } else if (actionName === 'viewMercPerOwnedWarranty') {
	        this.viewMercPerOwnedWarranty();
	      } else if (actionName === 'viewMercSPA') {
	        this.viewMercSPA();
	      } else if (actionName === 'viewMercPreOwnedSPA') {
	        this.viewMercPreOwnedSPA();
	      } else if (actionName === 'viewMercDPA') {
	        this.viewMercDPA();
	      } else if (actionName === 'viewMSLPreOwnedDPA') {
	        this.viewMSLPreOwnedDPA();
	      } else if (actionName === 'viewMazdaDPA') {
	        this.viewMazdaDPA();
	      } else if (actionName === 'viewSkodaDPA') {
	        this.viewSkodaDPA();
	      } else if (actionName === 'viewRf105Form') {
	        this.viewRf105Form();
	      } else if (actionName === 'viewRf105TradeForm') {
	        this.viewRf105TradeForm();
	      } else if (actionName === 'viewMslBydDpa') {
	        this.viewMslBydDpa();
	      } else if (actionName === 'viewOrderConfirmation') {
	        this.viewOrderConfirmation();
	      } else if (actionName === 'viewCunninghamOrderForm') {
	        this.viewCunninghamOrderForm();
	      } else if (actionName === 'viewDistanceSellingAddendum') {
	        this.viewDistanceSellingAddendum();
	      } else if (actionName === 'viewMSL_PCP') {
	        this.viewMSL_PCP();
	      } else if (actionName === 'viewMslPreOwnedWarrantyAgreement') {
	        this.viewMslPreOwnedWarrantyAgreement();
	      } else if (actionName === 'viewMslXpengDpa') {
	        this.viewMslXpengDpa();
	      } else if (actionName === 'viewSuzukiDataForm') {
	        this.viewSuzukiDataForm();
	      } else if (actionName === 'viewLyonsPrepWorkForm') {
	        this.viewLyonsPrepWorkForm();
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show(condition) {
	      if (condition === 'showDns') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      } else if (condition === 'showMercPerOwnedWarranty') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('Used');
	      } else if (condition === 'showMercSPA' || condition === 'showMercDPA') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('New');
	      } else if (condition === 'showMercPreOwnedSPA') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('Used');
	      } else if (condition === 'showMSLPreOwnedDPA') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasCondition('Used');
	      } else if (condition === 'showMslBydDpa') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('BYD') && this.vehicleHasCondition('New');
	      } else if (condition === 'showMazdaDPA') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Mazda') && this.vehicleHasCondition('New');
	      } else if (condition === 'showSkodaDPA') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Skoda') && this.vehicleHasCondition('New');
	      } else if (condition === 'showRf105Form') {
	        return !this.forTrader() && this.enquiry.tradeInVehicles.length > 0;
	      } else if (condition === 'showRf105TradeForm') {
	        return this.forTrader();
	      } else if (condition === 'showOrderConfirmation') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      } else if (condition === 'showCunninghamOrderForm') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      } else if (condition === 'showDistanceSellingAddendum') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      } else if (condition === 'showMSL_PCP') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      } else if (condition === 'showMslPreOwnedWarrantyAgreement') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasCondition('Used');
	      } else if (condition === 'showMslXpengDpa') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Xpeng') && this.vehicleHasCondition('New');
	      } else if (condition === 'showSuzukiDataForm') {
	        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Suzuki');
	      } else if (condition === 'showLyonsPrepWorkForm') {
	        return !this.forTrader() && this.isRetailEnquiry();
	      }
	
	      return true;
	    }
	  }, {
	    key: 'isRetailEnquiry',
	    value: function isRetailEnquiry() {
	      return this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.New || this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.Used;
	    }
	  }, {
	    key: 'forTrader',
	    value: function forTrader() {
	      return this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader;
	    }
	  }, {
	    key: 'vehicleHasBrand',
	    value: function vehicleHasBrand(brand) {
	      if (!this.brands) {
	        return false;
	      }
	
	      var brancToCheck = (0, _lodash.find)(this.brands, function (b) {
	        return b.name.toLowerCase() === brand.toLowerCase();
	      });
	
	      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	
	      if (!selectedVehicle) {
	        return false;
	      } else {
	        return selectedVehicle.vehicle.brandId === brancToCheck.brandId;
	      }
	    }
	  }, {
	    key: 'vehicleHasCondition',
	    value: function vehicleHasCondition(condition) {
	      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
	        return o.isSelected;
	      });
	
	      if (!selectedVehicle || !selectedVehicle.vehicle) {
	        return false;
	      } else {
	        return selectedVehicle.vehicle.condition === condition;
	      }
	    }
	  }, {
	    key: 'viewDns',
	    value: function viewDns() {
	      this.printService.printMSL_DNS_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMercPerOwnedWarranty',
	    value: function viewMercPerOwnedWarranty() {
	      this.printService.printMercUsedWarranty_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMercSPA',
	    value: function viewMercSPA() {
	      this.printService.printMercSPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMercPreOwnedSPA',
	    value: function viewMercPreOwnedSPA() {
	      this.printService.printMercUsedSPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMercDPA',
	    value: function viewMercDPA() {
	      this.printService.printMercDPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMSLPreOwnedDPA',
	    value: function viewMSLPreOwnedDPA() {
	      this.printService.printMslUsedDPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMazdaDPA',
	    value: function viewMazdaDPA() {
	      this.printService.printMazdaDPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewSkodaDPA',
	    value: function viewSkodaDPA() {
	      this.printService.printSkodaDPA_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewRf105Form',
	    value: function viewRf105Form() {
	      this.printService.printRf105Form_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewRf105TradeForm',
	    value: function viewRf105TradeForm() {
	      this.printService.printRf105TradeForm_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMslBydDpa',
	    value: function viewMslBydDpa() {
	      this.printService.printMslBydDpa_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewOrderConfirmation',
	    value: function viewOrderConfirmation() {
	      this.printService.printOrderConfirmation_Customer(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewCunninghamOrderForm',
	    value: function viewCunninghamOrderForm() {
	      this.printService.printCunninghamOrderForm_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewDistanceSellingAddendum',
	    value: function viewDistanceSellingAddendum() {
	      this.printService.printDistanceSellingAddendum_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewDistanceSellingAddendum',
	    value: function viewDistanceSellingAddendum() {
	      this.printService.printDistanceSellingAddendum_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMSL_PCP',
	    value: function viewMSL_PCP() {
	      this.printService.printMSL_PCP_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMslPreOwnedWarrantyAgreement',
	    value: function viewMslPreOwnedWarrantyAgreement() {
	      this.printService.printMslPreOwnedWarrantyAgreement(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewMslXpengDpa',
	    value: function viewMslXpengDpa() {
	      this.printService.printMslXpengDpa_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewSuzukiDataForm',
	    value: function viewSuzukiDataForm() {
	      this.printService.printSuzukiDataForm_CustomForm(this.enquiry.enquiryId);
	    }
	  }, {
	    key: 'viewLyonsPrepWorkForm',
	    value: function viewLyonsPrepWorkForm() {
	      this.printService.printLyonsPrepWorkForm_CustomForm(this.enquiry.enquiryId);
	    }
	  }]);
	  return CustomFormsController;
	}();
	
	exports.default = CustomFormsController;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1414);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./customForms.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./customForms.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".customForms{color:red}", ""]);
	
	// exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryList = __webpack_require__(1416);
	
	var _enquiryList2 = _interopRequireDefault(_enquiryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryListModule = _angular2.default.module('enquiryList', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquiryList', {
	    url: '/enquiry/list',
	    component: 'enquiryList',
	    params: {
	      vehicleConditionSearch: null
	    }
	  });
	}]).component('enquiryList', _enquiryList2.default).name;
	
	exports.default = enquiryListModule;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryList = __webpack_require__(1417);
	
	var _enquiryList2 = _interopRequireDefault(_enquiryList);
	
	var _enquiryList3 = __webpack_require__(1418);
	
	var _enquiryList4 = _interopRequireDefault(_enquiryList3);
	
	__webpack_require__(1419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiryList2.default,
	  controller: _enquiryList4.default
	};
	
	exports.default = enquiryListComponent;

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"enquiryListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n          <h2>Enquiry List</h2>\r\n        </header>\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Subject\"\r\n              ng-model=\"$ctrl.filterParams.subject\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Contact Name\"\r\n              ng-model=\"$ctrl.filterParams.contactName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Owner Name\"\r\n              ng-model=\"$ctrl.filterParams.ownerName\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"r.id as r.name for r in $ctrl.selectOptions.enquiryState\"\r\n              ng-model=\"$ctrl.filterParams.status\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listEnquiries()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('subject')\">\r\n                      Subject <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contactName')\">\r\n                      Contact Name <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('created')\">\r\n                      Created <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('lastModified')\">\r\n                      Last Modified <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('ownerName')\">\r\n                      Owner <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('status')\">\r\n                      Status <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"e in $ctrl.enquiries\">\r\n                    <td class=\"col-md-2\">{{ e.subject }}</td>\r\n                    <td class=\"col-md-2\">\r\n                      <a ui-sref=\"contactView({contactId: e.contactId})\">\r\n                      {{ e.contactName }}\r\n                      </a>\r\n                    </td>\r\n                    <td class=\"col-md-2\">{{ e.created | date : 'dd-MMMM-yyyy HH:mm' }}</td>\r\n                    <td class=\"col-md-2\">{{ e.lastModified | date : 'dd-MMMM-yyyy HH:mm' }}</td>\r\n                    <td class=\"col-md-2\">{{ e.ownerName }}</td>\r\n                    <td class=\"col-md-1\">{{ e.statusName }}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <button class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: e.enquiryId})\"\r\n                        ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.Edit, false)\r\n                        && (e.status === $ctrl.enums.ENQUIRY_STATE.Open || e.status === $ctrl.enums.ENQUIRY_STATE.Confirmed)\">\r\n                          Edit\r\n                      </button>\r\n\r\n                      <button class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: e.enquiryId})\"\r\n                        ng-if=\"$ctrl.authService.checkFeatureAccess('Enquiry', $ctrl.enums.PERMISSION_TYPE.View, false)\r\n                        && (e.status === $ctrl.enums.ENQUIRY_STATE.Lost || e.status === $ctrl.enums.ENQUIRY_STATE.Closed)\">\r\n                          View\r\n                      </button>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.enquiries.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listEnquiries()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryListController = function () {
	  EnquiryListController.$inject = ["authService", "enquiryService", "loadingService", "lookupService", "enums", "$window"];
	  function EnquiryListController(authService, enquiryService, loadingService, lookupService, enums, $window) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryListController);
	    if (!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.enquiryService = enquiryService;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.enums = enums;
	    this.$window = $window;
	
	    this.selectOptions = {};
	    this.filterParams = {};
	
	    this.initializeEnums();
	  }
	
	  (0, _createClass3.default)(EnquiryListController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'ENQUIRY_STATE', propName: 'enquiryState', defaultOption: true, defaultOptionText: 'All States' }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption, item.defaultOptionText);
	        ctrl.selectOptions[item.propName] = enumsArray;
	      });
	
	      this.reset();
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption, defaultOptionText) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: defaultOptionText || 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.subject = '';
	      this.filterParams.contactName = '';
	      this.filterParams.ownerName = '';
	      this.filterParams.status = null;
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'lastModified',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listEnquiries();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listEnquiries();
	    }
	  }, {
	    key: 'listEnquiries',
	    value: function listEnquiries() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('enquiryListing', 'Loading Enquiries ...');
	
	      ctrl.enquiryService.listEnquiries(ctrl.filterParams).then(function (response) {
	        ctrl.enquiries = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' enquiries'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiryListing');
	      });
	    }
	  }, {
	    key: 'deleteContact',
	    value: function deleteContact(contactId) {
	      var _this = this;
	
	      var ctrl = this;
	      var sure = void 0,
	          state = void 0;
	
	      sure = this.$window.confirm('Are you sure you want to delete this Contact ?');
	
	      if (!sure) {
	        return;
	      }
	
	      this.loadingService.showLoading('contactListing', 'Removing Contact ...');
	
	      ctrl.contactService.updateContactState(this.authService.authData.currentLocation.key, contactId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
	        ctrl.listContacts();
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg:  true ? err.data : err.data.messageDetail
	        };
	      }).finally(function () {
	        _this.loadingService.hideLoading('contactListing');
	      });
	    }
	  }]);
	  return EnquiryListController;
	}();
	
	exports.default = EnquiryListController;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1420);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryService = function () {
	  EnquiryService.$inject = ["$http", "appConfig"];
	  function EnquiryService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(EnquiryService, [{
	    key: 'getEnquiry',
	    value: function getEnquiry(entityId, contactId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/get/' + entityId + '/' + contactId));
	    }
	  }, {
	    key: 'updateOwner',
	    value: function updateOwner(enquiryId, ownerId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/updateOwner/' + enquiryId + '/' + ownerId));
	    }
	  }, {
	    key: 'editEnquiry',
	    value: function editEnquiry(enquiry) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/edit', enquiry);
	    }
	  }, {
	    key: 'canConfirmEnquiry',
	    value: function canConfirmEnquiry(enquiry) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/canconfirm', enquiry);
	    }
	  }, {
	    key: 'listEnquiries',
	    value: function listEnquiries(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&entityId=' + filterParams.entityId;
	
	      if (filterParams.subject) {
	        query += '&subject=' + filterParams.subject;
	      }
	
	      if (filterParams.contactName) {
	        query += '&contactName=' + filterParams.contactName;
	      }
	
	      if (filterParams.ownerName) {
	        query += '&ownerName=' + filterParams.ownerName;
	      }
	
	      if (filterParams.status) {
	        query += '&enquiryState=' + filterParams.status;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/enquiry/list' + query);
	    }
	  }, {
	    key: 'updateContactState',
	    value: function updateContactState(entityId, contactId, state) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/update/' + entityId + '/' + contactId + '/' + state));
	    }
	  }, {
	    key: 'duplicate',
	    value: function duplicate(enquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/duplicate/' + enquiryId));
	    }
	  }, {
	    key: 'notifyFinance',
	    value: function notifyFinance(enquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/notifyFinance/' + enquiryId));
	    }
	  }, {
	    key: 'addShowroomEntry',
	    value: function addShowroomEntry(entry) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/addshowroomentry', entry);
	    }
	  }, {
	    key: 'removeTradeIn',
	    value: function removeTradeIn(enquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/removetradein/' + enquiryId));
	    }
	  }, {
	    key: 'addExistingTradeIn',
	    value: function addExistingTradeIn(currentEnquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/addexistingtradein/' + currentEnquiryId));
	    }
	  }, {
	    key: 'closeLinkedEnquiries',
	    value: function closeLinkedEnquiries(enquiryIds) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/closeLinkedEnquiries/?enquiryIds=' + enquiryIds));
	    }
	  }, {
	    key: 'sendWebLeadFollowUpEmail',
	    value: function sendWebLeadFollowUpEmail(data) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/sendwebleadfollowupemail/', data);
	    }
	  }, {
	    key: 'addPayment',
	    value: function addPayment(enquiryId, payment) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/enquiry/addpayment/' + enquiryId), payment);
	    }
	  }, {
	    key: 'editPayment',
	    value: function editPayment(payment) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/editpayment/', payment);
	    }
	  }, {
	    key: 'deletePayment',
	    value: function deletePayment(enquiryPaymentId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/deletepayment/' + enquiryPaymentId));
	    }
	  }]);
	  return EnquiryService;
	}();
	
	exports.default = EnquiryService;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _welcomeCentre = __webpack_require__(1423);
	
	var _welcomeCentre2 = _interopRequireDefault(_welcomeCentre);
	
	var _progressBar = __webpack_require__(1431);
	
	var _progressBar2 = _interopRequireDefault(_progressBar);
	
	var _welcomeCentre3 = __webpack_require__(1436);
	
	var _welcomeCentre4 = _interopRequireDefault(_welcomeCentre3);
	
	var _pendingEnquiry = __webpack_require__(1437);
	
	var _pendingEnquiry2 = _interopRequireDefault(_pendingEnquiry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var welcomeCentreModule = _angular2.default.module('welcomeCentre', [_angularUiRouter2.default, _progressBar2.default, _pendingEnquiry2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('welcomeCentre', {
	    url: '/welcomeCentre',
	    component: 'welcomeCentre',
	    params: {
	      enquiry: null
	    }
	  });
	}]).component('welcomeCentre', _welcomeCentre2.default).service('welcomeCentreService', _welcomeCentre4.default).name;
	
	exports.default = welcomeCentreModule;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _welcomeCentre = __webpack_require__(1424);
	
	var _welcomeCentre2 = _interopRequireDefault(_welcomeCentre);
	
	var _welcomeCentre3 = __webpack_require__(1425);
	
	var _welcomeCentre4 = _interopRequireDefault(_welcomeCentre3);
	
	__webpack_require__(1429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var welcomeCentreComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _welcomeCentre2.default,
	  controller: _welcomeCentre4.default
	};
	
	exports.default = welcomeCentreComponent;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-lg-9 col-md-7 mt-1-desktop-lg\">\r\n        <h1 class=\"dashboard-title\">{{$ctrl.authService.authData.currentLocation.value}} Welcome Centre</h1>\r\n    </div>\r\n    <div class=\"col-lg-3 col-md-5\">\r\n    </div>\r\n</div>\r\n\r\n<!-- DPA Warning Basic -->\r\n<div class=\"alert alert-warning\" ng-show=\"!$ctrl.authService.authData.currentLocation.defaultLocation\">\r\n    <h2>Warning</h2>\r\n    You are currently creating an enquiry under a location which is not set as your default location.\r\n    <br />\r\n    <b>Click <a href=\"#\" ng-click=\"$ctrl.loadDefaultLocation()\">here</a> to load your default location.</b>\r\n</div>\r\n\r\n<div class=\"errors-panel\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n    <h4 ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n      Please Correct the following errors before proceeding\r\n    </h4>\r\n    <ul class=\"errors\">\r\n        <li ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">{{msg}}</li>\r\n    </ul>\r\n</div>\r\n<hr class=\"dashboard-seperator\">\r\n<div class=\"row\" stickyX offset=\"50\">\r\n    <div class=\"col-md-2 col-xs-6\">\r\n        &nbsp;<br><br>\r\n    </div>\r\n    <div class=\"col-md-3 mt-2 col-xs-6\">\r\n      &nbsp;<br><br>\r\n    </div>\r\n\r\n    <div class=\"mt-1 col-md-7 col-xs-12 mb-tablet\">\r\n        <div class=\"pull-sm-right\">\r\n                <button type=\"button\" class=\"btn btn-outline mr-1 pull-left\" ng-click=\"$ctrl.showSendMessage()\" ng-show=\"$ctrl.isReceptionist\"><i class=\"comment-icon\"></i> Send Message</button>\r\n            <div class=\"pull-right\">\r\n                <button type=\"button\" class=\"btn btn-danger mr-1\" ng-click=\"$ctrl.reset()\">Reset</button>\r\n                <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.editEnquiry()\">Save Changes</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" block-ui=\"editEnquiry\">\r\n  <div ng-class=\"{'col-md-12': !$ctrl.isReceptionist, 'col-md-9': $ctrl.isReceptionist}\">\r\n    <table class=\"table dashboard-welcome-table table-responsive\">\r\n        <tbody>\r\n            <tr>\r\n                <td>Enquiry Type</td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_type\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_TYPE.Sales\" ng-model=\"$ctrl.enquiry.enquiryType\" ng-click=\"$ctrl.updateUserMatrix()\">\r\n                        <span class=\"btn btn-outline\">Sales</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_type\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_TYPE.Aftersales\" ng-model=\"$ctrl.enquiry.enquiryType\" ng-click=\"$ctrl.updateUserMatrix()\">\r\n                        <span class=\"btn btn-outline\">Aftersales</span>\r\n                    </label>\r\n                </td>\r\n                <td colspan=\"3\">&nbsp;</td>\r\n            </tr>\r\n            <tr>\r\n                <td>Trade / Retail</td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_contact\" class=\"hidden\" ng-value=\"{{$ctrl.enums.ENQUIRY_CONTACT.Trade}}\" ng-model=\"$ctrl.enquiry.enquiryContact\">\r\n                        <span class=\"btn btn-outline\">Trade</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_contact\" class=\"hidden\" ng-value=\"{{$ctrl.enums.ENQUIRY_CONTACT.Retail}}\" ng-model=\"$ctrl.enquiry.enquiryContact\">\r\n                        <span class=\"btn btn-outline\">Retail</span>\r\n                    </label>\r\n                </td>\r\n                <td colspan=\"3\">&nbsp;</td>\r\n            </tr>\r\n            <tr ng-if=\"$ctrl.enquiry.enquiryType === $ctrl.enums.ENQUIRY_TYPE.Sales\">\r\n                <td>Enquiry Subtype</td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"{{$ctrl.enums.ENQUIRY_SUBTYPE.New}}\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">New</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.Used\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Used</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.BuyIn\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Buy In</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.FinanceQuote\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Finance Quote</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.Unsure\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Unsure</span>\r\n                    </label>\r\n                </td>\r\n            </tr>\r\n            <tr ng-if=\"$ctrl.enquiry.enquiryType === $ctrl.enums.ENQUIRY_TYPE.Aftersales\">\r\n                <td>Enquiry Subtype</td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"{{$ctrl.enums.ENQUIRY_SUBTYPE.ServiceBooking}}\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Service Booking</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.RepairsRequired\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Repairs Required</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.Parts\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Parts</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"enquiry_subtype\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_SUBTYPE.TechQuery\" ng-model=\"$ctrl.enquiry.enquirySubType\">\r\n                        <span class=\"btn btn-outline\">Technical Query</span>\r\n                    </label>\r\n                </td>\r\n            </tr>\r\n            <tr ng-if=\"false\" ng-show=\"$ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.New || $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.Used\">\r\n                <td>Vehicle</td>\r\n                <td colspan=\"4\">\r\n                  <label ng-show=\"$ctrl.enquiry.enquiryVehicles.length === 1\" class=\"control-label\">\r\n                    {{$ctrl.enquiry.enquiryVehicles[0].vehicle.model + ' ' + $ctrl.enquiry.enquiryVehicles[0].vehicle.variant}}\r\n                  </label>\r\n                </td>\r\n                <td>\r\n                    <button class=\"btn btn-primary w-100\"\r\n                    ui-sref=\"vehicleEnquiryView({source:'welcomeCentre', enquiry: $ctrl.enquiry, condition: $ctrl.enquiry.enquirySubType === $ctrl.enums.ENQUIRY_SUBTYPE.New ? $ctrl.enums.VEHICLE_CONDITION.New : $ctrl.enums.VEHICLE_CONDITION.Used})\">\r\n                      Select Vehicle\r\n                    </button>\r\n                </td>\r\n            </tr>\r\n            <tr ng-hide=\"$ctrl.enquiry.contactId\">\r\n                <td>Contact</td>\r\n                <td colspan=\"4\">\r\n                    <label class=\"radio-btn\">\r\n                      <div angucomplete-alt\r\n                        placeholder=\"Search Contacts by Phone, Name, Email or Registration\"\r\n                        id=\"searchContacts\"\r\n                        selected-object=\"$ctrl.contactSelected\"\r\n                        remote-url=\"{{$ctrl.searchContactUrl}}\"\r\n                        title-field=\"name,phone,email,reg\"\r\n                        minlength=\"2\"\r\n                        remote-url-response-formatter=\"$ctrl.contactSearched\"\r\n                        input-class=\"form-control form-control-small\"\r\n                        match-class=\"autocomplete-highlight\">\r\n                      </div>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <button class=\"btn btn-primary w-100\"\r\n                    ng-disabled=\"!$ctrl.createNewContact\"\r\n                    ng-click=\"$ctrl.showNewContact()\" ng-if=\"$ctrl.authService.checkFeatureAccess('Contact', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n                      <strong>+</strong> Create New\r\n                    </button>\r\n                </td>\r\n            </tr>\r\n            <tr ng-show=\"$ctrl.enquiry.contactId\">\r\n                <td>Contact</td>\r\n                <td colspan=\"4\">\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Contact Name:</dt>\r\n                        <dd>\r\n                          <a href=\"#\" ng-click=\"$ctrl.showEditContact()\">\r\n                            {{$ctrl.enquiry.contact.name}}\r\n                          </a>\r\n                        </dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Contact Phone:</dt>\r\n                        <dd>{{$ctrl.enquiry.contact.phone}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Contact Email:</dt>\r\n                        <dd>{{$ctrl.enquiry.contact.email}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Current Registration:</dt>\r\n                        <dd>{{$ctrl.enquiry.contact.reg}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                            <dt>Current Owner:</dt>\r\n                            <dd>\r\n                              {{$ctrl.enquiry.contact.enquiry.owner}}\r\n                            </dd>\r\n                    </dl>                                        \r\n                    <dl class=\"dl-horizontal\" ng-if=\"$ctrl.enquiry.contact.enquiry !== null\">\r\n                        <dt>Current Enquiry:</dt>\r\n                        <dd>\r\n                          {{$ctrl.enquiry.contact.enquiry.subject}}\r\n                          Click here to notify <a class=\"btn btn-link\" ng-click=\"$ctrl.notifyOwner($ctrl.enquiry.contact)\">{{$ctrl.enquiry.contact.enquiry.owner}}</a>\r\n                        </dd>\r\n                    </dl>\r\n                </td>\r\n                <td>\r\n                    <button class=\"btn btn-primary w-100\" ng-click=\"$ctrl.clearContact()\">Clear Contact</button>\r\n                </td>\r\n            </tr>\r\n            <tr ng-show=\"$ctrl.enquiry.enquiryType === $ctrl.enums.ENQUIRY_TYPE.Aftersales && !$ctrl.serviceVehicle\">\r\n                <td>Vehicle</td>\r\n                <td colspan=\"4\">\r\n                    <label class=\"radio-btn\">\r\n                      <input class=\"form-control form-control-small\" placeholder=\"Search vehicle by Registration Number\" ng-model=\"$ctrl.regNo\" />\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <button class=\"btn btn-primary w-100\"\r\n                    ng-click=\"$ctrl.lookupVehicle()\">\r\n                      <i class=\"glyphicon glyphicon-search\"></i>\r\n                      Lookup\r\n                    </button>\r\n                </td>\r\n            </tr>\r\n            <tr ng-show=\"$ctrl.enquiry.enquiryType === $ctrl.enums.ENQUIRY_TYPE.Aftersales && $ctrl.serviceVehicle\">\r\n                <td>Vehicle</td>\r\n                <td colspan=\"4\">\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Registration:</dt>\r\n                        <dd>{{$ctrl.regNo}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Model:</dt>\r\n                        <dd>{{$ctrl.serviceVehicle.make}} {{$ctrl.serviceVehicle.model}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Variant:</dt>\r\n                        <dd>{{$ctrl.serviceVehicle.variant}} {{$ctrl.serviceVehicle.variantCode}}</dd>\r\n                    </dl>\r\n                    <dl class=\"dl-horizontal\">\r\n                        <dt>Chassis:</dt>\r\n                        <dd>{{$ctrl.serviceVehicle.chassisNo}}</dd>\r\n                    </dl>                    \r\n                    <dl class=\"dl-horizontal\">\r\n                            <dt>First Registration:</dt>\r\n                            <dd>{{$ctrl.serviceVehicle.firstRegistration | date : 'dd MMM yyyy'}}</dd>\r\n                        </dl>                    \r\n                        <dl class=\"dl-horizontal\">\r\n                            <dt>Capacity:</dt>\r\n                            <dd>{{$ctrl.serviceVehicle.capacity}}</dd>\r\n                        </dl>                    \r\n                        <dl class=\"dl-horizontal\">\r\n                            <dt>Transmission Type:</dt>\r\n                            <dd>{{$ctrl.serviceVehicle.transmissionTypeName}}</dd>\r\n                        </dl>                    \r\n                        <dl class=\"dl-horizontal\">\r\n                            <dt>Fuel Type:</dt>\r\n                            <dd>{{$ctrl.serviceVehicle.fuelTypeName}}</dd>\r\n                        </dl>                                                                                                                            \r\n                </td>\r\n                <td>\r\n                    <button class=\"btn btn-primary w-100\" ng-click=\"$ctrl.clearVehicle()\">Clear Vehicle</button>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>Contact Method</td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"contact_method\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_ORIGINATION.WalkIn\" ng-model=\"$ctrl.enquiry.enquiryOrigination\">\r\n                        <span class=\"btn btn-outline\">Walk In</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"contact_method\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_ORIGINATION.Phone\" ng-model=\"$ctrl.enquiry.enquiryOrigination\">\r\n                        <span class=\"btn btn-outline\">Phone</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"contact_method\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_ORIGINATION.Email\" ng-model=\"$ctrl.enquiry.enquiryOrigination\">\r\n                        <span class=\"btn btn-outline\">Email</span>\r\n                    </label>\r\n                </td>\r\n                <td>\r\n                    <label class=\"radio-btn\">\r\n                        <input type=\"radio\" name=\"contact_method\" class=\"hidden\" ng-value=\"$ctrl.enums.ENQUIRY_ORIGINATION.Web\" ng-model=\"$ctrl.enquiry.enquiryOrigination\">\r\n                        <span class=\"btn btn-outline\">Web</span>\r\n                    </label>\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>Enquiry Source</td>\r\n                <td colspan=\"4\">                    \r\n                    <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.enquirySourceId as item.name for item in $ctrl.enquirySources\"\r\n                        ng-model=\"$ctrl.enquiry.enquirySourceId\">\r\n                    </select>\r\n                </td>\r\n            </tr>     \r\n            <tr ng-repeat=\"row in $ctrl.userMatrix\" ng-show=\"$ctrl.isReceptionist\">\r\n              <td>&nbsp;</td>\r\n              <td ng-repeat=\"user in row\">\r\n                <label class=\"person-image\">\r\n                    <input type=\"radio\" name=\"person\" class=\"hidden\" ng-value=\"user.userId\" ng-model=\"$ctrl.enquiry.ownerId\">\r\n                    <img class=\"img-outline img-responsive user-image\" ng-src=\"{{user.imageUrl}}\" alt=\"{{user.firstName + ' ' + user.lastName}}\">                    \r\n                    <strong>{{user.firstName + ' ' + user.lastName}}</strong>\r\n                    <span>\r\n                        <i class=\"fa fa-road user-stats-item1\" aria-hidden=\"true\"></i> {{$ctrl.getUserStatItem(user.userId, 'walkIn')}} \r\n                        <i class=\"fa fa-phone user-stats-item2\" aria-hidden=\"true\"></i> {{$ctrl.getUserStatItem(user.userId, 'phone')}}  <br />\r\n                        <i class=\"fa fa-envelope-o user-stats-item1\" aria-hidden=\"true\"></i> {{$ctrl.getUserStatItem(user.userId, 'email')}} \r\n                        <i class=\"fa fa-internet-explorer user-stats-item2\" aria-hidden=\"true\"></i> {{$ctrl.getUserStatItem(user.userId, 'web')}} \r\n                    </span>\r\n                </label>\r\n              </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n  </div>\r\n\r\n  <div class=\"col-md-3\" ng-show=\"$ctrl.currentEnquiries.length\">\r\n    <pending-Enquiry ng-repeat=\"e in $ctrl.currentEnquiries\" enquiry=\"e\" on-Choose-Owner=\"$ctrl.chooseDifferentOwner(enquiry)\" on-Accepted=\"$ctrl.pendingEnquiryAccepted(enquiryId)\"></pending-Enquiry>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	var _lodash = __webpack_require__(498);
	
	var _enquiryConfirmationModal = __webpack_require__(1426);
	
	var _enquiryConfirmationModal2 = _interopRequireDefault(_enquiryConfirmationModal);
	
	var _contactEditModal = __webpack_require__(1427);
	
	var _contactEditModal2 = _interopRequireDefault(_contactEditModal);
	
	var _sendMessageModal = __webpack_require__(1428);
	
	var _sendMessageModal2 = _interopRequireDefault(_sendMessageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WelcomeCentreController = function () {
	  WelcomeCentreController.$inject = ["authService", "$stateParams", "enums", "loadingService", "appConfig", "$scope", "enquiryService", "$uibModal", "userService", "$state", "pushService", "messagingService", "contactService", "lookupService", "$q", "enquirySourcesManagementService"];
	  function WelcomeCentreController(authService, $stateParams, enums, loadingService, appConfig, $scope, enquiryService, $uibModal, userService, $state, pushService, messagingService, contactService, lookupService, $q, enquirySourcesManagementService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, WelcomeCentreController);
	    this.authService = authService;
	    this.enums = enums;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.enquiryService = enquiryService;
	    this.loadingService = loadingService;
	    this.$uibModal = $uibModal;
	    this.userService = userService;
	    this.$state = $state;
	    this.pushService = pushService;
	    this.messagingService = messagingService;
	    this.contactService = contactService;
	    this.lookupService = lookupService;
	    this.$q = $q;
	    this.enquirySourcesManagementService = enquirySourcesManagementService;
	
	    this.formValidationService = new _FormValidationService2.default();
	
	    //If Accounts admin, redirect to Invoice List
	    var isAccountsAdmin = (0, _lodash.find)(this.authService.authData.userRoles, function (ur) {
	      return ur.roleId == 5 && ur.entityId == _this.authService.authData.currentLocation.key;
	    });
	    if (isAccountsAdmin != null) {
	      this.$state.go('invoiceList');
	    } else {
	      if (!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.Add, true)) {
	        return;
	      }
	    }
	
	    this.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + authService.authData.currentLocation.key + '/';
	    this.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';
	
	    this.enquiry = $stateParams.enquiry || {
	      entityId: authService.authData.currentLocation.key,
	      enquiryType: enums.ENQUIRY_TYPE.Sales,
	      enquiryVehicles: [],
	      testDrives: [],
	      enquiryPrices: [],
	      state: enums.ENQUIRY_STATE.Open,
	      criteria: null,
	      enquirySourceId: null
	    };
	
	    this.currentEnquiries = [];
	
	    this.selectOptions = {};
	    this.selectDefaults = {};
	    this.locationUsers = [];
	    this.userMatrix = [];
	    this.serviceVehicle = null;
	    this.userStats = [];
	
	    this.initializeLookups().then(function () {
	      _this.initializeEnums();
	      _this.initializeContactEnums();
	      _this.configureForm();
	      _this.loadEnumLists();
	      _this.getUserStats();
	      _this.initializeEnquirySources();
	    });
	
	    this.contactSelected = this.contactSelected.bind(this);
	    this.contactSearched = this.contactSearched.bind(this);
	
	    this.getLocationUsers();
	
	    this.isReceptionist = this.authService.authData.currentLocation.receptionistWelcomeCentre || authService.isReceptionist();
	
	    if (!this.isReceptionist) {
	      this.enquiry.ownerId = this.authService.authData.userId;
	    }
	
	    this.createNewContact = false;
	
	    this.authService.getLocationExtendedProperties('salutationEnabled');
	  }
	
	  (0, _createClass3.default)(WelcomeCentreController, [{
	    key: 'initializeEnums',
	    value: function initializeEnums() {
	      var ctrl = this;
	      var enumList = [{ enumName: 'ENQUIRY_TYPE', propName: 'enquiryType', defaultOption: true }, { enumName: 'ENQUIRY_CONTACT', propName: 'enquiryContact', defaultOption: true }, { enumName: 'ENQUIRY_ORIGINATION', propName: 'enquiryOrigination', defaultOption: true }];
	
	      enumList.map(function (item) {
	        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
	        ctrl.selectOptions[item.propName] = enumsArray;
	        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
	        ctrl.updateModelFromSelect(item.propName);
	      });
	    }
	  }, {
	    key: 'getDefaultOption',
	    value: function getDefaultOption(enumsArray, propName) {
	      var propVal = void 0;
	
	      try {
	        propVal = eval('this.enquiry.' + propName);
	      } catch (e) {}
	
	      if (propVal) {
	        return (0, _lodash.find)(enumsArray, function (o) {
	          return o.id === propVal;
	        });
	      } else {
	        return enumsArray[0];
	      }
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'updateModelFromSelect',
	    value: function updateModelFromSelect(modelProperty) {
	      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
	      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	      var val = this.selectDefaults[selectDefaultProperty][idProperty];
	
	      try {
	        eval('this.enquiry.' + modelProperty + ' = ' + val);
	      } catch (e) {}
	
	      if (modelProperty === 'enquiryType') {
	        this.loadEnquirySubTypes();
	      }
	    }
	  }, {
	    key: 'loadEnquirySubTypes',
	    value: function loadEnquirySubTypes() {
	      var objList = [];
	
	      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Sales) {
	        objList.push({ id: 1, name: 'New' });
	        objList.push({ id: 2, name: 'Used' });
	        objList.push({ id: 3, name: 'Unsure' });
	        objList.push({ id: 4, name: 'Buy In' });
	        objList.push({ id: 5, name: 'Finance Quote' });
	      } else if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales) {
	        objList.push({ id: 5, name: 'Service Booking' });
	        objList.push({ id: 6, name: 'Repairs Required' });
	        objList.push({ id: 7, name: 'Parts' });
	        objList.push({ id: 8, name: 'Tech Query' });
	      }
	
	      objList.unshift({ id: null, name: 'Please Select' });
	
	      this.selectOptions.enquirySubType = objList;
	      this.selectDefaults.enquirySubType = this.getDefaultOption(objList, 'enquirySubType');
	    }
	  }, {
	    key: 'configureForm',
	    value: function configureForm() {
	      var ctrl = this;
	
	      ctrl.formValidationService.initialize(ctrl.enquiry);
	
	      ctrl.formValidationService.addField({
	        fieldName: 'enquiryType',
	        displayName: 'Enquiry Type',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'enquiryContact',
	        displayName: 'Enquiry Contact',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'enquirySubType',
	        displayName: 'Enquiry SubType',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'enquiryOrigination',
	        displayName: 'Contact Method',
	        required: true
	      });
	
	      ctrl.formValidationService.addField({
	        fieldName: 'ownerId',
	        displayName: 'Owner',
	        required: true,
	        type: 'text'
	      });
	    }
	  }, {
	    key: 'clearContact',
	    value: function clearContact() {
	      this.enquiry.contactId = null;
	      this.enquiry.contact = null;
	    }
	  }, {
	    key: 'getLocationUsers',
	    value: function getLocationUsers() {
	      var _this2 = this;
	
	      var ctrl = this;
	      ctrl.userService.getLocationUsers(ctrl.authService.authData.currentLocation.key, false).then(function (response) {
	        if (response.data.length) {
	          ctrl.locationUsers = response.data;
	          _this2.updateUserMatrix();
	        }
	      });
	    }
	  }, {
	    key: 'updateUserMatrix',
	    value: function updateUserMatrix() {
	      var _this3 = this;
	
	      var limit = 5;
	      var selectedUsers = (0, _lodash.filter)(this.locationUsers, function (o) {
	        return o.workType === _this3.enquiry.enquiryType;
	      });
	      this.userMatrix = this.listToMatrix(selectedUsers, limit);
	    }
	  }, {
	    key: 'listToMatrix',
	    value: function listToMatrix(list, elementsPerSubArray) {
	      var matrix = [],
	          i,
	          k;
	
	      for (i = 0, k = -1; i < list.length; i++) {
	        if (i % elementsPerSubArray === 0) {
	          k++;
	          matrix[k] = [];
	        }
	
	        matrix[k].push(list[i]);
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'contactSearched',
	    value: function contactSearched(data) {
	      this.createNewContact = data.length === 0;
	      return data;
	    }
	  }, {
	    key: 'contactSelected',
	    value: function contactSelected(item) {
	      if (item) {
	        this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');
	        this.enquiry.contactId = item.originalObject.contactId;
	        this.enquiry.contact = item.originalObject;
	
	        if (this.authService.authData.currentLocation.salutationEnabled.enabled) {
	          this.enquiry.contact.name = this.getSalutationById(this.enquiry.contact.contactTitleId) + ' ' + this.enquiry.contact.name;
	        }
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.enquiry = {
	        entityId: this.authService.authData.currentLocation.key,
	        enquiryType: this.enums.ENQUIRY_TYPE.Sales,
	        enquiryVehicles: [],
	        testDrives: [],
	        enquiryPrices: [],
	        state: this.enums.ENQUIRY_STATE.Open
	      };
	
	      if (!this.isReceptionist) {
	        this.enquiry.ownerId = this.authService.authData.userId;
	      }
	
	      this.clearVehicle();
	
	      this.initializeEnums();
	
	      this.formValidationService = new _FormValidationService2.default();
	
	      this.configureForm();
	
	      this.createNewContact = false;
	    }
	  }, {
	    key: 'massageData',
	    value: function massageData() {
	      var ctrl = this;
	
	      //Massage Data
	      if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.Unsure) {
	        ctrl.enquiry.subject = 'Unsure';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.BuyIn) {
	        ctrl.enquiry.subject = 'Buy In';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.FinanceQuote) {
	        ctrl.enquiry.subject = 'Finance Quote';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.ServiceBooking) {
	        ctrl.enquiry.subject = 'Service Booking';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.RepairsRequired) {
	        ctrl.enquiry.subject = 'Repairs Required';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.Parts) {
	        ctrl.enquiry.subject = 'Parts';
	      } else if (ctrl.enquiry.enquirySubType === ctrl.enums.ENQUIRY_SUBTYPE.TechQuery) {
	        ctrl.enquiry.subject = 'Technical Query';
	      } else if (ctrl.enquiry.enquiryVehicles.length) {
	        ctrl.enquiry.subject = ctrl.enquiry.enquiryVehicles[0].vehicle.model + ' ' + ctrl.enquiry.enquiryVehicles[0].vehicle.variant;
	      }
	
	      //Remove All Vehicle Objects and just leave their IDs
	      ctrl.enquiry.enquiryVehicles.map(function (ev) {
	        ev.vehicle = null;
	      });
	
	      this.enquiry.contact = null;
	
	      if (this.enquiry.criteria) {
	        this.enquiry.criteria.brand = null;
	        this.enquiry.criteria.brandModel = null;
	      }
	
	      /*
	      * If this is aftersales enquiry
	      * The service vehicle should become part of the enquiry
	      * The service vehicle will be marked as Deleted
	      * The enquiry will be marked as closed
	      */
	      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales) {
	        this.enquiry.enquiryVehicles.push({
	          isSelected: true,
	          vehicle: this.serviceVehicle
	        });
	      }
	    }
	  }, {
	    key: 'editEnquiry',
	    value: function editEnquiry() {
	      var ctrl = this;
	      var isValid = false;
	
	      isValid = ctrl.formValidationService.validateForm();
	
	      var searchText = $('#searchContacts_value').val();
	      if (!this.enquiry.contactId) {
	        if (!searchText) {
	          ctrl.formValidationService.addModelError('contactId', 'Please select a contact or enter showroom entry details');
	          isValid = isValid && false;
	        } else {
	          ctrl.addShowroomEntry(searchText);
	          return;
	        }
	      }
	
	      isValid &= this.customValidation();
	
	      if (!isValid) {
	        return;
	      }
	
	      this.massageData();
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');
	
	      ctrl.enquiryService.editEnquiry(ctrl.enquiry).then(function (response) {
	        ctrl.state = 'Saved';
	
	        /*
	        * #714
	        * Update OwnerId of the Contact to the person 
	        * whose been assigned this enquiry
	        * otherwise the contact will be owned by Showroom Host
	        */
	        ctrl.contactService.updateOwner(ctrl.enquiry.contactId, ctrl.enquiry.ownerId);
	
	        ctrl.enquiry.enquiryId = response.data;
	
	        if (ctrl.isReceptionist) {
	          ctrl.enquiry.ownerImageUrl = (0, _lodash.find)(ctrl.locationUsers, function (o) {
	            return o.userId === ctrl.enquiry.ownerId;
	          }).imageUrl;
	          ctrl.enquiry.isAccepted = false;
	          ctrl.currentEnquiries.push((0, _assign2.default)({}, ctrl.enquiry));
	          ctrl.getUserStats();
	        } else {
	          ctrl.$state.go('enquiryEdit', { enquiryId: ctrl.enquiry.enquiryId });
	        }
	
	        ctrl.reset();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'chooseDifferentOwner',
	    value: function chooseDifferentOwner(enquiry) {
	      var ctrl = this;
	
	      ctrl.$scope.enquiry = enquiry;
	      ctrl.$scope.ownerUpdated = ctrl.ownerUpdated.bind(this);
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _enquiryConfirmationModal2.default,
	        scope: ctrl.$scope
	      });
	    }
	  }, {
	    key: 'ownerUpdated',
	    value: function ownerUpdated(newOwnerId) {
	      var ctrl = this;
	      ctrl.$scope.enquiry.ownerId = newOwnerId;
	      ctrl.$scope.enquiry.ownerImageUrl = (0, _lodash.find)(ctrl.locationUsers, function (o) {
	        return o.userId === ctrl.$scope.enquiry.ownerId;
	      }).imageUrl;
	      ctrl.$scope.$broadcast('welcomeCentre:ownerUpdated', { enquiryId: ctrl.$scope.enquiry.enquiryId });
	      ctrl.modalInstance.close();
	    }
	  }, {
	    key: 'getReturnParams',
	    value: function getReturnParams(newContactId, contact) {
	      if (newContactId) {
	        this.enquiry.contactId = newContactId;
	        this.enquiry.contact = {
	          name: contact.contactPerson.firstName + ' ' + contact.contactPerson.lastName,
	          phone: contact.contactPhones.length ? contact.contactPhones[0].phone : null,
	          email: contact.contactEmails.length ? contact.contactEmails[0].email : null,
	          reg: contact.currentReg
	        };
	      }
	
	      return {
	        stateName: 'welcomeCentre',
	        params: { enquiry: this.enquiry }
	      };
	    }
	  }, {
	    key: 'notifyOwner',
	    value: function notifyOwner(contact) {
	      var ctrl = this;
	
	      ctrl.formValidationService.resetValidations();
	
	      if (!ctrl.enquiry.enquiryOrigination) {
	        ctrl.formValidationService.addModelError('enquiryOrigination', 'Please provide a value for Select Method');
	        return;
	      }
	
	      ctrl.currentEnquiries.push({
	        contactId: contact.contactId,
	        contactName: contact.name,
	        contactMethod: ctrl.enquiry.enquiryOrigination,
	        enquiryId: contact.enquiry.enquiryId,
	        ownerId: contact.enquiry.ownerId,
	        ownerImageUrl: contact.enquiry.ownerImageUrl,
	        isExisting: true
	      });
	
	      ctrl.reset();
	    }
	  }, {
	    key: 'pendingEnquiryAccepted',
	    value: function pendingEnquiryAccepted(enquiryId) {
	      var acceptedEnquiry = (0, _lodash.find)(this.currentEnquiries, function (e) {
	        return e.enquiryId === enquiryId;
	      });
	      this.currentEnquiries = (0, _lodash.without)(this.currentEnquiries, acceptedEnquiry);
	    }
	  }, {
	    key: 'showSendMessage',
	    value: function showSendMessage() {
	      var ctrl = this;
	
	      ctrl.$scope.recipeintType = '1';
	      ctrl.$scope.enums = ctrl.enums;
	      ctrl.$scope.locationUsers = ctrl.locationUsers;
	      ctrl.$scope.pushService = ctrl.pushService;
	      ctrl.$scope.messagingService = ctrl.messagingService;
	      ctrl.$scope.myUserId = ctrl.authService.authData.userId;
	
	      ctrl.$scope.sendMessage = ctrl.sendMessage;
	      ctrl.$scope.cancelSend = ctrl.cancelSend.bind(this);
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _sendMessageModal2.default,
	        scope: ctrl.$scope
	      });
	
	      ctrl.$scope.modalInstance = ctrl.modalInstance;
	    }
	  }, {
	    key: 'cancelSend',
	    value: function cancelSend() {
	      this.modalInstance.close();
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage() {
	      var _this4 = this;
	
	      var fnFilter = void 0;
	      var userIds = void 0;
	
	      switch (this.recipeintType) {
	        case "1":
	          fnFilter = function fnFilter(o) {
	            return true;
	          };
	          break;
	
	        case "2":
	          fnFilter = function fnFilter(o) {
	            return o.workType === _this4.enums.USER_WORK_TYPE.Sales;
	          };
	          break;
	
	        case "3":
	          fnFilter = function fnFilter(o) {
	            return o.workType === _this4.enums.USER_WORK_TYPE.Aftersales;
	          };
	          break;
	      }
	
	      if (fnFilter) {
	        userIds = (0, _lodash.filter)(this.locationUsers, fnFilter).map(function (u) {
	          return u.userId;
	        });
	      } else {
	        userIds = this.messageRecipients.map(function (u) {
	          return u.userId;
	        });
	      }
	
	      this.pushService.messageHub.sendMessage(userIds, this.msgBody);
	
	      userIds.map(function (uid) {
	        var msg = {
	          senderId: _this4.myUserId,
	          userId: uid,
	          subject: 'New Message Received',
	          body: (0, _stringify2.default)({
	            msg: _this4.msgBody
	          })
	        };
	
	        _this4.messagingService.addMessage(msg);
	      });
	
	      alert('Message has been sent');
	      this.modalInstance.close();
	    }
	  }, {
	    key: 'initializeContactEnums',
	    value: function initializeContactEnums() {
	      var ctrl = this;
	
	      ctrl.$scope.contactTypes = ctrl.convertEnumToKeyValueList(ctrl.enums.CONTACT_TYPE);
	      ctrl.$scope.personTitles = ctrl.convertEnumToKeyValueList(ctrl.enums.PERSON_TITLE);
	    }
	  }, {
	    key: 'showNewContact',
	    value: function showNewContact() {
	      var ctrl = this;
	
	      ctrl.$scope.errMsg = '';
	      ctrl.$scope.quickEdit = false;
	      ctrl.$scope.editContact = this.editContact.bind(this);
	      ctrl.$scope.salutationEnabled = this.authService.authData.currentLocation.salutationEnabled.enabled;
	
	      ctrl.$scope.contact = {
	        entityId: ctrl.authService.authData.currentLocation.key,
	        ownerId: ctrl.authService.authData.userId,
	        contactType: ctrl.enums.CONTACT_TYPE.Customer,
	        contactPerson: {
	          title: this.authService.authData.currentLocation.salutationEnabled.enabled ? ctrl.enums.PERSON_TITLE.Mr : ctrl.enums.PERSON_TITLE.Other
	        },
	        partner: null,
	        address: {}
	      };
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _contactEditModal2.default,
	        scope: ctrl.$scope
	      });
	    }
	  }, {
	    key: 'showEditContact',
	    value: function showEditContact() {
	      var ctrl = this;
	
	      ctrl.$scope.errMsg = '';
	      ctrl.$scope.quickEdit = true;
	      ctrl.$scope.editContact = this.quickEditContact.bind(this);
	      ctrl.$scope.salutationEnabled = this.authService.authData.currentLocation.salutationEnabled.enabled;
	
	      ctrl.$scope.contact = {
	        entityId: ctrl.authService.authData.currentLocation.key,
	        contactId: ctrl.enquiry.contact.contactId,
	        ownerId: ctrl.authService.authData.userId,
	        contactType: ctrl.enquiry.contact.contactTypeId,
	        contactPerson: {
	          title: ctrl.enquiry.contact.contactTitleId,
	          firstName: ctrl.enquiry.contact.firstName,
	          lastName: ctrl.enquiry.contact.lastName
	        },
	        phone: ctrl.enquiry.contact.phone,
	        email: ctrl.enquiry.contact.email
	      };
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _contactEditModal2.default,
	        scope: ctrl.$scope
	      });
	    }
	  }, {
	    key: 'editContact',
	    value: function editContact() {
	      var _this5 = this;
	
	      var ctrl = this;
	
	      if (!ctrl.validateContact()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Saving Contact ...');
	
	      ctrl.contactService.editContact(ctrl.$scope.contact).then(function (response) {
	        var contactVm = {
	          entityId: ctrl.$scope.contact.entityId,
	          contactId: response.data,
	          contactTypeId: ctrl.$scope.contact.contactType,
	          contactTitleId: ctrl.$scope.contact.contactPerson.title,
	          firstName: ctrl.$scope.contact.contactPerson.firstName,
	          lastName: ctrl.$scope.contact.contactPerson.lastName,
	          name: ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName,
	          phone: ctrl.$scope.contact.phone,
	          email: ctrl.$scope.contact.email,
	          reg: null,
	          enquiry: null
	        };
	
	        if (_this5.authService.authData.currentLocation.salutationEnabled.enabled) {
	          contactVm.name = _this5.getSalutationById(ctrl.$scope.contact.contactPerson.title) + ' ' + ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName;
	        }
	
	        ctrl.contactSelected({ originalObject: contactVm });
	
	        ctrl.modalInstance.close();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          ctrl.$scope.errMsg = err.data.map(function (item) {
	            return item.value;
	          }).toString(',');
	        } else {
	          ctrl.$scope.errMsg = err.data;
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'quickEditContact',
	    value: function quickEditContact() {
	      var ctrl = this;
	
	      if (!ctrl.validateContact()) {
	        return;
	      }
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Saving Contact ...');
	
	      ctrl.$scope.contact.firstName = ctrl.$scope.contact.contactPerson.firstName;
	      ctrl.$scope.contact.lastName = ctrl.$scope.contact.contactPerson.lastName;
	
	      ctrl.contactService.quickEdit(ctrl.$scope.contact).then(function (response) {
	
	        var contactVm = {
	          entityId: ctrl.$scope.contact.entityId,
	          contactId: response.data,
	          contactTypeId: ctrl.$scope.contact.contactType,
	          contactTitleId: ctrl.$scope.contact.contactPerson.title,
	          firstName: ctrl.$scope.contact.firstName,
	          lastName: ctrl.$scope.contact.lastName,
	          name: ctrl.$scope.contact.contactPerson.firstName + ' ' + ctrl.$scope.contact.contactPerson.lastName,
	          phone: ctrl.$scope.contact.phone,
	          email: ctrl.$scope.contact.email,
	          reg: ctrl.enquiry.contact.reg,
	          enquiry: ctrl.enquiry.contact.enquiry
	        };
	
	        ctrl.contactSelected({ originalObject: contactVm });
	
	        ctrl.modalInstance.close();
	      }).catch(function (err) {
	        if (err.status === 400) {
	          ctrl.$scope.errMsg = err.data.map(function (item) {
	            return item.value;
	          }).toString(',');
	        } else {
	          ctrl.$scope.errMsg = err.data;
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'validateContact',
	    value: function validateContact() {
	      var ctrl = this;
	
	      ctrl.$scope.errMsg = '';
	
	      if (!(ctrl.$scope.contact.contactPerson.firstName && ctrl.$scope.contact.contactPerson.lastName && ctrl.$scope.contact.phone)) {
	
	        ctrl.$scope.errMsg = 'Please fill in all the fields marked with *';
	      }
	
	      return ctrl.$scope.errMsg.length === 0;
	    }
	  }, {
	    key: 'addShowroomEntry',
	    value: function addShowroomEntry(details) {
	      var ctrl = this;
	
	      this.state = 'Saving';
	
	      ctrl.loadingService.showLoading('editEnquiry', 'Saving Changes ...');
	
	      ctrl.enquiry.details = details;
	
	      ctrl.enquiry.createdBy = ctrl.enquiry.ownerId;
	      ctrl.enquiryService.addShowroomEntry(ctrl.enquiry).then(function (response) {
	        ctrl.state = 'Saved';
	        ctrl.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');
	
	        ctrl.reset();
	
	        if (ctrl.isReceptionist) {
	          ctrl.getUserStats();
	        }
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this6 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        _this6.allBrands = brands;
	
	        _this6.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this6.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'loadEnumLists',
	    value: function loadEnumLists() {
	      this.enumLists = {
	        transmissionType: this.convertEnumToKeyValueList(this.enums.TRANSMISSION_TYPE),
	        fuelType: this.convertEnumToKeyValueList(this.enums.FUEL_TYPE)
	      };
	    }
	  }, {
	    key: 'reverseLookup',
	    value: function reverseLookup(list, id) {
	      var item = (0, _lodash.find)(list, function (o) {
	        return o.id === id;
	      });
	
	      if (item) {
	        return item.name;
	      }
	    }
	  }, {
	    key: 'lookupVehicle',
	    value: function lookupVehicle() {
	      var _this7 = this;
	
	      this.msg = '';
	
	      if (!this.regNo) {
	        return;
	      }
	
	      this.clearVehicle();
	
	      this.loadingService.showLoading('editEnquiry', 'Looking up vehicle ...');
	
	      this.lookupService.lookupVehicleByRegNo(this.authService.authData.currentLocation.key, 1, this.regNo).then(function (response) {
	        _this7.data = response.data;
	
	        _this7.data.make = (0, _lodash.find)(_this7.allBrands, function (o) {
	          return o.brandId === _this7.data.brandId;
	        }).name;
	        _this7.data.model = (0, _lodash.find)(_this7.allBrandModels, function (o) {
	          return o.brandModelId === _this7.data.brandModelId;
	        }).name;
	        _this7.data.transmissionTypeName = _this7.reverseLookup(_this7.enumLists.transmissionType, _this7.data.transmissionType);
	        _this7.data.fuelTypeName = _this7.reverseLookup(_this7.enumLists.fuelType, _this7.data.fuelType);
	
	        _this7.serviceVehicle = _this7.data;
	      }).catch(function (err) {
	        alert('Could not fetch vehicle ' + _this7.regNo + '. Please check registration number or lookup settings and try again');
	      }).finally(function () {
	        _this7.loadingService.hideLoading('editEnquiry');
	      });
	    }
	  }, {
	    key: 'clearVehicle',
	    value: function clearVehicle() {
	      this.serviceVehicle = null;
	    }
	  }, {
	    key: 'customValidation',
	    value: function customValidation() {
	      if (this.enquiry.enquiryType === this.enums.ENQUIRY_TYPE.Aftersales && !this.serviceVehicle) {
	        this.formValidationService.addModelError('servhiceVehicle', 'Please lookup for a vehicle to be serviced');
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'loadDefaultLocation',
	    value: function loadDefaultLocation() {
	      var defaultLocation = (0, _lodash.find)(this.authService.authData.userLocations, function (o) {
	        return o.defaultLocation;
	      });
	      this.authService.authData.currentLocation = defaultLocation || this.authService.authData.userLocations[0];
	    }
	  }, {
	    key: 'getUserStats',
	    value: function getUserStats() {
	      var ctrl = this;
	      ctrl.userService.getUserStats(ctrl.authService.authData.currentLocation.key).then(function (response) {
	        ctrl.userStats = response.data;
	      });
	    }
	  }, {
	    key: 'getUserStatItem',
	    value: function getUserStatItem(userId, statType) {
	      var value = 0;
	
	      if (this.userStats.length) {
	        var stat = (0, _lodash.find)(this.userStats, function (o) {
	          return o.userId === userId;
	        });
	
	        if (stat) {
	          return stat[statType];
	        }
	      }
	
	      return value;
	    }
	  }, {
	    key: 'initializeEnquirySources',
	    value: function initializeEnquirySources() {
	      var ctrl = this;
	
	      ctrl.enquirySourcesManagementService.list(ctrl.authService.authData.currentLocation.key, true).then(function (response) {
	        ctrl.enquirySources = response.data;
	        ctrl.enquirySources.unshift({ enquirySourceId: null, name: 'Please Select' });
	      });
	    }
	  }, {
	    key: 'getSalutationById',
	    value: function getSalutationById(salId) {
	      var salList = this.convertEnumToKeyValueList(this.enums.PERSON_TITLE);
	
	      return (0, _lodash.find)(salList, function (o) {
	        return o.id === salId;
	      }).name;
	    }
	  }]);
	  return WelcomeCentreController;
	}();
	
	exports.default = WelcomeCentreController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">Choose a different owner</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Assign To</label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"user-image-container\">\r\n            <a ng-repeat=\"u in $ctrl.locationUsers\" ng-click=\"ownerUpdated(u.userId)\">\r\n              <img ng-src=\"{{u.imageUrl}}\" class=\"user-image\" title=\"{{u.firstName + ' ' + u.lastName}}\" ng-class=\"{'selected': $ctrl.enquiry.ownerId === u.userId}\"/>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">Contact Details</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"form-horizontal\">\r\n\r\n    <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n      {{errMsg}}\r\n    </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Contact Type <i class=\"required-star\">*</i></span></label>\r\n        <div class=\"col-sm-10\">\r\n          <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.id as item.name for item in contactTypes\"\r\n            ng-model=\"contact.contactType\">\r\n          </select>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\" ng-if=\"salutationEnabled\">\r\n        <label class=\"control-label col-sm-2\">Salutation <i class=\"required-star\">*</i></label>\r\n        <div class=\"col-sm-10\">\r\n          <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.id as item.name for item in personTitles\"\r\n            ng-model=\"contact.contactPerson.title\">\r\n          </select>\r\n        </div>\r\n      </div>      \r\n      \r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">First Name <i class=\"required-star\">*</i></label>\r\n        <div class=\"col-sm-10\">\r\n          <input class=\"form-control\" ng-model=\"contact.contactPerson.firstName\" placeholder=\"First Name\" maxlength=\"50\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Last Name <i class=\"required-star\">*</i></label>\r\n        <div class=\"col-sm-10\">\r\n          <input class=\"form-control\" ng-model=\"contact.contactPerson.lastName\" placeholder=\"Last Name\" maxlength=\"50\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Phone <i class=\"required-star\">*</i></label>\r\n        <div class=\"col-sm-10\">\r\n          <input class=\"form-control\" ng-model=\"contact.phone\" placeholder=\"Phone\" maxlength=\"50\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Email</label>\r\n        <div class=\"col-sm-10\">\r\n          <input class=\"form-control\" ng-model=\"contact.email\" placeholder=\"Email\" maxlength=\"100\">\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"form-group\" ng-hide=\"quickEdit\">\r\n        <label class=\"control-label col-sm-2\">Address Line 1</label>\r\n        <div class=\"col-sm-10\">\r\n          <textarea class=\"form-control\" ng-model=\"contact.address.line1\" placeholder=\"Address\" maxlength=\"100\"></textarea>\r\n        </div>\r\n      </div>\r\n\r\n\r\n</div>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"form-group\">\r\n\r\n        <button type=\"submit\" ng-click=\"editContact()\" class=\"btn btn-success\" style=\"width:48%\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n        </button>\r\n\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\">Compose Message</h3>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <label class=\"control-label col-sm-2\">Message Body</label>\r\n    </div>\r\n    <div class=\"col-md-9\">\r\n      <textarea class=\"form-control\" type=\"text\" placeholder=\"Type your message here\" ng-model=\"msgBody\"></textarea>\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n          <label class=\"control-label col-sm-2\">Recipients</label>\r\n      </div>\r\n      <div class=\"col-md-9\">\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"recipeintType\" value=\"1\">\r\n          All Employees\r\n        </label><br/>\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"recipeintType\" value=\"2\">\r\n          All Sales Employees\r\n        </label><br/>\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"recipeintType\" value=\"3\">\r\n          All Aftersales Employees\r\n        </label><br/>\r\n        <label>\r\n          <input type=\"radio\" ng-model=\"recipeintType\" value=\"4\">\r\n          Custom\r\n        </label><br/>\r\n      </div>\r\n    </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\" ng-show=\"recipeintType === '4'\">\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Assign To</label>\r\n        <div class=\"col-sm-10\">\r\n          <select\r\n            class=\"form-control\"\r\n            multiple=\"multiple\"\r\n            ng-options=\"(u.firstName + ' ' + u.lastName) for u in $ctrl.locationUsers track by u.userId\"\r\n            ng-model=\"messageRecipients\">\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n      <div class=\"modal-footer\">\r\n          <div class=\"col-md-12\">\r\n              <div class=\"form-group\">\r\n                <a ng-click=\"sendMessage()\" class=\"btn btn-primary\" style=\"width:20%\">Send</a>\r\n                <a ng-click=\"cancelSend()\" class=\"btn btn-warning\" style=\"width:20%\">Cancel</a>\r\n              </div>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1430);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./welcomeCentre.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./welcomeCentre.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".required-star{color:red}", ""]);
	
	// exports


/***/ }),
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WelcomeCentreService = function WelcomeCentreService($http, appConfig) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, WelcomeCentreService);
	  this._$http = $http;
	  this._appConfig = appConfig;
	};
	WelcomeCentreService.$inject = ["$http", "appConfig"];
	
	exports.default = WelcomeCentreService;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pendingEnquiry = __webpack_require__(1438);
	
	var _pendingEnquiry2 = _interopRequireDefault(_pendingEnquiry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pendingEnquiryModule = _angular2.default.module('pendingEnquiry', [_angularUiRouter2.default]).component('pendingEnquiry', _pendingEnquiry2.default).name;
	
	exports.default = pendingEnquiryModule;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pendingEnquiry = __webpack_require__(1439);
	
	var _pendingEnquiry2 = _interopRequireDefault(_pendingEnquiry);
	
	var _pendingEnquiry3 = __webpack_require__(1440);
	
	var _pendingEnquiry4 = _interopRequireDefault(_pendingEnquiry3);
	
	__webpack_require__(1441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pendingEnquiryComponent = {
	  restrict: 'E',
	  bindings: {
	    enquiry: '=',
	    onChooseOwner: '&',
	    onAccepted: '&'
	  },
	  template: _pendingEnquiry2.default,
	  controller: _pendingEnquiry4.default
	};
	
	exports.default = pendingEnquiryComponent;

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	module.exports = "<div class='card' ng-class=\"{'rejected': $ctrl.status === 'Rejected', 'accepted': $ctrl.status === 'Accepted', 'held': $ctrl.status === 'Held'}\">\r\n  <div class='card_left'>\r\n    <img ng-src={{$ctrl.enquiry.ownerImageUrl}}>\r\n  </div>\r\n  <div class='card_right'>\r\n    <h1>Status: {{$ctrl.status}}</h1>\r\n    <div class='card_right__details'>\r\n      <div ng-show=\"$ctrl.remainingTime\">\r\n        Time: {{$ctrl.remainingTime | time}}s\r\n      </div>\r\n      <div ng-show=\"!$ctrl.remainingTime && $ctrl.status !== 'Accepted'\">\r\n        <a href=\"#\" ng-click=\"$ctrl.sendMessage()\">Resend</a>\r\n        <br />\r\n        <a href=\"#\" ng-click=\"$ctrl.onChooseOwner({enquiry: $ctrl.enquiry})\">Choose Another</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(491);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingEnquiryController = function () {
	  PendingEnquiryController.$inject = ["authService", "pushService", "messagingService", "$interval", "$timeout", "$scope", "contactService", "enums"];
	  function PendingEnquiryController(authService, pushService, messagingService, $interval, $timeout, $scope, contactService, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PendingEnquiryController);
	    this.authService = authService;
	    this.pushService = pushService;
	    this.messagingService = messagingService;
	    this.$interval = $interval;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.contactService = contactService;
	    this.enums = enums;
	
	    this.pushService.registerEnquiryDeclinedHandler(this.enquiryDeclined.bind(this));
	    this.pushService.registerEnquiryAcceptedHandler(this.enquiryAccepted.bind(this));
	    this.pushService.registerEnquiryHeldHandler(this.enquiryHeld.bind(this));
	    this.sendMessage();
	
	    $scope.$on('welcomeCentre:ownerUpdated', this.ownerUpdated.bind(this));
	  }
	
	  (0, _createClass3.default)(PendingEnquiryController, [{
	    key: 'sendMessage',
	    value: function sendMessage() {
	      var _this = this;
	
	      this.status = 'Awaiting Response';
	      var ctrl = this;
	
	      //Create an Inbox Message
	      var msg = this.getMessageBody();
	
	      ctrl.messagingService.addMessage(msg).then(function (response) {
	        if (!_this.enquiry.isExisting) {
	          ctrl.pushService.messageHub.enquiryCreated(ctrl.enquiry.enquiryId, ctrl.enquiry.ownerId, ctrl.authService.authData.userId);
	        } else {
	          ctrl.pushService.messageHub.existingEnquiry(ctrl.enquiry.enquiryId, ctrl.enquiry.ownerId, ctrl.authService.authData.userId, ctrl.enquiry.contactName, ctrl.enquiry.contactMethod);
	        }
	        ctrl.confirmationTimeout();
	      });
	    }
	  }, {
	    key: 'getMessageBody',
	    value: function getMessageBody() {
	      var ctrl = this;
	
	      var msg = {
	        senderId: ctrl.authService.authData.userId,
	        userId: ctrl.enquiry.ownerId,
	        body: (0, _stringify2.default)({
	          enquiryId: ctrl.enquiry.enquiryId
	        })
	      };
	
	      if (!this.enquiry.isExisting) {
	        msg.subject = "New Enquiry Created";
	      } else {
	        switch (this.enquiry.contactMethod) {
	          case this.enums.ENQUIRY_ORIGINATION.WalkIn:
	            msg.subject = "Customer waiting at reception";
	            break;
	
	          case this.enums.ENQUIRY_ORIGINATION.Phone:
	            msg.subject = "Customer is on the phone looking to speak to you";
	            break;
	
	          case this.enums.ENQUIRY_ORIGINATION.Email:
	            msg.subject = "Customer has sent an email and is looking for you to contact them";
	            break;
	
	          case this.enums.ENQUIRY_ORIGINATION.Web:
	            msg.subject = "Customer has sent a message through the web and is looking for you to contact them";
	            break;
	        }
	      }
	
	      return msg;
	    }
	  }, {
	    key: 'confirmationTimeout',
	    value: function confirmationTimeout(timeoutVal) {
	      var ctrl = this;
	
	      ctrl.remainingTime = timeoutVal || 30;
	
	      ctrl.intervalId = ctrl.$interval(function () {
	        ctrl.remainingTime--;
	      }, 1000, ctrl.remainingTime);
	    }
	  }, {
	    key: 'enquiryDeclined',
	    value: function enquiryDeclined(enquiryId) {
	      var _this2 = this;
	
	      if (enquiryId === this.enquiry.enquiryId) {
	        this.$interval.cancel(this.intervalId);
	        this.$scope.$apply(function () {
	          _this2.status = 'Rejected';
	          _this2.remainingTime = 0;
	        });
	      }
	    }
	  }, {
	    key: 'ownerUpdated',
	    value: function ownerUpdated(evt, params) {
	      if (params.enquiryId === this.enquiry.enquiryId) {
	        this.sendMessage();
	      }
	    }
	  }, {
	    key: 'enquiryAccepted',
	    value: function enquiryAccepted(enquiryId) {
	      var _this3 = this;
	
	      if (enquiryId === this.enquiry.enquiryId) {
	        this.$interval.cancel(this.intervalId);
	
	        this.$scope.$apply(function () {
	          _this3.remainingTime = 0;
	
	          /*
	          * This looks like a hack for a memory leak in angular
	          * manually set the enquiry id to 0 so that it does
	          * not come in this condition at all
	          */
	          _this3.enquiry.enquiryId = 0;
	
	          _this3.$interval(function () {
	            //Add Life Cycle Event if Existing enquiryId
	            if (_this3.enquiry.isExisting) {
	              _this3.contactService.addEvent(_this3.enquiry.contactId, _this3.enquiry.contactMethod, _this3.enquiry.ownerId, enquiryId);
	            }
	
	            _this3.onAccepted({ enquiryId: _this3.enquiry.enquiryId });
	          }, 1000, 1);
	        });
	      }
	    }
	  }, {
	    key: 'enquiryHeld',
	    value: function enquiryHeld(enquiryId) {
	      var _this4 = this;
	
	      if (enquiryId === this.enquiry.enquiryId) {
	        this.$interval.cancel(this.intervalId);
	        this.$scope.$apply(function () {
	          _this4.status = 'Held';
	          _this4.remainingTime = 0;
	
	          /*
	          * This looks like a hack for a memory leak in angular
	          * manually set the enquiry id to 0 so that it does
	          * not come in this condition at all
	          */
	          _this4.enquiry.enquiryId = 0;
	
	          var locationHoldTime = _this4.authService.authData.currentLocation.enquiryHoldTime;
	          if (!locationHoldTime) {
	            locationHoldTime = 5;
	          }
	
	          //Add Life Cycle Event if Existing enquiryId
	          if (_this4.enquiry.isExisting) {
	            _this4.contactService.addEvent(_this4.enquiry.contactId, _this4.enquiry.contactMethod, _this4.enquiry.ownerId, enquiryId);
	          }
	
	          _this4.confirmationTimeout(locationHoldTime * 60);
	        });
	      }
	    }
	  }]);
	  return PendingEnquiryController;
	}();
	
	exports.default = PendingEnquiryController;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1442);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./pendingEnquiry.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./pendingEnquiry.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".card{width:200px;margin:auto;box-shadow:0 5px 10px 1px rgba(0,0,0,.55)}.card,.card_left{height:100px;background:transparent}.card_left{width:40%;float:left;overflow:hidden}.card_left img{padding-top:8px;width:100%;height:auto}.card_right{width:60%;float:left;background1:#000;height:100px;padding-top:10px}.card_right h1{color:#000}.card_right__details,.card_right h1{font-family:Montserrat,sans-serif;text-align:left;font-size:10px;margin:10px 0 0;padding:0 0 0 10px;letter-spacing:1px}.card_right__details ul{list-style-type:none;padding:0 0 0 10px;margin:10px 0 0}.card_right__details ul li{display:inline;color:#e3e3e3;font-family:Montserrat,sans-serif;font-size:10px;padding:0 10px 0 0}.held,.rejected{-webkit-animation-name:rejected;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-timing-function:linear;-moz-animation-name:rejected;-moz-animation-duration:1s;-moz-animation-iteration-count:1;-moz-animation-timing-function:linear}.accepted{-webkit-animation-name:accepted;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-timing-function:linear;-moz-animation-name:accepted;-moz-animation-duration:1s;-moz-animation-iteration-count:1;-moz-animation-timing-function:linear}", ""]);
	
	// exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _messaging = __webpack_require__(1444);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	var _messaging3 = __webpack_require__(1449);
	
	var _messaging4 = _interopRequireDefault(_messaging3);
	
	var _messageView = __webpack_require__(1450);
	
	var _messageView2 = _interopRequireDefault(_messageView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingModule = _angular2.default.module('messaging', [_angularUiRouter2.default, _messageView2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('messaging', {
	    url: '/messaging',
	    component: 'messaging'
	  });
	}]).component('messaging', _messaging2.default).service('messagingService', _messaging4.default).name;
	
	exports.default = messagingModule;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messaging = __webpack_require__(1445);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	var _messaging3 = __webpack_require__(1446);
	
	var _messaging4 = _interopRequireDefault(_messaging3);
	
	__webpack_require__(1447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _messaging2.default,
	  controller: _messaging4.default
	};
	
	exports.default = messagingComponent;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"messagingListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>My Messages</h2>\r\n      </header>\r\n\r\n      <uib-tabset>\r\n        <uib-tab index=\"0\" heading=\"Inbox\" select=\"$ctrl.showInbox()\">\r\n          <table class=\"table table-bordered table-hover table-striped\">\r\n              <thead>\r\n                  <tr>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('received')\">\r\n                        Received <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('sender')\">\r\n                        Sender <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-6\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('subject')\">\r\n                        Subject <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('read')\">\r\n                        Read <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                  </tr>\r\n              </thead>\r\n              <tbody>\r\n                  <tr data-ng-repeat=\"m in $ctrl.messages\" ng-class=\"{'highlightRow': m.read === null}\">\r\n                      <td class=\"col-md-2\">{{ m.received | date : 'dd MMM yy HH:mm' }}</td>\r\n                      <td class=\"col-md-2\">{{ m.sender }}</td>\r\n                      <td class=\"col-md-6\">\r\n                        <a href=\"#\" ng-click=\"$ctrl.viewMessage(m)\">\r\n                          {{ m.subject }}\r\n                        </a>\r\n                      </td>\r\n\r\n                      <td class=\"col-md-2\">{{ m.read | date : 'dd MMM yy HH:mm' }}</td>\r\n                  </tr>\r\n              </tbody>\r\n          </table>\r\n        </uib-tab>\r\n        <uib-tab index=\"1\" heading=\"Outbox\" select=\"$ctrl.showOutbox()\">\r\n          <table class=\"table table-bordered table-hover table-striped\">\r\n              <thead>\r\n                  <tr>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('received')\">\r\n                        Sent <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('sender')\">\r\n                        Receiver <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-6\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('subject')\">\r\n                        Subject <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                    <th class=\"col-md-2\">\r\n                      <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('read')\">\r\n                        Read <i class=\"fa fa-fw fa-sort\"></i>\r\n                      </a>\r\n                    </th>\r\n                  </tr>\r\n              </thead>\r\n              <tbody>\r\n                  <tr data-ng-repeat=\"m in $ctrl.messages\">\r\n                      <td class=\"col-md-2\">{{ m.received | date : 'dd MMM yy HH:mm' }}</td>\r\n                      <td class=\"col-md-2\">{{ m.user }}</td>\r\n                      <td class=\"col-md-6\">{{ m.subject | date : 'dd MMM yy HH:mm' }}</td>\r\n\r\n                      <td class=\"col-md-2\">{{ m.read | date : 'dd MMM yy HH:mm' }}</td>\r\n                  </tr>\r\n              </tbody>\r\n          </table>\r\n        </uib-tab>\r\n    </uib-tabset>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.messages.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listMessages()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessagingController = function () {
	  MessagingController.$inject = ["authService", "messagingService", "loadingService", "$state"];
	  function MessagingController(authService, messagingService, loadingService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MessagingController);
	    this.authService = authService;
	    this.messagingService = messagingService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	
	    this.filterParams = {};
	  }
	
	  (0, _createClass3.default)(MessagingController, [{
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.userId = this.authService.authData.userId;
	      this.filterParams.messagesType = this.activeTab;
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'received',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listMessages();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listMessages();
	    }
	  }, {
	    key: 'listMessages',
	    value: function listMessages() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('messagingListing', 'Loading Messages ...');
	
	      ctrl.messagingService.listMessages(ctrl.filterParams).then(function (response) {
	        ctrl.messages = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' messages'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching messages." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('messagingListing');
	      });
	    }
	  }, {
	    key: 'viewMessage',
	    value: function viewMessage(message) {
	      if (!message.read) {
	        this.authService.authData.msgCount--;
	      }
	
	      this.$state.go('messageView', { messageId: message.messageId });
	    }
	  }, {
	    key: 'showInbox',
	    value: function showInbox() {
	      this.activeTab = 'inbox';
	      this.reset();
	    }
	  }, {
	    key: 'showOutbox',
	    value: function showOutbox() {
	      this.activeTab = 'outbox';
	      this.reset();
	    }
	  }]);
	  return MessagingController;
	}();
	
	exports.default = MessagingController;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaging.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaging.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".highlightRow{background-color:#cec9c6!important}", ""]);
	
	// exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessagingService = function () {
	  MessagingService.$inject = ["$http", "appConfig"];
	  function MessagingService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MessagingService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(MessagingService, [{
	    key: 'getMessage',
	    value: function getMessage(messageId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/message/get//' + messageId));
	    }
	  }, {
	    key: 'addMessage',
	    value: function addMessage(msg) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/message/add', msg);
	    }
	  }, {
	    key: 'listMessages',
	    value: function listMessages(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&userId=' + filterParams.userId;
	      query += '&messagesType=' + filterParams.messagesType;
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/message/list' + query);
	    }
	  }]);
	  return MessagingService;
	}();
	
	exports.default = MessagingService;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _messageView = __webpack_require__(1451);
	
	var _messageView2 = _interopRequireDefault(_messageView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messageViewModule = _angular2.default.module('messageView', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('messageView', {
	    url: '/messaging/view/:messageId',
	    component: 'messageView'
	  });
	}]).component('messageView', _messageView2.default).name;
	
	exports.default = messageViewModule;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messageView = __webpack_require__(1452);
	
	var _messageView2 = _interopRequireDefault(_messageView);
	
	var _messageView3 = __webpack_require__(1453);
	
	var _messageView4 = _interopRequireDefault(_messageView3);
	
	__webpack_require__(1454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messageViewComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _messageView2.default,
	  controller: _messageView4.default
	};
	
	exports.default = messageViewComponent;

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n        <header>\r\n            <h2>View Message</h2>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n        <div class=\"form-horizontal\" block-ui=\"messageView\">\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\"></label>\r\n            <div class=\"col-sm-8\">\r\n              <a ui-sref=\"messaging\" class=\"btn btn-primary\">Go back to Messages</a>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Received</label>\r\n            <div class=\"col-sm-8\">\r\n              <label class=\"control-label\">{{$ctrl.message.received | date : 'dd MMM yy HH:mm' }}</label>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Sender</label>\r\n            <div class=\"col-sm-8\">\r\n              <label class=\"control-label\">{{$ctrl.message.sender }}</label>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Subject</label>\r\n            <div class=\"col-sm-8\">\r\n              <label class=\"control-label\">{{$ctrl.message.subject}}</label>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Body</label>\r\n            <div class=\"col-sm-8\">\r\n              {{$ctrl.messageBody}}\r\n\r\n              <div ng-show=\"!$ctrl.messageBody && $ctrl.messageType !== 'financeCreated'\">\r\n                Click here to open <a href=\"#\" ng-click=\"$ctrl.gotoEnquiry()\">Enquiry</a>\r\n              </div>\r\n\r\n              <div ng-show=\"!$ctrl.messageBody && $ctrl.messageType === 'financeCreated'\">\r\n                Click here to open <a href=\"#\" ng-click=\"$ctrl.gotoFinance()\">Finance</a>\r\n              </div>              \r\n            </div>\r\n          </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageViewController = function () {
	  MessageViewController.$inject = ["authService", "messagingService", "loadingService", "$stateParams", "$state", "pushService", "enquiryService"];
	  function MessageViewController(authService, messagingService, loadingService, $stateParams, $state, pushService, enquiryService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MessageViewController);
	    this.authService = authService;
	    this.messagingService = messagingService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	    this.pushService = pushService;
	    this.enquiryService = enquiryService;
	
	    this.loadMessage($stateParams.messageId);
	  }
	
	  (0, _createClass3.default)(MessageViewController, [{
	    key: 'loadMessage',
	    value: function loadMessage(messageId) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('messageView', 'Loading Message ...');
	
	      ctrl.messagingService.getMessage(messageId).then(function (response) {
	        ctrl.message = response.data;
	        ctrl.messageType = JSON.parse(ctrl.message.body).messageType;
	        ctrl.messageBody = JSON.parse(ctrl.message.body).msg;
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('messageView');
	      });
	    }
	  }, {
	    key: 'gotoEnquiry',
	    value: function gotoEnquiry() {
	      this.$state.go('enquiryEdit', {
	        enquiryId: JSON.parse(this.message.body).enquiryId
	      });
	    }
	  }, {
	    key: 'gotoFinance',
	    value: function gotoFinance() {
	      this.$state.go('financeEdit', {
	        financeId: JSON.parse(this.message.body).financeId
	      });
	    }
	  }, {
	    key: 'decline',
	    value: function decline() {
	      this.pushService.messageHub.enquiryDeclined(JSON.parse(this.message.body).enquiryId, JSON.parse(this.message.body).senderId);
	    }
	  }, {
	    key: 'accept',
	    value: function accept() {
	      var _this = this;
	
	      this.enquiryService.updateOwner(JSON.parse(this.message.body).enquiryId, this.authService.authData.userId).then(function () {
	        _this.pushService.messageHub.enquiryAccepted(JSON.parse(_this.message.body).enquiryId, JSON.parse(_this.message.body).senderId);
	        _this.$state.go('enquiryEdit', { enquiryId: JSON.parse(_this.message.body).enquiryId });
	      });
	    }
	  }]);
	  return MessageViewController;
	}();
	
	exports.default = MessageViewController;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1455);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./messageView.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./messageView.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".messageView{color:red}", ""]);
	
	// exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dashboard = __webpack_require__(1457);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _recentContacts = __webpack_require__(1462);
	
	var _recentContacts2 = _interopRequireDefault(_recentContacts);
	
	var _openEnquiries = __webpack_require__(1468);
	
	var _openEnquiries2 = _interopRequireDefault(_openEnquiries);
	
	var _openFinances = __webpack_require__(1474);
	
	var _openFinances2 = _interopRequireDefault(_openFinances);
	
	var _pendingDeliveries = __webpack_require__(1480);
	
	var _pendingDeliveries2 = _interopRequireDefault(_pendingDeliveries);
	
	var _contactMatch = __webpack_require__(1486);
	
	var _contactMatch2 = _interopRequireDefault(_contactMatch);
	
	var _vehicleMatch = __webpack_require__(1492);
	
	var _vehicleMatch2 = _interopRequireDefault(_vehicleMatch);
	
	var _webEnquiries = __webpack_require__(1498);
	
	var _webEnquiries2 = _interopRequireDefault(_webEnquiries);
	
	var _expiringContacts = __webpack_require__(1504);
	
	var _expiringContacts2 = _interopRequireDefault(_expiringContacts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('dashboard', [_angularUiRouter2.default, _openEnquiries2.default, _recentContacts2.default, _pendingDeliveries2.default, _contactMatch2.default, _vehicleMatch2.default, _openFinances2.default, _webEnquiries2.default, _expiringContacts2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('dashboard', {
	    url: '/dashboard',
	    component: 'dashboard',
	    params: {}
	  });
	}]).component('dashboard', _dashboard2.default).name;
	
	exports.default = dashboardModule;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(1458);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(1459);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	__webpack_require__(1460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _dashboard2.default,
	  controller: _dashboard4.default
	};
	
	exports.default = dashboardComponent;

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-2\">\r\n    <h1 class=\"dashboard-title\">My Dashboard</h1>\r\n  </div>\r\n  <div class=\"col-md-4 pull-right\">\r\n    <p class=\"input-group\">\r\n      <input type=\"text\" class=\"form-control\" ng-click=\"selectDate = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.selectedDate\" is-open=\"selectDate\" readonly=\"readOnly\" ng-change=\"$ctrl.reloadDashboard()\" datepicker-options=\"$ctrl.dtPickerOptions\" show-button-bar=\"false\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n      <span class=\"input-group-btn\">\r\n        <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"selectDate = true\"><i class=\"fa fa-calendar\"></i></button>\r\n      </span>\r\n    </p>\r\n  </div>\r\n  <div class=\"col-md-6 pull-right\">\r\n    <select\r\n      class=\"form-control\"\r\n      ng-show=\"$ctrl.authService.isManager()\"\r\n      ng-change=\"$ctrl.reloadDashboard()\"\r\n      ng-options=\"(item.firstName + ' ' + item.lastName) for item in $ctrl.users track by item.userId\"\r\n      ng-model=\"$ctrl.selectedUser\">\r\n    </select>\r\n  </div>\r\n</div>\r\n<hr class=\"dashboard-seperator\">\r\n\r\n<div class=\"dashboard-panels panel-group mt-3\" block-ui=\"editEnquiry\" id=\"accordion\">\r\n    <!-- Promises Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.promises\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-1\" ng-click=\"$ctrl.viewPromises()\">\r\n            <h4>\r\n                Promises                \r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.promise.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.promise.statsLoaded\">Due ({{$ctrl.stats.promise.dueToday}}), Overdue({{$ctrl.stats.promise.overdue}})</span>\r\n                </small>\r\n            </h4>            \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-1\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n              <promise-List on-load-stats=\"$ctrl.promisesLoaded(dueToday, overdue)\" on-load=\"$ctrl.promisesLoaded(dueToday, overdue)\">\r\n              </promise-List>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Promises End -->\r\n\r\n    <!-- Web Enquiries Begin -->\r\n    <div class=\"dashboard-panel panel\" \r\n        ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.webEnquiries\"\r\n        ng-hide=\"$ctrl.authService.authData.currentLocation.webEnquiryManagerOnly.enabled && !$ctrl.authService.isManager()\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-2\" ng-click=\"$ctrl.viewWebEnquiries()\">\r\n            <h4>\r\n                Web Enquiries\r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.webEnquiries.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.webEnquiries.statsLoaded\">Open({{$ctrl.stats.webEnquiries.count}})<span>\r\n                </small>\r\n            </h4>\r\n            \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-2\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n              <web-enquiries location-users=\"$ctrl.clonedUsers\" on-load-stats=\"$ctrl.webEnquiriesLoaded(count)\" on-load=\"$ctrl.webEnquiriesLoaded(count)\">\r\n              </web-enquiries>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Pending Deliveries End -->    \r\n\r\n    <!-- Open Enquiries Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.openEnquiries\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-3\" ng-click=\"$ctrl.viewOpenEnquiries()\">\r\n            <h4>\r\n                Open Enquiries\r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.enquiries.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.enquiries.statsLoaded\">Open({{$ctrl.stats.enquiries.count}})<span>\r\n                </small>\r\n            </h4>\r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-3\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n              <open-Enquiries on-load-stats=\"$ctrl.enquiriesLoaded(count)\" on-load=\"$ctrl.enquiriesLoaded(count)\">\r\n              </open-Enquiries>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Open Enquiries End -->\r\n\r\n    <!-- Open Finances Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.isManager() && $ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.openFinances\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-4\" ng-click=\"$ctrl.viewOpenFinances()\">\r\n            <h4>\r\n                Open Finances\r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.finances.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.finances.statsLoaded\">Open({{$ctrl.stats.finances.count}})<span>\r\n                </small>\r\n            </h4>            \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-4\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n              <open-Finances on-load-stats=\"$ctrl.financesLoaded(count)\" on-load=\"$ctrl.financesLoaded(count)\">\r\n              </open-Finances>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Open Finances End -->\r\n\r\n    <!-- Pending Deliveries Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.pendingDeliveries\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-5\" ng-click=\"$ctrl.viewPendingDeliveries()\">\r\n            <h4>\r\n                Pending Deliveries\r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.deliveries.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.deliveries.statsLoaded\">Due({{$ctrl.stats.deliveries.dueToday}}), Overdue({{$ctrl.stats.deliveries.overdue}})<span>\r\n                </small>\r\n            </h4>          \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-5\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n                <div class=\"data-container\">\r\n                    <pending-Deliveries on-load-stats=\"$ctrl.deliveriesLoaded(dueToday, overdue)\" on-load=\"$ctrl.deliveriesLoaded(dueToday, overdue)\"></pending-Deliveries>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Pending Deliveries End -->\r\n\r\n    <!-- Contacts Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.top10RecentContacts\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-6\" ng-click=\"$ctrl.viewRecentContacts()\">\r\n            <h4>\r\n                Top 10 Recent Contacts\r\n            </h4>      \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-6\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n              <recent-Contacts on-load=\"$ctrl.recentContactsLoaded()\">\r\n              </recent-Contacts>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Contacts End -->\r\n\r\n    <!-- Contact Matches Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.matchingContacts\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-7\">\r\n            <h4>\r\n                Matching Contacts\r\n                <small>\r\n                        <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.contactMatches.loaded\"></i>\r\n                        <span ng-show=\"$ctrl.stats.contactMatches.loaded\">Count({{$ctrl.stats.contactMatches.count}})<span>\r\n                    </small>\r\n            </h4>      \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-7\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n                <contact-match on-load=\"$ctrl.contactMatchesLoaded(count)\">\r\n                </contact-match>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Contact Matches End -->\r\n\r\n    <!-- Vehicle Matches Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.dashboardPreferences.panelVisibility.matchingVehicles\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-8\">\r\n            <h4>\r\n                Matching Vehicles\r\n                <small>\r\n                        <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.vehicleMatches.loaded\"></i>\r\n                        <span ng-show=\"$ctrl.stats.vehicleMatches.loaded\">Count({{$ctrl.stats.vehicleMatches.count}})<span>\r\n                    </small>\r\n            </h4>      \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-8\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n                <vehicle-match on-load=\"$ctrl.vehicleMatchesLoaded(count)\">\r\n                </vehicle-match>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- Vehicle Matches End -->    \r\n    \r\n    <!-- Expiring Contacts Begin -->\r\n    <div class=\"dashboard-panel panel\" ng-if=\"$ctrl.authService.authData.currentLocation.gdprMaintenance.enabled\">\r\n        <div class=\"dashboard-panel-heading\" data-parent=\"#accordion\" data-toggle=\"collapse\" data-target=\"#d-panel-9\" ng-click=\"$ctrl.viewExpiringContacts()\">\r\n            <h4>\r\n                GDPR Maintenance\r\n                <small>\r\n                    <i class=\"fa fa-spinner fa-spin\" ng-hide=\"$ctrl.stats.expiringContacts.statsLoaded\"></i>\r\n                    <span ng-show=\"$ctrl.stats.expiringContacts.statsLoaded\">Count({{$ctrl.stats.expiringContacts.count}})<span>\r\n                </small>\r\n            </h4>          \r\n        </div>\r\n        <div class=\"dashboard-panel-content collapse\" id=\"d-panel-9\">\r\n            <div class=\"dashboard-panel-content-inner\">\r\n                <expiring-contacts on-load-stats=\"$ctrl.expiringContactsLoaded(count)\" on-load=\"$ctrl.expiringContactsLoaded(count)\">\r\n                </expiring-contacts>\r\n            </div>\r\n        </div>\r\n    </div>\r\n<!-- Expiring Contacts End -->        \r\n</div>\r\n"

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function () {
	  DashboardController.$inject = ["authService", "userService", "$scope", "$interval"];
	  function DashboardController(authService, userService, $scope, $interval) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DashboardController);
	    this.authService = authService;
	    this.userService = userService;
	    this.$scope = $scope;
	    this.$interval = $interval;
	
	    this.authService.getLocationExtendedProperties('dashboardPreferences');
	    this.authService.getLocationExtendedProperties('gdprMaintenance');
	    this.authService.getLocationExtendedProperties('webEnquiryManagerOnly');
	
	    this.users = [{ userId: null, firstName: 'All Users' }];
	    this.clonedUsers = null;
	    this.selectedUser = this.users[0];
	    this.selectedDate = new Date();
	    this.currentPanel = null;
	
	    this.dtPickerOptions = {
	      minDate: new Date(),
	      showButtonBar: false
	    };
	
	    this.stats = {
	      promise: {
	        statsLoaded: false,
	        loaded: false,
	        dueToday: 0,
	        overdue: 0
	      },
	      webEnquiries: {
	        loaded: false,
	        count: 0
	      },
	      enquiries: {
	        loaded: false,
	        count: 0
	      },
	      finances: {
	        loaded: false,
	        count: 0
	      },
	      deliveries: {
	        loaded: false,
	        dueToday: 0,
	        overdue: 0
	      },
	      recentContacts: {
	        loaded: false
	      },
	      contactMatches: {
	        loaded: false,
	        count: 0
	      },
	      vehicleMatches: {
	        loaded: false,
	        count: 0
	      },
	      expiringContacts: {
	        loaded: false,
	        count: 0
	      }
	    };
	
	    if (this.authService.isManager()) {
	      this.loadUsers();
	    } else {
	      this.$interval(this.reloadDashboard.bind(this), 1, 1);
	    }
	  }
	
	  (0, _createClass3.default)(DashboardController, [{
	    key: 'loadUsers',
	    value: function loadUsers() {
	      var ctrl = this;
	
	      ctrl.userService.getLocationUsers(ctrl.authService.authData.currentLocation.key, true).then(function (response) {
	        ctrl.users = [ctrl.users[0]].concat((0, _toConsumableArray3.default)(response.data));
	
	        /*
	        * Set the Current User as Selected User as per the User Preference
	        * or All Users
	        * Take in account a rare edge case scenario, when a User has marked
	        * DashboardDefaultMyUser and DashboardHidden both true in User Preferences
	        */
	        if (ctrl.authService.authData.currentLocation.dashboardDefaultMyUser) {
	          var currentUser = (0, _lodash.find)(ctrl.users, function (o) {
	            return o.userId === ctrl.authService.authData.userId;
	          });
	          ctrl.selectedUser = currentUser || ctrl.users[0];
	        }
	
	        //Cloning a Copy of Location users to be reused for Web Enquiries
	        ctrl.clonedUsers = (0, _lodash.clone)(ctrl.users);
	
	        ctrl.reloadDashboard();
	      });
	    }
	  }, {
	    key: 'reloadDashboard',
	    value: function reloadDashboard() {
	      this.viewPromisesStats();
	      this.viewOpenEnquiriesStats();
	      this.viewOpenFinancesStats();
	      this.viewPendingDeliveriesStats();
	      this.viewContactMatches();
	      this.viewVehicleMatches();
	      this.viewWebEnquiriesStats();
	      this.viewExpiringContactsStats();
	
	      this.reloadOpenPanel();
	    }
	
	    //#region Promises
	
	  }, {
	    key: 'viewPromisesStats',
	    value: function viewPromisesStats() {
	      if (this.hasPanelVisibility('promises')) {
	        this.stats.promise.loaded = false;
	        this.$scope.$broadcast('dashboard:promisesStats', { userId: this.selectedUser.userId, selectedDate: this.selectedDate });
	      }
	    }
	  }, {
	    key: 'viewPromises',
	    value: function viewPromises(reload) {
	      if (this.hasPanelVisibility('promises')) {
	        this.currentPanel = 'promises';
	        this.stats.promise.loaded = false;
	        this.$scope.$broadcast('dashboard:promises', { reload: reload });
	      }
	    }
	  }, {
	    key: 'promisesLoaded',
	    value: function promisesLoaded(dueToday, overdue) {
	      this.stats.promise.statsLoaded = true;
	      this.stats.promise.dueToday = dueToday;
	      this.stats.promise.overdue = overdue;
	    }
	
	    //#endregion
	
	    //#region Web Enquiries
	
	  }, {
	    key: 'viewWebEnquiriesStats',
	    value: function viewWebEnquiriesStats() {
	      if (this.hasPanelVisibility('webEnquiries')) {
	        this.stats.webEnquiries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewWebEnquiriesStats', null);
	      }
	    }
	  }, {
	    key: 'viewWebEnquiries',
	    value: function viewWebEnquiries(reload) {
	      if (this.hasPanelVisibility('webEnquiries')) {
	        this.currentPanel = 'webEnquiries';;
	        this.stats.webEnquiries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewWebEnquiries');
	      }
	    }
	  }, {
	    key: 'webEnquiriesLoaded',
	    value: function webEnquiriesLoaded(count) {
	      this.stats.webEnquiries.statsLoaded = true;
	      this.stats.webEnquiries.count = count;
	    }
	
	    //#endregion
	
	    //#region Recent Contacts
	
	  }, {
	    key: 'viewRecentContacts',
	    value: function viewRecentContacts() {
	      if (this.hasPanelVisibility('top10RecentContacts')) {
	        this.currentPanel = 'top10RecentContacts';
	        this.stats.recentContacts.loaded = false;
	        this.$scope.$broadcast('dashboard:viewContacts', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'recentContactsLoaded',
	    value: function recentContactsLoaded() {
	      this.stats.recentContacts.loaded = true;
	    }
	
	    //#endregion
	
	    //#region Open Enquiries
	
	  }, {
	    key: 'viewOpenEnquiriesStats',
	    value: function viewOpenEnquiriesStats() {
	      if (this.hasPanelVisibility('openEnquiries')) {
	        this.stats.enquiries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewOpenEnquiriesStats', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'viewOpenEnquiries',
	    value: function viewOpenEnquiries(reload) {
	      if (this.hasPanelVisibility('openEnquiries')) {
	        this.currentPanel = 'openEnquiries';
	        this.stats.enquiries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewOpenEnquiries', { reload: reload });
	      }
	    }
	  }, {
	    key: 'enquiriesLoaded',
	    value: function enquiriesLoaded(count) {
	      this.stats.enquiries.statsLoaded = true;
	      this.stats.enquiries.count = count;
	    }
	
	    //#endregion
	
	    //#region Open Finances
	
	  }, {
	    key: 'viewOpenFinancesStats',
	    value: function viewOpenFinancesStats() {
	      if (this.hasPanelVisibility('openFinances')) {
	        this.stats.finances.loaded = false;
	        this.$scope.$broadcast('dashboard:viewOpenFinancesStats', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'viewOpenFinances',
	    value: function viewOpenFinances(reload) {
	      if (this.hasPanelVisibility('openFinances')) {
	        this.currentPanel = 'openFinances';
	        this.stats.finances.loaded = false;
	        this.$scope.$broadcast('dashboard:viewOpenFinances', { reload: reload });
	      }
	    }
	  }, {
	    key: 'financesLoaded',
	    value: function financesLoaded(count) {
	      this.stats.finances.statsLoaded = true;
	      this.stats.finances.count = count;
	    }
	
	    //#endregion
	
	    //#region Pending Deliveries
	
	  }, {
	    key: 'viewPendingDeliveriesStats',
	    value: function viewPendingDeliveriesStats() {
	      if (this.hasPanelVisibility('pendingDeliveries')) {
	        this.stats.deliveries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewPendingDeliveriesStats', { userId: this.selectedUser.userId, selectedDate: this.selectedDate });
	      }
	    }
	  }, {
	    key: 'viewPendingDeliveries',
	    value: function viewPendingDeliveries(reload) {
	      if (this.hasPanelVisibility('pendingDeliveries')) {
	        this.currentPanel = 'pendingDeliveries';
	        this.stats.deliveries.loaded = false;
	        this.$scope.$broadcast('dashboard:viewPendingDeliveries', { reload: reload });
	      }
	    }
	  }, {
	    key: 'deliveriesLoaded',
	    value: function deliveriesLoaded(dueToday, overdue) {
	      this.stats.deliveries.statsLoaded = true;
	      this.stats.deliveries.dueToday = dueToday;
	      this.stats.deliveries.overdue = overdue;
	    }
	
	    //#endregion
	
	    //#region Contact Matches
	
	  }, {
	    key: 'viewContactMatches',
	    value: function viewContactMatches() {
	      if (this.hasPanelVisibility('matchingContacts')) {
	        this.stats.contactMatches.loaded = false;
	        this.$scope.$broadcast('dashboard:viewContactMatches', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'contactMatchesLoaded',
	    value: function contactMatchesLoaded(count) {
	      this.stats.contactMatches.loaded = true;
	      this.stats.contactMatches.count = count;
	    }
	
	    //#endregion
	
	    //#region Vehicle Matches
	
	  }, {
	    key: 'viewVehicleMatches',
	    value: function viewVehicleMatches() {
	      if (this.hasPanelVisibility('matchingVehicles')) {
	        this.stats.vehicleMatches.loaded = false;
	        this.$scope.$broadcast('dashboard:viewVehicleMatches', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'vehicleMatchesLoaded',
	    value: function vehicleMatchesLoaded(count) {
	      this.stats.vehicleMatches.loaded = true;
	      this.stats.vehicleMatches.count = count;
	    }
	
	    //#endregion
	
	    //#region Expiring Contacts
	
	  }, {
	    key: 'viewExpiringContactsStats',
	    value: function viewExpiringContactsStats() {
	      if (this.hasExpiringContatsPanelVisibility()) {
	        this.stats.expiringContacts.loaded = false;
	        this.$scope.$broadcast('dashboard:viewExpiringContactsStats', { userId: this.selectedUser.userId });
	      }
	    }
	  }, {
	    key: 'viewExpiringContacts',
	    value: function viewExpiringContacts(reload) {
	      if (this.hasExpiringContatsPanelVisibility()) {
	        this.currentPanel = 'expiringContacts';
	        this.stats.expiringContacts.loaded = false;
	        this.$scope.$broadcast('dashboard:viewExpiringContacts', { reload: reload });
	      }
	    }
	  }, {
	    key: 'expiringContactsLoaded',
	    value: function expiringContactsLoaded(count) {
	      this.stats.expiringContacts.statsLoaded = true;
	      this.stats.expiringContacts.count = count;
	    }
	
	    //#endregion
	
	  }, {
	    key: 'hasPanelVisibility',
	    value: function hasPanelVisibility(panelName) {
	      return true;
	      //return this.authService.authData.currentLocation.dashboardPreferences.panelVisibility != null && this.authService.authData.currentLocation.dashboardPreferences.panelVisibility[panelName];
	    }
	  }, {
	    key: 'hasExpiringContatsPanelVisibility',
	    value: function hasExpiringContatsPanelVisibility() {
	      return true;
	      //return this.authService.authData.currentLocation.gdprMaintenance != null && this.authService.authData.currentLocation.gdprMaintenance.enabled;
	    }
	  }, {
	    key: 'reloadOpenPanel',
	    value: function reloadOpenPanel() {
	      if (!this.currentPanel) {
	        return;
	      }
	
	      if (this.currentPanel === 'promises') {
	        this.viewPromises(true);
	      } else if (this.currentPanel === 'openEnquiries') {
	        this.viewOpenEnquiries(true);
	      } else if (this.currentPanel === 'openFinances') {
	        this.viewOpenFinances(true);
	      } else if (this.currentPanel === 'pendingDeliveries') {
	        this.viewPendingDeliveries(true);
	      } else if (this.currentPanel === 'webEnquiries') {
	        this.viewWebEnquiries(true);
	      } else if (this.currentPanel === 'expiringContacts') {
	        this.viewExpiringContacts(true);
	      }
	    }
	  }]);
	  return DashboardController;
	}();
	
	exports.default = DashboardController;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1461);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./dashboard.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./dashboard.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".dashboard{color:red}.dashboard-data-container{overflow-y:scroll;height:420px!important}.dashboard-sticky-header-odd{position:sticky!important;top:0!important;background:linear-gradient(180deg,#ffe660 0,var(--primary-color))!important}.dashboard-sticky-header-even{position:sticky!important;top:0!important;background:linear-gradient(180deg,#c2c2b4 0,#cdccbc)!important}.clickable{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _recentContacts = __webpack_require__(1463);
	
	var _recentContacts2 = _interopRequireDefault(_recentContacts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recentContactsModule = _angular2.default.module('recentContacts', [_angularUiRouter2.default]).component('recentContacts', _recentContacts2.default).name;
	
	exports.default = recentContactsModule;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recentContacts = __webpack_require__(1464);
	
	var _recentContacts2 = _interopRequireDefault(_recentContacts);
	
	var _recentContacts3 = __webpack_require__(1465);
	
	var _recentContacts4 = _interopRequireDefault(_recentContacts3);
	
	__webpack_require__(1466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recentContactsComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoad: '&'
	  },
	  template: _recentContacts2.default,
	  controller: _recentContacts4.default
	};
	
	exports.default = recentContactsComponent;

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"contactList\">\r\n  <div class=\"list-group\">\r\n    <a ui-sref=\"contactView({contactId: c.contactId})\" class=\"list-group-item\" ng-repeat=\"c in $ctrl.contacts\">\r\n      {{c.name}}\r\n    </a>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecentContactsController = function () {
	  RecentContactsController.$inject = ["authService", "userService", "loadingService", "$scope"];
	  function RecentContactsController(authService, userService, loadingService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, RecentContactsController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	
	    this.contacts = [];
	
	    $scope.$on('dashboard:viewContacts', this.listRecentContacts.bind(this));
	  }
	
	  (0, _createClass3.default)(RecentContactsController, [{
	    key: 'listRecentContacts',
	    value: function listRecentContacts(evt, params) {
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.contacts.length) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('contactList', 'Loading Contacts');
	
	      ctrl.userService.recentContacts(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), params.userId).then(function (response) {
	        ctrl.contacts = response.data;
	        ctrl.onLoad();
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('contactList');
	      });
	    }
	  }]);
	  return RecentContactsController;
	}();
	
	exports.default = RecentContactsController;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1467);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./recentContacts.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./recentContacts.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".recentContacts{color:red}", ""]);
	
	// exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _openEnquiries = __webpack_require__(1469);
	
	var _openEnquiries2 = _interopRequireDefault(_openEnquiries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openEnquiriesModule = _angular2.default.module('openEnquiries', [_angularUiRouter2.default]).component('openEnquiries', _openEnquiries2.default).name;
	
	exports.default = openEnquiriesModule;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _openEnquiries = __webpack_require__(1470);
	
	var _openEnquiries2 = _interopRequireDefault(_openEnquiries);
	
	var _openEnquiries3 = __webpack_require__(1471);
	
	var _openEnquiries4 = _interopRequireDefault(_openEnquiries3);
	
	__webpack_require__(1472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openEnquiriesComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _openEnquiries2.default,
	  controller: _openEnquiries4.default
	};
	
	exports.default = openEnquiriesComponent;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"enquiryList\">\r\n  <ul uib-pagination\r\n    ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n    class=\"pull-right\"                \r\n    boundary-link-numbers=\"true\"\r\n    max-size=\"7\"\r\n    total-items=\"$ctrl.pagination.totalItems\"\r\n    items-per-page=\"$ctrl.pagination.pageSize\"\r\n    ng-model=\"$ctrl.pagination.currentPage\"\r\n    ng-change=\"$ctrl.viewOpenEnquiries()\"\r\n    boundary-links=\"true\" \r\n    previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n  </ul>\r\n\r\n  <div>\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th>Subject</th>\r\n                <th>Contact Name</th>\r\n                <th>Last Modified</th>\r\n                <th ng-show=\"$ctrl.authService.isManager()\">Owner</th>\r\n                <th>&nbsp;</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"e in $ctrl.enquiries\">\r\n                  <td>{{ e.subject }}</td>\r\n                  <td>\r\n                    <a ui-sref=\"contactView({contactId: e.contactId})\">\r\n                      {{ e.contactName }}\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ e.lastModified | date : 'dd-MMM-yyyy HH:mm' }}</td>\r\n                  <td ng-show=\"$ctrl.authService.isManager()\">{{e.ownerName}}</td>\r\n                  <td>\r\n                    <a class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: e.enquiryId})\">\r\n                      Edit\r\n                    </a>\r\n                  </td>\r\n              </tr>\r\n          </tbody>\r\n      </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OpenEnquiriesController = function () {
	  OpenEnquiriesController.$inject = ["authService", "userService", "loadingService", "$scope"];
	  function OpenEnquiriesController(authService, userService, loadingService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OpenEnquiriesController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    this.overrideUserId = null;
	    this.enquiries = [];
	
	    $scope.$on('dashboard:viewOpenEnquiriesStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:viewOpenEnquiries', this.viewOpenEnquiries.bind(this));
	  }
	
	  (0, _createClass3.default)(OpenEnquiriesController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');
	
	      this.overrideUserId = params ? params.userId : null;
	
	      ctrl.userService.openEnquiriesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
	        ctrl.pagination.totalItems = response.data;
	        ctrl.onLoadStats({ count: response.data });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiryList');
	      });
	    }
	  }, {
	    key: 'viewOpenEnquiries',
	    value: function viewOpenEnquiries(evt, params) {
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.enquiries.length && !params.reload) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');
	
	      ctrl.userService.openEnquiries(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage).then(function (response) {
	        ctrl.enquiries = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiryList');
	      });
	    }
	  }]);
	  return OpenEnquiriesController;
	}();
	
	exports.default = OpenEnquiriesController;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./openEnquiries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./openEnquiries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".openEnquiries{color:red}", ""]);
	
	// exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _openFinances = __webpack_require__(1475);
	
	var _openFinances2 = _interopRequireDefault(_openFinances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openFinancesModule = _angular2.default.module('openFinances', [_angularUiRouter2.default]).component('openFinances', _openFinances2.default).name;
	
	exports.default = openFinancesModule;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _openFinances = __webpack_require__(1476);
	
	var _openFinances2 = _interopRequireDefault(_openFinances);
	
	var _openFinances3 = __webpack_require__(1477);
	
	var _openFinances4 = _interopRequireDefault(_openFinances3);
	
	__webpack_require__(1478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openFinancesComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _openFinances2.default,
	  controller: _openFinances4.default
	};
	
	exports.default = openFinancesComponent;

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"financesList\">\r\n  <ul uib-pagination\r\n    ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n    class=\"pull-right\"                \r\n    boundary-link-numbers=\"true\"\r\n    max-size=\"7\"\r\n    total-items=\"$ctrl.pagination.totalItems\"\r\n    items-per-page=\"$ctrl.pagination.pageSize\"\r\n    ng-model=\"$ctrl.pagination.currentPage\"\r\n    ng-change=\"$ctrl.viewOpenFinances()\"\r\n    boundary-links=\"true\" \r\n    previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n  </ul>  \r\n\r\n  <div>\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th>Quote Name</th>\r\n                <th>Contact Name</th>\r\n                <th>Vehicle</th>\r\n                <th>Amount</th>\r\n                <th>Status</th>\r\n                <th>Last Modified</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"f in $ctrl.finances\">\r\n                <td>\r\n                  <a ui-sref=\"financeEdit({financeId: f.financeId})\">\r\n                    {{f.name}}\r\n                  </a>\r\n                </td>\r\n                  <td>\r\n                    <a ui-sref=\"contactView({contactId: f.contactId})\">\r\n                      {{f.contactName}}\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ f.vehicle }}</td>\r\n                  <td>{{ f.amount }}</td>\r\n                  <td>{{ f.state }}</td>\r\n                  <td>{{ f.lastModified| date : 'dd MMM yy HH:mm' }}</td>\r\n              </tr>\r\n          </tbody>\r\n      </table>    \r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OpenFinancesController = function () {
	  OpenFinancesController.$inject = ["authService", "userService", "loadingService", "$scope"];
	  function OpenFinancesController(authService, userService, loadingService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OpenFinancesController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    this.overrideUserId = null;
	    this.finances = [];
	
	    $scope.$on('dashboard:viewOpenFinancesStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:viewOpenFinances', this.viewOpenFinances.bind(this));
	  }
	
	  (0, _createClass3.default)(OpenFinancesController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financesList', 'Loading Finances');
	
	      this.overrideUserId = params ? params.userId : null;
	
	      ctrl.userService.openFinancesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
	        ctrl.pagination.totalItems = response.data;
	        ctrl.onLoadStats({ count: response.data });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('financesList');
	      });
	    }
	  }, {
	    key: 'viewOpenFinances',
	    value: function viewOpenFinances(evt, params) {
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.finances.length && !params.reload) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('financesList', 'Loading Finances');
	
	      ctrl.userService.openFinances(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
	        ctrl.finances = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('financesList');
	      });
	    }
	  }]);
	  return OpenFinancesController;
	}();
	
	exports.default = OpenFinancesController;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1479);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./openFinances.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./openFinances.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".openFinances{color:red}", ""]);
	
	// exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pendingDeliveries = __webpack_require__(1481);
	
	var _pendingDeliveries2 = _interopRequireDefault(_pendingDeliveries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pendingDeliveriesModule = _angular2.default.module('pendingDeliveries', [_angularUiRouter2.default]).component('pendingDeliveries', _pendingDeliveries2.default).name;
	
	exports.default = pendingDeliveriesModule;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pendingDeliveries = __webpack_require__(1482);
	
	var _pendingDeliveries2 = _interopRequireDefault(_pendingDeliveries);
	
	var _pendingDeliveries3 = __webpack_require__(1483);
	
	var _pendingDeliveries4 = _interopRequireDefault(_pendingDeliveries3);
	
	__webpack_require__(1484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pendingDeliveriesComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _pendingDeliveries2.default,
	  controller: _pendingDeliveries4.default
	};
	
	exports.default = pendingDeliveriesComponent;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehiclesList\">\r\n    <ul uib-pagination\r\n        ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n        class=\"pull-right\"                \r\n        boundary-link-numbers=\"true\"\r\n        max-size=\"7\"\r\n        total-items=\"$ctrl.pagination.totalItems\"\r\n        items-per-page=\"$ctrl.pagination.pageSize\"\r\n        ng-model=\"$ctrl.pagination.currentPage\"\r\n        ng-change=\"$ctrl.viewPendingDeliveries()\"\r\n        boundary-links=\"true\" \r\n        previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n    </ul>    \r\n\r\n  <div>\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th>Delivery Date</th>\r\n                <th>Registration</th>\r\n                <th>Vehicle</th>\r\n                <th>Contact</th>\r\n                <th>Comments</th>            \r\n                <th ng-show=\"$ctrl.authService.isManager()\">Owner</th>\r\n                <th>&nbsp;</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"v in $ctrl.vehicles\">\r\n                  <td>{{ v.deliveryDate | date : 'dd-MMM-yyyy' }}</td>\r\n                  <td>{{ v.registration }}</td>\r\n                  <td>{{ v.model + ' ' + v.variant }}</td>\r\n                  <td>{{ v.contact }}</td>\r\n                  <td>{{ v.comments }}</td>              \r\n                  <td ng-show=\"$ctrl.authService.isManager()\">{{v.ownerName}}</td>\r\n                  <td>\r\n                    <a class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: v.enquiryId})\">\r\n                      Edit Enquiry\r\n                    </a>\r\n                  </td>\r\n              </tr>\r\n          </tbody>\r\n      </table>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingDeliveriesController = function () {
	  PendingDeliveriesController.$inject = ["authService", "userService", "loadingService", "$scope"];
	  function PendingDeliveriesController(authService, userService, loadingService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PendingDeliveriesController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    this.overrideUserId = null;
	    this.selectedDate = null;
	    this.vehicles = [];
	
	    $scope.$on('dashboard:viewPendingDeliveriesStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:viewPendingDeliveries', this.viewPendingDeliveries.bind(this));
	  }
	
	  (0, _createClass3.default)(PendingDeliveriesController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      this.overrideUserId = params ? params.userId : null;
	      this.selectedDate = params ? params.selectedDate : new Date();
	
	      ctrl.userService.pendingDeliveriesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate).then(function (response) {
	        ctrl.pagination.totalItems = response.data.item3;
	        ctrl.onLoadStats({ dueToday: response.data.item1, overdue: response.data.item2 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }, {
	    key: 'viewPendingDeliveries',
	    value: function viewPendingDeliveries(evt, params) {
	      var _this = this;
	
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.vehicles.length && !params.reload) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      ctrl.userService.pendingDeliveries(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate, this.pagination.currentPage).then(function (response) {
	        _this.vehicles = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }]);
	  return PendingDeliveriesController;
	}();
	
	exports.default = PendingDeliveriesController;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1485);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./pendingDeliveries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./pendingDeliveries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".pendingDeliveries{color:red}", ""]);
	
	// exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactMatch = __webpack_require__(1487);
	
	var _contactMatch2 = _interopRequireDefault(_contactMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactMatchModule = _angular2.default.module('contactMatch', [_angularUiRouter2.default]).component('contactMatch', _contactMatch2.default).name;
	
	exports.default = contactMatchModule;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactMatch = __webpack_require__(1488);
	
	var _contactMatch2 = _interopRequireDefault(_contactMatch);
	
	var _contactMatch3 = __webpack_require__(1489);
	
	var _contactMatch4 = _interopRequireDefault(_contactMatch3);
	
	__webpack_require__(1490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactMatchComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoad: '&'
	  },
	  template: _contactMatch2.default,
	  controller: _contactMatch4.default
	};
	
	exports.default = contactMatchComponent;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"contactMatchList\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 dashboard-data-container\">\r\n        <div class=\"list-group\">\r\n          <div class=\"list-group-item\" ng-repeat=\"c in $ctrl.contactVehicleSalesMatches\" ng-class=\"{'list-group-item-success' : c.enquiryId === $ctrl.selectedContact.enquiryId}\">\r\n            <div class=\"row clickable\" ng-click=\"$ctrl.selectedContact = c\">\r\n              <div class=\"col-md-4\">\r\n                  {{c.contactName}}\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                  {{c.enquiryCreated | date : 'dd-MMM-yyyy HH:mm'}}\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <a href=\"#\" class=\"btn btn-primary pull-right\" ui-sref=\"enquiryEdit({enquiryId: c.enquiryId})\">\r\n                  Go to Enquiry\r\n                </a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-6 dashboard-data-container\">\r\n        <div class=\"list-group\">\r\n          <div class=\"list-group-item\" ng-repeat=\"v in $ctrl.selectedContact.vehicles\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-3\">\r\n                  {{v.model}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                  {{v.registration}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                {{v.state}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                {{v.dueIn}}\r\n              </div>            \r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>  "

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactMatchController = function () {
	    ContactMatchController.$inject = ["authService", "userService", "loadingService", "$scope"];
	    function ContactMatchController(authService, userService, loadingService, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ContactMatchController);
	        this.authService = authService;
	        this.userService = userService;
	        this.loadingService = loadingService;
	
	        this.contactVehicleSalesMatches = [];
	        this.selectedContact = null;
	
	        this.params = {};
	
	        $scope.$on('dashboard:viewContactMatches', this.viewContactMatches.bind(this));
	
	        this.stats = {
	            contactToVehicleCount: 0,
	            vehicleToContactCount: 0
	        };
	    }
	
	    (0, _createClass3.default)(ContactMatchController, [{
	        key: 'viewContactMatches',
	        value: function viewContactMatches(evt, params) {
	            var ctrl = this;
	
	            ctrl.params = params || ctrl.params;
	
	            ctrl.loadingService.showLoading('contactMatchList', 'Loading Matches');
	
	            ctrl.selectedContact = null;
	
	            ctrl.userService.salesMatches(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), ctrl.params.userId).then(function (response) {
	                ctrl.contactVehicleSalesMatches = response.data.contactVehicleSalesMatches;
	                if (ctrl.contactVehicleSalesMatches.length) {
	                    ctrl.selectedContact = ctrl.contactVehicleSalesMatches[0];
	                }
	
	                ctrl.onLoad({ count: ctrl.contactVehicleSalesMatches.length });
	            }).finally(function () {
	                ctrl.loadingService.hideLoading('contactMatchList');
	            });
	        }
	    }]);
	    return ContactMatchController;
	}();
	
	exports.default = ContactMatchController;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1491);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactMatch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactMatch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactMatch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleMatch = __webpack_require__(1493);
	
	var _vehicleMatch2 = _interopRequireDefault(_vehicleMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleMatchModule = _angular2.default.module('vehicleMatch', [_angularUiRouter2.default]).component('vehicleMatch', _vehicleMatch2.default).name;
	
	exports.default = vehicleMatchModule;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleMatch = __webpack_require__(1494);
	
	var _vehicleMatch2 = _interopRequireDefault(_vehicleMatch);
	
	var _vehicleMatch3 = __webpack_require__(1495);
	
	var _vehicleMatch4 = _interopRequireDefault(_vehicleMatch3);
	
	__webpack_require__(1496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleMatchComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoad: '&'
	  },
	  template: _vehicleMatch2.default,
	  controller: _vehicleMatch4.default
	};
	
	exports.default = vehicleMatchComponent;

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehicleList\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 dashboard-data-container\">\r\n        <div class=\"list-group\">\r\n          <div class=\"list-group-item\" ng-repeat=\"v in $ctrl.vehicleContactSalesMatches\" ng-class=\"{'list-group-item-success' : v.vehicleId === $ctrl.selectedVehicle.vehicleId}\">\r\n            <div class=\"row clickable\" ng-click=\"$ctrl.selectedVehicle = v\">\r\n              <div class=\"col-md-3\">\r\n                  {{v.model}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                  {{v.registration}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                {{v.state}}\r\n              </div>\r\n              <div class=\"col-md-3\">\r\n                {{v.dueIn}}\r\n              </div>            \r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-6 dashboard-data-container\">\r\n        <div class=\"list-group\">\r\n          <div class=\"list-group-item\" ng-repeat=\"c in $ctrl.selectedVehicle.contacts\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                  {{c.contactName}}\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                  {{c.enquiryCreated | date : 'dd-MMM-yyyy HH:mm'}}\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <a href=\"#\" class=\"btn btn-primary pull-right\" ui-sref=\"enquiryEdit({enquiryId: c.enquiryId})\">\r\n                  Go to Enquiry\r\n                </a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  "

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleMatchController = function () {
	    VehicleMatchController.$inject = ["authService", "userService", "loadingService", "$scope"];
	    function VehicleMatchController(authService, userService, loadingService, $scope) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, VehicleMatchController);
	        this.authService = authService;
	        this.userService = userService;
	        this.loadingService = loadingService;
	
	        this.vehicleContactSalesMatches = [];
	        this.selectedVehicle = null;
	
	        this.params = {};
	
	        $scope.$on('dashboard:viewVehicleMatches', this.viewVehicleMatches.bind(this));
	
	        this.stats = {
	            contactToVehicleCount: 0,
	            vehicleToContactCount: 0
	        };
	    }
	
	    (0, _createClass3.default)(VehicleMatchController, [{
	        key: 'viewVehicleMatches',
	        value: function viewVehicleMatches(evt, params) {
	            var ctrl = this;
	
	            ctrl.params = params || ctrl.params;
	
	            ctrl.loadingService.showLoading('vehicleList', 'Loading Matches');
	
	            ctrl.selectedVehicle = null;
	
	            ctrl.userService.salesMatches(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), ctrl.params.userId).then(function (response) {
	                ctrl.vehicleContactSalesMatches = response.data.vehicleContactSalesMatches;
	                if (ctrl.vehicleContactSalesMatches.length) {
	                    ctrl.selectedVehicle = ctrl.vehicleContactSalesMatches[0];
	                }
	
	                ctrl.onLoad({ count: ctrl.vehicleContactSalesMatches.length });
	            }).finally(function () {
	                ctrl.loadingService.hideLoading('vehicleList');
	            });
	        }
	    }]);
	    return VehicleMatchController;
	}();
	
	exports.default = VehicleMatchController;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1497);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleMatch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./vehicleMatch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleMatch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _webEnquiries = __webpack_require__(1499);
	
	var _webEnquiries2 = _interopRequireDefault(_webEnquiries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var webEnquiriesModule = _angular2.default.module('webEnquiries', [_angularUiRouter2.default]).component('webEnquiries', _webEnquiries2.default).name;
	
	exports.default = webEnquiriesModule;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _webEnquiries = __webpack_require__(1500);
	
	var _webEnquiries2 = _interopRequireDefault(_webEnquiries);
	
	var _webEnquiries3 = __webpack_require__(1501);
	
	var _webEnquiries4 = _interopRequireDefault(_webEnquiries3);
	
	__webpack_require__(1502);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var webEnquiriesComponent = {
	  restrict: 'E',
	  bindings: {
	    locationUsers: '=',
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _webEnquiries2.default,
	  controller: _webEnquiries4.default
	};
	
	exports.default = webEnquiriesComponent;

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"vehiclesList\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <ul uib-pagination\r\n            ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n            class=\"pull-right\"                \r\n            boundary-link-numbers=\"true\"\r\n            max-size=\"7\"\r\n            total-items=\"$ctrl.pagination.totalItems\"\r\n            items-per-page=\"$ctrl.pagination.pageSize\"\r\n            ng-model=\"$ctrl.pagination.currentPage\"\r\n            ng-change=\"$ctrl.viewWebEnquiries()\"\r\n            boundary-links=\"true\" \r\n            previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n    <div>\r\n            <table class=\"table table-bordered table-light\">\r\n                    <thead>\r\n                        <tr>\r\n                          <th class=\"col-md-3\">Subject</th>\r\n                          <th class=\"col-md-1\">Provider</th>\r\n                          <th class=\"col-md-2\">Contact</th>\r\n                          <th class=\"col-md-1\">Received</th>\r\n                          <th class=\"col-md-3\">Vehicle / Form</th>            \r\n                          <th ng-hide=\"$ctrl.authService.isManager() || $ctrl.authService.authData.currentLocation.webEnquiryManagerAssign\" class=\"dashboard-sticky-header-even\">Accept</th>\r\n                          <th ng-show=\"$ctrl.authService.isManager()\" class=\"dashboard-sticky-header-even\">Assign</th>\r\n                          <th ng-show=\"$ctrl.authService.isManager()\" class=\"dashboard-sticky-header-even\">Reject</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody data-ng-repeat=\"we in $ctrl.webEnquiries\">\r\n                        <tr>\r\n                            <td class=\"col-md-3\">{{ we.subject }}</td>\r\n                            <td class=\"col-md-1\">{{ we.providerName }}</td>\r\n                            <td class=\"col-md-2\">\r\n                              <span ng-if=\"!we.contactId\">\r\n                                  {{ we.contactName }}\r\n                              </span>\r\n              \r\n                              <span ng-if=\"we.contactId\">\r\n                                  <a ui-sref=\"contactView({contactId: we.contactId})\">\r\n                                    {{ we.contactName }}\r\n                                  </a>\r\n                              </span>                                \r\n                            </td>\r\n                            <td class=\"col-md-1\">{{ we.received | date : 'dd-MMM-yy HH:mm' }}</td>\r\n                            <td class=\"col-md-3\">\r\n                                <a href=\"{{we.link}}\" target=\"_blank\" ng-if=\"we.link\">\r\n                                    {{ we.vehicle || 'Click here'}}\r\n                                </a>\r\n\r\n                                <span ng-if=\"!we.link && we.vehicle\">\r\n                                  {{we.vehicle}}\r\n                                </span>\r\n                            </td>\r\n                            <td ng-hide=\"$ctrl.authService.isManager() || $ctrl.authService.authData.currentLocation.webEnquiryManagerAssign\">\r\n                              <a class=\"btn btn-primary\" href=\"#\" ng-click=\"$ctrl.acceptConfirm(we.webEnquiryId)\">Accept</a>\r\n                            </td>\r\n                            <td ng-show=\"$ctrl.authService.isManager()\">\r\n                              <a class=\"btn btn-primary\" href=\"#\" ng-click=\"$ctrl.assignConfirm(we.webEnquiryId, we.source)\">Assign</a>\r\n                            </td>\r\n                            <td ng-show=\"$ctrl.authService.isManager()\">\r\n                              <a class=\"btn btn-default\" href=\"#\" ng-click=\"$ctrl.deleteConfirm(we.webEnquiryId)\">Reject</a>\r\n                            </td>              \r\n                        </tr> \r\n                        <tr>\r\n                          <td colspan=\"8\" class=\"comment-cell\">\r\n                            <b>Comment</b> <br>\r\n                            <span marked=\"we.comment || 'No comment provided'\">\r\n                            </span>   \r\n                            <br ng-if=\"$ctrl.getTestDriveDate(we)\">\r\n                            <span ng-if=\"$ctrl.getTestDriveDate(we)\">\r\n                              <b>Requested Test Drive Date/Time:</b> {{$ctrl.getTestDriveDate(we)}}\r\n                            </span>\r\n                          </td>\r\n                        </tr>                                              \r\n                    </tbody>\r\n                </table>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebEnquiriesController = function () {
	  WebEnquiriesController.$inject = ["authService", "userService", "loadingService", "$scope", "webEnquiriesService", "$state", "$ngConfirm", "growl", "pushService", "$filter", "enums"];
	  function WebEnquiriesController(authService, userService, loadingService, $scope, webEnquiriesService, $state, $ngConfirm, growl, pushService, $filter, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, WebEnquiriesController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	    this.$scope = $scope;
	    this.webEnquiriesService = webEnquiriesService;
	    this.$state = $state;
	    this.$ngConfirm = $ngConfirm;
	    this.growl = growl;
	    this.pushService = pushService;
	    this.$filter = $filter;
	    this.enums = enums;
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    this.webEnquiries = [];
	
	    $scope.$on('dashboard:viewWebEnquiriesStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:viewWebEnquiries', this.viewWebEnquiries.bind(this));
	  }
	
	  (0, _createClass3.default)(WebEnquiriesController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      ctrl.userService.webEnquiriesStats(ctrl.authService.authData.currentLocation.key).then(function (response) {
	        ctrl.pagination.totalItems = response.data;
	        ctrl.onLoadStats({ count: response.data });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }, {
	    key: 'viewWebEnquiries',
	    value: function viewWebEnquiries(evt) {
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.webEnquiries.length) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      ctrl.userService.webEnquiries(ctrl.authService.authData.currentLocation.key, this.pagination.currentPage).then(function (response) {
	        ctrl.webEnquiries = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }, {
	    key: 'acceptConfirm',
	    value: function acceptConfirm(webEnquiryId) {
	      var _this = this;
	
	      this.$ngConfirm({
	        title: false,
	        content: 'Are you sure you want to accept this enquiry ?',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Accept',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this.createEnquiry(webEnquiryId, _this.authService.authData.userId, false);
	            }
	          },
	          no: {
	            text: 'Not Sure',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'assignConfirm',
	    value: function assignConfirm(webEnquiryId, source, confirm) {
	      var _this2 = this;
	
	      if (!confirm && source === this.enums.WEB_ENQUIRY_SOURCE.Codeweavers) {
	        this.getCodeweaversData(webEnquiryId);
	        return;
	      }
	
	      this.$scope.locationUsers = this.locationUsers;
	      this.$scope.selectedUser = this.locationUsers[0];
	      this.$scope.selectedUser.firstName = 'Please Select';
	
	      this.$ngConfirm({
	        title: 'Assign Enquiry',
	        contentUrl: 'templates/webEnquiry/assignWebEnquiry',
	        typeAnimation: false,
	        columnClass: 'm',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Assign',
	            btnClass: 'btn-primary',
	            action: function action() {
	              if (_this2.$scope.selectedUser.userId) {
	                _this2.createEnquiry(webEnquiryId, _this2.$scope.selectedUser.userId, true);
	              } else {
	                return false;
	              }
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'createEnquiry',
	    value: function createEnquiry(webEnquiryId, assignedTo, assignedByManager) {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      ctrl.webEnquiriesService.createEnquiry(webEnquiryId, assignedTo).then(function (response) {
	        if (!assignedByManager) {
	          _this3.$state.go('enquiryEdit', { enquiryId: response.data });
	        } else {
	          _this3.growl.success('Enquiry created successfully and has been assigned to ' + _this3.$scope.selectedUser.firstName + ' ' + _this3.$scope.selectedUser.lastName, { ttl: 5000 });
	          _this3.removeEnquiryAndUpdateCount(webEnquiryId);
	          if (assignedTo != _this3.authService.authData.userId) {
	            _this3.pushService.messageHub.enquiryCreatedFromWebEnquiry(assignedTo, response.data, _this3.authService.loggedInUserName());
	          }
	        }
	      }).catch(function (err) {
	        _this3.growl.error('An error occurred while creating enquiry', { ttl: 5000 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }, {
	    key: 'deleteConfirm',
	    value: function deleteConfirm(webEnquiryId) {
	      var _this4 = this;
	
	      this.$ngConfirm({
	        title: false,
	        content: 'Are you sure you want to reject this enquiry ?',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this4.deleteEnquiry(webEnquiryId);
	            }
	          },
	          no: {
	            text: 'Not Sure',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteEnquiry',
	    value: function deleteEnquiry(webEnquiryId) {
	      var _this5 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Loading Enquiries');
	
	      ctrl.webEnquiriesService.deleteEnquiry(webEnquiryId).then(function (response) {
	        _this5.growl.success('Enquiry rejected successfully', { ttl: 5000 });
	        _this5.removeEnquiryAndUpdateCount(webEnquiryId);
	      }).catch(function (err) {
	        _this5.growl.error('An error occurred while rejecting enquiry', { ttl: 5000 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }, {
	    key: 'removeEnquiryAndUpdateCount',
	    value: function removeEnquiryAndUpdateCount(webEnquiryId) {
	      var webEnquiry = this.webEnquiries.find(function (we) {
	        return we.webEnquiryId === webEnquiryId;
	      });
	      this.webEnquiries = (0, _lodash.without)(this.webEnquiries, webEnquiry);
	      this.onLoad({ count: this.webEnquiries.length });
	    }
	  }, {
	    key: 'getTestDriveDate',
	    value: function getTestDriveDate(we) {
	      if (we.additionalData) {
	        var data = JSON.parse(we.additionalData);
	
	        if (data.testDriveTime) {
	          return this.$filter('date')(new Date(data.testDriveTime), 'dd MMM yyyy HH:mm');
	        }
	      }
	    }
	  }, {
	    key: 'getCodeweaversData',
	    value: function getCodeweaversData(webEnquiryId) {
	      var _this6 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('vehiclesList', 'Getting Data');
	
	      ctrl.webEnquiriesService.getCodeweaversData(webEnquiryId).then(function (response) {
	        ctrl.$scope.data = response.data;
	
	        _this6.$ngConfirm({
	          title: 'Review Enquiry Data',
	          contentUrl: 'templates/webEnquiry/codeweaversDataTemplate',
	          typeAnimation: false,
	          columnClass: 'l',
	          scope: _this6.$scope,
	          buttons: {
	            yes: {
	              text: 'Go To Assign',
	              btnClass: 'btn-primary',
	              action: function action() {
	                ctrl.assignConfirm(webEnquiryId, ctrl.enums.WEB_ENQUIRY_SOURCE.Codeweavers, true);
	              }
	            },
	            no: {
	              text: 'Cancel',
	              btnClass: 'btn-default'
	            }
	          }
	        });
	      }).catch(function (err) {
	        _this6.growl.error('An error occurred while creating enquiry', { ttl: 5000 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('vehiclesList');
	      });
	    }
	  }]);
	  return WebEnquiriesController;
	}();
	
	exports.default = WebEnquiriesController;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1503);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./webEnquiries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./webEnquiries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".webEnquiries{color:red}.table-light{background-color:#f5f5f5}.comment-cell{font-size:10px;padding-bottom:10px;background-color:#d0cfc0}", ""]);
	
	// exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _expiringContacts = __webpack_require__(1505);
	
	var _expiringContacts2 = _interopRequireDefault(_expiringContacts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var expiringContactsModule = _angular2.default.module('expiringContacts', [_angularUiRouter2.default]).component('expiringContacts', _expiringContacts2.default).name;
	
	exports.default = expiringContactsModule;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _expiringContacts = __webpack_require__(1506);
	
	var _expiringContacts2 = _interopRequireDefault(_expiringContacts);
	
	var _expiringContacts3 = __webpack_require__(1507);
	
	var _expiringContacts4 = _interopRequireDefault(_expiringContacts3);
	
	__webpack_require__(1508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var expiringContactsComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _expiringContacts2.default,
	  controller: _expiringContacts4.default
	};
	
	exports.default = expiringContactsComponent;

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"contactList\">\r\n    <div>\r\n        <span class=\"label label-default\">Non-Customer Expiry Time: {{$ctrl.authService.authData.currentLocation.gdprMaintenance.contactExpiry}} days</span>\r\n        <span class=\"label label-default\">Customer Expiry Time: {{$ctrl.authService.authData.currentLocation.gdprMaintenance.customerExpiry}} days</span>\r\n        <span class=\"label label-default\">Notice Time: {{$ctrl.authService.authData.currentLocation.gdprMaintenance.contactExpiryNotice}} days</span>\r\n\r\n        <ul uib-pagination\r\n            ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n            class=\"pull-right\"                \r\n            boundary-link-numbers=\"true\"\r\n            max-size=\"7\"\r\n            total-items=\"$ctrl.pagination.totalItems\"\r\n            items-per-page=\"$ctrl.pagination.pageSize\"\r\n            ng-model=\"$ctrl.pagination.currentPage\"\r\n            ng-change=\"$ctrl.viewExpiringContacts()\"\r\n            boundary-links=\"true\" \r\n            previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n        </ul>\r\n    </div>\r\n    <div>\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                    <th class=\"col-md-2\">Contact Name</th>\r\n                    <th class=\"col-md-1\">Days Remaining</th>\r\n                    <th class=\"col-md-2\" ng-show=\"$ctrl.authService.isManager()\">Owner</th>                    \r\n                    <th class=\"col-md-2\" ng-show=\"$ctrl.authService.isManager()\">Last Modified</th>                    \r\n                    <th class=\"col-md-4\">Reason</th>\r\n                    <th class=\"col-md-1\" ng-show=\"$ctrl.authService.isManager()\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"c in $ctrl.contacts\" ng-class=\"{'danger' : c.timeRemaining <= 1}\">\r\n                    <td class=\"col-md-2\">\r\n                        <a ui-sref=\"contactView({contactId: c.contactId})\">\r\n                        {{c.contactName }}\r\n                        </a>                    \r\n                    </td>\r\n                    <td class=\"col-md-1\">{{ c.timeRemainingText }}</td>\r\n                    <td class=\"col-md-2\"ng-show=\"$ctrl.authService.isManager()\">{{ c.salesPerson }}</td>\r\n                    <td class=\"col-md-2\"ng-show=\"$ctrl.authService.isManager()\">{{ c.lastModified }}</td>\r\n                    <td class=\"col-md-4\">{{ c.reason }}</td>\r\n                    <td class=\"col-md-1\" ng-show=\"$ctrl.authService.isManager()\" style=\"align-content: center\" align=\"center\">\r\n                        <button ng-click=\"$ctrl.nukeContactConfirm(c)\" class=\"btn btn-danger\">\r\n                            <i class=\"fa fa-ban\"></i>\r\n                        </button>                            \r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n      "

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _moment = __webpack_require__(529);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpiringContactsController = function () {
	  ExpiringContactsController.$inject = ["authService", "userService", "loadingService", "$scope", "$ngConfirm", "contactService", "growl"];
	  function ExpiringContactsController(authService, userService, loadingService, $scope, $ngConfirm, contactService, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ExpiringContactsController);
	    this.authService = authService;
	    this.userService = userService;
	    this.loadingService = loadingService;
	    this.$scope = $scope;
	    this.$ngConfirm = $ngConfirm;
	    this.contactService = contactService;
	    this.growl = growl;
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    this.overrideUserId = null;
	    this.contacts = [];
	
	    $scope.$on('dashboard:viewExpiringContactsStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:viewExpiringContacts', this.viewExpiringContacts.bind(this));
	  }
	
	  (0, _createClass3.default)(ExpiringContactsController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');
	
	      this.overrideUserId = params ? params.userId : null;
	
	      ctrl.userService.expiringContactsStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId).then(function (response) {
	        ctrl.pagination.totalItems = response.data;
	        ctrl.onLoadStats({ count: response.data });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('contactList');
	      });
	    }
	  }, {
	    key: 'viewExpiringContacts',
	    value: function viewExpiringContacts(evt, params) {
	      var _this = this;
	
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.contacts.length && !params.reload) {
	        return;
	      }
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');
	
	      ctrl.userService.expiringContacts(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage).then(function (response) {
	        ctrl.contacts = response.data;
	        ctrl.contacts = (0, _lodash.map)(ctrl.contacts, _this.convertContact.bind(_this));
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('contactList');
	      });
	    }
	  }, {
	    key: 'nukeContactConfirm',
	    value: function nukeContactConfirm(contact) {
	      var _this2 = this;
	
	      this.$scope.contact = contact;
	
	      this.$ngConfirm({
	        title: 'Delete Contact',
	        contentUrl: 'templates/dashboard/nukeContactConfirmTemplate',
	        typeAnimation: false,
	        columnClass: 'm',
	        type: 'red',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Anonymize this Contact',
	            btnClass: 'btn-danger',
	            action: function action() {
	              _this2.nukeContact(contact);
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'nukeContact',
	    value: function nukeContact(contact) {
	      var _this3 = this;
	
	      this.loadingService.showLoading('contactList', 'Anonymizing Contact ...');
	
	      this.contactService.anonymize(contact.contactId).then(function (response) {
	        _this3.growl.success('Contact Anonymized Successfully ...', { ttl: 5000 });
	        _this3.contacts = (0, _lodash.without)(_this3.contacts, contact);
	      }).finally(function () {
	        _this3.loadingService.hideLoading('contactList');
	      });
	    }
	  }, {
	    key: 'isEmptyOrSpaces',
	    value: function isEmptyOrSpaces(str) {
	      return str === null || str.match(/^ *$/) !== null;
	    }
	  }, {
	    key: 'convertContact',
	    value: function convertContact(contact) {
	      var reason = void 0;
	
	      switch (contact.category) {
	        case 1:
	          reason = 'Contact has been inactive for over ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true);
	          break;
	
	        case 2:
	          reason = 'Due date for contact\'s promise lapsed ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
	          break;
	
	        case 3:
	          reason = 'A Lost Enquiry for contact was created ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
	          break;
	
	        case 4:
	          reason = 'An Open Enquiry for contact was created ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
	          break;
	
	        case 5:
	          reason = 'An Enquiry was Closed for contact ' + (0, _moment2.default)().add(contact.daysOver, 'd').fromNow(true) + ' ago';
	          break;
	      }
	
	      return {
	        contactId: contact.contactId,
	        contactName: this.isEmptyOrSpaces(contact.contactName) ? 'Blank' : contact.contactName,
	        timeRemaining: contact.timeRemaining,
	        timeRemainingText: contact.timeRemaining,
	        salesPerson: contact.salesPerson,
	        lastModified: contact.lastModifiedBySalesPerson,
	        reason: reason
	      };
	    }
	  }]);
	  return ExpiringContactsController;
	}();
	
	exports.default = ExpiringContactsController;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1509);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./expiringContacts.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./expiringContacts.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".danger td,.expiringContacts{color:red}", ""]);
	
	// exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _promise = __webpack_require__(1511);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _promiseList = __webpack_require__(1516);
	
	var _promiseList2 = _interopRequireDefault(_promiseList);
	
	var _promise3 = __webpack_require__(1528);
	
	var _promise4 = _interopRequireDefault(_promise3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promiseModule = _angular2.default.module('promise', [_angularUiRouter2.default, _promiseList2.default]).component('promise', _promise2.default).service('promiseService', _promise4.default).name;
	
	exports.default = promiseModule;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(1512);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _promise3 = __webpack_require__(1513);
	
	var _promise4 = _interopRequireDefault(_promise3);
	
	__webpack_require__(1514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promiseComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _promise2.default,
	  controller: _promise4.default
	};
	
	exports.default = promiseComponent;

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromiseController = function PromiseController() {
	  (0, _classCallCheck3.default)(this, PromiseController);
	
	  this.name = 'promise';
	};
	
	exports.default = PromiseController;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1515);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./promise.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./promise.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".promise{color:red}", ""]);
	
	// exports


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _promiseList = __webpack_require__(1517);
	
	var _promiseList2 = _interopRequireDefault(_promiseList);
	
	var _timePicker = __webpack_require__(1522);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promiseListModule = _angular2.default.module('promiseList', [_angularUiRouter2.default, _timePicker2.default]).component('promiseList', _promiseList2.default).name;
	
	exports.default = promiseListModule;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promiseList = __webpack_require__(1518);
	
	var _promiseList2 = _interopRequireDefault(_promiseList);
	
	var _promiseList3 = __webpack_require__(1519);
	
	var _promiseList4 = _interopRequireDefault(_promiseList3);
	
	__webpack_require__(1520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promiseListComponent = {
	  restrict: 'E',
	  bindings: {
	    onLoadStats: '&',
	    onLoad: '&'
	  },
	  template: _promiseList2.default,
	  controller: _promiseList4.default
	};
	
	exports.default = promiseListComponent;

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"promiseList\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <a class=\"btn btn-primary\" ng-click=\"$ctrl.showAddPromise()\">Add New Promise</a>    \r\n    </div>\r\n    <div class=\"col-md-9\">\r\n      <ul uib-pagination\r\n        ng-show=\"$ctrl.pagination.totalItems > 0\"\r\n        class=\"pull-right\"                \r\n        boundary-link-numbers=\"true\"\r\n        max-size=\"7\"\r\n        total-items=\"$ctrl.pagination.totalItems\"\r\n        items-per-page=\"$ctrl.pagination.pageSize\"\r\n        ng-model=\"$ctrl.pagination.currentPage\"\r\n        ng-change=\"$ctrl.listPromises()\"\r\n        boundary-links=\"true\" \r\n        previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n      </ul>\r\n    </div>\r\n  </div>\r\n  \r\n  <div>\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n          <thead>\r\n              <tr>\r\n                <th>Due Date</th>\r\n                <th>Category</th>\r\n                <th>Contact</th>\r\n                <th>Subject</th>\r\n                <th ng-show=\"$ctrl.authService.isManager()\">\r\n                  Owner\r\n                </th>\r\n              </tr>\r\n          </thead>\r\n          <tbody>\r\n              <tr data-ng-repeat=\"p in $ctrl.promises\" ng-class=\"{'overduePromise': p.isDue}\">\r\n                <td>{{p.dueDate | date : 'dd MMM yy HH:mm'}}</td>\r\n                <td>{{p.category}}</td>\r\n                <td>\r\n                  <a ui-sref=\"contactView({contactId: p.contactId})\">\r\n                    {{p.contactName}}\r\n                  </a>\r\n                </td>\r\n                <td>\r\n                  <a href=\"#\" ng-click=\"$ctrl.viewPromise(p)\">\r\n                    {{p.subject}}\r\n                  </a>\r\n                </td>\r\n                <td ng-show=\"$ctrl.authService.isManager()\">\r\n                  <a href=\"#\" ng-click=\"$ctrl.updateOwner(p.promiseId)\">\r\n                    {{p.owner}}\r\n                  </a>\r\n                </td>\r\n              </tr>\r\n          </tbody>\r\n      </table>\r\n  </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _viewPromiseModal = __webpack_require__(1289);
	
	var _viewPromiseModal2 = _interopRequireDefault(_viewPromiseModal);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromiseListController = function () {
	  PromiseListController.$inject = ["authService", "userService", "promiseService", "loadingService", "addPromiseService", "$uibModal", "$scope", "enums"];
	  function PromiseListController(authService, userService, promiseService, loadingService, addPromiseService, $uibModal, $scope, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PromiseListController);
	    this.authService = authService;
	    this.userService = userService;
	    this.promiseService = promiseService;
	    this.loadingService = loadingService;
	    this.addPromiseService = addPromiseService;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.enums = enums;
	
	    this.overrideUserId = null;
	    this.selectedDate = null;
	    this.promises = [];
	
	    this.pagination = {
	      totalItems: 0,
	      currentPage: 1,
	      pageSize: 10
	    };
	
	    $scope.$on('dashboard:promisesStats', this.loadStats.bind(this));
	    $scope.$on('dashboard:promises', this.listPromises.bind(this));
	  }
	
	  (0, _createClass3.default)(PromiseListController, [{
	    key: 'loadStats',
	    value: function loadStats(evt, params) {
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('promiseList', 'Loading Promises');
	
	      this.overrideUserId = params ? params.userId : null;
	      this.selectedDate = params ? params.selectedDate : new Date();
	
	      ctrl.userService.promisesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate).then(function (response) {
	        ctrl.pagination.totalItems = response.data.item3;
	        ctrl.onLoadStats({ dueToday: response.data.item1, overdue: response.data.item2 });
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('promiseList');
	      });
	    }
	  }, {
	    key: 'listPromises',
	    value: function listPromises(evt, params) {
	      var _this = this;
	
	      //Toggle Event coming from dashboard instead of page change, skip the method
	      if (evt && this.promises.length && !params.reload) {
	        return;
	      }
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('promiseList', 'Loading Promises');
	
	      ctrl.userService.promises(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate, this.pagination.currentPage).then(function (response) {
	        _this.promises = response.data;
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('promiseList');
	      });
	    }
	  }, {
	    key: 'showAddPromise',
	    value: function showAddPromise(contact) {
	      var _this2 = this;
	
	      this.addPromiseService.showAddPromise(function () {
	        _this2.listPromises();
	      }, null, null, contact, true);
	    }
	  }, {
	    key: 'updateOwner',
	    value: function updateOwner(promiseId) {
	      var _this3 = this;
	
	      this.addPromiseService.showUpdateOwner(promiseId, function () {
	        _this3.listPromises();
	      });
	    }
	  }, {
	    key: 'complete',
	    value: function complete(addAnother) {
	      var ctrl = this;
	
	      var sure = window.confirm('Are you sure you want to complete this promise');
	
	      if (!sure) {
	        return;
	      }
	
	      ctrl.promiseService.complete(this.selectedPromise.promiseId, this.tempComments).finally(function () {
	        ctrl.closeModal();
	        ctrl.listPromises();
	
	        if (addAnother) {
	          var contact = null;
	          if (ctrl.selectedPromise.categoryId === ctrl.enums.PROMISE_CATEGORY.Customer) {
	            contact = {
	              contactId: ctrl.selectedPromise.contactId,
	              contactName: ctrl.selectedPromise.contactName
	            };
	          }
	
	          ctrl.showAddPromise(contact);
	        }
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var ctrl = this;
	
	      if (ctrl.modalInstance) {
	        ctrl.modalInstance.close();
	      }
	    }
	  }, {
	    key: 'viewPromise',
	    value: function viewPromise(promise) {
	      this.errMsg = '';
	      this.tempComments = '';
	      this.selectedPromise = promise;
	      this.modalInstance = this.$uibModal.open({
	        template: _viewPromiseModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'completePromise',
	    value: function completePromise(addAnother) {
	      if (!this.tempComments) {
	        this.errMsg = "Please enter some comments first";
	        return;
	      }
	
	      this.complete(addAnother);
	    }
	  }]);
	  return PromiseListController;
	}();
	
	exports.default = PromiseListController;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1521);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./promiseList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./promiseList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".overduePromise{color:red}", ""]);
	
	// exports


/***/ }),
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromiseService = function () {
	  PromiseService.$inject = ["$http", "appConfig"];
	  function PromiseService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PromiseService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(PromiseService, [{
	    key: "addPromise",
	    value: function addPromise(promise) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/promise/add/", promise);
	    }
	  }, {
	    key: "updateOwner",
	    value: function updateOwner(promiseId, ownerId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/promise/updateowner/" + promiseId + "/" + ownerId));
	    }
	  }, {
	    key: "complete",
	    value: function complete(promiseId, comments) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + "api/promise/complete", { promiseId: promiseId, comments: comments });
	    }
	  }]);
	  return PromiseService;
	}();
	
	exports.default = PromiseService;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reports = __webpack_require__(1530);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _reporting = __webpack_require__(1535);
	
	var _reporting2 = _interopRequireDefault(_reporting);
	
	var _showroomTraffic = __webpack_require__(1536);
	
	var _showroomTraffic2 = _interopRequireDefault(_showroomTraffic);
	
	var _favoriteReports = __webpack_require__(1542);
	
	var _favoriteReports2 = _interopRequireDefault(_favoriteReports);
	
	var _salesReport = __webpack_require__(1548);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	var _allEnquiries = __webpack_require__(1554);
	
	var _allEnquiries2 = _interopRequireDefault(_allEnquiries);
	
	var _dealTimeline = __webpack_require__(1560);
	
	var _dealTimeline2 = _interopRequireDefault(_dealTimeline);
	
	var _deliveryPastEnquiries = __webpack_require__(1566);
	
	var _deliveryPastEnquiries2 = _interopRequireDefault(_deliveryPastEnquiries);
	
	var _appraisalAnalysis = __webpack_require__(1572);
	
	var _appraisalAnalysis2 = _interopRequireDefault(_appraisalAnalysis);
	
	var _contactsDataEntryMetric = __webpack_require__(1578);
	
	var _contactsDataEntryMetric2 = _interopRequireDefault(_contactsDataEntryMetric);
	
	var _lostDealAnalysis = __webpack_require__(1584);
	
	var _lostDealAnalysis2 = _interopRequireDefault(_lostDealAnalysis);
	
	var _marketingConversion = __webpack_require__(1590);
	
	var _marketingConversion2 = _interopRequireDefault(_marketingConversion);
	
	var _salesPersonConversion = __webpack_require__(1596);
	
	var _salesPersonConversion2 = _interopRequireDefault(_salesPersonConversion);
	
	var _showroomDetailed = __webpack_require__(1602);
	
	var _showroomDetailed2 = _interopRequireDefault(_showroomDetailed);
	
	var _testDrives = __webpack_require__(1608);
	
	var _testDrives2 = _interopRequireDefault(_testDrives);
	
	var _tradePriceList = __webpack_require__(1614);
	
	var _tradePriceList2 = _interopRequireDefault(_tradePriceList);
	
	var _leadTracker = __webpack_require__(1620);
	
	var _leadTracker2 = _interopRequireDefault(_leadTracker);
	
	var _reportSummary = __webpack_require__(1626);
	
	var _reportSummary2 = _interopRequireDefault(_reportSummary);
	
	var _reportData = __webpack_require__(1632);
	
	var _reportData2 = _interopRequireDefault(_reportData);
	
	var _financeDetail = __webpack_require__(1638);
	
	var _financeDetail2 = _interopRequireDefault(_financeDetail);
	
	var _financeSummary = __webpack_require__(1644);
	
	var _financeSummary2 = _interopRequireDefault(_financeSummary);
	
	var _bankSummary = __webpack_require__(1650);
	
	var _bankSummary2 = _interopRequireDefault(_bankSummary);
	
	var _modelEnquiry = __webpack_require__(1656);
	
	var _modelEnquiry2 = _interopRequireDefault(_modelEnquiry);
	
	var _salesTrend = __webpack_require__(1662);
	
	var _salesTrend2 = _interopRequireDefault(_salesTrend);
	
	var _reportableAddons = __webpack_require__(1668);
	
	var _reportableAddons2 = _interopRequireDefault(_reportableAddons);
	
	var _systemUsage = __webpack_require__(1674);
	
	var _systemUsage2 = _interopRequireDefault(_systemUsage);
	
	var _enquiryPayments = __webpack_require__(1680);
	
	var _enquiryPayments2 = _interopRequireDefault(_enquiryPayments);
	
	var _promisesReport = __webpack_require__(1686);
	
	var _promisesReport2 = _interopRequireDefault(_promisesReport);
	
	var _marketingConsent = __webpack_require__(1692);
	
	var _marketingConsent2 = _interopRequireDefault(_marketingConsent);
	
	var _digitalSignatures = __webpack_require__(1698);
	
	var _digitalSignatures2 = _interopRequireDefault(_digitalSignatures);
	
	var _SourceOfEnquiry = __webpack_require__(1704);
	
	var _SourceOfEnquiry2 = _interopRequireDefault(_SourceOfEnquiry);
	
	var _salesMatch = __webpack_require__(1716);
	
	var _salesMatch2 = _interopRequireDefault(_salesMatch);
	
	var _lastLogin = __webpack_require__(1722);
	
	var _lastLogin2 = _interopRequireDefault(_lastLogin);
	
	var _vehicleImports = __webpack_require__(1728);
	
	var _vehicleImports2 = _interopRequireDefault(_vehicleImports);
	
	var _reportsUsage = __webpack_require__(1734);
	
	var _reportsUsage2 = _interopRequireDefault(_reportsUsage);
	
	var _weeklySalesActivity = __webpack_require__(1741);
	
	var _weeklySalesActivity2 = _interopRequireDefault(_weeklySalesActivity);
	
	var _cashFlow = __webpack_require__(1747);
	
	var _cashFlow2 = _interopRequireDefault(_cashFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsModule = _angular2.default.module('reports', [_angularUiRouter2.default, _showroomTraffic2.default, _favoriteReports2.default, _salesReport2.default, _allEnquiries2.default, _dealTimeline2.default, _deliveryPastEnquiries2.default, _appraisalAnalysis2.default, _contactsDataEntryMetric2.default, _lostDealAnalysis2.default, _marketingConversion2.default, _salesPersonConversion2.default, _showroomDetailed2.default, _testDrives2.default, _tradePriceList2.default, _leadTracker2.default, _reportSummary2.default, _reportData2.default, _financeDetail2.default, _financeSummary2.default, _bankSummary2.default, _modelEnquiry2.default, _salesTrend2.default, _reportableAddons2.default, _systemUsage2.default, _enquiryPayments2.default, _promisesReport2.default, _marketingConsent2.default, _digitalSignatures2.default, _SourceOfEnquiry2.default, _salesMatch2.default, _lastLogin2.default, _vehicleImports2.default, _reportsUsage2.default, _weeklySalesActivity2.default, _cashFlow2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('reportsLanding', {
	    component: 'reports',
	    url: '/reports'
	  });
	}]).service('reportingService', _reporting2.default).component('reports', _reports2.default).name;
	
	exports.default = reportsModule;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reports = __webpack_require__(1531);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _reports3 = __webpack_require__(1532);
	
	var _reports4 = _interopRequireDefault(_reports3);
	
	__webpack_require__(1533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _reports2.default,
	  controller: _reports4.default
	};
	
	exports.default = reportsComponent;

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Reporting Suite</h2>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"reports\">\r\n    <div class=\"panel\">\r\n      <uib-accordion close-others=\"true\">\r\n        <div uib-accordion-group class=\"panel-default\" ng-repeat=\"cat in $ctrl.availableReports\">\r\n\r\n          <uib-accordion-heading>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-11\">\r\n                {{cat[0].categoryName}} ({{cat.length}})\r\n              </div>\r\n              <div class=\"col-md-1\">\r\n                <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels[cat[0].categoryId].visible, 'glyphicon-chevron-down': !$ctrl.panels.basicDetails.visible}\"></i>\r\n              </div>\r\n            </div>\r\n          </uib-accordion-heading>\r\n\r\n          <div>\r\n            <div class=\"list-group\" ng-repeat=\"r in cat\">\r\n              <a ui-sref=\"{{r.stateName}}\" class=\"list-group-item\">\r\n                <h4 class=\"list-group-item-heading\">{{r.name}}</h4>\r\n                <p class=\"list-group-item-text\">{{r.description}}</p>\r\n              </a>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </uib-accordion>\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsController = function () {
	  ReportsController.$inject = ["authService", "reportingService", "loadingService"];
	  function ReportsController(authService, reportingService, loadingService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportsController);
	    if (!authService.isLoggedIn()) {
	      return;
	    };
	
	    this.authService = authService;
	    this.reportingService = reportingService;
	    this.loadingService = loadingService;
	
	    this.availableReports = [];
	    this.loadReports();
	  }
	
	  (0, _createClass3.default)(ReportsController, [{
	    key: 'loadReports',
	    value: function loadReports() {
	      var _this = this;
	
	      this.loadingService.showLoading('reports', 'Loading Reports ...');
	
	      this.reportingService.availableReportsByCategory(this.authService.authData.currentLocation.key, this.authService.getRole().roleId).then(function (response) {
	        _this.availableReports = (0, _lodash.groupBy)(response.data, function (o) {
	          return o.categoryName;
	        });
	      }).catch(function (err) {}).finally(function () {
	        _this.loadingService.hideLoading('reports');
	      });
	    }
	  }]);
	  return ReportsController;
	}();
	
	exports.default = ReportsController;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1534);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./reports.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./reports.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".zef-report-data{height:100%;min-height:300px;max-height:600px;overflow:auto!important}.zef-report-data table{width:100%;table-layout:fixed}.zef-report-data td,.zef-report-data th{padding:10px 10px 5px}.zef-report-data th{font-family:Montserrat-Medium;font-size:8pt;color:#fff;line-height:1.4;text-transform:uppercase;background-color:#4d585a}.zef-report-data td{font-family:Montserrat-Regular;font-size:8pt;color:#666;line-height:1.4}.zef-report-data tbody tr:nth-child(odd){background-color:#f9f9f9}.zef-report-data tbody tr:nth-child(2n){background-color:var(--report-even-row)}.zef-report-data td:hover{background-color:var(--report-even-hover);color:#000}.zef-report-data .no-data{width:100%;height:100%;padding-top:50px;font-size:24px;font-weight:700;text-align:center}.zef-report-data .column100{width:100px}.zef-report-data .column150{width:150px}.zef-report-data .column200{width:200px}.report-summary{font-size:14px;table-layout:fixed;width:100%}.report-summary tr{padding-bottom1:10px}.report-summary td{padding-left:5px;padding-top:10px;padding-bottom:10px;margin-top:10px;margin-bottom:10px;width:16%}.report-summary .key{font-weight:700}.report-summary .value{text-align:center}.report-summary tbody tr:nth-child(odd){background-color:#f9f9f9}.report-summary tbody tr:nth-child(2n){background-color:var(--report-even-row)}.zef-report-data .totalsRow{padding-bottom:20px!important;background-color:#596568!important}.zef-report-data .totalsRow td{color:gold;font-weight:700;padding-top:10px!important;padding-bottom:10px!important}.zef-report-data .totalsRow td:hover{background-color:gold;color:#596568}.zef-report-data .center{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportingService = function () {
	  ReportingService.$inject = ["$http", "appConfig"];
	  function ReportingService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportingService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(ReportingService, [{
	    key: "getDateRange",
	    value: function getDateRange(rangeType) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/reports/daterange/" + rangeType));
	    }
	  }, {
	    key: "getFavoriteReports",
	    value: function getFavoriteReports(entityId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/reports/listfavorites/" + entityId));
	    }
	  }, {
	    key: "updateFavoriteReports",
	    value: function updateFavoriteReports(entityId, reportIds) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/reports/updatefavorites/" + entityId + "/" + reportIds));
	    }
	  }, {
	    key: "availableReportsByCategory",
	    value: function availableReportsByCategory(entityId, roleId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/reports/list/" + entityId + "/" + roleId));
	    }
	  }, {
	    key: "runReport",
	    value: function runReport(reportName, criteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/reports/" + reportName), criteria);
	    }
	  }, {
	    key: "runVisualReport",
	    value: function runVisualReport(reportName, criteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/visualreports/" + reportName), criteria);
	    }
	  }]);
	  return ReportingService;
	}();
	
	exports.default = ReportingService;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _showroomTraffic = __webpack_require__(1537);
	
	var _showroomTraffic2 = _interopRequireDefault(_showroomTraffic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showroomTrafficModule = _angular2.default.module('showroomTraffic', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('showroomTraffic', {
	    component: 'showroomTraffic',
	    url: '/reports/showroomTraffic'
	  });
	}]).component('showroomTraffic', _showroomTraffic2.default).name;
	
	exports.default = showroomTrafficModule;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showroomTraffic = __webpack_require__(1538);
	
	var _showroomTraffic2 = _interopRequireDefault(_showroomTraffic);
	
	var _showroomTraffic3 = __webpack_require__(1539);
	
	var _showroomTraffic4 = _interopRequireDefault(_showroomTraffic3);
	
	__webpack_require__(1540);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showroomTrafficComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _showroomTraffic2.default,
	  controller: _showroomTraffic4.default
	};
	
	exports.default = showroomTrafficComponent;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Showroom Traffic Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>        \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowroomTrafficController = function (_BaseReportController) {
	  ShowroomTrafficController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(ShowroomTrafficController, _BaseReportController);
	
	  function ShowroomTrafficController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ShowroomTrafficController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowroomTrafficController.__proto__ || (0, _getPrototypeOf2.default)(ShowroomTrafficController)).call(this, reportingService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShowroomTrafficController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'showroomTraffic',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Showroom Traffic', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Showroom Traffic', this.parseCriteria());
	    }
	  }]);
	  return ShowroomTrafficController;
	}(_baseReportController2.default);
	
	exports.default = ShowroomTrafficController;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1541);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./showroomTraffic.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./showroomTraffic.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".showroomTraffic{color:red}", ""]);
	
	// exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _favoriteReports = __webpack_require__(1543);
	
	var _favoriteReports2 = _interopRequireDefault(_favoriteReports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var favoriteReportsModule = _angular2.default.module('favoriteReports', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('favoriteReports', {
	    component: 'favoriteReports',
	    url: '/reports/favorites'
	  });
	}]).component('favoriteReports', _favoriteReports2.default).name;
	
	exports.default = favoriteReportsModule;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _favoriteReports = __webpack_require__(1544);
	
	var _favoriteReports2 = _interopRequireDefault(_favoriteReports);
	
	var _favoriteReports3 = __webpack_require__(1545);
	
	var _favoriteReports4 = _interopRequireDefault(_favoriteReports3);
	
	__webpack_require__(1546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var favoriteReportsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _favoriteReports2.default,
	  controller: _favoriteReports4.default
	};
	
	exports.default = favoriteReportsComponent;

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container no-print\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Manage Favourite Reports</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.saveChanges()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Save Changes\r\n        </a>\r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div block-ui=\"favReports\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-5\">\r\n            All Reports\r\n            <select\r\n              class=\"form-control report-select\"\r\n              multiple=\"multiple\"\r\n              ng-options=\"item.name for item in $ctrl.allReports track by item.reportId\"\r\n              ng-model=\"$ctrl.selAllReports\">\r\n            </select>\r\n          </div>\r\n          <div class=\"col-md-2 arrows\">\r\n            <a class=\"btn btn-default\" ng-click=\"$ctrl.selectReports()\">\r\n              <span class=\"fa fa-arrow-right\"></span>\r\n              Select\r\n            </a>\r\n\r\n            <br /></br>\r\n\r\n            <a class=\"btn btn-default\" ng-click=\"$ctrl.deselectReports()\">\r\n              <span class=\"fa fa-arrow-left\"></span>\r\n              Deselect\r\n            </a>\r\n          </div>\r\n          <div class=\"col-md-5\">\r\n            Favourite Reports\r\n            <select\r\n              class=\"form-control report-select\"\r\n              multiple=\"multiple\"\r\n              ng-options=\"item.name for item in $ctrl.favReports track by item.reportId\"\r\n              ng-model=\"$ctrl.selFavReports\">\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavoriteReportsController = function () {
	  FavoriteReportsController.$inject = ["authService", "reportingService", "loadingService", "$state"];
	  function FavoriteReportsController(authService, reportingService, loadingService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FavoriteReportsController);
	    this.authService = authService;
	    this.reportingService = reportingService;
	    this.loadingService = loadingService;
	    this.$state = $state;
	
	    this.loadReports();
	    this.allReports = [];
	    this.favReports = [];
	    this.selAllReports = [];
	    this.selFavReports = [];
	  }
	
	  (0, _createClass3.default)(FavoriteReportsController, [{
	    key: 'loadReports',
	    value: function loadReports() {
	      var _this = this;
	
	      this.loadingService.showLoading('favReports', 'Loading Reports ...');
	
	      this.reportingService.getFavoriteReports(this.authService.authData.currentLocation.key).then(function (response) {
	        _this.allReports = response.data.allReports;
	        _this.favReports = response.data.favoriteReports;
	
	        _this.sortReports();
	      }).catch(function (err) {}).finally(function () {
	        _this.loadingService.hideLoading('favReports');
	      });
	    }
	  }, {
	    key: 'sortReports',
	    value: function sortReports() {
	      this.allReports = (0, _lodash.sortBy)(this.allReports, 'name');
	      this.favReports = (0, _lodash.sortBy)(this.favReports, 'name');
	    }
	  }, {
	    key: 'selectReports',
	    value: function selectReports() {
	      var _favReports;
	
	      var selReportIds = this.selAllReports.map(function (r) {
	        return r.reportId;
	      });
	      var selReportItems = (0, _lodash.filter)(this.allReports, function (o) {
	        return (0, _lodash.find)(selReportIds, function (repId) {
	          return o.reportId === repId;
	        });
	      });
	      this.allReports = _lodash.without.apply(undefined, [this.allReports].concat((0, _toConsumableArray3.default)(selReportItems)));
	      (_favReports = this.favReports).push.apply(_favReports, (0, _toConsumableArray3.default)(selReportItems));
	      this.selAllReports = [];
	
	      this.sortReports();
	    }
	  }, {
	    key: 'deselectReports',
	    value: function deselectReports() {
	      var _allReports;
	
	      var selReportIds = this.selFavReports.map(function (r) {
	        return r.reportId;
	      });
	      var selReportItems = (0, _lodash.filter)(this.favReports, function (o) {
	        return (0, _lodash.find)(selReportIds, function (repId) {
	          return o.reportId === repId;
	        });
	      });
	      this.favReports = _lodash.without.apply(undefined, [this.favReports].concat((0, _toConsumableArray3.default)(selReportItems)));
	      (_allReports = this.allReports).push.apply(_allReports, (0, _toConsumableArray3.default)(selReportItems));
	      this.selFavReports = [];
	
	      this.sortReports();
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('favReports', 'Saving Changes ...');
	
	      var favReportIds = this.favReports.map(function (r) {
	        return r.reportId;
	      });
	
	      this.reportingService.updateFavoriteReports(this.authService.authData.currentLocation.key, favReportIds).then(function (response) {
	        _this2.$state.go('reportsLanding');
	      }).catch(function (err) {}).finally(function () {
	        _this2.loadingService.hideLoading('favReports');
	      });
	    }
	  }]);
	  return FavoriteReportsController;
	}();
	
	exports.default = FavoriteReportsController;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1547);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./favoriteReports.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./favoriteReports.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".report-select{height:400px!important}", ""]);
	
	// exports


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _salesReport = __webpack_require__(1549);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesReportModule = _angular2.default.module('salesReport', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesReport', {
	    component: 'salesReport',
	    url: '/reports/salesReport'
	  });
	}]).component('salesReport', _salesReport2.default).name;
	
	exports.default = salesReportModule;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesReport = __webpack_require__(1550);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	var _salesReport3 = __webpack_require__(1551);
	
	var _salesReport4 = _interopRequireDefault(_salesReport3);
	
	__webpack_require__(1552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesReportComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _salesReport2.default,
	  controller: _salesReport4.default
	};
	
	exports.default = salesReportComponent;

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Sales Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>           \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n              \r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        New / Used\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Trade / Retail\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Date Range Type\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>"

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesReportController = function (_BaseReportController) {
	  SalesReportController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(SalesReportController, _BaseReportController);
	
	  function SalesReportController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SalesReportController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SalesReportController.__proto__ || (0, _getPrototypeOf2.default)(SalesReportController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryContactList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(SalesReportController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'salesReport',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Sales', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Sales', this.parseCriteria());
	    }
	  }]);
	  return SalesReportController;
	}(_baseReportController2.default);
	
	exports.default = SalesReportController;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1553);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesReport.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesReport.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".salesReport{color:red}", ""]);
	
	// exports


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _allEnquiries = __webpack_require__(1555);
	
	var _allEnquiries2 = _interopRequireDefault(_allEnquiries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allEnquiriesModule = _angular2.default.module('allEnquiries', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('allEnquiries', {
	    component: 'allEnquiries',
	    url: '/reports/allEnquiries'
	  });
	}]).component('allEnquiries', _allEnquiries2.default).name;
	
	exports.default = allEnquiriesModule;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _allEnquiries = __webpack_require__(1556);
	
	var _allEnquiries2 = _interopRequireDefault(_allEnquiries);
	
	var _allEnquiries3 = __webpack_require__(1557);
	
	var _allEnquiries4 = _interopRequireDefault(_allEnquiries3);
	
	__webpack_require__(1558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allEnquiriesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _allEnquiries2.default,
	  controller: _allEnquiries4.default
	};
	
	exports.default = allEnquiriesComponent;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>All Enquiries Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n          </a>                  \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"panel\">\r\n              \r\n                      <!-- alerts -->\r\n                      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                        <div>\r\n                          Please correct the following errors before proceeding <br> <br>\r\n                        </div>\r\n              \r\n                        <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                          &emsp; - {{msg}} <br>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Date Range\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                            ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          New / Used\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Start Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          End Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Location\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                            ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.location\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Sales Rep\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.user\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Make\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                            ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brand\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Model\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Status\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                          </select>\r\n                        </div>\r\n\r\n                        <div class=\"col-md-2\">\r\n                            Trade / Retail\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                            </select>\r\n                          </div>                                      \r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                          <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                            <i class=\"fa fa-table\"></i>\r\n                            View Report\r\n                          </a>\r\n              \r\n                          <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                            Clear Filters\r\n                          </a>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>              \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllEnquiriesController = function (_BaseReportController) {
	  AllEnquiriesController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(AllEnquiriesController, _BaseReportController);
	
	  function AllEnquiriesController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AllEnquiriesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AllEnquiriesController.__proto__ || (0, _getPrototypeOf2.default)(AllEnquiriesController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryStatusList();
	      _this.getEnquiryContactList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AllEnquiriesController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'allEnquiries',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('All Enquiries', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('All Enquiries', this.parseCriteria());
	    }
	  }]);
	  return AllEnquiriesController;
	}(_baseReportController2.default);
	
	exports.default = AllEnquiriesController;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1559);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./allEnquiries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./allEnquiries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".allEnquiries{color:red}", ""]);
	
	// exports


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dealTimeline = __webpack_require__(1561);
	
	var _dealTimeline2 = _interopRequireDefault(_dealTimeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dealTimelineModule = _angular2.default.module('dealTimeline', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('dealTimeline', {
	    component: 'dealTimeline',
	    url: '/reports/dealTimeline'
	  });
	}]).component('dealTimeline', _dealTimeline2.default).name;
	
	exports.default = dealTimelineModule;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dealTimeline = __webpack_require__(1562);
	
	var _dealTimeline2 = _interopRequireDefault(_dealTimeline);
	
	var _dealTimeline3 = __webpack_require__(1563);
	
	var _dealTimeline4 = _interopRequireDefault(_dealTimeline3);
	
	__webpack_require__(1564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dealTimelineComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _dealTimeline2.default,
	  controller: _dealTimeline4.default
	};
	
	exports.default = dealTimelineComponent;

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Deal Timeline Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Trade / Retail\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                        </select>\r\n                        </div>                                              \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Status\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Origination\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryOriginationList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryOrigination\">\r\n                        </select>\r\n                      </div>                                                                   \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>             \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DealTimelineController = function (_BaseReportController) {
	  DealTimelineController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(DealTimelineController, _BaseReportController);
	
	  function DealTimelineController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DealTimelineController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DealTimelineController.__proto__ || (0, _getPrototypeOf2.default)(DealTimelineController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getEnquiryContactList();
	      _this.getEnquiryOriginationList();
	      _this.getEnquiryStatusList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(DealTimelineController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryOriginationList',
	    value: function getEnquiryOriginationList() {
	      this.enquiryOriginationList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_ORIGINATION);
	      this.enquiryOriginationList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[0];
	      this.reportCriteria.enquiryOrigination = this.enquiryOriginationList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'dealTimeline',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.enquiryOrigination = this.reportCriteria.enquiryOrigination.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Deal Timeline', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Deal Timeline', this.parseCriteria());
	    }
	  }]);
	  return DealTimelineController;
	}(_baseReportController2.default);
	
	exports.default = DealTimelineController;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1565);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./dealTimeline.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./dealTimeline.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".dealTimeline{color:red}", ""]);
	
	// exports


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _deliveryPastEnquiries = __webpack_require__(1567);
	
	var _deliveryPastEnquiries2 = _interopRequireDefault(_deliveryPastEnquiries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPastEnquiriesModule = _angular2.default.module('deliveryPastEnquiries', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('deliveryPastEnquiries', {
	    component: 'deliveryPastEnquiries',
	    url: '/reports/deliveryPastEnquiries'
	  });
	}]).component('deliveryPastEnquiries', _deliveryPastEnquiries2.default).name;
	
	exports.default = deliveryPastEnquiriesModule;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deliveryPastEnquiries = __webpack_require__(1568);
	
	var _deliveryPastEnquiries2 = _interopRequireDefault(_deliveryPastEnquiries);
	
	var _deliveryPastEnquiries3 = __webpack_require__(1569);
	
	var _deliveryPastEnquiries4 = _interopRequireDefault(_deliveryPastEnquiries3);
	
	__webpack_require__(1570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliveryPastEnquiriesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _deliveryPastEnquiries2.default,
	  controller: _deliveryPastEnquiries4.default
	};
	
	exports.default = deliveryPastEnquiriesComponent;

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Enquiries where Delivery Past Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        New / Used\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>             \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveryPastEnquiriesController = function (_BaseReportController) {
	  DeliveryPastEnquiriesController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(DeliveryPastEnquiriesController, _BaseReportController);
	
	  function DeliveryPastEnquiriesController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeliveryPastEnquiriesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DeliveryPastEnquiriesController.__proto__ || (0, _getPrototypeOf2.default)(DeliveryPastEnquiriesController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(DeliveryPastEnquiriesController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'deliveryPastEnquiries',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Delivery Past Enquiries', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Delivery Past Enquiries', this.parseCriteria());
	    }
	  }]);
	  return DeliveryPastEnquiriesController;
	}(_baseReportController2.default);
	
	exports.default = DeliveryPastEnquiriesController;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1571);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveryPastEnquiries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./deliveryPastEnquiries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".deliveryPastEnquiries{color:red}", ""]);
	
	// exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appraisalAnalysis = __webpack_require__(1573);
	
	var _appraisalAnalysis2 = _interopRequireDefault(_appraisalAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appraisalAnalysisModule = _angular2.default.module('appraisalAnalysis', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('appraisalAnalysis', {
	    component: 'appraisalAnalysis',
	    url: '/reports/appraisalAnalysis'
	  });
	}]).component('appraisalAnalysis', _appraisalAnalysis2.default).name;
	
	exports.default = appraisalAnalysisModule;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appraisalAnalysis = __webpack_require__(1574);
	
	var _appraisalAnalysis2 = _interopRequireDefault(_appraisalAnalysis);
	
	var _appraisalAnalysis3 = __webpack_require__(1575);
	
	var _appraisalAnalysis4 = _interopRequireDefault(_appraisalAnalysis3);
	
	__webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appraisalAnalysisComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _appraisalAnalysis2.default,
	  controller: _appraisalAnalysis4.default
	};
	
	exports.default = appraisalAnalysisComponent;

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Appraisal Analysis Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppraisalAnalysisController = function (_BaseReportController) {
	  AppraisalAnalysisController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(AppraisalAnalysisController, _BaseReportController);
	
	  function AppraisalAnalysisController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AppraisalAnalysisController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AppraisalAnalysisController.__proto__ || (0, _getPrototypeOf2.default)(AppraisalAnalysisController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AppraisalAnalysisController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'appraisalAnalysis',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Appraisal Analysis', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Appraisal Analysis', this.parseCriteria());
	    }
	  }]);
	  return AppraisalAnalysisController;
	}(_baseReportController2.default);
	
	exports.default = AppraisalAnalysisController;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1577);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./appraisalAnalysis.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./appraisalAnalysis.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".appraisalAnalysis{color:red}", ""]);
	
	// exports


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactsDataEntryMetric = __webpack_require__(1579);
	
	var _contactsDataEntryMetric2 = _interopRequireDefault(_contactsDataEntryMetric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactsDataEntryMetricModule = _angular2.default.module('contactsDataEntryMetric', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('contactsDataEntryMetric', {
	    component: 'contactsDataEntryMetric',
	    url: '/reports/contactsDataEntryMetric'
	  });
	}]).component('contactsDataEntryMetric', _contactsDataEntryMetric2.default).name;
	
	exports.default = contactsDataEntryMetricModule;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactsDataEntryMetric = __webpack_require__(1580);
	
	var _contactsDataEntryMetric2 = _interopRequireDefault(_contactsDataEntryMetric);
	
	var _contactsDataEntryMetric3 = __webpack_require__(1581);
	
	var _contactsDataEntryMetric4 = _interopRequireDefault(_contactsDataEntryMetric3);
	
	__webpack_require__(1582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactsDataEntryMetricComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _contactsDataEntryMetric2.default,
	  controller: _contactsDataEntryMetric4.default
	};
	
	exports.default = contactsDataEntryMetricComponent;

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Contacts Data Entry Metrics Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>            \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactsDataEntryMetricController = function (_BaseReportController) {
	  ContactsDataEntryMetricController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(ContactsDataEntryMetricController, _BaseReportController);
	
	  function ContactsDataEntryMetricController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactsDataEntryMetricController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ContactsDataEntryMetricController.__proto__ || (0, _getPrototypeOf2.default)(ContactsDataEntryMetricController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(ContactsDataEntryMetricController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'contactsDataEntryMetric',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Contacts Data Entry Metric', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Contacts Data Entry Metric', this.parseCriteria());
	    }
	  }]);
	  return ContactsDataEntryMetricController;
	}(_baseReportController2.default);
	
	exports.default = ContactsDataEntryMetricController;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactsDataEntryMetric.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactsDataEntryMetric.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactsDataEntryMetric{color:red}", ""]);
	
	// exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _lostDealAnalysis = __webpack_require__(1585);
	
	var _lostDealAnalysis2 = _interopRequireDefault(_lostDealAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lostDealAnalysisModule = _angular2.default.module('lostDealAnalysis', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('lostDealAnalysis', {
	    component: 'lostDealAnalysis',
	    url: '/reports/lostDealAnalysis'
	  });
	}]).component('lostDealAnalysis', _lostDealAnalysis2.default).name;
	
	exports.default = lostDealAnalysisModule;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lostDealAnalysis = __webpack_require__(1586);
	
	var _lostDealAnalysis2 = _interopRequireDefault(_lostDealAnalysis);
	
	var _lostDealAnalysis3 = __webpack_require__(1587);
	
	var _lostDealAnalysis4 = _interopRequireDefault(_lostDealAnalysis3);
	
	__webpack_require__(1588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lostDealAnalysisComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _lostDealAnalysis2.default,
	  controller: _lostDealAnalysis4.default
	};
	
	exports.default = lostDealAnalysisComponent;

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Lost Deal Analysis Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>            \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LostDealAnalysisController = function (_BaseReportController) {
	  LostDealAnalysisController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(LostDealAnalysisController, _BaseReportController);
	
	  function LostDealAnalysisController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LostDealAnalysisController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LostDealAnalysisController.__proto__ || (0, _getPrototypeOf2.default)(LostDealAnalysisController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(LostDealAnalysisController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'lostDealAnalysis',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Lost Deal Analysis', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Lost Deal Analysis', this.parseCriteria());
	    }
	  }]);
	  return LostDealAnalysisController;
	}(_baseReportController2.default);
	
	exports.default = LostDealAnalysisController;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./lostDealAnalysis.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./lostDealAnalysis.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".lostDealAnalysis{color:red}", ""]);
	
	// exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _marketingConversion = __webpack_require__(1591);
	
	var _marketingConversion2 = _interopRequireDefault(_marketingConversion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingConversionModule = _angular2.default.module('marketingConversion', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('marketingConversion', {
	    component: 'marketingConversion',
	    url: '/reports/marketingConversion'
	  });
	}]).component('marketingConversion', _marketingConversion2.default).name;
	
	exports.default = marketingConversionModule;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _marketingConversion = __webpack_require__(1592);
	
	var _marketingConversion2 = _interopRequireDefault(_marketingConversion);
	
	var _marketingConversion3 = __webpack_require__(1593);
	
	var _marketingConversion4 = _interopRequireDefault(_marketingConversion3);
	
	__webpack_require__(1594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingConversionComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _marketingConversion2.default,
	  controller: _marketingConversion4.default
	};
	
	exports.default = marketingConversionComponent;

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Marketing Conversion Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>             \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingConversionController = function (_BaseReportController) {
	  MarketingConversionController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(MarketingConversionController, _BaseReportController);
	
	  function MarketingConversionController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MarketingConversionController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MarketingConversionController.__proto__ || (0, _getPrototypeOf2.default)(MarketingConversionController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(MarketingConversionController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'marketingConversion',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Marketing Conversion', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Marketing Conversion', this.parseCriteria());
	    }
	  }]);
	  return MarketingConversionController;
	}(_baseReportController2.default);
	
	exports.default = MarketingConversionController;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./marketingConversion.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./marketingConversion.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".marketingConversion{color:red}", ""]);
	
	// exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _salesPersonConversion = __webpack_require__(1597);
	
	var _salesPersonConversion2 = _interopRequireDefault(_salesPersonConversion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesPersonConversionModule = _angular2.default.module('salesPersonConversion', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesPersonConversion', {
	    component: 'salesPersonConversion',
	    url: '/reports/salesPersonConversion'
	  });
	}]).component('salesPersonConversion', _salesPersonConversion2.default).name;
	
	exports.default = salesPersonConversionModule;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesPersonConversion = __webpack_require__(1598);
	
	var _salesPersonConversion2 = _interopRequireDefault(_salesPersonConversion);
	
	var _salesPersonConversion3 = __webpack_require__(1599);
	
	var _salesPersonConversion4 = _interopRequireDefault(_salesPersonConversion3);
	
	__webpack_require__(1600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesPersonConversionComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _salesPersonConversion2.default,
	  controller: _salesPersonConversion4.default
	};
	
	exports.default = salesPersonConversionComponent;

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Sales Person Conversion Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>            \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesPersonConversionController = function (_BaseReportController) {
	  SalesPersonConversionController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(SalesPersonConversionController, _BaseReportController);
	
	  function SalesPersonConversionController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SalesPersonConversionController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SalesPersonConversionController.__proto__ || (0, _getPrototypeOf2.default)(SalesPersonConversionController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SalesPersonConversionController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'salesPersonConversion',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Sales Person Conversion', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Sales Person Conversion', this.parseCriteria());
	    }
	  }]);
	  return SalesPersonConversionController;
	}(_baseReportController2.default);
	
	exports.default = SalesPersonConversionController;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1601);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesPersonConversion.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesPersonConversion.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".salesPersonConversion{color:red}", ""]);
	
	// exports


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _showroomDetailed = __webpack_require__(1603);
	
	var _showroomDetailed2 = _interopRequireDefault(_showroomDetailed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showroomDetailedModule = _angular2.default.module('showroomDetailed', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('showroomDetailed', {
	    component: 'showroomDetailed',
	    url: '/reports/showroomDetailed'
	  });
	}]).component('showroomDetailed', _showroomDetailed2.default).name;
	
	exports.default = showroomDetailedModule;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _showroomDetailed = __webpack_require__(1604);
	
	var _showroomDetailed2 = _interopRequireDefault(_showroomDetailed);
	
	var _showroomDetailed3 = __webpack_require__(1605);
	
	var _showroomDetailed4 = _interopRequireDefault(_showroomDetailed3);
	
	__webpack_require__(1606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showroomDetailedComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _showroomDetailed2.default,
	  controller: _showroomDetailed4.default
	};
	
	exports.default = showroomDetailedComponent;

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Showroom Detailed  Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>             \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShowroomDetailedController = function (_BaseReportController) {
	  ShowroomDetailedController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(ShowroomDetailedController, _BaseReportController);
	
	  function ShowroomDetailedController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ShowroomDetailedController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowroomDetailedController.__proto__ || (0, _getPrototypeOf2.default)(ShowroomDetailedController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(ShowroomDetailedController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'showroomDetailed',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Showroom Detailed', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Showroom Detailed', this.parseCriteria());
	    }
	  }]);
	  return ShowroomDetailedController;
	}(_baseReportController2.default);
	
	exports.default = ShowroomDetailedController;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./showroomDetailed.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./showroomDetailed.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".showroomDetailed{color:red}", ""]);
	
	// exports


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _testDrives = __webpack_require__(1609);
	
	var _testDrives2 = _interopRequireDefault(_testDrives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var testDrivesModule = _angular2.default.module('testDrives', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('testDrives', {
	    component: 'testDrives',
	    url: '/reports/testDrives'
	  });
	}]).component('testDrives', _testDrives2.default).name;
	
	exports.default = testDrivesModule;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _testDrives = __webpack_require__(1610);
	
	var _testDrives2 = _interopRequireDefault(_testDrives);
	
	var _testDrives3 = __webpack_require__(1611);
	
	var _testDrives4 = _interopRequireDefault(_testDrives3);
	
	__webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var testDrivesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _testDrives2.default,
	  controller: _testDrives4.default
	};
	
	exports.default = testDrivesComponent;

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Test Drives Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>        \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>             \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestDrivesController = function (_BaseReportController) {
	  TestDrivesController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(TestDrivesController, _BaseReportController);
	
	  function TestDrivesController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, TestDrivesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TestDrivesController.__proto__ || (0, _getPrototypeOf2.default)(TestDrivesController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TestDrivesController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this3 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this3.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this3.userList.unshift({ id: null, name: 'All' });
	
	        _this3.reportCriteria.user = _this3.userList[0];
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'testDrives',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this4 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this4.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Test Drives', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Test Drives', this.parseCriteria());
	    }
	  }]);
	  return TestDrivesController;
	}(_baseReportController2.default);
	
	exports.default = TestDrivesController;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./testDrives.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./testDrives.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".testDrives{color:red}", ""]);
	
	// exports


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tradePriceList = __webpack_require__(1615);
	
	var _tradePriceList2 = _interopRequireDefault(_tradePriceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tradePriceListModule = _angular2.default.module('tradePriceList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('tradePriceList', {
	    component: 'tradePriceList',
	    url: '/reports/tradePriceList'
	  });
	}]).component('tradePriceList', _tradePriceList2.default).name;
	
	exports.default = tradePriceListModule;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tradePriceList = __webpack_require__(1616);
	
	var _tradePriceList2 = _interopRequireDefault(_tradePriceList);
	
	var _tradePriceList3 = __webpack_require__(1617);
	
	var _tradePriceList4 = _interopRequireDefault(_tradePriceList3);
	
	__webpack_require__(1618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tradePriceListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _tradePriceList2.default,
	  controller: _tradePriceList4.default
	};
	
	exports.default = tradePriceListComponent;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Stock Price List Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n            </a>                  \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n        \r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Trade / Retail\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.vehicleConditionSearchList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.vehicleConditionSearch\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Status\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                            <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.statusList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.vehicleStatus\">\r\n                          </select>\r\n                        </div>\r\n                      </div>                    \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TradePriceListController = function () {
	  TradePriceListController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  function TradePriceListController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, TradePriceListController);
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.reportingService = reportingService;
	    this.userService = userService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.$scope = $scope;
	    this.printService = printService;
	    this.exportService = exportService;
	    this.utilsService = utilsService;
	
	    this.reportCriteria = {};
	    this.dtPopups = {};
	    this.errMsgs = [];
	
	    this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    this.summary = [];
	
	    this.getVehicleConditionSearch();
	    this.getVehicleStatus();
	    this.getUserLocations();
	    this.getDateRangeList();
	    this.reset();
	  }
	
	  (0, _createClass3.default)(TradePriceListController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionSearch',
	    value: function getVehicleConditionSearch() {
	      this.vehicleConditionSearchList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION_SEARCH);
	
	      //this.vehicleConditionSearchList.unshift({id: null, name: 'All'})
	    }
	  }, {
	    key: 'getVehicleStatus',
	    value: function getVehicleStatus() {
	      this.statusList = this.convertEnumToKeyValueList(this.enums.VEHICLE_STATUS);
	
	      this.statusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      var _this = this;
	
	      var locationsWithRoles = this.authService.authData.userLocations.map(function (l) {
	        return {
	          id: l.key,
	          name: l.value,
	          roleId: (0, _lodash.find)(_this.authService.authData.userRoles, function (o) {
	            return o.entityId === l.key;
	          }).roleId,
	          isDefault: l.defaultLocation
	        };
	      });
	
	      this.userLocations = (0, _lodash2.default)(locationsWithRoles).filter(function (o) {
	        return o.roleId !== 2 || o.isDefault;
	      }).map(function (o) {
	        return { id: o.id, name: o.name };
	      }).value();
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.statsCollection = {};
	
	      this.errMsgs = [];
	
	      this.reportCriteria.vehicleConditionSearch = this.vehicleConditionSearchList[0];
	      this.reportCriteria.vehicleStatus = this.statusList[0];
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateDateRange',
	    value: function updateDateRange() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id).then(function (response) {
	        response.data.startDate = _this2.utilsService.getReportStartDate(_this2.reportCriteria.dateRangeOption.id, response.data.startDate);
	        response.data.endDate = _this2.utilsService.getReportEndDate(_this2.reportCriteria.dateRangeOption.id, response.data.endDate);
	
	        _this2.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
	        _this2.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this3 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this3.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this3.userList.unshift({ id: null, name: 'All' });
	
	        _this3.reportCriteria.user = _this3.userList[0];
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'tradePriceList',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
	      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.vehicleConditionSearch = this.reportCriteria.vehicleConditionSearch.id;
	      parsedCriteria.vehicleStatus = this.reportCriteria.vehicleStatus.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Stock Price List', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Stock Price List', this.parseCriteria());
	    }
	  }]);
	  return TradePriceListController;
	}();
	
	exports.default = TradePriceListController;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1619);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./tradePriceList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./tradePriceList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".tradePriceList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _leadTracker = __webpack_require__(1621);
	
	var _leadTracker2 = _interopRequireDefault(_leadTracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leadTrackerModule = _angular2.default.module('leadTracker', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('leadTracker', {
	    component: 'leadTracker',
	    url: '/reports/leadTracker'
	  });
	}]).component('leadTracker', _leadTracker2.default).name;
	
	exports.default = leadTrackerModule;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leadTracker = __webpack_require__(1622);
	
	var _leadTracker2 = _interopRequireDefault(_leadTracker);
	
	var _leadTracker3 = __webpack_require__(1623);
	
	var _leadTracker4 = _interopRequireDefault(_leadTracker3);
	
	__webpack_require__(1624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leadTrackerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _leadTracker2.default,
	  controller: _leadTracker4.default
	};
	
	exports.default = leadTrackerComponent;

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Dealer Lead Tracker</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n              <span class=\"fa fa-file-excel-o\"></span>\r\n              Export\r\n          </a>                \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make 1\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Make 2\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand2\">\r\n                        </select>\r\n                      </div>\r\n                    </div>                        \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Report Criteria End -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <div ng-show=\"$ctrl.reportData.data\" block-ui=\"reportData\">\r\n                  <!-- All Enquiries -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Enquiries </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].newBrand1}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].newBrand2}}</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].newOthers}}</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].used}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Total</b></div>\r\n                    <div class=\"col-md-1 countCellTotal\">{{$ctrl.reportData.data[0].total}}</div>\r\n                  </div>\r\n                  <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">\r\n\r\n                  <!-- Orders -->\r\n                  <div class=\"row itemRow\">\r\n                      <div class=\"col-md-6\"><b>Orders </b></div>\r\n                      <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].orders_NewBrand1}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].orders_NewBrand2}}</div>\r\n                    </div>\r\n  \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].orders_NewOthers}}</div>\r\n                    </div>                  \r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].orders_Used}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Total</b></div>\r\n                      <div class=\"col-md-1 countCellTotal\">{{$ctrl.reportData.data[0].totalOrders}}</div>\r\n                    </div>\r\n                    <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">                  \r\n\r\n                  <!-- Customer Delivered -->\r\n                  <div class=\"row itemRow\">\r\n                      <div class=\"col-md-6\"><b>Customer Delivered </b></div>\r\n                      <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_NewBrand1}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_NewBrand2}}</div>\r\n                    </div>\r\n  \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_NewOthers}}</div>\r\n                    </div>                  \r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_Used}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Total</b></div>\r\n                      <div class=\"col-md-1 countCellTotal\">{{$ctrl.reportData.data[0].totalClosed}}</div>\r\n                    </div>\r\n                    <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">                                      \r\n\r\n                  <!-- Lost -->\r\n                  <div class=\"row itemRow\">\r\n                      <div class=\"col-md-6\"><b>Lost </b></div>\r\n                      <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].lost_NewBrand1}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].lost_NewBrand2}}</div>\r\n                    </div>\r\n  \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].lost_NewOthers}}</div>\r\n                    </div>                  \r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].lost_Used}}</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Total</b></div>\r\n                      <div class=\"col-md-1 countCellTotal\">{{$ctrl.reportData.data[0].totalLost}}</div>\r\n                    </div>\r\n                    <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">                                                          \r\n        \r\n                  <!-- Test Drives -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Test Drives </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_NewBrand1}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_NewBrand2}}</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_NewOthers}}</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_Used}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Total</b></div>\r\n                    <div class=\"col-md-1 countCellTotal\">{{$ctrl.reportData.data[0].totalTestDrives}}</div>\r\n                  </div>\r\n                  <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">\r\n        \r\n                  <!-- Enquiry to Test Drive Conv -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Enquiry to test drive conversion </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_Conv_NewBrand1}} %</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_Conv_NewBrand2}} %</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_Conv_NewOthers}} %</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].testDrives_Conv_Used}} %</div>\r\n                  </div>\r\n                  <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">\r\n        \r\n                  <!-- Enquiry to Order Conv -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Enquiry to order conversion </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].order_Conv_NewBrand1}} %</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].order_Conv_NewBrand2}} %</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].order_Conv_NewOthers}} %</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].order_Conv_Used}} %</div>\r\n                  </div>\r\n                  <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">\r\n\r\n                  <!-- Enquiry to Closed Conv -->\r\n                  <div class=\"row itemRow\">\r\n                      <div class=\"col-md-6\"><b>Enquiry to customer delivered conversion </b></div>\r\n                      <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_Conv_NewBrand1}} %</div>\r\n                    </div>\r\n          \r\n                    <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_Conv_NewBrand2}} %</div>\r\n                    </div>\r\n  \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_Conv_NewOthers}} %</div>\r\n                    </div>                  \r\n          \r\n                    <div class=\"row itemRow\">\r\n                      <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                      <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].closed_Conv_Used}} %</div>\r\n                    </div>\r\n                    <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">                  \r\n        \r\n                  <!-- Finance Notified -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Finance Notified </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeNotified_NewBrand1}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeNotified_NewBrand2}}</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeNotified_NewOthers}}</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeNotified_Used}}</div>\r\n                  </div>\r\n                  <hr style=\"height:1px; border:none; color:#ccc; background-color:#ccc;\">\r\n\r\n                  <!-- Finance Accepted -->\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-6\"><b>Finance Customer Accepted </b></div>\r\n                    <div class=\"col-md-3\"><b>New {{$ctrl.brand1}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeAccepted_NewBrand1}}</div>\r\n                  </div>\r\n        \r\n                  <div class=\"row itemRow\" ng-if=\"$ctrl.brand2 !== null\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New {{$ctrl.brand2}} </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeAccepted_NewBrand2}}</div>\r\n                  </div>\r\n\r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>New Others </b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeAccepted_NewOthers}}</div>\r\n                  </div>                  \r\n        \r\n                  <div class=\"row itemRow\">\r\n                    <div class=\"col-md-offset-6 col-md-3\"><b>Used</b></div>\r\n                    <div class=\"col-md-1 countCell\">{{$ctrl.reportData.data[0].financeAccepted_Used}}</div>\r\n                  </div>                  \r\n                </div>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeadTrackerController = function (_BaseReportController) {
	  LeadTrackerController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "printService", "exportService", "$q", "lookupService", "utilsService"];
	  (0, _inherits3.default)(LeadTrackerController, _BaseReportController);
	
	  function LeadTrackerController(authService, reportingService, userService, enums, loadingService, printService, exportService, $q, lookupService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LeadTrackerController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LeadTrackerController.__proto__ || (0, _getPrototypeOf2.default)(LeadTrackerController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.$q = $q;
	    _this.lookupService = lookupService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	    _this.reportData = {};
	
	    _this.brand1 = null;
	    _this.brand2 = null;
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summaryConfig = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(LeadTrackerController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'Please Select' });
	        _this2.brands = brands;
	
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.reportData = {
	        stats: {
	          total_WalkIn: 0,
	          total_Phone: 0,
	          total_Email: 0,
	          total_Web: 0,
	          total: 0
	        }
	      };
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.brand2 = this.brands[0];
	      this.reportCriteria.location = this.userLocations[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this3 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this3.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this3.userList.unshift({ id: null, name: 'All' });
	
	        _this3.reportCriteria.user = _this3.userList[0];
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this4 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('leadTracker', this.parseCriteria()).then(function (response) {
	        _this4.reportData = response.data;
	
	        _this4.brand1 = response.data.data[0].brand1;
	        _this4.brand2 = response.data.data[0].brand2;
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      if (!this.reportCriteria.brand.brandId && !this.reportCriteria.brand2.brandId) {
	        this.errMsgs.push('Please select at least one brand');
	      }
	
	      if (this.reportCriteria.brand.brandId && this.reportCriteria.brand.brandId === this.reportCriteria.brand2.brandId) {
	        this.errMsgs.push('Please select different brands');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandId2 = this.reportCriteria.brand2.brandId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Lead Tracker', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Lead Tracker', this.parseCriteria());
	    }
	  }]);
	  return LeadTrackerController;
	}(_baseReportController2.default);
	
	exports.default = LeadTrackerController;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./leadTracker.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./leadTracker.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".itemRow{padding-top:3px;padding-bottom:3px}.countCell,.countCellTotal{border:1px solid #000;text-align:center;padding-top:3px;padding-bottom:3px}.countCellTotal{background-color:#c6e0b4;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportSummary = __webpack_require__(1627);
	
	var _reportSummary2 = _interopRequireDefault(_reportSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportSummaryModule = _angular2.default.module('reportSummary', [_angularUiRouter2.default]).component('reportSummary', _reportSummary2.default).name;
	
	exports.default = reportSummaryModule;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportSummary = __webpack_require__(1628);
	
	var _reportSummary2 = _interopRequireDefault(_reportSummary);
	
	var _reportSummary3 = __webpack_require__(1629);
	
	var _reportSummary4 = _interopRequireDefault(_reportSummary3);
	
	__webpack_require__(1630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportSummaryComponent = {
	  restrict: 'E',
	  bindings: {
	    summary: '<'
	  },
	  template: _reportSummary2.default,
	  controller: _reportSummary4.default
	};
	
	exports.default = reportSummaryComponent;

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"report-summary\" border=\"1\">\r\n  <tr ng-repeat=\"row in $ctrl.summaryMatrix\">                \r\n    <td class=\"key\" ng-repeat=\"col in row\">{{col.item1}}: {{col.item2}}</td>\r\n  </tr>\r\n</table>"

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportSummaryController = function () {
	    function ReportSummaryController() {
	        "ngInject";
	
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, ReportSummaryController);
	        this.summaryMatrix = [];
	
	        this.$onChanges = function (changesObj) {
	            _this.summaryMatrix = _this.listToMatrix(_this.summary, 3);
	        };
	    }
	
	    (0, _createClass3.default)(ReportSummaryController, [{
	        key: "listToMatrix",
	        value: function listToMatrix(list, elementsPerSubArray) {
	            if (!list) {
	                return;
	            }
	
	            var matrix = [],
	                i,
	                k;
	
	            for (i = 0, k = -1; i < list.length; i++) {
	                if (i % elementsPerSubArray === 0) {
	                    k++;
	                    matrix[k] = [];
	                }
	
	                matrix[k].push(list[i]);
	            }
	
	            return matrix;
	        }
	    }]);
	    return ReportSummaryController;
	}();
	
	exports.default = ReportSummaryController;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1631);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportSummary.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportSummary.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportSummary{color:red}", ""]);
	
	// exports


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportData = __webpack_require__(1633);
	
	var _reportData2 = _interopRequireDefault(_reportData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportDataModule = _angular2.default.module('reportData', [_angularUiRouter2.default]).component('reportData', _reportData2.default).name;
	
	exports.default = reportDataModule;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportData = __webpack_require__(1634);
	
	var _reportData2 = _interopRequireDefault(_reportData);
	
	var _reportData3 = __webpack_require__(1635);
	
	var _reportData4 = _interopRequireDefault(_reportData3);
	
	__webpack_require__(1636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportDataComponent = {
	  restrict: 'E',
	  bindings: {
	    onReportRun: '&'
	  },
	  template: _reportData2.default,
	  controller: _reportData4.default
	};
	
	exports.default = reportDataComponent;

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"zef-report-data\" block-ui=\"reportData\">\r\n  <div class=\"no-data\" ng-hide=\"$ctrl.reportData.length\">\r\n    No data to display\r\n  </div>\r\n  <div class=\"data-container\" ng-show=\"$ctrl.reportData.length\">\r\n    <table>\r\n      <tead>\r\n        <tr>\r\n          <th ng-repeat=\"h in $ctrl.reportHeaders track by $index\" class=\"column{{h.item1}} sticky-top\">{{h.item2}} </th>\r\n        </tr>\r\n      </tead>\r\n      <tbody>\r\n        <tr data-ng-repeat=\"row in $ctrl.reportData track by $index\">\r\n          <td ng-repeat=\"field in row track by $index\" class1=\"column{{field.width}}\">{{field}}</td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>"

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportDataController = function () {
	  ReportDataController.$inject = ["loadingService", "reportingService", "$scope", "$filter"];
	  function ReportDataController(loadingService, reportingService, $scope, $filter) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportDataController);
	    this.loadingService = loadingService;
	    this.reportingService = reportingService;
	    this.$scope = $scope;
	    this.$filter = $filter;
	
	    this.$scope.$on('reports:runReport', this.runReport.bind(this));
	    this.$scope.$on('reports:reset', this.reset.bind(this));
	  }
	
	  (0, _createClass3.default)(ReportDataController, [{
	    key: 'reset',
	    value: function reset() {
	      this.reportData = [];
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport(e, data) {
	      var _this = this;
	
	      if (!data.criteriaValidator()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport(data.action, data.criteriaParser()).then(function (response) {
	        _this.reportHeaders = response.data.headers;
	
	        if (data.selector) {
	          _this.reportData = data.selector(response.data.data);
	        } else {
	          _this.reportData = response.data.data;
	        }
	        _this.onReportRun({ summary: response.data.summary, data: _this.reportData });
	      }).finally(function () {
	        _this.loadingService.hideLoading('reportData');
	      });
	    }
	  }]);
	  return ReportDataController;
	}();
	
	exports.default = ReportDataController;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportData.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportData.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportData{color:red}.sticky-top{position:sticky;top:0}", ""]);
	
	// exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeDetail = __webpack_require__(1639);
	
	var _financeDetail2 = _interopRequireDefault(_financeDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeDetailModule = _angular2.default.module('financeDetail', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('financeDetail', {
	    component: 'financeDetail',
	    url: '/reports/financeDetail'
	  });
	}]).component('financeDetail', _financeDetail2.default).name;
	
	exports.default = financeDetailModule;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeDetail = __webpack_require__(1640);
	
	var _financeDetail2 = _interopRequireDefault(_financeDetail);
	
	var _financeDetail3 = __webpack_require__(1641);
	
	var _financeDetail4 = _interopRequireDefault(_financeDetail3);
	
	__webpack_require__(1642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeDetailComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financeDetail2.default,
	  controller: _financeDetail4.default
	};
	
	exports.default = financeDetailComponent;

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Finance Detail Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n          </a>        \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n        \r\n              <div block-ui=\"reportCriteria\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"panel\">\r\n              \r\n                      <!-- alerts -->\r\n                      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                        <div>\r\n                          Please correct the following errors before proceeding <br> <br>\r\n                        </div>\r\n              \r\n                        <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                          &emsp; - {{msg}} <br>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Date Range\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                            ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          New / Used\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Start Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          End Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Location\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                            ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.location\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Sales Rep\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.user\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Make\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                            ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brand\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Model\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Finance Type\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.financeTypeList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.financeType\">\r\n                          </select>\r\n                        </div>\r\n                      </div>                      \r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                          <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                            <i class=\"fa fa-table\"></i>\r\n                            View Report\r\n                          </a>\r\n              \r\n                          <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                            Clear Filters\r\n                          </a>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n              \r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>  "

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceDetailController = function (_BaseReportController) {
	  FinanceDetailController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "lookupService", "$q", "utilsService"];
	  (0, _inherits3.default)(FinanceDetailController, _BaseReportController);
	
	  function FinanceDetailController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, lookupService, $q, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceDetailController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FinanceDetailController.__proto__ || (0, _getPrototypeOf2.default)(FinanceDetailController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getFinanceTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FinanceDetailController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getFinanceTypeList',
	    value: function getFinanceTypeList() {
	      this.financeTypeList = this.convertEnumToKeyValueList(this.enums.FINANCE_TYPE);
	      this.financeTypeList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.financeType = this.financeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'financeDetail',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.financeType = this.reportCriteria.financeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Finance Detail', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Finance Detail', this.parseCriteria());
	    }
	  }]);
	  return FinanceDetailController;
	}(_baseReportController2.default);
	
	exports.default = FinanceDetailController;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1643);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeDetail.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeDetail.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeDetail{color:red}", ""]);
	
	// exports


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeSummary = __webpack_require__(1645);
	
	var _financeSummary2 = _interopRequireDefault(_financeSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeSummaryModule = _angular2.default.module('financeSummary', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('financeSummary', {
	    component: 'financeSummary',
	    url: '/reports/financeSummary'
	  });
	}]).component('financeSummary', _financeSummary2.default).name;
	
	exports.default = financeSummaryModule;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeSummary = __webpack_require__(1646);
	
	var _financeSummary2 = _interopRequireDefault(_financeSummary);
	
	var _financeSummary3 = __webpack_require__(1647);
	
	var _financeSummary4 = _interopRequireDefault(_financeSummary3);
	
	__webpack_require__(1648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeSummaryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financeSummary2.default,
	  controller: _financeSummary4.default
	};
	
	exports.default = financeSummaryComponent;

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Finance Summary Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n          </a>        \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n        \r\n              <div block-ui=\"reportCriteria\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"panel\">\r\n              \r\n                      <!-- alerts -->\r\n                      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                        <div>\r\n                          Please correct the following errors before proceeding <br> <br>\r\n                        </div>\r\n              \r\n                        <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                          &emsp; - {{msg}} <br>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Date Range\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.id as item.name for item in $ctrl.dateRangeList\"\r\n                            ng-model=\"$ctrl.reportCriteria.dateRangeCode\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                            New / Used\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                            </select>\r\n                          </div>                        \r\n                      </div>\r\n\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Location\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                            ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.location\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Sales Rep\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.user\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Make\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                            ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brand\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Model\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                          </select>\r\n                        </div>\r\n                      </div>                      \r\n\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                          <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                            <i class=\"fa fa-table\"></i>\r\n                            View Report\r\n                          </a>\r\n              \r\n                          <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                            Clear Filters\r\n                          </a>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n              \r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n            </div>\r\n            <!-- Report Criteria End -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <div class=\"zef-report-data\" ng-show=\"$ctrl.reportData\" block-ui=\"reportData\">\r\n                <div class=\"no-data\" ng-hide=\"$ctrl.reportData\">\r\n                  No data to display\r\n                </div>                \r\n                <div class=\"data-container\">\r\n                  <table>\r\n                    <tead>\r\n                      <tr>\r\n                        <th class=\"column200\">&nbsp;</th>\r\n                        <th class=\"column100\">{{$ctrl.yearLabel}}</th>\r\n                        <th class=\"column100\">{{$ctrl.monthLabel}}</th>\r\n                      </tr>\r\n                    </tead>\r\n                    <tbody>\r\n                      <tr>\r\n                        <td>Finance Turnover</td>\r\n                        <td>{{$ctrl.reportData.finance_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.finance_Month | currency:'&euro;':2}}</td>\r\n                      </tr>\r\n\r\n                      <tr>\r\n                        <td>Commission</td>\r\n                        <td>{{$ctrl.reportData.comission_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.comission_Month | currency:'&euro;':2}}</td>\r\n                      </tr>           \r\n                      \r\n                      <tr>\r\n                        <td>Paint Protection</td>\r\n                        <td>{{$ctrl.reportData.pP_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.pP_Month | currency:'&euro;':2}}</td>\r\n                      </tr>                 \r\n                      \r\n                      <tr class=\"totalsRow\">\r\n                        <td>Total Income</td>\r\n                        <td>{{$ctrl.reportData.tI_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.tI_Month | currency:'&euro;':2}}</td>\r\n                      </tr>             \r\n                      \r\n                      <tr>\r\n                        <td>Penetration</td>\r\n                        <td>{{$ctrl.reportData.penetration_YTD | number:2}} %</td>\r\n                        <td>{{$ctrl.reportData.penetration_Month | number:2}} %</td>\r\n                      </tr>            \r\n                      \r\n                      <tr>\r\n                        <td>Sell Rate</td>\r\n                        <td>{{$ctrl.reportData.sellRate_YTD | number:2}} %</td>\r\n                        <td>{{$ctrl.reportData.sellRate_Month | number:2}} %</td>\r\n                      </tr>          \r\n                      \r\n                      <tr>\r\n                        <td>HP units</td>\r\n                        <td>{{$ctrl.reportData.hP_YTD | number:0}}</td>\r\n                        <td>{{$ctrl.reportData.hP_Month  | number:0}}</td>\r\n                      </tr>         \r\n                      \r\n                      <tr>\r\n                        <td>PCP units</td>\r\n                        <td>{{$ctrl.reportData.pcP_YTD | number:0}}</td>\r\n                        <td>{{$ctrl.reportData.pcP_Month | number:0}}</td>\r\n                      </tr>  \r\n                      \r\n                      <tr>\r\n                        <td>PCP %</td>\r\n                        <td>{{$ctrl.reportData.pcpPercent_YTD | number:2}} %</td>\r\n                        <td>{{$ctrl.reportData.pcpPercent_Month | number:2}} %</td>\r\n                      </tr>                                                                 \r\n                      \r\n                      <tr class=\"totalsRow\">\r\n                        <td>Total Deals</td>\r\n                        <td>{{$ctrl.reportData.tD_YTD | number:0}}</td>\r\n                        <td>{{$ctrl.reportData.tD_Month | number:0}}</td>\r\n                      </tr>            \r\n                      \r\n                      <tr>\r\n                        <td>Average Balance HP</td>\r\n                        <td>{{$ctrl.reportData.avgBalHP_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.avgBalHP_Month | currency:'&euro;':2}}</td>\r\n                      </tr>                   \r\n                      \r\n                      <tr>\r\n                        <td>Average Balance PCP</td>\r\n                        <td>{{$ctrl.reportData.avgBalPCP_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.avgBalPCP_Month | currency:'&euro;':2}}</td>\r\n                      </tr>                    \r\n                      \r\n                      <tr>\r\n                        <td>Average Income HP</td>\r\n                        <td>{{$ctrl.reportData.avgIncHP_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.avgIncHP_Month | currency:'&euro;':2}}</td>\r\n                      </tr>                  \r\n                      \r\n                      <tr>\r\n                        <td>Average Income PCP</td>\r\n                        <td>{{$ctrl.reportData.avgIncPCP_YTD | currency:'&euro;':2}}</td>\r\n                        <td>{{$ctrl.reportData.avgIncPCP_Month | currency:'&euro;':2}}</td>\r\n                      </tr>                                          \r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>  "

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceSummaryController = function () {
	  FinanceSummaryController.$inject = ["authService", "reportingService", "enums", "loadingService", "printService", "exportService", "lookupService", "$q", "userService"];
	  function FinanceSummaryController(authService, reportingService, enums, loadingService, printService, exportService, lookupService, $q, userService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FinanceSummaryController);
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.reportingService = reportingService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.printService = printService;
	    this.exportService = exportService;
	    this.lookupService = lookupService;
	    this.$q = $q;
	    this.userService = userService;
	
	    this.reportCriteria = {};
	    this.dtPopups = {};
	    this.errMsgs = [];
	
	    this.yearLabel = '';
	    this.monthLabel = '';
	
	    this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    this.summary = [];
	
	    this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(FinanceSummaryController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      var _this3 = this;
	
	      var locationsWithRoles = this.authService.authData.userLocations.map(function (l) {
	        return {
	          id: l.key,
	          name: l.value,
	          roleId: (0, _lodash.find)(_this3.authService.authData.userRoles, function (o) {
	            return o.entityId === l.key;
	          }).roleId,
	          isDefault: l.defaultLocation
	        };
	      });
	
	      this.userLocations = (0, _lodash2.default)(locationsWithRoles).filter(function (o) {
	        return o.roleId !== 2 || o.isDefault;
	      }).map(function (o) {
	        return { id: o.id, name: o.name };
	      }).value();
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this4 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this4.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = [];
	      var months = ['December', 'November', 'October', 'September', 'August', 'July', 'June', 'May', 'April', 'March', 'February', 'January'].reverse();
	
	      var currentDate = new Date();
	
	      for (var i = 0; i <= 11; i++) {
	        this.dateRangeList.push({
	          id: currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1),
	          name: months[currentDate.getMonth()] + ' ' + currentDate.getFullYear()
	        });
	
	        currentDate.setMonth(currentDate.getMonth() - 1);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportData = null;
	
	      this.yearLabel = 'Year';
	      this.monthLabel = 'Month';
	
	      this.reportCriteria.dateRangeCode = this.dateRangeList[0].id;
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this5 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this5.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this5.userList.unshift({ id: null, name: 'All' });
	
	        _this5.reportCriteria.user = _this5.userList[0];
	      }).finally(function () {
	        _this5.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this6 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('financeSummary', this.parseCriteria()).then(function (response) {
	        _this6.reportData = response.data ? response.data.data[0] : null;
	      }).finally(function () {
	        _this6.loadingService.hideLoading('reportData');
	
	        var dateRange = (0, _lodash.find)(_this6.dateRangeList, function (o) {
	          return o.id === _this6.reportCriteria.dateRangeCode;
	        });
	
	        _this6.yearLabel = 'Jan - ' + dateRange.name;
	        _this6.monthLabel = dateRange.name;
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      parsedCriteria.dateRangeCode = this.reportCriteria.dateRangeCode;
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Finance Summary', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Finance Summary', this.parseCriteria());
	    }
	  }]);
	  return FinanceSummaryController;
	}();
	
	exports.default = FinanceSummaryController;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1649);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeSummary.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeSummary.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeSummary{color:red}", ""]);
	
	// exports


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bankSummary = __webpack_require__(1651);
	
	var _bankSummary2 = _interopRequireDefault(_bankSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankSummaryModule = _angular2.default.module('bankSummary', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('bankSummary', {
	    component: 'bankSummary',
	    url: '/reports/bankSummary'
	  });
	}]).component('bankSummary', _bankSummary2.default).name;
	
	exports.default = bankSummaryModule;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bankSummary = __webpack_require__(1652);
	
	var _bankSummary2 = _interopRequireDefault(_bankSummary);
	
	var _bankSummary3 = __webpack_require__(1653);
	
	var _bankSummary4 = _interopRequireDefault(_bankSummary3);
	
	__webpack_require__(1654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankSummaryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _bankSummary2.default,
	  controller: _bankSummary4.default
	};
	
	exports.default = bankSummaryComponent;

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Bank Summary Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>        \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        New / Used\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>  "

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankSummaryController = function (_BaseReportController) {
	  BankSummaryController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "lookupService", "$q", "utilsService"];
	  (0, _inherits3.default)(BankSummaryController, _BaseReportController);
	
	  function BankSummaryController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, lookupService, $q, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, BankSummaryController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BankSummaryController.__proto__ || (0, _getPrototypeOf2.default)(BankSummaryController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(BankSummaryController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'bankSummary',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Bank Summary', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Bank Summary', this.parseCriteria());
	    }
	  }]);
	  return BankSummaryController;
	}(_baseReportController2.default);
	
	exports.default = BankSummaryController;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bankSummary.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./bankSummary.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".bankSummary{color:red}", ""]);
	
	// exports


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _modelEnquiry = __webpack_require__(1657);
	
	var _modelEnquiry2 = _interopRequireDefault(_modelEnquiry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelEnquiryModule = _angular2.default.module('modelEnquiry', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('modelEnquiry', {
	    component: 'modelEnquiry',
	    url: '/reports/modelEnquiry'
	  });
	}]).component('modelEnquiry', _modelEnquiry2.default).name;
	
	exports.default = modelEnquiryModule;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modelEnquiry = __webpack_require__(1658);
	
	var _modelEnquiry2 = _interopRequireDefault(_modelEnquiry);
	
	var _modelEnquiry3 = __webpack_require__(1659);
	
	var _modelEnquiry4 = _interopRequireDefault(_modelEnquiry3);
	
	__webpack_require__(1660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modelEnquiryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _modelEnquiry2.default,
	  controller: _modelEnquiry4.default
	};
	
	exports.default = modelEnquiryComponent;

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Model Enquiry Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>        \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Date Range Type\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                        </select>                      \r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        New / Used\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Status\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                        </select>\r\n                      </div>\r\n                    </div>    \r\n                    \r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Make\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                            ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brand\">\r\n                          </select>\r\n                        </div>\r\n\r\n                        <div class=\"col-md-2\">\r\n                          Trade / Retail\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                          </select>\r\n                        </div>                        \r\n                      </div>                    \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                          Sales Rep\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.user\">\r\n                          </select>\r\n                        </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Brands'\" \r\n                  data=\"$ctrl.reportData.data[0].brands\">\r\n                </enquiries-breakdown>                \r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Models'\" \r\n                  data=\"$ctrl.reportData.data[0].brandModels\">\r\n                </enquiries-breakdown>                \r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Fuel Types'\" \r\n                  data=\"$ctrl.reportData.data[0].fuelTypes\">\r\n                </enquiries-breakdown>                \r\n              </div>                            \r\n            </div>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>      \r\n            \r\n            <div class=\"no-data\" ng-hide=\"$ctrl.reportData.data[0].brandModels.length\">\r\n              No data to display\r\n            </div>            \r\n\r\n            <div class=\"row\" ng-show=\"$ctrl.reportData.data[0].brandModels.length\" block-ui=\"reportData\">\r\n              <div class=\"col-md-4\">\r\n                <div class=\"list-container\">\r\n                  <ul class=\"list-group\">\r\n                    <a href=\"#\" class=\"list-group-item\" ng-repeat=\"bm in $ctrl.reportData.data[0].brandModels\">\r\n                      {{bm.name}}\r\n\r\n                      <span class=\"badge\">{{bm.count}}</span>\r\n                    </a>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-md-8\">\r\n                  <div class=\"verticalChart\">\r\n                      <div class=\"heading\">Top 10 Brands</div>\r\n                      <div class=\"singleBar\" ng-repeat=\"bm in $ctrl.reportData.data[0].topTenBrands\">                    \r\n                        <div class=\"bar\">                    \r\n                          <div class=\"value\" style=\"height: {{bm.item2}}%;\">\r\n                            <span class=\"bar-figure\">{{bm.item2 | number:0}} %</span>\r\n                          </div>                    \r\n                        </div>                    \r\n                        <div class=\"title\">{{bm.item1}}</div>                    \r\n                      </div>                  \r\n                    \r\n                      <div class=\"singleBar\" ng-repeat=\"n in [].constructor(10 - $ctrl.reportData.data[0].topTenBrands.length) track by $index\">                    \r\n                        <div class=\"bar\">                    \r\n                          <div class=\"value\">\r\n                            <span>&nbsp;</span>\r\n                          </div>                    \r\n                        </div>                    \r\n                        <div class=\"title\">&nbsp;</div>                    \r\n                      </div>\t\r\n                    \r\n                      <div class=\"clearfix\"></div>\r\n                    \r\n                  </div>    \r\n\r\n                  <div class=\"verticalChart\">\r\n                      <div class=\"heading\">Top 10 Models</div>\r\n                      <div class=\"singleBar\" ng-repeat=\"bm in $ctrl.reportData.data[0].topTen\">                    \r\n                        <div class=\"bar\">                    \r\n                          <div class=\"value\" style=\"height: {{bm.item2}}%;\">\r\n                            <span class=\"bar-figure\">{{bm.item2 | number:0}} %</span>\r\n                          </div>                    \r\n                        </div>                    \r\n                        <div class=\"title\">{{bm.item1}}</div>                    \r\n                      </div>                  \r\n                    \r\n                      <div class=\"singleBar\" ng-repeat=\"n in [].constructor(10 - $ctrl.reportData.data[0].topTen.length) track by $index\">                    \r\n                        <div class=\"bar\">                    \r\n                          <div class=\"value\">\r\n                            <span>&nbsp;</span>\r\n                          </div>                    \r\n                        </div>                    \r\n                        <div class=\"title\">&nbsp;</div>                    \r\n                      </div>\t\r\n                    \r\n                      <div class=\"clearfix\"></div>\r\n                    \r\n                  </div>    \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModelEnquiryController = function (_BaseReportController) {
	  ModelEnquiryController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "$q", "lookupService", "utilsService"];
	  (0, _inherits3.default)(ModelEnquiryController, _BaseReportController);
	
	  function ModelEnquiryController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, $q, lookupService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ModelEnquiryController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ModelEnquiryController.__proto__ || (0, _getPrototypeOf2.default)(ModelEnquiryController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.$q = $q;
	    _this.lookupService = lookupService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getVehicleConditionList();
	      _this.getEnquiryStatusList();
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getEnquiryContactList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ModelEnquiryController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'createddate', name: 'Created Date' });
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this3 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this3.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this3.userList.unshift({ id: null, name: 'All' });
	
	        _this3.reportCriteria.user = _this3.userList[0];
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this4 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('modelEnquiry', this.parseCriteria()).then(function (response) {
	        _this4.reportData = response.data;
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Model Enquiry', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Model Enquiry', this.parseCriteria());
	    }
	  }]);
	  return ModelEnquiryController;
	}(_baseReportController2.default);
	
	exports.default = ModelEnquiryController;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./modelEnquiry.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./modelEnquiry.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".list-container{overflow-y:scroll;height:400px;width:100%}.verticalChart{width:100%;margin-botom:10px;margin-top:10px}.verticalChart .heading{padding-top:10px;text-align:center;font-size:14px;font-weight:700}.verticalChart .singleBar{width:9%;float:left;margin-left:.5%;margin-right:.5%}.verticalChart .singleBar .bar{position:relative;height:150px;overflow:hidden;border-bottom:1px solid #666}.verticalChart .singleBar .bar .value{position:absolute;bottom:0;width:100%;background:var(--primary-color);border-radius:5px 5px 0 0;border-left:1px solid #999;border-right:1px solid #999;border-top:1px solid #999}.value:hover{filter:brightness(90%);cursor:pointer}.verticalChart .singleBar .bar .value span{position:absolute;font-size:12px;bottom:0;width:100%;height:20px;display:none;text-align:center}.verticalChart .singleBar .title{margin-top:10px;text-align:center;color:#4d585a;transform:rotate(-45deg);font-size:10px;word-wrap:break-word;word-spacing:9999999px}.bar-figure{color:#4d585a!important;display:inline!important}", ""]);
	
	// exports


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _salesTrend = __webpack_require__(1663);
	
	var _salesTrend2 = _interopRequireDefault(_salesTrend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesTrendModule = _angular2.default.module('salesTrend', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesTrend', {
	    component: 'salesTrend',
	    url: '/reports/salesTrend'
	  });
	}]).component('salesTrend', _salesTrend2.default).name;
	
	exports.default = salesTrendModule;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesTrend = __webpack_require__(1664);
	
	var _salesTrend2 = _interopRequireDefault(_salesTrend);
	
	var _salesTrend3 = __webpack_require__(1665);
	
	var _salesTrend4 = _interopRequireDefault(_salesTrend3);
	
	__webpack_require__(1666);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesTrendComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _salesTrend2.default,
	  controller: _salesTrend4.default
	};
	
	exports.default = salesTrendComponent;

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Sales Trend Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>                  \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                          Compare to Year\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.yearsList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.compareToYear\">\r\n                          </select>\r\n                        </div>\r\n\r\n                        <div class=\"col-md-2\">\r\n                            New / Used\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                            </select>\r\n                          </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n\r\n                    <div class=\"col-md-2\">\r\n                        Breakdown Type\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.breakdownTypes track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.breakdownType\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\" ng-hide=\"true\">\r\n                          Trade / Retail\r\n                        </div>\r\n                        <div class=\"col-md-3\" ng-hide=\"true\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                          </select>\r\n                        </div>                                      \r\n                    </div>\r\n\r\n                    <div class=\"row\" ng-hide=\"true\">\r\n\r\n                        <div class=\"col-md-2\">\r\n                            Status\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                            </select>\r\n                          </div>\r\n\r\n                                      \r\n                    </div>                    \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.reportData.data[0].summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n\r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n\r\n              <div class=\"zef-report-data\" ng-show=\"$ctrl.reportData.data[0].dataItems.length\" block-ui=\"reportData\">            \r\n                <div class=\"data-container\">\r\n                  <table>\r\n                    <tead>\r\n                      <tr>\r\n                        <th class=\"column100\" ng-repeat=\"h in $ctrl.reportData.data[0].headers\">{{h}}</th>\r\n                      </tr>\r\n                    </tead>\r\n                    <tbody>\r\n                      <tr ng-repeat=\"item in $ctrl.reportData.data[0].dataItems\">\r\n                        <td>{{item.monthWeek}}</td>\r\n                        <td>{{item.comparedToYear}}</td>\r\n                        <td>{{item.currentYear}}</td>\r\n                        <td>{{item.diff}}</td>\r\n                        <td>{{item.percent}}</td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </div>   \r\n            </div>\r\n            <!-- Report Summary -->                     \r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesTrendController = function () {
	  SalesTrendController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService"];
	  function SalesTrendController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService) {
	    "ngInject";
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SalesTrendController);
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.reportingService = reportingService;
	    this.userService = userService;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.lookupService = lookupService;
	    this.$q = $q;
	    this.$scope = $scope;
	    this.printService = printService;
	    this.exportService = exportService;
	
	    this.reportCriteria = {};
	    this.dtPopups = {};
	    this.errMsgs = [];
	
	    this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    this.summary = [];
	
	    this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getVehicleConditionList();
	      _this.getEnquiryStatusList();
	      _this.getEnquiryContactList();
	      _this.getLast5YearsList();
	      _this.getBreakdownTypes();
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(SalesTrendController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      var _this4 = this;
	
	      var locationsWithRoles = this.authService.authData.userLocations.map(function (l) {
	        return {
	          id: l.key,
	          name: l.value,
	          roleId: (0, _lodash.find)(_this4.authService.authData.userRoles, function (o) {
	            return o.entityId === l.key;
	          }).roleId,
	          isDefault: l.defaultLocation
	        };
	      });
	
	      this.userLocations = (0, _lodash2.default)(locationsWithRoles).filter(function (o) {
	        return o.roleId !== 2 || o.isDefault;
	      }).map(function (o) {
	        return { id: o.id, name: o.name };
	      }).value();
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getLast5YearsList',
	    value: function getLast5YearsList() {
	      this.yearsList = [];
	      var year = new Date().getFullYear() - 1;
	
	      for (var i = year; i > year - 5; i--) {
	        this.yearsList.push({ id: i, name: i });
	      }
	    }
	  }, {
	    key: 'getBreakdownTypes',
	    value: function getBreakdownTypes() {
	      this.breakdownTypes = [];
	      this.breakdownTypes.push({ id: 1, name: 'Month' });
	      this.breakdownTypes.push({ id: 2, name: 'Week' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[0];
	      this.reportCriteria.compareToYear = this.yearsList[0];
	      this.reportCriteria.breakdownType = this.breakdownTypes[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this5 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this5.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this5.userList.unshift({ id: null, name: 'All' });
	
	        _this5.reportCriteria.user = _this5.userList[0];
	      }).finally(function () {
	        _this5.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this6 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('salesTrend', this.parseCriteria()).then(function (response) {
	        _this6.reportData = response.data;
	      }).finally(function () {
	        _this6.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.compareToYear = this.reportCriteria.compareToYear.id;
	      parsedCriteria.breakdownType = this.reportCriteria.breakdownType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Sales Trend', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Sales Trend', this.parseCriteria());
	    }
	  }]);
	  return SalesTrendController;
	}();
	
	exports.default = SalesTrendController;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1667);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesTrend.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesTrend.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".salesTrend{color:red}", ""]);
	
	// exports


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportableAddons = __webpack_require__(1669);
	
	var _reportableAddons2 = _interopRequireDefault(_reportableAddons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportableAddonsModule = _angular2.default.module('reportableAddons', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('reportableAddons', {
	    component: 'reportableAddons',
	    url: '/reports/reportableAddons'
	  });
	}]).component('reportableAddons', _reportableAddons2.default).name;
	
	exports.default = reportableAddonsModule;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportableAddons = __webpack_require__(1670);
	
	var _reportableAddons2 = _interopRequireDefault(_reportableAddons);
	
	var _reportableAddons3 = __webpack_require__(1671);
	
	var _reportableAddons4 = _interopRequireDefault(_reportableAddons3);
	
	__webpack_require__(1672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportableAddonsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _reportableAddons2.default,
	  controller: _reportableAddons4.default
	};
	
	exports.default = reportableAddonsComponent;

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"panel\">\r\n        <header class=\"empty\">\r\n          <h2>Reportable Addons Report</h2>\r\n  \r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n            <span class=\"fa fa-print\"></span>\r\n            Print\r\n          </a>\r\n\r\n          <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n          </a>                  \r\n        </header>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\">\r\n        <uib-accordion close-others=\"false\">\r\n            <!-- Report Criteria -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Criteria\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <div block-ui=\"reportCriteria\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"panel\">\r\n              \r\n                      <!-- alerts -->\r\n                      <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                        <div>\r\n                          Please correct the following errors before proceeding <br> <br>\r\n                        </div>\r\n              \r\n                        <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                          &emsp; - {{msg}} <br>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Date Range\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                            ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          New / Used\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Start Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          End Date\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <p class=\"input-group\">\r\n                            <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                            <span class=\"input-group-btn\">\r\n                              <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                            </span>\r\n                          </p>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Location\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                            ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.location\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Sales Rep\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.user\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Make\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                            ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brand\">\r\n                          </select>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          Model\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                            ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                          </select>\r\n                        </div>\r\n                      </div>\r\n              \r\n                      <div class=\"row\" ng-hide=\"true\">\r\n                        <div class=\"col-md-2\">\r\n                          Status\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                          </select>\r\n                        </div>\r\n\r\n                        <div class=\"col-md-2\">\r\n                            Trade / Retail\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                            </select>\r\n                          </div>                                      \r\n                      </div>\r\n\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                          Date Range Type\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                          </select>\r\n                        </div>                      \r\n                      </div>                      \r\n\r\n                      <div class=\"row\" ng-hide=\"true\">\r\n                          <div class=\"col-md-2\">\r\n                            Addon Type\r\n                          </div>\r\n                          <div class=\"col-md-3\">\r\n                            <select\r\n                              class=\"form-control\"\r\n                              ng-options=\"item.name for item in $ctrl.reportableAddonTypeList track by item.id\"\r\n                              ng-model=\"$ctrl.reportCriteria.addonType\">\r\n                            </select>\r\n                          </div>\r\n                        </div>                      \r\n              \r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                          <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                            <i class=\"fa fa-table\"></i>\r\n                            View Report\r\n                          </a>\r\n              \r\n                          <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                            Clear Filters\r\n                          </a>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>              \r\n            </div>\r\n            <!-- Report Criteria End -->\r\n            \r\n            <!-- Report Summary -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Summary\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                  </div>\r\n                </div>              \r\n              </uib-accordion-heading>  \r\n  \r\n              <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n            </div>\r\n            <!-- Report Summary -->\r\n                        \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n            </div>\r\n            <!-- Report Data -->\r\n        </uib-accordion>      \r\n    </div>  \r\n  </div>\r\n  \r\n  \r\n  "

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(766);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportableAddonsController = function (_BaseReportController) {
	  ReportableAddonsController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(ReportableAddonsController, _BaseReportController);
	
	  function ReportableAddonsController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportableAddonsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportableAddonsController.__proto__ || (0, _getPrototypeOf2.default)(ReportableAddonsController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryStatusList();
	      _this.getEnquiryContactList();
	      _this.getReportableAddonTypeList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReportableAddonsController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getReportableAddonTypeList',
	    value: function getReportableAddonTypeList() {
	      this.reportableAddonTypeList = this.convertEnumToKeyValueList(this.enums.REPORTABLE_ADDON_TYPE);
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.addonType = this.reportableAddonTypeList[0];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'reportableAddons',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this),
	        selector: this.filterEmptyRows
	      });
	    }
	  }, {
	    key: 'filterEmptyRows',
	    value: function filterEmptyRows(reportData) {
	      var empty = (0, _lodash.filter)(reportData, function (o) {
	        return o[4] === '' && o[6] === '';
	      });
	      var withoutEmpty = _lodash.without.apply(undefined, [reportData].concat((0, _toConsumableArray3.default)(empty)));
	
	      return withoutEmpty;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.addonType = this.reportCriteria.addonType.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Reportable Addons', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Reportable Addons', this.parseCriteria());
	    }
	  }]);
	  return ReportableAddonsController;
	}(_baseReportController2.default);
	
	exports.default = ReportableAddonsController;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1673);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportableAddons.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./reportableAddons.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportableAddons{color:red}", ""]);
	
	// exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _systemUsage = __webpack_require__(1675);
	
	var _systemUsage2 = _interopRequireDefault(_systemUsage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemUsageModule = _angular2.default.module('systemUsage', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('systemUsage', {
	    component: 'systemUsage',
	    url: '/admin/reports/systemUsage'
	  });
	}]).component('systemUsage', _systemUsage2.default).name;
	
	exports.default = systemUsageModule;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _systemUsage = __webpack_require__(1676);
	
	var _systemUsage2 = _interopRequireDefault(_systemUsage);
	
	var _systemUsage3 = __webpack_require__(1677);
	
	var _systemUsage4 = _interopRequireDefault(_systemUsage3);
	
	__webpack_require__(1678);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemUsageComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _systemUsage2.default,
	  controller: _systemUsage4.default
	};
	
	exports.default = systemUsageComponent;

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>System Usage Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\" ng-hide=\"true\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>                  \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Brand\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter1\">\r\n                          <option value=\"0\">All</option>\r\n                          <option value=\"1\">Cars Now</option>\r\n                          <option value=\"2\">Lead Manager</option>\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.reportSummary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n            <!-- Report Data -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Report Data\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>       \r\n  \r\n              <div class=\"zef-report-data\" ng-show=\"$ctrl.reportData\" block-ui=\"reportData\">\r\n                <div class=\"no-data\" ng-hide=\"$ctrl.reportData\">\r\n                  No data to display\r\n                </div>                \r\n                <div class=\"data-container\">\r\n                  <table>\r\n                    <tead>\r\n                      <tr>\r\n                        <th class=\"column100\">User</th>\r\n                        <th class=\"column100\">Last Login</th>\r\n                        <th class=\"column100 center\">Enquiries Created</th>\r\n                        <th class=\"column100 center\">Enquiries Lost</th>\r\n                        <th class=\"column100 center\">Enquiries Confirmed</th>\r\n                        <th class=\"column100 center\">Enquiries Closed</th>\r\n                      </tr>\r\n                    </tead>\r\n                  </table>\r\n\r\n                  <table ng-repeat=\"loc in $ctrl.reportData\">\r\n                    <tbody>     \r\n                      <tr ng-repeat=\"details in loc.details\" ng-show=\"$ctrl.locationDetailsHidden[loc.locationName]\" ng-click=\"$ctrl.locationDetailsHidden[loc.locationName] = !$ctrl.locationDetailsHidden[loc.locationName]\">\r\n                        <td class=\"column100\">{{details.username}}</td>\r\n                        <td class=\"column100\">{{details.lastLogin | date : 'dd MMM yy HH:mm'}}</td>\r\n                        <td class=\"column100 center\">{{details.enquiriesCreated}}</td>\r\n                        <td class=\"column100 center\">{{details.enquiriesLost}}</td>\r\n                        <td class=\"column100 center\">{{details.enquiriesConfirmed}}</td>\r\n                        <td class=\"column100 center\">{{details.enquiriesClosed}}</td>\r\n                      </tr>\r\n                                            \r\n                      <tr class=\"totalsRow\" ng-click=\"$ctrl.locationDetailsHidden[loc.locationName] = !$ctrl.locationDetailsHidden[loc.locationName]\">\r\n                          <td class=\"column100\">{{loc.locationName}}</td>\r\n                          <td class=\"column100\">{{loc.isLeadManager ? 'Lead Manager' : 'Cars Now'}}</td>\r\n                          <td class=\"column100 center\">{{$ctrl.sumDetails(loc.details, 'created')}}</td>\r\n                          <td class=\"column100 center\">{{$ctrl.sumDetails(loc.details, 'lost')}}</td>\r\n                          <td class=\"column100 center\">{{$ctrl.sumDetails(loc.details, 'confirmed')}}</td>\r\n                          <td class=\"column100 center\">{{$ctrl.sumDetails(loc.details, 'closed')}}</td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>                  \r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SystemUsageController = function (_BaseReportController) {
	  SystemUsageController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(SystemUsageController, _BaseReportController);
	
	  function SystemUsageController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SystemUsageController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SystemUsageController.__proto__ || (0, _getPrototypeOf2.default)(SystemUsageController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	    _this.locationDetailsHidden = [];
	
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SystemUsageController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.additionalParameter1 = "0";
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this2 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('systemUsage', this.parseCriteria()).then(function (response) {
	        _this2.reportData = response.data.usages;
	        _this2.reportSummary = response.data.summary;
	
	        (0, _lodash.map)(_this2.reportData, function (usage) {
	          _this2.locationDetailsHidden[usage.locationName] = false;
	        });
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.dateRange = this.reportCriteria.dateRangeOption.id;
	      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
	      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
	      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('All Enquiries', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('System Usage', this.parseCriteria());
	    }
	  }, {
	    key: 'sumDetails',
	    value: function sumDetails(details, detailType) {
	      if (detailType === 'created') {
	        return (0, _lodash.sumBy)(details, function (d) {
	          return d.enquiriesCreated;
	        });
	      } else if (detailType === 'lost') {
	        return (0, _lodash.sumBy)(details, function (d) {
	          return d.enquiriesLost;
	        });
	      } else if (detailType === 'confirmed') {
	        return (0, _lodash.sumBy)(details, function (d) {
	          return d.enquiriesConfirmed;
	        });
	      } else if (detailType === 'closed') {
	        return (0, _lodash.sumBy)(details, function (d) {
	          return d.enquiriesClosed;
	        });
	      }
	    }
	  }]);
	  return SystemUsageController;
	}(_baseReportController2.default);
	
	exports.default = SystemUsageController;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1679);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./systemUsage.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./systemUsage.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".systemUsage{color:red}", ""]);
	
	// exports


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiryPayments = __webpack_require__(1681);
	
	var _enquiryPayments2 = _interopRequireDefault(_enquiryPayments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryPaymentsModule = _angular2.default.module('enquiryPayments', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('enquiryPayments', {
	    component: 'enquiryPayments',
	    url: '/reports/enquiryPayments'
	  });
	}]).component('enquiryPayments', _enquiryPayments2.default).name;
	
	exports.default = enquiryPaymentsModule;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiryPayments = __webpack_require__(1682);
	
	var _enquiryPayments2 = _interopRequireDefault(_enquiryPayments);
	
	var _enquiryPayments3 = __webpack_require__(1683);
	
	var _enquiryPayments4 = _interopRequireDefault(_enquiryPayments3);
	
	__webpack_require__(1684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiryPaymentsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _enquiryPayments2.default,
	  controller: _enquiryPayments4.default
	};
	
	exports.default = enquiryPaymentsComponent;

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Enquiry Payments Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n        </a>           \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n            \r\n            <div block-ui=\"reportCriteria\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"panel\">\r\n          \r\n                  <!-- alerts -->\r\n                  <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                    <div>\r\n                      Please correct the following errors before proceeding <br> <br>\r\n                    </div>\r\n          \r\n                    <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                      &emsp; - {{msg}} <br>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      New / Used\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Start Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      End Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Location\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                        ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.location\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Sales Rep\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.user\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Make\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                        ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brand\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Model\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range Type\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                      </select>\r\n                    </div>               \r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                        <i class=\"fa fa-table\"></i>\r\n                        View Report\r\n                      </a>\r\n          \r\n                      <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                        Clear Filters\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n          \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiryPaymentsController = function (_BaseReportController) {
	  EnquiryPaymentsController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(EnquiryPaymentsController, _BaseReportController);
	
	  function EnquiryPaymentsController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiryPaymentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (EnquiryPaymentsController.__proto__ || (0, _getPrototypeOf2.default)(EnquiryPaymentsController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryContactList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(EnquiryPaymentsController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'createddate', name: 'Enquiry Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'enquiryPayments',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Enquiry Payments', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Enquiry Payments', this.parseCriteria());
	    }
	  }]);
	  return EnquiryPaymentsController;
	}(_baseReportController2.default);
	
	exports.default = EnquiryPaymentsController;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryPayments.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiryPayments.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiryPayments{color:red}", ""]);
	
	// exports


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _promisesReport = __webpack_require__(1687);
	
	var _promisesReport2 = _interopRequireDefault(_promisesReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promisesReportModule = _angular2.default.module('promisesReport', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('promisesReport', {
	    component: 'promisesReport',
	    url: '/reports/promisesReport'
	  });
	}]).component('promisesReport', _promisesReport2.default).name;
	
	exports.default = promisesReportModule;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promisesReport = __webpack_require__(1688);
	
	var _promisesReport2 = _interopRequireDefault(_promisesReport);
	
	var _promisesReport3 = __webpack_require__(1689);
	
	var _promisesReport4 = _interopRequireDefault(_promisesReport3);
	
	__webpack_require__(1690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var promisesReportComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _promisesReport2.default,
	  controller: _promisesReport4.default
	};
	
	exports.default = promisesReportComponent;

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Promises Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>        \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Date Range Type\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromisesReportController = function (_BaseReportController) {
	  PromisesReportController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(PromisesReportController, _BaseReportController);
	
	  function PromisesReportController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PromisesReportController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PromisesReportController.__proto__ || (0, _getPrototypeOf2.default)(PromisesReportController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.getDateRangeTypeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(PromisesReportController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'createddate', name: 'Created Date' });
	      this.dateRangeTypeList.push({ id: 'duedate', name: 'Due Date' });
	      this.dateRangeTypeList.push({ id: 'completeddate', name: 'Completed Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'promisesReport',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Promises Report', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Promises Report', this.parseCriteria());
	    }
	  }]);
	  return PromisesReportController;
	}(_baseReportController2.default);
	
	exports.default = PromisesReportController;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./promisesReport.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./promisesReport.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".promisesReport{color:red}", ""]);
	
	// exports


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _marketingConsent = __webpack_require__(1693);
	
	var _marketingConsent2 = _interopRequireDefault(_marketingConsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingConsentModule = _angular2.default.module('marketingConsent', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('marketingConsent', {
	    component: 'marketingConsent',
	    url: '/reports/marketingConsent'
	  });
	}]).component('marketingConsent', _marketingConsent2.default).name;
	
	exports.default = marketingConsentModule;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _marketingConsent = __webpack_require__(1694);
	
	var _marketingConsent2 = _interopRequireDefault(_marketingConsent);
	
	var _marketingConsent3 = __webpack_require__(1695);
	
	var _marketingConsent4 = _interopRequireDefault(_marketingConsent3);
	
	__webpack_require__(1696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marketingConsentComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _marketingConsent2.default,
	  controller: _marketingConsent4.default
	};
	
	exports.default = marketingConsentComponent;

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Marketing Consent Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>                  \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        New / Used\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                          ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Sales Rep\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.user\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Make\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                          ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brand\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Model\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                          ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Status\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.enquiryStatusList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.enquiryStatus\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Enquiry Origination\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.enquiryOriginationList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.enquiryOrigination\">\r\n                          </select>\r\n                        </div>                                      \r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Category\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.gdprCategoryList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.gdprCategory\">\r\n                        </select>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-2\">\r\n                        Channel\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.name for item in $ctrl.gdprChannelList track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.gdprChannel\">\r\n                          </select>\r\n                        </div>                                      \r\n                    </div>                    \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingConsentController = function (_BaseReportController) {
	  MarketingConsentController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "$ngConfirm", "utilsService"];
	  (0, _inherits3.default)(MarketingConsentController, _BaseReportController);
	
	  function MarketingConsentController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, $ngConfirm, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, MarketingConsentController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MarketingConsentController.__proto__ || (0, _getPrototypeOf2.default)(MarketingConsentController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.$ngConfirm = $ngConfirm;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryStatusList();
	      _this.getEnquiryOriginationList();
	      _this.getGdprCategoryList();
	      _this.getGdprChannelList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(MarketingConsentController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getEnquiryStatusList',
	    value: function getEnquiryStatusList() {
	      this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
	      this.enquiryStatusList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryOriginationList',
	    value: function getEnquiryOriginationList() {
	      this.enquiryOriginationList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_ORIGINATION);
	      this.enquiryOriginationList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getGdprCategoryList',
	    value: function getGdprCategoryList() {
	      this.gdprCategoryList = [];
	      this.gdprCategoryList.push({ id: null, name: 'Please Select' });
	      this.gdprCategoryList.push({ id: 'marketing', name: 'Marketing' });
	      this.gdprCategoryList.push({ id: 'service', name: 'Service' });
	      this.gdprCategoryList.push({ id: 'manufacturer', name: 'Manufacturer' });
	      this.gdprCategoryList.push({ id: 'surveys', name: 'Surveys' });
	      this.gdprCategoryList.push({ id: 'changeCycle', name: 'Change Cycle' });
	    }
	  }, {
	    key: 'getGdprChannelList',
	    value: function getGdprChannelList() {
	      this.gdprChannelList = [];
	      this.gdprChannelList.push({ id: null, name: 'Please Select' });
	      this.gdprChannelList.push({ id: 'email', name: 'Email' });
	      this.gdprChannelList.push({ id: 'text', name: 'Text' });
	      this.gdprChannelList.push({ id: 'phone', name: 'Phone' });
	      this.gdprChannelList.push({ id: 'post', name: 'Post' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
	      this.reportCriteria.enquiryOrigination = this.enquiryOriginationList[0];
	      this.reportCriteria.gdprCategory = this.gdprCategoryList[0];
	      this.reportCriteria.gdprChannel = this.gdprChannelList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'marketingConsent',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      if (this.reportCriteria.gdprCategory.id === null) {
	        this.errMsgs.push('Please select a Category first');
	      }
	
	      if (this.reportCriteria.gdprChannel.id === null) {
	        this.errMsgs.push('Please select a Channel first');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
	      parsedCriteria.enquiryOrigination = this.reportCriteria.enquiryOrigination.id;
	      parsedCriteria.gdprCategory = this.reportCriteria.gdprCategory.id;
	      parsedCriteria.gdprChannel = this.reportCriteria.gdprChannel.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Marketing Consent', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      var _this5 = this;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.$ngConfirm({
	        title: 'Export Contact Information',
	        content: '<b>Exporting contact information will update the contact life cycle for impacted contacts</b>',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes1: {
	            text: 'Export',
	            btnClass: 'btn-primary',
	            action: function action() {
	              var criteria = _this5.parseCriteria();
	              criteria.additionalParameter1 = "true";
	              criteria.additionalParameter2 = _this5.authService.authData.userId;
	              _this5.exportService.exportReport('Marketing Consent', criteria);
	            }
	          },
	          yes2: {
	            text: 'Export with Promise',
	            btnClass: 'btn-default',
	            action: function action() {
	              _this5.exportReportWithPromise();
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'exportReportWithPromise',
	    value: function exportReportWithPromise() {
	      var _this6 = this;
	
	      var criteria = this.parseCriteria();
	
	      var scope = this.$scope.$new();
	
	      scope.dueDate = null;
	
	      scope.datePickerOptions = {
	        minDate: new Date(),
	        showButtonBar: false
	      };
	
	      this.$ngConfirm({
	        title: 'Export Contact Information',
	        contentUrl: 'templates/reports/marketingConsentExportTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: scope,
	        buttons: {
	          yes: {
	            text: 'Export',
	            btnClass: 'btn-primary',
	            action: function action(scope) {
	              //Validation
	              if (!scope.subject || !scope.dueDate || !scope.dueTime) {
	                scope.errMsg = "Please fill in all the fields to proceed";
	
	                return false;
	              }
	
	              var criteria = _this6.parseCriteria();
	              criteria.additionalParameter1 = "true";
	              criteria.additionalParameter2 = _this6.authService.authData.userId;
	              criteria.additionalParameter3 = _this6.authService.authData.currentLocation.key;
	              criteria.additionalParameter4 = scope.subject;
	              criteria.additionalParameter5 = _this6.getFullDateTime(scope.dueDate, scope.dueTime);
	
	              _this6.exportService.exportReport('Marketing Consent', criteria);
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getFullDateTime',
	    value: function getFullDateTime(dueDate, dueTime) {
	      var dt = dueDate.getFullYear() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getDate();
	      var time = dueTime.getHours() + ':' + dueTime.getMinutes();
	
	      return dt + ' ' + time;
	    }
	  }]);
	  return MarketingConsentController;
	}(_baseReportController2.default);
	
	exports.default = MarketingConsentController;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1697);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./marketingConsent.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./marketingConsent.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".marketingConsent{color:red}.uib-datepicker .active{color:#000!important;background-color:var(--primary-color)!important}", ""]);
	
	// exports


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _digitalSignatures = __webpack_require__(1699);
	
	var _digitalSignatures2 = _interopRequireDefault(_digitalSignatures);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var digitalSignaturesModule = _angular2.default.module('digitalSignatures', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('digitalSignatures', {
	    component: 'digitalSignatures',
	    url: '/admin/reports/digitalSignatures'
	  });
	}]).component('digitalSignatures', _digitalSignatures2.default).name;
	
	exports.default = digitalSignaturesModule;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _digitalSignatures = __webpack_require__(1700);
	
	var _digitalSignatures2 = _interopRequireDefault(_digitalSignatures);
	
	var _digitalSignatures3 = __webpack_require__(1701);
	
	var _digitalSignatures4 = _interopRequireDefault(_digitalSignatures3);
	
	__webpack_require__(1702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var digitalSignaturesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _digitalSignatures2.default,
	  controller: _digitalSignatures4.default
	};
	
	exports.default = digitalSignaturesComponent;

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Digital Signatures Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>        \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DigitalSignaturesController = function (_BaseReportController) {
	  DigitalSignaturesController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(DigitalSignaturesController, _BaseReportController);
	
	  function DigitalSignaturesController(authService, reportingService, userService, enums, loadingService, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DigitalSignaturesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DigitalSignaturesController.__proto__ || (0, _getPrototypeOf2.default)(DigitalSignaturesController)).call(this, reportingService, loadingService, utilsService));
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getDateRangeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(DigitalSignaturesController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'digitalSignatures',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Digital Signatures', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Digital Signatures', this.parseCriteria());
	    }
	  }]);
	  return DigitalSignaturesController;
	}(_baseReportController2.default);
	
	exports.default = DigitalSignaturesController;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1703);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./digitalSignatures.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./digitalSignatures.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".digitalSignatures{color:red}", ""]);
	
	// exports


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sourceOfEnquiry = __webpack_require__(1705);
	
	var _sourceOfEnquiry2 = _interopRequireDefault(_sourceOfEnquiry);
	
	var _sourceOfEnquiryChart = __webpack_require__(1710);
	
	var _sourceOfEnquiryChart2 = _interopRequireDefault(_sourceOfEnquiryChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sourceOfEnquiryModule = _angular2.default.module('sourceOfEnquiry', [_angularUiRouter2.default, _sourceOfEnquiryChart2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('sourceOfEnquiry', {
	    component: 'sourceOfEnquiry',
	    url: '/reports/sourceOfEnquiry'
	  });
	}]).component('sourceOfEnquiry', _sourceOfEnquiry2.default).name;
	
	exports.default = sourceOfEnquiryModule;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sourceOfEnquiry = __webpack_require__(1706);
	
	var _sourceOfEnquiry2 = _interopRequireDefault(_sourceOfEnquiry);
	
	var _sourceOfEnquiry3 = __webpack_require__(1707);
	
	var _sourceOfEnquiry4 = _interopRequireDefault(_sourceOfEnquiry3);
	
	__webpack_require__(1708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sourceOfEnquiryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _sourceOfEnquiry2.default,
	  controller: _sourceOfEnquiry4.default
	};
	
	exports.default = sourceOfEnquiryComponent;

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Source of Enquiry (ROI)</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n        </a>           \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n            \r\n            <div block-ui=\"reportCriteria\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"panel\">\r\n          \r\n                  <!-- alerts -->\r\n                  <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                    <div>\r\n                      Please correct the following errors before proceeding <br> <br>\r\n                    </div>\r\n          \r\n                    <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                      &emsp; - {{msg}} <br>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      New / Used\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Start Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      End Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Location\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <div ng-hide=\"true\" ng-dropdown-multiselect=\"\" options=\"$ctrl.userLocations\" selected-model=\"$ctrl.reportCriteria.location\" extra-settings=\"$ctrl.multiSelectSettings\"></div>\r\n                      <select ng-hide=\"false\"\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                        ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.location\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Sales Rep\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.user\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Make\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                        ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brand\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Model\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Trade / Retail\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                      </select>\r\n                    </div>\r\n\r\n                    <div class=\"col-md-2\">\r\n                      Date Range Type\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                      </select>\r\n                    </div>                      \r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                        <i class=\"fa fa-table\"></i>\r\n                        View Report\r\n                      </a>\r\n          \r\n                      <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                        Clear Filters\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n          \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n                      \r\n          <!-- Report Summary -->\r\n          <source-of-enquiry-chart title=\"Report Summary\" data=\"$ctrl.reportData\"></source-of-enquiry-chart>\r\n          <!-- Report Summary -->\r\n\r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary,data)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->          \r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SourceOfEnquiryController = function (_BaseReportController) {
	  SourceOfEnquiryController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(SourceOfEnquiryController, _BaseReportController);
	
	  function SourceOfEnquiryController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SourceOfEnquiryController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SourceOfEnquiryController.__proto__ || (0, _getPrototypeOf2.default)(SourceOfEnquiryController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryContactList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	
	    _this.multiSelectSettings = {
	      displayProp: 'name',
	      scrollableHeight: '300px',
	      scrollable: true,
	      enableSearch: true,
	      buttonClasses: 'btn'
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SourceOfEnquiryController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'createddate', name: 'Created Date' });
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportData = null;
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'sourceOfEnquiry',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary, data) {
	      this.summary = summary;
	      this.reportData = data;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Source Of Enquiry', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Source Of Enquiry', this.parseCriteria());
	    }
	  }]);
	  return SourceOfEnquiryController;
	}(_baseReportController2.default);
	
	exports.default = SourceOfEnquiryController;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1709);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./sourceOfEnquiry.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./sourceOfEnquiry.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".sourceOfEnquiry{color:red}", ""]);
	
	// exports


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sourceOfEnquiryChart = __webpack_require__(1711);
	
	var _sourceOfEnquiryChart2 = _interopRequireDefault(_sourceOfEnquiryChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sourceOfEnquiryChartModule = _angular2.default.module('sourceOfEnquiryChart', [_angularUiRouter2.default]).component('sourceOfEnquiryChart', _sourceOfEnquiryChart2.default).name;
	
	exports.default = sourceOfEnquiryChartModule;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sourceOfEnquiryChart = __webpack_require__(1712);
	
	var _sourceOfEnquiryChart2 = _interopRequireDefault(_sourceOfEnquiryChart);
	
	var _sourceOfEnquiryChart3 = __webpack_require__(1713);
	
	var _sourceOfEnquiryChart4 = _interopRequireDefault(_sourceOfEnquiryChart3);
	
	__webpack_require__(1714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sourceOfEnquiryChartComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '@',
	    data: '<'
	  },
	  template: _sourceOfEnquiryChart2.default,
	  controller: _sourceOfEnquiryChart4.default
	};
	
	exports.default = sourceOfEnquiryChartComponent;

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-hide=\"$ctrl.data.length\">No data to display</div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" ng-show=\"$ctrl.data.length\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SourceOfEnquiryChartController = function () {
	    SourceOfEnquiryChartController.$inject = ["$scope"];
	    function SourceOfEnquiryChartController($scope) {
	        "ngInject";
	
	        //Begin Services
	
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, SourceOfEnquiryChartController);
	        this.$scope = $scope;
	        //End Services
	
	        //Begin Data
	        this.hasNoTarget = false;
	        this.chartContainerId = "chartContainer" + this.getGuid();
	        this.chart = null;
	        //End Data
	
	        //Begin Initialize
	        this.$onChanges = function (changesObj) {
	            if (changesObj.data && changesObj.data.currentValue) {
	                _this.chart = _this.generateChart();
	            } else {
	                if (_this.chart) {
	                    _this.chart.destroy();
	                }
	            }
	        };
	        //End Initialize 
	    }
	
	    (0, _createClass3.default)(SourceOfEnquiryChartController, [{
	        key: "generateChart",
	        value: function generateChart() {
	            var _this2 = this;
	
	            //Chart Code Start    
	            var ctrl = this;
	
	            var labels = [];
	            var costSeries = [];
	            var openSeries = [];
	            var lostSeries = [];
	            var confirmedSeries = [];
	            var closedSeries = [];
	            var conversionSeries = [];
	
	            this.data.map(function (item) {
	                var location = item[0];
	                var source = item[1];
	
	                var costPerEnquiry = _this2.toNumber(item[3]);
	                var conversionRatio = _this2.toNumber(item[4]);
	
	                var open = _this2.toNumber(item[5]);
	                var lost = _this2.toNumber(item[6]);
	                var confirmed = _this2.toNumber(item[7]);
	                var closed = _this2.toNumber(item[8]);
	
	                labels.push(location + "<br>" + source);
	                costSeries.push(costPerEnquiry);
	                openSeries.push(open);
	                lostSeries.push(lost);
	                confirmedSeries.push(confirmed);
	                closedSeries.push(closed);
	                conversionSeries.push(conversionRatio);
	            });
	
	            var chartOptions = {
	                chart: {
	                    type: 'column',
	                    height: '300'
	                },
	                title: {
	                    text: null
	                },
	                xAxis: {
	                    categories: labels,
	                    crosshair: true
	                },
	                yAxis: {
	                    min: 0,
	                    title: {
	                        text: null
	                    }
	                },
	                credits: {
	                    enabled: false
	                },
	                tooltip: {
	                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
	                    footerFormat: '</table>',
	                    shared: true,
	                    useHTML: true
	                },
	                plotOptions: {
	                    column: {
	                        pointPadding: 0.2,
	                        borderWidth: 0,
	                        stacking: 'normal'
	                    }
	                },
	                series: [{
	                    name: 'Conversion Ratio',
	                    data: conversionSeries
	                }, {
	                    name: 'Cost per Enquiry (€)',
	                    data: costSeries
	                }, {
	                    name: 'Open',
	                    data: openSeries,
	                    stack: 'count'
	                }, {
	                    name: 'Lost',
	                    data: lostSeries,
	                    stack: 'count'
	                }, {
	                    name: 'Confirmed',
	                    data: confirmedSeries,
	                    stack: 'count'
	                }, {
	                    name: 'Closed',
	                    data: closedSeries,
	                    stack: 'count'
	                }]
	            };
	
	            return _highcharts2.default.chart(this.chartContainerId, chartOptions);
	
	            //Chart Code End
	        }
	    }, {
	        key: "getGuid",
	        value: function getGuid() {
	            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }, {
	        key: "toNumber",
	        value: function toNumber(currency) {
	            if (currency) {
	                return parseInt(currency.replace("€", ""));
	            }
	
	            return 0;
	        }
	    }]);
	    return SourceOfEnquiryChartController;
	}();
	
	exports.default = SourceOfEnquiryChartController;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1715);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./sourceOfEnquiryChart.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./sourceOfEnquiryChart.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".sourceOfEnquiryChart{color:red}", ""]);
	
	// exports


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _salesMatch = __webpack_require__(1717);
	
	var _salesMatch2 = _interopRequireDefault(_salesMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesMatchModule = _angular2.default.module('salesMatch', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('salesMatch', {
	    component: 'salesMatch',
	    url: '/reports/salesMatch'
	  });
	}]).component('salesMatch', _salesMatch2.default).name;
	
	exports.default = salesMatchModule;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _salesMatch = __webpack_require__(1718);
	
	var _salesMatch2 = _interopRequireDefault(_salesMatch);
	
	var _salesMatch3 = __webpack_require__(1719);
	
	var _salesMatch4 = _interopRequireDefault(_salesMatch3);
	
	__webpack_require__(1720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var salesMatchComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _salesMatch2.default,
	  controller: _salesMatch4.default
	};
	
	exports.default = salesMatchComponent;

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Sales Match Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n        </a>           \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n            \r\n            <div block-ui=\"reportCriteria\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"panel\">\r\n          \r\n                  <!-- alerts -->\r\n                  <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                    <div>\r\n                      Please correct the following errors before proceeding <br> <br>\r\n                    </div>\r\n          \r\n                    <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                      &emsp; - {{msg}} <br>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Start Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      End Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Location\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                        ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.location\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Sales Rep\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.user\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                        <i class=\"fa fa-table\"></i>\r\n                        View Report\r\n                      </a>\r\n          \r\n                      <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                        Clear Filters\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n          \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalesMatchController = function (_BaseReportController) {
	  SalesMatchController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(SalesMatchController, _BaseReportController);
	
	  function SalesMatchController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SalesMatchController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SalesMatchController.__proto__ || (0, _getPrototypeOf2.default)(SalesMatchController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.getDateRangeTypeList();
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(SalesMatchController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this2 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this2.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this2.userList.unshift({ id: null, name: 'All' });
	
	        _this2.reportCriteria.user = _this2.userList[0];
	      }).finally(function () {
	        _this2.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'salesMatch',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Sales Match', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Sales Match', this.parseCriteria());
	    }
	  }]);
	  return SalesMatchController;
	}(_baseReportController2.default);
	
	exports.default = SalesMatchController;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1721);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesMatch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./salesMatch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".salesMatch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _lastLogin = __webpack_require__(1723);
	
	var _lastLogin2 = _interopRequireDefault(_lastLogin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastLoginModule = _angular2.default.module('lastLogin', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('lastLogin', {
	    component: 'lastLogin',
	    url: '/admin/reports/lastLogin'
	  });
	}]).component('lastLogin', _lastLogin2.default).name;
	
	exports.default = lastLoginModule;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lastLogin = __webpack_require__(1724);
	
	var _lastLogin2 = _interopRequireDefault(_lastLogin);
	
	var _lastLogin3 = __webpack_require__(1725);
	
	var _lastLogin4 = _interopRequireDefault(_lastLogin3);
	
	__webpack_require__(1726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastLoginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _lastLogin2.default,
	  controller: _lastLogin4.default
	};
	
	exports.default = lastLoginComponent;

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Last Login Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\" ng-hide=\"true\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>                  \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Brand\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter1\">\r\n                          <option value=\"0\">All</option>\r\n                          <option value=\"1\">Cars Now</option>\r\n                          <option value=\"2\">Lead Manager</option>\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\" ng-hide=\"true\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.reportSummary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LastLoginController = function (_BaseReportController) {
	  LastLoginController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(LastLoginController, _BaseReportController);
	
	  function LastLoginController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LastLoginController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LastLoginController.__proto__ || (0, _getPrototypeOf2.default)(LastLoginController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	    _this.locationDetailsHidden = [];
	
	    _this.reset();
	    return _this;
	  }
	
	  (0, _createClass3.default)(LastLoginController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.additionalParameter1 = "0";
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'lastLogin',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Last Login', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Last Login', this.parseCriteria());
	    }
	  }]);
	  return LastLoginController;
	}(_baseReportController2.default);
	
	exports.default = LastLoginController;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1727);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./lastLogin.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./lastLogin.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".lastLogin{color:red}", ""]);
	
	// exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _vehicleImports = __webpack_require__(1729);
	
	var _vehicleImports2 = _interopRequireDefault(_vehicleImports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleImportsModule = _angular2.default.module('vehicleImports', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('vehicleImports', {
	    component: 'vehicleImports',
	    url: '/admin/reports/vehicleImports'
	  });
	}]).component('vehicleImports', _vehicleImports2.default).name;
	
	exports.default = vehicleImportsModule;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleImports = __webpack_require__(1730);
	
	var _vehicleImports2 = _interopRequireDefault(_vehicleImports);
	
	var _vehicleImports3 = __webpack_require__(1731);
	
	var _vehicleImports4 = _interopRequireDefault(_vehicleImports3);
	
	__webpack_require__(1732);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vehicleImportsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _vehicleImports2.default,
	  controller: _vehicleImports4.default
	};
	
	exports.default = vehicleImportsComponent;

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Vehicle Imports Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\" ng-hide=\"true\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n          <span class=\"fa fa-file-excel-o\"></span>\r\n          Export\r\n        </a>                  \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        Brand\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select class=\"form-control\" ng-model=\"$ctrl.reportCriteria.additionalParameter1\">\r\n                          <option value=\"0\">All</option>\r\n                          <option value=\"1\">Cars Now</option>\r\n                          <option value=\"2\">Lead Manager</option>\r\n                        </select>\r\n                      </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Location\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\"\r\n                          ng-options=\"item.name for item in $ctrl.locations track by item.entityId\"\r\n                          ng-model=\"$ctrl.reportCriteria.location\">\r\n                        </select>\r\n                      </div>\r\n                    </div>                    \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Report\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->          \r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div class=\"zef-report-data\" ng-show=\"$ctrl.reportData\" block-ui=\"reportData\">\r\n              <div class=\"no-data\" ng-hide=\"$ctrl.reportData\">\r\n                No data to display\r\n              </div>                \r\n              <div class=\"data-container\">\r\n                <table>\r\n                  <tead>\r\n                    <tr>\r\n                      <th class=\"column100\">Import Time</th>\r\n                      <th class=\"column100\">Ad Id</th>\r\n                      <th class=\"column100\">Registration</th>                      \r\n                      <th class=\"column100\">VehicleId</th>\r\n                      <th class=\"column100\">Event</th>\r\n                    </tr>\r\n                  </tead>\r\n                </table>\r\n\r\n                <table ng-repeat=\"item in $ctrl.reportData\">\r\n                  <tbody>     \r\n                    <tr ng-repeat=\"details in item.details\">\r\n                      <td class=\"column100\">{{item.importTime | date : 'dd MMM yy HH:mm'}}</td>\r\n                      <td class=\"column100\">{{details.adId}}</td>\r\n                      <td class=\"column100\">{{details.reg}}</td>                      \r\n                      <td class=\"column100\">{{details.vehicleId}}</td>\r\n                      <td class=\"column100\">{{details.event}}</td>\r\n                    </tr>\r\n                                          \r\n                    <tr class=\"totalsRow\">\r\n                        <td class=\"column100\">{{item.importTime | date : 'dd MMM yy HH:mm'}}</td>\r\n                        <td class=\"column100\" colspan=\"2\">Total Vehicles in Feed {{item.numVehicles}}</td>\r\n                        <td class=\"column100\" colspan=\"2\"><a href=\"#\" ng-click=\"$ctrl.downloadFeed(item.transactionId)\">Click here to download actual feed</a></td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>                  \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleImportsController = function (_BaseReportController) {
	  VehicleImportsController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService", "entityService", "appConfig"];
	  (0, _inherits3.default)(VehicleImportsController, _BaseReportController);
	
	  function VehicleImportsController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService, entityService, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, VehicleImportsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VehicleImportsController.__proto__ || (0, _getPrototypeOf2.default)(VehicleImportsController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	    _this.entityService = entityService;
	    _this.appConfig = appConfig;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	    _this.locationDetailsHidden = [];
	
	    _this.getAllLocations().then(function () {
	      _this.getDateRangeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VehicleImportsController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'getAllLocations',
	    value: function getAllLocations() {
	      var _this2 = this;
	
	      var deferred = this.$q.defer();
	
	      this.entityService.listAllImportLocations().then(function (response) {
	        _this2.locations = response.data.items;
	
	        _this2.locations.unshift({ entityId: null, name: 'Select Location' });
	
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.locations[0];
	      this.reportCriteria.additionalParameter1 = "0";
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this3 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('vehicleImports', this.parseCriteria()).then(function (response) {
	        _this3.reportData = response.data;
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      if (this.reportCriteria.location.entityId == null) {
	        this.errMsgs.push('Please select a loction');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.dateRange = this.reportCriteria.dateRangeOption.id;
	      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
	      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
	      parsedCriteria.locationIds = [this.reportCriteria.location.entityId];
	      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Vehicle Imports', this.parseCriteria());
	    }
	  }, {
	    key: 'downloadFeed',
	    value: function downloadFeed(transactionId) {
	      window.open(this.appConfig.apiServiceBaseUri + ('api/file/getvehiclefeed/' + this.reportCriteria.location.entityId + '/' + transactionId));
	    }
	  }]);
	  return VehicleImportsController;
	}(_baseReportController2.default);
	
	exports.default = VehicleImportsController;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1733);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleImports.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./vehicleImports.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".vehicleImports{color:red}", ""]);
	
	// exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reportsUsage = __webpack_require__(1735);
	
	var _reportsUsage2 = _interopRequireDefault(_reportsUsage);
	
	var _reportsUsage3 = __webpack_require__(1740);
	
	var _reportsUsage4 = _interopRequireDefault(_reportsUsage3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsUsageModule = _angular2.default.module('reportsUsage', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('reportsUsage', {
	    component: 'reportsUsage',
	    url: '/admin/reports/reportsUsage'
	  });
	}]).component('reportsUsage', _reportsUsage2.default).service('reportsUsageService', _reportsUsage4.default).name;
	
	exports.default = reportsUsageModule;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reportsUsage = __webpack_require__(1736);
	
	var _reportsUsage2 = _interopRequireDefault(_reportsUsage);
	
	var _reportsUsage3 = __webpack_require__(1737);
	
	var _reportsUsage4 = _interopRequireDefault(_reportsUsage3);
	
	__webpack_require__(1738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsUsageComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _reportsUsage2.default,
	  controller: _reportsUsage4.default
	};
	
	exports.default = reportsUsageComponent;

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  \r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>   \r\n                      \r\n                      <div class=\"col-md-2\">\r\n                        Location(s)\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <div ng-dropdown-multiselect=\"\" options=\"$ctrl.locations\" selected-model=\"$ctrl.reportCriteria.locationIds\" extra-settings=\"$ctrl.locationSelectSettings\"></div>\r\n                      </div>                       \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>         \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.viewAnalytics()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Analytics\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->         \r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Analytics\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Brand'\" \r\n                  data=\"$ctrl.breakdownByBrands\"\r\n                  event=\"brandSelected\"\r\n                  identifiers=\"['name']\">\r\n                </enquiries-breakdown>                \r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Locations'\" \r\n                  data=\"$ctrl.breakdownByLocations\"\r\n                  event=\"locationSelected\"\r\n                  identifiers=\"['identifier']\">\r\n                </enquiries-breakdown>\r\n              </div>                            \r\n            </div>         \r\n\r\n            <div class=\"row\">         \r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by Type'\" \r\n                  data=\"$ctrl.breakdownByType\"\r\n                  event=\"typeSelected\"\r\n                  identifiers=\"['identifier']\">\r\n                </enquiries-breakdown>                \r\n              </div>              \r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Breakdown by OutputType'\" \r\n                  data=\"$ctrl.breakdownByOutputType\"\r\n                  event=\"outputTypeSelected\"\r\n                  identifiers=\"['identifier']\">                  \r\n                </enquiries-breakdown>                \r\n              </div>                                          \r\n            </div>  \r\n            \r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <bar-chart\r\n                  title=\"'Breakdown by Sales Person'\"\r\n                  data=\"$ctrl.breakdownBySalesPerson\">\r\n                </bar-chart>                                \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsUsageController = function (_BaseReportController) {
	  ReportsUsageController.$inject = ["authService", "reportingService", "loadingService", "utilsService", "entityService", "enums", "reportsUsageService", "$scope"];
	  (0, _inherits3.default)(ReportsUsageController, _BaseReportController);
	
	  function ReportsUsageController(authService, reportingService, loadingService, utilsService, entityService, enums, reportsUsageService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ReportsUsageController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportsUsageController.__proto__ || (0, _getPrototypeOf2.default)(ReportsUsageController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.loadingService = loadingService;
	    _this.utilsService = utilsService;
	    _this.entityService = entityService;
	    _this.enums = enums;
	    _this.reportsUsageService = reportsUsageService;
	    _this.$scope = $scope;
	
	    _this.reportCriteria = {
	      locationIds: []
	    };
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportData: false
	    };
	
	    _this.locationSelectSettings = {
	      displayProp: 'name',
	      idProp: 'entityId',
	      enableSearch: true,
	      scrollableHeight: '500px',
	      scrollable: true,
	      styleActive: true,
	      closeOnBlur: true
	    };
	
	    _this.breakdownByBrands = null;
	    _this.breakdownByLocations = null;
	    _this.breakdownByType = null;
	    _this.breakdownByOutputType = null;
	    _this.breakdownBySalesPerson = null;
	
	    _this.selectedBrand = null;
	    _this.selectedLocation = null;
	    _this.selectedType = null;
	    _this.selectedOutputType = null;
	
	    _this.$scope.$on('leadMonitor:selectionChanged', _this.selectionChanged.bind(_this));
	
	    _this.getLocations();
	    _this.getDateRangeList();
	    _this.reset().then(function (response) {
	      //this.viewAnalytics();    
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ReportsUsageController, [{
	    key: 'getLocations',
	    value: function getLocations() {
	      var _this2 = this;
	
	      this.entityService.listAllLocations().then(function (response) {
	        _this2.locations = response.data.items;
	      });
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      this.userLocations = this.authService.authData.userLocations.map(function (l) {
	        return { id: l.key, name: l.value };
	      });
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.locationIds = [];
	
	      this.resetSelection();
	
	      return this.updateDateRange();
	    }
	  }, {
	    key: 'resetSelection',
	    value: function resetSelection() {
	      this.breakdownByBrands = null;
	      this.breakdownByLocations = null;
	      this.breakdownByType = null;
	      this.breakdownByOutputType = null;
	      this.breakdownBySalesPerson = null;
	
	      this.selectedBrand = null;
	      this.selectedLocation = null;
	      this.selectedType = null;
	      this.selectedOutputType = null;
	    }
	  }, {
	    key: 'viewAnalytics',
	    value: function viewAnalytics() {
	      var _this3 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.breakdownByBrands = null;
	      this.breakdownByLocations = null;
	      this.breakdownByType = null;
	      this.breakdownByOutputType = null;
	      this.breakdownBySalesPerson = null;
	
	      var parsedCriteria = this.parseCriteria();
	
	      this.reportsUsageService.getReportsBreakdownByBrand(parsedCriteria).then(function (response) {
	        _this3.breakdownByBrands = response.data;
	      });
	
	      this.reportsUsageService.getReportsBreakdownByLocation(parsedCriteria).then(function (response) {
	        _this3.breakdownByLocations = response.data;
	      });
	
	      this.reportsUsageService.getReportsBreakdownByType(parsedCriteria).then(function (response) {
	        _this3.breakdownByType = response.data;
	      });
	
	      this.reportsUsageService.getReportsBreakdownByOutputType(parsedCriteria).then(function (response) {
	        _this3.breakdownByOutputType = response.data;
	      });
	
	      this.reportsUsageService.getReportsBreakdownBySalesPerson(parsedCriteria).then(function (response) {
	        _this3.breakdownBySalesPerson = response.data;
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.reportCriteria.locationIds.map(function (l) {
	        return l.entityId;
	      });
	      parsedCriteria.additionalParameter1 = this.selectedBrand;
	      parsedCriteria.additionalParameter2 = this.selectedLocation;
	      parsedCriteria.additionalParameter3 = this.selectedType;
	      parsedCriteria.additionalParameter4 = this.selectedOutputType;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'selectionChanged',
	    value: function selectionChanged(e, data) {
	      if (data.event === 'brandSelected') {
	        this.selectedBrand = this.addUpdateParameter(this.selectedBrand, data.identifiers.name);
	        this.selectedLocation = null;
	        this.selectedType = null;
	        this.selectedOutputType = null;
	
	        this.updateLocations();
	      } else if (data.event === 'locationSelected') {
	        this.selectedLocation = this.addUpdateParameter(this.selectedLocation, data.identifiers.identifier);;
	        this.selectedType = null;
	        this.selectedOutputType = null;
	
	        this.updateType();
	      } else if (data.event === 'typeSelected') {
	        this.selectedType = this.addUpdateParameter(this.sselectedType, data.identifiers.identifier);;
	        this.selectedOutputType = null;
	
	        this.updateOutputType();
	      } else if (data.event === 'outputTypeSelected') {
	        this.selectedOutputType = this.addUpdateParameter(this.selectedOutputType, data.identifiers.identifier);;
	
	        this.updateOutputType();
	      }
	    }
	  }, {
	    key: 'updateLocations',
	    value: function updateLocations() {
	      var _this4 = this;
	
	      this.breakdownByLocations = null;
	
	      this.reportsUsageService.getReportsBreakdownByLocation(this.parseCriteria()).then(function (response) {
	        _this4.breakdownByLocations = response.data;
	      });
	
	      this.updateType();
	    }
	  }, {
	    key: 'updateType',
	    value: function updateType() {
	      var _this5 = this;
	
	      this.breakdownByType = null;
	
	      this.reportsUsageService.getReportsBreakdownByType(this.parseCriteria()).then(function (response) {
	        _this5.breakdownByType = response.data;
	      });
	
	      this.updateOutputType();
	    }
	  }, {
	    key: 'updateOutputType',
	    value: function updateOutputType() {
	      var _this6 = this;
	
	      this.breakdownByOutputType = null;
	
	      this.reportsUsageService.getReportsBreakdownByOutputType(this.parseCriteria()).then(function (response) {
	        _this6.breakdownByOutputType = response.data;
	      });
	
	      this.updateSalesPerson();
	    }
	  }, {
	    key: 'updateSalesPerson',
	    value: function updateSalesPerson() {
	      var _this7 = this;
	
	      this.breakdownBySalesPerson = null;
	
	      this.reportsUsageService.getReportsBreakdownBySalesPerson(this.parseCriteria()).then(function (response) {
	        _this7.breakdownBySalesPerson = response.data;
	      });
	    }
	  }, {
	    key: 'addUpdateParameter',
	    value: function addUpdateParameter(currentValue, newValue) {
	      if (currentValue === newValue) {
	        return null;
	      }
	
	      return newValue;
	    }
	  }, {
	    key: 'titleBuilder',
	    value: function titleBuilder(base, params) {
	      var title = base;
	
	      params.map(function (p) {
	        if (p.name) {
	          title += ' ' + p.category + ' ' + p.name + ',';
	        }
	      });
	
	      return base;
	    }
	  }, {
	    key: 'forWebEnquiry',
	    value: function forWebEnquiry() {
	      return this.reportCriteria.dataSource.id === 1;
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel(item) {
	      return item.name;
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(item) {
	      return item.count;
	    }
	  }]);
	  return ReportsUsageController;
	}(_baseReportController2.default);
	
	exports.default = ReportsUsageController;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1739);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./reportsUsage.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./reportsUsage.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".reportsUsage{color:red}", ""]);
	
	// exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsUsageService = function () {
	    ReportsUsageService.$inject = ["$http", "appConfig"];
	    function ReportsUsageService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, ReportsUsageService);
	        this._$http = $http;
	        this._appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(ReportsUsageService, [{
	        key: 'getReportsBreakdownByBrand',
	        value: function getReportsBreakdownByBrand(criteria) {
	            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/GetReportsBreakdownByBrand/', criteria);
	        }
	    }, {
	        key: 'getReportsBreakdownByLocation',
	        value: function getReportsBreakdownByLocation(criteria) {
	            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbylocation/', criteria);
	        }
	    }, {
	        key: 'getReportsBreakdownByType',
	        value: function getReportsBreakdownByType(criteria) {
	            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbytype/', criteria);
	        }
	    }, {
	        key: 'getReportsBreakdownByOutputType',
	        value: function getReportsBreakdownByOutputType(criteria) {
	            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbyoutputtype/', criteria);
	        }
	    }, {
	        key: 'getReportsBreakdownBySalesPerson',
	        value: function getReportsBreakdownBySalesPerson(criteria) {
	            return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/reportsusage/getreportsbreakdownbysalesperson/', criteria);
	        }
	    }]);
	    return ReportsUsageService;
	}();
	
	exports.default = ReportsUsageService;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _weeklySalesActivity = __webpack_require__(1742);
	
	var _weeklySalesActivity2 = _interopRequireDefault(_weeklySalesActivity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeklySalesActivityModule = _angular2.default.module('weeklySalesActivity', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('weeklySalesActivity', {
	    component: 'weeklySalesActivity',
	    url: '/reports/weeklySalesActivity'
	  });
	}]).component('weeklySalesActivity', _weeklySalesActivity2.default).name;
	
	exports.default = weeklySalesActivityModule;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _weeklySalesActivity = __webpack_require__(1743);
	
	var _weeklySalesActivity2 = _interopRequireDefault(_weeklySalesActivity);
	
	var _weeklySalesActivity3 = __webpack_require__(1744);
	
	var _weeklySalesActivity4 = _interopRequireDefault(_weeklySalesActivity3);
	
	__webpack_require__(1745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeklySalesActivityComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _weeklySalesActivity2.default,
	  controller: _weeklySalesActivity4.default
	};
	
	exports.default = weeklySalesActivityComponent;

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Sales Activity Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n        </a>                \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n\r\n            <div block-ui=\"reportCriteria\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"panel\">\r\n          \r\n                  <!-- alerts -->\r\n                  <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                    <div>\r\n                      Please correct the following errors before proceeding <br> <br>\r\n                    </div>\r\n          \r\n                    <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                      &emsp; - {{msg}} <br>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                      </select>\r\n                    </div>\r\n\r\n                    <div class=\"col-md-2\">\r\n                      Location\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                        ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.location\">\r\n                      </select>\r\n                    </div>                    \r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Start Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      End Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                  </div>  \r\n\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                        <i class=\"fa fa-table\"></i>\r\n                        View Report\r\n                      </a>\r\n          \r\n                      <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                        Clear Filters\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n          \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>             \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n                                \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div class=\"zef-report-data\" block-ui=\"reportData\">\r\n              <div class=\"no-data\" ng-hide=\"$ctrl.reportData\">\r\n                No data to display\r\n              </div>\r\n              <div class=\"data-container\" ng-show=\"$ctrl.reportData\">                \r\n                <table>\r\n                  <tead>\r\n                    <tr>\r\n                      <th class=\"column100 stick-top\">Salesperson</th>\r\n                      <th class=\"column100 stick-top\">New Enquiries</th>\r\n                      <th class=\"column100 stick-top\">Total Open Enquiries</th>\r\n                      <th class=\"column100 stick-top\">WebLeads FollowedUp</th>\r\n                      <th class=\"column100 stick-top\">Quotes Saved</th>\r\n                      <th class=\"column100 stick-top\">Quotes Emailed</th>\r\n                      <th class=\"column100 stick-top\">Confirmed Enquiries</th>\r\n                      <th class=\"column100 stick-top\">Lost Enquiries</th>\r\n                      <th class=\"column100 stick-top\">Vehicles Delivered</th>\r\n                    </tr>\r\n                  </tead>\r\n                  <tbody>\r\n                    <tr data-ng-repeat=\"row in $ctrl.reportData.enquiries\">\r\n                      <td class=\"column100\">{{row.username}}</td>\r\n                      <td class=\"column100\">{{row.created}}</td>\r\n                      <td class=\"column100\">{{row.open}}</td>\r\n                      <td class=\"column100\">{{row.followedUp}}</td>\r\n                      <td class=\"column100\">{{row.quotesSaved}}</td>\r\n                      <td class=\"column100\">{{row.quotesEmailed}}</td>\r\n                      <td class=\"column100\">{{row.confirmed}}</td>\r\n                      <td class=\"column100\">{{row.lost}}</td>\r\n                      <td class=\"column100\">{{row.delivered}}</td>                      \r\n                    </tr>                    \r\n                  </tbody>\r\n                </table>\r\n\r\n                <br />\r\n                <table>\r\n                  <tead>\r\n                    <tr>\r\n                      <th class=\"column100 stick-top\">Enquiry Source</th>\r\n                      <th class=\"column100 stick-top\">Number of New Enquiries</th>\r\n                    </tr>\r\n                  </tead>\r\n                  <tbody>\r\n                    <tr data-ng-repeat=\"row in $ctrl.reportData.sources\">\r\n                      <td class=\"column100\">{{row.name}}</td>\r\n                      <td class=\"column100\">{{row.count}}</td>                 \r\n                    </tr>                    \r\n                  </tbody>\r\n                </table>  \r\n\r\n                <br />\r\n                <table>\r\n                  <tead>\r\n                    <tr>\r\n                      <th class=\"column100 stick-top\">Enquiry Origination</th>\r\n                      <th class=\"column100 stick-top\">Number of New Enquiries</th>\r\n                    </tr>\r\n                  </tead>\r\n                  <tbody>\r\n                    <tr data-ng-repeat=\"row in $ctrl.reportData.origination\">\r\n                      <td class=\"column100\">{{row.name}}</td>\r\n                      <td class=\"column100\">{{row.count}}</td>                 \r\n                    </tr>                    \r\n                  </tbody>\r\n                </table>                  \r\n\r\n              </div>\r\n            </div>            \r\n\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WeeklySalesActivityController = function (_BaseReportController) {
	  WeeklySalesActivityController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(WeeklySalesActivityController, _BaseReportController);
	
	  function WeeklySalesActivityController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, WeeklySalesActivityController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WeeklySalesActivityController.__proto__ || (0, _getPrototypeOf2.default)(WeeklySalesActivityController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.getDateRangeList();
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(WeeklySalesActivityController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      var _this3 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.reportingService.runReport('weeklySalesActivity', this.parseCriteria()).then(function (response) {
	        _this3.reportData = response.data;
	      }).finally(function () {
	        _this3.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.location.id) {
	        this.errMsgs.push('Please select a location first');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Sales Activity', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Sales Activity', this.parseCriteria());
	    }
	  }]);
	  return WeeklySalesActivityController;
	}(_baseReportController2.default);
	
	exports.default = WeeklySalesActivityController;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1746);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./weeklySalesActivity.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./weeklySalesActivity.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".weeklySalesActivity{color:red}", ""]);
	
	// exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cashFlow = __webpack_require__(1748);
	
	var _cashFlow2 = _interopRequireDefault(_cashFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cashFlowModule = _angular2.default.module('cashFlow', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('cashFlow', {
	    component: 'cashFlow',
	    url: '/reports/cashFlow'
	  });
	}]).component('cashFlow', _cashFlow2.default).name;
	
	exports.default = cashFlowModule;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cashFlow = __webpack_require__(1749);
	
	var _cashFlow2 = _interopRequireDefault(_cashFlow);
	
	var _cashFlow3 = __webpack_require__(1750);
	
	var _cashFlow4 = _interopRequireDefault(_cashFlow3);
	
	__webpack_require__(1751);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cashFlowComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _cashFlow2.default,
	  controller: _cashFlow4.default
	};
	
	exports.default = cashFlowComponent;

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Cash Flow Report</h2>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.printReport()\">\r\n          <span class=\"fa fa-print\"></span>\r\n          Print\r\n        </a>\r\n\r\n        <a class=\"btn btn-success btn-lg\" ng-click=\"$ctrl.exportReport()\">\r\n            <span class=\"fa fa-file-excel-o\"></span>\r\n            Export\r\n        </a>           \r\n      </header>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n            \r\n            <div block-ui=\"reportCriteria\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"panel\">\r\n          \r\n                  <!-- alerts -->\r\n                  <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                    <div>\r\n                      Please correct the following errors before proceeding <br> <br>\r\n                    </div>\r\n          \r\n                    <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                      &emsp; - {{msg}} <br>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Date Range\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      New / Used\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Start Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      End Date\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <p class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                        <span class=\"input-group-btn\">\r\n                          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                        </span>\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Location\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                        ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.location\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Sales Rep\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.user\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Make\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                        ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brand\">\r\n                      </select>\r\n                    </div>\r\n                    <div class=\"col-md-2\">\r\n                      Model\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                        ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\">\r\n                      Trade / Retail\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.enquiryContactList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.enquiryContact\">\r\n                      </select>\r\n                    </div>\r\n\r\n                    <div class=\"col-md-2\">\r\n                      Date Range Type\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.dateRangeTypeList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.dateRangeType\">\r\n                      </select>\r\n                    </div>                      \r\n                  </div>\r\n          \r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                      <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.runReport()\">\r\n                        <i class=\"fa fa-table\"></i>\r\n                        View Report\r\n                      </a>\r\n          \r\n                      <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                        Clear Filters\r\n                      </a>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n          \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>              \r\n          </div>\r\n          <!-- Report Criteria End -->\r\n          \r\n          <!-- Report Summary -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportSummary\">              \r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Summary\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportSummary, 'glyphicon-chevron-down': !$ctrl.panels.reportSummary}\"></i>\r\n                </div>\r\n              </div>              \r\n            </uib-accordion-heading>  \r\n\r\n            <report-summary summary=\"$ctrl.summary\"></report-summary>\r\n          </div>\r\n          <!-- Report Summary -->\r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Data\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <report-data on-report-run=\"$ctrl.onReportRun(summary)\"></report-data>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CashFlowController = function (_BaseReportController) {
	  CashFlowController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "lookupService", "$q", "$scope", "printService", "exportService", "utilsService"];
	  (0, _inherits3.default)(CashFlowController, _BaseReportController);
	
	  function CashFlowController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CashFlowController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CashFlowController.__proto__ || (0, _getPrototypeOf2.default)(CashFlowController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.lookupService = lookupService;
	    _this.$q = $q;
	    _this.$scope = $scope;
	    _this.printService = printService;
	    _this.exportService = exportService;
	    _this.utilsService = utilsService;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportSummary: false,
	      reportData: false
	    };
	
	    _this.summary = [];
	
	    _this.initializeLookups().then(function () {
	      _this.getUserLocations();
	      _this.getDateRangeList();
	      _this.getVehicleConditionList();
	      _this.getEnquiryContactList();
	      _this.getDateRangeTypeList();
	      _this.reset();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CashFlowController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var deferred = ctrl.$q.defer();
	
	      this.lookupService.lookupBrands().then(function (brands) {
	        brands.splice(0, 1);
	        brands.unshift({ id: null, name: 'All' });
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	          deferred.resolve();
	        });
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
	      this.vehicleConditionList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getEnquiryContactList',
	    value: function getEnquiryContactList() {
	      this.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
	      this.enquiryContactList.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getDateRangeTypeList',
	    value: function getDateRangeTypeList() {
	      this.dateRangeTypeList = [];
	      this.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
	      this.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('reports:reset');
	
	      this.summary = [];
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	      this.reportCriteria.enquiryContact = this.enquiryContactList[2];
	      this.reportCriteria.dateRangeType = this.dateRangeTypeList[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this4.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this4.userList.unshift({ id: null, name: 'All' });
	
	        _this4.reportCriteria.user = _this4.userList[0];
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'runReport',
	    value: function runReport() {
	      this.panels.reportData = true;
	
	      this.$scope.$broadcast('reports:runReport', {
	        action: 'cashFlow',
	        criteriaValidator: this.validateCriteria.bind(this),
	        criteriaParser: this.parseCriteria.bind(this)
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	      parsedCriteria.enquiryContact = this.reportCriteria.enquiryContact.id;
	      parsedCriteria.dateRangeType = this.reportCriteria.dateRangeType.id;
	
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'onReportRun',
	    value: function onReportRun(summary) {
	      this.summary = summary;
	    }
	  }, {
	    key: 'printReport',
	    value: function printReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.printService.printReport('Cash Flow', this.parseCriteria());
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.exportService.exportReport('Cash Flow', this.parseCriteria());
	    }
	  }]);
	  return CashFlowController;
	}(_baseReportController2.default);
	
	exports.default = CashFlowController;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1752);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./cashFlow.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./cashFlow.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".cashFlow{color:red}", ""]);
	
	// exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _finance = __webpack_require__(1754);
	
	var _finance2 = _interopRequireDefault(_finance);
	
	var _financeEdit = __webpack_require__(1759);
	
	var _financeEdit2 = _interopRequireDefault(_financeEdit);
	
	var _finance3 = __webpack_require__(1799);
	
	var _finance4 = _interopRequireDefault(_finance3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeModule = _angular2.default.module('finance', [_angularUiRouter2.default, _financeEdit2.default]).component('finance', _finance2.default).service('financeService', _finance4.default).name;
	
	exports.default = financeModule;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _finance = __webpack_require__(1755);
	
	var _finance2 = _interopRequireDefault(_finance);
	
	var _finance3 = __webpack_require__(1756);
	
	var _finance4 = _interopRequireDefault(_finance3);
	
	__webpack_require__(1757);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _finance2.default,
	  controller: _finance4.default
	};
	
	exports.default = financeComponent;

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceController = function FinanceController() {
	  (0, _classCallCheck3.default)(this, FinanceController);
	
	  this.name = 'finance';
	};
	
	exports.default = FinanceController;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1758);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./finance.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./finance.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".finance{color:red}", ""]);
	
	// exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeEdit = __webpack_require__(1760);
	
	var _financeEdit2 = _interopRequireDefault(_financeEdit);
	
	var _contactInfo = __webpack_require__(1765);
	
	var _contactInfo2 = _interopRequireDefault(_contactInfo);
	
	var _financeVehicleInfo = __webpack_require__(1771);
	
	var _financeVehicleInfo2 = _interopRequireDefault(_financeVehicleInfo);
	
	var _priceBreakdown = __webpack_require__(1777);
	
	var _priceBreakdown2 = _interopRequireDefault(_priceBreakdown);
	
	var _financeQuotes = __webpack_require__(1783);
	
	var _financeQuotes2 = _interopRequireDefault(_financeQuotes);
	
	var _financeConclude = __webpack_require__(1792);
	
	var _financeConclude2 = _interopRequireDefault(_financeConclude);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeEditModule = _angular2.default.module('financeEdit', [_angularUiRouter2.default, _contactInfo2.default, _financeVehicleInfo2.default, _financeQuotes2.default, _priceBreakdown2.default, _financeConclude2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('financeEdit', {
	    url: '/finance/edit/:financeId',
	    component: 'financeEdit',
	    params: {
	      activeTab: null
	    }
	  });
	}]).component('financeEdit', _financeEdit2.default).name;
	
	exports.default = financeEditModule;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeEdit = __webpack_require__(1761);
	
	var _financeEdit2 = _interopRequireDefault(_financeEdit);
	
	var _financeEdit3 = __webpack_require__(1762);
	
	var _financeEdit4 = _interopRequireDefault(_financeEdit3);
	
	__webpack_require__(1763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeEditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _financeEdit2.default,
	  controller: _financeEdit4.default
	};
	
	exports.default = financeEditComponent;

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" stickyX offset=\"50\">\r\n    <div class=\"panel\">\r\n      <header class=\"empty\">\r\n        <h2>Edit Finance</h2>\r\n        <a class=\"btn btn-success form-submit\" ng-click=\"$ctrl.editFinance()\">\r\n            <span class=\"glyphicon glyphicon-floppy-disk\"></span>\r\n            <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.state === 'Saving'\"></i>\r\n            {{ $ctrl.state !== 'Saving' ? 'Save Changes' : 'Saving Changes ...' }}\r\n        </a>\r\n\r\n        <a\r\n          class=\"btn btn-warning\"\r\n          ng-click=\"$ctrl.redirectToParent()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n            Go Back\r\n        </a>\r\n\r\n      </header>\r\n\r\n      <!-- DPA Warning Basic -->\r\n      <div class=\"alert alert-warning\" ng-show=\"$ctrl.initialized && !$ctrl.finance.acknowledged\">\r\n        <h2>Warning</h2>\r\n        Changes have been made to the enquiry since this Finance Deal was created, all options have been recalculated for your convenience. \r\n        <br />\r\n        <a href=\"#\" ng-click=\"$ctrl.acknowledge()\">Please click here to acknowledge</a>\r\n      </div>      \r\n\r\n      <!-- alerts -->\r\n      <div class=\"alert alert-danger\" ng-show=\"$ctrl.formValidationService.validations.msgs.length !== 0\">\r\n        <div ng-hide=\"$ctrl.formValidationService.validations.errorType === 'System'\">\r\n          Please correct the following errors before proceeding <br> <br>\r\n        </div>\r\n\r\n        <div ng-repeat=\"msg in $ctrl.formValidationService.validations.msgs\">\r\n          &emsp; - {{msg}} <br>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" block-ui=\"editFinance\">\r\n    <div class=\"panel\">\r\n        <div class=\"form-horizontal\">\r\n          <uib-accordion close-others=\"true\">\r\n            <!-- Contact Information Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.contactInfo.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Contact Information\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.contactInfo.visible, 'glyphicon-chevron-down': !$ctrl.panels.contactInfo.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <contact-Info finance=\"$ctrl.finance\">\r\n              </contact-Info>\r\n            </div>\r\n            <!-- Contact Information End -->\r\n\r\n            <!-- Vehicle Information Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.vehicleInfo.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Vehicle Information\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.vehicleInfo.visible, 'glyphicon-chevron-down': !$ctrl.panels.vehicleInfo.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <finance-Vehicle-Info finance=\"$ctrl.finance\">\r\n              </finance-Vehicle-Info>\r\n            </div>\r\n            <!-- Vehicle Information End -->\r\n            \r\n            <!-- Finance Quotes Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"true\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-11\">\r\n                    Finance Quotes\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.financeQuotes.visible, 'glyphicon-chevron-down': !$ctrl.panels.financeQuotes.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <finance-Quotes finance=\"$ctrl.finance\">\r\n              </finance-Quotes>\r\n            </div>\r\n            <!-- Finance Quotes End -->\r\n\r\n            <!-- Conclusion Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.conclusion.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-2\">\r\n                    Conclusion\r\n                  </div>\r\n                  <div class=\"col-md-9\">\r\n                    <div ng-show=\"!ctrl.panels.conclusion.visible\">{{$ctrl.panels.conclusion.summary}}</div>\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.conclusion.visible, 'glyphicon-chevron-down': !ctrl.panels.conclusion.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <finance-Conclude finance=\"$ctrl.finance\">\r\n              </finance-Conclude>\r\n            </div>\r\n            <!-- Conclusion End -->\r\n\r\n            <!-- Notes Begin -->\r\n            <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.notes.visible\">\r\n              <uib-accordion-heading>\r\n                <div class=\"row\" ng-click=\"$ctrl.updateSummaries()\">\r\n                  <div class=\"col-md-11\">\r\n                    Notes\r\n                  </div>\r\n                  <div class=\"col-md-1\">\r\n                    <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': ctrl.panels.notes.visible, 'glyphicon-chevron-down': !ctrl.panels.notes.visible}\"></i>\r\n                  </div>\r\n                </div>\r\n              </uib-accordion-heading>\r\n\r\n              <notes notes-Collection=\"$ctrl.finance.notes\" with-Promises=\"false\"/>\r\n            </div>\r\n            <!-- Notes End -->\r\n          </uib-accordion>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(485);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _FormValidationService = __webpack_require__(736);
	
	var _FormValidationService2 = _interopRequireDefault(_FormValidationService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceEditController = function () {
	  FinanceEditController.$inject = ["authService", "$state", "$stateParams", "enums", "loadingService", "financeService", "$scope", "growl", "utilsService"];
	  function FinanceEditController(authService, $state, $stateParams, enums, loadingService, financeService, $scope, growl, utilsService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceEditController);
	    if (!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.Edit, true)) {
	      return;
	    }
	
	    this.authService = authService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.enums = enums;
	    this.loadingService = loadingService;
	    this.financeService = financeService;
	    this.$scope = $scope;
	    this.growl = growl;
	    this.utilsService = utilsService;
	
	    this.formValidationService = new _FormValidationService2.default();
	
	    this.finance = {};
	
	    this.panels = {};
	
	    this.initialized = false;
	
	    this.loadFinance();
	
	    this.$scope.$on('saveFinance', this.editFinance.bind(this));
	  }
	
	  (0, _createClass3.default)(FinanceEditController, [{
	    key: 'loadFinance',
	    value: function loadFinance() {
	      var _this = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('editFinance', 'Loading Finance ...');
	
	      ctrl.financeService.getFinance(ctrl.$stateParams.financeId).then(function (response) {
	        (0, _assign2.default)(ctrl.finance, response.data);
	        ctrl.finance.referralCode = ctrl.finance.referralCode || 'Please Select';
	        ctrl.finance.referralQuality = ctrl.finance.referralQuality || 'Please Select';
	        ctrl.finance.installmentStart = ctrl.utilsService.getDatePart(ctrl.finance.installmentStart);
	
	        ctrl.initialized = true;
	
	        _this.$scope.$broadcast('finance:initialized');
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('editFinance');
	      });
	    }
	  }, {
	    key: 'redirectToParent',
	    value: function redirectToParent() {
	      this.$state.go('dashboard');
	    }
	  }, {
	    key: 'editFinance',
	    value: function editFinance(evt, params) {
	      var _this2 = this;
	
	      var ctrl = this;
	
	      //if (!ctrl.formValidationService.validateForm()) { return; }
	
	      this.state = 'Saving';
	
	      //Data Cleansing
	      ctrl.finance.referralCode = ctrl.finance.referralCode === 'Please Select' ? null : ctrl.finance.referralCode;
	      ctrl.finance.referralQuality = ctrl.finance.referralQuality === 'Please Select' ? null : ctrl.finance.referralQuality;
	
	      ctrl.loadingService.showLoading('editFinance', 'Saving Changes ...');
	
	      ctrl.financeService.editFinance(ctrl.authService.authData.currentLocation.key, ctrl.finance).then(function (response) {
	        _this2.state = 'Saved';
	
	        if (!params || params && !params.skipNotification) {
	          _this2.growl.success('Changes to the finance quote updated successfully', { ttl: 5000 });
	        }
	      }).catch(function (err) {
	        if (err.status === 400) {
	          //Bad Request
	          ctrl.state = 'ModelError';
	
	          err.data.map(function (item) {
	            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
	          });
	        } else if (err.status === 500) {
	          ctrl.state = 'SystemError';
	          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
	        }
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('editFinance');
	      });
	    }
	  }, {
	    key: 'acknowledge',
	    value: function acknowledge() {
	      var _this3 = this;
	
	      var ctrl = this;
	
	      ctrl.loadingService.showLoading('editFinance', 'Acknowledge Finance ...');
	
	      ctrl.financeService.acknowledge(ctrl.$stateParams.financeId).then(function (response) {
	        _this3.growl.success('Changes to the finance quote updated successfully', { ttl: 5000 });
	        ctrl.finance.acknowledged = true;
	      }).catch(function (err) {}).finally(function () {
	        ctrl.loadingService.hideLoading('editFinance');
	      });
	    }
	  }]);
	  return FinanceEditController;
	}();
	
	exports.default = FinanceEditController;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1764);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeEdit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./financeEdit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeEdit{color:red}", ""]);
	
	// exports


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactInfo = __webpack_require__(1766);
	
	var _contactInfo2 = _interopRequireDefault(_contactInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactInfoModule = _angular2.default.module('contactInfo', [_angularUiRouter2.default]).component('contactInfo', _contactInfo2.default).name;
	
	exports.default = contactInfoModule;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactInfo = __webpack_require__(1767);
	
	var _contactInfo2 = _interopRequireDefault(_contactInfo);
	
	var _contactInfo3 = __webpack_require__(1768);
	
	var _contactInfo4 = _interopRequireDefault(_contactInfo3);
	
	__webpack_require__(1769);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactInfoComponent = {
	  restrict: 'E',
	  bindings: {
	    finance: '='
	  },
	  template: _contactInfo2.default,
	  controller: _contactInfo4.default
	};
	
	exports.default = contactInfoComponent;

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n\r\n  <div>\r\n    <h3>Contact Details</h3>\r\n    <hr />\r\n\r\n    Contact Type: {{$ctrl.finance.contact.contactType}} </br>\r\n    Contact Name: <a ui-sref=\"contactEdit({contactId: $ctrl.finance.contactId})\">{{$ctrl.finance.contact.name}} </a> </br>\r\n    Residence: {{$ctrl.finance.contact.residenceType}} </br>\r\n    Current Address: {{$ctrl.finance.contact.currentAddress}} </br>\r\n    Length of Stay: {{$ctrl.finance.contact.lengthOfStay}} </br>\r\n    Date of Birth: {{$ctrl.finance.contact.dateOfBirth | date : 'dd MMMM yyyy' }} </br>\r\n    Place of Birth: {{$ctrl.finance.contact.placeOfBirth}} </br>\r\n    Gender: {{$ctrl.finance.contact.gender}} </br>\r\n    Marital Status: {{$ctrl.finance.contact.maritalStatus}} </br>\r\n    Dependent Children: {{$ctrl.finance.contact.dependentChildren}} </br>\r\n    Phone: {{$ctrl.finance.contact.phone}} </br>\r\n    Email: {{$ctrl.finance.contact.email}} </br>\r\n\r\n    <br /><br />\r\n    Previous Address: {{$ctrl.finance.contact.previousAddress}} </br>\r\n    Length of Stay: {{$ctrl.finance.contact.prevAddLengthOfStay}}\r\n  </div>\r\n\r\n  <div>\r\n    <h3>Emlpoyment Details</h3>\r\n    <hr />\r\n\r\n    Employer Name: {{$ctrl.finance.contact.employerName}}  </br>\r\n    Employer Address: {{$ctrl.finance.contact.employerAddress}} </br>\r\n    Length of Employment: {{$ctrl.finance.contact.lengthOfEmployment}} </br>\r\n    Occupation: {{$ctrl.finance.contact.occupation}} </br>\r\n    Employment Type: {{$ctrl.finance.contact.employmentType}} </br>\r\n    Work Permit No: {{$ctrl.finance.contact.workPermitNo}} </br>\r\n    Work Permit Expiry: {{$ctrl.finance.contact.workPermitExpiry | date : 'dd MMMM yyyy' }} </br>\r\n    Previous Employer: {{$ctrl.finance.contact.previousEmployer}} </br>\r\n    Address: {{$ctrl.finance.contact.previousEmployerAddress}} </br>\r\n    Length of Employment: {{$ctrl.finance.contact.lengthOfPrevEmployment}} </br>\r\n  </div>\r\n\r\n  <div>\r\n    <h3>Financial Details</h3>\r\n    <hr />\r\n\r\n    Bank Name: {{$ctrl.finance.contact.bankName}}  </br>\r\n    Branch Name: {{$ctrl.finance.contact.branchName}} </br>\r\n    Sort Code: {{$ctrl.finance.contact.sortCode}} </br>\r\n    Account No: {{$ctrl.finance.contact.accountNo}} </br>\r\n    IBAN: {{$ctrl.finance.contact.iban}} </br>\r\n    Account Name: {{$ctrl.finance.contact.accountName}} </br>\r\n    Length of Stay: {{$ctrl.finance.contact.stayWithBank}} </br>\r\n    Monthly Income: € {{$ctrl.finance.contact.monthlyIncome | number:2}} </br>\r\n    Other Income: € {{$ctrl.finance.contact.otherIncome | number:2}} </br>\r\n    Mortgage / Rent: € {{$ctrl.finance.contact.mortgage | number:2}} </br>\r\n    Other Borrowing: € {{$ctrl.finance.contact.otherBorrowing | number:2}} </br>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactInfoController = function ContactInfoController() {
	  (0, _classCallCheck3.default)(this, ContactInfoController);
	
	  this.name = 'contactInfo';
	};
	
	exports.default = ContactInfoController;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1770);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactInfo.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./contactInfo.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactInfo{color:red}", ""]);
	
	// exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeVehicleInfo = __webpack_require__(1772);
	
	var _financeVehicleInfo2 = _interopRequireDefault(_financeVehicleInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeVehicleInfoModule = _angular2.default.module('financeVehicleInfo', [_angularUiRouter2.default]).component('financeVehicleInfo', _financeVehicleInfo2.default).name;
	
	exports.default = financeVehicleInfoModule;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeVehicleInfo = __webpack_require__(1773);
	
	var _financeVehicleInfo2 = _interopRequireDefault(_financeVehicleInfo);
	
	var _financeVehicleInfo3 = __webpack_require__(1774);
	
	var _financeVehicleInfo4 = _interopRequireDefault(_financeVehicleInfo3);
	
	__webpack_require__(1775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeVehicleInfoComponent = {
	  restrict: 'E',
	  bindings: {
	    finance: '='
	  },
	  template: _financeVehicleInfo2.default,
	  controller: _financeVehicleInfo4.default
	};
	
	exports.default = financeVehicleInfoComponent;

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n      <h3>Vehicle Details</h3>\r\n      <hr />\r\n\r\n      Vehicle Condition: {{$ctrl.finance.vehicleInfo.vehicle.vehicleCondition}} <br />\r\n      Model: {{$ctrl.finance.vehicleInfo.vehicle.model}} <br />\r\n      Registration: \r\n      <a ui-sref=\"vehicleEdit({vehicleId: $ctrl.finance.vehicleInfo.vehicle.vehicleId, origin: {source:'editFinance', financeId: $ctrl.finance.financeId}})\">\r\n        {{$ctrl.finance.vehicleInfo.vehicle.registration}} </a><br />\r\n      Body Type: {{$ctrl.finance.vehicleInfo.vehicle.vehicleBodyType}} <br />\r\n      Color: {{$ctrl.finance.vehicleInfo.vehicle.color}} <br />\r\n      Year: {{$ctrl.finance.vehicleInfo.vehicle.year}} <br />\r\n      Fuel Type: {{$ctrl.finance.vehicleInfo.vehicle.fuelType}} <br />\r\n      Capacity: {{$ctrl.finance.vehicleInfo.vehicle.capacity}} <br />\r\n      Transmission Type: {{$ctrl.finance.vehicleInfo.vehicle.transmissionType}} <br />\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n      <h3>Trade In Details</h3>\r\n      <hr />\r\n\r\n      Vehicle Condition: {{$ctrl.finance.vehicleInfo.tradeInVehicle.vehicleCondition}} <br />\r\n      Model: {{$ctrl.finance.vehicleInfo.tradeInVehicle.model}} <br />\r\n      Registration: \r\n      <a ui-sref=\"vehicleEdit({vehicleId: $ctrl.finance.vehicleInfo.tradeInVehicle.vehicleId, origin: {source:'editFinance', financeId: $ctrl.finance.financeId}})\">\r\n        {{$ctrl.finance.vehicleInfo.tradeInVehicle.registration}} </a><br />\r\n      Body Type: {{$ctrl.finance.vehicleInfo.tradeInVehicle.vehicleBodyType}} <br />\r\n      Color: {{$ctrl.finance.vehicleInfo.tradeInVehicle.color}} <br />\r\n      Year: {{$ctrl.finance.vehicleInfo.tradeInVehicle.year}} <br />\r\n      Fuel Type: {{$ctrl.finance.vehicleInfo.tradeInVehicle.fuelType}} <br />\r\n      Capacity: {{$ctrl.finance.vehicleInfo.tradeInVehicle.capacity}} <br />\r\n      Transmission Type: {{$ctrl.finance.vehicleInfo.tradeInVehicle.transmissionType}} <br />\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceVehicleInfoController = function FinanceVehicleInfoController() {
	  (0, _classCallCheck3.default)(this, FinanceVehicleInfoController);
	
	  this.name = 'financeVehicleInfo';
	};
	
	exports.default = FinanceVehicleInfoController;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1776);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeVehicleInfo.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeVehicleInfo.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeVehicleInfo{color:red}", ""]);
	
	// exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _priceBreakdown = __webpack_require__(1778);
	
	var _priceBreakdown2 = _interopRequireDefault(_priceBreakdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceBreakdownModule = _angular2.default.module('priceBreakdown', [_angularUiRouter2.default]).component('priceBreakdown', _priceBreakdown2.default).name;
	
	exports.default = priceBreakdownModule;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _priceBreakdown = __webpack_require__(1779);
	
	var _priceBreakdown2 = _interopRequireDefault(_priceBreakdown);
	
	var _priceBreakdown3 = __webpack_require__(1780);
	
	var _priceBreakdown4 = _interopRequireDefault(_priceBreakdown3);
	
	__webpack_require__(1781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceBreakdownComponent = {
	  restrict: 'E',
	  bindings: {
	    finance: '='
	  },
	  template: _priceBreakdown2.default,
	  controller: _priceBreakdown4.default
	};
	
	exports.default = priceBreakdownComponent;

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <table class=\"table table-hover\">\r\n    <thead>\r\n        <tr>\r\n            <th class=\"col-md-4\">Item</th>\r\n            <th class=\"col-md-8\">Amount</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr>\r\n          <td class=\"col-md-4\">Vehicle Price</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.vehiclePrice | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Discount</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.discount | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Trade In</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.tradeIn | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Advanced Deposit</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.deposit | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Warranty</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.warranty | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Accessories</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.accessories | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Settlement</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.settlement | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">GMFV</td>\r\n          <td class=\"col-md-8\">\r\n            <a ui-sref=\"vehicleEdit({vehicleId: $ctrl.finance.vehicleInfo.vehicle.vehicleId, origin: {source:'editFinance', financeId: $ctrl.finance.financeId}})\">\r\n              € {{$ctrl.finance.priceBreakdown.gmfv | number : 2}}\r\n            </a>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Balance</td>\r\n          <td class=\"col-md-8\">\r\n            <a ui-sref=\"enquiryEdit({enquiryId: $ctrl.finance.financeId, origin: 'editFinance'})\">\r\n                € {{$ctrl.finance.priceBreakdown.financeAmount | number : 2}}\r\n            </a>                        \r\n          </td>\r\n        </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n"

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceBreakdownController = function PriceBreakdownController(enums) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PriceBreakdownController);
	  this.enums = enums;
	};
	PriceBreakdownController.$inject = ["enums"];
	
	exports.default = PriceBreakdownController;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1782);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./priceBreakdown.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./priceBreakdown.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".priceBreakdown{color:red}", ""]);
	
	// exports


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeQuotes = __webpack_require__(1784);
	
	var _financeQuotes2 = _interopRequireDefault(_financeQuotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeQuotesModule = _angular2.default.module('financeQuotes', [_angularUiRouter2.default]).component('financeQuotes', _financeQuotes2.default).name;
	
	exports.default = financeQuotesModule;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeQuotes = __webpack_require__(1785);
	
	var _financeQuotes2 = _interopRequireDefault(_financeQuotes);
	
	var _financeQuotes3 = __webpack_require__(1786);
	
	var _financeQuotes4 = _interopRequireDefault(_financeQuotes3);
	
	__webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeQuotesComponent = {
	  restrict: 'E',
	  bindings: {
	    finance: '='
	  },
	  template: _financeQuotes2.default,
	  controller: _financeQuotes4.default
	};
	
	exports.default = financeQuotesComponent;

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <table class=\"table table-hover\">\r\n    <thead>\r\n        <tr>\r\n            <th class=\"col-md-4\">Item</th>\r\n            <th class=\"col-md-8\">Amount</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr>\r\n          <td class=\"col-md-4\">Vehicle Price</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.vehiclePrice | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Discount</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.discount | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Trade In</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.tradeIn | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n            <td class=\"col-md-4\">Trade In (Overallowance)</td>\r\n            <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.tradeInOverAllowance | number : 2}}</td>\r\n          </tr>        \r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Advanced Deposit</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.deposit | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Warranty</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.warranty | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Accessories</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.accessories | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Settlement</td>\r\n          <td class=\"col-md-8\">€ {{$ctrl.finance.priceBreakdown.settlement | number : 2}}</td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">GMFV</td>\r\n          <td class=\"col-md-8\">\r\n            <a ui-sref=\"vehicleEdit({vehicleId: $ctrl.finance.vehicleInfo.vehicle.vehicleId, origin: {source:'editFinance', financeId: $ctrl.finance.financeId}})\">\r\n              € {{$ctrl.finance.priceBreakdown.gmfv | number : 2}}\r\n            </a>\r\n          </td>\r\n        </tr>\r\n\r\n        <tr>\r\n          <td class=\"col-md-4\">Balance</td>\r\n          <td class=\"col-md-8\">\r\n            <a ui-sref=\"enquiryEdit({enquiryId: $ctrl.finance.financeId, origin: 'editFinance'})\">\r\n                € {{$ctrl.finance.priceBreakdown.financeAmount | number : 2}}\r\n            </a>                        \r\n          </td>\r\n        </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n\r\n<div>\r\n  <div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-3\">Quote Name *</label>\r\n      <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"$ctrl.finance.name\" placeholder=\"Enter quote name\" maxLength=150>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-3\">Balance to Finance</label>\r\n      <div class=\"col-sm-9\">\r\n        <label class=\"control-label\">\r\n          <a ui-sref=\"enquiryEdit({enquiryId: $ctrl.finance.financeId, origin: 'editFinance'})\">\r\n            € {{$ctrl.finance.priceBreakdown.financeAmount | number : 2}}\r\n          </a>\r\n        </label>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-3\">HP Options</label>\r\n      <div class=\"col-sm-3\">\r\n        <label class=\"control-label\" for=\"hp0\">\r\n          <input type=\"radio\" ng-model=\"$ctrl.finance.selectedOption\" value=\"hp0\" id=\"hp0\" ng-disabled=\"$ctrl.isOptionSelectable($ctrl.enums.FINANCE_TYPE.HP, 0)\">\r\n          <a href=\"#\" ng-click=\"$ctrl.viewHpCalculator(false, 0)\">{{$ctrl.hpTexts[0]}}</a>\r\n        </label>\r\n      </div>\r\n      <div class=\"col-sm-3\">\r\n        <label class=\"control-label\" for=\"hp1\">\r\n          <input type=\"radio\" ng-model=\"$ctrl.finance.selectedOption\" value=\"hp1\" id=\"hp1\" ng-disabled=\"$ctrl.isOptionSelectable($ctrl.enums.FINANCE_TYPE.HP, 1)\">\r\n          <a href=\"#\" ng-click=\"$ctrl.viewHpCalculator(false, 1)\">{{$ctrl.hpTexts[1]}}</a>\r\n        </label>\r\n      </div>\r\n      <div class=\"col-sm-3\">\r\n        <label class=\"control-label\" for=\"hp2\">\r\n          <input type=\"radio\" ng-model=\"$ctrl.finance.selectedOption\" value=\"hp2\" id=\"hp2\" ng-disabled=\"$ctrl.isOptionSelectable($ctrl.enums.FINANCE_TYPE.HP, 2)\">\r\n          <a href=\"#\" ng-click=\"$ctrl.viewHpCalculator(false, 2)\">{{$ctrl.hpTexts[2]}}</a>\r\n        </label>\r\n      </div>            \r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-3\">PCP Options</label>\r\n      <div class=\"col-sm-9\">\r\n        <label class=\"control-label\" for=\"pcp0\">\r\n          <input type=\"radio\" ng-model=\"$ctrl.finance.selectedOption\" value=\"pcp0\" id=\"pcp0\" ng-disabled=\"$ctrl.isOptionSelectable($ctrl.enums.FINANCE_TYPE.PCP, 0)\">\r\n          <a href=\"#\" ng-click=\"$ctrl.viewPcpCalculator(false, 0)\">{{$ctrl.pcpTexts[0]}}</a>\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <div class=\"dropdown\">\r\n        <button class=\"btn btn-primary\" type=\"button\" data-toggle=\"dropdown\">\r\n          <i class=\"fa fa-euro\"></i>\r\n          View Calculator\r\n          <span class=\"caret\"></span>\r\n        </button>\r\n        <ul class=\"dropdown-menu\">\r\n          <li><a href=\"#\" ng-click=\"$ctrl.viewHpCalculator(true)\">HP Calculator</a></li>\r\n          <li><a href=\"#\" ng-click=\"$ctrl.viewPcpCalculator(true)\">PCP Calculator</a></li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n      <div class=\"dropdown\">\r\n        <button class=\"btn btn-primary\" type=\"button\" data-toggle=\"dropdown\">        \r\n          View Quotation\r\n          <span class=\"caret\"></span>\r\n        </button>\r\n        <ul class=\"dropdown-menu\">\r\n          <li><a href=\"#\" ng-click=\"$ctrl.viewQuotation(false)\">All Options</a></li>\r\n          <li><a href=\"#\" ng-click=\"$ctrl.viewQuotation(true)\">Selected Option</a></li>\r\n        </ul>\r\n      </div>    \r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n      <a class=\"btn btn-default\" ng-click=\"$ctrl.editNotes()\">\r\n          <span class=\"fa fa-file-text-o\"></span>\r\n          Deal Specific Notes\r\n      </a>      \r\n    </div>\r\n\r\n    <a class=\"btn btn-primary\" ui-sref=\"financeProposal({financeId: $ctrl.finance.financeId})\" ng-hide=\"true\">View Proposal</a>\r\n  </div>\r\n  \r\n</div>"

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _financeCalculatorModal = __webpack_require__(1787);
	
	var _financeCalculatorModal2 = _interopRequireDefault(_financeCalculatorModal);
	
	var _financeCalculatorPcpModal = __webpack_require__(1788);
	
	var _financeCalculatorPcpModal2 = _interopRequireDefault(_financeCalculatorPcpModal);
	
	var _dealNotesModal = __webpack_require__(1789);
	
	var _dealNotesModal2 = _interopRequireDefault(_dealNotesModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceQuotesController = function () {
	  FinanceQuotesController.$inject = ["authService", "financeCompaniesManagementService", "$q", "$scope", "$uibModal", "utilsService", "loadingService", "enums", "printService", "growl"];
	  function FinanceQuotesController(authService, financeCompaniesManagementService, $q, $scope, $uibModal, utilsService, loadingService, enums, printService, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceQuotesController);
	    this.authService = authService;
	    this.financeCompaniesManagementService = financeCompaniesManagementService;
	    this.$q = $q;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.utilsService = utilsService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	    this.printService = printService;
	    this.growl = growl;
	
	    this.financeCompanies = [];
	    this.hpTexts = [];
	    this.pcpTexts = [];
	
	    this.$scope.$on('finance:initialized', this.financeInitialized.bind(this));
	  }
	
	  (0, _createClass3.default)(FinanceQuotesController, [{
	    key: 'financeInitialized',
	    value: function financeInitialized() {
	      var _this = this;
	
	      this.loadFinanceCompanies().then(function () {
	        _this.updateQuotes();
	      });
	    }
	  }, {
	    key: 'loadFinanceCompanies',
	    value: function loadFinanceCompanies() {
	      var _this2 = this;
	
	      var deferred = this.$q.defer();
	
	      this.financeCompaniesManagementService.listFinanceCompanies(this.authService.authData.currentLocation.key).then(function (response) {
	        _this2.financeCompanies = response.data.items;
	        _this2.financeCompanies.unshift({ 'financeCompanyId': null, name: 'Please Select' });
	
	        deferred.resolve();
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateQuotes',
	    value: function updateQuotes() {
	      var _this3 = this;
	
	      this.hpTexts[0] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 0);
	      this.hpTexts[1] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 1);
	      this.hpTexts[2] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, 2);
	      this.pcpTexts[0] = this.getFinanceText(this.enums.FINANCE_TYPE.PCP, 0);
	
	      this.finance.financeOptions.map(function (opt) {
	        opt.amountToFinance = _this3.finance.priceBreakdown.financeAmount;
	        opt.financeCompany = (0, _lodash.find)(_this3.financeCompanies, function (o) {
	          return o.financeCompanyId === opt.financeCompanyId;
	        });
	      });
	    }
	  }, {
	    key: 'viewHpCalculator',
	    value: function viewHpCalculator(isStandalone, optionIndex) {
	      var ctrl = this;
	
	      //Clear Watchers
	      if (ctrl.watcher1) {
	        this.watcher1();
	      }
	
	      //Props
	      ctrl.$scope.errMsg = '';
	      ctrl.$scope.financeCompanies = ctrl.financeCompanies;
	      ctrl.$scope.optionIndex = optionIndex;
	      ctrl.$scope.isStandalone = isStandalone;
	      ctrl.$scope.rateHidden = true;
	
	      if (isStandalone) {
	        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.HP, null);
	        ctrl.$scope.financeCalc.financeType = ctrl.enums.FINANCE_TYPE.HP;
	      } else {
	        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.HP, optionIndex);
	      }
	
	      //Methods
	      ctrl.$scope.$ctrl = ctrl;
	      ctrl.$scope.calculateAmount = ctrl.calculateAmount;
	      ctrl.$scope.calculateMonthly = ctrl.calculateMonthly;
	      ctrl.$scope.calculateTerm = ctrl.calculateTerm;
	      ctrl.$scope.calculateRate = ctrl.calculateRate;
	      ctrl.$scope.validateFinanceValues = ctrl.validateFinanceValues;
	      ctrl.$scope.validatePositiveNo = ctrl.validatePositiveNo;
	      ctrl.$scope.closeModal = ctrl.closeModal.bind(ctrl);
	      ctrl.$scope.saveOption = ctrl.saveOption.bind(ctrl);
	
	      ctrl.$scope.loadingService = ctrl.loadingService;
	      ctrl.$scope.utilsService = ctrl.utilsService;
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _financeCalculatorModal2.default,
	        scope: ctrl.$scope
	      });
	    }
	  }, {
	    key: 'viewPcpCalculator',
	    value: function viewPcpCalculator(isStandalone, optionIndex) {
	      var ctrl = this;
	
	      //Props
	      ctrl.$scope.errMsg = '';
	      ctrl.$scope.financeCompanies = ctrl.financeCompanies;
	      ctrl.$scope.optionIndex = optionIndex;
	      ctrl.$scope.isStandalone = isStandalone;
	      ctrl.$scope.rateHidden = true;
	
	      if (isStandalone) {
	        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.PCP, null);
	      } else {
	        ctrl.$scope.financeCalc = ctrl.getFinanceOption(ctrl.enums.FINANCE_TYPE.PCP, optionIndex);
	      }
	
	      ctrl.watcher1 = ctrl.$scope.$watch('financeCalc.deposit', this.updateFigures.bind(this));
	
	      //Set Net / Gross Figures
	      ctrl.updateFigures();
	
	      this.updateDeposit();
	
	      //Methods
	      ctrl.$scope.$ctrl = ctrl;
	      ctrl.$scope.calculateAmount = ctrl.calculateAmount;
	      ctrl.$scope.calculateMonthly = ctrl.calculateMonthly;
	      ctrl.$scope.calculateTerm = ctrl.calculateTerm;
	      ctrl.$scope.calculateRate = ctrl.calculateRate;
	      ctrl.$scope.validateFinanceValues = ctrl.validateFinanceValues;
	      ctrl.$scope.validatePositiveNo = ctrl.validatePositiveNo;
	      ctrl.$scope.closeModal = ctrl.closeModal.bind(ctrl);
	      ctrl.$scope.saveOption = ctrl.saveOption.bind(ctrl);
	      ctrl.$scope.toggleNet = ctrl.toggleNet.bind(ctrl);
	
	      ctrl.$scope.sliderOptions = {
	        floor: 10,
	        ceil: 30,
	        hideLimitLabels: true,
	        onChange: this.updateDeposit.bind(this),
	        onEnd: this.updateDeposit.bind(this)
	      };
	
	      ctrl.$scope.loadingService = ctrl.loadingService;
	      ctrl.$scope.utilsService = ctrl.utilsService;
	
	      ctrl.modalInstance = ctrl.$uibModal.open({
	        template: _financeCalculatorPcpModal2.default,
	        scope: ctrl.$scope
	      });
	    }
	  }, {
	    key: 'updateDeposit',
	    value: function updateDeposit() {
	      var deposit = 0;
	
	      this.$scope.financeCalc.amountToFinance = this.finance.priceBreakdown.vehiclePrice - (this.finance.priceBreakdown.tradeIn || 0) - (this.finance.priceBreakdown.discount || 0) - (this.$scope.financeCalc.deposit || 0) + (this.finance.priceBreakdown.warranty || 0) + (this.finance.priceBreakdown.accessories || 0) + (this.finance.priceBreakdown.settlement || 0);
	
	      this.$scope.financeCalc.calculatedDeposit = Math.round(this.$scope.vehiclePrice * this.$scope.financeCalc.depositPercent / 100, 2);
	      this.$scope.financeCalc.calculatedCashback = this.$scope.tradeInEquity + parseInt(this.$scope.financeCalc.deposit) - this.$scope.financeCalc.calculatedDeposit;
	    }
	  }, {
	    key: 'updateFigures',
	    value: function updateFigures() {
	      this.$scope.vehiclePrice = this.finance.priceBreakdown.vehiclePrice + this.finance.priceBreakdown.accessories;
	      this.$scope.tradeInEquity = this.finance.priceBreakdown.tradeIn + parseInt(this.$scope.financeCalc.deposit) - this.finance.priceBreakdown.settlement;
	
	      if (this.$scope.financeCalc.net) {
	        this.$scope.vehiclePrice -= this.finance.priceBreakdown.tradeInOverAllowance;
	        this.$scope.tradeInEquity -= this.finance.priceBreakdown.tradeInOverAllowance;
	      }
	
	      this.$scope.tradeInEquityPercent = this.$scope.tradeInEquity / this.$scope.vehiclePrice * 100;
	
	      this.updateDeposit();
	    }
	  }, {
	    key: 'toggleNet',
	    value: function toggleNet() {
	      this.$scope.financeCalc.net = !this.$scope.financeCalc.net;
	
	      this.updateFigures();
	      this.updateDeposit();
	    }
	  }, {
	    key: 'calculateAmount',
	    value: function calculateAmount() {
	      var _this4 = this;
	
	      this.errMsg = '';
	
	      var valuesToValidate = [
	      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
	      { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];
	
	      if (!this.validateFinanceValues(valuesToValidate)) {
	        return;
	      }
	
	      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');
	
	      this.utilsService.calculateAmount(this.financeCalc).then(function (response) {
	        _this4.financeCalc.amountToFinance = response.data;
	      }).finally(function () {
	        _this4.loadingService.hideLoading('financeCalc');
	      });
	    }
	  }, {
	    key: 'calculateMonthly',
	    value: function calculateMonthly() {
	      var _this5 = this;
	
	      this.errMsg = '';
	
	      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false },
	      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
	      { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }];
	
	      if (!this.validateFinanceValues(valuesToValidate)) {
	        return;
	      }
	
	      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');
	
	      this.utilsService.calculateMonthly(this.financeCalc).then(function (response) {
	        _this5.financeCalc.monthly = response.data;
	      }).finally(function () {
	        _this5.loadingService.hideLoading('financeCalc');
	      });
	    }
	  }, {
	    key: 'calculateTerm',
	    value: function calculateTerm() {
	      var _this6 = this;
	
	      this.errMsg = '';
	
	      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false },
	      /*{name: 'IRR', val: this.financeCalc.irr, allowEmpty: false},*/
	      { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];
	
	      if (!this.validateFinanceValues(valuesToValidate)) {
	        return;
	      }
	
	      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');
	
	      this.utilsService.calculateTerm(this.financeCalc).then(function (response) {
	        _this6.financeCalc.term = response.data;
	      }).finally(function () {
	        _this6.loadingService.hideLoading('financeCalc');
	      });
	    }
	  }, {
	    key: 'calculateRate',
	    value: function calculateRate() {
	      var _this7 = this;
	
	      this.errMsg = '';
	
	      var valuesToValidate = [{ name: 'Amount To Finance', val: this.financeCalc.amountToFinance, allowEmpty: false }, { name: 'Finance Term', val: this.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.financeCalc.monthly, allowEmpty: false }];
	
	      if (!this.validateFinanceValues(valuesToValidate)) {
	        return;
	      }
	
	      this.loadingService.showLoading('financeCalc', 'Updating Calculations ...');
	
	      this.utilsService.calculateRate(this.financeCalc).then(function (response) {
	        _this7.financeCalc.irr = response.data;
	      }).finally(function () {
	        _this7.loadingService.hideLoading('financeCalc');
	      });
	    }
	  }, {
	    key: 'validateFinanceValues',
	    value: function validateFinanceValues(arrValues) {
	      var _this8 = this;
	
	      var isValid = true;
	      arrValues.forEach(function (item) {
	        if (!_this8.validatePositiveNo(item.val, item.allowEmpty)) {
	          if (_this8.$scope) {
	            _this8.$scope.errMsg = item.name + ' must be a number and greater than 0';
	          } else {
	            _this8.errMsg = item.name + ' must be a number and greater than 0';
	          }
	          isValid = false;
	        }
	      });
	
	      return isValid;
	    }
	  }, {
	    key: 'validatePositiveNo',
	    value: function validatePositiveNo(val, allowEmpty) {
	      if (!allowEmpty) {
	        if (!val || typeof val === 'undefined' || val === null) {
	          return false;
	        }
	
	        if (!isFinite(val)) {
	          return false;
	        }
	
	        if (val <= 0) {
	          return false;
	        }
	
	        return true;
	      } else {
	        if (!val) {
	          return true;
	        }
	
	        if (!isFinite(val)) {
	          return false;
	        }
	
	        if (val <= 0) {
	          return false;
	        }
	
	        return true;
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modalInstance.close();
	    }
	  }, {
	    key: 'saveOption',
	    value: function saveOption() {
	      var valuesToValidate = [{ name: 'Amount To Finance', val: this.$scope.financeCalc.amountToFinance, allowEmpty: false },
	      /*{name: 'IRR', val: this.$scope.financeCalc.irr, allowEmpty: false},*/
	      { name: 'Finance Term', val: this.$scope.financeCalc.term, allowEmpty: false }, { name: 'Monthly', val: this.$scope.financeCalc.monthly, allowEmpty: false }];
	
	      if (this.$scope.financeCalc.financeCompany.financeCompanyId === null) {
	        this.$scope.errMsg = 'You must select a Finance Company';
	        return;
	      } else if (!this.validateFinanceValues(valuesToValidate)) {
	        return;
	      }
	
	      switch (this.$scope.financeCalc.financeType) {
	        case this.enums.FINANCE_TYPE.HP:
	          this.updateFinanceOption(this.enums.FINANCE_TYPE.HP, this.$scope.optionIndex, this.$scope.financeCalc);
	          this.hpTexts[this.$scope.optionIndex] = this.getFinanceText(this.enums.FINANCE_TYPE.HP, this.$scope.optionIndex);
	          break;
	
	        case this.enums.FINANCE_TYPE.PCP:
	          this.updateFinanceOption(this.enums.FINANCE_TYPE.PCP, this.$scope.optionIndex, this.$scope.financeCalc);
	          this.pcpTexts[this.$scope.optionIndex] = this.getFinanceText(this.enums.FINANCE_TYPE.PCP, this.$scope.optionIndex);
	          break;
	      }
	
	      this.closeModal();
	
	      if (!this.finance.selectedOption) {
	        if (this.$scope.financeCalc.financeType === this.enums.FINANCE_TYPE.HP) {
	          this.finance.selectedOption = 'hp' + this.$scope.optionIndex;
	        } else {
	          this.finance.selectedOption = 'pcp' + this.$scope.optionIndex;
	        }
	      }
	
	      this.$scope.$emit('saveFinance', { skipNotification: false });
	    }
	  }, {
	    key: 'getFinanceText',
	    value: function getFinanceText(financeType, optionIndex) {
	      var option = null;
	
	      option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
	        return o.financeType === financeType && o.index === optionIndex;
	      });
	
	      if (option) {
	        return '\u20AC' + option.monthly + ' for ' + option.term + ' months';
	      } else {
	        return 'Click here to update values';
	      }
	    }
	  }, {
	    key: 'getFinanceOption',
	    value: function getFinanceOption(financeType, optionIndex) {
	      var option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
	        return o.financeType === financeType && o.index === optionIndex;
	      });
	      //debugger;
	      if (financeType === this.enums.FINANCE_TYPE.HP && !option) {
	        if (optionIndex === null) {
	          //Standalone Version
	          option = {
	            financeCompany: this.financeCompanies[0],
	            amountToFinance: this.finance.priceBreakdown.financeAmount,
	            financeType: this.enums.FINANCE_TYPE.HP,
	            irr: 0,
	            term: 0,
	            monthly: 0
	          };
	        } else {
	          option = {
	            financeId: this.finance.financeId,
	            financeCompany: this.financeCompanies[0],
	            amountToFinance: this.finance.priceBreakdown.financeAmount,
	            financeType: this.enums.FINANCE_TYPE.HP,
	            irr: 0,
	            term: 0,
	            monthly: 0,
	            index: optionIndex
	          };
	        }
	
	        option.net = false;
	      }
	
	      if (financeType === this.enums.FINANCE_TYPE.PCP && !option) {
	        if (optionIndex === null) {
	          //Standalone Version
	          option = {
	            financeCompany: this.financeCompanies[0],
	            amountToFinance: this.finance.priceBreakdown.financeAmount,
	            depositPercent: 10,
	            financeType: this.enums.FINANCE_TYPE.PCP,
	            irr: 0,
	            term: 36,
	            monthly: 0,
	            proposedMileage: 'N/A'
	          };
	        } else {
	          option = {
	            financeId: this.finance.financeId,
	            financeCompany: this.financeCompanies[0],
	            amountToFinance: this.finance.priceBreakdown.financeAmount,
	            depositPercent: 10,
	            financeType: this.enums.FINANCE_TYPE.PCP,
	            irr: 0,
	            term: 36,
	            monthly: 0,
	            proposedMileage: 'N/A',
	            index: optionIndex
	          };
	        }
	
	        option.net = false;
	      }
	
	      if (financeType === this.enums.FINANCE_TYPE.PCP) {
	        option.deposit = this.finance.priceBreakdown.deposit;
	        option.gmfv = this.finance.priceBreakdown.gmfv || 0;
	      }
	
	      return option;
	    }
	  }, {
	    key: 'updateFinanceOption',
	    value: function updateFinanceOption(financeType, optionIndex, financeOption) {
	      var option = (0, _lodash.find)(this.finance.financeOptions, function (o) {
	        return o.financeType === financeType && o.index === optionIndex;
	      });
	
	      if (option) {
	        option = financeOption;
	      } else {
	        this.finance.financeOptions.push(financeOption);
	      }
	    }
	  }, {
	    key: 'isOptionSelectable',
	    value: function isOptionSelectable(financeType, optionIndex) {
	      return (0, _lodash.find)(this.finance.financeOptions, function (o) {
	        return o.financeType === financeType && o.index === optionIndex;
	      }) == null;
	    }
	  }, {
	    key: 'viewQuotation',
	    value: function viewQuotation(selectedOption) {
	      if (!this.finance.selectedOption) {
	        this.growl.error('Please provide at least one finance option first', { ttl: 5000 });
	        return;
	      }
	
	      this.printService.printFinanceQuotation(this.finance.financeId, selectedOption);
	    }
	  }, {
	    key: 'editNotes',
	    value: function editNotes() {
	      this.errMsg = '';
	      this.modalHeader = 'Update Deal Notes';
	      this.modelProp = this.finance.dealNotes;
	
	      this.modalInstance = this.$uibModal.open({
	        template: _dealNotesModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'saveNotes',
	    value: function saveNotes() {
	      this.finance.dealNotes = this.modelProp;
	
	      this.$scope.$emit('saveFinance');
	
	      this.closeModal();
	    }
	  }]);
	  return FinanceQuotesController;
	}();
	
	exports.default = FinanceQuotesController;

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <button type=\"button\"\r\n          class=\"close\"\r\n          data-dismiss=\"modal\"\r\n          aria-hidden=\"true\"\r\n          ng-click=\"closeModal()\">x</button>\r\n  <h2>  HP Calculator </h2>\r\n  <a href=\"#\" class=\"btn btn-small btn-default\" ng-click=\"rateHidden = !rateHidden\">{{rateHidden ? 'RS' : 'RH'}}</a>\r\n</div>\r\n\r\n<div class=\"modal-body\" block-ui=\"financeCalc\">\r\n  <div class=\"form-horizontal\">\r\n\r\n    <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n      {{errMsg}}\r\n    </div>\r\n    \r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Amount to Finance&nbsp;&nbsp;</label>\r\n        <div class=\"col-sm-10\">                \r\n            <div class=\"input-group\" ng-if=\"isStandalone\">\r\n              <input class=\"form-control\" ng-model=\"financeCalc.amountToFinance\" placeholder=\"Amount to Finance\">\r\n              <span class=\"input-group-btn\">\r\n                   <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateAmount()\"></button>\r\n              </span>\r\n           </div>              \r\n            <label class=\"control-label\" ng-if=\"!isStandalone\">{{financeCalc.amountToFinance | currency:'&euro;':2}}</label>\r\n        </div>\r\n      </div>         \r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Finance Provider&nbsp;&nbsp;</label>\r\n        <div class=\"col-sm-10\">\r\n          <select\r\n            class=\"form-control\"\r\n            ng-change=\"financeCalc.irr = financeCalc.financeCompany.sellRate; financeCalc.financeCompanyId = financeCalc.financeCompany.financeCompanyId\"\r\n            ng-options=\"item.name for item in financeCompanies track by item.financeCompanyId\"\r\n            ng-model=\"financeCalc.financeCompany\">\r\n          </select>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\" ng-show=\"!rateHidden\">\r\n        <label class=\"control-label col-sm-2\">IRR&nbsp;&nbsp;</label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"input-group\">\r\n             <input class=\"form-control\" ng-model=\"financeCalc.irr\" placeholder=\"Interest Rate\">\r\n             <span class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateRate()\"></button>\r\n             </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Finance Term&nbsp;&nbsp;</label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"input-group\">\r\n             <input class=\"form-control\" ng-model=\"financeCalc.term\" placeholder=\"Term (No. of Months)\">\r\n             <span class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateTerm()\"></button>\r\n             </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Monthly&nbsp;&nbsp;</label>\r\n        <div class=\"col-sm-10\">\r\n          <div class=\"input-group\">\r\n             <input class=\"form-control\" ng-model=\"financeCalc.monthly\" placeholder=\"Monthly\">\r\n             <span class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateMonthly()\"></button>\r\n             </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"form-group\">\r\n\r\n        <button type=\"submit\" ng-click=\"saveOption()\" class=\"btn btn-success\" style=\"width:48%\" ng-show=\"!isStandalone\">\r\n            <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n        </button>\r\n\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n        <button type=\"button\"\r\n                class=\"close\"\r\n                data-dismiss=\"modal\"\r\n                aria-hidden=\"true\"\r\n                ng-click=\"closeModal()\">x</button>\r\n        <h2>  PCP Calculator </h2>\r\n        <a href=\"#\" class=\"btn btn-small btn-default\" ng-click=\"rateHidden = !rateHidden\">{{rateHidden ? 'RS' : 'RH'}}</a>\r\n        <a href=\"#\" class=\"btn btn-small btn-default\" ng-click=\"toggleNet()\">{{financeCalc.net ? 'Use Gross Figures' : 'Use Net Figures'}}</a>\r\n      </div>\r\n      \r\n      <div class=\"modal-body\" block-ui=\"financeCalc\">\r\n        <div class=\"form-horizontal\">\r\n      \r\n          <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n            {{errMsg}}\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Road Price&nbsp;&nbsp;</label>    \r\n            <label class=\"control-label text-left col-sm-10\">{{vehiclePrice | currency:'&euro;':2}}&nbsp;&nbsp;</label>\r\n          </div>\r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">GMFV&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-4\">                \r\n                <input class=\"form-control\" ng-model=\"financeCalc.gmfv\" placeholder=\"GMFV\" ng-if=\"isStandalone\">                    \r\n                <label class=\"control-label\" ng-if=\"!isStandalone\">{{financeCalc.gmfv | currency:'&euro;':2}}</label>\r\n            </div>\r\n            <label class=\"control-label col-sm-2\">Proposed Mileage&nbsp;&nbsp;</label>\r\n            <label class=\"control-label text-left col-sm-4\">{{financeCalc.proposedMileage}}&nbsp;&nbsp;</label> \r\n          </div>    \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Cash Deposit&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-10\">\r\n                <input class=\"form-control\" ng-model=\"financeCalc.deposit\" placeholder=\"Deposit\" ng-if=\"isStandalone\">                    \r\n                <label class=\"control-label\" ng-if=\"!isStandalone\">{{financeCalc.deposit | currency:'&euro;':2}}</label>                              \r\n            </div>\r\n          </div>  \r\n          \r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Equity&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-10\">\r\n                <label class=\"control-label\">\r\n                  {{tradeInEquity | currency:'&euro;':2}} \r\n                  ({{tradeInEquityPercent | number:2}} %)\r\n                </label>\r\n            </div>\r\n          </div>            \r\n\r\n          <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Amount to Finance&nbsp;&nbsp;</label>    \r\n            <div class=\"col-sm-10\">\r\n                <label class=\"control-label\">{{financeCalc.amountToFinance | currency:'&euro;':2}}</label>                              \r\n             </div>\r\n           </div>  \r\n\r\n          <div class=\"form-group\" ng-show=\"isStandalone\">\r\n            <label class=\"control-label col-sm-2\">Variable Deposit&nbsp;&nbsp;</label>\r\n            <div class=\"col-sm-9\">\r\n                <rzslider class=\"custom-slider\" rz-slider-model=\"financeCalc.depositPercent\" rz-slider-options=\"sliderOptions\"></rzslider>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-show=\"isStandalone\">            \r\n            <label class=\"control-label col-sm-2\">Calculated Deposit&nbsp;&nbsp;</label>\r\n            <label class=\"control-label col-sm-4 text-left\">{{financeCalc.calculatedDeposit | currency:'&euro;':2}}&nbsp;&nbsp;</label>              \r\n            <label class=\"control-label col-sm-2\">Cashback&nbsp;&nbsp;</label>\r\n            <label class=\"control-label col-sm-4 text-left\" ng-class=\"{'cashback-positive': financeCalc.calculatedCashback >= 0, 'cashback-negative':financeCalc.calculatedCashback < 0}\">{{financeCalc.calculatedCashback | currency:'&euro;':2}}&nbsp;&nbsp;</label>\r\n          </div>                     \r\n      \r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-2\">Finance Provider&nbsp;&nbsp;</label>\r\n                <div class=\"col-sm-10\">\r\n                <select\r\n                    class=\"form-control\"\r\n                    ng-change=\"financeCalc.irr = financeCalc.financeCompany.sellRate; financeCalc.financeCompanyId = financeCalc.financeCompany.financeCompanyId\"\r\n                    ng-options=\"item.name for item in financeCompanies track by item.financeCompanyId\"\r\n                    ng-model=\"financeCalc.financeCompany\">\r\n                </select>\r\n                </div>\r\n            </div>\r\n      \r\n            <div class=\"form-group\" ng-show=\"!rateHidden\">\r\n              <label class=\"control-label col-sm-2\">IRR&nbsp;&nbsp;</label>\r\n              <div class=\"col-sm-10\">\r\n                <div class=\"input-group\">\r\n                   <input class=\"form-control\" ng-model=\"financeCalc.irr\" placeholder=\"Interest Rate\">\r\n                   <span class=\"input-group-btn\">\r\n                        <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateRate()\"></button>\r\n                   </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-2\">Monthly&nbsp;&nbsp;</label>\r\n              <div class=\"col-sm-10\">\r\n                <div class=\"input-group\">\r\n                   <input class=\"form-control\" ng-model=\"financeCalc.monthly\" placeholder=\"Monthly\">\r\n                   <span class=\"input-group-btn\">\r\n                        <button class=\"btn btn-default fa fa-calculator iconBtn\" type=\"button\" ng-click=\"calculateMonthly()\"></button>\r\n                   </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n          </div>\r\n      </div>\r\n      \r\n      <div class=\"modal-footer\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"form-group\">\r\n      \r\n              <button type=\"submit\" ng-click=\"saveOption()\" class=\"btn btn-success\" style=\"width:48%\" ng-show=\"!isStandalone\">\r\n                  <span class=\"glyphicon glyphicon-plus\"></span> Save Changes\r\n              </button>\r\n      \r\n            </div>\r\n          </div>\r\n      </div>\r\n      "

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n        <button type=\"button\"\r\n                class=\"close\"\r\n                data-dismiss=\"modal\"\r\n                aria-hidden=\"true\"\r\n                ng-click=\"$ctrl.closeModal()\">x</button>\r\n        <h2>Update Deal Notes</h2>\r\n    </div>\r\n    \r\n    <div class=\"modal-body\">\r\n    \r\n      <div id=\"result\" class=\"result\"></div>\r\n      <div class=\"form-horizontal\">      \r\n          <div class=\"row\">\r\n              <div class=\"col-md-3\">\r\n                <label>Deal Specific Notes</label>\r\n              </div>\r\n              <div class=\"col-md-9 ph10 mb5\">\r\n                <textarea\r\n                  maxlength=\"250\"\r\n                  rows=\"6\"\r\n                  class=\"form-control\"\r\n                  placeholder=\"Enter Deal Specific notes here\"\r\n                  ng-model=\"$ctrl.modelProp\">\r\n                </textarea>\r\n              </div>\r\n          </div>\r\n    \r\n          <div class=\"row\">\r\n              <div class=\"modal-footer\">\r\n                  <div class=\"col-md-12\">\r\n                      <div class=\"form-group\">\r\n    \r\n                        <button type=\"submit\" ng-click=\"$ctrl.saveNotes()\" name=\"save\" class=\"btn btn-success\" >\r\n                            <span class=\"fa fa-floppy-o\"></span> Save Changes\r\n                        </button>\r\n    \r\n                        <button type=\"submit\" ng-click=\"$ctrl.closeModal()\" name=\"save\" class=\"btn btn-warning\" >\r\n                            <span class=\"fa fa-times\"></span> Cancel\r\n                        </button>                    \r\n    \r\n    \r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n    \r\n      </div>\r\n    </div>\r\n    "

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1791);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeQuotes.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeQuotes.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeQuotes{color:red}.cashback-positive{color:green}.cashback-negative{color:red}.custom-slider.rzslider .rz-bar{background:gold;height:2px}.custom-slider.rzslider .rz-selection{background:pink}.custom-slider.rzslider .rz-pointer{width:6px;height:20px;top:auto;bottom:0;margin-bottom:-5px;background-color:#333}.custom-slider.rzslider .rz-pointer:after{display:none}.custom-slider.rzslider .rz-bubble{bottom:14px}.custom-slider.rzslider .rz-limit{font-weight:700;color:pink}.custom-slider.rzslider .rz-tick{width:1px;height:10px;margin-left:4px;border-radius:0;background:#ffe4d1;top:-1px}.custom-slider.rzslider .rz-tick.rz-selected{background:pink}", ""]);
	
	// exports


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _financeConclude = __webpack_require__(1793);
	
	var _financeConclude2 = _interopRequireDefault(_financeConclude);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeConcludeModule = _angular2.default.module('financeConclude', [_angularUiRouter2.default]).component('financeConclude', _financeConclude2.default).name;
	
	exports.default = financeConcludeModule;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financeConclude = __webpack_require__(1794);
	
	var _financeConclude2 = _interopRequireDefault(_financeConclude);
	
	var _financeConclude3 = __webpack_require__(1795);
	
	var _financeConclude4 = _interopRequireDefault(_financeConclude3);
	
	__webpack_require__(1797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var financeConcludeComponent = {
	  restrict: 'E',
	  bindings: {
	    finance: '='
	  },
	  template: _financeConclude2.default,
	  controller: _financeConclude4.default
	};
	
	exports.default = financeConcludeComponent;

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	module.exports = "<div block-ui=\"testDrives\">\r\n  <header>\r\n    <h2>Conclude Finance</h2>\r\n  </header>\r\n\r\n  <div ng-show=\"$ctrl.finance.state === $ctrl.enums.FINANCE_STATE.Customer_Accepted\">      \r\n        <div class=\"form-group\">\r\n          <label class=\"col-md-offset-2 control-label col-md-2\">Commission Achieved</label>\r\n          <div class=\"col-md-8\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Customer_Accepted)\">\r\n              {{$ctrl.finance.commissionAchieved | currency:'&euro;':2}}\r\n            </a>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label class=\"col-md-offset-2 control-label col-md-2\">Installment Start</label>\r\n          <label class=\"col-md-8\">{{$ctrl.finance.installmentStart | date : 'dd MMM yy' }}</label>\r\n        </div>\r\n  </div>  \r\n\r\n  <div class=\"col-md-offset-3 col-md-6\">\r\n    <div>\r\n      <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Status</label>\r\n        <div class=\"col-sm-10\">\r\n          <label class=\"col-sm-10\">{{$ctrl.statusText}}</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <br \\><br \\> \r\n\r\n  <div class=\"col-md-offset-3 col-md-6\" block-ui=\"enquiryConclusion\">\r\n    <button class=\"btn btn-default btn-block btn-lg\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Awaiting_Approval)\" ng-show=\"$ctrl.states.awaitingApproval\">\r\n        Awaiting Approval\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-success btn-block btn-lg\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Finance_Accepted)\" ng-show=\"$ctrl.states.financeAccepted\">\r\n        Finance Accepted\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-danger btn-block btn-lg\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Finance_Rejected)\" ng-show=\"$ctrl.states.financeRejected\">\r\n        Finance Rejected\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-success btn-block btn-lg\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Customer_Accepted)\" ng-show=\"$ctrl.states.customerAccepted\">\r\n        Customer Accepted\r\n    </button> <br>\r\n\r\n    <button class=\"btn btn-danger btn-block btn-lg\" ng-click=\"$ctrl.updateState($ctrl.enums.FINANCE_STATE.Customer_Rejected)\" ng-show=\"$ctrl.states.customerRejected\">\r\n        Customer Rejected\r\n    </button> <br>\r\n  </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _customerAcceptedModal = __webpack_require__(1796);
	
	var _customerAcceptedModal2 = _interopRequireDefault(_customerAcceptedModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceConcludeController = function () {
	  FinanceConcludeController.$inject = ["enums", "$scope", "$uibModal", "$ngConfirm", "growl"];
	  function FinanceConcludeController(enums, $scope, $uibModal, $ngConfirm, growl) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceConcludeController);
	    this.enums = enums;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.$ngConfirm = $ngConfirm;
	    this.growl = growl;
	
	    this.states = {};
	    this.statusText = '';
	
	    this.dtPopups = {}; //Cleanup
	
	    this.$scope.$on('finance:initialized', this.setStateVisibility.bind(this));
	  }
	
	  (0, _createClass3.default)(FinanceConcludeController, [{
	    key: 'resetStateVisibility',
	    value: function resetStateVisibility() {
	      this.states = {
	        awaitingApproval: false,
	        financeAccepted: false,
	        financeRejected: false,
	        customerAccepted: false,
	        customerRejected: false
	      };
	    }
	  }, {
	    key: 'setStateVisibility',
	    value: function setStateVisibility() {
	      this.resetStateVisibility();
	
	      switch (this.finance.state) {
	        case this.enums.FINANCE_STATE.Awaiting_Approval:
	          this.states.financeAccepted = true;
	          this.states.financeRejected = true;
	
	          this.statusText = 'Awaiting Approval';
	          break;
	
	        case this.enums.FINANCE_STATE.Finance_Accepted:
	          this.states.customerAccepted = true;
	          this.states.customerRejected = true;
	
	          this.statusText = 'Finance Accepted';
	          break;
	
	        case this.enums.FINANCE_STATE.Finance_Rejected:
	          this.states.awaitingApproval = true;
	
	          this.statusText = 'Finance Rejected';
	          break;
	
	        case this.enums.FINANCE_STATE.Customer_Accepted:
	          this.statusText = 'Customer Accepted';
	
	          this.states.customerRejected = true;
	          break;
	
	        case this.enums.FINANCE_STATE.Customer_Rejected:
	          this.statusText = 'Customer Rejected';
	          break;
	      }
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(newState) {
	      var _this = this;
	
	      if (newState === this.enums.FINANCE_STATE.Finance_Accepted && !this.finance.selectedOption) {
	        this.growl.error('Please provide at least one finance option first', { ttl: 5000 });
	        return;
	      }
	
	      if (newState === this.enums.FINANCE_STATE.Customer_Accepted) {
	        this.showCustomerAccepted();
	        return;
	      }
	
	      this.$ngConfirm({
	        title: 'Update Finance Status',
	        content: 'Are you sure you want to mark this deal as <br /> <b>' + this.getStateText(newState) + '</b>',
	        typeAnimation: false,
	        columnClass: 'm',
	        buttons: {
	          yes: {
	            text: 'Yes',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this.saveState(newState);
	            }
	          },
	          no: {
	            text: 'No',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getStateText',
	    value: function getStateText(state) {
	      switch (state) {
	        case this.enums.FINANCE_STATE.Awaiting_Approval:
	          return "Awaiting Approval";
	
	        case this.enums.FINANCE_STATE.Finance_Accepted:
	          return "Finance Accepted";
	
	        case this.enums.FINANCE_STATE.Finance_Rejected:
	          return "Finance Rejected";
	
	        case this.enums.FINANCE_STATE.Customer_Accepted:
	          return "Customer Accepted";
	
	        case this.enums.FINANCE_STATE.Customer_Rejected:
	          return "Customer Rejected";
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(id) {
	      this.dtPopups[id] = true;
	    }
	  }, {
	    key: 'showCustomerAccepted',
	    value: function showCustomerAccepted() {
	      this.errMsg = '';
	      this.modalData = {
	        commissionAchieved: this.finance.commissionAchieved,
	        installmentStart: this.finance.installmentStart
	      };
	
	      this.modalInstance = this.$uibModal.open({
	        template: _customerAcceptedModal2.default,
	        scope: this.$scope
	      });
	    }
	  }, {
	    key: 'customerAccepted',
	    value: function customerAccepted() {
	      this.finance.commissionAchieved = this.modalData.commissionAchieved;
	      this.finance.installmentStart = this.modalData.installmentStart;
	
	      this.saveState(this.enums.FINANCE_STATE.Customer_Accepted);
	
	      this.closeModal();
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.modalInstance.close();
	    }
	  }, {
	    key: 'saveState',
	    value: function saveState(newState) {
	      this.finance.state = newState;
	
	      this.$scope.$emit('saveFinance');
	
	      this.setStateVisibility();
	    }
	  }]);
	  return FinanceConcludeController;
	}();
	
	exports.default = FinanceConcludeController;

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n        <button type=\"button\"\r\n                class=\"close\"\r\n                data-dismiss=\"modal\"\r\n                aria-hidden=\"true\"\r\n                ng-click=\"$ctrl.closeModal()\">x</button>\r\n        <h2>  Customer Accepted</h2>\r\n    </div>\r\n    \r\n    <div class=\"modal-body\">\r\n    \r\n      <div id=\"result\" class=\"result\"></div>\r\n      <div class=\"form-horizontal\">\r\n          <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsg !== ''\">\r\n            {{$ctrl.errMsg}}\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n              <div class=\"col-md-3\">\r\n                <label>Commission Achieved *</label>\r\n              </div>\r\n              <div class=\"col-md-9 ph10 mb5\">\r\n                  <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.modalData.commissionAchieved\" placeholder=\"Commission Achieved\">          \r\n              </div>\r\n          </div>          \r\n    \r\n          <div class=\"row\">\r\n              <div class=\"col-md-3\">\r\n                <label>Installment Start</label>\r\n              </div>\r\n              <div class=\"col-md-9 ph10 mb5\">\r\n                <p class=\"input-group\">\r\n                  <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.modalData.showTimeStamp = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.modalData.installmentStart\" is-open=\"$ctrl.modalData.showTimeStamp\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n                  <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.modalData.showTimeStamp = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                  </span>\r\n                </p>\r\n              </div>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n              <div class=\"modal-footer\">\r\n                  <div class=\"col-md-12\">\r\n                      <div class=\"form-group\">\r\n    \r\n                        <button type=\"submit\" ng-click=\"$ctrl.customerAccepted()\" name=\"save\" class=\"btn btn-success\" style=\"width:48%\">\r\n                            <span class=\"fa fa-floppy-o\"></span> Save Changes\r\n                        </button>\r\n    \r\n    \r\n                      </div>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n    \r\n      </div>\r\n    </div>\r\n    "

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1798);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeConclude.styl", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./financeConclude.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".financeConclude{color:red}", ""]);
	
	// exports


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinanceService = function () {
	  FinanceService.$inject = ["$http", "appConfig"];
	  function FinanceService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FinanceService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(FinanceService, [{
	    key: "getFinance",
	    value: function getFinance(financeId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/finance/get/" + financeId));
	    }
	  }, {
	    key: "editFinance",
	    value: function editFinance(entityId, finance) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/finance/edit/" + entityId), finance);
	    }
	  }, {
	    key: "acknowledge",
	    value: function acknowledge(financeId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/finance/acknowledge/" + financeId));
	    }
	  }]);
	  return FinanceService;
	}();
	
	exports.default = FinanceService;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _omniSearch = __webpack_require__(1801);
	
	var _omniSearch2 = _interopRequireDefault(_omniSearch);
	
	var _search = __webpack_require__(1806);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _enquiriesSearch = __webpack_require__(1807);
	
	var _enquiriesSearch2 = _interopRequireDefault(_enquiriesSearch);
	
	var _contactOmniSearch = __webpack_require__(1813);
	
	var _contactOmniSearch2 = _interopRequireDefault(_contactOmniSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var omniSearchModule = _angular2.default.module('omniSearch', [_angularUiRouter2.default, _enquiriesSearch2.default, _contactOmniSearch2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('omniSearch', {
	    component: 'omniSearch',
	    url: '/omniSearch'
	  });
	}]).component('omniSearch', _omniSearch2.default).service('searchService', _search2.default).name;
	
	exports.default = omniSearchModule;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omniSearch = __webpack_require__(1802);
	
	var _omniSearch2 = _interopRequireDefault(_omniSearch);
	
	var _omniSearch3 = __webpack_require__(1803);
	
	var _omniSearch4 = _interopRequireDefault(_omniSearch3);
	
	__webpack_require__(1804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var omniSearchComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _omniSearch2.default,
	  controller: _omniSearch4.default
	};
	
	exports.default = omniSearchComponent;

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-lg-9 col-md-7 mt-1-desktop-lg\">\r\n        <h1 class=\"dashboard-title\">Search Section</h1>\r\n    </div>\r\n    <div class=\"col-lg-3 col-md-5\">\r\n    </div>\r\n</div>\r\n\r\n<div>\r\n  <form class=\"form-horizontal\" name=\"entityForm\" novalidate ng-submit=\"$ctrl.search()\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">                   \r\n        <input class=\"form-control\" type=\"text\" placeholder=\"Search Term ...\" ng-model=\"$ctrl.searchTerm\" ng-disabled=\"$ctrl.searching\"/>        \r\n      </div>  \r\n      <div class=\"col-md-3\">                   \r\n          <button class=\"btn btn-primary\" ng-submit=\"$ctrl.search()\" ng-disabled=\"$ctrl.searching\">Search</button>\r\n      </div>              \r\n    </div>\r\n  </form>  \r\n\r\n  <br />\r\n\r\n  <uib-tabset active=\"activeJustified\">\r\n    <uib-tab index=\"0\">\r\n      <uib-tab-heading>\r\n        Enquiries \r\n        <span class=\"badge\" ng-hide=\"$ctrl.panels.enquiries.loading\">{{$ctrl.panels.enquiries.results}}</span>\r\n        <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.panels.enquiries.loading\"></i>\r\n      </uib-tab-heading>      \r\n\r\n      <enquiries-search on-update=\"$ctrl.panelLoaded(panelName, numResults)\" on-select=\"$ctrl.linkSelected(selectedObj)\"></enquiries-search>\r\n    </uib-tab>\r\n\r\n    <uib-tab index=\"1\">\r\n      <uib-tab-heading>\r\n        Contacts\r\n        <span class=\"badge\" ng-hide=\"$ctrl.panels.contacts.loading\">{{$ctrl.panels.contacts.results}}</span>\r\n        <i class=\"fa fa-spinner fa-spin\" ng-show=\"$ctrl.panels.contacts.loading\"></i>        \r\n      </uib-tab-heading>            \r\n        \r\n      <contact-omni-search on-update=\"$ctrl.panelLoaded(panelName, numResults)\" on-select=\"$ctrl.linkSelected(selectedObj)\"></contact-omni-search>\r\n    </uib-tab>    \r\n  </uib-tabset>\r\n</div>"

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OmniSearchController = function () {
	  OmniSearchController.$inject = ["$scope", "$ngConfirm", "authService", "enums", "$state"];
	  function OmniSearchController($scope, $ngConfirm, authService, enums, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, OmniSearchController);
	    this.$scope = $scope;
	    this.$ngConfirm = $ngConfirm;
	    this.enums = enums;
	    this.$state = $state;
	    this.authService = authService;
	
	    this.searchTerm;
	
	    this.panels = [];
	    this.panels['enquiries'] = { loading: false, results: null };
	    this.panels['contacts'] = { loading: false, results: null };
	
	    this.currentEntityId = authService.authData.currentLocation.key;
	
	    this.searching = false;
	  }
	
	  (0, _createClass3.default)(OmniSearchController, [{
	    key: 'search',
	    value: function search() {
	      if (!this.searchTerm || this.searchTerm.length < 3) {
	        this.$ngConfirm({
	          title: "Error",
	          content: 'Please search with a minimum of 3 characters',
	          type: 'red',
	          buttons: {
	            ok: function ok() {}
	          }
	        });
	
	        return;
	      }
	
	      this.panels.enquiries.loading = true;
	      this.panels.contacts.loading = true;
	      this.searching = true;
	
	      this.$scope.$broadcast('omniSearch:search', this.searchTerm);
	    }
	  }, {
	    key: 'panelLoaded',
	    value: function panelLoaded(panelName, numResults) {
	      this.panels[panelName].loading = false;
	      this.panels[panelName].results = numResults;
	
	      this.allPanelsLoaded();
	    }
	  }, {
	    key: 'allPanelsLoaded',
	    value: function allPanelsLoaded() {
	      this.searching = (0, _lodash.find)(this.panels, function (o) {
	        return o.loading;
	      }) != null;
	    }
	  }, {
	    key: 'linkSelected',
	    value: function linkSelected(selectedObj) {
	      var _this = this;
	
	      if (selectedObj.entityId === this.currentEntityId) {
	        this.gotoLink(selectedObj);
	        return;
	      }
	
	      this.$ngConfirm({
	        title: "Warning",
	        content: 'The object you\'re trying to navigate is not in your currently selected location.<br><br>If you wish to proceed, your selected location will be updated',
	        type: 'orange',
	        columnClass: 'l',
	        buttons: {
	          ok: {
	            text: 'Proceed',
	            btnClass: 'btn-primary',
	            action: function action() {
	              _this.authService.updateLocationById(selectedObj.entityId);
	              _this.gotoLink(selectedObj);
	            }
	          },
	          cancel: {
	            text: 'Not sure',
	            btnClass: 'btn-default',
	            action: function action() {}
	          }
	        }
	      });
	    }
	  }, {
	    key: 'gotoLink',
	    value: function gotoLink(selectedObj) {
	      switch (selectedObj.objectType) {
	        case this.enums.OMNISEARCH_OBJECT_TYPE.Enquiry:
	          this.$state.go('enquiryEdit', { enquiryId: selectedObj.objectId });
	          break;
	
	        case this.enums.OMNISEARCH_OBJECT_TYPE.Contact:
	          this.$state.go('contactView', { contactId: selectedObj.objectId });
	          break;
	      }
	    }
	  }]);
	  return OmniSearchController;
	}();
	
	exports.default = OmniSearchController;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1805);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./omniSearch.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./omniSearch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".omniSearch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchService = function () {
	  SearchService.$inject = ["$http", "$q", "authService", "appConfig"];
	  function SearchService($http, $q, authService, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SearchService);
	    this.$http = $http;
	    this.$q = $q;
	    this.appConfig = appConfig;
	    this.authService = authService;
	  }
	
	  (0, _createClass3.default)(SearchService, [{
	    key: 'buildSearchQuery',
	    value: function buildSearchQuery(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	
	      query += '&searchTerm=' + filterParams.searchTerm;
	
	      return query;
	    }
	  }, {
	    key: 'searchEnquiriesByReg',
	    value: function searchEnquiriesByReg(filterParams) {
	      var entityIds = (0, _lodash.map)(this.authService.authData.userLocations, function (o) {
	        return o.key;
	      });
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/search/enquiries' + this.buildSearchQuery(filterParams), entityIds);
	    }
	  }, {
	    key: 'searchContacts',
	    value: function searchContacts(filterParams) {
	      var entityIds = (0, _lodash.map)(this.authService.authData.userLocations, function (o) {
	        return o.key;
	      });
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/search/contacts' + this.buildSearchQuery(filterParams), entityIds);
	    }
	  }]);
	  return SearchService;
	}();
	
	exports.default = SearchService;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiriesSearch = __webpack_require__(1808);
	
	var _enquiriesSearch2 = _interopRequireDefault(_enquiriesSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesSearchModule = _angular2.default.module('enquiriesSearch', [_angularUiRouter2.default]).component('enquiriesSearch', _enquiriesSearch2.default).name;
	
	exports.default = enquiriesSearchModule;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiriesSearch = __webpack_require__(1809);
	
	var _enquiriesSearch2 = _interopRequireDefault(_enquiriesSearch);
	
	var _enquiriesSearch3 = __webpack_require__(1810);
	
	var _enquiriesSearch4 = _interopRequireDefault(_enquiriesSearch3);
	
	__webpack_require__(1811);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesSearchComponent = {
	  restrict: 'E',
	  bindings: {
	    onUpdate: '&',
	    onSelect: '&'
	  },
	  template: _enquiriesSearch2.default,
	  controller: _enquiriesSearch4.default
	};
	
	exports.default = enquiriesSearchComponent;

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-bordered table-hover table-striped\" block-ui=\"enquiriesList\">\r\n  <thead>\r\n      <tr>\r\n        <th class=\"col-md-1\">\r\n          <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('locationName')\">\r\n            Location <i class=\"fa fa-fw fa-sort\"></i>\r\n          </a>          \r\n        </th>\r\n        <th class=\"col-md-2\">\r\n          <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contactName')\">\r\n            Contact <i class=\"fa fa-fw fa-sort\"></i>\r\n          </a>\r\n        </th>\r\n        <th class=\"col-md-1\">\r\n            Phone\r\n        </th>            \r\n        <th class=\"col-md-2\">              \r\n          Subject\r\n        </th>\r\n        <th class=\"col-md-1\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('enquiryReg')\">\r\n              Enquiry Reg <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n        </th>\r\n        <th class=\"col-md-1\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('tradeInReg')\">\r\n              TradeIn Reg <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n        </th>\r\n        <th class=\"col-md-2\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('salesPerson')\">\r\n              Sales Person <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n        </th>\r\n        <th class=\"col-md-1\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('created')\">\r\n              Created <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n        </th>        \r\n        <th class=\"col-md-1\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('status')\">\r\n              Status <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n        </th>   \r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr data-ng-repeat=\"e in $ctrl.enquiries\">\r\n          <td class=\"col-md-1\">\r\n            {{ e.locationName }}\r\n          </td>        \r\n          <td class=\"col-md-2\">\r\n            <a href=\"#\"\r\n              ng-click=\"$ctrl.onSelect({selectedObj: {objectType: $ctrl.enums.OMNISEARCH_OBJECT_TYPE.Contact, entityId: e.entityId, objectId: e.contactId}})\">\r\n            {{ e.contactName }}\r\n            </a>\r\n          </td>\r\n          <td class=\"col-md-1\">\r\n            {{ e.contactMobile }}\r\n          </td>\r\n          <td class=\"col-md-2\">\r\n              <a href=\"#\"\r\n              ng-click=\"$ctrl.onSelect({selectedObj: {objectType: $ctrl.enums.OMNISEARCH_OBJECT_TYPE.Enquiry, entityId: e.entityId, objectId: e.enquiryId}})\">\r\n              {{ e.subject }}\r\n            </a>                \r\n          </td>         \r\n          <td class=\"col-md-1\">\r\n            {{ e.enquiryReg }}\r\n          </td>            \r\n          <td class=\"col-md-1\">\r\n            {{ e.tradeInReg }}\r\n          </td>           \r\n          <td class=\"col-md-2\">\r\n            {{ e.salesPerson }}\r\n          </td>              \r\n          <td class=\"col-md-1\">\r\n            {{ e.created | date : 'dd MMM yyyy' }}\r\n          </td>                         \r\n          <td class=\"col-md-1\">\r\n            {{ e.status }}\r\n          </td>           \r\n      </tr>\r\n  </tbody>\r\n</table>\r\n\r\n<footer>\r\n<div class=\"row\" >\r\n  <div class=\"col-md-8 pages\" ng-hide=\"!$ctrl.enquiries.length\">\r\n    <ul uib-pagination\r\n      boundary-link-numbers=\"true\"\r\n      max-size=\"7\"\r\n      total-items=\"$ctrl.pagination.totalItems\"\r\n      items-per-page=\"$ctrl.pagination.pageSize\"\r\n      ng-model=\"$ctrl.pagination.currentPage\"\r\n      ng-change=\"$ctrl.searchEnquiries()\">\r\n    </ul>\r\n  </div>\r\n\r\n  <span class=\"col-md-4 pull-right\">\r\n    <span class=\"pull-right\">\r\n      {{$ctrl.notification.msg}}\r\n    </span>\r\n  </span>\r\n</div>\r\n</footer>  "

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiriesSearchController = function () {
	  EnquiriesSearchController.$inject = ["$scope", "searchService", "loadingService", "enums"];
	  function EnquiriesSearchController($scope, searchService, loadingService, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EnquiriesSearchController);
	    this.$scope = $scope;
	    this.searchService = searchService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	
	    this.filterParams = {};
	    this.enquiries = null;
	
	    this.$scope.$on('omniSearch:search', this.searchEnquiries.bind(this));
	  }
	
	  (0, _createClass3.default)(EnquiriesSearchController, [{
	    key: 'reset',
	    value: function reset() {
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'created',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.searchEnquiries();
	    }
	  }, {
	    key: 'searchEnquiries',
	    value: function searchEnquiries(evt, searchTerm) {
	      if (searchTerm) {
	        this.reset();
	        this.filterParams.searchTerm = searchTerm;
	      }
	
	      this.enquiries = null;
	
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('enquiriesList', 'Searching Enquiries ...');
	
	      this.searchService.searchEnquiriesByReg(this.filterParams).then(function (response) {
	        ctrl.enquiries = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' enquiries'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('enquiriesList');
	
	        ctrl.onUpdate({ panelName: 'enquiries', numResults: ctrl.pagination.totalItems });
	      });
	    }
	  }]);
	  return EnquiriesSearchController;
	}();
	
	exports.default = EnquiriesSearchController;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1812);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesSearch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesSearch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiriesSearch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contactOmniSearch = __webpack_require__(1814);
	
	var _contactOmniSearch2 = _interopRequireDefault(_contactOmniSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactOmniSearchModule = _angular2.default.module('contactOmniSearch', [_angularUiRouter2.default]).component('contactOmniSearch', _contactOmniSearch2.default).name;
	
	exports.default = contactOmniSearchModule;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactOmniSearch = __webpack_require__(1815);
	
	var _contactOmniSearch2 = _interopRequireDefault(_contactOmniSearch);
	
	var _contactOmniSearch3 = __webpack_require__(1816);
	
	var _contactOmniSearch4 = _interopRequireDefault(_contactOmniSearch3);
	
	__webpack_require__(1817);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactOmniSearchComponent = {
	  restrict: 'E',
	  bindings: {
	    onUpdate: '&',
	    onSelect: '&'
	  },
	  template: _contactOmniSearch2.default,
	  controller: _contactOmniSearch4.default
	};
	
	exports.default = contactOmniSearchComponent;

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-bordered table-hover table-striped\" block-ui=\"contactList\">\r\n    <thead>\r\n        <tr>\r\n          <th class=\"col-md-2\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('locationName')\">\r\n              Location <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n          </th>        \r\n          <th class=\"col-md-2\">\r\n            <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contactName')\">\r\n              Contact Name <i class=\"fa fa-fw fa-sort\"></i>\r\n            </a>\r\n          </th>\r\n          <th class=\"col-md-1\">\r\n              Type\r\n          </th>                    \r\n          <th class=\"col-md-1\">\r\n              Phone\r\n          </th>            \r\n          <th class=\"col-md-2\">\r\n              Email\r\n          </th>\r\n          <th class=\"col-md-1\">\r\n              Current Reg\r\n          </th>        \r\n          <th class=\"col-md-2\">\r\n              Owner\r\n          </th>                \r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr data-ng-repeat=\"c in $ctrl.contacts\">\r\n            <td class=\"col-md-2\">\r\n              {{ c.locationName }}\r\n            </td>\r\n            <td class=\"col-md-2\">\r\n                <a href=\"#\"\r\n                ng-click=\"$ctrl.onSelect({selectedObj: {objectType: $ctrl.enums.OMNISEARCH_OBJECT_TYPE.Contact, entityId: c.entityId, objectId: c.contactId}})\">\r\n              {{ c.contactName }}\r\n              </a>\r\n            </td>          \r\n            <td class=\"col-md-1\">\r\n              {{ c.contactType }}\r\n            </td>          \r\n            <td class=\"col-md-1\">\r\n              {{ c.phone }}\r\n            </td>\r\n            <td class=\"col-md-2\">\r\n              {{ c.email }} \r\n            </td>         \r\n            <td class=\"col-md-1\">\r\n              {{ c.currentReg }}\r\n            </td>            \r\n            <td class=\"col-md-2\">\r\n              {{ c.salesPerson }}\r\n            </td>           \r\n        </tr>\r\n    </tbody>\r\n  </table>\r\n  \r\n  <footer>\r\n  <div class=\"row\" >\r\n    <div class=\"col-md-8 pages\" ng-hide=\"!$ctrl.contacts.length\">\r\n      <ul uib-pagination\r\n        boundary-link-numbers=\"true\"\r\n        max-size=\"7\"\r\n        total-items=\"$ctrl.pagination.totalItems\"\r\n        items-per-page=\"$ctrl.pagination.pageSize\"\r\n        ng-model=\"$ctrl.pagination.currentPage\"\r\n        ng-change=\"$ctrl.searchContacts()\">\r\n      </ul>\r\n    </div>\r\n  \r\n    <span class=\"col-md-4 pull-right\">\r\n      <span class=\"pull-right\">\r\n        {{$ctrl.notification.msg}}\r\n      </span>\r\n    </span>\r\n  </div>\r\n  </footer>  "

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactOmniSearchController = function () {
	  ContactOmniSearchController.$inject = ["$scope", "searchService", "loadingService", "enums"];
	  function ContactOmniSearchController($scope, searchService, loadingService, enums) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ContactOmniSearchController);
	    this.$scope = $scope;
	    this.searchService = searchService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	
	    this.filterParams = {};
	    this.contacts = null;
	
	    this.$scope.$on('omniSearch:search', this.searchContacts.bind(this));
	  }
	
	  (0, _createClass3.default)(ContactOmniSearchController, [{
	    key: 'reset',
	    value: function reset() {
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'contactName',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.searchContacts();
	    }
	  }, {
	    key: 'searchContacts',
	    value: function searchContacts(evt, searchTerm) {
	      if (searchTerm) {
	        this.reset();
	        this.filterParams.searchTerm = searchTerm;
	      }
	
	      this.contacts = null;
	
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('contactList', 'Searching Contacts ...');
	
	      this.searchService.searchContacts(this.filterParams).then(function (response) {
	        ctrl.contacts = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' enquiries'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('contactList');
	        ctrl.onUpdate({ panelName: 'contacts', numResults: ctrl.pagination.totalItems });
	      });
	    }
	  }]);
	  return ContactOmniSearchController;
	}();
	
	exports.default = ContactOmniSearchController;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1818);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactOmniSearch.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./contactOmniSearch.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactOmniSearch{color:red}", ""]);
	
	// exports


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebEnquiryService = function () {
	  WebEnquiryService.$inject = ["$http", "appConfig"];
	  function WebEnquiryService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, WebEnquiryService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(WebEnquiryService, [{
	    key: "createEnquiry",
	    value: function createEnquiry(webEnquiryId, assignedTo) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/webenquiries/createenquiry/" + webEnquiryId + "/" + assignedTo));
	    }
	  }, {
	    key: "getCodeweaversData",
	    value: function getCodeweaversData(webEnquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/webenquiries/getcodeweaversdata/" + webEnquiryId));
	    }
	  }, {
	    key: "deleteEnquiry",
	    value: function deleteEnquiry(webEnquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/webenquiries/deleteenquiry/" + webEnquiryId));
	    }
	  }, {
	    key: "listWebEnquiries",
	    value: function listWebEnquiries(criteria) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/webenquiries/listwebenquiries', criteria);
	    }
	  }, {
	    key: "reprocess",
	    value: function reprocess(webEnquiryId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/webenquiries/reprocess/" + webEnquiryId));
	    }
	  }]);
	  return WebEnquiryService;
	}();
	
	exports.default = WebEnquiryService;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _kpiAnalytics = __webpack_require__(1821);
	
	var _kpiAnalytics2 = _interopRequireDefault(_kpiAnalytics);
	
	var _targetsOverview = __webpack_require__(1826);
	
	var _targetsOverview2 = _interopRequireDefault(_targetsOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kpiAnalyticsModule = _angular2.default.module('kpiAnalytics', [_angularUiRouter2.default, _targetsOverview2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('kpiAnalytics', {
	    url: '/kpiAnalytics',
	    component: 'kpiAnalytics'
	  });
	}]).component('kpiAnalytics', _kpiAnalytics2.default).name;
	
	exports.default = kpiAnalyticsModule;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _kpiAnalytics = __webpack_require__(1822);
	
	var _kpiAnalytics2 = _interopRequireDefault(_kpiAnalytics);
	
	var _kpiAnalytics3 = __webpack_require__(1823);
	
	var _kpiAnalytics4 = _interopRequireDefault(_kpiAnalytics3);
	
	__webpack_require__(1824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var kpiAnalyticsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _kpiAnalytics2.default,
	  controller: _kpiAnalytics4.default
	};
	
	exports.default = kpiAnalyticsComponent;

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports = "<targets-overview></targets-overview>\r\n\r\n\r\n"

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KpiAnalyticsController = function KpiAnalyticsController() {
	  (0, _classCallCheck3.default)(this, KpiAnalyticsController);
	};
	
	exports.default = KpiAnalyticsController;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1825);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./kpiAnalytics.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./kpiAnalytics.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".kpiAnalytics{color:red}", ""]);
	
	// exports


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _targetsOverview = __webpack_require__(1827);
	
	var _targetsOverview2 = _interopRequireDefault(_targetsOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetsOverviewModule = _angular2.default.module('targetsOverview', [_angularUiRouter2.default]).component('targetsOverview', _targetsOverview2.default).name;
	
	exports.default = targetsOverviewModule;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _targetsOverview = __webpack_require__(1828);
	
	var _targetsOverview2 = _interopRequireDefault(_targetsOverview);
	
	var _targetsOverview3 = __webpack_require__(1829);
	
	var _targetsOverview4 = _interopRequireDefault(_targetsOverview3);
	
	__webpack_require__(1830);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetsOverviewComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _targetsOverview2.default,
	  controller: _targetsOverview4.default
	};
	
	exports.default = targetsOverviewComponent;

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12\">\r\n  <uib-accordion close-others=\"false\">\r\n      <!-- Report Criteria -->\r\n      <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n        <uib-accordion-heading>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-11\">\r\n              Report Criteria\r\n            </div>\r\n            <div class=\"col-md-1\">\r\n              <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n            </div>\r\n          </div>\r\n        </uib-accordion-heading>\r\n\r\n        <div block-ui=\"reportCriteria\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"panel\">\r\n        \r\n                <!-- alerts -->\r\n                <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                  <div>\r\n                    Please correct the following errors before proceeding <br> <br>\r\n                  </div>\r\n        \r\n                  <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                    &emsp; - {{msg}} <br>\r\n                  </div>\r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                  <div class=\"col-md-2\">\r\n                    Date Range\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <select\r\n                      class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                      ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                      ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                    </select>\r\n                  </div>\r\n                  <div class=\"col-md-2\">\r\n                      New / Used\r\n                    </div>\r\n                    <div class=\"col-md-3\">\r\n                      <select\r\n                        class=\"form-control\"\r\n                        ng-options=\"item.name for item in $ctrl.vehicleConditionList track by item.id\"\r\n                        ng-model=\"$ctrl.reportCriteria.vehicleCondition\">\r\n                      </select>\r\n                    </div>                  \r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                  <div class=\"col-md-2\">\r\n                    Start Date\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <input type=\"month\" class=\"form-control\" ng-model=\"$ctrl.reportCriteria.startDate\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\" />                    \r\n                  </div>\r\n                  <div class=\"col-md-2\">\r\n                    End Date\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                      <input type=\"month\" class=\"form-control\" ng-model=\"$ctrl.reportCriteria.endDate\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\" />\r\n                  </div>\r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                  <div class=\"col-md-2\">\r\n                    Location\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <select\r\n                      class=\"form-control\" ng-change=\"$ctrl.updateUserList()\"\r\n                      ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                      ng-model=\"$ctrl.reportCriteria.location\">\r\n                    </select>\r\n                  </div>\r\n                  <div class=\"col-md-2\">\r\n                    Sales Rep\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <select\r\n                      class=\"form-control\"\r\n                      ng-options=\"item.name for item in $ctrl.userList track by item.id\"\r\n                      ng-model=\"$ctrl.reportCriteria.user\">\r\n                    </select>\r\n                  </div>\r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                  <div class=\"col-md-2\">\r\n                    Make\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <select\r\n                      class=\"form-control\" ng-change=\"$ctrl.updateBrandModel()\"\r\n                      ng-disabled=\"$ctrl.reportCriteria.vehicleCondition.id !== $ctrl.enums.VEHICLE_CONDITION.New\"\r\n                      ng-options=\"item.name for item in $ctrl.brands track by item.brandId\"\r\n                      ng-model=\"$ctrl.reportCriteria.brand\">\r\n                    </select>\r\n                  </div>\r\n                  <div class=\"col-md-2\">\r\n                    Model\r\n                  </div>\r\n                  <div class=\"col-md-3\">\r\n                    <select\r\n                      class=\"form-control\"\r\n                      ng-disabled=\"$ctrl.reportCriteria.vehicleCondition.id !== $ctrl.enums.VEHICLE_CONDITION.New\"\r\n                      ng-options=\"item.name for item in $ctrl.brandModels track by item.brandModelId\"\r\n                      ng-model=\"$ctrl.reportCriteria.brandModel\">\r\n                    </select>\r\n                  </div>\r\n                </div>         \r\n        \r\n                <div class=\"row\">\r\n                  <div class=\"col-md-6\">\r\n                    <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.viewAnalytics()\">\r\n                      <i class=\"fa fa-line-chart\"></i>\r\n                      View Analytics\r\n                    </a>\r\n        \r\n                    <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                      <i class=\"fa fa-eraser\"></i>\r\n                      Clear Filters\r\n                    </a>\r\n                  </div>\r\n                  <div class=\"col-md-6\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>              \r\n      </div>\r\n      <!-- Report Criteria End -->\r\n                  \r\n      <!-- Report Data -->\r\n      <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n        <uib-accordion-heading>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-11\">\r\n              Analytics\r\n            </div>\r\n            <div class=\"col-md-1\">\r\n              <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n            </div>\r\n          </div>\r\n        </uib-accordion-heading>\r\n        \r\n        <table>\r\n          <tr>\r\n            <td class=\"col-md-4\">\r\n                <gauge-chart title=\"Enquiries Created\" event-id=\"enquiriesCreated\"></gauge-chart>\r\n            </td>\r\n            <td class=\"col-md-4\">\r\n                <gauge-chart title=\"Enquiries Delivered\" event-id=\"enquiriesDelivered\"></gauge-chart>            \r\n            </td>\r\n          </tr>          \r\n        </table>\r\n      </div>\r\n      <!-- Report Data -->\r\n  </uib-accordion>      \r\n</div>  \r\n\r\n\r\n"

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	var _app = __webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TargetsOverviewController = function () {
	  TargetsOverviewController.$inject = ["authService", "enums", "lookupService", "userService", "$scope", "loadingService", "reportingService", "performanceManagementService", "utilsService"];
	  function TargetsOverviewController(authService, enums, lookupService, userService, $scope, loadingService, reportingService, performanceManagementService, utilsService) {
	    "ngInject";
	
	    //Services Begin
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, TargetsOverviewController);
	    this.authService = authService;
	    this.enums = enums;
	    this.lookupService = lookupService;
	    this.userService = userService;
	    this.$scope = $scope;
	    this.loadingService = loadingService;
	    this.reportingService = reportingService;
	    this.performanceManagementService = performanceManagementService;
	    this.utilsService = utilsService;
	    //Servies End
	
	    //Begin Data
	    this.dateRangeList = [];
	    this.brands = [];
	    this.allBrandModels = [];
	    this.userLocations = [];
	    this.userList = [];
	
	    this.reportCriteria = {};
	
	    this.dtPopups = {};
	
	    this.panels = {
	      reportCriteria: true,
	      reportData: false
	    };
	    //End Data
	
	    this.initializeLookups().then(function () {
	      _this.getDateRangeList();
	      _this.getUserLocations();
	      _this.getVehicleConditionList();
	
	      _this.reset();
	    });
	  }
	
	  (0, _createClass3.default)(TargetsOverviewController, [{
	    key: 'initializeLookups',
	    value: function initializeLookups() {
	      var _this2 = this;
	
	      var ctrl = this;
	      var promise = this.lookupService.lookupBrands();
	
	      promise.then(function (brands) {
	        _this2.brands = brands;
	
	        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
	          _this2.allBrandModels = brandModels;
	        });
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'updateBrandModel',
	    value: function updateBrandModel() {
	      var _this3 = this;
	
	      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
	        return o.brandId === _this3.reportCriteria.brand.brandId;
	      });
	      this.brandModels.unshift({ id: null, name: 'All' });
	      this.reportCriteria.brandModel = this.brandModels[0];
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Month'], name: 'This Month' });
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Quarter'], name: 'This Quarter' });
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Last Month'], name: 'Last Month' });
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Last Quarter'], name: 'Last Quarter' });
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Year'], name: 'This Year' });
	      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Custom'], name: 'Custom' });
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      this.userLocations = this.authService.authData.userLocations.map(function (l) {
	        return { id: l.key, name: l.value };
	      });
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'getVehicleConditionList',
	    value: function getVehicleConditionList() {
	      this.vehicleConditionList = (0, _app.convertEnumToKeyValueList)(this.enums.VEHICLE_CONDITION);
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.$scope.$broadcast('kpiAnalytics:reset');
	
	      this.errMsgs = [];
	
	      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
	      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.brand = this.brands[0];
	
	      this.updateUserList();
	      this.updateBrandModel();
	    }
	  }, {
	    key: 'updateDateRange',
	    value: function updateDateRange() {
	      var _this4 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id).then(function (response) {
	        response.data.startDate = _this4.utilsService.getReportStartDate(_this4.reportCriteria.dateRangeOption.id, response.data.startDate);
	        response.data.endDate = _this4.utilsService.getReportEndDate(_this4.reportCriteria.dateRangeOption.id, response.data.endDate);
	
	        _this4.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
	        _this4.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
	      }).finally(function () {
	        _this4.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'updateUserList',
	    value: function updateUserList() {
	      var _this5 = this;
	
	      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
	
	      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
	        _this5.userList = response.data.map(function (i) {
	          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
	        });
	        _this5.userList.unshift({ id: null, name: 'All' });
	
	        _this5.reportCriteria.user = _this5.userList[0];
	      }).finally(function () {
	        _this5.loadingService.hideLoading('reportCriteria');
	      });
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'viewAnalytics',
	    value: function viewAnalytics() {
	      var _this6 = this;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      this.loadingService.showLoading('reportData', 'Running Report ...');
	
	      this.performanceManagementService.getTargetsOverview(this.parseCriteria()).then(function (response) {
	        _this6.$scope.$broadcast('kpiAnalytics:targetsOverviewUpdated.enquiriesCreated', { target: response.data.enquiriesCreatedTarget, achieved: response.data.enquiriesCreated });
	        _this6.$scope.$broadcast('kpiAnalytics:targetsOverviewUpdated.enquiriesDelivered', { target: response.data.enquiriesDeliveredTarget, achieved: response.data.enquiriesDelivered });
	      }).finally(function () {
	        _this6.loadingService.hideLoading('reportData');
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
	      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
	      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.salesRepId = this.reportCriteria.user.id;
	      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
	      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
	
	      return parsedCriteria;
	    }
	  }]);
	  return TargetsOverviewController;
	}();
	
	exports.default = TargetsOverviewController;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1831);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./targetsOverview.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./targetsOverview.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".targetsOverview{color:red}", ""]);
	
	// exports


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _leadMonitor = __webpack_require__(1833);
	
	var _leadMonitor2 = _interopRequireDefault(_leadMonitor);
	
	var _enquiriesBreakdown = __webpack_require__(1838);
	
	var _enquiriesBreakdown2 = _interopRequireDefault(_enquiriesBreakdown);
	
	var _enquiriesExpenditure = __webpack_require__(1845);
	
	var _enquiriesExpenditure2 = _interopRequireDefault(_enquiriesExpenditure);
	
	var _leadMonitor3 = __webpack_require__(1851);
	
	var _leadMonitor4 = _interopRequireDefault(_leadMonitor3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leadMonitorModule = _angular2.default.module('leadMonitor', [_angularUiRouter2.default, _enquiriesBreakdown2.default, _enquiriesExpenditure2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('leadMonitor', {
	    url: '/leadMonitor',
	    component: 'leadMonitor',
	    params: {
	      dataSource: null,
	      dateRange: null
	    }
	  });
	}]).component('leadMonitor', _leadMonitor2.default).service('leadMonitorService', _leadMonitor4.default).name;
	
	exports.default = leadMonitorModule;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leadMonitor = __webpack_require__(1834);
	
	var _leadMonitor2 = _interopRequireDefault(_leadMonitor);
	
	var _leadMonitor3 = __webpack_require__(1835);
	
	var _leadMonitor4 = _interopRequireDefault(_leadMonitor3);
	
	__webpack_require__(1836);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leadMonitorComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _leadMonitor2.default,
	  controller: _leadMonitor4.default
	};
	
	exports.default = leadMonitorComponent;

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  \r\n  <div class=\"col-md-12\">\r\n      <uib-accordion close-others=\"false\">\r\n          <!-- Report Criteria -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportCriteria\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Report Criteria\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportCriteria, 'glyphicon-chevron-down': !$ctrl.panels.reportCriteria}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>\r\n      \r\n            <div block-ui=\"reportCriteria\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"panel\">\r\n            \r\n                    <!-- alerts -->\r\n                    <div class=\"alert alert-danger\" ng-show=\"$ctrl.errMsgs.length\">\r\n                      <div>\r\n                        Please correct the following errors before proceeding <br> <br>\r\n                      </div>\r\n            \r\n                      <div ng-repeat=\"msg in $ctrl.errMsgs\">\r\n                        &emsp; - {{msg}} <br>\r\n                      </div>\r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Date Range\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <select\r\n                          class=\"form-control\" ng-change=\"$ctrl.updateDateRange()\"\r\n                          ng-options=\"item.name for item in $ctrl.dateRangeList track by item.id\"\r\n                          ng-model=\"$ctrl.reportCriteria.dateRangeOption\">\r\n                        </select>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                          Location\r\n                        </div>\r\n                        <div class=\"col-md-3\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.resetSelection()\"\r\n                            ng-options=\"item.name for item in $ctrl.userLocations track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.location\">\r\n                          </select>\r\n                        </div>                      \r\n                    </div>\r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Start Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('startDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.startDate\" is-open=\"$ctrl.dtPopups.startDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('startDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        End Date\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDatePopup('endDate')\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.reportCriteria.endDate\" is-open=\"$ctrl.dtPopups.endDate\" readonly=\"readOnly\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"/>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDatePopup('endDate')\" ng-disabled=\"$ctrl.reportCriteria.dateRangeOption.id !== $ctrl.enums.DATE_RANGE_TYPE.Custom\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                          </span>\r\n                        </p>\r\n                      </div>\r\n                    </div>  \r\n                    \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-2\">\r\n                        Data Source\r\n                      </div>\r\n                      <div class=\"col-md-3\">\r\n                        <p class=\"input-group\">\r\n                          <select\r\n                            class=\"form-control\" ng-change=\"$ctrl.updateDataSource()\"\r\n                            ng-options=\"item.name for item in $ctrl.dataSources track by item.id\"\r\n                            ng-model=\"$ctrl.reportCriteria.dataSource\">\r\n                          </select>\r\n                        </p>\r\n                      </div>\r\n                    </div>                      \r\n            \r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6\">\r\n                        <a class=\"btn btn-block1 btn-primary\" ng-click=\"$ctrl.viewAnalytics()\">\r\n                          <i class=\"fa fa-table\"></i>\r\n                          View Analytics\r\n                        </a>\r\n            \r\n                        <a class=\"btn btn-block1 btn-default\" ng-click=\"$ctrl.reset()\">\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                          Clear Filters\r\n                        </a>\r\n                      </div>\r\n                      <div class=\"col-md-6\">\r\n            \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n          <!-- Report Criteria End -->         \r\n                      \r\n          <!-- Report Data -->\r\n          <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.panels.reportData\">\r\n            <uib-accordion-heading>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-11\">\r\n                  Analytics\r\n                </div>\r\n                <div class=\"col-md-1\">\r\n                  <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-up': $ctrl.panels.reportData, 'glyphicon-chevron-down': !$ctrl.panels.reportData}\"></i>\r\n                </div>\r\n              </div>\r\n            </uib-accordion-heading>       \r\n\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Enquiries by Source'\" \r\n                  data=\"$ctrl.enquiriesBySource\"\r\n                  event=\"sourceSelected\"\r\n                  identifiers=\"['sourceType', 'providerType', 'customSource', 'id']\">\r\n                </enquiries-breakdown>                \r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"$ctrl.reportCriteria.dataSource.id === 1 ? 'Enquiries by Reason' : 'Enquiries by Origination'\" \r\n                  chart-title=\"$ctrl.reportCriteria.dataSource.id === 1 ? 'Enquiries by Reason' : 'Enquiries by Origination'\" \r\n                  data=\"$ctrl.enquiriesByReason\"\r\n                  event=\"reasonSelected\"\r\n                  identifiers=\"['identifier', 'id']\">\r\n                </enquiries-breakdown>\r\n              </div>                            \r\n            </div>         \r\n\r\n            <div class=\"row\">         \r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Enquiries by Brand'\" \r\n                  chart-title=\"'Enquiries by Brand'\" \r\n                  data=\"$ctrl.enquiriesByBrand\"\r\n                  event=\"brandSelected\"\r\n                  identifiers=\"['identifier', 'id']\">\r\n                </enquiries-breakdown>                \r\n              </div>              \r\n              <div class=\"col-md-6\">\r\n                <enquiries-breakdown \r\n                  title=\"'Enquiries by Model'\" \r\n                  chart-title=\"'Enquiries by Model'\" \r\n                  data=\"$ctrl.enquiriesByModel\">\r\n                </enquiries-breakdown>                \r\n              </div>                                          \r\n            </div>  \r\n            \r\n            <div class=\"row\" ng-hide=\"false\">\r\n              <div class=\"col-md-12\">\r\n                <enquiries-expenditure\r\n                  title=\"No of Enquiries vs Expenditure\"\r\n                  data=\"$ctrl.enquiriesExpenditure\">\r\n                </enquiries-expenditure>                                \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Report Data -->\r\n      </uib-accordion>      \r\n  </div>  \r\n</div>"

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(910);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(913);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(935);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _baseReportController = __webpack_require__(943);
	
	var _baseReportController2 = _interopRequireDefault(_baseReportController);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeadMonitorController = function (_BaseReportController) {
	  LeadMonitorController.$inject = ["authService", "reportingService", "userService", "enums", "loadingService", "$scope", "utilsService", "leadMonitorService", "$stateParams", "$q"];
	  (0, _inherits3.default)(LeadMonitorController, _BaseReportController);
	
	  function LeadMonitorController(authService, reportingService, userService, enums, loadingService, $scope, utilsService, leadMonitorService, $stateParams, $q) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, LeadMonitorController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LeadMonitorController.__proto__ || (0, _getPrototypeOf2.default)(LeadMonitorController)).call(this, reportingService, loadingService, utilsService));
	
	    if (!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) {
	      return (0, _possibleConstructorReturn3.default)(_this);
	    }
	
	    _this.authService = authService;
	    _this.reportingService = reportingService;
	    _this.userService = userService;
	    _this.enums = enums;
	    _this.loadingService = loadingService;
	    _this.$scope = $scope;
	    _this.utilsService = utilsService;
	    _this.leadMonitorService = leadMonitorService;
	    _this.$stateParams = $stateParams;
	
	    _this.reportCriteria = {};
	    _this.dtPopups = {};
	    _this.errMsgs = [];
	
	    _this.panels = {
	      reportCriteria: true,
	      reportData: false
	    };
	
	    _this.enquiriesBySource = null;
	    _this.enquiriesByReason = null;
	    _this.enquiriesByBrand = null;
	    _this.enquiriesByModel = null;
	    _this.enquiriesExpenditure = null;
	
	    _this.selectedSource = null;
	    _this.selectedSourceName = null;
	    _this.selectedProvider = null;
	    _this.selectedCustomSource = null;
	    _this.selectedReason = null;
	    _this.selectedReasonName = null;
	    _this.selectedBrandId = null;
	    _this.selectedBrandName = null;
	
	    _this.reasonTitle = null;
	    _this.brandTitle = null;
	    _this.modelTitle = null;
	
	    _this.$scope.$on('leadMonitor:selectionChanged', _this.selectionChanged.bind(_this));
	
	    _this.dataSources = [{ id: 1, name: 'Leads' }, { id: 2, name: 'Enquiries' }];
	
	    _this.getUserLocations();
	    _this.getDateRangeList();
	    _this.reset().then(function (response) {
	      _this.viewAnalytics();
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(LeadMonitorController, [{
	    key: 'convertEnumToKeyValueList',
	    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
	      var objList = [];
	
	      if (defaultOption) {
	        objList.push({
	          id: null,
	          name: 'Please Select'
	        });
	      }
	
	      for (var prop in enumObj) {
	        objList.push({
	          id: enumObj[prop],
	          name: prop
	        });
	      }
	
	      return objList;
	    }
	  }, {
	    key: 'getDateRangeList',
	    value: function getDateRangeList() {
	      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
	    }
	  }, {
	    key: 'getUserLocations',
	    value: function getUserLocations() {
	      this.userLocations = this.authService.authData.userLocations.map(function (l) {
	        return { id: l.key, name: l.value };
	      });
	
	      this.userLocations.unshift({ id: null, name: 'All' });
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(fieldName) {
	      this.dtPopups[fieldName] = true;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var _this2 = this;
	
	      this.errMsgs = [];
	      var dataSource = (0, _lodash.find)(this.dataSources, function (o) {
	        return o.id === _this2.$stateParams.dataSource;
	      });
	      var dateRange = (0, _lodash.find)(this.dateRangeList, function (o) {
	        return o.id === _this2.$stateParams.dateRange;
	      });
	
	      this.reportCriteria.dateRangeOption = dateRange || this.dateRangeList[0];
	      this.reportCriteria.startDate = new Date();
	      this.reportCriteria.endDate = new Date();
	      this.reportCriteria.location = this.userLocations[0];
	      this.reportCriteria.dataSource = dataSource || this.dataSources[0];
	
	      this.resetSelection();
	
	      return this.updateDateRange();
	    }
	  }, {
	    key: 'resetSelection',
	    value: function resetSelection() {
	      this.reasonTitle = 'Enquiries by Reason';
	      this.brandTitle = 'Enquiries by Brand';
	      this.modelTitle = 'Enquiries by Model';
	
	      this.selectedSource = null;
	      this.selectedSourceName = null;
	      this.selectedProvider = null;
	      this.selectedCustomSource = null;
	      this.selectedReason = null;
	      this.selectedReasonName = null;
	      this.selectedBrandId = null;
	      this.selectedBrandName = null;
	    }
	  }, {
	    key: 'viewAnalytics',
	    value: function viewAnalytics() {
	      var _this3 = this;
	
	      this.panels.reportData = true;
	
	      if (!this.validateCriteria()) {
	        return;
	      }
	
	      var parsedCriteria = this.parseCriteria();
	
	      var src1 = void 0,
	          src2 = void 0,
	          src3 = void 0,
	          src4 = void 0,
	          src5 = void 0;
	
	      if (this.forWebEnquiry()) {
	        src1 = this.leadMonitorService.getWebEnquiriesBySource(parsedCriteria);
	        src2 = this.leadMonitorService.getWebEnquiriesByReason(parsedCriteria);
	        src3 = this.leadMonitorService.getWebEnquiriesByBrands(parsedCriteria);
	        src4 = this.leadMonitorService.getWebEnquiriesByModel(parsedCriteria);
	        src5 = this.leadMonitorService.getWebEnquiriesExpenditure(parsedCriteria);
	      } else {
	        src1 = this.leadMonitorService.getEnquiriesBySource(parsedCriteria);
	        src2 = this.leadMonitorService.getEnquiriesByOrigination(parsedCriteria);
	        src3 = this.leadMonitorService.getEnquiriesByBrand(parsedCriteria);
	        src4 = this.leadMonitorService.getEnquiriesByModel(parsedCriteria);
	        src5 = this.leadMonitorService.getEnquiriesExpenditure(parsedCriteria);
	      }
	
	      src1.then(function (response) {
	        _this3.enquiriesBySource = response.data;
	      });
	      src2.then(function (response) {
	        _this3.enquiriesByReason = response.data;
	      });
	      src3.then(function (response) {
	        _this3.enquiriesByBrand = response.data;
	      });
	      src4.then(function (response) {
	        _this3.enquiriesByModel = response.data;
	      });
	      src5.then(function (response) {
	        _this3.enquiriesExpenditure = response.data;
	      });
	    }
	  }, {
	    key: 'validateCriteria',
	    value: function validateCriteria() {
	      this.errMsgs = [];
	
	      if (!this.reportCriteria.startDate) {
	        this.errMsgs.push('Please provide a Start Date');
	      }
	
	      if (!this.reportCriteria.endDate) {
	        this.errMsgs.push('Please provide an End Date');
	      }
	
	      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
	        this.errMsgs.push('Start Date can not be greater than End Date');
	      }
	
	      return this.errMsgs.length === 0;
	    }
	  }, {
	    key: 'parseCriteria',
	    value: function parseCriteria() {
	      var parsedCriteria = {};
	
	      this.parseStartAndEndDate(parsedCriteria);
	
	      parsedCriteria.locationIds = this.getLocationIds();
	      parsedCriteria.additionalParameter1 = this.selectedSource;
	      parsedCriteria.additionalParameter2 = this.selectedProvider;
	      parsedCriteria.additionalParameter3 = this.selectedCustomSource;
	      parsedCriteria.additionalParameter4 = this.selectedReason;
	      parsedCriteria.brandId = this.selectedBrandId;
	      return parsedCriteria;
	    }
	  }, {
	    key: 'getLocationIds',
	    value: function getLocationIds() {
	      var locationIds = void 0;
	
	      if (!this.reportCriteria.location.id) {
	        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
	          return o.id;
	        }).map(function (ul) {
	          return ul.id;
	        });
	      } else {
	        locationIds = [this.reportCriteria.location.id];
	      }
	
	      return locationIds;
	    }
	  }, {
	    key: 'selectionChanged',
	    value: function selectionChanged(e, data) {
	      if (data.event === 'sourceSelected') {
	        if (this.forWebEnquiry()) {
	          this.selectedSource = this.addUpdateParameter(this.selectedSource, data.identifiers.sourceType);
	        } else {
	          this.selectedSource = this.addUpdateParameter(this.selectedSource, data.identifiers.id);
	        }
	
	        this.selectedProvider = this.addUpdateParameter(this.selectedProvider, data.identifiers.providerType);
	        this.selectedCustomSource = this.addUpdateParameter(this.selectedCustomSource, data.identifiers.customSource);
	        this.selectedReason = null;
	        this.selectedBrandId = null;
	
	        this.selectedSourceName = this.addUpdateParameter(this.selectedSourceName, data.name);
	
	        this.reasonTitle = this.titleBuilder('Enquiries by Reason', [{ category: 'Source', name: this.selectedSourceName }]);
	
	        this.updateReasons();
	      } else if (data.event === 'reasonSelected') {
	        if (this.forWebEnquiry()) {
	          this.selectedReason = this.addUpdateParameter(this.selectedReason, data.identifiers.identifier);
	        } else {
	          this.selectedReason = this.addUpdateParameter(this.selectedReason, data.identifiers.id);
	        }
	        this.selectedBrandId = null;
	
	        this.selectedReasonName = this.addUpdateParameter(this.selectedReasonName, data.name);
	
	        this.brandTitle = this.titleBuilder('Enquiries by Brand', [{ category: 'Source', name: this.selectedSourceName }, { category: 'Reason', name: this.selectedReasonName }]);
	
	        this.updateBrands();
	      } else if (data.event === 'brandSelected') {
	        if (this.forWebEnquiry()) {
	          this.selectedBrandId = this.addUpdateParameter(this.selectedBrandId, data.identifiers.identifier);
	        } else {
	          this.selectedBrandId = this.addUpdateParameter(this.selectedBrandId, data.identifiers.id);
	        }
	
	        this.selectedBrandName = this.addUpdateParameter(this.selectedBrandName, data.name);
	
	        this.modelTitle = this.titleBuilder('Enquiries by Model', [{ category: 'Source', name: this.selectedSourceName }, { category: 'Reason', name: this.selectedReasonName }, { category: 'Brand', name: this.selectedBrandName }]);
	
	        this.updateModels();
	      }
	    }
	  }, {
	    key: 'updateReasons',
	    value: function updateReasons() {
	      var _this4 = this;
	
	      var src = void 0;
	      if (this.forWebEnquiry()) {
	        src = this.leadMonitorService.getWebEnquiriesByReason(this.parseCriteria());
	      } else {
	        src = this.leadMonitorService.getEnquiriesByOrigination(this.parseCriteria());
	      }
	
	      src.then(function (response) {
	        _this4.enquiriesByReason = response.data;
	      });
	
	      this.updateBrands();
	    }
	  }, {
	    key: 'updateBrands',
	    value: function updateBrands() {
	      var _this5 = this;
	
	      var src = void 0;
	      if (this.forWebEnquiry()) {
	        src = this.leadMonitorService.getWebEnquiriesByBrands(this.parseCriteria());
	      } else {
	        src = this.leadMonitorService.getEnquiriesByBrand(this.parseCriteria());
	      }
	
	      src.then(function (response) {
	        _this5.enquiriesByBrand = response.data;
	      });
	
	      this.updateModels();
	    }
	  }, {
	    key: 'updateModels',
	    value: function updateModels() {
	      var _this6 = this;
	
	      var src = void 0;
	      if (this.forWebEnquiry()) {
	        src = this.leadMonitorService.getWebEnquiriesByModel(this.parseCriteria());
	      } else {
	        src = this.leadMonitorService.getEnquiriesByModel(this.parseCriteria());
	      }
	
	      src.then(function (response) {
	        _this6.enquiriesByModel = response.data;
	      });
	    }
	  }, {
	    key: 'addUpdateParameter',
	    value: function addUpdateParameter(currentValue, newValue) {
	      if (currentValue === newValue) {
	        return null;
	      }
	
	      return newValue;
	    }
	  }, {
	    key: 'titleBuilder',
	    value: function titleBuilder(base, params) {
	      var title = base;
	
	      params.map(function (p) {
	        if (p.name) {
	          title += ' ' + p.category + ' ' + p.name + ',';
	        }
	      });
	
	      return base;
	    }
	  }, {
	    key: 'forWebEnquiry',
	    value: function forWebEnquiry() {
	      return this.reportCriteria.dataSource.id === 1;
	    }
	  }]);
	  return LeadMonitorController;
	}(_baseReportController2.default);
	
	exports.default = LeadMonitorController;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1837);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./leadMonitor.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./leadMonitor.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".leadMonitor{color:red}", ""]);
	
	// exports


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiriesBreakdown = __webpack_require__(1839);
	
	var _enquiriesBreakdown2 = _interopRequireDefault(_enquiriesBreakdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesBreakdownModule = _angular2.default.module('enquiriesBreakdown', [_angularUiRouter2.default]).component('enquiriesBreakdown', _enquiriesBreakdown2.default).name;
	
	exports.default = enquiriesBreakdownModule;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiriesBreakdown = __webpack_require__(1840);
	
	var _enquiriesBreakdown2 = _interopRequireDefault(_enquiriesBreakdown);
	
	var _enquiriesBreakdown3 = __webpack_require__(1841);
	
	var _enquiriesBreakdown4 = _interopRequireDefault(_enquiriesBreakdown3);
	
	__webpack_require__(1843);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesBreakdownComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '<',
	    chartTitle: '<',
	    data: '<',
	    event: '@',
	    identifiers: '<'
	  },
	  template: _enquiriesBreakdown2.default,
	  controller: _enquiriesBreakdown4.default
	};
	
	exports.default = enquiriesBreakdownComponent;

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-hide=\"$ctrl.data.length\"><p>No data to display</p></div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" ng-show=\"$ctrl.data.length\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(1842);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiriesBreakdownController = function () {
	  EnquiriesBreakdownController.$inject = ["$scope"];
	  function EnquiriesBreakdownController($scope) {
	    "ngInject";
	
	    //Begin Services
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EnquiriesBreakdownController);
	    this.$scope = $scope;
	    //End Services
	
	    //Begin Data
	    this.hasNoTarget = false;
	    this.chartContainerId = "chartContainer" + this.getGuid();
	    this.chart = null;
	    //End Data
	
	    //Begin Initialize
	    this.$onChanges = function (changesObj) {
	      if (changesObj.data && changesObj.data.currentValue) {
	        _this.chart = _this.generateChart();
	      }
	    };
	    //End Initialize 
	  }
	
	  (0, _createClass3.default)(EnquiriesBreakdownController, [{
	    key: "generateChart",
	    value: function generateChart() {
	      var _chartOptions;
	
	      //Chart Code Start    
	      var ctrl = this;
	
	      var series = this.data.map(function (item) {
	        var identifiers = {};
	
	        if (ctrl.identifiers) {
	          ctrl.identifiers.map(function (id) {
	            identifiers[id] = item[id];
	          });
	        }
	
	        return {
	          name: item.name,
	          y: item.count,
	          identifiers: identifiers
	        };
	      });
	
	      var chartOptions = (_chartOptions = {
	        chart: {
	          plotBackgroundColor: null,
	          plotBorderWidth: null,
	          plotShadow: false,
	          type: 'pie',
	          height: '300'
	        },
	        title: null,
	        tooltip: {
	          pointFormat: '<b>{point.percentage:.1f}%</b>'
	        },
	        accessibility: {
	          point: {
	            valueSuffix: '%'
	          }
	        },
	        plotOptions: {
	          pie: {
	            allowPointSelect: ctrl.event !== undefined,
	            cursor: 'pointer',
	            dataLabels: {
	              enabled: false
	            },
	            showInLegend: true,
	            point: {
	              events: {
	                legendItemClick: function legendItemClick(e) {
	                  this.select();
	                  this.events.click(this.identifiers);
	                  e.preventDefault();
	                }
	              }
	            }
	          }
	        },
	        legend: {
	          align: 'right',
	          verticalAlign: 'top',
	          layout: 'vertical',
	          x: 0,
	          y: 10,
	          labelFormat: '{name} ({y})'
	        },
	        credits: {
	          enabled: false
	        }
	      }, (0, _defineProperty3.default)(_chartOptions, "title", {
	        align: 'center',
	        //text: ctrl.chartTitle,
	        text: null,
	        verticalAlign: 'bottom',
	        y: 10
	      }), (0, _defineProperty3.default)(_chartOptions, "series", [{
	        name: 'Brands',
	        colorByPoint: true,
	        data: series,
	        point: {
	          events: {
	            click: function click(identifiers) {
	              if (ctrl.event) {
	                ctrl.$scope.$emit('leadMonitor:selectionChanged', {
	                  event: ctrl.event,
	                  name: this.name,
	                  identifiers: this.identifiers || identifiers
	                });
	              }
	            }
	          }
	        }
	      }]), _chartOptions);
	
	      // The speed gauge
	      return _highcharts2.default.chart(this.chartContainerId, chartOptions);
	
	      //Chart Code End
	    }
	  }, {
	    key: "getGuid",
	    value: function getGuid() {
	      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0,
	            v = c == 'x' ? r : r & 0x3 | 0x8;
	        return v.toString(16);
	      });
	    }
	  }]);
	  return EnquiriesBreakdownController;
	}();
	
	exports.default = EnquiriesBreakdownController;

/***/ }),
/* 1842 */,
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1844);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesBreakdown.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesBreakdown.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiriesBreakdown{color:red}", ""]);
	
	// exports


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _enquiriesExpenditure = __webpack_require__(1846);
	
	var _enquiriesExpenditure2 = _interopRequireDefault(_enquiriesExpenditure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesExpenditureModule = _angular2.default.module('enquiriesExpenditure', [_angularUiRouter2.default]).component('enquiriesExpenditure', _enquiriesExpenditure2.default).name;
	
	exports.default = enquiriesExpenditureModule;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enquiriesExpenditure = __webpack_require__(1847);
	
	var _enquiriesExpenditure2 = _interopRequireDefault(_enquiriesExpenditure);
	
	var _enquiriesExpenditure3 = __webpack_require__(1848);
	
	var _enquiriesExpenditure4 = _interopRequireDefault(_enquiriesExpenditure3);
	
	__webpack_require__(1849);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enquiriesExpenditureComponent = {
	  restrict: 'E',
	  bindings: {
	    title: '@',
	    data: '<'
	  },
	  template: _enquiriesExpenditure2.default,
	  controller: _enquiriesExpenditure4.default
	};
	
	exports.default = enquiriesExpenditureComponent;

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-hide=\"$ctrl.data.length\">No data to display</div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" ng-show=\"$ctrl.data.length\"></div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _highcharts = __webpack_require__(672);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnquiriesExpenditureController = function () {
	    EnquiriesExpenditureController.$inject = ["$scope"];
	    function EnquiriesExpenditureController($scope) {
	        "ngInject";
	
	        //Begin Services
	
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, EnquiriesExpenditureController);
	        this.$scope = $scope;
	        //End Services
	
	        //Begin Data
	        this.hasNoTarget = false;
	        this.chartContainerId = "chartContainer" + this.getGuid();
	        this.chart = null;
	        //End Data
	
	        //Begin Initialize
	        this.$onChanges = function (changesObj) {
	            if (changesObj.data && changesObj.data.currentValue) {
	                _this.chart = _this.generateChart();
	            }
	        };
	        //End Initialize 
	    }
	
	    (0, _createClass3.default)(EnquiriesExpenditureController, [{
	        key: "generateChart",
	        value: function generateChart() {
	            //debugger;
	            //Chart Code Start    
	            var ctrl = this;
	
	            var labels = [];
	            var expenditureSeries = [];
	            var countSeries = [];
	
	            this.data.map(function (item) {
	                labels.push(item.location + "<br>" + item.source);
	                expenditureSeries.push(item.expenditure);
	                countSeries.push(item.count);
	            });
	
	            var chartOptions = {
	                chart: {
	                    type: 'column',
	                    height: '300'
	                },
	                title: {
	                    text: null
	                },
	                xAxis: {
	                    categories: labels,
	                    crosshair: true
	                },
	                yAxis: {
	                    min: 0,
	                    title: {
	                        text: null
	                    }
	                },
	                credits: {
	                    enabled: false
	                },
	                tooltip: {
	                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
	                    footerFormat: '</table>',
	                    shared: true,
	                    useHTML: true
	                },
	                plotOptions: {
	                    column: {
	                        pointPadding: 0.2,
	                        borderWidth: 0
	                    }
	                },
	                series: [{
	                    name: 'Spend (€)',
	                    data: expenditureSeries
	                }, {
	                    name: 'Count',
	                    data: countSeries
	                }]
	            };
	
	            return _highcharts2.default.chart(this.chartContainerId, chartOptions);
	
	            //Chart Code End
	        }
	    }, {
	        key: "getGuid",
	        value: function getGuid() {
	            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }]);
	    return EnquiriesExpenditureController;
	}();
	
	exports.default = EnquiriesExpenditureController;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1850);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesExpenditure.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./enquiriesExpenditure.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".enquiriesExpenditure{color:red}", ""]);
	
	// exports


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeadMonitorService = function () {
	    LeadMonitorService.$inject = ["$http", "appConfig"];
	    function LeadMonitorService($http, appConfig) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, LeadMonitorService);
	        this.$http = $http;
	        this.appConfig = appConfig;
	    }
	
	    (0, _createClass3.default)(LeadMonitorService, [{
	        key: "getEnquiriesBySource",
	        value: function getEnquiriesBySource(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesBySource", criteria);
	        }
	    }, {
	        key: "getEnquiriesByOrigination",
	        value: function getEnquiriesByOrigination(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByOrigination", criteria);
	        }
	    }, {
	        key: "getEnquiriesByBrand",
	        value: function getEnquiriesByBrand(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByBrand", criteria);
	        }
	    }, {
	        key: "getEnquiriesByModel",
	        value: function getEnquiriesByModel(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByModel", criteria);
	        }
	    }, {
	        key: "getEnquiriesExpenditure",
	        value: function getEnquiriesExpenditure(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesExpenditure", criteria);
	        }
	    }, {
	        key: "getWebEnquiriesBySource",
	        value: function getWebEnquiriesBySource(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesBySource", criteria);
	        }
	    }, {
	        key: "getWebEnquiriesByReason",
	        value: function getWebEnquiriesByReason(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByReason", criteria);
	        }
	    }, {
	        key: "getWebEnquiriesByBrands",
	        value: function getWebEnquiriesByBrands(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByBrands", criteria);
	        }
	    }, {
	        key: "getWebEnquiriesByModel",
	        value: function getWebEnquiriesByModel(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByModel", criteria);
	        }
	    }, {
	        key: "getWebEnquiriesExpenditure",
	        value: function getWebEnquiriesExpenditure(criteria) {
	            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesExpenditure", criteria);
	        }
	    }]);
	    return LeadMonitorService;
	}();
	
	exports.default = LeadMonitorService;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _privacyPolicy = __webpack_require__(1853);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyPolicyModule = _angular2.default.module('privacyPolicy', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('privacyPolicy', {
	    url: '/privacyPolicy',
	    component: 'privacyPolicy'
	  });
	}]).component('privacyPolicy', _privacyPolicy2.default).name;
	
	exports.default = privacyPolicyModule;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _privacyPolicy = __webpack_require__(1854);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	var _privacyPolicy3 = __webpack_require__(1855);
	
	var _privacyPolicy4 = _interopRequireDefault(_privacyPolicy3);
	
	__webpack_require__(1856);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyPolicyComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _privacyPolicy2.default,
	  controller: _privacyPolicy4.default
	};
	
	exports.default = privacyPolicyComponent;

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	module.exports = "<style>\r\n  [data-custom-class='body'], [data-custom-class='body'] * {\r\n          background: transparent !important;\r\n        }\r\n[data-custom-class='title'], [data-custom-class='title'] * {\r\n          font-family: Arial !important;\r\nfont-size: 26px !important;\r\ncolor: #000000 !important;\r\n        }\r\n[data-custom-class='subtitle'], [data-custom-class='subtitle'] * {\r\n          font-family: Arial !important;\r\ncolor: #595959 !important;\r\nfont-size: 14px !important;\r\n        }\r\n[data-custom-class='heading_1'], [data-custom-class='heading_1'] * {\r\n          font-family: Arial !important;\r\nfont-size: 19px !important;\r\ncolor: #000000 !important;\r\n        }\r\n[data-custom-class='heading_2'], [data-custom-class='heading_2'] * {\r\n          font-family: Arial !important;\r\nfont-size: 17px !important;\r\ncolor: #000000 !important;\r\n        }\r\n[data-custom-class='body_text'], [data-custom-class='body_text'] * {\r\n          color: #595959 !important;\r\nfont-size: 14px !important;\r\nfont-family: Arial !important;\r\n        }\r\n[data-custom-class='link'], [data-custom-class='link'] * {\r\n          color: #3030F1 !important;\r\nfont-size: 14px !important;\r\nfont-family: Arial !important;\r\nword-break: break-word !important;\r\n        }\r\n</style>\r\n      <span style=\"display: block;margin: 0 auto 3.125rem;width: 11.125rem;height: 2.375rem;background: url(data:image/svg+xml;base64,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) center no-repeat;\"></span>\r\n\r\n      <div data-custom-class=\"body\">\r\n      <div><strong><span style=\"font-size: 26px;\"><span data-custom-class=\"title\"><bdt class=\"block-component\"></bdt><bdt class=\"question\">PRIVACY POLICY</bdt><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></strong></div><div><br></div><div><span style=\"color: rgb(127, 127, 127);\"><strong><span style=\"font-size: 15px;\"><span data-custom-class=\"subtitle\">Last updated <bdt class=\"question\">July 22, 2024</bdt></span></span></strong></span></div><div><br></div><div><br></div><div><br></div><div style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\">This privacy notice for <bdt class=\"question\">CarsNow Ltd<bdt class=\"block-component\"></bdt></bdt> (<bdt class=\"block-component\"></bdt>'<strong>we</strong>', '<strong>us</strong>', or '<strong>our</strong>'<bdt class=\"else-block\"></bdt></span><span data-custom-class=\"body_text\">), describes how and why we might collect, store, use, and/or share (<bdt class=\"block-component\"></bdt>'<strong>process</strong>'<bdt class=\"else-block\"></bdt>) your information when you use our services (<bdt class=\"block-component\"></bdt>'<strong>Services</strong>'<bdt class=\"else-block\"></bdt>), such as when you:</span></span></span><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></li></ul><div><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">Download and use<bdt class=\"block-component\"></bdt> our mobile application<bdt class=\"block-component\"></bdt> (<bdt class=\"question\">CarsNow)<span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\">,</bdt></span></span></span></span></span></span></span></span></bdt></span><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"><bdt class=\"block-component\"> or any other application of ours that links to this privacy notice</bdt></bdt></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">Engage with us in other related ways, including any sales, marketing, or events<span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span data-custom-class=\"body_text\"><strong>Questions or concerns? </strong>Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services.<bdt class=\"block-component\"></bdt> If you still have any questions or concerns, please contact us at <bdt class=\"question\">info@carsnow.ie</bdt>.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><strong><span style=\"font-size: 15px;\"><span data-custom-class=\"heading_1\">SUMMARY OF KEY POINTS</span></span></strong></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong><em>This summary provides key points from our privacy notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our </em></strong></span></span><a data-custom-class=\"link\" href=\"#toc\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\"><strong><em>table of contents</em></strong></span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong><em> below to find the section you are looking for.</em></strong></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more about </span></span><a data-custom-class=\"link\" href=\"#personalinfo\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">personal information you disclose to us</span></span></a><span data-custom-class=\"body_text\">.</span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>Do we process any sensitive personal information?</strong> <bdt class=\"block-component\"></bdt>We do not process sensitive personal information.<bdt class=\"else-block\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>Do we collect any information from third parties?</strong> <bdt class=\"block-component\"></bdt>We do not collect any information from third parties.<bdt class=\"else-block\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Learn more about </span></span><a data-custom-class=\"link\" href=\"#infouse\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">how we process your information</span></span></a><span data-custom-class=\"body_text\">.</span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>In what situations and with which <bdt class=\"block-component\"></bdt>parties do we share personal information?</strong> We may share information in specific situations and with specific <bdt class=\"block-component\"></bdt>third parties. Learn more about </span></span><a data-custom-class=\"link\" href=\"#whoshare\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">when and with whom we share your personal information</span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">.<bdt class=\"block-component\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>How do we keep your information safe?</strong> We have <bdt class=\"block-component\"></bdt>organisational<bdt class=\"else-block\"></bdt> and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other <bdt class=\"block-component\"></bdt>unauthorised<bdt class=\"else-block\"></bdt> third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Learn more about </span></span><a data-custom-class=\"link\" href=\"#infosafe\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">how we keep your information safe</span></span></a><span data-custom-class=\"body_text\">.</span><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Learn more about </span></span><a data-custom-class=\"link\" href=\"#privacyrights\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">your privacy rights</span></span></a><span data-custom-class=\"body_text\">.</span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by <bdt class=\"block-component\">submitting a </bdt></span></span><a data-custom-class=\"link\" href=\"https://app.termly.io/notify/76504042-9630-496c-abf6-3da86635d6c9\" rel=\"noopener noreferrer\" target=\"_blank\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">data subject access request</span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt>, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.</span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">Want to learn more about what we do with any information we collect? </span></span><a data-custom-class=\"link\" href=\"#toc\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">Review the privacy notice in full</span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">.</span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><br></div><div id=\"toc\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">TABLE OF CONTENTS</span></strong></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#infocollect\"><span style=\"color: rgb(0, 58, 250);\">1. WHAT INFORMATION DO WE COLLECT?</span></a></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#infouse\"><span style=\"color: rgb(0, 58, 250);\">2. HOW DO WE PROCESS YOUR INFORMATION?<bdt class=\"block-component\"></bdt></span></a></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#legalbases\"><span style=\"color: rgb(0, 58, 250);\">3. <span style=\"font-size: 15px;\"><span style=\"color: rgb(0, 58, 250);\">WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?</span></span><bdt class=\"statement-end-if-in-editor\"></bdt></span></a></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(0, 58, 250);\"><a data-custom-class=\"link\" href=\"#whoshare\">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</a></span><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></a><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span></span></span><bdt class=\"block-component\"></bdt></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span><bdt class=\"block-component\"></bdt></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#inforetain\"><span style=\"color: rgb(0, 58, 250);\">5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></a><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#infosafe\"><span style=\"color: rgb(0, 58, 250);\">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span></a><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"></bdt><bdt class=\"block-component\"></bdt></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#infominors\"><span style=\"color: rgb(0, 58, 250);\">7. DO WE COLLECT INFORMATION FROM MINORS?</span></a><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(0, 58, 250);\"><a data-custom-class=\"link\" href=\"#privacyrights\">8. WHAT ARE YOUR PRIVACY RIGHTS?</a></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#DNT\"><span style=\"color: rgb(0, 58, 250);\">9. CONTROLS FOR DO-NOT-TRACK FEATURES<bdt class=\"block-component\"></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></bdt></span></div><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></span></bdt></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><a data-custom-class=\"link\" href=\"#policyupdates\"><span style=\"color: rgb(0, 58, 250);\">10. DO WE MAKE UPDATES TO THIS NOTICE?</span></a></span></div><div style=\"line-height: 1.5;\"><a data-custom-class=\"link\" href=\"#contact\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\">11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></a></div><div style=\"line-height: 1.5;\"><a data-custom-class=\"link\" href=\"#request\"><span style=\"color: rgb(0, 58, 250);\">12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span></a></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><br></div><div id=\"infocollect\" style=\"line-height: 1.5;\"><span style=\"color: rgb(0, 0, 0);\"><span style=\"color: rgb(0, 0, 0); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(0, 0, 0);\"><span style=\"font-size: 15px; color: rgb(0, 0, 0);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">1. WHAT INFORMATION DO WE COLLECT?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"personalinfo\" style=\"line-height: 1.5;\"><span data-custom-class=\"heading_2\" style=\"color: rgb(0, 0, 0);\"><span style=\"font-size: 15px;\"><strong>Personal information you disclose to us</strong></span></span></div><div><div><br></div><div style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short:</em></strong></span></span></span></span><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em> </em></strong><em>We collect personal information that you provide to us.</em></span></span></span></span></span></span></div></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We collect personal information that you voluntarily provide to us when you <span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span></span><span data-custom-class=\"body_text\">express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong>Personal Information Provided by You.</strong> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:<span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"forloop-component\"></bdt></span></span></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">names</bdt></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"forloop-component\"></bdt></span></span></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">phone numbers</bdt></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"forloop-component\"></bdt></span></span></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">email addresses</bdt></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"forloop-component\"></bdt></span></span></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">job titles</bdt></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"forloop-component\"></bdt></span><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></div><div id=\"sensitiveinfo\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>Sensitive Information.</strong> <bdt class=\"block-component\"></bdt>We do not process sensitive information.</span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"else-block\"></bdt></span></span><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"><bdt class=\"block-component\"></bdt></bdt></span></span></span></span><bdt class=\"block-component\"><bdt class=\"block-component\"></bdt></bdt></div><div style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>Application Data.</strong> If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:<bdt class=\"block-component\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><em>Mobile Device Access.</em> We may request access or permission to certain features from your mobile device, including your mobile device's <bdt class=\"forloop-component\"></bdt><bdt class=\"question\">camera</bdt>, <bdt class=\"forloop-component\"></bdt>and other features. If you wish to change our access or permissions, you may do so in your device's settings.<bdt class=\"statement-end-if-in-editor\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><em>Push Notifications.</em> We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device's settings.<bdt class=\"statement-end-if-in-editor\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.</span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></bdt></span></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><strong><span data-custom-class=\"heading_2\">Google API</span></strong></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><br></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">Our use of information received from Google APIs will adhere to </span></span><a data-custom-class=\"link\" href=\"https://developers.google.com/terms/api-services-user-data-policy\" rel=\"noopener noreferrer\" target=\"_blank\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">Google API Services User Data Policy</span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">, including the </span></span><a data-custom-class=\"link\" href=\"https://developers.google.com/terms/api-services-user-data-policy#limited-use\" rel=\"noopener noreferrer\" target=\"_blank\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">Limited Use requirements</span></span></a><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">.</span><br></span></div><div><span style=\"font-size: 15px;\"><br></span></div><div style=\"line-height: 1.5;\"><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"></span></bdt><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"><bdt class=\"block-component\"></bdt></bdt></span></span></span></span></bdt></span></span></span></span></span></span></span></span><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"infouse\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">2. HOW DO WE PROCESS YOUR INFORMATION?</span></strong></span></span></span></span></span></div><div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short: </em></strong><em>We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent.</em></span></span></span></span></span></span></div></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</strong><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong>To deliver and facilitate delivery of services to the user. </strong>We may process your information to provide you with the requested service.<span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong>To send administrative information to you. </strong>We may process your information to send you details about our products and services, changes to our terms and policies, and other similar information.<span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>To <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> and manage your orders.</strong> We may process your information to <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> and manage your orders, payments, returns, and exchanges made through the Services.</span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><p style=\"font-size: 15px; line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span></span></span></span></span></span></span></span></span></span></span></li></ul><p style=\"font-size: 15px; line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt></p><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong>To enable user-to-user communications. </strong>We may process your information if you choose to use any of our offerings that allow for communication with another user.<span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></span></span></span></span></span></span></span></span></li></ul><p style=\"font-size: 15px; line-height: 1.5;\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></li></ul><p style=\"font-size: 15px; line-height: 1.5;\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></bdt></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>To save or protect an individual's vital interest.</strong> We may process your information when necessary to save or protect an individual’s vital interest, such as to prevent harm.</span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><div style=\"line-height: 1.5;\"><br></div><div id=\"legalbases\" style=\"line-height: 1.5;\"><strong><span style=\"font-size: 15px;\"><span data-custom-class=\"heading_1\">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</span></span></strong></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><em><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>In Short: </strong>We only process your personal information when we believe it is necessary and we have a valid legal reason (i.e.<bdt class=\"block-component\"></bdt> legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide you with services to enter into or <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> our contractual obligations, to protect your rights, or to <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> our legitimate business interests.</span></span></em></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">The General Data Protection Regulation (GDPR) and UK GDPR require us to explain the valid legal bases we rely on in order to process your personal information. As such, we may rely on the following legal bases to process your personal information:</span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>Consent. </strong>We may process your information if you have given us permission (i.e.<bdt class=\"block-component\"></bdt> consent) to use your personal information for a specific purpose. You can withdraw your consent at any time. Learn more about </span></span><a data-custom-class=\"link\" href=\"#withdrawconsent\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><span data-custom-class=\"body_text\">withdrawing your consent</span></span></a><span data-custom-class=\"body_text\">.</span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>Performance of a Contract.</strong> We may process your personal information when we believe it is necessary to <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> our contractual obligations to you, including providing our Services or at your request prior to entering into a contract with you.</span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>Legal Obligations.</strong> We may process your information where we believe it is necessary for compliance with our legal obligations, such as to cooperate with a law enforcement body or regulatory agency, exercise or defend our legal rights, or disclose your information as evidence in litigation in which we are involved.<bdt class=\"statement-end-if-in-editor\"></bdt><br></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><strong>Vital Interests.</strong> We may process your information where we believe it is necessary to protect your vital interests or the vital interests of a third party, such as situations involving potential threats to the safety of any person.</span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"><bdt class=\"block-component\"></span></span></bdt><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><div style=\"line-height: 1.5;\"><br></div><div id=\"whoshare\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short:</em></strong><em> We may share information in specific situations described in this section and/or with the following <bdt class=\"block-component\"></bdt>third parties.</em></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">We <bdt class=\"block-component\"></bdt>may need to share your personal information in the following situations:</span></span></div><ul><li data-custom-class=\"body_text\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"><span data-custom-class=\"body_text\"></span></bdt></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></bdt></span></span></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></li></ul><div style=\"line-height: 1.5;\"><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"><span data-custom-class=\"heading_1\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span><bdt class=\"block-component\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"inforetain\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short: </em></strong><em>We keep your information for as long as necessary to <bdt class=\"block-component\"></bdt>fulfil<bdt class=\"else-block\"></bdt> the purposes outlined in this privacy notice unless otherwise required by law.</em></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).<bdt class=\"block-component\"></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">When we have no ongoing legitimate business need to process your personal information, we will either delete or <bdt class=\"block-component\"></bdt>anonymise<bdt class=\"else-block\"></bdt> such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.<span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"infosafe\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short: </em></strong><em>We aim to protect your personal information through a system of <bdt class=\"block-component\"></bdt>organisational<bdt class=\"else-block\"></bdt> and technical security measures.</em></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We have implemented appropriate and reasonable technical and <bdt class=\"block-component\"></bdt>organisational<bdt class=\"else-block\"></bdt> security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other <bdt class=\"block-component\"></bdt>unauthorised<bdt class=\"else-block\"></bdt> third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.<span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"></bdt></span><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"infominors\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">7. DO WE COLLECT INFORMATION FROM MINORS?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short:</em></strong><em> We do not knowingly collect data from or market to <bdt class=\"block-component\"></bdt>children under 18 years of age<bdt class=\"else-block\"></bdt>.</em><bdt class=\"block-component\"></bdt></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We do not knowingly collect, solicit data from, or market to children under 18 years of age, nor do we knowingly sell such personal information. By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at <span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt><bdt class=\"question\">info@carsnow.ie</bdt><bdt class=\"else-block\"></bdt></span></span>.</span><span data-custom-class=\"body_text\"><bdt class=\"else-block\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"privacyrights\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">8. WHAT ARE YOUR PRIVACY RIGHTS?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><em>In Short:</em></strong><em> <span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><em><bdt class=\"block-component\"></bdt></em></span></span></span><bdt class=\"block-component\"></bdt>In <bdt class=\"statement-end-if-in-editor\"></bdt>some regions, such as <bdt class=\"block-component\"></bdt>the European Economic Area (EEA), United Kingdom (UK), and Switzerland<bdt class=\"block-component\"></bdt>, you have rights that allow you greater access to and control over your personal information.<span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><em><bdt class=\"statement-end-if-in-editor\"></bdt></em></span></span> </span>You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.</em><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">In some regions (like <bdt class=\"block-component\"></bdt>the EEA, UK, and Switzerland<bdt class=\"block-component\"></bdt>), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; (iv) if applicable, to data portability; and (v) not to be subject to automated decision-making. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us by using the contact details provided in the section <bdt class=\"block-component\"></bdt>'<bdt class=\"else-block\"></bdt></span></span></span><a data-custom-class=\"link\" href=\"#contact\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></span></span></a><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt>'<bdt class=\"else-block\"></bdt> below.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We will consider and act upon any request in accordance with applicable data protection laws.<bdt class=\"block-component\"></bdt></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"> </span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">If you are located in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your <span style=\"font-size: 15px;\"><span style=\"color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\"><a data-custom-class=\"link\" href=\"https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm\" rel=\"noopener noreferrer\" target=\"_blank\"><span style=\"font-size: 15px;\">Member State data protection authority</span></a></span></span></span></span></span> or </span></span></span><a data-custom-class=\"link\" href=\"https://ico.org.uk/make-a-complaint/data-protection-complaints/data-protection-complaints/\" rel=\"noopener noreferrer\" target=\"_blank\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\">UK data protection authority</span></span></span></a><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">If you are located in Switzerland, you may contact the <span style=\"font-size: 15px;\"><span style=\"color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><a data-custom-class=\"link\" href=\"https://www.edoeb.admin.ch/edoeb/en/home.html\" rel=\"noopener noreferrer\" target=\"_blank\">Federal Data Protection and Information Commissioner</a></span></span></span></span></span></span>.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"withdrawconsent\" style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><strong><u>Withdrawing your consent:</u></strong> If we are relying on your consent to process your personal information,<bdt class=\"block-component\"></bdt><bdt class=\"else-block\"></bdt> you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section <bdt class=\"block-component\"></bdt>'<bdt class=\"else-block\"></bdt></span></span></span><a data-custom-class=\"link\" href=\"#contact\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span style=\"font-size: 15px; color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></span></span></a><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt>'<bdt class=\"else-block\"></bdt> below<bdt class=\"block-component\"></bdt>.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\">However, please note that this will not affect the lawfulness of the processing before its withdrawal nor,<bdt class=\"block-component\"></bdt><bdt class=\"else-block\"></bdt> will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.<bdt class=\"block-component\"></bdt></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span></span></span></span></span></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\">If you have questions or comments about your privacy rights, you may email us at <bdt class=\"question\">info@carsnow.ie</bdt>.</span></span><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"></span></span></bdt></div><div style=\"line-height: 1.5;\"><br></div><div id=\"DNT\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (<bdt class=\"block-component\"></bdt>'DNT'<bdt class=\"else-block\"></bdt>) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for <bdt class=\"block-component\"></bdt>recognising<bdt class=\"else-block\"></bdt> and implementing DNT signals has been <bdt class=\"block-component\"></bdt>finalised<bdt class=\"else-block\"></bdt>. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.</span></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></bdt></span></span></span></span></span></span></span></span></span></span></span></bdt></span></span></span></span></span></span></span></span></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></bdt></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt></div><div style=\"line-height: 1.5;\"><br></div><div id=\"policyupdates\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">10. DO WE MAKE UPDATES TO THIS NOTICE?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><em><strong>In Short: </strong>Yes, we will update this notice as necessary to stay compliant with relevant laws.</em></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">We may update this privacy notice from time to time. The updated version will be indicated by an updated <bdt class=\"block-component\"></bdt>'Revised'<bdt class=\"else-block\"></bdt> date at the top of this privacy notice. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.</span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"contact\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">If you have questions or comments about this notice, you may <span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"><bdt class=\"block-component\"></bdt></bdt>email us at <bdt class=\"question\">info@carsnow.ie or </bdt><bdt class=\"statement-end-if-in-editor\"><bdt class=\"block-component\"></bdt></bdt></span></span><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\">contact us by post at:</span></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"question\">CarsNow Ltd</bdt></span></span></span></span></span><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt></bdt></span></span></span></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">Maple Avenue, Blackrock, Co. Dublin</bdt><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt></span></span></span></bdt></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"question\">Dublin</bdt><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><bdt class=\"block-component\"></bdt>, <bdt class=\"question\">Leinster</bdt><bdt class=\"statement-end-if-in-editor\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt><bdt class=\"block-component\"></bdt></span></span></span></bdt></span></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"block-component\"></bdt></span></span></span><bdt class=\"question\">Ireland</bdt><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></bdt><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><bdt class=\"statement-end-if-in-editor\"></bdt></span></span></span></bdt></span></span></span></span><span data-custom-class=\"body_text\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89);\"><bdt class=\"statement-end-if-in-editor\"><span style=\"color: rgb(89, 89, 89);\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"><bdt class=\"block-component\"></bdt></span></span></span></span></span></span><bdt class=\"block-component\"><span style=\"font-size: 15px;\"></span></bdt><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px;\"><span data-custom-class=\"body_text\"><bdt class=\"statement-end-if-in-editor\"><bdt class=\"block-component\"></bdt></span></span></div><div style=\"line-height: 1.5;\"><br></div><div id=\"request\" style=\"line-height: 1.5;\"><span style=\"color: rgb(127, 127, 127);\"><span style=\"color: rgb(89, 89, 89); font-size: 15px;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span id=\"control\" style=\"color: rgb(0, 0, 0);\"><strong><span data-custom-class=\"heading_1\">12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span></strong></span></span></span></span></span></div><div style=\"line-height: 1.5;\"><br></div><div style=\"line-height: 1.5;\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span style=\"font-size: 15px; color: rgb(89, 89, 89);\"><span data-custom-class=\"body_text\"><bdt class=\"block-component\"></bdt>Based on the applicable laws of your country<bdt class=\"block-component\"></bdt>, you may<bdt class=\"else-block\"><bdt class=\"block-component\"> have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to <bdt class=\"block-component\"></bdt>withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. To request to review, update, or delete your personal information, please <bdt class=\"block-component\"></bdt>fill out and submit a </span><span style=\"color: rgb(0, 58, 250);\"><span data-custom-class=\"body_text\"><span style=\"color: rgb(0, 58, 250); font-size: 15px;\"><a data-custom-class=\"link\" href=\"https://app.termly.io/notify/76504042-9630-496c-abf6-3da86635d6c9\" rel=\"noopener noreferrer\" target=\"_blank\">data subject access request</a></span></span></span><bdt class=\"block-component\"><span data-custom-class=\"body_text\"></bdt></span></span><span data-custom-class=\"body_text\">.</span></span></span></div><style>\r\n      ul {\r\n        list-style-type: square;\r\n      }\r\n      ul > li > ul {\r\n        list-style-type: circle;\r\n      }\r\n      ul > li > ul > li > ul {\r\n        list-style-type: square;\r\n      }\r\n      ol li {\r\n        font-family: Arial ;\r\n      }\r\n    </style>\r\n      </div>\r\n      "

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPolicyController = function PrivacyPolicyController() {
	  (0, _classCallCheck3.default)(this, PrivacyPolicyController);
	
	  this.name = 'privacyPolicy';
	};
	
	exports.default = PrivacyPolicyController;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1857);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./privacyPolicy.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./privacyPolicy.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".privacyPolicy{color:red}", ""]);
	
	// exports


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _accounting = __webpack_require__(1859);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _productList = __webpack_require__(1864);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _invoiceList = __webpack_require__(1870);
	
	var _invoiceList2 = _interopRequireDefault(_invoiceList);
	
	var _editInvoice = __webpack_require__(1876);
	
	var _editInvoice2 = _interopRequireDefault(_editInvoice);
	
	var _accounting3 = __webpack_require__(1882);
	
	var _accounting4 = _interopRequireDefault(_accounting3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountingModule = _angular2.default.module('accounting', [_angularUiRouter2.default, _productList2.default, _invoiceList2.default, _editInvoice2.default]).component('accounting', _accounting2.default).service('accountingService', _accounting4.default).name;
	
	exports.default = accountingModule;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(1860);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _accounting3 = __webpack_require__(1861);
	
	var _accounting4 = _interopRequireDefault(_accounting3);
	
	__webpack_require__(1862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _accounting2.default,
	  controller: _accounting4.default
	};
	
	exports.default = accountingComponent;

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <h1>{{ $ctrl.name }}</h1>\r\n</div>\r\n"

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountingController = function AccountingController() {
	  (0, _classCallCheck3.default)(this, AccountingController);
	
	  this.name = 'accounting';
	};
	
	exports.default = AccountingController;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1863);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accounting.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accounting.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".accounting{color:red}", ""]);
	
	// exports


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _productList = __webpack_require__(1865);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productListModule = _angular2.default.module('productList', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('productList', {
	    url: '/productList',
	    component: 'productList'
	  });
	}]).component('productList', _productList2.default).name;
	
	exports.default = productListModule;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productList = __webpack_require__(1866);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	var _productList3 = __webpack_require__(1867);
	
	var _productList4 = _interopRequireDefault(_productList3);
	
	__webpack_require__(1868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _productList2.default,
	  controller: _productList4.default
	};
	
	exports.default = productListComponent;

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"productListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n          <h2>Products List</h2>\r\n        </header>\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Title\"\r\n              ng-model=\"$ctrl.filterParams.title\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Created By\"\r\n              ng-model=\"$ctrl.filterParams.createdBy\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-model=\"$ctrl.filterParams.status\">\r\n              <option value=\"\">All</option>\r\n              <option value=\"1\">Active</option>\r\n              <option value=\"2\">Suspended</option>\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listProducts()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>            \r\n          </span>          \r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.showAddProduct()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-plus\"></i>\r\n              Add Product\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-4\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('title')\">\r\n                      Title <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('price')\">\r\n                      Price <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>                  \r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('vatRate')\">\r\n                      VAT % <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('created')\">\r\n                      Created <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('createdBy')\">\r\n                      Created By <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('status')\">\r\n                      Status <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"p in $ctrl.products\">\r\n                    <td class=\"col-md-4\">{{ p.title }}</td>\r\n                    <td class=\"col-md-1\">{{ p.price | number : 2 }}</td>\r\n                    <td class=\"col-md-1\">{{ p.vatRate | number : 1 }} %</td>                    \r\n                    <td class=\"col-md-2\">{{ p.created | date : 'dd-MMM-yyyy HH:mm' }}</td>\r\n                    <td class=\"col-md-2\">{{ p.createdBy }}</td>\r\n                    <td class=\"col-md-1\">{{ p.statusName }}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\" ng-if=\"p.status == $ctrl.enums.OBJECT_ROW_STATE.Active\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.editProduct(p.productId)\">Edit</a>\r\n                          </li>\r\n                          <li role=\"menuitem\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.updateStatus(p.productId, $ctrl.enums.OBJECT_ROW_STATE.Deleted)\">Delete</a>\r\n                          </li>\r\n                          <li role=\"menuitem\" ng-if=\"p.status == $ctrl.enums.OBJECT_ROW_STATE.Active\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.updateStatus(p.productId, $ctrl.enums.OBJECT_ROW_STATE.Inactive)\">Suspend</a>\r\n                          </li>   \r\n                          <li role=\"menuitem\" ng-if=\"p.status == $ctrl.enums.OBJECT_ROW_STATE.Inactive\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.updateStatus(p.productId, $ctrl.enums.OBJECT_ROW_STATE.Active)\">Activate</a>\r\n                          </li>                                                    \r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.products.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listProducts()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductListController = function () {
	  ProductListController.$inject = ["authService", "accountingService", "loadingService", "enums", "$ngConfirm", "$scope"];
	  function ProductListController(authService, accountingService, loadingService, enums, $ngConfirm, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, ProductListController);
	    this.authService = authService;
	    this.accountingService = accountingService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	
	    this.selectOptions = {};
	    this.filterParams = {};
	
	    this.$scope.vatRates = [{ id: null, name: 'Please Select' }, { id: '0', name: '0%' }, { id: '13.5', name: '13.5%' }, { id: '23', name: '23%' }];
	
	    this.reset();
	  }
	
	  (0, _createClass3.default)(ProductListController, [{
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.title = '';
	      this.filterParams.createdBy = '';
	      this.filterParams.status = "";
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'created',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listProducts();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listProducts();
	    }
	  }, {
	    key: 'listProducts',
	    value: function listProducts() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('productListing', 'Loading Products ...');
	
	      ctrl.accountingService.listProducts(ctrl.filterParams).then(function (response) {
	        ctrl.products = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' products'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching products." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('productListing');
	      });
	    }
	  }, {
	    key: 'showAddProduct',
	    value: function showAddProduct() {
	      var _this = this;
	
	      this.$scope.errMsg = '';
	
	      this.$scope.product = {
	        productId: null,
	        title: null,
	        description: null,
	        price: null,
	        vatRate: null
	      };
	
	      this.createDialog = this.$ngConfirm({
	        title: 'Add Product',
	        contentUrl: 'templates/product/editProductTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this.validateAddProduct();
	
	              if (valid) {
	                _this.loadingService.showLoading('productListing', 'Adding product ...');
	
	                _this.accountingService.addProduct(_this.authService.authData.currentLocation.key, _this.$scope.product).then(function (response) {
	                  _this.listProducts();
	                  _this.createDialog.close();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this.loadingService.hideLoading('productListing');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateAddProduct',
	    value: function validateAddProduct() {
	      if (this.$scope.product.title === null || this.$scope.product.title === '') {
	        this.$scope.errMsg = 'Please enter a title.';
	        return false;
	      }
	      if (this.$scope.product.price === null || this.$scope.product.price === '') {
	        this.$scope.errMsg = 'Please enter a price.';
	        return false;
	      }
	      if (this.$scope.product.vatRate === null || this.$scope.product.vatRate === '') {
	        this.$scope.errMsg = 'Please select a VAT rate.';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'editProduct',
	    value: function editProduct(productId) {
	      var _this2 = this;
	
	      this.$scope.errMsg = '';
	
	      this.accountingService.getProduct(productId).then(function (response) {
	        _this2.showEditProduct(response.data);
	      });
	    }
	  }, {
	    key: 'showEditProduct',
	    value: function showEditProduct(product) {
	      var _this3 = this;
	
	      this.$scope.errMsg = '';
	
	      this.$scope.product = product;
	      this.$scope.product.vatRate = product.vatRate.toString();
	
	      this.editDialog = this.$ngConfirm({
	        title: 'Edit Product',
	        contentUrl: 'templates/product/editProductTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this3.validateAddProduct();
	
	              if (valid) {
	                _this3.loadingService.showLoading('productListing', 'Updating product ...');
	
	                _this3.accountingService.editProduct(_this3.authService.authData.currentLocation.key, _this3.$scope.product).then(function (response) {
	                  _this3.listProducts();
	                  _this3.editDialog.close();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this3.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this3.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this3.loadingService.hideLoading('productListing');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus(productId, status) {
	      var _this4 = this;
	
	      var ctrl = this;
	      var title = void 0,
	          content = void 0;
	
	      switch (status) {
	        case this.enums.OBJECT_ROW_STATE.Active:
	          title = 'Activate Product';
	          content = 'Are you sure you want to activate this product?';
	          break;
	
	        case this.enums.OBJECT_ROW_STATE.Inactive:
	          title = 'Suspend Product';
	          content = 'Are you sure you want to suspend this product?';
	          break;
	
	        case this.enums.OBJECT_ROW_STATE.Deleted:
	          title = 'Delete Product';
	          content = 'Are you sure you want to delete this product?';
	          break;
	      }
	
	      this.$ngConfirm({
	        title: title,
	        content: content,
	        type: 'red',
	        buttons: {
	          confirm: function confirm() {
	            ctrl.loadingService.showLoading('productListing', 'Updating product status ...');
	
	            ctrl.accountingService.updateProductStatus(_this4.authService.authData.currentLocation.key, productId, status).then(function (response) {
	              ctrl.listProducts();
	            }).catch(function (err) {
	              switch (err.status) {
	                case 400:
	                  ctrl.notification = {
	                    type: 'error',
	                    msg: err.data[0].value
	                  };
	                  break;
	
	                default:
	                  ctrl.notification = {
	                    type: 'error',
	                    msg: err.data.message
	                  };
	                  break;
	              }
	            }).finally(function () {
	              ctrl.loadingService.hideLoading('productListing');
	            });
	          },
	          cancel: function cancel() {}
	        }
	      });
	    }
	  }]);
	  return ProductListController;
	}();
	
	exports.default = ProductListController;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1869);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./productList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./productList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".productList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _invoiceList = __webpack_require__(1871);
	
	var _invoiceList2 = _interopRequireDefault(_invoiceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invoiceListModule = _angular2.default.module('invoiceList', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('invoiceList', {
	    url: '/invoiceList',
	    component: 'invoiceList'
	  });
	}]).component('invoiceList', _invoiceList2.default).name;
	
	exports.default = invoiceListModule;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invoiceList = __webpack_require__(1872);
	
	var _invoiceList2 = _interopRequireDefault(_invoiceList);
	
	var _invoiceList3 = __webpack_require__(1873);
	
	var _invoiceList4 = _interopRequireDefault(_invoiceList3);
	
	__webpack_require__(1874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invoiceListComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _invoiceList2.default,
	  controller: _invoiceList4.default
	};
	
	exports.default = invoiceListComponent;

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"col-md-12\" block-ui=\"invoiceListing\">\r\n    <div class=\"panel\">\r\n        <header>\r\n          <h2>Invoice List</h2>\r\n        </header>\r\n\r\n        <section class=\"search\">\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Numbner\"\r\n              ng-model=\"$ctrl.filterParams.number\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <input\r\n              class=\"form-control\"\r\n              placeholder=\"Search by Contact\"\r\n              ng-model=\"$ctrl.filterParams.contact\">\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-model=\"$ctrl.filterParams.status\">\r\n              <option value=\"\">All</option>\r\n              <option value=\"1\">Draft</option>\r\n              <option value=\"2\">Issued</option>\r\n              <option value=\"3\">Paid</option>\r\n              <option value=\"4\">Voided</option>\r\n              <option value=\"5\">Deleted</option>\r\n            </select>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.listInvoices()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-search\"></i>\r\n              Search\r\n            </button>\r\n          </span>\r\n\r\n          <span class=\"col-md-2 nopadding\">\r\n            <button ng-click=\"$ctrl.reset()\" class=\"btn btn-default pull-right\">\r\n              <i class=\"fa fa-eraser\"></i>\r\n              Clear Filters\r\n            </button>            \r\n          </span>          \r\n\r\n          <span class=\"col-md-2 nopadding pull-right\">\r\n            <button ng-click=\"$ctrl.newInvoice()\" class=\"btn btn-primary\">\r\n              <i class=\"glyphicon glyphicon-plus\"></i>\r\n              New Invoice\r\n            </button>\r\n          </span>\r\n\r\n        </section>\r\n\r\n        <table class=\"table table-bordered table-hover table-striped\">\r\n            <thead>\r\n                <tr>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('number')\">\r\n                      Number <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('contact')\">\r\n                      Contact <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>                  \r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('created')\">\r\n                      Created <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('createdby')\">\r\n                      Created By <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-2\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('status')\">\r\n                      Status <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('net')\">\r\n                      Net <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>\r\n                  <th class=\"col-md-1\">\r\n                    <a class=\"btn btn-link\" ng-click=\"$ctrl.updateSort('total')\">\r\n                      Total <i class=\"fa fa-fw fa-sort\"></i>\r\n                    </a>\r\n                  </th>                  \r\n                  <th class=\"col-md-1\">&nbsp;</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr data-ng-repeat=\"i in $ctrl.invoices\">\r\n                    <td class=\"col-md-1\">{{ i.invoiceNumber }}</td>\r\n                    <td class=\"col-md-2\">{{ i.contact }}</td>\r\n                    <td class=\"col-md-2\">{{ i.created | date : 'dd-MMM-yyyy HH:mm' }}</td>\r\n                    <td class=\"col-md-2\">{{ i.createdBy }}</td>\r\n                    <td class=\"col-md-2\">{{ i.statusName }}</td>\r\n                    <td class=\"col-md-1\">{{ i.net | currency : '&euro;' : 2}}</td>\r\n                    <td class=\"col-md-1\">{{ i.total | currency : '&euro;' : 2}}</td>\r\n                    <td class=\"col-md-1\">\r\n                      <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\r\n                        <button id=\"btn-append-to-body\" type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle>\r\n                          Actions <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"btn-append-to-body\">\r\n                          <li role=\"menuitem\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.editInvoice(i.invoiceId)\">View</a>\r\n                          </li>\r\n                          <li role=\"menuitem\">\r\n                            <a href=\"#\" ng-click=\"$ctrl.printInvoice(i.invoiceId)\">Print</a>\r\n                          </li>                         \r\n                        </ul>\r\n                      </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <footer>\r\n          <div class=\"row\" >\r\n            <div class=\"col-md-4 pages\" ng-hide=\"!$ctrl.invoices.length\">\r\n              <ul uib-pagination\r\n                total-items=\"$ctrl.pagination.totalItems\"\r\n                items-per-page=\"$ctrl.pagination.pageSize\"\r\n                ng-model=\"$ctrl.pagination.currentPage\"\r\n                ng-change=\"$ctrl.listInvoices()\">\r\n              </ul>\r\n            </div>\r\n\r\n            <span class=\"col-md-4 pull-right\">\r\n              <span class=\"pull-right\">\r\n                {{$ctrl.notification.msg}}\r\n              </span>\r\n            </span>\r\n          </div>\r\n        </footer>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvoiceListController = function () {
	  InvoiceListController.$inject = ["authService", "accountingService", "loadingService", "enums", "$ngConfirm", "$scope", "$state", "printService"];
	  function InvoiceListController(authService, accountingService, loadingService, enums, $ngConfirm, $scope, $state, printService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, InvoiceListController);
	    this.authService = authService;
	    this.accountingService = accountingService;
	    this.loadingService = loadingService;
	    this.enums = enums;
	    this.$ngConfirm = $ngConfirm;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.printService = printService;
	
	    this.selectOptions = {};
	    this.filterParams = {};
	
	    this.reset();
	  }
	
	  (0, _createClass3.default)(InvoiceListController, [{
	    key: 'reset',
	    value: function reset() {
	      var ctrl = this;
	
	      this.filterParams.entityId = this.authService.authData.currentLocation.key;
	      this.filterParams.number = '';
	      this.filterParams.contact = '';
	      this.filterParams.status = "";
	
	      this.pagination = {
	        totalItems: 0,
	        currentPage: 1,
	        pageSize: 10
	      };
	
	      this.filterParams.pageCriteria = {
	        pageStart: 0,
	        itemsToFetch: this.pagination.pageSize,
	        sortExpression: 'created',
	        ascending: false
	      };
	
	      this.notification = {
	        type: 'info',
	        msg: ''
	      };
	
	      this.listInvoices();
	    }
	  }, {
	    key: 'updatePageIndex',
	    value: function updatePageIndex() {
	      if (this.pagination.currentPage === 1) {
	        this.filterParams.pageCriteria.pageStart = 0;
	      } else {
	        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
	      }
	    }
	  }, {
	    key: 'updateSort',
	    value: function updateSort(fieldName) {
	      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
	        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
	      } else {
	        this.filterParams.pageCriteria.sortExpression = fieldName;
	        this.filterParams.pageCriteria.ascending = true;
	      }
	
	      this.listInvoices();
	    }
	  }, {
	    key: 'listInvoices',
	    value: function listInvoices() {
	      var ctrl = this;
	
	      ctrl.updatePageIndex();
	
	      ctrl.loadingService.showLoading('invoiceListing', 'Loading Invoices ...');
	
	      ctrl.accountingService.listInvoices(ctrl.filterParams).then(function (response) {
	        ctrl.invoices = response.data.items;
	        ctrl.pagination.totalItems = response.data.totalRecords;
	
	        if (ctrl.pagination.totalItems === 0) {
	          ctrl.notification = {
	            type: 'info',
	            msg: 'No data to display'
	          };
	        } else {
	          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;
	
	          ctrl.notification = {
	            type: 'info',
	            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' invoices'
	          };
	        }
	      }).catch(function (err) {
	        ctrl.notification = {
	          type: 'error',
	          msg: "An error occurred while fetching invoices." + (err.data ? err.data.messageDetail : '')
	        };
	      }).finally(function () {
	        ctrl.loadingService.hideLoading('invoiceListing');
	      });
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus(productId, status) {
	      var _this = this;
	
	      var ctrl = this;
	      var title = void 0,
	          content = void 0;
	
	      switch (status) {
	        case this.enums.OBJECT_ROW_STATE.Active:
	          title = 'Activate Product';
	          content = 'Are you sure you want to activate this product?';
	          break;
	
	        case this.enums.OBJECT_ROW_STATE.Inactive:
	          title = 'Suspend Product';
	          content = 'Are you sure you want to suspend this product?';
	          break;
	
	        case this.enums.OBJECT_ROW_STATE.Deleted:
	          title = 'Delete Product';
	          content = 'Are you sure you want to delete this product?';
	          break;
	      }
	
	      this.$ngConfirm({
	        title: title,
	        content: content,
	        type: 'red',
	        buttons: {
	          confirm: function confirm() {
	            ctrl.loadingService.showLoading('invoiceListing', 'Updating product status ...');
	
	            ctrl.productsManagementService.updateStatus(_this.authService.authData.currentLocation.key, productId, status).then(function (response) {
	              ctrl.listProducts();
	            }).catch(function (err) {
	              switch (err.status) {
	                case 400:
	                  ctrl.notification = {
	                    type: 'error',
	                    msg: err.data[0].value
	                  };
	                  break;
	
	                default:
	                  ctrl.notification = {
	                    type: 'error',
	                    msg: err.data.message
	                  };
	                  break;
	              }
	            }).finally(function () {
	              ctrl.loadingService.hideLoading('invoiceListing');
	            });
	          },
	          cancel: function cancel() {}
	        }
	      });
	    }
	  }, {
	    key: 'newInvoice',
	    value: function newInvoice() {
	      this.$state.go('editInvoice', { locationId: this.authService.authData.currentLocation.key, invoiceId: null });
	    }
	  }, {
	    key: 'editInvoice',
	    value: function editInvoice(invoiceId) {
	      this.$state.go('editInvoice', { locationId: this.authService.authData.currentLocation.key, invoiceId: invoiceId });
	    }
	  }, {
	    key: 'printInvoice',
	    value: function printInvoice(invoiceId) {
	      this.printService.printInvoice(invoiceId);
	    }
	  }]);
	  return InvoiceListController;
	}();
	
	exports.default = InvoiceListController;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1875);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./invoiceList.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./invoiceList.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".invoiceList{color:red}", ""]);
	
	// exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(370);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(372);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _editInvoice = __webpack_require__(1877);
	
	var _editInvoice2 = _interopRequireDefault(_editInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editInvoiceModule = _angular2.default.module('editInvoice', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('editInvoice', {
	    url: '/editInvoice/:invoiceId?',
	    component: 'editInvoice'
	  });
	
	  $stateProvider.state('addInvoice', {
	    url: '/editInvoice',
	    component: 'editInvoice'
	  });
	}]).component('editInvoice', _editInvoice2.default).name;
	
	exports.default = editInvoiceModule;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _editInvoice = __webpack_require__(1878);
	
	var _editInvoice2 = _interopRequireDefault(_editInvoice);
	
	var _editInvoice3 = __webpack_require__(1879);
	
	var _editInvoice4 = _interopRequireDefault(_editInvoice3);
	
	__webpack_require__(1880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editInvoiceComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _editInvoice2.default,
	  controller: _editInvoice4.default
	};
	
	exports.default = editInvoiceComponent;

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n\r\n  <a href=\"#\" class=\"btn btn-default\" ui-sref=\"invoiceList\">\r\n    <i class=\"fa fa-arrow-left\"></i> Back to Invoices\r\n  </a>\r\n\r\n  <fieldset class=\"mt-20 rounded\">\r\n    <h3>Contact Details</h3>\r\n\r\n    <div class=\"row\" ng-hide=\"$ctrl.invoice.contactId\" block-ui=\"customerManagement\">      \r\n      <div class=\"col-md-12\">\r\n          <label class=\"radio-btn col-md-10\">\r\n            <div angucomplete-alt\r\n              placeholder=\"Search Contacts by Phone, Name, Email or Registration\"\r\n              id=\"searchContacts\"\r\n              selected-object=\"$ctrl.contactSelected\"\r\n              remote-url=\"{{$ctrl.searchContactUrl}}\"\r\n              title-field=\"name,phone,email,reg\"\r\n              minlength=\"2\"\r\n              remote-url-response-formatter=\"$ctrl.contactSearched\"\r\n              input-class=\"form-control  full-width\"\r\n              match-class=\"autocomplete-highlight\"\r\n              style=\"width: 100%;\">\r\n            </div>\r\n          </label>\r\n\r\n          <button class=\"btn btn-primary\"\r\n            ng-disabled=\"!$ctrl.createNewContact\"\r\n            ng-click=\"$ctrl.showNewContact()\" ng-if=\"$ctrl.authService.checkFeatureAccess('Contact', $ctrl.enums.PERMISSION_TYPE.Add, false)\">\r\n              <strong>+</strong> Create New\r\n          </button>          \r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-show=\"$ctrl.invoice.contactId\">      \r\n      <div class=\"col-md-12\">\r\n          <dl class=\"dl-horizontal\">\r\n              <dt>Contact Name:</dt>\r\n              <dd>\r\n                <a href=\"#\" ng-click=\"$ctrl.showEditContact($ctrl.selectedContact)\">\r\n                  {{$ctrl.selectedContact.contactPerson.firstName}} {{$ctrl.selectedContact.contactPerson.lastName}}\r\n                </a>\r\n              </dd>\r\n          </dl>\r\n          <dl class=\"dl-horizontal\">\r\n              <dt>Contact Phone:</dt>\r\n              <dd>{{$ctrl.selectedContact.phone}}</dd>\r\n          </dl>\r\n          <dl class=\"dl-horizontal\">\r\n              <dt>Contact Email:</dt>\r\n              <dd>{{$ctrl.selectedContact.email}}</dd>\r\n          </dl>\r\n          <dl class=\"dl-horizontal\">\r\n            <dt>Address:</dt>\r\n            <dd>{{$ctrl.selectedContact.address.line1}}</dd>\r\n            <dd>{{$ctrl.selectedContact.address.line2}}</dd>\r\n            <dd>{{$ctrl.selectedContact.address.line3}}</dd>\r\n            <dd>{{$ctrl.selectedContact.address.zip}}</dd>\r\n        </dl>       \r\n          <dl class=\"dl-horizontal\" ng-if=\"$ctrl.enquiry.contact.enquiry !== null\">\r\n            <button class=\"btn btn-primary w-100\" ng-click=\"$ctrl.clearContact()\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\">Clear Contact</button>\r\n          </dl>          \r\n        </div>\r\n    </div>\r\n\r\n  </fieldset>\r\n\r\n  <fieldset class=\"mt-20 rounded\">\r\n    <h3>Invoice Details</h3>\r\n\r\n    <div class=\"row\" ng-show1=\"$ctrl.invoice.contactId\" block-ui=\"invoicesManagement\">      \r\n      <div class=\"col-md-12\">\r\n        <dl class=\"dl-horizontal\">\r\n            <dt><b>Status:</b></dt>\r\n            <dd>\r\n              <b>{{$ctrl.invoice.statusName}}</b>\r\n            </dd>\r\n        </dl>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Invoice Number:</dt>\r\n          <dd>\r\n            {{$ctrl.invoice.invoiceNumber}}\r\n          </dd>\r\n        </dl> \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Invoice Date:</dt>\r\n          <dd style=\"width: 30%;\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showInvDatePopup = !$ctrl.showInvDatePopup\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.invoice.invoiceDate\" is-open=\"$ctrl.showInvDatePopup\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showInvDatePopup = !$ctrl.showInvDatePopup\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n            <dd ng-if=\"$ctrl.invoice.status !== $ctrl.enums.INVOICE_STATUS.Draft\">\r\n              {{$ctrl.invoice.invoiceDate | date : 'dd-MMMM-yyyy'}}\r\n            </dd>\r\n          </dd>\r\n        </dl>                      \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Due Date:</dt>\r\n          <dd style=\"width: 30%;\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\">\r\n            <p class=\"input-group\">\r\n              <input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.showDueDatePopup = !$ctrl.showDueDatePopup\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"$ctrl.invoice.dueDate\" is-open=\"$ctrl.showDueDatePopup\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"$ctrl.showDueDatePopup = !$ctrl.showDueDatePopup\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n              </span>\r\n            </p>\r\n            <dd ng-if=\"$ctrl.invoice.status !== $ctrl.enums.INVOICE_STATUS.Draft\">\r\n              {{$ctrl.invoice.dueDate | date : 'dd-MMMM-yyyy'}}\r\n            </dd>\r\n          </dd>\r\n        </dl>                              \r\n        <dl class=\"dl-horizontal\">\r\n            <dt>Actions:</dt>\r\n            <dd>\r\n              <button class=\"btn btn-success\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\" ng-click=\"$ctrl.saveDraft()\">\r\n                Save Draft\r\n                <i class=\"fa fa-floppy-o\"></i>                \r\n              </button>\r\n              <button class=\"btn btn-primary\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && $ctrl.invoice.invoiceId\" ng-click=\"$ctrl.issue()\">\r\n                Issue Invoice\r\n                <i class=\"fa fa-gavel\"></i>                                \r\n              </button>\r\n              <button class=\"btn btn-success\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Issued\" ng-click=\"$ctrl.paid()\">\r\n                Mark as Paid\r\n                <i class=\"fa fa-euro\"></i>                                \r\n              </button>              \r\n              <button class=\"btn btn-danger\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && $ctrl.invoice.invoiceId\" ng-click=\"$ctrl.delete()\">\r\n                Delete\r\n                <i class=\"fa fa-trash\"></i>                                \r\n              </button>\r\n              <button class=\"btn btn-danger\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Issued\" ng-click=\"$ctrl.void()\">\r\n                Void\r\n                <i class=\"fa fa-ban\"></i>                                \r\n              </button>\r\n              <button class=\"btn btn-default\" ng-if=\"$ctrl.invoice.invoiceId\" ng-click=\"$ctrl.printInvoice()\">\r\n                Print\r\n                <i class=\"fa fa-print\"></i>                                \r\n              </button>\r\n              <button class=\"btn btn-default\" ng-if=\"$ctrl.invoice.invoiceId\" ng-click=\"$ctrl.emailInvoice()\">\r\n                Email\r\n                <i class=\"fa fa-envelope-o\"></i>                                \r\n              </button>\r\n            </dd>\r\n        </dl>\r\n    </div>\r\n\r\n  </fieldset> \r\n  \r\n  <fieldset class=\"mt-20 rounded\">\r\n    <h3>Invoice Items</h3>\r\n    <table class=\"table table-bordered table-hover table-striped\">\r\n      <thead>\r\n        <tr>\r\n          <th class=\"col-md-5\">Title</th>\r\n          <th class=\"col-md-1 text-right\">Qty</th>\r\n          <th class=\"col-md-1 text-right\">Price (&euro;)</th>\r\n          <th class=\"col-md-1 text-right\">VAT Rate</th>\r\n          <th class=\"col-md-1 text-right\">Net (&euro;)</th>\r\n          <th class=\"col-md-1 text-right\">VAT (&euro;)</th>  \r\n          <th class=\"col-md-1 text-right\">Total (&euro;)</th>\r\n          <th class=\"col-md-1 text-right\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\">&nbsp;</th>                  \r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-repeat=\"item in $ctrl.invoice.lineItems\">\r\n          <td class=\"col-md-5\">\r\n            <span ng-if=\"!item.editMode\">{{item.title}}</span>\r\n            <input class=\"form-control\" ng-model=\"$ctrl.tempLineItem.title\" ng-if=\"item.editMode\" maxlength=\"100\"/>\r\n          </td>\r\n          <td class=\"col-md-1 text-right\">            \r\n            <span ng-if=\"!item.editMode\">{{item.quantity | number:2}}</span>\r\n            <input class=\"form-control\" type=\"number\" step=\".5\" ng-model=\"$ctrl.tempLineItem.quantity\" ng-if=\"item.editMode\" ng-change=\"$ctrl.updateLineItemTotals()\"  maxlength=\"50\"/>\r\n          </td>\r\n          <td class=\"col-md-1 text-right\">\r\n            <span ng-if=\"!item.editMode\">{{item.price | number:2}}</span>\r\n            <input class=\"form-control\" type=\"number\" step=\".5\" ng-model=\"$ctrl.tempLineItem.price\" ng-if=\"item.editMode\" ng-change=\"$ctrl.updateLineItemTotals()\"  maxlength=\"50\"/>\r\n          </td>\r\n          <td class=\"col-md-1 text-right\">\r\n            <span ng-if=\"!item.editMode\">{{item.vatRate}}%</span>\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.id as item.name for item in $ctrl.vatRates\"\r\n              ng-change=\"$ctrl.updateLineItemTotals()\" \r\n              ng-model=\"$ctrl.tempLineItem.vatRate\" ng-if=\"item.editMode\">\r\n          </td>\r\n          <td class=\"col-md-1 text-right\">\r\n            <span ng-if=\"!item.editMode\">{{item.net | number:2}}</span>\r\n            <span ng-if=\"item.editMode\">{{$ctrl.tempLineItem.net | number:2}}</span>\r\n          </td> \r\n          <td class=\"col-md-1 text-right\">\r\n            <span ng-if=\"!item.editMode\">{{item.vat | number:2}}</span>\r\n            <span ng-if=\"item.editMode\">{{$ctrl.tempLineItem.vat | number:2}}</span>\r\n          </td> \r\n          <td class=\"col-md-1 text-right\">\r\n            <span ng-if=\"!item.editMode\">{{item.total | number:2}}</span>\r\n            <span ng-if=\"item.editMode\">{{$ctrl.tempLineItem.total | number:2}}</span>\r\n          </td>                            \r\n          <td class=\"col-md-1 text-center\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\">\r\n            <a href=\"#\" ng-click=\"$ctrl.editLineItem(item)\" title=\"Edit\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && !item.editMode && !$ctrl.editMode\">\r\n              <i class=\"fa fa-pencil text-default\" style=\"font-size: 20px;\"></i>\r\n            </a> \r\n            <a href=\"#\" ng-click=\"$ctrl.updateLineItem(item)\" title=\"Update\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && item.editMode\">\r\n              <i class=\"fa fa-check text-default\" style=\"font-size: 20px;\"></i>\r\n            </a>                            \r\n            &nbsp;\r\n            <a href=\"#\" ng-click=\"$ctrl.removeLineItem(item)\" title=\"Delete\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && !item.editMode && !$ctrl.editMode\">\r\n              <i class=\"fa fa-trash text-danger\" style=\"font-size: 20px;\"></i>\r\n            </a>  \r\n            <a href=\"#\" ng-click=\"$ctrl.cancelEditLineItem(item)\" title=\"Cancel\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && item.editMode\">\r\n              <i class=\"fa fa-ban text-danger\" style=\"font-size: 20px;\"></i>\r\n            </a>                     \r\n          </td>\r\n        </tr>        \r\n        <tr ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft && !$ctrl.editMode\">\r\n          <td class=\"col-md-5\">\r\n            <label class=\"radio-btn col-md-10\">\r\n              <div angucomplete-alt\r\n                placeholder=\"Search product by title\"\r\n                id=\"searchProducts\"\r\n                selected-object=\"$ctrl.poructSelected\"\r\n                remote-url=\"{{$ctrl.searchProductUrl}}\"\r\n                title-field=\"title,priceString,vatRateString\"\r\n                minlength=\"2\"\r\n                remote-url-response-formatter=\"$ctrl.productSearched\"\r\n                input-class=\"form-control\"\r\n                match-class=\"autocomplete-highlight\"\r\n                style=\"width: 100%;\"\r\n                maxlength=\"100\">\r\n              </div>\r\n            </label>\r\n          </td>\r\n          <td class=\"col-md-1\"><input class=\"form-control\" type=\"number\" step=\".5\" ng-model=\"$ctrl.tempLineItem.quantity\" ng-change=\"$ctrl.updateLineItemTotals()\" maxlength=\"50\"/></td>\r\n          <td class=\"col-md-1\"><input class=\"form-control\" type=\"number\" step=\".5\" ng-model=\"$ctrl.tempLineItem.price\" ng-change=\"$ctrl.updateLineItemTotals()\" maxlength=\"50\"/></td>\r\n          <td class=\"col-md-1\">\r\n            <select\r\n              class=\"form-control\"\r\n              ng-options=\"item.id as item.name for item in $ctrl.vatRates\"\r\n              ng-change=\"$ctrl.updateLineItemTotals()\" \r\n              ng-model=\"$ctrl.tempLineItem.vatRate\">\r\n          </select>\r\n          </td>\r\n          <td class=\"col-md-1\">{{$ctrl.tempLineItem.net | number:2}}</td>\r\n          <td class=\"col-md-1\">{{$ctrl.tempLineItem.vat | number:2}}</td>\r\n          <td class=\"col-md-1\">{{$ctrl.tempLineItem.total | number:2}}</td>\r\n          <td class=\"col-md-1 text-center\">\r\n            <a href=\"#\" ng-click=\"$ctrl.addLineItem()\" title=\"Add\">\r\n              <i class=\"fa fa-plus text-primary\" style=\"font-size: 20px;\"></i>\r\n            </a>  \r\n            &nbsp;\r\n            <a href=\"#\" ng-click=\"$ctrl.resetLineItem(item)\" title=\"Reset\">\r\n              <i class=\"fa fa-eraser text-warning\" style=\"font-size: 20px;\"></i>\r\n            </a>                        \r\n          </td>\r\n        </tr>        \r\n      </tbody>\r\n    </table>\r\n  </fieldset>    \r\n\r\n  <fieldset class=\"mt-20 rounded\">\r\n    <h3>Invoice Payments</h3>\r\n    <button class=\"btn btn-primary\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Issued\" ng-click=\"$ctrl.showAddPaymentModal()\">\r\n      <i class=\"fa fa-plus\"></i> Add Payment\r\n    </button>  \r\n    <button class=\"btn btn-default\" ng-if=\"$ctrl.invoice.invoiceId\" ng-click=\"$ctrl.printPaymentReceipt()\">\r\n      Print Payment Receipt\r\n      <i class=\"fa fa-print\"></i>                                \r\n    </button>\r\n    <div block-ui=\"invoicePayments\">\r\n      <table class=\"table table-bordered table-hover table-striped\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"col-md-2\">Payment Mode</th>\r\n            <th class=\"col-md-2\">Timestamp</th>\r\n            <th class=\"col-md-1\">Amount (&euro;)</th>\r\n            <th class=\"col-md-2\">Received By</th>\r\n            <th class=\"col-md-4\">Comments</th>\r\n            <th class=\"col-md-1\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Issued\">&nbsp;</th>                  \r\n          </tr>\r\n        </thead>\r\n        <tbody>      \r\n          <tr ng-repeat=\"item in $ctrl.invoice.payments | orderBy:'timeStamp'\">\r\n            <td class=\"col-md-2\">{{item.paymentMode}}</td>\r\n            <td class=\"col-md-2\">{{item.timeStamp| date : 'dd-MMMM-yyyy'}}</td>\r\n            <td class=\"col-md-1\">{{item.amount | number:2}}</td>\r\n            <td class=\"col-md-2\">{{item.receivedBy}}</td>\r\n            <td class=\"col-md-4\">{{item.comments}}</td>\r\n            <td class=\"col-md-1 text-center\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Issued\">\r\n              <a href=\"#\" ng-click=\"$ctrl.showEditPaymentModal(item)\" title=\"Edit\">\r\n                <i class=\"fa fa-pencil text-default\" style=\"font-size: 20px;\"></i>\r\n              </a> \r\n              &nbsp;\r\n              <a href=\"#\" ng-click=\"$ctrl.showDeletePaymentModal(item)\" title=\"Delete\">\r\n                <i class=\"fa fa-trash text-danger\" style=\"font-size: 20px;\"></i>\r\n              </a>  \r\n          </tr>              \r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </fieldset>     \r\n\r\n  <fieldset class=\"mt-20 rounded\">\r\n    <h3>Invoice Totals</h3>\r\n\r\n    <div class=\"row\" ng-show1=\"$ctrl.invoice.contactId\" block-ui=\"invoicesManagement\">      \r\n      <div class=\"col-md-12\">\r\n        <dl class=\"dl-horizontal\">\r\n            <dt>Net:</dt>\r\n            <dd>\r\n              {{$ctrl.invoice.net | currency : '&euro;' : 2}}\r\n            </dd>\r\n        </dl>\r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Discount:</dt>\r\n          <dd>\r\n            <a href=\"#\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\" ng-click=\"$ctrl.editDiscount()\">\r\n              <i class=\"fa fa-pencil text-default\" style=\"font-size: 20px;\"></i>\r\n            {{$ctrl.invoice.discount | currency : '&euro;' : 2}}          \r\n            </a>\r\n            <span ng-if=\"$ctrl.invoice.status !== $ctrl.enums.INVOICE_STATUS.Draft\">\r\n              {{$ctrl.invoice.discount | currency : '&euro;' : 2}}  \r\n          </dd>\r\n        </dl> \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Standard VAT (23%):</dt>\r\n          <dd>\r\n            {{$ctrl.invoice.standardVat | currency : '&euro;' : 2}}\r\n          </dd>\r\n        </dl>  \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Reduced VAT (13%):</dt>\r\n          <dd>\r\n            {{$ctrl.invoice.reducedVat | currency : '&euro;' : 2}}\r\n          </dd>\r\n        </dl>   \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Total:</dt>\r\n          <dd>\r\n            {{$ctrl.invoice.total | currency : '&euro;' : 2}}\r\n          </dd>\r\n        </dl> \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Balance:</dt>\r\n          <dd>\r\n            {{$ctrl.invoice.balance | currency : '&euro;' : 2}}\r\n          </dd>\r\n        </dl>         \r\n        <dl class=\"dl-horizontal\">\r\n          <dt>Notes:</dt>\r\n          <dd>\r\n            <textarea class=\"form-control\" rows=\"3\" ng-model=\"$ctrl.invoice.notes\" ng-if=\"$ctrl.invoice.status === $ctrl.enums.INVOICE_STATUS.Draft\" maxlength=\"200\"></textarea>\r\n            <p class=\"form-control-static\" ng-if=\"$ctrl.invoice.status !== $ctrl.enums.INVOICE_STATUS.Draft\">{{$ctrl.invoice.notes}}</p>\r\n          </dd>\r\n        </dl>      \r\n    </div>\r\n\r\n  </fieldset>   \r\n</div>"

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _appMisc = __webpack_require__(956);
	
	var _lodash = __webpack_require__(498);
	
	var _dialogConfig = __webpack_require__(678);
	
	var _dialogConfig2 = _interopRequireDefault(_dialogConfig);
	
	var _dialogButton = __webpack_require__(676);
	
	var _dialogButton2 = _interopRequireDefault(_dialogButton);
	
	var _dialogColor = __webpack_require__(677);
	
	var _dialogColor2 = _interopRequireDefault(_dialogColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditInvoiceController = function () {
	  EditInvoiceController.$inject = ["appConfig", "authService", "$stateParams", "$scope", "enums", "$ngConfirm", "accountingService", "loadingService", "contactService", "dialogService", "growl", "utilsService", "$state", "printService"];
	  function EditInvoiceController(appConfig, authService, $stateParams, $scope, enums, $ngConfirm, accountingService, loadingService, contactService, dialogService, growl, utilsService, $state, printService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, EditInvoiceController);
	    this.authService = authService;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.enums = enums;
	    this.$ngConfirm = $ngConfirm;
	    this.accountingService = accountingService;
	    this.loadingService = loadingService;
	    this.contactService = contactService;
	    this.dialogService = dialogService;
	    this.growl = growl;
	    this.utilsService = utilsService;
	    this.$state = $state;
	    this.printService = printService;
	
	    this.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + this.authService.authData.currentLocation.key + '/';
	    this.searchProductUrl = appConfig.apiServiceBaseUri + 'api/accounting/searchproduct/' + this.authService.authData.currentLocation.key + '/';
	
	    this.contactSelected = this.contactSelected.bind(this);
	    this.contactSearched = this.contactSearched.bind(this);
	    this.poructSelected = this.poructSelected.bind(this);
	    this.productSearched = this.productSearched.bind(this);
	
	    this.vatRates = [{ id: '0', name: '0%' }, { id: '13.5', name: '13.5%' }, { id: '23', name: '23%' }];
	
	    this.$scope.paymentModes = [{ id: null, name: 'Select Payment Method' }, { id: 1, name: 'Cash' }, { id: 2, name: 'Card' }, { id: 3, name: 'EFT' }, { id: 4, name: 'Other' }, { id: 5, name: 'Cheque' }];
	
	    this.invoice = {};
	    this.createNewContact = false;
	    this.selectedContact = null;
	    this.tempLineItem = {};
	
	    this.contactTypes = (0, _appMisc.convertEnumToKeyValueList)(this.enums.CONTACT_TYPE, false);
	    this.showInvDatePopup = false;
	
	    this.loadInvoice();
	  }
	
	  // #region Contact
	
	  (0, _createClass3.default)(EditInvoiceController, [{
	    key: 'contactSearched',
	    value: function contactSearched(data) {
	      this.createNewContact = data.length === 0;
	      return data;
	    }
	  }, {
	    key: 'contactSelected',
	    value: function contactSelected(item) {
	      if (item) {
	        this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');
	        this.invoice.contactId = item.originalObject.contactId;
	        this.selectedContact = {
	          contactType: item.originalObject.contactTypeId,
	          contactPerson: {
	            firstName: item.originalObject.firstName,
	            lastName: item.originalObject.lastName
	          },
	          phone: item.originalObject.phone,
	          email: item.originalObject.email,
	          address: {
	            line1: item.originalObject.addressLine1,
	            line2: item.originalObject.addressLine2,
	            line3: item.originalObject.addressLine3,
	            zip: item.originalObject.zip
	          }
	        };
	      }
	    }
	  }, {
	    key: 'clearContact',
	    value: function clearContact() {
	      this.invoice.contactId = null;
	      this.selectedContact = null;
	    }
	  }, {
	    key: 'showNewContact',
	    value: function showNewContact() {
	      var _this = this;
	
	      this.$scope.errMsg = '';
	
	      this.$scope.contact = {
	        contactType: this.enums.CONTACT_TYPE.Customer
	      };
	
	      this.$scope.contactTypes = this.contactTypes;
	
	      this.createDialog = this.$ngConfirm({
	        title: 'Create Contact',
	        contentUrl: 'templates/contact/editContactTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this.validateContact();
	
	              if (valid) {
	                _this.loadingService.showLoading('customerManagement', 'Creating Contact ...');
	
	                _this.accountingService.createContact(_this.$this.authService.authData.currentLocation.key, _this.$scope.contact).then(function (response) {
	                  _this.invoice.contactId = response.data;
	                  _this.selectedContact = {
	                    contactType: _this.$scope.contact.contactType,
	                    contactPerson: {
	                      firstName: _this.$scope.contact.firstName,
	                      lastName: _this.$scope.contact.lastName
	                    },
	                    address: {
	                      line1: _this.$scope.contact.line1,
	                      line2: _this.$scope.contact.line2,
	                      line3: _this.$scope.contact.line3,
	                      zip: _this.$scope.contact.zip
	                    },
	                    phone: _this.$scope.contact.phone,
	                    email: _this.$scope.contact.email
	                  };
	                  _this.createDialog.close();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this.loadingService.hideLoading('customerManagement');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	
	    //Need to fix
	
	  }, {
	    key: 'showEditContact',
	    value: function showEditContact(contact) {
	      var _this2 = this;
	
	      var ctrl = this;
	      this.$scope.errMsg = '';
	
	      this.$scope.contact = {
	        contactType: contact.contactType,
	        firstName: contact.contactPerson.firstName,
	        lastName: contact.contactPerson.lastName,
	        phone: contact.phone,
	        email: contact.email,
	        line1: contact.address.line1,
	        line2: contact.address.line2,
	        line3: contact.address.line3,
	        zip: contact.address.zip
	      };
	
	      this.$scope.contactTypes = this.contactTypes;
	
	      this.editDialog = this.$ngConfirm({
	        title: 'Edit Contact',
	        contentUrl: 'templates/contact/editContactTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this2.validateContact();
	
	              if (valid) {
	                _this2.loadingService.showLoading('customerManagement', 'Updating Contact ...');
	
	                _this2.accountingService.editContact(_this2.authService.authData.currentLocation.key, _this2.invoice.contactId, _this2.$scope.contact).then(function (response) {
	                  _this2.selectedContact = {
	                    contactType: ctrl.$scope.contact.contactType,
	                    contactPerson: {
	                      firstName: ctrl.$scope.contact.firstName,
	                      lastName: ctrl.$scope.contact.lastName
	                    },
	                    address: {
	                      line1: ctrl.$scope.contact.line1,
	                      line2: ctrl.$scope.contact.line2,
	                      line3: ctrl.$scope.contact.line3,
	                      zip: ctrl.$scope.contact.zip
	                    },
	                    phone: ctrl.$scope.contact.phone,
	                    email: ctrl.$scope.contact.email
	                  };
	                  _this2.editDialog.close();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this2.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this2.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this2.loadingService.hideLoading('customerManagement');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'validateContact',
	    value: function validateContact() {
	      if (!this.$scope.contact.contactType) {
	        this.$scope.errMsg = 'Please select a contact type.';
	        return false;
	      }
	
	      if (!this.$scope.contact.firstName || this.$scope.contact.firstName.length < 2) {
	        this.$scope.errMsg = 'Please enter a first name.';
	        return false;
	      }
	
	      if (!this.$scope.contact.lastName || this.$scope.contact.lastName.length < 2) {
	        this.$scope.errMsg = 'Please enter a last name.';
	        return false;
	      }
	
	      if (!this.$scope.contact.phone) {
	        this.$scope.errMsg = 'Please enter a phone number.';
	        return false;
	      }
	
	      if (this.$scope.contact.email && !this.validateEmail(this.$scope.contact.email)) {
	        this.$scope.errMsg = 'Please enter a valid email address.';
	        return false;
	      }
	
	      if (!this.$scope.contact.line1) {
	        this.$scope.errMsg = 'Please enter an address in line1.';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(email);
	    }
	
	    // #endregion
	
	    // #region Line Items
	
	  }, {
	    key: 'productSearched',
	    value: function productSearched(data) {
	      if (data.length === 0) {
	        this.tempLineItem.title = $('#searchProducts_value').val();
	      }
	
	      return data;
	    }
	  }, {
	    key: 'poructSelected',
	    value: function poructSelected(item) {
	      if (!item) {
	        return;
	      }
	
	      this.$scope.$broadcast('angucomplete-alt:changeInput', 'searchProducts', item.originalObject.title);
	
	      this.tempLineItem.title = item.originalObject.title;
	      this.tempLineItem.quantity = 1;
	      this.tempLineItem.price = item.originalObject.price;
	      this.tempLineItem.vatRate = item.originalObject.vatRate.toString();
	
	      this.updateLineItemTotals();
	    }
	  }, {
	    key: 'updateLineItemTotals',
	    value: function updateLineItemTotals() {
	      this.tempLineItem.net = this.tempLineItem.quantity * this.tempLineItem.price;
	      this.tempLineItem.vat = this.tempLineItem.net * this.tempLineItem.vatRate / 100;
	      this.tempLineItem.total = this.tempLineItem.net + this.tempLineItem.vat;
	    }
	  }, {
	    key: 'addLineItem',
	    value: function addLineItem() {
	      if (!this.validateLineItem()) {
	        return;
	      }
	
	      this.updateLineItemTotals();
	      this.invoice.lineItems.push(this.tempLineItem);
	      this.tempLineItem = {};
	      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchProducts');
	      this.updateInvoiceTotals();
	    }
	  }, {
	    key: 'validateLineItem',
	    value: function validateLineItem() {
	      var _this3 = this;
	
	      if (!this.tempLineItem.title || this.tempLineItem.title.length < 2) {
	        this.dialogService.error('Please enter a title.');
	        return;
	      }
	
	      if (this.invoice.lineItems.find(function (l) {
	        return l.title.toLowerCase() === _this3.tempLineItem.title.toLowerCase() && !l.editMode;
	      })) {
	        this.dialogService.error('This item is already in the invoice.');
	        return;
	      }
	
	      if (!this.tempLineItem.quantity || this.tempLineItem.quantity < 0) {
	        this.dialogService.error('Please enter a quantity.');
	        return;
	      }
	
	      if (!this.tempLineItem.price || this.tempLineItem.price < 0) {
	        this.dialogService.error('Please enter a price.');
	        return;
	      }
	
	      if (!this.tempLineItem.vatRate || this.tempLineItem.vatRate < 0) {
	        this.dialogService.error('Please select a VAT rate.');
	        return;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'removeLineItem',
	    value: function removeLineItem(lineItem) {
	      this.invoice.lineItems = (0, _lodash.without)(this.invoice.lineItems, lineItem);
	      this.updateInvoiceTotals();
	    }
	  }, {
	    key: 'resetLineItem',
	    value: function resetLineItem() {
	      this.tempLineItem = {
	        title: null,
	        quantity: null,
	        price: null,
	        vatRate: null,
	        net: null,
	        vat: null,
	        total: null
	      };
	
	      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchProducts');
	    }
	  }, {
	    key: 'editLineItem',
	    value: function editLineItem(lineItem) {
	      this.tempLineItem = {
	        title: lineItem.title,
	        quantity: lineItem.quantity,
	        price: lineItem.price,
	        vatRate: lineItem.vatRate.toString(),
	        net: lineItem.net,
	        vat: lineItem.vat,
	        total: lineItem.total
	      };
	      lineItem.editMode = true;
	      this.editMode = true;
	    }
	  }, {
	    key: 'updateLineItem',
	    value: function updateLineItem(lineItem) {
	      if (!this.validateLineItem()) {
	        return;
	      }
	
	      lineItem.title = this.tempLineItem.title;
	      lineItem.quantity = this.tempLineItem.quantity;
	      lineItem.price = this.tempLineItem.price;
	      lineItem.vatRate = this.tempLineItem.vatRate;
	      lineItem.net = this.tempLineItem.net;
	      lineItem.vat = this.tempLineItem.vat;
	      lineItem.total = this.tempLineItem.total;
	
	      lineItem.editMode = false;
	      this.editMode = false;
	      this.updateLineItemTotals();
	      this.resetLineItem();
	      this.updateInvoiceTotals();
	    }
	  }, {
	    key: 'cancelEditLineItem',
	    value: function cancelEditLineItem(lineItem) {
	      lineItem.editMode = false;
	      this.editMode = false;
	      this.resetLineItem();
	    }
	
	    // #endregion
	
	    // #region Invoice
	
	  }, {
	    key: 'loadInvoice',
	    value: function loadInvoice() {
	      var _this4 = this;
	
	      if (!this.$stateParams.invoiceId) {
	        this.invoice = {
	          status: this.enums.INVOICE_STATUS.Draft,
	          statusName: (0, _appMisc.getEnumPropName)(this.enums.INVOICE_STATUS, this.enums.INVOICE_STATUS.Draft),
	          lineItems: [],
	          invoiceDate: new Date(),
	          dueDate: new Date(),
	          discount: 0,
	          net: null,
	          standardVat: null,
	          reducedVat: null,
	          total: null,
	          notes: null,
	          balance: null,
	          payments: []
	        };
	      } else {
	        this.loadingService.showLoading('invoicesManagement', 'Loading Invoice ...');
	        this.accountingService.getInvoice(this.$stateParams.invoiceId).then(function (response) {
	          _this4.invoice = response.data;
	          _this4.invoice.invoiceDate = _this4.utilsService.getDatePart(_this4.invoice.invoiceDate);
	          _this4.invoice.dueDate = _this4.utilsService.getDatePart(_this4.invoice.dueDate);
	          _this4.invoice.lineItems = (0, _lodash.map)(_this4.invoice.lineItems, function (item) {
	            item.total = item.net + item.vat;
	            return item;
	          });
	
	          _this4.selectedContact = {
	            contactType: _this4.invoice.contactType,
	            contactPerson: {
	              firstName: _this4.invoice.firstName,
	              lastName: _this4.invoice.lastName
	            },
	            phone: _this4.invoice.contactPhone,
	            email: _this4.invoice.contactEmail,
	            address: {
	              line1: _this4.invoice.contactAddress1,
	              line2: _this4.invoice.contactAddress2,
	              line3: _this4.invoice.contactAddress3,
	              zip: _this4.invoice.contactZip
	            }
	          };
	
	          _this4.updateInvoiceTotals();
	        }).catch(function (err) {
	          _this4.growl.error('Error loading invoice.' + err.data.message, { ttl: 5000 });
	        }).finally(function () {
	          _this4.loadingService.hideLoading('invoicesManagement');
	        });
	      }
	    }
	  }, {
	    key: 'updateInvoiceTotals',
	    value: function updateInvoiceTotals() {
	      this.invoice.net = this.invoice.lineItems.reduce(function (sum, item) {
	        return sum + item.net;
	      }, 0);
	      this.invoice.standardVat = this.invoice.lineItems.filter(function (item) {
	        return item.vatRate.toString() === '23';
	      }).reduce(function (sum, item) {
	        return sum + item.vat;
	      }, 0);
	      this.invoice.reducedVat = this.invoice.lineItems.filter(function (item) {
	        return item.vatRate.toString() === '13.5';
	      }).reduce(function (sum, item) {
	        return sum + item.vat;
	      }, 0);
	      this.invoice.total = this.invoice.net + this.invoice.standardVat + this.invoice.reducedVat;
	
	      if (this.invoice.discount && this.invoice.discount > 0) {
	        this.invoice.total -= this.invoice.discount;
	      }
	
	      this.invoice.balance = this.invoice.total - this.invoice.payments.reduce(function (sum, payment) {
	        return sum + payment.amount;
	      }, 0);
	    }
	  }, {
	    key: 'showDatePopup',
	    value: function showDatePopup(id) {
	      this.dtPopups[id] = true;
	    }
	  }, {
	    key: 'getInvoiceEditViewModel',
	    value: function getInvoiceEditViewModel() {
	      return {
	        invoiceId: this.invoice.invoiceId,
	        invoiceDate: this.invoice.invoiceDate,
	        dueDate: this.invoice.dueDate,
	        contactId: this.invoice.contactId,
	        net: this.invoice.net,
	        discount: this.invoice.discount,
	        total: this.invoice.total,
	        standardVat: this.invoice.standardVat,
	        reducedVat: this.invoice.reducedVat,
	        notes: this.invoice.notes,
	        lineItems: this.invoice.lineItems.map(function (item) {
	          return item;
	        })
	      };
	    }
	  }, {
	    key: 'validateSaveDraft',
	    value: function validateSaveDraft() {
	      if (!this.invoice.contactId) {
	        this.dialogService.error('Please select a contact.');
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'saveDraft',
	    value: function saveDraft() {
	      var _this5 = this;
	
	      if (!this.validateSaveDraft()) {
	        return;
	      }
	
	      this.loadingService.showLoading('invoicesManagement', 'Saving Invoice Draft ...');
	
	      this.accountingService.saveDraft(this.authService.authData.currentLocation.key, this.getInvoiceEditViewModel()).then(function (response) {
	        _this5.invoice.invoiceId = response.data;
	        _this5.growl.success('Invoice draft saved successfully.', { ttl: 5000 });
	      }).catch(function (err) {
	        _this5.growl.error('Error saving draft.' + err.data.message, { ttl: 5000 });
	      }).finally(function () {
	        _this5.loadingService.hideLoading('invoicesManagement');
	      });
	    }
	  }, {
	    key: 'editDiscount',
	    value: function editDiscount() {
	      var _this6 = this;
	
	      //Convert this into dialog service
	      this.$ngConfirm({
	        title: 'Edit Discount',
	        content: '<div class="form-group">\n                  <label for="discount">Discount Amount</label>\n                  <input type="number" class="form-control" id="discount" ng-model="discount" min="0" step="0.01">\n                </div>',
	        scope: this.$scope,
	        buttons: {
	          confirm: {
	            text: 'Save',
	            btnClass: 'btn-success',
	            action: function action() {
	              if (_this6.$scope.discount < 0) {
	                _this6.dialogService.error('Discount cannot be negative.');
	                return false;
	              }
	              _this6.invoice.discount = _this6.$scope.discount || 0;
	              _this6.updateInvoiceTotals();
	            }
	          },
	          cancel: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to delete this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, this.deleteInvoice.bind(this)), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'deleteInvoice',
	    value: function deleteInvoice() {
	      var _this7 = this;
	
	      this.loadingService.showLoading('invoicesManagement', 'Deleting Invoice ...');
	      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Deleted).then(function () {
	        _this7.growl.success('Invoice deleted successfully.', { ttl: 5000 });
	        _this7.$state.go('invoicesManagement.container', { locationId: _this7.authService.authData.currentLocation.key }, { reload: true });
	      }).catch(function (err) {
	        _this7.growl.error('Error deleting invoice.' + err.data.message, { ttl: 5000 });
	      }).finally(function () {
	        _this7.loadingService.hideLoading('invoicesManagement');
	      });
	    }
	  }, {
	    key: 'issue',
	    value: function issue() {
	      if (this.invoice.lineItems.length === 0) {
	        this.dialogService.error('Cannot issue invoice without line items.');
	        return;
	      }
	
	      this.dialogService.double(_dialogConfig2.default.primary('Are you sure you want to issue this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.PRIMARY, this.issueInvoice.bind(this)), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'issueInvoice',
	    value: function issueInvoice() {
	      var _this8 = this;
	
	      this.loadingService.showLoading('invoicesManagement', 'Issuing Invoice ...');
	      this.accountingService.issueInvoice(this.invoice.invoiceId).then(function (response) {
	        _this8.invoice.status = _this8.enums.INVOICE_STATUS.Issued;
	        _this8.invoice.statusName = (0, _appMisc.getEnumPropName)(_this8.enums.INVOICE_STATUS, _this8.enums.INVOICE_STATUS.Issued);
	        _this8.invoice.invoiceNumber = response.data;
	        _this8.growl.success('Invoice issued successfully.', { ttl: 5000 });
	      }).catch(function (err) {
	        if (err.status === 400) {
	          _this8.dialogService.error('Error issuing invoice: ' + err.data[0].value);
	        } else {
	          _this8.growl.error('Error issuing invoice.' + err.data.message, { ttl: 5000 });
	        }
	      }).finally(function () {
	        _this8.loadingService.hideLoading('invoicesManagement');
	      });
	    }
	  }, {
	    key: 'paid',
	    value: function paid() {
	      this.dialogService.double(_dialogConfig2.default.success('Are you sure you want to mark this invoice as paid?'), _dialogButton2.default.new('Yes', _dialogColor2.default.GREEN, this.markAsPaid.bind(this)), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'markAsPaid',
	    value: function markAsPaid() {
	      var _this9 = this;
	
	      this.loadingService.showLoading('invoicesManagement', 'Marking Invoice as Paid ...');
	      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Paid).then(function () {
	        _this9.invoice.status = _this9.enums.INVOICE_STATUS.Paid;
	        _this9.invoice.statusName = (0, _appMisc.getEnumPropName)(_this9.enums.INVOICE_STATUS, _this9.enums.INVOICE_STATUS.Paid);
	        _this9.growl.success('Invoice marked as paid successfully.', { ttl: 5000 });
	      }).catch(function (err) {
	        _this9.growl.error('Error marking invoice as paid.' + err.data.message, { ttl: 5000 });
	      }).finally(function () {
	        _this9.loadingService.hideLoading('invoicesManagement');
	      });
	    }
	  }, {
	    key: 'void',
	    value: function _void() {
	      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to void this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, this.voidInvoice.bind(this)), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'voidInvoice',
	    value: function voidInvoice() {
	      var _this10 = this;
	
	      this.loadingService.showLoading('invoicesManagement', 'Voiding Invoice ...');
	      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Voided).then(function () {
	        _this10.invoice.status = _this10.enums.INVOICE_STATUS.Voided;
	        _this10.invoice.statusName = (0, _appMisc.getEnumPropName)(_this10.enums.INVOICE_STATUS, _this10.enums.INVOICE_STATUS.Voided);
	        _this10.growl.success('Invoice voided successfully.', { ttl: 5000 });
	      }).catch(function (err) {
	        _this10.growl.error('Error voiding invoice.' + err.data.message, { ttl: 5000 });
	      }).finally(function () {
	        _this10.loadingService.hideLoading('invoicesManagement');
	      });
	    }
	  }, {
	    key: 'printInvoice',
	    value: function printInvoice() {
	      this.printService.printInvoice(this.invoice.invoiceId);
	    }
	  }, {
	    key: 'emailInvoice',
	    value: function emailInvoice() {
	      var _this11 = this;
	
	      if (!this.selectedContact.email) {
	        this.dialogService.error('Cannot email invoice. No email address provided for contact.');
	        return;
	      }
	
	      //Ask user if they want to cc themselves
	      this.dialogService.triple(_dialogConfig2.default.primary('Do you want to CC yourself on this invoice?', 'Send Email'), _dialogButton2.default.new('Yes', _dialogColor2.default.PRIMARY, function () {
	        return _this11.sendEmail(true);
	      }), _dialogButton2.default.new('No', _dialogColor2.default.DARK, function () {
	        return _this11.sendEmail(false);
	      }), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'sendEmail',
	    value: function sendEmail(cc) {
	      var _this12 = this;
	
	      this.loadingService.showLoading('invoicesManagement', 'Emailing Invoice ...');
	      this.printService.emailInvoice(this.authService.authData.currentLocation.key, this.invoice.invoiceId, cc).then(function () {
	        _this12.growl.success('Invoice email sent successfully.', { ttl: 5000 });
	      }).catch(function (err) {
	        _this12.growl.error('Error sending invoice email.' + (err.data.message + ' ' + err.data.exceptionMessage), { ttl: 5000 });
	      }).finally(function () {
	        _this12.loadingService.hideLoading('invoicesManagement');
	      });
	
	      return true;
	    }
	
	    // #endregion
	
	    // #region Payments
	
	  }, {
	    key: 'showAddPaymentModal',
	    value: function showAddPaymentModal() {
	      var _this13 = this;
	
	      this.$scope.payment = {
	        paymentMode: null,
	        timeStamp: new Date(),
	        amount: null,
	        comments: null
	      };
	
	      this.$scope.errMsg = '';
	
	      this.addPaymentDialog = this.$ngConfirm({
	        title: 'Add Payment',
	        contentUrl: 'templates/accounting/editInvoicePaymentTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this13.validateAddPayment();
	
	              if (valid) {
	                _this13.loadingService.showLoading('invoicePayments', 'Adding payment ...');
	
	                _this13.accountingService.updatePayment(_this13.authService.authData.currentLocation.key, _this13.invoice.invoiceId, _this13.$scope.payment).then(function (response) {
	                  _this13.growl.success('Payment added successfully.', { ttl: 5000 });
	                  _this13.invoice.payments.push({
	                    invoicePaymentId: response.data,
	                    paymentMode: _this13.$scope.paymentModes[_this13.$scope.payment.paymentMode].name,
	                    timeStamp: _this13.$scope.payment.timeStamp,
	                    amount: _this13.$scope.payment.amount,
	                    comments: _this13.$scope.payment.comments,
	                    receivedBy: _this13.authService.authData.firstName + ' ' + _this13.authService.authData.lastName
	                  });
	                  _this13.addPaymentDialog.close();
	                  _this13.updateInvoiceTotals();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this13.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this13.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this13.loadingService.hideLoading('invoicePayments');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showEditPaymentModal',
	    value: function showEditPaymentModal(payment) {
	      var _this14 = this;
	
	      this.$scope.payment = {
	        invoicePaymentId: payment.invoicePaymentId,
	        paymentMode: this.stringToId(payment.paymentMode, this.$scope.paymentModes),
	        timeStamp: this.utilsService.getDatePart(payment.timeStamp),
	        amount: payment.amount,
	        comments: payment.comments
	      };
	
	      this.$scope.errMsg = '';
	
	      this.addPaymentDialog = this.$ngConfirm({
	        title: 'Add Payment',
	        contentUrl: 'templates/accounting/editInvoicePaymentTemplate',
	        typeAnimation: false,
	        columnClass: 'l',
	        scope: this.$scope,
	        buttons: {
	          yes: {
	            text: 'Save Changes',
	            btnClass: 'btn-success',
	            action: function action() {
	              var valid = _this14.validateAddPayment(payment.invoicePaymentId);
	
	              if (valid) {
	                _this14.loadingService.showLoading('invoicePayments', 'Adding payment ...');
	
	                _this14.accountingService.updatePayment(_this14.authService.authData.currentLocation.key, _this14.invoice.invoiceId, _this14.$scope.payment).then(function (response) {
	                  _this14.growl.success('Payment updated successfully.', { ttl: 5000 });
	
	                  payment.paymentMode = _this14.$scope.paymentModes[_this14.$scope.payment.paymentMode].name;
	                  payment.timeStamp = _this14.$scope.payment.timeStamp.toJSON();
	                  payment.amount = _this14.$scope.payment.amount;
	                  payment.comments = _this14.$scope.payment.comments;
	                  payment.receivedBy = _this14.authService.authData.firstName + ' ' + _this14.authService.authData.lastName;
	
	                  _this14.addPaymentDialog.close();
	                  _this14.updateInvoiceTotals();
	                }).catch(function (err) {
	                  switch (err.status) {
	                    case 400:
	                      _this14.$scope.errMsg = err.data[0].value;
	                      break;
	
	                    default:
	                      _this14.$scope.errMsg = err.data.message;
	                      break;
	                  }
	                }).finally(function () {
	                  _this14.loadingService.hideLoading('invoicePayments');
	                });
	              }
	
	              return false;
	            }
	          },
	          no: {
	            text: 'Cancel',
	            btnClass: 'btn-default'
	          }
	        }
	      });
	    }
	  }, {
	    key: 'showDeletePaymentModal',
	    value: function showDeletePaymentModal(payment) {
	      var _this15 = this;
	
	      this.deletePayment.bind(this);
	      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to delete this payment?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, function () {
	        return _this15.deletePayment(payment);
	      }), _dialogButton2.default.cancel());
	    }
	  }, {
	    key: 'deletePayment',
	    value: function deletePayment(payment) {
	      var _this16 = this;
	
	      this.loadingService.showLoading('invoicePayments', 'Deleting payment ...');
	      this.accountingService.deletePayment(this.authService.authData.currentLocation.key, payment.invoicePaymentId).then(function () {
	        _this16.growl.success('Payment deleted successfully.', { ttl: 5000 });
	        _this16.invoice.payments = _this16.invoice.payments.filter(function (p) {
	          return p.invoicePaymentId !== payment.invoicePaymentId;
	        });
	        _this16.updateInvoiceTotals();
	      }).catch(function (err) {
	        switch (err.status) {
	          case 400:
	            _this16.$scope.errMsg = err.data[0].value;
	            break;
	          default:
	            _this16.$scope.errMsg = err.data.message;
	            break;
	        }
	      }).finally(function () {
	        _this16.loadingService.hideLoading('invoicePayments');
	      });
	
	      return true;
	    }
	  }, {
	    key: 'validateAddPayment',
	    value: function validateAddPayment(invoicePaymentId) {
	      this.$scope.errMsg = null;
	
	      if (!this.$scope.payment.paymentMode) {
	        this.$scope.errMsg = 'Please select a payment method.';
	        return false;
	      }
	
	      if (!this.$scope.payment.amount || this.$scope.payment.amount <= 0) {
	        this.$scope.errMsg = 'Please enter a valid amount.';
	        return false;
	      }
	
	      var balance = this.invoice.total - this.invoice.payments.reduce(function (sum, payment) {
	        return sum + payment.amount;
	      }, 0);
	
	      if (invoicePaymentId) {
	        balance += this.invoice.payments.find(function (p) {
	          return p.invoicePaymentId === invoicePaymentId;
	        }).amount;
	      }
	
	      if (this.$scope.payment.amount > balance) {
	        this.$scope.errMsg = 'Payment amount cannot exceed the invoice balance of ' + balance.toFixed(2) + '.';
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'stringToId',
	    value: function stringToId(strName, collection) {
	      if (!strName || !collection) {
	        return null;
	      }
	
	      var item = (0, _lodash.find)(collection, { name: strName });
	      return item ? item.id : null;
	    }
	  }, {
	    key: 'printPaymentReceipt',
	    value: function printPaymentReceipt() {
	      this.printService.printInvoicePaymentReceipt(this.invoice.invoiceId);
	    }
	
	    // #endregion
	
	  }]);
	  return EditInvoiceController;
	}();
	
	exports.default = EditInvoiceController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1881);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./editInvoice.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./editInvoice.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, "#searchContacts_dropdown.angucomplete-dropdown{margin-top:0!important}#searchContacts_dropdown{width:500px}.rounded{border-radius:10px}.mt-20{margin-bottom:40px!important}.text-right{align:right}.text-center{align:center}#searchProducts_dropdown.angucomplete-dropdown{margin-top:0!important}#searchProducts_dropdown{width:500px}", ""]);
	
	// exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(494);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountingService = function () {
	  AccountingService.$inject = ["$http", "appConfig"];
	  function AccountingService($http, appConfig) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AccountingService);
	    this.$http = $http;
	    this.appConfig = appConfig;
	  }
	
	  (0, _createClass3.default)(AccountingService, [{
	    key: 'listProducts',
	    value: function listProducts(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&entityId=' + filterParams.entityId;
	
	      if (filterParams.title) {
	        query += '&title=' + filterParams.title;
	      }
	
	      if (filterParams.createdBy) {
	        query += '&createdBy=' + filterParams.createdBy;
	      }
	
	      if (filterParams.status) {
	        query += '&status=' + filterParams.status;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/listproducts' + query);
	    }
	  }, {
	    key: 'addProduct',
	    value: function addProduct(entityId, product) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/addproduct/' + entityId), product);
	    }
	  }, {
	    key: 'getProduct',
	    value: function getProduct(productId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/getproduct/' + productId));
	    }
	  }, {
	    key: 'editProduct',
	    value: function editProduct(entityId, product) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/editproduct/' + entityId), product);
	    }
	  }, {
	    key: 'updateProductStatus',
	    value: function updateProductStatus(entityId, productId, status) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/updateproductstatus/' + entityId + '/' + productId + '/' + status));
	    }
	  }, {
	    key: 'listInvoices',
	    value: function listInvoices(filterParams) {
	      var query = '';
	
	      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
	      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
	      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
	      query += '&ascending=' + filterParams.pageCriteria.ascending;
	      query += '&entityId=' + filterParams.entityId;
	
	      if (filterParams.number) {
	        query += '&number=' + filterParams.number;
	      }
	
	      if (filterParams.contact) {
	        query += '&contact=' + filterParams.contact;
	      }
	
	      if (filterParams.status) {
	        query += '&status=' + filterParams.status;
	      }
	
	      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/invoice/list' + query);
	    }
	  }, {
	    key: 'createContact',
	    value: function createContact(entityId, contact) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/createcontact/' + entityId), contact);
	    }
	  }, {
	    key: 'editContact',
	    value: function editContact(entityId, contactId, contact) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/editcontact/' + entityId + '/' + contactId), contact);
	    }
	  }, {
	    key: 'saveDraft',
	    value: function saveDraft(entityId, invoice) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/savedraft/' + entityId), invoice);
	    }
	  }, {
	    key: 'getInvoice',
	    value: function getInvoice(invoiceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/get/' + invoiceId));
	    }
	  }, {
	    key: 'updateInvoiceStatus',
	    value: function updateInvoiceStatus(invoiceId, status) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/updatestatus/' + invoiceId + '/' + status));
	    }
	  }, {
	    key: 'issueInvoice',
	    value: function issueInvoice(invoiceId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/issue/' + invoiceId));
	    }
	  }, {
	    key: 'updatePayment',
	    value: function updatePayment(entityId, invoiceId, payment) {
	      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/addpayment/' + entityId + '/' + invoiceId), payment);
	    }
	  }, {
	    key: 'deletePayment',
	    value: function deletePayment(entityId, invoicePaymentId) {
	      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/deletepayment/' + entityId + '/' + invoicePaymentId));
	    }
	  }]);
	  return AccountingService;
	}();
	
	exports.default = AccountingService;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(1884);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(1885);
	
	var _app4 = _interopRequireDefault(_app3);
	
	__webpack_require__(1886);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E',
	  controller: _app4.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

	module.exports = "<navbar2></navbar2>\r\n\r\n<main class1=\"dashboard-main-area\" ng-class=\"{'dashboard-main-area': $ctrl.authService.authData.userId}\">\r\n  <navbar></navbar>\r\n\r\n  <div class=\"app\">\r\n    <div ui-view></div>\r\n  </div>\r\n\r\n</main>\r\n\r\n<div growl></div>"

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(493);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppController = function AppController(authService) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, AppController);
	  this.authService = authService;
	};
	AppController.$inject = ["authService"];
	
	exports.default = AppController;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1887);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".footer{position:absolute;bottom:-100px;width:100%;height:150px;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.modal.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.modal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal-body{font-family:Roboto,sans-serif;padding-bottom:0}.modal-body .row{margin-bottom:5px}.modal-body .row label{padding-top:7px}.modal-body .modal-footer{margin-top:10px;padding-bottom:0}.modal-content{border-radius:0}", ""]);
	
	// exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1897);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--logo-path:\"\";--default-color:#fff;--default-color-hover:#fff;--primary-color:#fff;--primary-color-hover:#fff;--success-color:#fff;--success-color-hover:#fff;--danger-color:#fff;--danger-color-hover:#fff;--topNav-user-text:#fff;--dashboard-odd-panel-mainColor:#fff;--dashboard-odd-panel-gradColor:#fff;--dashboard-even-panel-mainColor:#fff;--dashboard-even-panel-gradColor:#fff;--report-even-row:#fff;--report-even-hover:#fff}@font-face{font-family:Montserrat-Regular;src:url(" + __webpack_require__(1898) + ")}@font-face{font-family:Montserrat-Medium;src:url(" + __webpack_require__(1899) + ")}body{font-family:Montserrat-Regular,arial,sans-serif;font-weight:300;line-height:1.2;color:#000;height:100%;margin:0;overflow:visible}.btn,h1,h2,h3,h4,h5,h6{font-weight:500}.btn{font-size:1.1em;border-radius:7px;padding:8px 13px;box-shadow:none;outline:none;white-space:normal;text-overflow:inherit;overflow:visible;transition:background .3s ease}.btn.btn-default{background-color:var(--default-color);color:#fff;border:0}.btn.btn-default:focus,.btn.btn-default:hover{background-color:var(--default-color-hover)}.btn.btn-primary,.dashboard-welcome-table .radio-btn input:checked~span.btn.btn-outline{background-color:var(--primary-color);color:#000;border-color:#000}.btn.btn-primary:focus,.btn.btn-primary:hover,.dashboard-welcome-table .radio-btn input:checked~span.btn.btn-outline:focus,.dashboard-welcome-table .radio-btn input:checked~span.btn.btn-outline:hover{background-color:var(--primary-color-hover)}.btn.btn-success{background-color:var(--success-color);border-color:#000}.btn.btn-success:focus,.btn.btn-success:hover{background-color:var(--success-color-hover)}.btn.btn-danger{background-color:var(--danger-color);border-color:#000}.btn.btn-danger:focus,.btn.btn-danger:hover{background-color:var(--danger-color-hover)}.btn.btn-outline{border:1px solid #000;color:#000;background-color:transparent}.btn.btn-outline:focus,.btn.btn-outline:hover{background-color:#f4f4f4}.btn.btn-outline .comment-icon{width:24px;height:19px;display:inline-block;background-image:url(" + __webpack_require__(1900) + ");background-size:20px 16px;background-repeat:no-repeat;background-position:0 5px}.mt-0{margin-top:0}.mt-1{margin-top:15px}.mt-2{margin-top:30px}.mt-3{margin-top:60px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:15px}.mb-2{margin-bottom:30px}.mb-3{margin-bottom:60px}.ml-0{margin-left:0}.ml-1{margin-left:15px}.ml-2{margin-left:30px}.ml-3{margin-left:60px}.mr-0{margin-right:0}.mr-1{margin-right:15px}.mr-2{margin-right:30px}.mr-3{margin-right:60px}.pt-1{padding-top:15px}.pt-2{padding-top:30px}.pt-3{padding-top:60px}.pb-1{padding-bottom:15px}.pb-2{padding-bottom:30px}.pb-3{padding-bottom:60px}.pl-1{padding-left:15px}.pl-2{padding-left:30px}.pl-3{padding-left:60px}.pr-1{padding-right:15px}.pr-2{padding-right:30px}.pr-3{padding-right:60px}.dealership{display:inline-block;border:2px solid #000;vertical-align:middle;font-size:1.2em;padding:3px 5px 3px 25px;color:#000;position:relative}.dealership img{position:absolute;left:5px;top:5px;width:9px;height:17px}.dealership a{color:inherit;text-decoration:none}.dealership ul{position:absolute;top:27px;left:-2px;width:200px;list-style:none;margin:0;z-index:99;background-color:#efefef;padding:15px;visibility:hidden;transform-origin:top;transform:scaleY(0);transition:transform .3s ease,visibility .3s ease}.dealership ul li{display:block}.dealership ul li a{display:block;text-transform:uppercase;color:#000;font-size:.85em}.dealership ul li:not(:last-child){margin-bottom:7px;padding-bottom:7px;border-bottom:2px solid rgba(0,0,0,.05)}.dealership ul.active{opacity:1;visibility:visible;transform:scaleY(1)}.dashboard-header{border-bottom:3px solid #000;position:relative;padding:15px 30px 15px 210px}@media (max-width:991px){.dashboard-header{padding-left:170px}}.dashboard-header .logo{position:absolute;top:54px;left:78px;z-index:9999}.dashboard-header .logo2{position:absolute;top:24px;left:6px;z-index:9999}@media (max-width:991px){.dashboard-header .logo{top:6px;left:23px}.dashboard-header .logo img{width:90px;height:auto}}.dashboard-header .dashboard-user{float:left}.dashboard-header .dashboard-user small{color:var(--primary-color);font-size:1.2em;display:block}.dashboard-header .dashboard-user strong{font-size:1.4em;display:block;color:var(--topNav-user-text);font-weight:300}@media (max-width:991px){.dashboard-header .dashboard-user strong{font-size:1.2em}}.dashboard-header .dashboard-nav{float:right}@media (min-width:992px){.dashboard-header .dashboard-nav{padding-top:31px}}.dashboard-header .dashboard-nav ul{margin:0;padding-left:0}.dashboard-header .dashboard-nav ul li{display:inline-block}.dashboard-header .dashboard-nav ul li:not(:last-child){margin-right:30px}.dashboard-header .dashboard-nav ul li a{color:#000;display:block;vertical-align:bottom;text-decoration:none}.dashboard-header .dashboard-nav ul li a img{display:inline-block;vertical-align:bottom;width:50px;height:auto}@media (max-width:991px){.dashboard-header .dashboard-nav ul li a img{width:70px}}.dashboard-header .dashboard-nav ul li a span{display:inline-block;vertical-align:bottom;font-size:1.2em}@media (max-width:991px){.dashboard-header .dashboard-nav ul li a span{display:none}}.dashboard-sidenav{position:absolute;top:0;bottom:0;left:0;width:135px;background-color:var(--default-color);padding:15px;z-index:999}.dashboard-sidenav>ul{margin:0;padding-left:0}.dashboard-sidenav>ul>li{list-style:none;position:relative}.dashboard-sidenav>ul>li:not(:last-child){margin-bottom:30px}.dashboard-sidenav>ul>li>a{color:var(--primary-color)}.dashboard-sidenav>ul>li>a img{display:block;margin:auto;width:50px;height:auto}.dashboard-sidenav>ul>li>a span{text-align:center;font-size:1.1em;margin-top:7px;display:block}.dashboard-sidenav>ul>li ul{display:none;position:absolute;width:150px;top:35%;right:-165px;background-color:#485254;padding-left:0;margin:0}.dashboard-sidenav>ul>li ul.active{display:block;animation:drowdown-slide .3s ease}.dashboard-sidenav>ul>li ul li{display:block;list-style:none}.dashboard-sidenav>ul>li ul li:not(:last-child){border-bottom:2px solid #434d4e}.dashboard-sidenav>ul>li ul li a{display:block;color:#fff;text-transform:uppercase;text-decoration:none;font-size:.9em;padding:10px;transition:background-color .3s ease,color .3s ease}.dashboard-sidenav>ul>li ul li:focus a,.dashboard-sidenav>ul>li ul li:hover a{background-color:var(--primary-color);color:#000}.dashboard-main-area{padding:50px 30px 50px 210px;color:#666;position:relative}.dashboard-main-area .dashboard-title{font-size:2.25em;margin-top:0}.dashboard-main-area .dashboard-subtitle{font-size:1.5em;margin-top:0;border-bottom:1px solid #5f6767;padding-bottom:15px;margin-bottom:15px}.dashboard-main-area .dashboard-seperator{border-top:3px solid #4e5757}.dashboard-main-area .dashboard-seperator-sm{border-top:2px solid #a3a7ac}@media (max-width:1110px){.dashboard-main-area{padding-left:170px}}.dashboard-welcome-table{table-layout:fixed;border-top:0}.dashboard-welcome-table:last-child{margin-bottom:0}.dashboard-welcome-table tbody tr td,.dashboard-welcome-table thead tr th{vertical-align:middle!important}.dashboard-welcome-table span.btn{width:100%;display:block;font-size:1.1em}@media (min-width:992px){.dashboard-welcome-table span.btn{padding-left:30px;padding-right:30px}}@media (max-width:991px){.dashboard-welcome-table span.btn{font-size:.95em;padding-left:10px;padding-right:10px}}.dashboard-welcome-table .radio-btn{display:block}.dashboard-welcome-table input{border:1px solid #000;padding:8px 13px;background-color:transparent;border-radius:7px;width:100%;outline:none}.dashboard-welcome-table input:-moz-placeholder{color:#666}.dashboard-welcome-table input::placeholder{color:#666}.dashboard-welcome-table input::-webkit-input-placeholder{color:#666}.dashboard-welcome-table input:-ms-input-placeholder{color:#666}.person-image label{float:left;display:block}.person-image .img-outline{cursor:pointer;border-radius:7px;border:1px solid #000;transition:border .3s ease;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.person-image input:checked~.img-outline{border-color:var(--primary-color)}.person-image strong{display:block;margin-top:15px;text-align:center}.user-stats-item1{color:var(--default-color);padding-left:30px}.user-stats-item2{color:var(--default-color);padding-left:10px}.dashboard-panel{border:solid #000;border-width:2px 2px 0;padding-bottom:20px}.dashboard-panel:first-child{margin-top:40px}.dashboard-panel:nth-child(odd){background:linear-gradient(180deg,var(--dashboard-odd-panel-mainColor) 0,hsla(0,0%,100%,0));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffe662\",endColorstr=\"#00ffffff\",GradientType=0)}.dashboard-panel:nth-child(odd) .dashboard-panel-heading{background:var(--dashboard-odd-panel-gradColor);background:linear-gradient(180deg,var(--dashboard-odd-panel-gradColor) 0,var(--dashboard-odd-panel-mainColor));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffe660\",endColorstr=\"#ffe247\",GradientType=0)}.dashboard-panel:nth-child(2n){background:linear-gradient(180deg,var(--dashboard-even-panel-mainColor) 0,hsla(0,0%,100%,0));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffe662\",endColorstr=\"#00ffffff\",GradientType=0)}.dashboard-panel:nth-child(2n) .dashboard-panel-heading{background:var(--dashboard-even-panel-gradColor);background:linear-gradient(180deg,var(--dashboard-even-panel-gradColor) 0,var(--dashboard-even-panel-mainColor));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#c2c2b4\",endColorstr=\"#cdccbc\",GradientType=0)}.dashboard-panel .dashboard-panel-heading{cursor:pointer;border:solid #000;border-width:2px 2px 0;border-top-left-radius:15px;border-top-right-radius:15px;display:inline-block;padding:15px;width:360px;height:41px;position:relative;top:-40px;left:-2px;color:#4d4d4d}.dashboard-panel .dashboard-panel-heading h4{font-weight:700;margin:0 0 15px}.dashboard-panel .dashboard-panel-heading small{color:#000;float:right;font-weight:6px!important;margin:0;display:block}.dashboard-panel .dashboard-panel-content .dashboard-panel-content-inner{padding:10px}.errors-panel{padding:20px;position:relative;background-color:#ffe5d8;border-radius:10px;margin:15px 0}.errors-panel .close-btn{position:absolute;right:15px;top:15px;background-color:transparent;padding:0;margin:0;border:0;box-shadow:none;outline:none;font-size:1.5em;color:red}.errors-panel h4{color:#4c3935;text-transform:uppercase;margin-top:0}.errors-panel ul{margin:0;padding-left:0}.errors-panel ul li{padding-left:20px;color:#000;position:relative;font-weight:700;list-style:none}.errors-panel ul li:not(:last-child){margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid rgba(0,0,0,.2)}.errors-panel ul li:before{font-family:Glyphicons Halflings;content:\"\\E014\";color:red;position:absolute;left:0}.w-100{width:100%}.sublabel{margin-top:9px}.panel-heading i{transform:rotate(180deg);transition:transform .3s ease}.panel-heading.collapsed i{transform:rotate(0)}.add-on .input-group-btn>.btn{border-left-width:0;left:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.add-on .form-control:focus{box-shadow:none;border-color:#ccc}@media (min-width:992px){.pull-sm-right{float:right}}@media (max-width:991px){.pull-sm-xs-right{float:right}.mt-tablet{margin-top:30px}.mb-tablet{margin-bottom:30px}}@media (min-width:1200px){.mt-1-desktop-lg{margin-top:15px}}@media (min-width:1200px){.mt-2-desktop-lg{margin-top:30px}}@keyframes drowdown-slide{0%{opacity:0;transform:translateX(-40px)}to{opacity:1;transform:translateX(0)}}.home-header{padding:15px 0 10px}.home-header .container{position:relative}.home-header .logo{position:absolute;top:37px;left:15px}.home-header .home-nav{float:right}.home-header .home-nav ul{margin:0;padding-left:0;float:left}.home-header .home-nav ul li{float:left;list-style:none;width:92px;height:94px;background:url(" + __webpack_require__(1901) + ") no-repeat}.home-header .home-nav ul li a{display:block;padding:34px 0;text-align:center;font-size:.9em;color:#000;font-weight:500}.home-banner{background:url(" + __webpack_require__(1902) + ") no-repeat;background-size:50% auto;border-top:2px solid #000}.home-banner h2{font-weight:500;color:var(--primary-color);text-shadow:0 0 5px rgba(0,0,0,.9);font-size:2.5em;margin-top:0}.home-banner hr{border-top:1px #000}.home-banner .home-banner-content{width:50%;margin-left:auto;padding-top:50px;padding-bottom:50px}.form-horizontal .control-label.text-left{text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c46095118380d38f12e67c916b427f9.ttf";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a98626e1aef6ceba5dfc1ee7112e235a.ttf";

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAABe0lEQVRIicXWPUscURTG8d/uRlNoghDsRCsrmxCIkEZIYZsihTaKYGVjY+MXsBLS2guBQEy+gqghJgaSiGIIQXzDRrEQC19hTXF3YFlmzI6Z2X3gaaY4/3vm3HvOKahPXRjEC/ShBx1owxnOsYPf+IxF7NUZO1atGMUnlHGbwmWsYrwSJ5WGsJsSmOR9DNcDbcf7jKC1/lCJH6sn+J4TOPI6OmvBrUJt8wRH/oqH1fCZBoEjz0bgLlw2GH6D7hKm8bK2DjmrWDmAb/c4eRb+WRA61KOcM43TaQHXaGkC/LqI4yaA4aiItSbB14p41yT4AjzApsbe9C3huSHM6asGgW/QX/sbxqWf22ldxkRSHUZwkRP4EmNJ4EjPhNGXJXgDz/8FjvQqI+gBJqVsYv+zzRxivpJA6S5IIeZbL34JTzBOy3iLx8IScosTIcs/ws52L5WwIvmmvpHjHJhLAG9hIC8oTMVAv+C1qm6Uparr+lSYcD+whI/YzgMa6S/p6pTlYiwGPAAAAABJRU5ErkJggg=="

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f0a77408e5a203e01ef3f1024ab1485.png";

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1904);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(342)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./form.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./form.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(336)();
	// imports
	
	
	// module
	exports.push([module.id, ".checkbox label,.radio label{padding-left:25px}input[type=checkbox]{margin:2px 0 0}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{-webkit-appearance:none;margin-left:-25px}.checkbox.no-margin input[type=checkbox]{margin-left:0}.checkbox-inline input[type=checkbox]:after,.checkbox input[type=checkbox]:after,.radio-inline input[type=radio]:after,.radio input[type=radio]:after{border-color:rgba(0,0,0,.54)}.checkbox{color:#333}.checkbox-inline input[type=checkbox]:disabled:after,.checkbox input[type=checkbox]:disabled:after,.radio-inline input[type=radio]:disabled:after,.radio input[type=radio]:disabled:after{border-color:rgba(0,0,0,.26)}.checkbox-inline input[type=checkbox]:focus,.checkbox input[type=checkbox]:focus,.radio-inline input[type=radio]:focus,.radio input[type=radio]:focus{outline:none}input[type=radio]{margin:3px 0 0}.checkbox-inline input[type=checkbox]:after,.checkbox input[type=checkbox]:after{border:2px solid;border-radius:2px;content:\"\";display:block;height:18px;transition:.24s;width:18px}.checkbox-inline input[type=checkbox]:checked:before,.checkbox input[type=checkbox]:checked:before{transform:rotate(45deg);position:absolute;left:6px;top:0;display:table;width:6px;height:12px;border:2px solid #fff;border-top:0;border-left:0;content:\"\"}.checkbox-inline input[type=checkbox]:checked:after,.checkbox input[type=checkbox]:checked:after{background-color:#0c84e4;border-color:#0c84e4}.checkbox-inline input[type=checkbox]:disabled:checked:after,.checkbox input[type=checkbox]:disabled:checked:after{background-color:rgba(0,0,0,.26);border-color:transparent}.radio-inline input[type=radio]:after,.radio-inline input[type=radio]:before,.radio input[type=radio]:after,.radio input[type=radio]:before{content:\"\";border-radius:50%;display:block;height:16px;width:16px;transition:.24s}.radio-inline input[type=radio]:after,.radio input[type=radio]:after{border:2px solid}.radio-inline input[type=radio]:checked:after,.radio input[type=radio]:checked:after{border-color:#0c84e4}.radio-inline input[type=radio]:before,.radio input[type=radio]:before{background-color:#0c84e4;position:absolute;top:0;left:0;transform:scale(0)}.radio-inline input[type=radio]:checked:before,.radio input[type=radio]:checked:before{transform:scale(.55)}.radio-inline input[type=radio]:disabled:checked:after,.radio input[type=radio]:disabled:checked:after{border-color:rgba(0,0,0,.26)}.radio-inline input[type=radio]:disabled:checked:before,.radio input[type=radio]:disabled:checked:before{background-color:rgba(0,0,0,.26)}", ""]);
	
	// exports


/***/ }),
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var enquiryNotificationTemplate = "\n<div class=\"ui-notification\">\n  <h3>New Enquiry Received</h3>\n  <div class=\"message\">\n    Please choose from one of the following options\n    \n    <a class=\"btn btn-success\" ng-click=\"enquiryAcceptedByUser(enquiryId, senderId)\">Accept</a>\n    <a class=\"btn btn-warning\" ng-click=\"enquiryHeldByUser(enquiryId, senderId)\">Hold</a>\n    <a class=\"btn btn-danger\" ng-click=\"enquiryRejectedByUser(enquiryId, senderId)\">Reject</a>\n  </div>\n</div>\n";
	
	exports.default = enquiryNotificationTemplate;

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var existingEnquiryTemplate = "\n<div class=\"ui-notification\">\n  <h3>{{header}}</h3>\n  <div class=\"message\">\n    {{msgBody}}\n    \n    <br />\n    <a class=\"btn btn-success\" ng-click=\"enquiryAcceptedByUser(enquiryId, senderId)\">Accept</a>\n    <a class=\"btn btn-warning\" ng-click=\"enquiryHeldByUser(enquiryId, senderId)\">Hold</a>\n    <a class=\"btn btn-danger\" ng-click=\"enquiryRejectedByUser(enquiryId, senderId)\">Reject</a>\n  </div>\n</div>\n";
	
	exports.default = existingEnquiryTemplate;

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sendMessageTemplate = "\n<div class=\"ui-notification\">\n  <h3>{{header}}</h3>\n  <div class=\"message\">\n    {{msg}} \n  </div>\n</div>\n";
	
	exports.default = sendMessageTemplate;

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var webEnquiriesCreatedTemplate = "\n<div class=\"ui-notification\">\n  <h3>Web Enquiries Created</h3>\n  <div class=\"message\">\n    {{count}} new web enquiries received. Click on to go do Dashboard\n    <br />  \n\n    <a class=\"btn btn-success\" ui-srefx=\"dashboard\" ng-click=\"viewDashoard()\">View Dashboard</a>\n  </div>\n</div>\n";
	
	exports.default = webEnquiriesCreatedTemplate;

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var enquiryFromWebEnquiryTemplate = "\n<div class=\"ui-notification\">\n  <h3>New Enquiry Received</h3>\n  <div class=\"message\">\n    You have been assigned a new Web Enquiry by {{sender}}\n    <br />  \n\n    <a class=\"btn btn-success\" ui-sref=\"enquiryEdit({enquiryId: {{enquiryId}}})\">View</a>\n  </div>\n</div>\n";
	
	exports.default = enquiryFromWebEnquiryTemplate;

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

	module.exports = "Please select a Sales Rep\r\n\r\n<select\r\n    style=\"margin-top: 20px;\"\r\n    class=\"form-control\"\r\n    ng-options=\"(item.firstName + ' ' + item.lastName) for item in locationUsers track by item.userId\"\r\n    ng-model=\"selectedUser\">\r\n</select>"

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <b>Contact</b>\r\n        <ul>\r\n            <li>Name: {{data.contact.name}}</li>\r\n            <li>Phone: {{data.contact.phone}}</li>\r\n            <li>Email: {{data.contact.email}}</li>\r\n        </ul>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <b>Vehicle</b>\r\n        <ul>\r\n            <li>Registration: {{data.vehicle.registration}}</li>\r\n            <li>Make/Model: {{data.vehicle.brand}} {{data.vehicle.brandModel}}</li>\r\n            <li>Variant: {{data.vehicle.variant}}</li>\r\n            <li>Price: {{data.vehicle.price | currency:'&euro;':2 }}</li>\r\n        </ul>\r\n    </div>    \r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <b>Finance</b>\r\n        <ul>\r\n            <li>Product: {{data.finance.type}}</li>\r\n            <li>Term: {{data.finance.term}}</li>\r\n            <li>Rate: {{data.finance.rate}}</li>\r\n            <li>Monthly: {{data.finance.monthly | currency:'&euro;':2 }}</li>\r\n        </ul>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <b>Notes ({{data.notes.length}})</b> <br />\r\n        {{data.notes.length ? data.notes[data.notes.length - 1].text : ''}}\r\n    </div>    \r\n</div>"

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\">\r\n\r\n    <div class=\"form-horizontal\">\r\n        <div class=\"alert\" ng-show1=\"errMsg !== ''\" ng-class=\"{'alert-danger': errMsg !== ''}\">\r\n                {{errMsg}}\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-9\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\">\r\n                        <label>Trigger</label>\r\n                    </div>\r\n        \r\n                    <div class=\"col-md-9 ph10 mb5\">\r\n                        <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.id as item.name for item in autoPromiseTriggers\"\r\n                            ng-model=\"autoPromise.autopromiseTrigger\">\r\n                        </select>\r\n        \r\n                    </div>\r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\">\r\n                        <label>Due In #</label>\r\n                    </div>\r\n        \r\n                    <div class=\"col-md-9 ph10 mb5\">\r\n                        <input type=\"number\" class=\"form-control\" placeholder=\"Due In\" ng-model=\"autoPromise.timespan\" />\r\n                    </div>\r\n                </div>\r\n        \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\">\r\n                        <label>Due In</label>\r\n                    </div>\r\n        \r\n                    <div class=\"col-md-9 ph10 mb5\">\r\n                        <select\r\n                            class=\"form-control\"\r\n                            ng-options=\"item.id as item.name for item in timeSpanTypes\"\r\n                            ng-model=\"autoPromise.timespanType\">\r\n                        </select>\r\n                    </div>\r\n                </div>      \r\n        \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\">\r\n                        <label>Subject</label>\r\n                    </div>\r\n        \r\n                    <div class=\"col-md-9 ph10 mb5\">\r\n                        <textarea class=\"form-control\" placeholder=\"Subject\" ng-model=\"autoPromise.subject\"  maxlength=\"150\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-md-3\">\r\n                <div class=\"alert alert-info\">\r\n                    Dynamic Texts <br/>\r\n                    - {contactName}  <br/>\r\n                    - {contactPhone}  <br/>\r\n                    - {regNumber}  <br/>\r\n                    - {variant}  <br/>\r\n                    - {vehiclePrice}  <br/>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n"

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	module.exports = "Are you sure you want to anonymize <b>{{contact.contactName}}</b>\r\n<br><br>\r\nThe following will happen once this action is taken\r\n<br><br>\r\n<ul>\r\n    <li>The name of the contact will be anonymized</li>\r\n    <li>All contact fields will be wiped</li>\r\n    <li>All promises for this contact will be removed</li>\r\n    <li>All notes added for this contact will be removed</li>\r\n    <li>Any open enquiries for this contact will be marked as Lost with reason <i>No Further Contact Possible</i></li>\r\n    <li>This contact will not appear in any list and will not be searchable</li>\r\n</ul>"

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var webEnquiriesCreatedTemplate = "\n<div class=\"ui-notification\">\n  <h3>Enquiry Quote Viewed</h3>\n  <div class=\"message\">\n    <a class=\"btn btn-primary\" ui-sref=\"enquiryEdit({enquiryId: {{enquiryId}}})\">View Enquiry</a>\n  </div>\n</div>\n";
	
	exports.default = webEnquiriesCreatedTemplate;

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal\" novalidate>\r\n    <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n        {{errMsg}}\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">New or Used</label>\r\n        <div class=\"col-sm-10\">\r\n                <select\r\n                    class=\"form-control\"\r\n                    ng-disabled=\"monthlyDistribution.monthlyDistributionId\"\r\n                    ng-options=\"c.id as c.name for c in vehicleConditionList\"\r\n                    ng-model=\"monthlyDistribution.condition\">\r\n                </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Brand</label>\r\n        <div class=\"col-sm-10\">\r\n                <select\r\n                    class=\"form-control\"\r\n                    ng-change=\"filterBrandModels(monthlyDistribution)\"\r\n                    ng-disabled=\"monthlyDistribution.monthlyDistributionId || monthlyDistribution.condition === 2\"\r\n                    ng-options=\"b.brandId as b.name for b in brands\"\r\n                    ng-model=\"monthlyDistribution.brandId\">\r\n                </select>\r\n        </div>\r\n    </div> \r\n    \r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Model</label>\r\n        <div class=\"col-sm-10\">\r\n                <select\r\n                    class=\"form-control\"\r\n                    ng-disabled=\"monthlyDistribution.monthlyDistributionId || monthlyDistribution.condition === 2\"\r\n                    ng-options=\"bm.brandModelId as bm.name for bm in brandModels\"\r\n                    ng-model=\"monthlyDistribution.brandModelId\">\r\n                </select>\r\n        </div>\r\n    </div>     \r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Performance Target</label>\r\n        <div class=\"col-sm-10\">\r\n            <label>\r\n                <input type=\"radio\" ng-model=\"monthlyDistribution.targetType\" ng-value=\"1\" ng-disabled=\"monthlyDistribution.monthlyDistributionId\" />\r\n                Enquiry Created \r\n            </label>\r\n            <label>\r\n                <input type=\"radio\" ng-model=\"monthlyDistribution.targetType\" ng-value=\"2\" ng-disabled=\"monthlyDistribution.monthlyDistributionId\" />\r\n                Enquiry Delivered\r\n            </label>\r\n        </div>\r\n    </div>       \r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Distribution</label>\r\n        <div class=\"col-sm-10\">\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">Jan</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.jan\" min=\"0\">                \r\n                </div>\r\n\r\n                <label class=\"control-label col-sm-2\">Feb</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.feb\" min=\"0\">\r\n                </div>                \r\n\r\n                <label class=\"control-label col-sm-2\">Mar</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.mar\" min=\"0\">                \r\n                </div>                \r\n            </div>            \r\n\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">Apr</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.apr\" min=\"0\">                \r\n                </div>\r\n\r\n                <label class=\"control-label col-sm-2\">May</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.may\" min=\"0\">\r\n                </div>                \r\n\r\n                <label class=\"control-label col-sm-2\">Jun</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.jun\" min=\"0\">\r\n                </div>                \r\n            </div>                        \r\n\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">Jul</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.jul\" min=\"0\">                \r\n                </div>\r\n\r\n                <label class=\"control-label col-sm-2\">Aug</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.aug\" min=\"0\">\r\n                </div>                \r\n\r\n                <label class=\"control-label col-sm-2\">Sep</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.sep\" min=\"0\">                \r\n                </div>                \r\n            </div>                        \r\n\r\n            <div class=\"row\">\r\n                <label class=\"control-label col-sm-2\">Oct</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.oct\" min=\"0\">                \r\n                </div>\r\n\r\n                <label class=\"control-label col-sm-2\">Nov</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.nov\" min=\"0\">\r\n                </div>                \r\n\r\n                <label class=\"control-label col-sm-2\">Dec</label>\r\n                <div class=\"col-sm-2\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"monthlyDistribution.dec\" min=\"0\">                \r\n                </div>                \r\n            </div>                        \r\n        </div>\r\n    </div>       \r\n\r\n</form>"

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal\" novalidate>\r\n        <div class=\"alert alert-danger\" ng-show=\"errMsg !== ''\">\r\n            {{errMsg}}\r\n        </div>\r\n    \r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">User</label>\r\n            <div class=\"col-sm-10\">\r\n                    <select\r\n                        class=\"form-control\"\r\n                        ng-disabled=\"userTarget.userTargetId\"\r\n                        ng-options=\"eu.entityUserId as (eu.firstName + ' ' + eu.lastName) for eu in entityUsers\"\r\n                        ng-model=\"userTarget.entityUserId\">\r\n                    </select>\r\n            </div>\r\n        </div> \r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">New or Used</label>\r\n            <div class=\"col-sm-10\">\r\n                    <select\r\n                        class=\"form-control\"\r\n                        ng-disabled=\"userTarget.userTargetId\"\r\n                        ng-options=\"c.id as c.name for c in vehicleConditionList\"\r\n                        ng-model=\"userTarget.condition\">\r\n                    </select>\r\n            </div>\r\n        </div>\r\n    \r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Brand</label>\r\n            <div class=\"col-sm-10\">\r\n                    <select\r\n                        class=\"form-control\"\r\n                        ng-change=\"filterBrandModels(userTarget)\"\r\n                        ng-disabled=\"userTarget.userTargetId || userTarget.condition === 2\"\r\n                        ng-options=\"b.brandId as b.name for b in brands\"\r\n                        ng-model=\"userTarget.brandId\">\r\n                    </select>\r\n            </div>\r\n        </div> \r\n        \r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Model</label>\r\n            <div class=\"col-sm-10\">\r\n                    <select\r\n                        class=\"form-control\"\r\n                        ng-disabled=\"userTarget.userTargetId || userTarget.condition === 2\"\r\n                        ng-options=\"bm.brandModelId as bm.name for bm in brandModels\"\r\n                        ng-model=\"userTarget.brandModelId\">\r\n                    </select>\r\n            </div>\r\n        </div>     \r\n    \r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Enquiries Created</label>\r\n            <div class=\"col-sm-10\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"userTarget.enquiriesCreated\" min=\"0\">                \r\n            </div>\r\n        </div>       \r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Enquiries Delivered</label>\r\n            <div class=\"col-sm-10\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"userTarget.enquiriesDelivered\" min=\"0\">                \r\n            </div>\r\n        </div>               \r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Finances Referred</label>\r\n            <div class=\"col-sm-10\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"userTarget.financesReferred\" min=\"0\">                \r\n            </div>\r\n        </div>               \r\n\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label col-sm-2\">Finances Accepted</label>\r\n            <div class=\"col-sm-10\">\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"userTarget.financesAccepted\" min=\"0\">                \r\n            </div>\r\n        </div>  \r\n    </form>"

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errMsg\">\r\n    {{errMsg}}\r\n</div>\r\n\r\n<div class=\"row\">    \r\n    <div class=\"col-md-3\">\r\n      <label>Subject *</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <textarea class=\"form-control\" placeholder=\"Subject\" ng-model=\"subject\" maxlength=\"200\">\r\n      </textarea>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <label>Date *</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n        <div style=\"display:inline-block; min-height:290px; \">\r\n            <div uib-datepicker ng-model=\"dueDate\" class=\"well well-sm\" datepicker-options=\"datePickerOptions\" ng-model-options=\"{timezone: 'utc'}\"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <label>Time *</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n        <div uib-timepicker ng-model=\"dueTime\" minute-step=\"15\" show-meridian=\"false\"></div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <img class=\"branding-preview\" ng-src=\"{{selectedImage.url}}\" />\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.brandingTemplateId as item.name for item in templates\"\r\n            ng-model=\"selectedTemplateId\">\r\n        </select>\r\n\r\n        <div class=\"branding-list-container\">\r\n            <ul class=\"branding-image-list\">\r\n                <li ng-repeat=\"m in images | orderBy:'order'\">\r\n                    <img ng-src=\"{{m.url}}\" class=\"branding-imgGallery\" ng-click=\"updateImage(m)\" ng-class=\"{'css-hide': m.loading}\"/>\r\n                    <i class=\"fa fa-spinner fa-spin fa-spin fa-2x img-loader\" ng-if=\"m.loading\"></i>\r\n                    <div class=\"branding-imgOptions\">\r\n                        <input type=\"checkbox\" ng-model=\"m.selected\">\r\n                    </div>                    \r\n                </li>\r\n            </ul>  \r\n        </div>\r\n    </div>    \r\n</div>"

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	module.exports = "<!-- alerts -->\r\n<div class=\"alert alert-danger\" ng-show=\"errMsg\">\r\n    {{errMsg}}\r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Name</label>\r\n        <div class=\"col-sm-10\">\r\n        <input class=\"form-control\" ng-model=\"tempSource.name\" placeholder=\"Enter name here\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Monthly Spend</label>\r\n        <div class=\"col-sm-10\">\r\n        <input class=\"form-control\" type=\"number\" ng-model=\"tempSource.spend\" placeholder=\"Enter monthly spend\">\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var financeCreatedTemplate = "\n<div class=\"ui-notification\">\n  <h3>New Finance Referral</h3>\n  <div class=\"message\">\n    <a class=\"btn btn-primary\" ui-sref=\"financeEdit({financeId: {{financeId}}})\">View Finance</a>\n  </div>\n</div>\n";
	
	exports.default = financeCreatedTemplate;

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        This action requirest authentication through <b>DocuSign</b> <br /><br />\r\n\r\n        You will be redirected to DocuSign for authentication. <br />\r\n        Please use your DocuSign account to login and you will be automatically redirected back to this page    \r\n    </div>\r\n</div>"

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var signatureEventTemplate = "\n<div class=\"ui-notification\">\n  <h3>New eSignature Event</h3>\n  <div class=\"message\">\n    {{msg}}\n    <br />  \n\n    <a class=\"btn btn-success\" ui-sref=\"enquiryEdit({enquiryId: {{enquiryId}}})\">View</a>\n  </div>\n</div>\n";
	
	exports.default = signatureEventTemplate;

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        This action requires authentication through <b>Mazda Portal</b> <br /><br />\r\n\r\n        <b>Please save any changes before proceeding</b><br /><br />\r\n\r\n        You will be redirected to Mazda Portal for authentication. <br />\r\n        Please use your Mazda account to login and you will be automatically redirected back to this page\r\n    </div>\r\n</div>"

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	module.exports = "Please select a Custom Form to Add\r\n\r\n<select\r\n    class=\"form-control\"\r\n    ng-options=\"(item.name) for item in customForms track by item.customFormId\"\r\n    ng-model=\"selectedForm\">\r\n</select>"

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errMsgs\">\r\n    Please fix the following errors before proceeding\r\n    <br /><br/>\r\n    <ul>\r\n      <li ng-repeat=\"msg in errMsgs\">\r\n        {{msg}}\r\n      </li>\r\n    </ul>    \r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Exchange Plan *</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"settings.exchangePlan\" placeholder=\"Enter Exchange plan here\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Sales Manager *</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"settings.salesManager\" placeholder=\"Enter Sales Manager name here\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Service Manager *</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"settings.serviceManager\" placeholder=\"Enter Service Manager name here\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Parts Manager *</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"settings.partsManager\" placeholder=\"Enter Parts Manager name here\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Warranty Period *</label>\r\n        <div class=\"col-sm-9\">\r\n        <textarea class=\"form-control\" ng-model=\"settings.warrantyPeriod\" placeholder=\"Enter Warranty Period here\" maxLength=\"250\"></textarea>\r\n        </div>\r\n    </div>    \r\n</div>"

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errMsgs\">\r\n    Please fix the following errors before proceeding\r\n    <br /><br/>\r\n    <ul>\r\n      <li ng-repeat=\"msg in errMsgs\">\r\n        {{msg}}\r\n      </li>\r\n    </ul>    \r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Provider</label>\r\n        <div class=\"col-sm-9\">\r\n            <select \r\n                ng-options=\"item.id as item.name for item in stockProviderList\"\r\n                ng-change=\"changeProvider()\"\r\n                class=\"form-control\" \r\n                ng-model=\"stockProviderViewModel.stockProvider\">\r\n        </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\" ng-repeat=\"param in stockProviderViewModel.params\">\r\n        <label class=\"control-label col-sm-3\">{{param.label}}*</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"param.value\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" ng-hide=\"true\">\r\n    <div class=\"col-md-12\">\r\n        <ul class=\"list-group\">\r\n            <li class=\"list-group-item\" ng-repeat=\"item in emailTexts\">{{item}}</li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <div style=\"overflow-y: scroll; height:300px;\">\r\n            <ul class=\"list-group\">\r\n                <a href=\"#\" ng-click=\"selectEmailText(item)\" class=\"list-group-item\" ng-repeat=\"item in emailTexts\" style=\"overflow: hidden; white-space: nowrap;text-overflow: ellipsis;\">{{item}}</a>\r\n            </ul>            \r\n        </div>\r\n\r\n        <textarea style=\"width:100%; height: 200px;\" ng-model=\"selectedText\" ng-change=\"updateText()\"></textarea>\r\n        <hr />\r\n\r\n        <header>\r\n            <h3>Custom Links</h3>\r\n        </header>\r\n\r\n        <div class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Link Text</label>\r\n                <div class=\"col-sm-9\">\r\n                    <input class=\"form-control\" ng-model=\"tempTextLink\" />\r\n                </div>\r\n            </div>\r\n    \r\n            <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-3\">Link</label>\r\n                <div class=\"col-sm-9\">\r\n                    <input class=\"form-control\" ng-model=\"tempLink\" />\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <button class=\"btn btn-success\" ng-click=\"addCustomLink()\">Add Link</button>\r\n\r\n        <ul class=\"list-group\">\r\n            <li class=\"list-group-item\" ng-repeat=\"link in customLinks\" style=\"overflow: hidden; white-space: nowrap;text-overflow: ellipsis;\">\r\n                {{link.text}}\r\n                <a href=\"#\" ng-click=\"removeLink(link)\" class=\"btn btn-small btn-danger pull-right\" type=\"button\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\r\n            </li>\r\n        </ul>          \r\n\r\n\r\n        <label>Only jpg, png & gif files allowed. Max Attachment limit of 10Mb</label>\r\n        <div upload-button class=\"btn btn-default btn-upload\" accept=\"image/jpeg,image/x-png,image/gif\" url=\"{{uploadUrl}}\" on-success=\"onMediaUploadSuccess(response)\" on-error=\"onMediaUploadError(response)\" multiple=\"true\">\r\n            Add Image(s)\r\n        </div>     \r\n        \r\n        <label class=\"alert alert-danger\" ng-show=\"imagesOverLimit\">The total size of attached images exceeds 10Mb. Please remove one or more images to fix the error</label>\r\n\r\n        <ul class=\"image-list\">\r\n            <li ng-repeat=\"m in images\">\r\n                <img ng-src=\"{{m}}\" class=\"imgGallery\" />          \r\n                <div class=\"imgOptions\">\r\n                    <div class=\"delete-image\">\r\n                      <a href=\"#\" ng-click=\"$ctrl.removeFollowUpImage(m)\">\r\n                        <i class=\"fa fa-trash-o\"></i>\r\n                      </a>\r\n                    </div>\r\n                </div>\r\n            </li>\r\n          </ul>          \r\n    </div>\r\n\r\n    <div class=\"col-md-6\" ng-bind-html=\"template\"></div>\r\n</div>"

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errors.length\">\r\n    Please correct the following errors first\r\n    <ul>\r\n        <li ng-repeat=\"err in errors\">{{err}}</li>\r\n    </ul>\r\n</div>\r\n\r\n<div class=\"row\">    \r\n    <div class=\"col-md-3\">\r\n      <label>Report *</label>\r\n    </div>\r\n    <div class=\"col-md-3 ph10 mb5\">\r\n        <select\r\n            class=\"form-control\"\r\n            ng-change=\"reportTypeChanged()\"\r\n            ng-options=\"item.reportId as item.name group by item.categoryName for item in reportsList\"\r\n            ng-model=\"scheduledReport.reportId\"\r\n            ng-disabled=\"editMode\">\r\n      </select>\r\n    </div>\r\n\r\n    <div class=\"col-md-3\">\r\n        <label>Frequency *</label>\r\n      </div>\r\n      <div class=\"col-md-3 ph10 mb5\">\r\n        <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.id as item.name for item in frequencyList\"\r\n            ng-model=\"scheduledReport.frequency\">\r\n      </select>\r\n      </div>    \r\n</div>\r\n\r\n<div class=\"row\">    \r\n    <div class=\"col-md-3\">\r\n      <label>Output *</label>\r\n    </div>\r\n    <div class=\"col-md-3 ph10 mb5\">\r\n        <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.id as item.name for item in outputList\"\r\n            ng-model=\"scheduledReport.outputType\">\r\n      </select>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">    \r\n    <div class=\"col-md-12\">\r\n      <label>Recipients *</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"col-md-12\">\r\n    <div class=\"panel\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-5\">\r\n          All Users\r\n          <select\r\n            class=\"form-control user-list\"\r\n            multiple=\"multiple\"\r\n            ng-options=\"(item.firstName + ' ' + item.lastName) for item in locationUsers track by item.userId\"\r\n            ng-model=\"selAllUsers\">\r\n          </select>\r\n        </div>\r\n        <div class=\"col-md-2 select-button-margin\">\r\n          <a class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.selectUsers()\">\r\n            <span class=\"fa fa-arrow-right\"></span>\r\n            Select\r\n          </a>\r\n\r\n          <br /></br>\r\n\r\n          <a class=\"btn btn-default btn-xs\" ng-click=\"$ctrl.deSelectUsers()\">\r\n            <span class=\"fa fa-arrow-left\"></span>\r\n            Deselect\r\n          </a>\r\n        </div>\r\n        <div class=\"col-md-5\">\r\n            Selected Users\r\n          <select\r\n            class=\"form-control user-list\"\r\n            multiple=\"multiple\"\r\n            ng-options=\"(item.firstName + ' ' + item.lastName) for item in selectedUsers track by item.userId\"\r\n            ng-model=\"selUsers\">\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n<div class=\"row\">    \r\n    <div class=\"col-md-3\">\r\n      <label>Additional Recipients</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <textarea class=\"form-control\" placeholder=\"Comma Separated Emails\" ng-model=\"scheduledReport.additionalRecipients\" maxlength=\"1000\">\r\n      </textarea>\r\n    </div>\r\n</div>\r\n\r\n<div ng-show=\"selectedReportName\">\r\n    <hr />\r\n    <h3>{{selectedReportName}} Parmeters</h3>\r\n    <div class=\"row\" ng-show=\"reportParameters.userLocations\">\r\n        <div class=\"col-md-4\">\r\n          Location\r\n        </div>\r\n        <div class=\"col-md-8\">\r\n          <select\r\n            class=\"form-control\" ng-change=\"reportParameterData.updateUserList()\"\r\n            ng-options=\"item.name for item in reportParameterData.userLocations track by item.id\"\r\n            ng-model=\"scheduledReport.criteria.location\">\r\n          </select>\r\n        </div>\r\n    </div>\r\n    \r\n    <div class=\"row\" ng-show=\"reportParameters.userList\">\r\n        <div class=\"col-md-4\">\r\n          Sales Rep\r\n        </div>\r\n        <div class=\"col-md-8\">\r\n            <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.name for item in reportParameterData.userList track by item.id\"\r\n            ng-model=\"scheduledReport.criteria.user\">\r\n          </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-show=\"reportParameters.brands\">\r\n      <div class=\"col-md-4\">\r\n        Make\r\n      </div>\r\n      <div class=\"col-md-8\">\r\n          <select\r\n          class=\"form-control\"  ng-change=\"reportParameterData.updateBrandModel()\"\r\n          ng-options=\"item.name for item in reportParameterData.brands track by item.brandId\"\r\n          ng-model=\"scheduledReport.criteria.brand\">\r\n        </select>\r\n      </div>\r\n  </div> \r\n  \r\n  <div class=\"row\" ng-show=\"reportParameters.brands\">\r\n    <div class=\"col-md-4\">\r\n      Model\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.name for item in reportParameterData.brandModels track by item.brandModelId\"\r\n        ng-model=\"scheduledReport.criteria.brandModel\">\r\n      </select>\r\n    </div>\r\n  </div>   \r\n\r\n  <div class=\"row\" ng-show=\"reportParameters.enquiryContact\">\r\n    <div class=\"col-md-4\">\r\n      Trade / Retail\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.name for item in reportParameterData.enquiryContactList track by item.id\"\r\n        ng-model=\"scheduledReport.criteria.enquiryContact\">\r\n      </select>\r\n    </div>\r\n  </div>    \r\n\r\n  <div class=\"row\" ng-show=\"reportParameters.dateRangeType\">\r\n    <div class=\"col-md-4\">\r\n      Date Range Type\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.name for item in reportParameterData.dateRangeTypeList track by item.id\"\r\n        ng-model=\"scheduledReport.criteria.dateRangeType\">\r\n      </select>\r\n    </div>\r\n  </div> \r\n\r\n  <div class=\"row\" ng-show=\"reportParameters.enquiryStatus\">\r\n    <div class=\"col-md-4\">\r\n      Status\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.name for item in reportParameterData.enquiryStatusList track by item.id\"\r\n        ng-model=\"scheduledReport.criteria.enquiryStatus\">\r\n      </select>\r\n    </div>\r\n  </div>  \r\n</div>\r\n"

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

	module.exports = "<ul>\r\n    <li ng-repeat=\"reg in regs\">\r\n        <a href=\"#\" ng-click=\"goToVehicle(reg.item1)\">{{reg.item2}}</a>\r\n    </li>\r\n</ul>"

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errMsgs\">\r\n    Please fix the following errors before proceeding\r\n    <br /><br/>\r\n    <ul>\r\n      <li ng-repeat=\"msg in errMsgs\">\r\n        {{msg}}\r\n      </li>\r\n    </ul>    \r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-3\">Provider</label>\r\n        <div class=\"col-sm-9\">\r\n            <select \r\n                ng-options=\"item.id as item.name for item in telecomProviderList\"\r\n                ng-change=\"changeProvider()\"\r\n                class=\"form-control\" \r\n                ng-model=\"telecomProviderViewModel.id\">\r\n        </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\" ng-repeat=\"param in telecomProviderViewModel.params\">\r\n        <label class=\"control-label col-sm-3\">{{param.label}}*</label>\r\n        <div class=\"col-sm-9\">\r\n        <input class=\"form-control\" ng-model=\"param.value\" maxLength=\"50\">\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"!inProgress\">\r\n    By pressing Confirm, the system will export all contacts to {{telecomProviderName}}\r\n    <br /><br />\r\n    Are you sure you want to continue ?\r\n</div>\r\n\r\n<div ng-show=\"inProgress && !completed\">\r\n    Exporting contacts to {{telecomProviderName}} <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\r\n    <br /><br />\r\n    This will take a few moments, please be patient.\r\n</div>\r\n\r\n<div ng-show=\"completed\">\r\n    We found a total of <b>{{stats.total}}</b> contacts to be exported, out of which <b>{{stats.successful.length}}</b> were successful and <b>{{stats.failed.length}}</b> failed\r\n    <br /><br />\r\n\r\n    Please find the summary below of the first 20 failed contacts, fix the error and repeat the Export Process.\r\n    <br /><br />\r\n    \r\n    <b>Note: The succcessful contacts will not be duplicated on next export</b>\r\n    <br /><br />\r\n\r\n    <table class=\"table table-bordered table-hover table-striped\">\r\n        <thead>\r\n            <tr>\r\n                <th>Contact Name</th>\r\n                <th>Reason</th>\r\n            </tr>            \r\n        </thead>\r\n\r\n        <tr data-ng-repeat=\"f in stats.failed | limitTo:20\">\r\n            <td><a ng-click=\"editContact(f.contactId)\">{{f.name}}</a></td>\r\n            <td>{{f.reason}}</td>\r\n        </tr>\r\n    </table>\r\n</div>"

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Provider</div>\r\n    <div class=\"col-md-9\">{{callLog.provider}}</div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Timestamp</div>\r\n    <div class=\"col-md-9\">{{callLog.timestamp | date : 'dd MMM yy HH:mm'}}</div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Direction</div>\r\n    <div class=\"col-md-9\">{{callLog.direction}}</div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Answered</div>\r\n    <div class=\"col-md-9\">\r\n        <label style=\"color: green;\" ng-if=\"callLog.answered\">Yes</label>\r\n        <label style=\"color: red;\" ng-if=\"!callLog.answered\">No</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Duration</div>\r\n    <div class=\"col-md-9\">{{callLog.duration}}</div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">User</div>\r\n    <div class=\"col-md-9\">{{callLog.username}}</div>\r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    <div class=\"col-md-3\">Call Link</div>\r\n    <div class=\"col-md-9\" ng-if=\"callLog.callRecordingLink != null\">\r\n        <a class=\"button\" ng-href=\"{{callLog.callRecordingLink}}\">Click here to download</a>\r\n    </div>    \r\n</div>\r\n\r\n<div class=\"row marginBottom h4\">\r\n    &nbsp;\r\n</div>"

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	module.exports = "<!-- alerts -->\r\n<div class=\"alert alert-danger\" ng-show=\"errMsg\">\r\n    {{errMsg}}\r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Title *</label>\r\n        <div class=\"col-sm-10\">\r\n        <input class=\"form-control\" ng-model=\"product.title\" placeholder=\"Title\" maxLength=\"100\">\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Description</label>\r\n        <div class=\"col-sm-10\">\r\n        <textarea class=\"form-control\" ng-model=\"product.description\" placeholder=\"Description\" maxLength=\"250\">\r\n        </textarea>\r\n        </div>\r\n    </div>\r\n    \r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">Price *</label>\r\n        <div class=\"col-sm-10\">\r\n        <input class=\"form-control\" ng-model=\"product.price\" placeholder=\"Price\" type=\"number\">\r\n        </div>\r\n    </div>    \r\n\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label col-sm-2\">VAT Rate *</label>\r\n        <div class=\"col-sm-10\">\r\n            <select\r\n            class=\"form-control\"\r\n            ng-options=\"item.id as item.name for item in vatRates\"\r\n            ng-model=\"product.vatRate\">\r\n          </select>\r\n        </div>\r\n    </div>   \r\n</div>"

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

	module.exports = "<!-- alerts -->\r\n<div class=\"alert alert-danger\" ng-show=\"errMsg\">\r\n  {{errMsg}}\r\n</div>\r\n\r\n<div class=\"form-horizontal\">\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Contact Type *</label>\r\n    <div class=\"col-sm-10\">\r\n        <select\r\n        class=\"form-control\"\r\n        ng-options=\"item.id as item.name for item in contactTypes\"\r\n        ng-model=\"contact.contactType\">\r\n      </select>\r\n    </div>\r\n  </div>   \r\n  \r\n  <div class=\"form-group\">\r\n      <label class=\"control-label col-sm-2\">First Name</label>\r\n      <div class=\"col-sm-10\">\r\n        <input class=\"form-control\" ng-model=\"contact.firstName\" placeholder=\"First Name\" maxLength=\"50\">\r\n      </textarea>\r\n      </div>\r\n  </div>\r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Last Name</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.lastName\" placeholder=\"Last Name\" maxLength=\"50\">\r\n    </textarea>\r\n    </div>\r\n  </div>  \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Phone</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.phone\" placeholder=\"Phone\" maxLength=\"50\">\r\n    </textarea>\r\n    </div>\r\n  </div>  \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Email</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.email\" placeholder=\"Email\" maxLength=\"100\">\r\n    </textarea>\r\n    </div>\r\n  </div>  \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Address Line 1</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.line1\" placeholder=\"Address Line 1\" maxLength=\"100\">\r\n    </textarea>\r\n    </div>\r\n  </div>  \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Address Line 2</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.line2\" placeholder=\"Addres Line 2\" maxLength=\"100\">\r\n    </textarea>\r\n    </div>\r\n  </div>    \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Address Line 3</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.line3\" placeholder=\"Address Line 3\" maxLength=\"100\">\r\n    </textarea>\r\n    </div>\r\n  </div>    \r\n\r\n  <div class=\"form-group\">\r\n    <label class=\"control-label col-sm-2\">Eircode</label>\r\n    <div class=\"col-sm-10\">\r\n      <input class=\"form-control\" ng-model=\"contact.zip\" placeholder=\"Eircode\" maxLength=\"10\">\r\n    </textarea>\r\n    </div>\r\n  </div>   \r\n</div>"

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-danger\" ng-show=\"errMsg\">\r\n  {{errMsg}}\r\n</div>\r\n\r\n<div class=\"form-horizontal\" style=\"height:425px;\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Payment Mode *</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <select\r\n        ng-options=\"p.id as p.name for p in paymentModes\"\r\n        ng-model=\"payment.paymentMode\"\r\n        class=\"form-control\">\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Date *</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <p class=\"input-group\">\r\n        <input type=\"text\" class=\"form-control\" ng-click=\"timeStamp = true\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"payment.timeStamp\" is-open=\"timeStamp\" readonly=\"readOnly\" ng-model-options=\"{timezone: 'utc'}\"/>\r\n        <span class=\"input-group-btn\">\r\n          <button type=\"button\" class=\"btn btn-default iconBtn\" ng-click=\"timeStamp = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n        </span>\r\n      </p>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Amount Paid*</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <input type=\"number\" class=\"form-control\" ng-model=\"payment.amount\" placeholder=\"Enter amount here\"/>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n      <label>Comments</label>\r\n    </div>\r\n    <div class=\"col-md-9 ph10 mb5\">\r\n      <textarea\r\n        maxlength=\"250\"\r\n        class=\"form-control\"\r\n        placeholder=\"Comments\"\r\n        ng-model=\"payment.comments\">\r\n      </textarea>\r\n    </div>\r\n  </div>  \r\n</div>"

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js